import { jsx as u, Fragment as Ee, jsxs as T } from "react/jsx-runtime";
import * as b from "react";
import X, { useLayoutEffect as ea, useState as ue, forwardRef as cn, createElement as D1, useCallback as Ve, useContext as Ht, useRef as le, createContext as Kn, useMemo as Xe, Component as Mn, Fragment as M1, useEffect as ye, useReducer as Hy } from "react";
import * as Ri from "react-dom";
import kt, { createPortal as A7, findDOMNode as Vu, unstable_batchedUpdates as By } from "react-dom";
function y5(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function jn(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = y5(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : y5(e[o], null);
        }
      };
  };
}
function we(...e) {
  return b.useCallback(jn(...e), e);
}
// @__NO_SIDE_EFFECTS__
function mr(e) {
  const t = /* @__PURE__ */ Gy(e), n = b.forwardRef((r, o) => {
    const { children: a, ...i } = r, s = b.Children.toArray(a), l = s.find(Zy);
    if (l) {
      const c = l.props.children, d = s.map((f) => f === l ? b.Children.count(c) > 1 ? b.Children.only(null) : b.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ u(t, { ...i, ref: o, children: b.isValidElement(c) ? b.cloneElement(c, void 0, d) : null });
    }
    return /* @__PURE__ */ u(t, { ...i, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var ta = /* @__PURE__ */ mr("Slot");
// @__NO_SIDE_EFFECTS__
function Gy(e) {
  const t = b.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (b.isValidElement(o)) {
      const i = Yy(o), s = $y(a, o.props);
      return o.type !== b.Fragment && (s.ref = r ? jn(r, i) : i), b.cloneElement(o, s);
    }
    return b.Children.count(o) > 1 ? b.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var _7 = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Wy(e) {
  const t = ({ children: n }) => /* @__PURE__ */ u(Ee, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = _7, t;
}
function Zy(e) {
  return b.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === _7;
}
function $y(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      const l = a(...s);
      return o(...s), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Yy(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function O7(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = O7(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function T7() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = O7(e)) && (r && (r += " "), r += t);
  return r;
}
const x5 = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, E5 = T7, Xt = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return E5(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, i = Object.keys(o).map((c) => {
    const d = n == null ? void 0 : n[c], f = a == null ? void 0 : a[c];
    if (d === null)
      return null;
    const p = x5(d) || x5(f);
    return o[c][p];
  }), s = n && Object.entries(n).reduce((c, d) => {
    let [f, p] = d;
    return p === void 0 || (c[f] = p), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, d) => {
    let { class: f, className: p, ...h } = d;
    return Object.entries(h).every((g) => {
      let [m, v] = g;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...s
      }[m]) : {
        ...a,
        ...s
      }[m] === v;
    }) ? [
      ...c,
      f,
      p
    ] : c;
  }, []);
  return E5(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
var jy = {
  cm: !0,
  mm: !0,
  in: !0,
  px: !0,
  pt: !0,
  pc: !0,
  em: !0,
  ex: !0,
  ch: !0,
  rem: !0,
  vw: !0,
  vh: !0,
  vmin: !0,
  vmax: !0,
  "%": !0
};
function zy(e) {
  if (typeof e == "number")
    return {
      value: e,
      unit: "px"
    };
  var t, n = (e.match(/^[0-9.]*/) || "").toString();
  n.includes(".") ? t = parseFloat(n) : t = parseInt(n, 10);
  var r = (e.match(/[^0-9]*$/) || "").toString();
  return jy[r] ? {
    value: t,
    unit: r
  } : (console.warn("React Spinners: ".concat(e, " is not a valid css value. Defaulting to ").concat(t, "px.")), {
    value: t,
    unit: "px"
  });
}
function I5(e) {
  var t = zy(e);
  return "".concat(t.value).concat(t.unit);
}
var Xy = function(e, t, n) {
  var r = "react-spinners-".concat(e, "-").concat(n);
  if (typeof window > "u" || !window.document)
    return r;
  var o = document.createElement("style");
  document.head.appendChild(o);
  var a = o.sheet, i = `
    @keyframes `.concat(r, ` {
      `).concat(t, `
    }
  `);
  return a && a.insertRule(i, 0), r;
}, fl = globalThis && globalThis.__assign || function() {
  return fl = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, fl.apply(this, arguments);
}, Uy = globalThis && globalThis.__rest || function(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}, Jy = Xy("ClipLoader", "0% {transform: rotate(0deg) scale(1)} 50% {transform: rotate(180deg) scale(0.8)} 100% {transform: rotate(360deg) scale(1)}", "clip");
function Ky(e) {
  var t = e.loading, n = t === void 0 ? !0 : t, r = e.color, o = r === void 0 ? "#000000" : r, a = e.speedMultiplier, i = a === void 0 ? 1 : a, s = e.cssOverride, l = s === void 0 ? {} : s, c = e.size, d = c === void 0 ? 35 : c, f = Uy(e, ["loading", "color", "speedMultiplier", "cssOverride", "size"]), p = fl({ background: "transparent !important", width: I5(d), height: I5(d), borderRadius: "100%", border: "2px solid", borderTopColor: o, borderBottomColor: "transparent", borderLeftColor: o, borderRightColor: o, display: "inline-block", animation: "".concat(Jy, " ").concat(0.75 / i, "s 0s infinite linear"), animationFillMode: "both" }, l);
  return n ? b.createElement("span", fl({ style: p }, f)) : null;
}
const L7 = {
  colors: {
    pulsarGreen: "#4BD1A0",
    white: "#FFFFFF",
    powderWhite: "#F5F5F5",
    lightGray: "#9D9D9D",
    darkGray: "#707070",
    extraLightGray: "#f0f0f0",
    black: "#000000",
    alert: "#F45757",
    warning: "#FFD505",
    lightAlert: "#FEE6E6",
    status: {
      light: {
        alert: "#E9646433",
        stopped: "#FFE6834D",
        producing: "#78CD3833"
      },
      dark: {
        alert: "#E96464",
        stopped: "#FFE683",
        producing: "#78CD38"
      }
    }
  },
  fontSizes: {
    small: "0.8rem",
    regular: "1em",
    large: "1.5em"
  },
  fontWeights: {
    light: "300",
    regular: "400",
    semiBold: "700",
    bold: "900"
  }
}, R7 = (e) => /* @__PURE__ */ u("div", { className: e.className, id: e.id, children: /* @__PURE__ */ u(
  Ky,
  {
    className: "clip-loader",
    size: e.size ?? 24,
    loading: e.loading ?? !0,
    color: e.color ?? L7.colors.pulsarGreen
  }
) }), o2 = "-", qy = (e) => {
  const t = ex(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(o2);
      return s[0] === "" && s.length !== 1 && s.shift(), V7(s, t) || Qy(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const l = n[i] || [];
      return s && r[i] ? [...l, ...r[i]] : l;
    }
  };
}, V7 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? V7(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(o2);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}, S5 = /^\[(.+)\]$/, Qy = (e) => {
  if (S5.test(e)) {
    const t = S5.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, ex = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return nx(Object.entries(e.classGroups), n).forEach(([a, i]) => {
    N1(i, r, a, t);
  }), r;
}, N1 = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : D5(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (tx(o)) {
        N1(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      N1(i, D5(t, a), n, r);
    });
  });
}, D5 = (e, t) => {
  let n = e;
  return t.split(o2).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, tx = (e) => e.isThemeGetter, nx = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, s]) => [t + i, s])) : a);
  return [n, o];
}) : e, rx = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    n.set(a, i), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = n.get(a);
      if (i !== void 0)
        return i;
      if ((i = r.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      n.has(a) ? n.set(a, i) : o(a, i);
    }
  };
}, k7 = "!", ox = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], a = t.length, i = (s) => {
    const l = [];
    let c = 0, d = 0, f;
    for (let v = 0; v < s.length; v++) {
      let w = s[v];
      if (c === 0) {
        if (w === o && (r || s.slice(v, v + a) === t)) {
          l.push(s.slice(d, v)), d = v + a;
          continue;
        }
        if (w === "/") {
          f = v;
          continue;
        }
      }
      w === "[" ? c++ : w === "]" && c--;
    }
    const p = l.length === 0 ? s : s.substring(d), h = p.startsWith(k7), g = h ? p.substring(1) : p, m = f && f > d ? f - d : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (s) => n({
    className: s,
    parseClassName: i
  }) : i;
}, ax = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, ix = (e) => ({
  cache: rx(e.cacheSize),
  parseClassName: ox(e),
  ...qy(e)
}), sx = /\s+/, lx = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, a = [], i = e.trim().split(sx);
  let s = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let g = !!h, m = r(g ? p.substring(0, h) : p);
    if (!m) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (m = r(p), !m) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const v = ax(d).join(":"), w = f ? v + k7 : v, C = w + m;
    if (a.includes(C))
      continue;
    a.push(C);
    const y = o(m, g);
    for (let x = 0; x < y.length; ++x) {
      const E = y[x];
      a.push(w + E);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function cx() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = F7(t)) && (r && (r += " "), r += n);
  return r;
}
const F7 = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = F7(e[r])) && (n && (n += " "), n += t);
  return n;
};
function M5(e, ...t) {
  let n, r, o, a = i;
  function i(l) {
    const c = t.reduce((d, f) => f(d), e());
    return n = ix(c), r = n.cache.get, o = n.cache.set, a = s, s(l);
  }
  function s(l) {
    const c = r(l);
    if (c)
      return c;
    const d = lx(l, n);
    return o(l, d), d;
  }
  return function() {
    return a(cx.apply(null, arguments));
  };
}
const Ze = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, H7 = /^\[(?:([a-z-]+):)?(.+)\]$/i, ux = /^\d+\/\d+$/, dx = /* @__PURE__ */ new Set(["px", "full", "screen"]), fx = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, px = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, hx = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, mx = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, vx = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Ln = (e) => To(e) || dx.has(e) || ux.test(e), tr = (e) => na(e, "length", Ix), To = (e) => !!e && !Number.isNaN(Number(e)), ku = (e) => na(e, "number", To), Ma = (e) => !!e && Number.isInteger(Number(e)), gx = (e) => e.endsWith("%") && To(e.slice(0, -1)), be = (e) => H7.test(e), nr = (e) => fx.test(e), wx = /* @__PURE__ */ new Set(["length", "size", "percentage"]), bx = (e) => na(e, wx, B7), Cx = (e) => na(e, "position", B7), yx = /* @__PURE__ */ new Set(["image", "url"]), xx = (e) => na(e, yx, Dx), Ex = (e) => na(e, "", Sx), Na = () => !0, na = (e, t, n) => {
  const r = H7.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, Ix = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  px.test(e) && !hx.test(e)
), B7 = () => !1, Sx = (e) => mx.test(e), Dx = (e) => vx.test(e), N5 = () => {
  const e = Ze("colors"), t = Ze("spacing"), n = Ze("blur"), r = Ze("brightness"), o = Ze("borderColor"), a = Ze("borderRadius"), i = Ze("borderSpacing"), s = Ze("borderWidth"), l = Ze("contrast"), c = Ze("grayscale"), d = Ze("hueRotate"), f = Ze("invert"), p = Ze("gap"), h = Ze("gradientColorStops"), g = Ze("gradientColorStopPositions"), m = Ze("inset"), v = Ze("margin"), w = Ze("opacity"), C = Ze("padding"), y = Ze("saturate"), x = Ze("scale"), E = Ze("sepia"), S = Ze("skew"), I = Ze("space"), D = Ze("translate"), N = () => ["auto", "contain", "none"], A = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", be, t], F = () => [be, t], k = () => ["", Ln, tr], G = () => ["auto", To, be], J = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], $ = () => ["solid", "dashed", "dotted", "double", "none"], H = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], V = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", be], B = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], Z = () => [To, be];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Na],
      spacing: [Ln, tr],
      blur: ["none", "", nr, be],
      brightness: Z(),
      borderColor: [e],
      borderRadius: ["none", "", "full", nr, be],
      borderSpacing: F(),
      borderWidth: k(),
      contrast: Z(),
      grayscale: j(),
      hueRotate: Z(),
      invert: j(),
      gap: F(),
      gradientColorStops: [e],
      gradientColorStopPositions: [gx, tr],
      inset: L(),
      margin: L(),
      opacity: Z(),
      padding: F(),
      saturate: Z(),
      scale: Z(),
      sepia: j(),
      skew: Z(),
      space: F(),
      translate: F()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", be]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [nr]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": B()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": B()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...J(), be]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: A()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": A()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": A()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: N()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": N()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": N()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Ma, be]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", be]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Ma, be]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Na]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Ma, be]
        }, be]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Na]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Ma, be]
        }, be]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", be]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", be]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...V()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...V(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...V(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [C]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [C]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [C]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [C]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [C]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [C]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [C]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [C]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [C]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [v]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [v]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [v]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [v]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [v]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [v]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [v]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [v]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [v]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", be, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [be, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [be, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [nr]
        }, nr]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [be, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [be, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [be, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [be, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", nr, tr]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ku]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Na]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", be]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", To, ku]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ln, be]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", be]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", be]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...$(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Ln, tr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ln, be]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: F()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", be]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", be]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...J(), Cx]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", bx]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, xx]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...$(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...$()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ln, be]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Ln, tr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: k()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Ln, tr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", nr, Ex]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Na]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...H(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": H()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", nr, be]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [y]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [y]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", be]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: Z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", be]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: Z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", be]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Ma, be]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [D]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [D]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", be]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", be]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": F()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": F()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": F()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": F()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": F()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": F()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": F()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": F()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": F()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": F()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": F()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": F()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": F()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": F()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": F()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": F()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": F()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": F()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", be]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ln, tr, ku]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, Mx = (e, {
  cacheSize: t,
  prefix: n,
  separator: r,
  experimentalParseClassName: o,
  extend: a = {},
  override: i = {}
}) => {
  $a(e, "cacheSize", t), $a(e, "prefix", n), $a(e, "separator", r), $a(e, "experimentalParseClassName", o);
  for (const s in i)
    Nx(e[s], i[s]);
  for (const s in a)
    Px(e[s], a[s]);
  return e;
}, $a = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, Nx = (e, t) => {
  if (t)
    for (const n in t)
      $a(e, n, t[n]);
}, Px = (e, t) => {
  if (t)
    for (const n in t) {
      const r = t[n];
      r !== void 0 && (e[n] = (e[n] || []).concat(r));
    }
}, Ax = (e, ...t) => typeof e == "function" ? M5(N5, e, ...t) : M5(() => Mx(N5(), e), ...t), _x = Ax({
  prefix: "tw-",
  override: {
    classGroups: {
      "font-size": [
        "text-h1",
        "text-h2",
        "text-h3",
        "text-h4",
        "text-h5",
        "text-normal",
        "text-label",
        "text-xs",
        "text-sm",
        "text-base",
        "text-lg",
        "text-xl",
        "text-2xl",
        "text-3xl",
        "text-4xl",
        "text-5xl",
        "text-6xl",
        "text-7xl"
      ]
    }
  }
});
function P(...e) {
  return _x(T7(e));
}
function Ox(e) {
  return `${Lx(e.replaceAll("-", " ")).replaceAll(" ", "")}Icon`;
}
function Tx(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Lx(e) {
  return e.split(" ").map((t) => Tx(t)).join(" ");
}
const Rx = Xt(
  "tw-text-normal tw-shadow tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-gap-8px tw-rounded-md !disabled:tw-pointer-events-none disabled:tw-cursor-not-allowed focus-visible:tw-outline-none",
  {
    variants: {
      variant: {
        primary: "tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary-hover hover:tw-text-primary-hover-foreground focus-visible:tw-bg-primary-focused focus-visible:tw-text-primary-focused-foreground focus-visible:tw-shadow-primary-focus disabled:tw-bg-primary-disabled disabled:tw-text-primary-disabled-foreground",
        destructive: "tw-bg-destructive !tw-text-destructive-foreground hover:tw-bg-destructive-hover hover:tw-text-destructive-hover-foreground focus-visible:tw-bg-destructive-focused focus-visible:tw-text-destructive-focused-foreground focus-visible:tw-shadow-destructive-focus disabled:tw-bg-destructive-disabled disabled:tw-text-destructive-disabled-foreground",
        outline: "tw-border tw-border-input !tw-text-grayscale-text-body tw-bg-background disabled:tw-bg-gray-0 hover:tw-bg-gray-50 hover:tw-text-grayscale-text-body disabled:tw-border-gray-200 !disabled:tw-pointer-events-none disabled:tw-text-gray-400",
        secondary: "tw-border tw-border-secondary-border tw-bg-secondary !tw-text-primary-foreground hover:tw-bg-secondary-hover hover:tw-text-secondary-hover-foreground focus-visible:tw-bg-secondary-focused focus-visible:tw-text-secondary-focused-foreground focus-visible:tw-shadow-secondary-focus disabled:tw-bg-secondary-disabled disabled:tw-text-secondary-disabled-foreground",
        ghost: "tw-bg-ghost tw-text-grayscale-text-body hover:tw-bg-gray-100 hover:tw-text-grayscale-text-body focus-visible:tw-bg-ghost-focused focus-visible:tw-text-ghost-focused-foreground focus-visible:tw-shadow-ghost-focus disabled:tw-bg-ghost disabled:tw-text-gray-400 tw-shadow-none tw-box-border",
        link: "tw-bg-gray-0 !tw-text-brand-700 hover:tw-bg-gray-0 hover:tw-text-brand-700 focus-visible:tw-bg-gray-0 focus-visible:tw-text-brand-700 focus-visible:tw-shadow-link-button-focus disabled:tw-bg-gray-0 disabled:tw-text-gray-400 tw-shadow-none"
      },
      size: {
        sm: "!tw-px-2 !tw-py-[9px] tw-text-sm !tw-leading-4",
        md: "!tw-px-2 !tw-py-[12px] tw-text-base tw-leading-5 ",
        lg: "tw-text-lg !tw-p-[16px]",
        icon: "tw-h-10 tw-w-10"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), Yr = b.forwardRef(
  ({ className: e, variant: t = "primary", size: n = "sm", isLoading: r, asChild: o = !1, ...a }, i) => /* @__PURE__ */ u(o ? ta : "button", { className: P(Rx({ variant: t, size: n }), e), ref: i, ...a, children: /* @__PURE__ */ T(Ee, { children: [
    r && /* @__PURE__ */ u(R7, {}),
    a.children
  ] }) })
);
Yr.displayName = "Button";
const Vx = Xt(
  "tw-h-16px tw-w-16px tw-text-normal tw-shadow tw-box-content tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-gap-8px tw-rounded-md disabled:tw-pointer-events-none",
  {
    variants: {
      variant: {
        primary: "tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary-hover hover:tw-text-primary-hover-foreground focus:tw-bg-primary-focused focus:tw-text-primary-focused-foreground focus:tw-shadow-primary-focus disabled:tw-bg-primary-disabled disabled:tw-text-primary-disabled-foreground",
        destructive: "tw-border tw-border-destructive-border tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive-hover hover:tw-text-destructive-hover-foreground focus:tw-bg-destructive-focused focus:tw-text-destructive-focused-foreground focus:tw-shadow-destructive-focus disabled:tw-bg-destructive-disabled disabled:tw-text-destructive-disabled-foreground",
        outline: "tw-border tw-border-input tw-bg-background hover:tw-bg-accent hover:tw-text-accent-foreground",
        secondary: "tw-border tw-border-secondary-border tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary-hover hover:tw-text-secondary-hover-foreground focus:tw-bg-secondary-focused focus:tw-text-secondary-focused-foreground focus:tw-shadow-secondary-focus disabled:tw-bg-secondary-disabled disabled:tw-text-secondary-disabled-foreground",
        ghost: "tw-bg-ghost tw-text-ghost-foreground hover:tw-bg-ghost-focused hover:tw-text-ghost-focused-foreground focus:tw-bg-ghost-focused focus:tw-text-ghost-focused-foreground focus:tw-shadow-ghost-focus disabled:tw-bg-ghost-disabled disabled:tw-text-ghost-disabled-foreground",
        link: "tw-bg-link tw-text-link-foreground hover:tw-bg-link-focused hover:tw-text-link-focused-foreground focus:tw-bg-link-focused focus:tw-text-link-focused-foreground focus:tw-shadow-link-focus disabled:tw-bg-link-disabled disabled:tw-text-link-disabled-foreground"
      },
      size: {
        sm: "tw-p-8px",
        md: "tw-p-12px",
        lg: "tw-p-16px"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), kx = b.forwardRef(
  ({ className: e, variant: t, size: n, isLoading: r, asChild: o = !1, ...a }, i) => {
    const s = o ? ta : "button", l = () => b.Children.map(
      a.children,
      (c) => b.cloneElement(c, {
        strokeWidth: "3"
      })
    );
    return /* @__PURE__ */ u(s, { className: P(Vx({ variant: t, size: n, className: e })), ref: i, ...a, children: /* @__PURE__ */ T(Ee, { children: [
      r && /* @__PURE__ */ u(R7, {}),
      /* @__PURE__ */ u(l, {})
    ] }) });
  }
);
kx.displayName = "IconButton";
function P5(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function oe(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Fx(e, t) {
  const n = b.createContext(t), r = (a) => {
    const { children: i, ...s } = a, l = b.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ u(n.Provider, { value: l, children: i });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const i = b.useContext(n);
    if (i)
      return i;
    if (t !== void 0)
      return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function st(e, t = []) {
  let n = [];
  function r(a, i) {
    const s = b.createContext(i), l = n.length;
    n = [...n, i];
    const c = (f) => {
      var w;
      const { scope: p, children: h, ...g } = f, m = ((w = p == null ? void 0 : p[e]) == null ? void 0 : w[l]) || s, v = b.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u(m.Provider, { value: v, children: h });
    };
    c.displayName = a + "Provider";
    function d(f, p) {
      var m;
      const h = ((m = p == null ? void 0 : p[e]) == null ? void 0 : m[l]) || s, g = b.useContext(h);
      if (g)
        return g;
      if (i !== void 0)
        return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [c, d];
  }
  const o = () => {
    const a = n.map((i) => b.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return b.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return o.scopeName = e, [r, Hx(o, ...t)];
}
function Hx(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(a)[`__scope${c}`];
        return { ...s, ...f };
      }, {});
      return b.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Vi(e) {
  const t = e + "CollectionProvider", [n, r] = st(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: v, children: w } = m, C = X.useRef(null), y = X.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u(o, { scope: v, itemMap: y, collectionRef: C, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ mr(s), c = X.forwardRef(
    (m, v) => {
      const { scope: w, children: C } = m, y = a(s, w), x = we(v, y.collectionRef);
      return /* @__PURE__ */ u(l, { ref: x, children: C });
    }
  );
  c.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", p = /* @__PURE__ */ mr(d), h = X.forwardRef(
    (m, v) => {
      const { scope: w, children: C, ...y } = m, x = X.useRef(null), E = we(v, x), S = a(d, w);
      return X.useEffect(() => (S.itemMap.set(x, { ref: x, ...y }), () => void S.itemMap.delete(x))), /* @__PURE__ */ u(p, { [f]: "", ref: E, children: C });
    }
  );
  h.displayName = d;
  function g(m) {
    const v = a(e + "CollectionConsumer", m);
    return X.useCallback(() => {
      const C = v.collectionRef.current;
      if (!C)
        return [];
      const y = Array.from(C.querySelectorAll(`[${f}]`));
      return Array.from(v.itemMap.values()).sort(
        (S, I) => y.indexOf(S.ref.current) - y.indexOf(I.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: h },
    g,
    r
  ];
}
var Bx = b.createContext(void 0);
function ra(e) {
  const t = b.useContext(Bx);
  return e || t || "ltr";
}
var Gx = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ie = Gx.reduce((e, t) => {
  const n = /* @__PURE__ */ mr(`Primitive.${t}`), r = b.forwardRef((o, a) => {
    const { asChild: i, ...s } = o, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(l, { ...s, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function a2(e, t) {
  e && Ri.flushSync(() => e.dispatchEvent(t));
}
function Ct(e) {
  const t = b.useRef(e);
  return b.useEffect(() => {
    t.current = e;
  }), b.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Wx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ct(e);
  b.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Zx = "DismissableLayer", P1 = "dismissableLayer.update", $x = "dismissableLayer.pointerDownOutside", Yx = "dismissableLayer.focusOutside", A5, G7 = b.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), no = b.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = b.useContext(G7), [d, f] = b.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = b.useState({}), g = we(t, (I) => f(I)), m = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(v), C = d ? m.indexOf(d) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, x = C >= w, E = zx((I) => {
      const D = I.target, N = [...c.branches].some((A) => A.contains(D));
      !x || N || (o == null || o(I), i == null || i(I), I.defaultPrevented || s == null || s());
    }, p), S = Xx((I) => {
      const D = I.target;
      [...c.branches].some((A) => A.contains(D)) || (a == null || a(I), i == null || i(I), I.defaultPrevented || s == null || s());
    }, p);
    return Wx((I) => {
      C === c.layers.size - 1 && (r == null || r(I), !I.defaultPrevented && s && (I.preventDefault(), s()));
    }, p), b.useEffect(() => {
      if (d)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (A5 = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(d)), c.layers.add(d), _5(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = A5);
        };
    }, [d, p, n, c]), b.useEffect(() => () => {
      d && (c.layers.delete(d), c.layersWithOutsidePointerEventsDisabled.delete(d), _5());
    }, [d, c]), b.useEffect(() => {
      const I = () => h({});
      return document.addEventListener(P1, I), () => document.removeEventListener(P1, I);
    }, []), /* @__PURE__ */ u(
      ie.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: y ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: oe(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: oe(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: oe(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
no.displayName = Zx;
var jx = "DismissableLayerBranch", W7 = b.forwardRef((e, t) => {
  const n = b.useContext(G7), r = b.useRef(null), o = we(t, r);
  return b.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ u(ie.div, { ...e, ref: o });
});
W7.displayName = jx;
function zx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ct(e), r = b.useRef(!1), o = b.useRef(() => {
  });
  return b.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Z7(
            $x,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Xx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ct(e), r = b.useRef(!1);
  return b.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Z7(Yx, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function _5() {
  const e = new CustomEvent(P1);
  document.dispatchEvent(e);
}
function Z7(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? a2(o, a) : o.dispatchEvent(a);
}
var Ux = no, Jx = W7, Fu = 0;
function Kl() {
  b.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? O5()), document.body.insertAdjacentElement("beforeend", e[1] ?? O5()), Fu++, () => {
      Fu === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Fu--;
    };
  }, []);
}
function O5() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Hu = "focusScope.autoFocusOnMount", Bu = "focusScope.autoFocusOnUnmount", T5 = { bubbles: !1, cancelable: !0 }, Kx = "FocusScope", ki = b.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = b.useState(null), c = Ct(o), d = Ct(a), f = b.useRef(null), p = we(t, (m) => l(m)), h = b.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  b.useEffect(() => {
    if (r) {
      let m = function(y) {
        if (h.paused || !s)
          return;
        const x = y.target;
        s.contains(x) ? f.current = x : or(f.current, { select: !0 });
      }, v = function(y) {
        if (h.paused || !s)
          return;
        const x = y.relatedTarget;
        x !== null && (s.contains(x) || or(f.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const E of y)
            E.removedNodes.length > 0 && or(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", v);
      const C = new MutationObserver(w);
      return s && C.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", v), C.disconnect();
      };
    }
  }, [r, s, h.paused]), b.useEffect(() => {
    if (s) {
      R5.add(h);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const w = new CustomEvent(Hu, T5);
        s.addEventListener(Hu, c), s.dispatchEvent(w), w.defaultPrevented || (qx(rE($7(s)), { select: !0 }), document.activeElement === m && or(s));
      }
      return () => {
        s.removeEventListener(Hu, c), setTimeout(() => {
          const w = new CustomEvent(Bu, T5);
          s.addEventListener(Bu, d), s.dispatchEvent(w), w.defaultPrevented || or(m ?? document.body, { select: !0 }), s.removeEventListener(Bu, d), R5.remove(h);
        }, 0);
      };
    }
  }, [s, c, d, h]);
  const g = b.useCallback(
    (m) => {
      if (!n && !r || h.paused)
        return;
      const v = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (v && w) {
        const C = m.currentTarget, [y, x] = Qx(C);
        y && x ? !m.shiftKey && w === x ? (m.preventDefault(), n && or(y, { select: !0 })) : m.shiftKey && w === y && (m.preventDefault(), n && or(x, { select: !0 })) : w === C && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ u(ie.div, { tabIndex: -1, ...i, ref: p, onKeyDown: g });
});
ki.displayName = Kx;
function qx(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (or(r, { select: t }), document.activeElement !== n)
      return;
}
function Qx(e) {
  const t = $7(e), n = L5(t, e), r = L5(t.reverse(), e);
  return [n, r];
}
function $7(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function L5(e, t) {
  for (const n of e)
    if (!eE(n, { upTo: t }))
      return n;
}
function eE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function tE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function or(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && tE(e) && t && e.select();
  }
}
var R5 = nE();
function nE() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = V5(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = V5(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function V5(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function rE(e) {
  return e.filter((t) => t.tagName !== "A");
}
var at = globalThis != null && globalThis.document ? b.useLayoutEffect : () => {
}, oE = b[" useId ".trim().toString()] || (() => {
}), aE = 0;
function Ue(e) {
  const [t, n] = b.useState(oE());
  return at(() => {
    e || n((r) => r ?? String(aE++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const iE = ["top", "right", "bottom", "left"], vr = Math.min, At = Math.max, pl = Math.round, ws = Math.floor, yn = (e) => ({
  x: e,
  y: e
}), sE = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lE = {
  start: "end",
  end: "start"
};
function A1(e, t, n) {
  return At(e, vr(t, n));
}
function zn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xn(e) {
  return e.split("-")[0];
}
function oa(e) {
  return e.split("-")[1];
}
function i2(e) {
  return e === "x" ? "y" : "x";
}
function s2(e) {
  return e === "y" ? "height" : "width";
}
const cE = /* @__PURE__ */ new Set(["top", "bottom"]);
function wn(e) {
  return cE.has(Xn(e)) ? "y" : "x";
}
function l2(e) {
  return i2(wn(e));
}
function uE(e, t, n) {
  n === void 0 && (n = !1);
  const r = oa(e), o = l2(e), a = s2(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = hl(i)), [i, hl(i)];
}
function dE(e) {
  const t = hl(e);
  return [_1(e), t, _1(t)];
}
function _1(e) {
  return e.replace(/start|end/g, (t) => lE[t]);
}
const k5 = ["left", "right"], F5 = ["right", "left"], fE = ["top", "bottom"], pE = ["bottom", "top"];
function hE(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? F5 : k5 : t ? k5 : F5;
    case "left":
    case "right":
      return t ? fE : pE;
    default:
      return [];
  }
}
function mE(e, t, n, r) {
  const o = oa(e);
  let a = hE(Xn(e), n === "start", r);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(_1)))), a;
}
function hl(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sE[t]);
}
function vE(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Y7(e) {
  return typeof e != "number" ? vE(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ml(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function H5(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = wn(t), i = l2(t), s = s2(i), l = Xn(t), c = a === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[s] / 2 - o[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (oa(t)) {
    case "start":
      h[i] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += p * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const gE = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = H5(c, r, l), p = r, h = {}, g = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: v,
      fn: w
    } = s[m], {
      x: C,
      y,
      data: x,
      reset: E
    } = await w({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = C ?? d, f = y ?? f, h = {
      ...h,
      [v]: {
        ...h[v],
        ...x
      }
    }, E && g <= 50 && (g++, typeof E == "object" && (E.placement && (p = E.placement), E.rects && (c = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: d,
      y: f
    } = H5(c, p, l)), m = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: h
  };
};
async function si(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = zn(t, e), g = Y7(h), v = s[p ? f === "floating" ? "reference" : "floating" : f], w = ml(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: d,
    strategy: l
  })), C = f === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), x = await (a.isElement == null ? void 0 : a.isElement(y)) ? await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = ml(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: C,
    offsetParent: y,
    strategy: l
  }) : C);
  return {
    top: (w.top - E.top + g.top) / x.y,
    bottom: (E.bottom - w.bottom + g.bottom) / x.y,
    left: (w.left - E.left + g.left) / x.x,
    right: (E.right - w.right + g.right) / x.x
  };
}
const wE = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: d = 0
    } = zn(e, t) || {};
    if (c == null)
      return {};
    const f = Y7(d), p = {
      x: n,
      y: r
    }, h = l2(o), g = s2(h), m = await i.getDimensions(c), v = h === "y", w = v ? "top" : "left", C = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", x = a.reference[g] + a.reference[h] - p[h] - a.floating[g], E = p[h] - a.reference[h], S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let I = S ? S[y] : 0;
    (!I || !await (i.isElement == null ? void 0 : i.isElement(S))) && (I = s.floating[y] || a.floating[g]);
    const D = x / 2 - E / 2, N = I / 2 - m[g] / 2 - 1, A = vr(f[w], N), L = vr(f[C], N), F = A, k = I - m[g] - L, G = I / 2 - m[g] / 2 + D, J = A1(F, G, k), $ = !l.arrow && oa(o) != null && G !== J && a.reference[g] / 2 - (G < F ? A : L) - m[g] / 2 < 0, H = $ ? G < F ? G - F : G - k : 0;
    return {
      [h]: p[h] + H,
      data: {
        [h]: J,
        centerOffset: G - J - H,
        ...$ && {
          alignmentOffset: H
        }
      },
      reset: $
    };
  }
}), bE = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: m = !0,
        ...v
      } = zn(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const w = Xn(o), C = wn(s), y = Xn(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), E = p || (y || !m ? [hl(s)] : dE(s)), S = g !== "none";
      !p && S && E.push(...mE(s, m, g, x));
      const I = [s, ...E], D = await si(t, v), N = [];
      let A = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && N.push(D[w]), f) {
        const G = uE(o, i, x);
        N.push(D[G[0]], D[G[1]]);
      }
      if (A = [...A, {
        placement: o,
        overflows: N
      }], !N.every((G) => G <= 0)) {
        var L, F;
        const G = (((L = a.flip) == null ? void 0 : L.index) || 0) + 1, J = I[G];
        if (J && (!(f === "alignment" ? C !== wn(J) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        A.every((V) => V.overflows[0] > 0 && wn(V.placement) === C)))
          return {
            data: {
              index: G,
              overflows: A
            },
            reset: {
              placement: J
            }
          };
        let $ = (F = A.filter((H) => H.overflows[0] <= 0).sort((H, V) => H.overflows[1] - V.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!$)
          switch (h) {
            case "bestFit": {
              var k;
              const H = (k = A.filter((V) => {
                if (S) {
                  const j = wn(V.placement);
                  return j === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter((j) => j > 0).reduce((j, B) => j + B, 0)]).sort((V, j) => V[1] - j[1])[0]) == null ? void 0 : k[0];
              H && ($ = H);
              break;
            }
            case "initialPlacement":
              $ = s;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function B5(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function G5(e) {
  return iE.some((t) => e[t] >= 0);
}
const CE = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = zn(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await si(t, {
            ...o,
            elementContext: "reference"
          }), i = B5(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: G5(i)
            }
          };
        }
        case "escaped": {
          const a = await si(t, {
            ...o,
            altBoundary: !0
          }), i = B5(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: G5(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, j7 = /* @__PURE__ */ new Set(["left", "top"]);
async function yE(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Xn(n), s = oa(n), l = wn(n) === "y", c = j7.has(i) ? -1 : 1, d = a && l ? -1 : 1, f = zn(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (h = s === "end" ? g * -1 : g), l ? {
    x: h * d,
    y: p * c
  } : {
    x: p * c,
    y: h * d
  };
}
const xE = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await yE(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, EE = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: w,
              y: C
            } = v;
            return {
              x: w,
              y: C
            };
          }
        },
        ...l
      } = zn(e, t), c = {
        x: n,
        y: r
      }, d = await si(t, l), f = wn(Xn(o)), p = i2(f);
      let h = c[p], g = c[f];
      if (a) {
        const v = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", C = h + d[v], y = h - d[w];
        h = A1(C, h, y);
      }
      if (i) {
        const v = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", C = g + d[v], y = g - d[w];
        g = A1(C, g, y);
      }
      const m = s.fn({
        ...t,
        [p]: h,
        [f]: g
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [p]: a,
            [f]: i
          }
        }
      };
    }
  };
}, IE = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = zn(e, t), d = {
        x: n,
        y: r
      }, f = wn(o), p = i2(f);
      let h = d[p], g = d[f];
      const m = zn(s, t), v = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const y = p === "y" ? "height" : "width", x = a.reference[p] - a.floating[y] + v.mainAxis, E = a.reference[p] + a.reference[y] - v.mainAxis;
        h < x ? h = x : h > E && (h = E);
      }
      if (c) {
        var w, C;
        const y = p === "y" ? "width" : "height", x = j7.has(Xn(o)), E = a.reference[f] - a.floating[y] + (x && ((w = i.offset) == null ? void 0 : w[f]) || 0) + (x ? 0 : v.crossAxis), S = a.reference[f] + a.reference[y] + (x ? 0 : ((C = i.offset) == null ? void 0 : C[f]) || 0) - (x ? v.crossAxis : 0);
        g < E ? g = E : g > S && (g = S);
      }
      return {
        [p]: h,
        [f]: g
      };
    }
  };
}, SE = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = zn(e, t), d = await si(t, c), f = Xn(o), p = oa(o), h = wn(o) === "y", {
        width: g,
        height: m
      } = a.floating;
      let v, w;
      f === "top" || f === "bottom" ? (v = f, w = p === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = f, v = p === "end" ? "top" : "bottom");
      const C = m - d.top - d.bottom, y = g - d.left - d.right, x = vr(m - d[v], C), E = vr(g - d[w], y), S = !t.middlewareData.shift;
      let I = x, D = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (D = y), (r = t.middlewareData.shift) != null && r.enabled.y && (I = C), S && !p) {
        const A = At(d.left, 0), L = At(d.right, 0), F = At(d.top, 0), k = At(d.bottom, 0);
        h ? D = g - 2 * (A !== 0 || L !== 0 ? A + L : At(d.left, d.right)) : I = m - 2 * (F !== 0 || k !== 0 ? F + k : At(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: D,
        availableHeight: I
      });
      const N = await i.getDimensions(s.floating);
      return g !== N.width || m !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ql() {
  return typeof window < "u";
}
function aa(e) {
  return z7(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Tt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Nn(e) {
  var t;
  return (t = (z7(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function z7(e) {
  return ql() ? e instanceof Node || e instanceof Tt(e).Node : !1;
}
function nn(e) {
  return ql() ? e instanceof Element || e instanceof Tt(e).Element : !1;
}
function In(e) {
  return ql() ? e instanceof HTMLElement || e instanceof Tt(e).HTMLElement : !1;
}
function W5(e) {
  return !ql() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Tt(e).ShadowRoot;
}
const DE = /* @__PURE__ */ new Set(["inline", "contents"]);
function Fi(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = rn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !DE.has(o);
}
const ME = /* @__PURE__ */ new Set(["table", "td", "th"]);
function NE(e) {
  return ME.has(aa(e));
}
const PE = [":popover-open", ":modal"];
function Ql(e) {
  return PE.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const AE = ["transform", "translate", "scale", "rotate", "perspective"], _E = ["transform", "translate", "scale", "rotate", "perspective", "filter"], OE = ["paint", "layout", "strict", "content"];
function c2(e) {
  const t = u2(), n = nn(e) ? rn(e) : e;
  return AE.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || _E.some((r) => (n.willChange || "").includes(r)) || OE.some((r) => (n.contain || "").includes(r));
}
function TE(e) {
  let t = gr(e);
  for (; In(t) && !Yo(t); ) {
    if (c2(t))
      return t;
    if (Ql(t))
      return null;
    t = gr(t);
  }
  return null;
}
function u2() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const LE = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Yo(e) {
  return LE.has(aa(e));
}
function rn(e) {
  return Tt(e).getComputedStyle(e);
}
function ec(e) {
  return nn(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function gr(e) {
  if (aa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    W5(e) && e.host || // Fallback.
    Nn(e)
  );
  return W5(t) ? t.host : t;
}
function X7(e) {
  const t = gr(e);
  return Yo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : In(t) && Fi(t) ? t : X7(t);
}
function li(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = X7(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Tt(o);
  if (a) {
    const s = O1(i);
    return t.concat(i, i.visualViewport || [], Fi(o) ? o : [], s && n ? li(s) : []);
  }
  return t.concat(o, li(o, [], n));
}
function O1(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function U7(e) {
  const t = rn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = In(e), a = o ? e.offsetWidth : n, i = o ? e.offsetHeight : r, s = pl(n) !== a || pl(r) !== i;
  return s && (n = a, r = i), {
    width: n,
    height: r,
    $: s
  };
}
function d2(e) {
  return nn(e) ? e : e.contextElement;
}
function Lo(e) {
  const t = d2(e);
  if (!In(t))
    return yn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = U7(t);
  let i = (a ? pl(n.width) : n.width) / r, s = (a ? pl(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const RE = /* @__PURE__ */ yn(0);
function J7(e) {
  const t = Tt(e);
  return !u2() || !t.visualViewport ? RE : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function VE(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Tt(e) ? !1 : t;
}
function jr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = d2(e);
  let i = yn(1);
  t && (r ? nn(r) && (i = Lo(r)) : i = Lo(e));
  const s = VE(a, n, r) ? J7(a) : yn(0);
  let l = (o.left + s.x) / i.x, c = (o.top + s.y) / i.y, d = o.width / i.x, f = o.height / i.y;
  if (a) {
    const p = Tt(a), h = r && nn(r) ? Tt(r) : r;
    let g = p, m = O1(g);
    for (; m && r && h !== g; ) {
      const v = Lo(m), w = m.getBoundingClientRect(), C = rn(m), y = w.left + (m.clientLeft + parseFloat(C.paddingLeft)) * v.x, x = w.top + (m.clientTop + parseFloat(C.paddingTop)) * v.y;
      l *= v.x, c *= v.y, d *= v.x, f *= v.y, l += y, c += x, g = Tt(m), m = O1(g);
    }
  }
  return ml({
    width: d,
    height: f,
    x: l,
    y: c
  });
}
function f2(e, t) {
  const n = ec(e).scrollLeft;
  return t ? t.left + n : jr(Nn(e)).left + n;
}
function K7(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    f2(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function kE(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", i = Nn(r), s = t ? Ql(t.floating) : !1;
  if (r === i || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = yn(1);
  const d = yn(0), f = In(r);
  if ((f || !f && !a) && ((aa(r) !== "body" || Fi(i)) && (l = ec(r)), In(r))) {
    const h = jr(r);
    c = Lo(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const p = i && !f && !a ? K7(i, l, !0) : yn(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + d.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + d.y + p.y
  };
}
function FE(e) {
  return Array.from(e.getClientRects());
}
function HE(e) {
  const t = Nn(e), n = ec(e), r = e.ownerDocument.body, o = At(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = At(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + f2(e);
  const s = -n.scrollTop;
  return rn(r).direction === "rtl" && (i += At(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function BE(e, t) {
  const n = Tt(e), r = Nn(e), o = n.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = u2();
    (!c || c && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
const GE = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function WE(e, t) {
  const n = jr(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = In(e) ? Lo(e) : yn(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, c = r * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function Z5(e, t, n) {
  let r;
  if (t === "viewport")
    r = BE(e, n);
  else if (t === "document")
    r = HE(Nn(e));
  else if (nn(t))
    r = WE(t, n);
  else {
    const o = J7(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return ml(r);
}
function q7(e, t) {
  const n = gr(e);
  return n === t || !nn(n) || Yo(n) ? !1 : rn(n).position === "fixed" || q7(n, t);
}
function ZE(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = li(e, [], !1).filter((s) => nn(s) && aa(s) !== "body"), o = null;
  const a = rn(e).position === "fixed";
  let i = a ? gr(e) : e;
  for (; nn(i) && !Yo(i); ) {
    const s = rn(i), l = c2(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && GE.has(o.position) || Fi(i) && !l && q7(e, i)) ? r = r.filter((d) => d !== i) : o = s, i = gr(i);
  }
  return t.set(e, r), r;
}
function $E(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...n === "clippingAncestors" ? Ql(t) ? [] : ZE(t, this._c) : [].concat(n), r], s = i[0], l = i.reduce((c, d) => {
    const f = Z5(t, d, o);
    return c.top = At(f.top, c.top), c.right = vr(f.right, c.right), c.bottom = vr(f.bottom, c.bottom), c.left = At(f.left, c.left), c;
  }, Z5(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function YE(e) {
  const {
    width: t,
    height: n
  } = U7(e);
  return {
    width: t,
    height: n
  };
}
function jE(e, t, n) {
  const r = In(t), o = Nn(t), a = n === "fixed", i = jr(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = yn(0);
  function c() {
    l.x = f2(o);
  }
  if (r || !r && !a)
    if ((aa(t) !== "body" || Fi(o)) && (s = ec(t)), r) {
      const h = jr(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else
      o && c();
  a && !r && o && c();
  const d = o && !r && !a ? K7(o, s) : yn(0), f = i.left + s.scrollLeft - l.x - d.x, p = i.top + s.scrollTop - l.y - d.y;
  return {
    x: f,
    y: p,
    width: i.width,
    height: i.height
  };
}
function Gu(e) {
  return rn(e).position === "static";
}
function $5(e, t) {
  if (!In(e) || rn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Nn(e) === n && (n = n.ownerDocument.body), n;
}
function Q7(e, t) {
  const n = Tt(e);
  if (Ql(e))
    return n;
  if (!In(e)) {
    let o = gr(e);
    for (; o && !Yo(o); ) {
      if (nn(o) && !Gu(o))
        return o;
      o = gr(o);
    }
    return n;
  }
  let r = $5(e, t);
  for (; r && NE(r) && Gu(r); )
    r = $5(r, t);
  return r && Yo(r) && Gu(r) && !c2(r) ? n : r || TE(e) || n;
}
const zE = async function(e) {
  const t = this.getOffsetParent || Q7, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: jE(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function XE(e) {
  return rn(e).direction === "rtl";
}
const UE = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kE,
  getDocumentElement: Nn,
  getClippingRect: $E,
  getOffsetParent: Q7,
  getElementRects: zE,
  getClientRects: FE,
  getDimensions: YE,
  getScale: Lo,
  isElement: nn,
  isRTL: XE
};
function e9(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function JE(e, t) {
  let n = null, r;
  const o = Nn(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const c = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: p,
      height: h
    } = c;
    if (s || t(), !p || !h)
      return;
    const g = ws(f), m = ws(o.clientWidth - (d + p)), v = ws(o.clientHeight - (f + h)), w = ws(d), y = {
      rootMargin: -g + "px " + -m + "px " + -v + "px " + -w + "px",
      threshold: At(0, vr(1, l)) || 1
    };
    let x = !0;
    function E(S) {
      const I = S[0].intersectionRatio;
      if (I !== l) {
        if (!x)
          return i();
        I ? i(!1, I) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !e9(c, e.getBoundingClientRect()) && i(), x = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, y);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function t9(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = d2(e), d = o || a ? [...c ? li(c) : [], ...li(t)] : [];
  d.forEach((w) => {
    o && w.addEventListener("scroll", n, {
      passive: !0
    }), a && w.addEventListener("resize", n);
  });
  const f = c && s ? JE(c, n) : null;
  let p = -1, h = null;
  i && (h = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === c && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var y;
      (y = h) == null || y.observe(t);
    })), n();
  }), c && !l && h.observe(c), h.observe(t));
  let g, m = l ? jr(e) : null;
  l && v();
  function v() {
    const w = jr(e);
    m && !e9(m, w) && n(), m = w, g = requestAnimationFrame(v);
  }
  return n(), () => {
    var w;
    d.forEach((C) => {
      o && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), f == null || f(), (w = h) == null || w.disconnect(), h = null, l && cancelAnimationFrame(g);
  };
}
const KE = xE, qE = EE, QE = bE, eI = SE, tI = CE, Y5 = wE, nI = IE, rI = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: UE,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return gE(e, t, {
    ...o,
    platform: a
  });
};
var oI = typeof document < "u", aI = function() {
}, Js = oI ? ea : aI;
function vl(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!vl(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !vl(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function n9(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function j5(e, t) {
  const n = n9(e);
  return Math.round(t * n) / n;
}
function Wu(e) {
  const t = b.useRef(e);
  return Js(() => {
    t.current = e;
  }), t;
}
function iI(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [d, f] = b.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = b.useState(r);
  vl(p, r) || h(r);
  const [g, m] = b.useState(null), [v, w] = b.useState(null), C = b.useCallback((V) => {
    V !== S.current && (S.current = V, m(V));
  }, []), y = b.useCallback((V) => {
    V !== I.current && (I.current = V, w(V));
  }, []), x = a || g, E = i || v, S = b.useRef(null), I = b.useRef(null), D = b.useRef(d), N = l != null, A = Wu(l), L = Wu(o), F = Wu(c), k = b.useCallback(() => {
    if (!S.current || !I.current)
      return;
    const V = {
      placement: t,
      strategy: n,
      middleware: p
    };
    L.current && (V.platform = L.current), rI(S.current, I.current, V).then((j) => {
      const B = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      G.current && !vl(D.current, B) && (D.current = B, Ri.flushSync(() => {
        f(B);
      }));
    });
  }, [p, t, n, L, F]);
  Js(() => {
    c === !1 && D.current.isPositioned && (D.current.isPositioned = !1, f((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [c]);
  const G = b.useRef(!1);
  Js(() => (G.current = !0, () => {
    G.current = !1;
  }), []), Js(() => {
    if (x && (S.current = x), E && (I.current = E), x && E) {
      if (A.current)
        return A.current(x, E, k);
      k();
    }
  }, [x, E, k, A, N]);
  const J = b.useMemo(() => ({
    reference: S,
    floating: I,
    setReference: C,
    setFloating: y
  }), [C, y]), $ = b.useMemo(() => ({
    reference: x,
    floating: E
  }), [x, E]), H = b.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return V;
    const j = j5($.floating, d.x), B = j5($.floating, d.y);
    return s ? {
      ...V,
      transform: "translate(" + j + "px, " + B + "px)",
      ...n9($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: j,
      top: B
    };
  }, [n, s, $.floating, d.x, d.y]);
  return b.useMemo(() => ({
    ...d,
    update: k,
    refs: J,
    elements: $,
    floatingStyles: H
  }), [d, k, J, $, H]);
}
const sI = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Y5({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Y5({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, lI = (e, t) => ({
  ...KE(e),
  options: [e, t]
}), cI = (e, t) => ({
  ...qE(e),
  options: [e, t]
}), uI = (e, t) => ({
  ...nI(e),
  options: [e, t]
}), dI = (e, t) => ({
  ...QE(e),
  options: [e, t]
}), fI = (e, t) => ({
  ...eI(e),
  options: [e, t]
}), pI = (e, t) => ({
  ...tI(e),
  options: [e, t]
}), hI = (e, t) => ({
  ...sI(e),
  options: [e, t]
});
var mI = "Arrow", r9 = b.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ u(
    ie.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ u("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
r9.displayName = mI;
var vI = r9;
function tc(e) {
  const [t, n] = b.useState(void 0);
  return at(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var p2 = "Popper", [o9, xr] = st(p2), [gI, a9] = o9(p2), i9 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = b.useState(null);
  return /* @__PURE__ */ u(gI, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
i9.displayName = p2;
var s9 = "PopperAnchor", l9 = b.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = a9(s9, n), i = b.useRef(null), s = we(t, i);
    return b.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ u(ie.div, { ...o, ref: s });
  }
);
l9.displayName = s9;
var h2 = "PopperContent", [wI, bI] = o9(h2), c9 = b.forwardRef(
  (e, t) => {
    var W, Q, te, re, z, R;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...m
    } = e, v = a9(h2, n), [w, C] = b.useState(null), y = we(t, (ce) => C(ce)), [x, E] = b.useState(null), S = tc(x), I = (S == null ? void 0 : S.width) ?? 0, D = (S == null ? void 0 : S.height) ?? 0, N = r + (a !== "center" ? "-" + a : ""), A = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, L = Array.isArray(c) ? c : [c], F = L.length > 0, k = {
      padding: A,
      boundary: L.filter(yI),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: G, floatingStyles: J, placement: $, isPositioned: H, middlewareData: V } = iI({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...ce) => t9(...ce, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        lI({ mainAxis: o + D, alignmentAxis: i }),
        l && cI({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? uI() : void 0,
          ...k
        }),
        l && dI({ ...k }),
        fI({
          ...k,
          apply: ({ elements: ce, rects: ve, availableWidth: ke, availableHeight: Qe }) => {
            const { width: et, height: xt } = ve.reference, dt = ce.floating.style;
            dt.setProperty("--radix-popper-available-width", `${ke}px`), dt.setProperty("--radix-popper-available-height", `${Qe}px`), dt.setProperty("--radix-popper-anchor-width", `${et}px`), dt.setProperty("--radix-popper-anchor-height", `${xt}px`);
          }
        }),
        x && hI({ element: x, padding: s }),
        xI({ arrowWidth: I, arrowHeight: D }),
        p && pI({ strategy: "referenceHidden", ...k })
      ]
    }), [j, B] = f9($), Z = Ct(g);
    at(() => {
      H && (Z == null || Z());
    }, [H, Z]);
    const O = (W = V.arrow) == null ? void 0 : W.x, Y = (Q = V.arrow) == null ? void 0 : Q.y, U = ((te = V.arrow) == null ? void 0 : te.centerOffset) !== 0, [K, q] = b.useState();
    return at(() => {
      w && q(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ u(
      "div",
      {
        ref: G.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...J,
          transform: H ? J.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: K,
          "--radix-popper-transform-origin": [
            (re = V.transformOrigin) == null ? void 0 : re.x,
            (z = V.transformOrigin) == null ? void 0 : z.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((R = V.hide) == null ? void 0 : R.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u(
          wI,
          {
            scope: n,
            placedSide: j,
            onArrowChange: E,
            arrowX: O,
            arrowY: Y,
            shouldHideArrow: U,
            children: /* @__PURE__ */ u(
              ie.div,
              {
                "data-side": j,
                "data-align": B,
                ...m,
                ref: y,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: H ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
c9.displayName = h2;
var u9 = "PopperArrow", CI = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, d9 = b.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = bI(u9, r), i = CI[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u(
          vI,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
d9.displayName = u9;
function yI(e) {
  return e !== null;
}
var xI = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, w, C;
    const { placement: n, rects: r, middlewareData: o } = t, i = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [c, d] = f9(n), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, h = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + l / 2;
    let g = "", m = "";
    return c === "bottom" ? (g = i ? f : `${p}px`, m = `${-l}px`) : c === "top" ? (g = i ? f : `${p}px`, m = `${r.floating.height + l}px`) : c === "right" ? (g = `${-l}px`, m = i ? f : `${h}px`) : c === "left" && (g = `${r.floating.width + l}px`, m = i ? f : `${h}px`), { data: { x: g, y: m } };
  }
});
function f9(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Hi = i9, Bi = l9, nc = c9, rc = d9, EI = "Portal", ro = b.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [o, a] = b.useState(!1);
  at(() => a(!0), []);
  const i = n || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? kt.createPortal(/* @__PURE__ */ u(ie.div, { ...r, ref: t }), i) : null;
});
ro.displayName = EI;
var II = b[" useInsertionEffect ".trim().toString()] || at;
function vt({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, i] = SI({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : o;
  {
    const d = b.useRef(e !== void 0);
    b.useEffect(() => {
      const f = d.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = s;
    }, [s, r]);
  }
  const c = b.useCallback(
    (d) => {
      var f;
      if (s) {
        const p = DI(d) ? d(e) : d;
        p !== e && ((f = i.current) == null || f.call(i, p));
      } else
        a(d);
    },
    [s, e, a, i]
  );
  return [l, c];
}
function SI({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = b.useState(e), o = b.useRef(n), a = b.useRef(t);
  return II(() => {
    a.current = t;
  }, [t]), b.useEffect(() => {
    var i;
    o.current !== n && ((i = a.current) == null || i.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function DI(e) {
  return typeof e == "function";
}
function oc(e) {
  const t = b.useRef({ value: e, previous: e });
  return b.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var p9 = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), MI = "VisuallyHidden", ac = b.forwardRef(
  (e, t) => /* @__PURE__ */ u(
    ie.span,
    {
      ...e,
      ref: t,
      style: { ...p9, ...e.style }
    }
  )
);
ac.displayName = MI;
var NI = ac, PI = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, vo = /* @__PURE__ */ new WeakMap(), bs = /* @__PURE__ */ new WeakMap(), Cs = {}, Zu = 0, h9 = function(e) {
  return e && (e.host || h9(e.parentNode));
}, AI = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = h9(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, _I = function(e, t, n, r) {
  var o = AI(t, Array.isArray(e) ? e : [e]);
  Cs[n] || (Cs[n] = /* @__PURE__ */ new WeakMap());
  var a = Cs[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), c = function(f) {
    !f || s.has(f) || (s.add(f), c(f.parentNode));
  };
  o.forEach(c);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (s.has(p))
        d(p);
      else
        try {
          var h = p.getAttribute(r), g = h !== null && h !== "false", m = (vo.get(p) || 0) + 1, v = (a.get(p) || 0) + 1;
          vo.set(p, m), a.set(p, v), i.push(p), m === 1 && g && bs.set(p, !0), v === 1 && p.setAttribute(n, "true"), g || p.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", p, w);
        }
    });
  };
  return d(t), s.clear(), Zu++, function() {
    i.forEach(function(f) {
      var p = vo.get(f) - 1, h = a.get(f) - 1;
      vo.set(f, p), a.set(f, h), p || (bs.has(f) || f.removeAttribute(r), bs.delete(f)), h || f.removeAttribute(n);
    }), Zu--, Zu || (vo = /* @__PURE__ */ new WeakMap(), vo = /* @__PURE__ */ new WeakMap(), bs = /* @__PURE__ */ new WeakMap(), Cs = {});
  };
}, ic = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || PI(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), _I(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, vn = function() {
  return vn = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, vn.apply(this, arguments);
};
function m9(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function OI(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Ks = "right-scroll-bar-position", qs = "width-before-scroll-bar", TI = "with-scroll-bars-hidden", LI = "--removed-body-scroll-bar-size";
function $u(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function RI(e, t) {
  var n = ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var VI = typeof window < "u" ? b.useLayoutEffect : b.useEffect, z5 = /* @__PURE__ */ new WeakMap();
function kI(e, t) {
  var n = RI(t || null, function(r) {
    return e.forEach(function(o) {
      return $u(o, r);
    });
  });
  return VI(function() {
    var r = z5.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), i = n.current;
      o.forEach(function(s) {
        a.has(s) || $u(s, null);
      }), a.forEach(function(s) {
        o.has(s) || $u(s, i);
      });
    }
    z5.set(n, e);
  }, [e]), n;
}
function FI(e) {
  return e;
}
function HI(e, t) {
  t === void 0 && (t = FI);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, r);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var l = function() {
        var d = i;
        i = [], d.forEach(a);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(d) {
          i.push(d), c();
        },
        filter: function(d) {
          return i = i.filter(d), n;
        }
      };
    }
  };
  return o;
}
function BI(e) {
  e === void 0 && (e = {});
  var t = HI(null);
  return t.options = vn({ async: !0, ssr: !1 }, e), t;
}
var v9 = function(e) {
  var t = e.sideCar, n = m9(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return b.createElement(r, vn({}, n));
};
v9.isSideCarExport = !0;
function GI(e, t) {
  return e.useMedium(t), v9;
}
var g9 = BI(), Yu = function() {
}, sc = b.forwardRef(function(e, t) {
  var n = b.useRef(null), r = b.useState({
    onScrollCapture: Yu,
    onWheelCapture: Yu,
    onTouchMoveCapture: Yu
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, h = e.noRelative, g = e.noIsolation, m = e.inert, v = e.allowPinchZoom, w = e.as, C = w === void 0 ? "div" : w, y = e.gapMode, x = m9(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = p, S = kI([n, t]), I = vn(vn({}, x), o);
  return b.createElement(
    b.Fragment,
    null,
    d && b.createElement(E, { sideCar: g9, removeScrollBar: c, shards: f, noRelative: h, noIsolation: g, inert: m, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: y }),
    i ? b.cloneElement(b.Children.only(s), vn(vn({}, I), { ref: S })) : b.createElement(C, vn({}, I, { className: l, ref: S }), s)
  );
});
sc.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
sc.classNames = {
  fullWidth: qs,
  zeroRight: Ks
};
var X5, WI = function() {
  if (X5)
    return X5;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ZI() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = WI();
  return t && e.setAttribute("nonce", t), e;
}
function $I(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function YI(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var jI = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = ZI()) && ($I(t, n), YI(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, zI = function() {
  var e = jI();
  return function(t, n) {
    b.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, w9 = function() {
  var e = zI(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, XI = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ju = function(e) {
  return parseInt(e || "", 10) || 0;
}, UI = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ju(n), ju(r), ju(o)];
}, JI = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return XI;
  var t = UI(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, KI = w9(), Ro = "data-scroll-locked", qI = function(e, t, n, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(TI, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Ro, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ks, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(qs, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Ks, " .").concat(Ks, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(qs, " .").concat(qs, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ro, `] {
    `).concat(LI, ": ").concat(s, `px;
  }
`);
}, U5 = function() {
  var e = parseInt(document.body.getAttribute(Ro) || "0", 10);
  return isFinite(e) ? e : 0;
}, QI = function() {
  b.useEffect(function() {
    return document.body.setAttribute(Ro, (U5() + 1).toString()), function() {
      var e = U5() - 1;
      e <= 0 ? document.body.removeAttribute(Ro) : document.body.setAttribute(Ro, e.toString());
    };
  }, []);
}, eS = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  QI();
  var a = b.useMemo(function() {
    return JI(o);
  }, [o]);
  return b.createElement(KI, { styles: qI(a, !t, o, n ? "" : "!important") });
}, T1 = !1;
if (typeof window < "u")
  try {
    var ys = Object.defineProperty({}, "passive", {
      get: function() {
        return T1 = !0, !0;
      }
    });
    window.addEventListener("test", ys, ys), window.removeEventListener("test", ys, ys);
  } catch {
    T1 = !1;
  }
var go = T1 ? { passive: !1 } : !1, tS = function(e) {
  return e.tagName === "TEXTAREA";
}, b9 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !tS(e) && n[t] === "visible")
  );
}, nS = function(e) {
  return b9(e, "overflowY");
}, rS = function(e) {
  return b9(e, "overflowX");
}, J5 = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = C9(e, r);
    if (o) {
      var a = y9(e, r), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, oS = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, aS = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, C9 = function(e, t) {
  return e === "v" ? nS(t) : rS(t);
}, y9 = function(e, t) {
  return e === "v" ? oS(t) : aS(t);
}, iS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, sS = function(e, t, n, r, o) {
  var a = iS(e, window.getComputedStyle(t).direction), i = a * r, s = n.target, l = t.contains(s), c = !1, d = i > 0, f = 0, p = 0;
  do {
    if (!s)
      break;
    var h = y9(e, s), g = h[0], m = h[1], v = h[2], w = m - v - a * g;
    (g || w) && C9(e, s) && (f += w, p += g);
    var C = s.parentNode;
    s = C && C.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? C.host : C;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (o && Math.abs(f) < 1 || !o && i > f) || !d && (o && Math.abs(p) < 1 || !o && -i > p)) && (c = !0), c;
}, xs = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, K5 = function(e) {
  return [e.deltaX, e.deltaY];
}, q5 = function(e) {
  return e && "current" in e ? e.current : e;
}, lS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, cS = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, uS = 0, wo = [];
function dS(e) {
  var t = b.useRef([]), n = b.useRef([0, 0]), r = b.useRef(), o = b.useState(uS++)[0], a = b.useState(w9)[0], i = b.useRef(e);
  b.useEffect(function() {
    i.current = e;
  }, [e]), b.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = OI([e.lockRef.current], (e.shards || []).map(q5), !0).filter(Boolean);
      return m.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = b.useCallback(function(m, v) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = xs(m), C = n.current, y = "deltaX" in m ? m.deltaX : C[0] - w[0], x = "deltaY" in m ? m.deltaY : C[1] - w[1], E, S = m.target, I = Math.abs(y) > Math.abs(x) ? "h" : "v";
    if ("touches" in m && I === "h" && S.type === "range")
      return !1;
    var D = J5(I, S);
    if (!D)
      return !0;
    if (D ? E = I : (E = I === "v" ? "h" : "v", D = J5(I, S)), !D)
      return !1;
    if (!r.current && "changedTouches" in m && (y || x) && (r.current = E), !E)
      return !0;
    var N = r.current || E;
    return sS(N, v, m, N === "h" ? y : x, !0);
  }, []), l = b.useCallback(function(m) {
    var v = m;
    if (!(!wo.length || wo[wo.length - 1] !== a)) {
      var w = "deltaY" in v ? K5(v) : xs(v), C = t.current.filter(function(E) {
        return E.name === v.type && (E.target === v.target || v.target === E.shadowParent) && lS(E.delta, w);
      })[0];
      if (C && C.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!C) {
        var y = (i.current.shards || []).map(q5).filter(Boolean).filter(function(E) {
          return E.contains(v.target);
        }), x = y.length > 0 ? s(v, y[0]) : !i.current.noIsolation;
        x && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = b.useCallback(function(m, v, w, C) {
    var y = { name: m, delta: v, target: w, should: C, shadowParent: fS(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== y;
      });
    }, 1);
  }, []), d = b.useCallback(function(m) {
    n.current = xs(m), r.current = void 0;
  }, []), f = b.useCallback(function(m) {
    c(m.type, K5(m), m.target, s(m, e.lockRef.current));
  }, []), p = b.useCallback(function(m) {
    c(m.type, xs(m), m.target, s(m, e.lockRef.current));
  }, []);
  b.useEffect(function() {
    return wo.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, go), document.addEventListener("touchmove", l, go), document.addEventListener("touchstart", d, go), function() {
      wo = wo.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", l, go), document.removeEventListener("touchmove", l, go), document.removeEventListener("touchstart", d, go);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return b.createElement(
    b.Fragment,
    null,
    g ? b.createElement(a, { styles: cS(o) }) : null,
    h ? b.createElement(eS, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function fS(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const pS = GI(g9, dS);
var x9 = b.forwardRef(function(e, t) {
  return b.createElement(sc, vn({}, e, { ref: t, sideCar: pS }));
});
x9.classNames = sc.classNames;
const lc = x9;
var hS = [" ", "Enter", "ArrowUp", "ArrowDown"], mS = [" ", "Enter"], zr = "Select", [cc, uc, vS] = Vi(zr), [ia, mte] = st(zr, [
  vS,
  xr
]), dc = xr(), [gS, Er] = ia(zr), [wS, bS] = ia(zr), E9 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: d,
    autoComplete: f,
    disabled: p,
    required: h,
    form: g
  } = e, m = dc(t), [v, w] = b.useState(null), [C, y] = b.useState(null), [x, E] = b.useState(!1), S = ra(c), [I, D] = vt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: zr
  }), [N, A] = vt({
    prop: i,
    defaultProp: s,
    onChange: l,
    caller: zr
  }), L = b.useRef(null), F = v ? g || !!v.closest("form") : !0, [k, G] = b.useState(/* @__PURE__ */ new Set()), J = Array.from(k).map(($) => $.props.value).join(";");
  return /* @__PURE__ */ u(Hi, { ...m, children: /* @__PURE__ */ T(
    gS,
    {
      required: h,
      scope: t,
      trigger: v,
      onTriggerChange: w,
      valueNode: C,
      onValueNodeChange: y,
      valueNodeHasChildren: x,
      onValueNodeHasChildrenChange: E,
      contentId: Ue(),
      value: N,
      onValueChange: A,
      open: I,
      onOpenChange: D,
      dir: S,
      triggerPointerDownPosRef: L,
      disabled: p,
      children: [
        /* @__PURE__ */ u(cc.Provider, { scope: t, children: /* @__PURE__ */ u(
          wS,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: b.useCallback(($) => {
              G((H) => new Set(H).add($));
            }, []),
            onNativeOptionRemove: b.useCallback(($) => {
              G((H) => {
                const V = new Set(H);
                return V.delete($), V;
              });
            }, []),
            children: n
          }
        ) }),
        F ? /* @__PURE__ */ T(
          z9,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: N,
            onChange: ($) => A($.target.value),
            disabled: p,
            form: g,
            children: [
              N === void 0 ? /* @__PURE__ */ u("option", { value: "" }) : null,
              Array.from(k)
            ]
          },
          J
        ) : null
      ]
    }
  ) });
};
E9.displayName = zr;
var I9 = "SelectTrigger", S9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, a = dc(n), i = Er(I9, n), s = i.disabled || r, l = we(t, i.onTriggerChange), c = uc(n), d = b.useRef("touch"), [f, p, h] = U9((m) => {
      const v = c().filter((y) => !y.disabled), w = v.find((y) => y.value === i.value), C = J9(v, m, w);
      C !== void 0 && i.onValueChange(C.value);
    }), g = (m) => {
      s || (i.onOpenChange(!0), h()), m && (i.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ u(Bi, { asChild: !0, ...a, children: /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": X9(i.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: oe(o.onClick, (m) => {
          m.currentTarget.focus(), d.current !== "mouse" && g(m);
        }),
        onPointerDown: oe(o.onPointerDown, (m) => {
          d.current = m.pointerType;
          const v = m.target;
          v.hasPointerCapture(m.pointerId) && v.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (g(m), m.preventDefault());
        }),
        onKeyDown: oe(o.onKeyDown, (m) => {
          const v = f.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && p(m.key), !(v && m.key === " ") && hS.includes(m.key) && (g(), m.preventDefault());
        })
      }
    ) });
  }
);
S9.displayName = I9;
var D9 = "SelectValue", M9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: a, placeholder: i = "", ...s } = e, l = Er(D9, n), { onValueNodeHasChildrenChange: c } = l, d = a !== void 0, f = we(t, l.onValueNodeChange);
    return at(() => {
      c(d);
    }, [c, d]), /* @__PURE__ */ u(
      ie.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: X9(l.value) ? /* @__PURE__ */ u(Ee, { children: i }) : a
      }
    );
  }
);
M9.displayName = D9;
var CS = "SelectIcon", N9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ u(ie.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
N9.displayName = CS;
var yS = "SelectPortal", P9 = (e) => /* @__PURE__ */ u(ro, { asChild: !0, ...e });
P9.displayName = yS;
var Xr = "SelectContent", A9 = b.forwardRef(
  (e, t) => {
    const n = Er(Xr, e.__scopeSelect), [r, o] = b.useState();
    if (at(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const a = r;
      return a ? Ri.createPortal(
        /* @__PURE__ */ u(_9, { scope: e.__scopeSelect, children: /* @__PURE__ */ u(cc.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ u("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ u(O9, { ...e, ref: t });
  }
);
A9.displayName = Xr;
var qt = 10, [_9, Ir] = ia(Xr), xS = "SelectContentImpl", ES = /* @__PURE__ */ mr("SelectContent.RemoveScroll"), O9 = b.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: v,
      //
      ...w
    } = e, C = Er(Xr, n), [y, x] = b.useState(null), [E, S] = b.useState(null), I = we(t, (W) => x(W)), [D, N] = b.useState(null), [A, L] = b.useState(
      null
    ), F = uc(n), [k, G] = b.useState(!1), J = b.useRef(!1);
    b.useEffect(() => {
      if (y)
        return ic(y);
    }, [y]), Kl();
    const $ = b.useCallback(
      (W) => {
        const [Q, ...te] = F().map((R) => R.ref.current), [re] = te.slice(-1), z = document.activeElement;
        for (const R of W)
          if (R === z || (R == null || R.scrollIntoView({ block: "nearest" }), R === Q && E && (E.scrollTop = 0), R === re && E && (E.scrollTop = E.scrollHeight), R == null || R.focus(), document.activeElement !== z))
            return;
      },
      [F, E]
    ), H = b.useCallback(
      () => $([D, y]),
      [$, D, y]
    );
    b.useEffect(() => {
      k && H();
    }, [k, H]);
    const { onOpenChange: V, triggerPointerDownPosRef: j } = C;
    b.useEffect(() => {
      if (y) {
        let W = { x: 0, y: 0 };
        const Q = (re) => {
          var z, R;
          W = {
            x: Math.abs(Math.round(re.pageX) - (((z = j.current) == null ? void 0 : z.x) ?? 0)),
            y: Math.abs(Math.round(re.pageY) - (((R = j.current) == null ? void 0 : R.y) ?? 0))
          };
        }, te = (re) => {
          W.x <= 10 && W.y <= 10 ? re.preventDefault() : y.contains(re.target) || V(!1), document.removeEventListener("pointermove", Q), j.current = null;
        };
        return j.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", te, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", te, { capture: !0 });
        };
      }
    }, [y, V, j]), b.useEffect(() => {
      const W = () => V(!1);
      return window.addEventListener("blur", W), window.addEventListener("resize", W), () => {
        window.removeEventListener("blur", W), window.removeEventListener("resize", W);
      };
    }, [V]);
    const [B, Z] = U9((W) => {
      const Q = F().filter((z) => !z.disabled), te = Q.find((z) => z.ref.current === document.activeElement), re = J9(Q, W, te);
      re && setTimeout(() => re.ref.current.focus());
    }), O = b.useCallback(
      (W, Q, te) => {
        const re = !J.current && !te;
        (C.value !== void 0 && C.value === Q || re) && (N(W), re && (J.current = !0));
      },
      [C.value]
    ), Y = b.useCallback(() => y == null ? void 0 : y.focus(), [y]), U = b.useCallback(
      (W, Q, te) => {
        const re = !J.current && !te;
        (C.value !== void 0 && C.value === Q || re) && L(W);
      },
      [C.value]
    ), K = r === "popper" ? L1 : T9, q = K === L1 ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: m,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ u(
      _9,
      {
        scope: n,
        content: y,
        viewport: E,
        onViewportChange: S,
        itemRefCallback: O,
        selectedItem: D,
        onItemLeave: Y,
        itemTextRefCallback: U,
        focusSelectedItem: H,
        selectedItemText: A,
        position: r,
        isPositioned: k,
        searchRef: B,
        children: /* @__PURE__ */ u(lc, { as: ES, allowPinchZoom: !0, children: /* @__PURE__ */ u(
          ki,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (W) => {
              W.preventDefault();
            },
            onUnmountAutoFocus: oe(o, (W) => {
              var Q;
              (Q = C.trigger) == null || Q.focus({ preventScroll: !0 }), W.preventDefault();
            }),
            children: /* @__PURE__ */ u(
              no,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (W) => W.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ u(
                  K,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (W) => W.preventDefault(),
                    ...w,
                    ...q,
                    onPlaced: () => G(!0),
                    ref: I,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: oe(w.onKeyDown, (W) => {
                      const Q = W.ctrlKey || W.altKey || W.metaKey;
                      if (W.key === "Tab" && W.preventDefault(), !Q && W.key.length === 1 && Z(W.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(W.key)) {
                        let re = F().filter((z) => !z.disabled).map((z) => z.ref.current);
                        if (["ArrowUp", "End"].includes(W.key) && (re = re.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(W.key)) {
                          const z = W.target, R = re.indexOf(z);
                          re = re.slice(R + 1);
                        }
                        setTimeout(() => $(re)), W.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
O9.displayName = xS;
var IS = "SelectItemAlignedPosition", T9 = b.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, a = Er(Xr, n), i = Ir(Xr, n), [s, l] = b.useState(null), [c, d] = b.useState(null), f = we(t, (I) => d(I)), p = uc(n), h = b.useRef(!1), g = b.useRef(!0), { viewport: m, selectedItem: v, selectedItemText: w, focusSelectedItem: C } = i, y = b.useCallback(() => {
    if (a.trigger && a.valueNode && s && c && m && v && w) {
      const I = a.trigger.getBoundingClientRect(), D = c.getBoundingClientRect(), N = a.valueNode.getBoundingClientRect(), A = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const z = A.left - D.left, R = N.left - z, ce = I.left - R, ve = I.width + ce, ke = Math.max(ve, D.width), Qe = window.innerWidth - qt, et = P5(R, [
          qt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(qt, Qe - ke)
        ]);
        s.style.minWidth = ve + "px", s.style.left = et + "px";
      } else {
        const z = D.right - A.right, R = window.innerWidth - N.right - z, ce = window.innerWidth - I.right - R, ve = I.width + ce, ke = Math.max(ve, D.width), Qe = window.innerWidth - qt, et = P5(R, [
          qt,
          Math.max(qt, Qe - ke)
        ]);
        s.style.minWidth = ve + "px", s.style.right = et + "px";
      }
      const L = p(), F = window.innerHeight - qt * 2, k = m.scrollHeight, G = window.getComputedStyle(c), J = parseInt(G.borderTopWidth, 10), $ = parseInt(G.paddingTop, 10), H = parseInt(G.borderBottomWidth, 10), V = parseInt(G.paddingBottom, 10), j = J + $ + k + V + H, B = Math.min(v.offsetHeight * 5, j), Z = window.getComputedStyle(m), O = parseInt(Z.paddingTop, 10), Y = parseInt(Z.paddingBottom, 10), U = I.top + I.height / 2 - qt, K = F - U, q = v.offsetHeight / 2, W = v.offsetTop + q, Q = J + $ + W, te = j - Q;
      if (Q <= U) {
        const z = L.length > 0 && v === L[L.length - 1].ref.current;
        s.style.bottom = "0px";
        const R = c.clientHeight - m.offsetTop - m.offsetHeight, ce = Math.max(
          K,
          q + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (z ? Y : 0) + R + H
        ), ve = Q + ce;
        s.style.height = ve + "px";
      } else {
        const z = L.length > 0 && v === L[0].ref.current;
        s.style.top = "0px";
        const ce = Math.max(
          U,
          J + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (z ? O : 0) + q
        ) + te;
        s.style.height = ce + "px", m.scrollTop = Q - U + m.offsetTop;
      }
      s.style.margin = `${qt}px 0`, s.style.minHeight = B + "px", s.style.maxHeight = F + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    p,
    a.trigger,
    a.valueNode,
    s,
    c,
    m,
    v,
    w,
    a.dir,
    r
  ]);
  at(() => y(), [y]);
  const [x, E] = b.useState();
  at(() => {
    c && E(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = b.useCallback(
    (I) => {
      I && g.current === !0 && (y(), C == null || C(), g.current = !1);
    },
    [y, C]
  );
  return /* @__PURE__ */ u(
    DS,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ u(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: x
          },
          children: /* @__PURE__ */ u(
            ie.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
T9.displayName = IS;
var SS = "SelectPopperPosition", L1 = b.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = qt,
    ...a
  } = e, i = dc(n);
  return /* @__PURE__ */ u(
    nc,
    {
      ...i,
      ...a,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
L1.displayName = SS;
var [DS, m2] = ia(Xr, {}), R1 = "SelectViewport", L9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, a = Ir(R1, n), i = m2(R1, n), s = we(t, a.onViewportChange), l = b.useRef(0);
    return /* @__PURE__ */ T(Ee, { children: [
      /* @__PURE__ */ u(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ u(cc.Slot, { scope: n, children: /* @__PURE__ */ u(
        ie.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: oe(o.onScroll, (c) => {
            const d = c.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: p } = i;
            if (p != null && p.current && f) {
              const h = Math.abs(l.current - d.scrollTop);
              if (h > 0) {
                const g = window.innerHeight - qt * 2, m = parseFloat(f.style.minHeight), v = parseFloat(f.style.height), w = Math.max(m, v);
                if (w < g) {
                  const C = w + h, y = Math.min(g, C), x = C - y;
                  f.style.height = y + "px", f.style.bottom === "0px" && (d.scrollTop = x > 0 ? x : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
L9.displayName = R1;
var R9 = "SelectGroup", [MS, NS] = ia(R9), PS = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = Ue();
    return /* @__PURE__ */ u(MS, { scope: n, id: o, children: /* @__PURE__ */ u(ie.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
PS.displayName = R9;
var V9 = "SelectLabel", k9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = NS(V9, n);
    return /* @__PURE__ */ u(ie.div, { id: o.id, ...r, ref: t });
  }
);
k9.displayName = V9;
var gl = "SelectItem", [AS, F9] = ia(gl), H9 = b.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: a,
      ...i
    } = e, s = Er(gl, n), l = Ir(gl, n), c = s.value === r, [d, f] = b.useState(a ?? ""), [p, h] = b.useState(!1), g = we(
      t,
      (C) => {
        var y;
        return (y = l.itemRefCallback) == null ? void 0 : y.call(l, C, r, o);
      }
    ), m = Ue(), v = b.useRef("touch"), w = () => {
      o || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ u(
      AS,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: m,
        isSelected: c,
        onItemTextChange: b.useCallback((C) => {
          f((y) => y || ((C == null ? void 0 : C.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ u(
          cc.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: d,
            children: /* @__PURE__ */ u(
              ie.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": c && p,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: g,
                onFocus: oe(i.onFocus, () => h(!0)),
                onBlur: oe(i.onBlur, () => h(!1)),
                onClick: oe(i.onClick, () => {
                  v.current !== "mouse" && w();
                }),
                onPointerUp: oe(i.onPointerUp, () => {
                  v.current === "mouse" && w();
                }),
                onPointerDown: oe(i.onPointerDown, (C) => {
                  v.current = C.pointerType;
                }),
                onPointerMove: oe(i.onPointerMove, (C) => {
                  var y;
                  v.current = C.pointerType, o ? (y = l.onItemLeave) == null || y.call(l) : v.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: oe(i.onPointerLeave, (C) => {
                  var y;
                  C.currentTarget === document.activeElement && ((y = l.onItemLeave) == null || y.call(l));
                }),
                onKeyDown: oe(i.onKeyDown, (C) => {
                  var x;
                  ((x = l.searchRef) == null ? void 0 : x.current) !== "" && C.key === " " || (mS.includes(C.key) && w(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
H9.displayName = gl;
var Ya = "SelectItemText", B9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...a } = e, i = Er(Ya, n), s = Ir(Ya, n), l = F9(Ya, n), c = bS(Ya, n), [d, f] = b.useState(null), p = we(
      t,
      (w) => f(w),
      l.onItemTextChange,
      (w) => {
        var C;
        return (C = s.itemTextRefCallback) == null ? void 0 : C.call(s, w, l.value, l.disabled);
      }
    ), h = d == null ? void 0 : d.textContent, g = b.useMemo(
      () => /* @__PURE__ */ u("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: v } = c;
    return at(() => (m(g), () => v(g)), [m, v, g]), /* @__PURE__ */ T(Ee, { children: [
      /* @__PURE__ */ u(ie.span, { id: l.textId, ...a, ref: p }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? Ri.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
B9.displayName = Ya;
var G9 = "SelectItemIndicator", W9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return F9(G9, n).isSelected ? /* @__PURE__ */ u(ie.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
W9.displayName = G9;
var V1 = "SelectScrollUpButton", Z9 = b.forwardRef((e, t) => {
  const n = Ir(V1, e.__scopeSelect), r = m2(V1, e.__scopeSelect), [o, a] = b.useState(!1), i = we(t, r.onScrollButtonChange);
  return at(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ u(
    Y9,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Z9.displayName = V1;
var k1 = "SelectScrollDownButton", $9 = b.forwardRef((e, t) => {
  const n = Ir(k1, e.__scopeSelect), r = m2(k1, e.__scopeSelect), [o, a] = b.useState(!1), i = we(t, r.onScrollButtonChange);
  return at(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < c;
        a(d);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ u(
    Y9,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
$9.displayName = k1;
var Y9 = b.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, a = Ir("SelectScrollButton", n), i = b.useRef(null), s = uc(n), l = b.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return b.useEffect(() => () => l(), [l]), at(() => {
    var d;
    const c = s().find((f) => f.ref.current === document.activeElement);
    (d = c == null ? void 0 : c.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ u(
    ie.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: oe(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerMove: oe(o.onPointerMove, () => {
        var c;
        (c = a.onItemLeave) == null || c.call(a), i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerLeave: oe(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), _S = "SelectSeparator", j9 = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ u(ie.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
j9.displayName = _S;
var F1 = "SelectArrow", OS = b.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = dc(n), a = Er(F1, n), i = Ir(F1, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ u(rc, { ...o, ...r, ref: t }) : null;
  }
);
OS.displayName = F1;
var TS = "SelectBubbleInput", z9 = b.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = b.useRef(null), a = we(r, o), i = oc(t);
    return b.useEffect(() => {
      const s = o.current;
      if (!s)
        return;
      const l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(s, t), s.dispatchEvent(f);
      }
    }, [i, t]), /* @__PURE__ */ u(
      ie.select,
      {
        ...n,
        style: { ...p9, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
z9.displayName = TS;
function X9(e) {
  return e === "" || e === void 0;
}
function U9(e) {
  const t = Ct(e), n = b.useRef(""), r = b.useRef(0), o = b.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), a = b.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return b.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, a];
}
function J9(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = LS(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((c) => c !== n));
  const l = i.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function LS(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var RS = E9, K9 = S9, VS = M9, kS = N9, q9 = P9, fc = A9, Q9 = L9, e8 = k9, t8 = H9, FS = B9, HS = W9, n8 = Z9, pc = $9, r8 = j9;
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BS = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), GS = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), Q5 = (e) => {
  const t = GS(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, o8 = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), WS = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var ZS = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $S = cn(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: a,
    iconNode: i,
    ...s
  }, l) => D1(
    "svg",
    {
      ref: l,
      ...ZS,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: o8("lucide", o),
      ...!a && !WS(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...i.map(([c, d]) => D1(c, d)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oe = (e, t) => {
  const n = cn(
    ({ className: r, ...o }, a) => D1($S, {
      ref: a,
      iconNode: t,
      className: o8(
        `lucide-${BS(Q5(e))}`,
        `lucide-${e}`,
        r
      ),
      ...o
    })
  );
  return n.displayName = Q5(e), n;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YS = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], jS = Oe("arrow-left", YS);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zS = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], XS = Oe("arrow-right", zS);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const US = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], JS = Oe("calendar", US);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KS = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], sa = Oe("check", KS);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qS = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], qn = Oe("chevron-down", qS);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QS = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], eD = Oe("chevron-left", QS);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tD = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], hc = Oe("chevron-right", tD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nD = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], mc = Oe("chevron-up", nD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rD = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], la = Oe("chevrons-up-down", rD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oD = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], a8 = Oe("circle-alert", oD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aD = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], i8 = Oe("circle-check", aD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iD = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], v2 = Oe("circle", iD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sD = [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
], lD = Oe("clock-alert", sD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cD = [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
], uD = Oe("clock-arrow-down", cD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dD = [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
], fD = Oe("clock-arrow-up", dD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pD = [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
], hD = Oe("clock-fading", pD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mD = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
], s8 = Oe("clock", mD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vD = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], gD = Oe("ellipsis", vD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wD = [
  [
    "path",
    {
      d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
      key: "sc7q7i"
    }
  ]
], e4 = Oe("funnel", wD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bD = [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
], l8 = Oe("grip-vertical", bD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CD = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], c8 = Oe("info", CD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yD = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], xD = Oe("loader-circle", yD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ED = [
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 18h16", key: "19g7jn" }],
  ["path", { d: "M4 6h16", key: "1o0s65" }]
], ID = Oe("menu", ED);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SD = [["path", { d: "M5 12h14", key: "1ays0h" }]], DD = Oe("minus", SD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MD = [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
], u8 = Oe("octagon-alert", MD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ND = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], PD = Oe("panel-left-close", ND);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AD = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], d8 = Oe("search", AD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _D = [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
], OD = Oe("timer-off", _D);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TD = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
], LD = Oe("trash", TD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RD = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], VD = Oe("upload", RD);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kD = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], rt = Oe("x", kD), f8 = (e) => {
  const [t, n] = ue("");
  return /* @__PURE__ */ u(
    "div",
    {
      className: P(
        "tw-flex tw-h-full tw-w-full tw-flex-col tw-rounded-md tw-bg-popover tw-text-popover-foreground tw-overflow-visible",
        e.className
      ),
      children: /* @__PURE__ */ T(
        "div",
        {
          className: P("tw-flex tw-items-center tw-border-b tw-px-3", e.className && "tw-border-r"),
          onKeyDown: (r) => {
            r.stopPropagation();
          },
          children: [
            /* @__PURE__ */ u(d8, { className: "tw-mr-2 tw-h-5 tw-w-5 tw-shrink-0 tw-opacity-50" }),
            /* @__PURE__ */ u(
              "input",
              {
                className: "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-bg-transparent tw-py-3 tw-text-normal tw-outline-none placeholder:tw-text-normal placeholder:tw-text-muted-foreground disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
                placeholder: e.searchPlaceholder,
                type: "text",
                onChange: (r) => {
                  r.stopPropagation(), r.preventDefault(), e.onInputChange != null && e.onInputChange(r.target.value), n(r.target.value);
                },
                value: t
              }
            )
          ]
        }
      )
    }
  );
}, p8 = RS, h8 = VS, g2 = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(
  K9,
  {
    ref: r,
    className: P(
      "tw-flex tw-h-10 tw-items-center tw-justify-between tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-normal tw-ring-offset-background data-[placeholder]:tw-text-muted-foreground focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>span]:tw-line-clamp-1",
      e
    ),
    ...n,
    children: t
  }
));
g2.displayName = K9.displayName;
const FD = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  n8,
  {
    ref: n,
    className: P("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-1", e),
    ...t,
    children: /* @__PURE__ */ u(mc, { className: "tw-h-4 tw-w-4" })
  }
));
FD.displayName = n8.displayName;
const m8 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  pc,
  {
    ref: n,
    className: P("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-1", e),
    ...t,
    children: /* @__PURE__ */ u(qn, { className: "tw-h-4 tw-w-4" })
  }
));
m8.displayName = pc.displayName;
const v8 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  pc,
  {
    ref: n,
    className: P("tw-flex tw-cursor-default tw-items-center tw-justify-center tw-py-1", e),
    ...t,
    children: /* @__PURE__ */ u(qn, { className: "tw-h-4 tw-w-4 tw-mr-6" })
  }
));
v8.displayName = pc.displayName;
const g8 = b.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ u(q9, { children: /* @__PURE__ */ T(
  fc,
  {
    ref: o,
    className: P(
      "tw-relative !tw-z-[99999] tw-max-h-[300px] tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-text-popover-foreground tw-shadow-md data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:tw-translate-y-1 data-[side=left]:tw--translate-x-1 data-[side=right]:tw-translate-x-1 data-[side=top]:tw--translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      r.isSearchEnabled && r.optionsLength > 0 && !r.smallerVariant && /* @__PURE__ */ u(f8, { searchPlaceholder: r.searchPlaceholder, onInputChange: r.onInputChange }),
      /* @__PURE__ */ u(
        Q9,
        {
          className: P(
            "tw-p-1",
            n === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-w-full tw-min-w-[var(--radix-select-trigger-width)]",
            e
          ),
          children: t
        }
      ),
      r.showScrollDownButton && /* @__PURE__ */ u(m8, {})
    ]
  }
) }));
g8.displayName = fc.displayName;
const w8 = b.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ u(q9, { children: /* @__PURE__ */ T(
  fc,
  {
    ref: o,
    className: P(
      "tw-relative !tw-z-[99999] tw-min-h-[300px] tw-max-h-[300px] tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-text-popover-foreground tw-shadow-md data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:tw-translate-y-1 data-[side=left]:tw--translate-x-1 data-[side=right]:tw-translate-x-1 data-[side=top]:tw--translate-y-1",
      e
    ),
    position: n,
    ...r,
    children: [
      r.isSearchEnabled && r.optionsLength > 0 && !r.smallerVariant && /* @__PURE__ */ u(
        f8,
        {
          className: "tw-w-1/2",
          searchPlaceholder: r.searchPlaceholder,
          onInputChange: r.onInputChange
        }
      ),
      /* @__PURE__ */ u(
        Q9,
        {
          className: P(
            "tw-p-1",
            n === "popper" && "tw-h-[var(--radix-select-trigger-height)] tw-min-w-[var(--radix-select-trigger-width)] tw-max-w-[50%] tw-border-r",
            e
          ),
          children: t
        }
      ),
      r.selectedImageUrl && /* @__PURE__ */ u("div", { className: "tw-absolute tw-h-full tw-right-0 tw-top-0 tw-w-[50%] tw-flex tw-items-center tw-justify-center", children: /* @__PURE__ */ u("img", { alt: "Plot", src: r.selectedImageUrl, className: "tw-h-full tw-w-full" }) }),
      r.showScrollDownButton && /* @__PURE__ */ u(v8, {})
    ]
  }
) }));
w8.displayName = fc.displayName;
const HD = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  e8,
  {
    ref: n,
    className: P("tw-py-12px tw-pl-8 tw-pr-2 tw-text-normal tw-font-semibold", e),
    ...t
  }
));
HD.displayName = e8.displayName;
const w2 = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ T(
  t8,
  {
    ref: r,
    className: P(
      "tw-relative tw-flex tw-w-full tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-12px  tw-pr-2 tw-text-[16px] tw-outline-none focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-bg-gray-50",
      n.icon ? "tw-pl-3" : "tw-pl-8",
      e
    ),
    ...n,
    children: [
      !n.icon && /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(HS, { children: /* @__PURE__ */ u(sa, { className: "tw-h-4 tw-w-4" }) }) }),
      /* @__PURE__ */ u(FS, { children: t })
    ]
  }
));
w2.displayName = t8.displayName;
const BD = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(r8, { ref: n, className: P("tw--mx-1 tw-my-1 tw-h-px tw-bg-muted", e), ...t }));
BD.displayName = r8.displayName;
const b2 = kS, GD = {
  h1: "tw-text-grayscale-text-title",
  h2: "tw-text-grayscale-text-title",
  h3: "tw-text-grayscale-text-title",
  h4: "tw-text-grayscale-text-title",
  h5: "tw-text-grayscale-text-title",
  label: "tw-text-grayscale-text-label",
  normal: "tw-text-grayscale-text-body"
}, WD = Xt("tw-leading-[1.15]", {
  variants: {
    variant: {
      h1: "tw-text-h1 tw-font-semibold",
      h2: "tw-text-h2 tw-font-semibold",
      h3: "tw-text-h3 tw-font-semibold",
      h4: "tw-text-h4 tw-font-semibold",
      h5: "tw-text-h5 tw-font-semibold",
      label: "tw-text-label",
      normal: "tw-text-normal"
    }
  },
  defaultVariants: {
    variant: "h1"
  }
}), De = (e) => /* @__PURE__ */ u(
  "span",
  {
    className: P(WD({ variant: e.variant }), GD[e.variant], e.className),
    style: {
      ...e.lineHeight && { lineHeight: e.lineHeight },
      ...e.hasHelperText && { color: "#6B7280" },
      ...e.hasError && { color: "#EF4444" }
    },
    children: e.children
  }
), vte = (e) => {
  var i;
  const [t, n] = ue((/* @__PURE__ */ new Date()).getTime()), [r, o] = ue(e.options), a = (s) => {
    e.onOpenChange != null && e.onOpenChange(s), o(e.options);
  };
  return /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-start tw-gap-8px", children: [
    /* @__PURE__ */ T(
      p8,
      {
        onValueChange: (s) => {
          e.onChange != null && e.onChange(s);
        },
        value: (i = e.value) == null ? void 0 : i.toString(),
        disabled: e.isDisabled,
        onOpenChange: a,
        children: [
          /* @__PURE__ */ T(
            g2,
            {
              className: P(
                "tw-w-[300px] tw-h-[56px]",
                e.error && "tw-border-errorRed",
                e.smallerVariant && "tw-w-[120px]",
                e.selectButtonClassName
              ),
              children: [
                /* @__PURE__ */ u(h8, { placeholder: e.placeholder }),
                /* @__PURE__ */ u(b2, { asChild: !0, children: e.value && e.allowClear && !e.isDisabled ? /* @__PURE__ */ u(
                  rt,
                  {
                    className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label",
                    onPointerDown: (s) => {
                      s.stopPropagation(), e.onChange != null && e.onChange(null), e.onClear != null && e.onClear(), n(+(/* @__PURE__ */ new Date()).getTime());
                    }
                  }
                ) : e.smallerVariant ? /* @__PURE__ */ u(qn, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) : /* @__PURE__ */ u(la, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) })
              ]
            }
          ),
          /* @__PURE__ */ T(
            g8,
            {
              className: P("tw-max-w-min", e.smallerVariant && "tw-w-[120px]", e.selectContentClassName),
              isSearchEnabled: e.isSearchEnabled,
              searchPlaceholder: e.searchPlaceholder,
              optionsLength: e.options.length,
              showScrollDownButton: r.length > 0,
              onInputChange: (s) => {
                const l = [...e.options];
                o(
                  l.filter(
                    (c) => c.label.trim().toLocaleLowerCase().includes(s.trim().toLocaleLowerCase())
                  )
                );
              },
              smallerVariant: e.smallerVariant,
              children: [
                e.options.map((s) => /* @__PURE__ */ u(
                  w2,
                  {
                    className: P(
                      "data-[highlighted]:tw-bg-grayscale-surface-light tw-text-grayscale-text-body tw-overflow-x-hidden tw-text-ellipsis",
                      !r.map((l) => l.value).includes(s.value) && "tw-hidden",
                      s.isHidden && "tw-hidden"
                    ),
                    value: s.value.toString(),
                    disabled: s.isDisabled,
                    icon: s.icon,
                    children: s.icon ? /* @__PURE__ */ T("div", { className: "tw-flex tw-justify-start tw-items-center", children: [
                      /* @__PURE__ */ u("span", { className: "tw-mr-1 tw-h-5 tw-w-5 tw-flex tw-items-center tw-justify-center", children: s.icon }),
                      s.label
                    ] }) : s.label
                  },
                  s.value
                )),
                e.options.length === 0 && /* @__PURE__ */ u("div", { className: "tw-py-12px tw-text-center", role: "presentation", children: /* @__PURE__ */ u(De, { variant: "label", lineHeight: "20px", children: e.noOptionText ?? "No option" }) }),
                e.options.length > 0 && r.length === 0 && /* @__PURE__ */ u("div", { className: "tw-py-12px tw-text-center", role: "presentation", children: /* @__PURE__ */ u(De, { variant: "label", lineHeight: "20px", children: e.emptyResultText }) })
              ]
            }
          )
        ]
      },
      t
    ),
    e.error ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) : e.helperText && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: e.helperText })
  ] });
};
function Ur(e) {
  "@babel/helpers - typeof";
  return Ur = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ur(e);
}
function ZD(e, t) {
  if (Ur(e) != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Ur(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function b8(e) {
  var t = ZD(e, "string");
  return Ur(t) == "symbol" ? t : t + "";
}
function ja(e, t, n) {
  return (t = b8(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function t4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t4(Object(n), !0).forEach(function(r) {
      ja(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : t4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function $D(e) {
  if (Array.isArray(e))
    return e;
}
function YD(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, o, a, i, s = [], l = !0, c = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n)
          return;
        l = !1;
      } else
        for (; !(l = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); l = !0)
          ;
    } catch (d) {
      c = !0, o = d;
    } finally {
      try {
        if (!l && n.return != null && (i = n.return(), Object(i) !== i))
          return;
      } finally {
        if (c)
          throw o;
      }
    }
    return s;
  }
}
function H1(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function C8(e, t) {
  if (e) {
    if (typeof e == "string")
      return H1(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? H1(e, t) : void 0;
  }
}
function jD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Wn(e, t) {
  return $D(e) || YD(e, t) || C8(e, t) || jD();
}
function ci(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function Pn(e, t) {
  if (e == null)
    return {};
  var n, r, o = ci(e, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (r = 0; r < a.length; r++)
      n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var zD = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function y8(e) {
  var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, o = r === void 0 ? !1 : r, a = e.defaultValue, i = a === void 0 ? null : a, s = e.inputValue, l = e.menuIsOpen, c = e.onChange, d = e.onInputChange, f = e.onMenuClose, p = e.onMenuOpen, h = e.value, g = Pn(e, zD), m = ue(s !== void 0 ? s : n), v = Wn(m, 2), w = v[0], C = v[1], y = ue(l !== void 0 ? l : o), x = Wn(y, 2), E = x[0], S = x[1], I = ue(h !== void 0 ? h : i), D = Wn(I, 2), N = D[0], A = D[1], L = Ve(function(V, j) {
    typeof c == "function" && c(V, j), A(V);
  }, [c]), F = Ve(function(V, j) {
    var B;
    typeof d == "function" && (B = d(V, j)), C(B !== void 0 ? B : V);
  }, [d]), k = Ve(function() {
    typeof p == "function" && p(), S(!0);
  }, [p]), G = Ve(function() {
    typeof f == "function" && f(), S(!1);
  }, [f]), J = s !== void 0 ? s : w, $ = l !== void 0 ? l : E, H = h !== void 0 ? h : N;
  return de(de({}, g), {}, {
    inputValue: J,
    menuIsOpen: $,
    onChange: L,
    onInputChange: F,
    onMenuClose: G,
    onMenuOpen: k,
    value: H
  });
}
function ee() {
  return ee = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ee.apply(null, arguments);
}
function XD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function n4(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, b8(r.key), r);
  }
}
function UD(e, t, n) {
  return t && n4(e.prototype, t), n && n4(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function wl(e, t) {
  return wl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, wl(e, t);
}
function JD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && wl(e, t);
}
function bl(e) {
  return bl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, bl(e);
}
function x8() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (x8 = function() {
    return !!e;
  })();
}
function KD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function qD(e, t) {
  if (t && (Ur(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return KD(e);
}
function QD(e) {
  var t = x8();
  return function() {
    var n, r = bl(e);
    if (t) {
      var o = bl(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else
      n = r.apply(this, arguments);
    return qD(this, n);
  };
}
function eM(e) {
  if (Array.isArray(e))
    return H1(e);
}
function tM(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function nM() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vo(e) {
  return eM(e) || tM(e) || C8(e) || nM();
}
var rM = !1;
function oM(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function aM(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var iM = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, a), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !rM : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(aM(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = oM(o);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), ft = "-ms-", Cl = "-moz-", Ae = "-webkit-", E8 = "comm", C2 = "rule", y2 = "decl", sM = "@import", I8 = "@keyframes", lM = "@layer", cM = Math.abs, vc = String.fromCharCode, uM = Object.assign;
function dM(e, t) {
  return lt(e, 0) ^ 45 ? (((t << 2 ^ lt(e, 0)) << 2 ^ lt(e, 1)) << 2 ^ lt(e, 2)) << 2 ^ lt(e, 3) : 0;
}
function S8(e) {
  return e.trim();
}
function fM(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function _e(e, t, n) {
  return e.replace(t, n);
}
function B1(e, t) {
  return e.indexOf(t);
}
function lt(e, t) {
  return e.charCodeAt(t) | 0;
}
function ui(e, t, n) {
  return e.slice(t, n);
}
function hn(e) {
  return e.length;
}
function x2(e) {
  return e.length;
}
function Es(e, t) {
  return t.push(e), e;
}
function pM(e, t) {
  return e.map(t).join("");
}
var gc = 1, jo = 1, D8 = 0, Pt = 0, qe = 0, ca = "";
function wc(e, t, n, r, o, a, i) {
  return { value: e, root: t, parent: n, type: r, props: o, children: a, line: gc, column: jo, length: i, return: "" };
}
function Pa(e, t) {
  return uM(wc("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function hM() {
  return qe;
}
function mM() {
  return qe = Pt > 0 ? lt(ca, --Pt) : 0, jo--, qe === 10 && (jo = 1, gc--), qe;
}
function Lt() {
  return qe = Pt < D8 ? lt(ca, Pt++) : 0, jo++, qe === 10 && (jo = 1, gc++), qe;
}
function xn() {
  return lt(ca, Pt);
}
function Qs() {
  return Pt;
}
function Gi(e, t) {
  return ui(ca, e, t);
}
function di(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function M8(e) {
  return gc = jo = 1, D8 = hn(ca = e), Pt = 0, [];
}
function N8(e) {
  return ca = "", e;
}
function el(e) {
  return S8(Gi(Pt - 1, G1(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function vM(e) {
  for (; (qe = xn()) && qe < 33; )
    Lt();
  return di(e) > 2 || di(qe) > 3 ? "" : " ";
}
function gM(e, t) {
  for (; --t && Lt() && !(qe < 48 || qe > 102 || qe > 57 && qe < 65 || qe > 70 && qe < 97); )
    ;
  return Gi(e, Qs() + (t < 6 && xn() == 32 && Lt() == 32));
}
function G1(e) {
  for (; Lt(); )
    switch (qe) {
      case e:
        return Pt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && G1(qe);
        break;
      case 40:
        e === 41 && G1(e);
        break;
      case 92:
        Lt();
        break;
    }
  return Pt;
}
function wM(e, t) {
  for (; Lt() && e + qe !== 47 + 10; )
    if (e + qe === 42 + 42 && xn() === 47)
      break;
  return "/*" + Gi(t, Pt - 1) + "*" + vc(e === 47 ? e : Lt());
}
function bM(e) {
  for (; !di(xn()); )
    Lt();
  return Gi(e, Pt);
}
function CM(e) {
  return N8(tl("", null, null, null, [""], e = M8(e), 0, [0], e));
}
function tl(e, t, n, r, o, a, i, s, l) {
  for (var c = 0, d = 0, f = i, p = 0, h = 0, g = 0, m = 1, v = 1, w = 1, C = 0, y = "", x = o, E = a, S = r, I = y; v; )
    switch (g = C, C = Lt()) {
      case 40:
        if (g != 108 && lt(I, f - 1) == 58) {
          B1(I += _e(el(C), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += el(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += vM(g);
        break;
      case 92:
        I += gM(Qs() - 1, 7);
        continue;
      case 47:
        switch (xn()) {
          case 42:
          case 47:
            Es(yM(wM(Lt(), Qs()), t, n), l);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * m:
        s[c++] = hn(I) * w;
      case 125 * m:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            v = 0;
          case 59 + d:
            w == -1 && (I = _e(I, /\f/g, "")), h > 0 && hn(I) - f && Es(h > 32 ? o4(I + ";", r, n, f - 1) : o4(_e(I, " ", "") + ";", r, n, f - 2), l);
            break;
          case 59:
            I += ";";
          default:
            if (Es(S = r4(I, t, n, c, d, o, s, y, x = [], E = [], f), a), C === 123)
              if (d === 0)
                tl(I, t, S, S, x, a, f, s, E);
              else
                switch (p === 99 && lt(I, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    tl(e, S, S, r && Es(r4(e, S, S, 0, 0, o, s, y, o, x = [], f), E), o, E, f, s, r ? x : E);
                    break;
                  default:
                    tl(I, S, S, S, [""], E, 0, s, E);
                }
        }
        c = d = h = 0, m = w = 1, y = I = "", f = i;
        break;
      case 58:
        f = 1 + hn(I), h = g;
      default:
        if (m < 1) {
          if (C == 123)
            --m;
          else if (C == 125 && m++ == 0 && mM() == 125)
            continue;
        }
        switch (I += vc(C), C * m) {
          case 38:
            w = d > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            s[c++] = (hn(I) - 1) * w, w = 1;
            break;
          case 64:
            xn() === 45 && (I += el(Lt())), p = xn(), d = f = hn(y = I += bM(Qs())), C++;
            break;
          case 45:
            g === 45 && hn(I) == 2 && (m = 0);
        }
    }
  return a;
}
function r4(e, t, n, r, o, a, i, s, l, c, d) {
  for (var f = o - 1, p = o === 0 ? a : [""], h = x2(p), g = 0, m = 0, v = 0; g < r; ++g)
    for (var w = 0, C = ui(e, f + 1, f = cM(m = i[g])), y = e; w < h; ++w)
      (y = S8(m > 0 ? p[w] + " " + C : _e(C, /&\f/g, p[w]))) && (l[v++] = y);
  return wc(e, t, n, o === 0 ? C2 : s, l, c, d);
}
function yM(e, t, n) {
  return wc(e, t, n, E8, vc(hM()), ui(e, 2, -2), 0);
}
function o4(e, t, n, r) {
  return wc(e, t, n, y2, ui(e, 0, r), ui(e, r + 1, -1), r);
}
function ko(e, t) {
  for (var n = "", r = x2(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function xM(e, t, n, r) {
  switch (e.type) {
    case lM:
      if (e.children.length)
        break;
    case sM:
    case y2:
      return e.return = e.return || e.value;
    case E8:
      return "";
    case I8:
      return e.return = e.value + "{" + ko(e.children, r) + "}";
    case C2:
      e.value = e.props.join(",");
  }
  return hn(n = ko(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function EM(e) {
  var t = x2(e);
  return function(n, r, o, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](n, r, o, a) || "";
    return i;
  };
}
function IM(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function SM(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var DM = function(t, n, r) {
  for (var o = 0, a = 0; o = a, a = xn(), o === 38 && a === 12 && (n[r] = 1), !di(a); )
    Lt();
  return Gi(t, Pt);
}, MM = function(t, n) {
  var r = -1, o = 44;
  do
    switch (di(o)) {
      case 0:
        o === 38 && xn() === 12 && (n[r] = 1), t[r] += DM(Pt - 1, n, r);
        break;
      case 2:
        t[r] += el(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = xn() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += vc(o);
    }
  while (o = Lt());
  return t;
}, NM = function(t, n) {
  return N8(MM(M8(t), n));
}, a4 = /* @__PURE__ */ new WeakMap(), PM = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r)
        return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !a4.get(r)) && !o) {
      a4.set(t, !0);
      for (var a = [], i = NM(n, a), s = r.props, l = 0, c = 0; l < i.length; l++)
        for (var d = 0; d < s.length; d++, c++)
          t.props[c] = a[l] ? i[l].replace(/&\f/g, s[d]) : s[d] + " " + i[l];
    }
  }
}, AM = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function P8(e, t) {
  switch (dM(e, t)) {
    case 5103:
      return Ae + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Ae + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Ae + e + Cl + e + ft + e + e;
    case 6828:
    case 4268:
      return Ae + e + ft + e + e;
    case 6165:
      return Ae + e + ft + "flex-" + e + e;
    case 5187:
      return Ae + e + _e(e, /(\w+).+(:[^]+)/, Ae + "box-$1$2" + ft + "flex-$1$2") + e;
    case 5443:
      return Ae + e + ft + "flex-item-" + _e(e, /flex-|-self/, "") + e;
    case 4675:
      return Ae + e + ft + "flex-line-pack" + _e(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Ae + e + ft + _e(e, "shrink", "negative") + e;
    case 5292:
      return Ae + e + ft + _e(e, "basis", "preferred-size") + e;
    case 6060:
      return Ae + "box-" + _e(e, "-grow", "") + Ae + e + ft + _e(e, "grow", "positive") + e;
    case 4554:
      return Ae + _e(e, /([^-])(transform)/g, "$1" + Ae + "$2") + e;
    case 6187:
      return _e(_e(_e(e, /(zoom-|grab)/, Ae + "$1"), /(image-set)/, Ae + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return _e(e, /(image-set\([^]*)/, Ae + "$1$`$1");
    case 4968:
      return _e(_e(e, /(.+:)(flex-)?(.*)/, Ae + "box-pack:$3" + ft + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ae + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return _e(e, /(.+)-inline(.+)/, Ae + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (hn(e) - 1 - t > 6)
        switch (lt(e, t + 1)) {
          case 109:
            if (lt(e, t + 4) !== 45)
              break;
          case 102:
            return _e(e, /(.+:)(.+)-([^]+)/, "$1" + Ae + "$2-$3$1" + Cl + (lt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~B1(e, "stretch") ? P8(_e(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (lt(e, t + 1) !== 115)
        break;
    case 6444:
      switch (lt(e, hn(e) - 3 - (~B1(e, "!important") && 10))) {
        case 107:
          return _e(e, ":", ":" + Ae) + e;
        case 101:
          return _e(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ae + (lt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Ae + "$2$3$1" + ft + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (lt(e, t + 11)) {
        case 114:
          return Ae + e + ft + _e(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Ae + e + ft + _e(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Ae + e + ft + _e(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Ae + e + ft + e + e;
  }
  return e;
}
var _M = function(t, n, r, o) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case y2:
        t.return = P8(t.value, t.length);
        break;
      case I8:
        return ko([Pa(t, {
          value: _e(t.value, "@", "@" + Ae)
        })], o);
      case C2:
        if (t.length)
          return pM(t.props, function(a) {
            switch (fM(a, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ko([Pa(t, {
                  props: [_e(a, /:(read-\w+)/, ":" + Cl + "$1")]
                })], o);
              case "::placeholder":
                return ko([Pa(t, {
                  props: [_e(a, /:(plac\w+)/, ":" + Ae + "input-$1")]
                }), Pa(t, {
                  props: [_e(a, /:(plac\w+)/, ":" + Cl + "$1")]
                }), Pa(t, {
                  props: [_e(a, /:(plac\w+)/, ft + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, OM = [_M], TM = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(m) {
      var v = m.getAttribute("data-emotion");
      v.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || OM, a = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var v = m.getAttribute("data-emotion").split(" "), w = 1; w < v.length; w++)
        a[v[w]] = !0;
      s.push(m);
    }
  );
  var l, c = [PM, AM];
  {
    var d, f = [xM, IM(function(m) {
      d.insert(m);
    })], p = EM(c.concat(o, f)), h = function(v) {
      return ko(CM(v), p);
    };
    l = function(v, w, C, y) {
      d = C, h(v ? v + "{" + w.styles + "}" : w.styles), y && (g.inserted[w.name] = !0);
    };
  }
  var g = {
    key: n,
    sheet: new iM({
      key: n,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(s), g;
}, A8 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ua(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var W1 = { exports: {} }, Te = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var i4;
function LM() {
  if (i4)
    return Te;
  i4 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function y(E) {
    if (typeof E == "object" && E !== null) {
      var S = E.$$typeof;
      switch (S) {
        case t:
          switch (E = E.type, E) {
            case l:
            case c:
            case r:
            case a:
            case o:
            case f:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case d:
                case g:
                case h:
                case i:
                  return E;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function x(E) {
    return y(E) === c;
  }
  return Te.AsyncMode = l, Te.ConcurrentMode = c, Te.ContextConsumer = s, Te.ContextProvider = i, Te.Element = t, Te.ForwardRef = d, Te.Fragment = r, Te.Lazy = g, Te.Memo = h, Te.Portal = n, Te.Profiler = a, Te.StrictMode = o, Te.Suspense = f, Te.isAsyncMode = function(E) {
    return x(E) || y(E) === l;
  }, Te.isConcurrentMode = x, Te.isContextConsumer = function(E) {
    return y(E) === s;
  }, Te.isContextProvider = function(E) {
    return y(E) === i;
  }, Te.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, Te.isForwardRef = function(E) {
    return y(E) === d;
  }, Te.isFragment = function(E) {
    return y(E) === r;
  }, Te.isLazy = function(E) {
    return y(E) === g;
  }, Te.isMemo = function(E) {
    return y(E) === h;
  }, Te.isPortal = function(E) {
    return y(E) === n;
  }, Te.isProfiler = function(E) {
    return y(E) === a;
  }, Te.isStrictMode = function(E) {
    return y(E) === o;
  }, Te.isSuspense = function(E) {
    return y(E) === f;
  }, Te.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === r || E === c || E === a || E === o || E === f || E === p || typeof E == "object" && E !== null && (E.$$typeof === g || E.$$typeof === h || E.$$typeof === i || E.$$typeof === s || E.$$typeof === d || E.$$typeof === v || E.$$typeof === w || E.$$typeof === C || E.$$typeof === m);
  }, Te.typeOf = y, Te;
}
var Le = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var s4;
function RM() {
  return s4 || (s4 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function y(R) {
      return typeof R == "string" || typeof R == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      R === r || R === c || R === a || R === o || R === f || R === p || typeof R == "object" && R !== null && (R.$$typeof === g || R.$$typeof === h || R.$$typeof === i || R.$$typeof === s || R.$$typeof === d || R.$$typeof === v || R.$$typeof === w || R.$$typeof === C || R.$$typeof === m);
    }
    function x(R) {
      if (typeof R == "object" && R !== null) {
        var ce = R.$$typeof;
        switch (ce) {
          case t:
            var ve = R.type;
            switch (ve) {
              case l:
              case c:
              case r:
              case a:
              case o:
              case f:
                return ve;
              default:
                var ke = ve && ve.$$typeof;
                switch (ke) {
                  case s:
                  case d:
                  case g:
                  case h:
                  case i:
                    return ke;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var E = l, S = c, I = s, D = i, N = t, A = d, L = r, F = g, k = h, G = n, J = a, $ = o, H = f, V = !1;
    function j(R) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), B(R) || x(R) === l;
    }
    function B(R) {
      return x(R) === c;
    }
    function Z(R) {
      return x(R) === s;
    }
    function O(R) {
      return x(R) === i;
    }
    function Y(R) {
      return typeof R == "object" && R !== null && R.$$typeof === t;
    }
    function U(R) {
      return x(R) === d;
    }
    function K(R) {
      return x(R) === r;
    }
    function q(R) {
      return x(R) === g;
    }
    function W(R) {
      return x(R) === h;
    }
    function Q(R) {
      return x(R) === n;
    }
    function te(R) {
      return x(R) === a;
    }
    function re(R) {
      return x(R) === o;
    }
    function z(R) {
      return x(R) === f;
    }
    Le.AsyncMode = E, Le.ConcurrentMode = S, Le.ContextConsumer = I, Le.ContextProvider = D, Le.Element = N, Le.ForwardRef = A, Le.Fragment = L, Le.Lazy = F, Le.Memo = k, Le.Portal = G, Le.Profiler = J, Le.StrictMode = $, Le.Suspense = H, Le.isAsyncMode = j, Le.isConcurrentMode = B, Le.isContextConsumer = Z, Le.isContextProvider = O, Le.isElement = Y, Le.isForwardRef = U, Le.isFragment = K, Le.isLazy = q, Le.isMemo = W, Le.isPortal = Q, Le.isProfiler = te, Le.isStrictMode = re, Le.isSuspense = z, Le.isValidElementType = y, Le.typeOf = x;
  }()), Le;
}
process.env.NODE_ENV === "production" ? W1.exports = LM() : W1.exports = RM();
var E2 = W1.exports, I2 = E2, VM = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, kM = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, FM = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, _8 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, S2 = {};
S2[I2.ForwardRef] = FM;
S2[I2.Memo] = _8;
function l4(e) {
  return I2.isMemo(e) ? _8 : S2[e.$$typeof] || VM;
}
var HM = Object.defineProperty, BM = Object.getOwnPropertyNames, c4 = Object.getOwnPropertySymbols, GM = Object.getOwnPropertyDescriptor, WM = Object.getPrototypeOf, u4 = Object.prototype;
function O8(e, t, n) {
  if (typeof t != "string") {
    if (u4) {
      var r = WM(t);
      r && r !== u4 && O8(e, r, n);
    }
    var o = BM(t);
    c4 && (o = o.concat(c4(t)));
    for (var a = l4(e), i = l4(t), s = 0; s < o.length; ++s) {
      var l = o[s];
      if (!kM[l] && !(n && n[l]) && !(i && i[l]) && !(a && a[l])) {
        var c = GM(t, l);
        try {
          HM(e, l, c);
        } catch {
        }
      }
    }
  }
  return e;
}
var ZM = O8;
const d4 = /* @__PURE__ */ ua(ZM);
var $M = !0;
function YM(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (r += o + " ");
  }), r;
}
var T8 = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  $M === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, jM = function(t, n, r) {
  T8(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function zM(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var XM = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, UM = !1, JM = /[A-Z]|^ms/g, KM = /_EMO_([^_]+?)_([^]*?)_EMO_/g, L8 = function(t) {
  return t.charCodeAt(1) === 45;
}, f4 = function(t) {
  return t != null && typeof t != "boolean";
}, zu = /* @__PURE__ */ SM(function(e) {
  return L8(e) ? e : e.replace(JM, "-$&").toLowerCase();
}), p4 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(KM, function(r, o, a) {
          return mn = {
            name: o,
            styles: a,
            next: mn
          }, o;
        });
  }
  return XM[t] !== 1 && !L8(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, qM = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function fi(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return mn = {
          name: o.name,
          styles: o.styles,
          next: mn
        }, o.name;
      var a = n;
      if (a.styles !== void 0) {
        var i = a.next;
        if (i !== void 0)
          for (; i !== void 0; )
            mn = {
              name: i.name,
              styles: i.styles,
              next: mn
            }, i = i.next;
        var s = a.styles + ";";
        return s;
      }
      return QM(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = mn, c = n(e);
        return mn = l, fi(e, t, c);
      }
      break;
    }
  }
  var d = n;
  if (t == null)
    return d;
  var f = t[d];
  return f !== void 0 ? f : d;
}
function QM(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += fi(e, t, n[o]) + ";";
  else
    for (var a in n) {
      var i = n[a];
      if (typeof i != "object") {
        var s = i;
        t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : f4(s) && (r += zu(a) + ":" + p4(a, s) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && UM)
          throw new Error(qM);
        if (Array.isArray(i) && typeof i[0] == "string" && (t == null || t[i[0]] === void 0))
          for (var l = 0; l < i.length; l++)
            f4(i[l]) && (r += zu(a) + ":" + p4(a, i[l]) + ";");
        else {
          var c = fi(e, t, i);
          switch (a) {
            case "animation":
            case "animationName": {
              r += zu(a) + ":" + c + ";";
              break;
            }
            default:
              r += a + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var h4 = /label:\s*([^\s;{]+)\s*(;|$)/g, mn;
function R8(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  mn = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, o += fi(n, t, a);
  else {
    var i = a;
    o += i[0];
  }
  for (var s = 1; s < e.length; s++)
    if (o += fi(n, t, e[s]), r) {
      var l = a;
      o += l[s];
    }
  h4.lastIndex = 0;
  for (var c = "", d; (d = h4.exec(o)) !== null; )
    c += "-" + d[1];
  var f = zM(o) + c;
  return {
    name: f,
    styles: o,
    next: mn
  };
}
var eN = function(t) {
  return t();
}, tN = b["useInsertionEffect"] ? b["useInsertionEffect"] : !1, nN = tN || eN, rN = !1, V8 = /* @__PURE__ */ b.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ TM({
    key: "css"
  }) : null
);
V8.Provider;
var oN = function(t) {
  return /* @__PURE__ */ cn(function(n, r) {
    var o = Ht(V8);
    return t(n, o, r);
  });
}, aN = /* @__PURE__ */ b.createContext({}), D2 = {}.hasOwnProperty, Z1 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", iN = function(t, n) {
  var r = {};
  for (var o in n)
    D2.call(n, o) && (r[o] = n[o]);
  return r[Z1] = t, r;
}, sN = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return T8(n, r, o), nN(function() {
    return jM(n, r, o);
  }), null;
}, lN = /* @__PURE__ */ oN(function(e, t, n) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var o = e[Z1], a = [r], i = "";
  typeof e.className == "string" ? i = YM(t.registered, a, e.className) : e.className != null && (i = e.className + " ");
  var s = R8(a, void 0, b.useContext(aN));
  i += t.key + "-" + s.name;
  var l = {};
  for (var c in e)
    D2.call(e, c) && c !== "css" && c !== Z1 && !rN && (l[c] = e[c]);
  return l.className = i, n && (l.ref = n), /* @__PURE__ */ b.createElement(b.Fragment, null, /* @__PURE__ */ b.createElement(sN, {
    cache: t,
    serialized: s,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ b.createElement(o, l));
}), cN = lN, pe = function(t, n) {
  var r = arguments;
  if (n == null || !D2.call(n, "css"))
    return b.createElement.apply(void 0, r);
  var o = r.length, a = new Array(o);
  a[0] = cN, a[1] = iN(t, n);
  for (var i = 2; i < o; i++)
    a[i] = r[i];
  return b.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(pe || (pe = {}));
function M2() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return R8(t);
}
function uN() {
  var e = M2.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function dN(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
var yl = ea, fN = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], xl = function() {
};
function pN(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function hN(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
    r[o - 2] = arguments[o];
  var a = [].concat(r);
  if (t && e)
    for (var i in t)
      t.hasOwnProperty(i) && t[i] && a.push("".concat(pN(e, i)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var El = function(t) {
  return EN(t) ? t.filter(Boolean) : Ur(t) === "object" && t !== null ? [t] : [];
}, k8 = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var n = Pn(t, fN);
  return de({}, n);
}, Je = function(t, n, r) {
  var o = t.cx, a = t.getStyles, i = t.getClassNames, s = t.className;
  return {
    css: a(n, t),
    className: o(r ?? {}, i(n, t), s)
  };
};
function bc(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function mN(e) {
  return bc(e) ? window.innerHeight : e.clientHeight;
}
function F8(e) {
  return bc(e) ? window.pageYOffset : e.scrollTop;
}
function Il(e, t) {
  if (bc(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function vN(e) {
  var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed")
    return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (t = getComputedStyle(o), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return o;
  return document.documentElement;
}
function gN(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Is(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : xl, o = F8(e), a = t - o, i = 10, s = 0;
  function l() {
    s += i;
    var c = gN(s, o, a, n);
    Il(e, c), s < n ? window.requestAnimationFrame(l) : r(e);
  }
  l();
}
function m4(e, t) {
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), o = t.offsetHeight / 3;
  r.bottom + o > n.bottom ? Il(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : r.top - o < n.top && Il(e, Math.max(t.offsetTop - o, 0));
}
function wN(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function v4() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function bN() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var H8 = !1, CN = {
  get passive() {
    return H8 = !0;
  }
}, Ss = typeof window < "u" ? window : {};
Ss.addEventListener && Ss.removeEventListener && (Ss.addEventListener("p", xl, CN), Ss.removeEventListener("p", xl, !1));
var yN = H8;
function xN(e) {
  return e != null;
}
function EN(e) {
  return Array.isArray(e);
}
function za(e, t, n) {
  return e ? t : n;
}
var IN = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  var a = Object.entries(t).filter(function(i) {
    var s = Wn(i, 1), l = s[0];
    return !r.includes(l);
  });
  return a.reduce(function(i, s) {
    var l = Wn(s, 2), c = l[0], d = l[1];
    return i[c] = d, i;
  }, {});
}, SN = ["children", "innerProps"], DN = ["children", "innerProps"];
function MN(e) {
  var t = e.maxHeight, n = e.menuEl, r = e.minHeight, o = e.placement, a = e.shouldScroll, i = e.isFixedPosition, s = e.controlHeight, l = vN(n), c = {
    placement: "bottom",
    maxHeight: t
  };
  if (!n || !n.offsetParent)
    return c;
  var d = l.getBoundingClientRect(), f = d.height, p = n.getBoundingClientRect(), h = p.bottom, g = p.height, m = p.top, v = n.offsetParent.getBoundingClientRect(), w = v.top, C = i ? window.innerHeight : mN(l), y = F8(l), x = parseInt(getComputedStyle(n).marginBottom, 10), E = parseInt(getComputedStyle(n).marginTop, 10), S = w - E, I = C - m, D = S + y, N = f - y - m, A = h - C + y + x, L = y + m - E, F = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (I >= g)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (N >= g && !i)
        return a && Is(l, A, F), {
          placement: "bottom",
          maxHeight: t
        };
      if (!i && N >= r || i && I >= r) {
        a && Is(l, A, F);
        var k = i ? I - x : N - x;
        return {
          placement: "bottom",
          maxHeight: k
        };
      }
      if (o === "auto" || i) {
        var G = t, J = i ? S : D;
        return J >= r && (G = Math.min(J - x - s, t)), {
          placement: "top",
          maxHeight: G
        };
      }
      if (o === "bottom")
        return a && Il(l, A), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (S >= g)
        return {
          placement: "top",
          maxHeight: t
        };
      if (D >= g && !i)
        return a && Is(l, L, F), {
          placement: "top",
          maxHeight: t
        };
      if (!i && D >= r || i && S >= r) {
        var $ = t;
        return (!i && D >= r || i && S >= r) && ($ = i ? S - E : D - E), a && Is(l, L, F), {
          placement: "top",
          maxHeight: $
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return c;
}
function NN(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var B8 = function(t) {
  return t === "auto" ? "bottom" : t;
}, PN = function(t, n) {
  var r, o = t.placement, a = t.theme, i = a.borderRadius, s = a.spacing, l = a.colors;
  return de((r = {
    label: "menu"
  }, ja(r, NN(o), "100%"), ja(r, "position", "absolute"), ja(r, "width", "100%"), ja(r, "zIndex", 1), r), n ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, G8 = /* @__PURE__ */ Kn(null), AN = function(t) {
  var n = t.children, r = t.minMenuHeight, o = t.maxMenuHeight, a = t.menuPlacement, i = t.menuPosition, s = t.menuShouldScrollIntoView, l = t.theme, c = Ht(G8) || {}, d = c.setPortalPlacement, f = le(null), p = ue(o), h = Wn(p, 2), g = h[0], m = h[1], v = ue(null), w = Wn(v, 2), C = w[0], y = w[1], x = l.spacing.controlHeight;
  return yl(function() {
    var E = f.current;
    if (E) {
      var S = i === "fixed", I = s && !S, D = MN({
        maxHeight: o,
        menuEl: E,
        minHeight: r,
        placement: a,
        shouldScroll: I,
        isFixedPosition: S,
        controlHeight: x
      });
      m(D.maxHeight), y(D.placement), d == null || d(D.placement);
    }
  }, [o, a, i, s, r, d, x]), n({
    ref: f,
    placerProps: de(de({}, t), {}, {
      placement: C || B8(a),
      maxHeight: g
    })
  });
}, _N = function(t) {
  var n = t.children, r = t.innerRef, o = t.innerProps;
  return pe("div", ee({}, Je(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, o), n);
}, ON = _N, TN = function(t, n) {
  var r = t.maxHeight, o = t.theme.spacing.baseUnit;
  return de({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, n ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, LN = function(t) {
  var n = t.children, r = t.innerProps, o = t.innerRef, a = t.isMulti;
  return pe("div", ee({}, Je(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, r), n);
}, W8 = function(t, n) {
  var r = t.theme, o = r.spacing.baseUnit, a = r.colors;
  return de({
    textAlign: "center"
  }, n ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, RN = W8, VN = W8, kN = function(t) {
  var n = t.children, r = n === void 0 ? "No options" : n, o = t.innerProps, a = Pn(t, SN);
  return pe("div", ee({}, Je(de(de({}, a), {}, {
    children: r,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), r);
}, FN = function(t) {
  var n = t.children, r = n === void 0 ? "Loading..." : n, o = t.innerProps, a = Pn(t, DN);
  return pe("div", ee({}, Je(de(de({}, a), {}, {
    children: r,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), r);
}, HN = function(t) {
  var n = t.rect, r = t.offset, o = t.position;
  return {
    left: n.left,
    position: o,
    top: r,
    width: n.width,
    zIndex: 1
  };
}, BN = function(t) {
  var n = t.appendTo, r = t.children, o = t.controlElement, a = t.innerProps, i = t.menuPlacement, s = t.menuPosition, l = le(null), c = le(null), d = ue(B8(i)), f = Wn(d, 2), p = f[0], h = f[1], g = Xe(function() {
    return {
      setPortalPlacement: h
    };
  }, []), m = ue(null), v = Wn(m, 2), w = v[0], C = v[1], y = Ve(function() {
    if (o) {
      var I = wN(o), D = s === "fixed" ? 0 : window.pageYOffset, N = I[p] + D;
      (N !== (w == null ? void 0 : w.offset) || I.left !== (w == null ? void 0 : w.rect.left) || I.width !== (w == null ? void 0 : w.rect.width)) && C({
        offset: N,
        rect: I
      });
    }
  }, [o, s, p, w == null ? void 0 : w.offset, w == null ? void 0 : w.rect.left, w == null ? void 0 : w.rect.width]);
  yl(function() {
    y();
  }, [y]);
  var x = Ve(function() {
    typeof c.current == "function" && (c.current(), c.current = null), o && l.current && (c.current = t9(o, l.current, y, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, y]);
  yl(function() {
    x();
  }, [x]);
  var E = Ve(function(I) {
    l.current = I, x();
  }, [x]);
  if (!n && s !== "fixed" || !w)
    return null;
  var S = pe("div", ee({
    ref: E
  }, Je(de(de({}, t), {}, {
    offset: w.offset,
    position: s,
    rect: w.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), r);
  return pe(G8.Provider, {
    value: g
  }, n ? /* @__PURE__ */ A7(S, n) : S);
}, GN = function(t) {
  var n = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: n ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, WN = function(t) {
  var n = t.children, r = t.innerProps, o = t.isDisabled, a = t.isRtl;
  return pe("div", ee({}, Je(t, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), r), n);
}, ZN = function(t, n) {
  var r = t.theme.spacing, o = t.isMulti, a = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return de({
    alignItems: "center",
    display: o && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, n ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, $N = function(t) {
  var n = t.children, r = t.innerProps, o = t.isMulti, a = t.hasValue;
  return pe("div", ee({}, Je(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), r), n);
}, YN = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, jN = function(t) {
  var n = t.children, r = t.innerProps;
  return pe("div", ee({}, Je(t, "indicatorsContainer", {
    indicators: !0
  }), r), n);
}, g4, zN = ["size"], XN = ["innerProps", "isRtl", "size"];
function UN() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var JN = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: UN
}, Z8 = function(t) {
  var n = t.size, r = Pn(t, zN);
  return pe("svg", ee({
    height: n,
    width: n,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: JN
  }, r));
}, N2 = function(t) {
  return pe(Z8, ee({
    size: 20
  }, t), pe("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, $8 = function(t) {
  return pe(Z8, ee({
    size: 20
  }, t), pe("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, Y8 = function(t, n) {
  var r = t.isFocused, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return de({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: a * 2,
    ":hover": {
      color: r ? i.neutral80 : i.neutral40
    }
  });
}, KN = Y8, qN = function(t) {
  var n = t.children, r = t.innerProps;
  return pe("div", ee({}, Je(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), n || pe($8, null));
}, QN = Y8, eP = function(t) {
  var n = t.children, r = t.innerProps;
  return pe("div", ee({}, Je(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), n || pe(N2, null));
}, tP = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing.baseUnit, i = o.colors;
  return de({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, n ? {} : {
    backgroundColor: r ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, nP = function(t) {
  var n = t.innerProps;
  return pe("span", ee({}, n, Je(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, rP = uN(g4 || (g4 = dN([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), oP = function(t, n) {
  var r = t.isFocused, o = t.size, a = t.theme, i = a.colors, s = a.spacing.baseUnit;
  return de({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, n ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: s * 2
  });
}, Xu = function(t) {
  var n = t.delay, r = t.offset;
  return pe("span", {
    css: /* @__PURE__ */ M2({
      animation: "".concat(rP, " 1s ease-in-out ").concat(n, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, aP = function(t) {
  var n = t.innerProps, r = t.isRtl, o = t.size, a = o === void 0 ? 4 : o, i = Pn(t, XN);
  return pe("div", ee({}, Je(de(de({}, i), {}, {
    innerProps: n,
    isRtl: r,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), n), pe(Xu, {
    delay: 0,
    offset: r
  }), pe(Xu, {
    delay: 160,
    offset: !0
  }), pe(Xu, {
    delay: 320,
    offset: !r
  }));
}, iP = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.theme, i = a.colors, s = a.borderRadius, l = a.spacing;
  return de({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, n ? {} : {
    backgroundColor: r ? i.neutral5 : i.neutral0,
    borderColor: r ? i.neutral10 : o ? i.primary : i.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: o ? i.primary : i.neutral30
    }
  });
}, sP = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.innerRef, i = t.innerProps, s = t.menuIsOpen;
  return pe("div", ee({
    ref: a
  }, Je(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": o,
    "control--menu-is-open": s
  }), i, {
    "aria-disabled": r || void 0
  }), n);
}, lP = sP, cP = ["data"], uP = function(t, n) {
  var r = t.theme.spacing;
  return n ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, dP = function(t) {
  var n = t.children, r = t.cx, o = t.getStyles, a = t.getClassNames, i = t.Heading, s = t.headingProps, l = t.innerProps, c = t.label, d = t.theme, f = t.selectProps;
  return pe("div", ee({}, Je(t, "group", {
    group: !0
  }), l), pe(i, ee({}, s, {
    selectProps: f,
    theme: d,
    getStyles: o,
    getClassNames: a,
    cx: r
  }), c), pe("div", null, n));
}, fP = function(t, n) {
  var r = t.theme, o = r.colors, a = r.spacing;
  return de({
    label: "group",
    cursor: "default",
    display: "block"
  }, n ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, pP = function(t) {
  var n = k8(t);
  n.data;
  var r = Pn(n, cP);
  return pe("div", ee({}, Je(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, hP = dP, mP = ["innerRef", "isDisabled", "isHidden", "inputClassName"], vP = function(t, n) {
  var r = t.isDisabled, o = t.value, a = t.theme, i = a.spacing, s = a.colors;
  return de(de({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, gP), n ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: s.neutral80
  });
}, j8 = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, gP = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": de({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, j8)
}, wP = function(t) {
  return de({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, j8);
}, bP = function(t) {
  var n = t.cx, r = t.value, o = k8(t), a = o.innerRef, i = o.isDisabled, s = o.isHidden, l = o.inputClassName, c = Pn(o, mP);
  return pe("div", ee({}, Je(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), pe("input", ee({
    className: n({
      input: !0
    }, l),
    ref: a,
    style: wP(s),
    disabled: i
  }, c)));
}, CP = bP, yP = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors;
  return de({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, n ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, xP = function(t, n) {
  var r = t.theme, o = r.borderRadius, a = r.colors, i = t.cropWithEllipsis;
  return de({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, n ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, EP = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.borderRadius, i = r.colors, s = t.isFocused;
  return de({
    alignItems: "center",
    display: "flex"
  }, n ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? i.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, z8 = function(t) {
  var n = t.children, r = t.innerProps;
  return pe("div", r, n);
}, IP = z8, SP = z8;
function DP(e) {
  var t = e.children, n = e.innerProps;
  return pe("div", ee({
    role: "button"
  }, n), t || pe(N2, {
    size: 14
  }));
}
var MP = function(t) {
  var n = t.children, r = t.components, o = t.data, a = t.innerProps, i = t.isDisabled, s = t.removeProps, l = t.selectProps, c = r.Container, d = r.Label, f = r.Remove;
  return pe(c, {
    data: o,
    innerProps: de(de({}, Je(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), a),
    selectProps: l
  }, pe(d, {
    data: o,
    innerProps: de({}, Je(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, n), pe(f, {
    data: o,
    innerProps: de(de({}, Je(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(n || "option")
    }, s),
    selectProps: l
  }));
}, NP = MP, PP = function(t, n) {
  var r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.theme, s = i.spacing, l = i.colors;
  return de({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, n ? {} : {
    backgroundColor: a ? l.primary : o ? l.primary25 : "transparent",
    color: r ? l.neutral20 : a ? l.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : a ? l.primary : l.primary50
    }
  });
}, AP = function(t) {
  var n = t.children, r = t.isDisabled, o = t.isFocused, a = t.isSelected, i = t.innerRef, s = t.innerProps;
  return pe("div", ee({}, Je(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: i,
    "aria-disabled": r
  }, s), n);
}, _P = AP, OP = function(t, n) {
  var r = t.theme, o = r.spacing, a = r.colors;
  return de({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, n ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, TP = function(t) {
  var n = t.children, r = t.innerProps;
  return pe("div", ee({}, Je(t, "placeholder", {
    placeholder: !0
  }), r), n);
}, LP = TP, RP = function(t, n) {
  var r = t.isDisabled, o = t.theme, a = o.spacing, i = o.colors;
  return de({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, n ? {} : {
    color: r ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, VP = function(t) {
  var n = t.children, r = t.isDisabled, o = t.innerProps;
  return pe("div", ee({}, Je(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), o), n);
}, kP = VP, X8 = {
  ClearIndicator: eP,
  Control: lP,
  DropdownIndicator: qN,
  DownChevron: $8,
  CrossIcon: N2,
  Group: hP,
  GroupHeading: pP,
  IndicatorsContainer: jN,
  IndicatorSeparator: nP,
  Input: CP,
  LoadingIndicator: aP,
  Menu: ON,
  MenuList: LN,
  MenuPortal: BN,
  LoadingMessage: FN,
  NoOptionsMessage: kN,
  MultiValue: NP,
  MultiValueContainer: IP,
  MultiValueLabel: SP,
  MultiValueRemove: DP,
  Option: _P,
  Placeholder: LP,
  SelectContainer: WN,
  SingleValue: kP,
  ValueContainer: $N
}, FP = function(t) {
  return de(de({}, X8), t.components);
}, w4 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function HP(e, t) {
  return !!(e === t || w4(e) && w4(t));
}
function BP(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!HP(e[n], t[n]))
      return !1;
  return !0;
}
function GP(e, t) {
  t === void 0 && (t = BP);
  var n = null;
  function r() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (n && n.lastThis === this && t(o, n.lastArgs))
      return n.lastResult;
    var i = e.apply(this, o);
    return n = {
      lastResult: i,
      lastArgs: o,
      lastThis: this
    }, i;
  }
  return r.clear = function() {
    n = null;
  }, r;
}
function WP() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var ZP = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: WP
}, $P = function(t) {
  return pe("span", ee({
    css: ZP
  }, t));
}, b4 = $P, YP = {
  guidance: function(t) {
    var n = t.isSearchable, r = t.isMulti, o = t.tabSelectsValue, a = t.context, i = t.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(t["aria-label"] || "Select", " is focused ").concat(n ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var n = t.action, r = t.label, o = r === void 0 ? "" : r, a = t.labels, i = t.isDisabled;
    switch (n) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var n = t.context, r = t.focused, o = t.options, a = t.label, i = a === void 0 ? "" : a, s = t.selectValue, l = t.isDisabled, c = t.isSelected, d = t.isAppleDevice, f = function(m, v) {
      return m && m.length ? "".concat(m.indexOf(v) + 1, " of ").concat(m.length) : "";
    };
    if (n === "value" && s)
      return "value ".concat(i, " focused, ").concat(f(s, r), ".");
    if (n === "menu" && d) {
      var p = l ? " disabled" : "", h = "".concat(c ? " selected" : "").concat(p);
      return "".concat(i).concat(h, ", ").concat(f(o, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var n = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(n ? " for search term " + n : "", ".");
  }
}, jP = function(t) {
  var n = t.ariaSelection, r = t.focusedOption, o = t.focusedValue, a = t.focusableOptions, i = t.isFocused, s = t.selectValue, l = t.selectProps, c = t.id, d = t.isAppleDevice, f = l.ariaLiveMessages, p = l.getOptionLabel, h = l.inputValue, g = l.isMulti, m = l.isOptionDisabled, v = l.isSearchable, w = l.menuIsOpen, C = l.options, y = l.screenReaderStatus, x = l.tabSelectsValue, E = l.isLoading, S = l["aria-label"], I = l["aria-live"], D = Xe(function() {
    return de(de({}, YP), f || {});
  }, [f]), N = Xe(function() {
    var J = "";
    if (n && D.onChange) {
      var $ = n.option, H = n.options, V = n.removedValue, j = n.removedValues, B = n.value, Z = function(Q) {
        return Array.isArray(Q) ? null : Q;
      }, O = V || $ || Z(B), Y = O ? p(O) : "", U = H || j || void 0, K = U ? U.map(p) : [], q = de({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: O && m(O, s),
        label: Y,
        labels: K
      }, n);
      J = D.onChange(q);
    }
    return J;
  }, [n, D, m, s, p]), A = Xe(function() {
    var J = "", $ = r || o, H = !!(r && s && s.includes(r));
    if ($ && D.onFocus) {
      var V = {
        focused: $,
        label: p($),
        isDisabled: m($, s),
        isSelected: H,
        options: a,
        context: $ === r ? "menu" : "value",
        selectValue: s,
        isAppleDevice: d
      };
      J = D.onFocus(V);
    }
    return J;
  }, [r, o, p, m, D, a, s, d]), L = Xe(function() {
    var J = "";
    if (w && C.length && !E && D.onFilter) {
      var $ = y({
        count: a.length
      });
      J = D.onFilter({
        inputValue: h,
        resultsMessage: $
      });
    }
    return J;
  }, [a, h, w, D, C, y, E]), F = (n == null ? void 0 : n.action) === "initial-input-focus", k = Xe(function() {
    var J = "";
    if (D.guidance) {
      var $ = o ? "value" : w ? "menu" : "input";
      J = D.guidance({
        "aria-label": S,
        context: $,
        isDisabled: r && m(r, s),
        isMulti: g,
        isSearchable: v,
        tabSelectsValue: x,
        isInitialFocus: F
      });
    }
    return J;
  }, [S, r, o, g, m, v, w, D, s, x, F]), G = pe(M1, null, pe("span", {
    id: "aria-selection"
  }, N), pe("span", {
    id: "aria-focused"
  }, A), pe("span", {
    id: "aria-results"
  }, L), pe("span", {
    id: "aria-guidance"
  }, k));
  return pe(M1, null, pe(b4, {
    id: c
  }, F && G), pe(b4, {
    "aria-live": I,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !F && G));
}, zP = jP, $1 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], XP = new RegExp("[" + $1.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), U8 = {};
for (var Uu = 0; Uu < $1.length; Uu++)
  for (var Ju = $1[Uu], Ku = 0; Ku < Ju.letters.length; Ku++)
    U8[Ju.letters[Ku]] = Ju.base;
var J8 = function(t) {
  return t.replace(XP, function(n) {
    return U8[n];
  });
}, UP = GP(J8), C4 = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, JP = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, KP = function(t) {
  return function(n, r) {
    if (n.data.__isNew__)
      return !0;
    var o = de({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: JP,
      trim: !0,
      matchFrom: "any"
    }, t), a = o.ignoreCase, i = o.ignoreAccents, s = o.stringify, l = o.trim, c = o.matchFrom, d = l ? C4(r) : r, f = l ? C4(s(n)) : s(n);
    return a && (d = d.toLowerCase(), f = f.toLowerCase()), i && (d = UP(d), f = J8(f)), c === "start" ? f.substr(0, d.length) === d : f.indexOf(d) > -1;
  };
}, qP = ["innerRef"];
function QP(e) {
  var t = e.innerRef, n = Pn(e, qP), r = IN(n, "onExited", "in", "enter", "exit", "appear");
  return pe("input", ee({
    ref: t
  }, r, {
    css: /* @__PURE__ */ M2({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var eA = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function tA(e) {
  var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, i = le(!1), s = le(!1), l = le(0), c = le(null), d = Ve(function(v, w) {
    if (c.current !== null) {
      var C = c.current, y = C.scrollTop, x = C.scrollHeight, E = C.clientHeight, S = c.current, I = w > 0, D = x - E - y, N = !1;
      D > w && i.current && (r && r(v), i.current = !1), I && s.current && (a && a(v), s.current = !1), I && w > D ? (n && !i.current && n(v), S.scrollTop = x, N = !0, i.current = !0) : !I && -w > y && (o && !s.current && o(v), S.scrollTop = 0, N = !0, s.current = !0), N && eA(v);
    }
  }, [n, r, o, a]), f = Ve(function(v) {
    d(v, v.deltaY);
  }, [d]), p = Ve(function(v) {
    l.current = v.changedTouches[0].clientY;
  }, []), h = Ve(function(v) {
    var w = l.current - v.changedTouches[0].clientY;
    d(v, w);
  }, [d]), g = Ve(function(v) {
    if (v) {
      var w = yN ? {
        passive: !1
      } : !1;
      v.addEventListener("wheel", f, w), v.addEventListener("touchstart", p, w), v.addEventListener("touchmove", h, w);
    }
  }, [h, p, f]), m = Ve(function(v) {
    v && (v.removeEventListener("wheel", f, !1), v.removeEventListener("touchstart", p, !1), v.removeEventListener("touchmove", h, !1));
  }, [h, p, f]);
  return ye(function() {
    if (t) {
      var v = c.current;
      return g(v), function() {
        m(v);
      };
    }
  }, [t, g, m]), function(v) {
    c.current = v;
  };
}
var y4 = ["boxSizing", "height", "overflow", "paddingRight", "position"], x4 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function E4(e) {
  e.cancelable && e.preventDefault();
}
function I4(e) {
  e.stopPropagation();
}
function S4() {
  var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function D4() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var M4 = !!(typeof window < "u" && window.document && window.document.createElement), Aa = 0, bo = {
  capture: !1,
  passive: !1
};
function nA(e) {
  var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, o = le({}), a = le(null), i = Ve(function(l) {
    if (M4) {
      var c = document.body, d = c && c.style;
      if (r && y4.forEach(function(g) {
        var m = d && d[g];
        o.current[g] = m;
      }), r && Aa < 1) {
        var f = parseInt(o.current.paddingRight, 10) || 0, p = document.body ? document.body.clientWidth : 0, h = window.innerWidth - p + f || 0;
        Object.keys(x4).forEach(function(g) {
          var m = x4[g];
          d && (d[g] = m);
        }), d && (d.paddingRight = "".concat(h, "px"));
      }
      c && D4() && (c.addEventListener("touchmove", E4, bo), l && (l.addEventListener("touchstart", S4, bo), l.addEventListener("touchmove", I4, bo))), Aa += 1;
    }
  }, [r]), s = Ve(function(l) {
    if (M4) {
      var c = document.body, d = c && c.style;
      Aa = Math.max(Aa - 1, 0), r && Aa < 1 && y4.forEach(function(f) {
        var p = o.current[f];
        d && (d[f] = p);
      }), c && D4() && (c.removeEventListener("touchmove", E4, bo), l && (l.removeEventListener("touchstart", S4, bo), l.removeEventListener("touchmove", I4, bo)));
    }
  }, [r]);
  return ye(function() {
    if (t) {
      var l = a.current;
      return i(l), function() {
        s(l);
      };
    }
  }, [t, i, s]), function(l) {
    a.current = l;
  };
}
function rA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var oA = function(t) {
  var n = t.target;
  return n.ownerDocument.activeElement && n.ownerDocument.activeElement.blur();
}, aA = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: rA
};
function iA(e) {
  var t = e.children, n = e.lockEnabled, r = e.captureEnabled, o = r === void 0 ? !0 : r, a = e.onBottomArrive, i = e.onBottomLeave, s = e.onTopArrive, l = e.onTopLeave, c = tA({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: i,
    onTopArrive: s,
    onTopLeave: l
  }), d = nA({
    isEnabled: n
  }), f = function(h) {
    c(h), d(h);
  };
  return pe(M1, null, n && pe("div", {
    onClick: oA,
    css: aA
  }), t(f));
}
function sA() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var lA = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: sA
}, cA = function(t) {
  var n = t.name, r = t.onFocus;
  return pe("input", {
    required: !0,
    name: n,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: lA,
    value: "",
    onChange: function() {
    }
  });
}, uA = cA;
function P2(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function dA() {
  return P2(/^iPhone/i);
}
function K8() {
  return P2(/^Mac/i);
}
function fA() {
  return P2(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  K8() && navigator.maxTouchPoints > 1;
}
function pA() {
  return dA() || fA();
}
function hA() {
  return K8() || pA();
}
var mA = function(t) {
  return t.label;
}, q8 = function(t) {
  return t.label;
}, Q8 = function(t) {
  return t.value;
}, vA = function(t) {
  return !!t.isDisabled;
}, gA = {
  clearIndicator: QN,
  container: GN,
  control: iP,
  dropdownIndicator: KN,
  group: uP,
  groupHeading: fP,
  indicatorsContainer: YN,
  indicatorSeparator: tP,
  input: vP,
  loadingIndicator: oP,
  loadingMessage: VN,
  menu: PN,
  menuList: TN,
  menuPortal: HN,
  multiValue: yP,
  multiValueLabel: xP,
  multiValueRemove: EP,
  noOptionsMessage: RN,
  option: PP,
  placeholder: OP,
  singleValue: RP,
  valueContainer: ZN
}, wA = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, bA = 4, eh = 4, CA = 38, yA = eh * 2, xA = {
  baseUnit: eh,
  controlHeight: CA,
  menuGutter: yA
}, qu = {
  borderRadius: bA,
  colors: wA,
  spacing: xA
}, EA = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: v4(),
  captureMenuScroll: !v4(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: KP(),
  formatGroupLabel: mA,
  getOptionLabel: q8,
  getOptionValue: Q8,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: vA,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !bN(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var n = t.count;
    return "".concat(n, " result").concat(n !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function N4(e, t, n, r) {
  var o = rh(e, t, n), a = oh(e, t, n), i = nh(e, t), s = Sl(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: o,
    isSelected: a,
    label: i,
    value: s,
    index: r
  };
}
function nl(e, t) {
  return e.options.map(function(n, r) {
    if ("options" in n) {
      var o = n.options.map(function(i, s) {
        return N4(e, i, t, s);
      }).filter(function(i) {
        return A4(e, i);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var a = N4(e, n, t, r);
    return A4(e, a) ? a : void 0;
  }).filter(xN);
}
function th(e) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Vo(n.options.map(function(r) {
      return r.data;
    }))) : t.push(n.data), t;
  }, []);
}
function P4(e, t) {
  return e.reduce(function(n, r) {
    return r.type === "group" ? n.push.apply(n, Vo(r.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(o.index)
      };
    }))) : n.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), n;
  }, []);
}
function IA(e, t) {
  return th(nl(e, t));
}
function A4(e, t) {
  var n = e.inputValue, r = n === void 0 ? "" : n, o = t.data, a = t.isSelected, i = t.label, s = t.value;
  return (!ih(e) || !a) && ah(e, {
    label: i,
    value: s,
    data: o
  }, r);
}
function SA(e, t) {
  var n = e.focusedValue, r = e.selectValue, o = r.indexOf(n);
  if (o > -1) {
    var a = t.indexOf(n);
    if (a > -1)
      return n;
    if (o < t.length)
      return t[o];
  }
  return null;
}
function DA(e, t) {
  var n = e.focusedOption;
  return n && t.indexOf(n) > -1 ? n : t[0];
}
var Qu = function(t, n) {
  var r, o = (r = t.find(function(a) {
    return a.data === n;
  })) === null || r === void 0 ? void 0 : r.id;
  return o || null;
}, nh = function(t, n) {
  return t.getOptionLabel(n);
}, Sl = function(t, n) {
  return t.getOptionValue(n);
};
function rh(e, t, n) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function oh(e, t, n) {
  if (n.indexOf(t) > -1)
    return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, n);
  var r = Sl(e, t);
  return n.some(function(o) {
    return Sl(e, o) === r;
  });
}
function ah(e, t, n) {
  return e.filterOption ? e.filterOption(t, n) : !0;
}
var ih = function(t) {
  var n = t.hideSelectedOptions, r = t.isMulti;
  return n === void 0 ? r : n;
}, MA = 1, A2 = /* @__PURE__ */ function(e) {
  JD(n, e);
  var t = QD(n);
  function n(r) {
    var o;
    if (XD(this, n), o = t.call(this, r), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = hA(), o.controlRef = null, o.getControlRef = function(l) {
      o.controlRef = l;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(l) {
      o.focusedOptionRef = l;
    }, o.menuListRef = null, o.getMenuListRef = function(l) {
      o.menuListRef = l;
    }, o.inputRef = null, o.getInputRef = function(l) {
      o.inputRef = l;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(l, c) {
      var d = o.props, f = d.onChange, p = d.name;
      c.name = p, o.ariaOnChange(l, c), f(l, c);
    }, o.setValue = function(l, c, d) {
      var f = o.props, p = f.closeMenuOnSelect, h = f.isMulti, g = f.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: g
      }), p && (o.setState({
        inputIsHiddenAfterUpdate: !h
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(l, {
        action: c,
        option: d
      });
    }, o.selectOption = function(l) {
      var c = o.props, d = c.blurInputOnSelect, f = c.isMulti, p = c.name, h = o.state.selectValue, g = f && o.isOptionSelected(l, h), m = o.isOptionDisabled(l, h);
      if (g) {
        var v = o.getOptionValue(l);
        o.setValue(h.filter(function(w) {
          return o.getOptionValue(w) !== v;
        }), "deselect-option", l);
      } else if (!m)
        f ? o.setValue([].concat(Vo(h), [l]), "select-option", l) : o.setValue(l, "select-option");
      else {
        o.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: p
        });
        return;
      }
      d && o.blurInput();
    }, o.removeValue = function(l) {
      var c = o.props.isMulti, d = o.state.selectValue, f = o.getOptionValue(l), p = d.filter(function(g) {
        return o.getOptionValue(g) !== f;
      }), h = za(c, p, p[0] || null);
      o.onChange(h, {
        action: "remove-value",
        removedValue: l
      }), o.focusInput();
    }, o.clearValue = function() {
      var l = o.state.selectValue;
      o.onChange(za(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, o.popValue = function() {
      var l = o.props.isMulti, c = o.state.selectValue, d = c[c.length - 1], f = c.slice(0, c.length - 1), p = za(l, f, f[0] || null);
      d && o.onChange(p, {
        action: "pop-value",
        removedValue: d
      });
    }, o.getFocusedOptionId = function(l) {
      return Qu(o.state.focusableOptionsWithIds, l);
    }, o.getFocusableOptionsWithIds = function() {
      return P4(nl(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var l = arguments.length, c = new Array(l), d = 0; d < l; d++)
        c[d] = arguments[d];
      return hN.apply(void 0, [o.props.classNamePrefix].concat(c));
    }, o.getOptionLabel = function(l) {
      return nh(o.props, l);
    }, o.getOptionValue = function(l) {
      return Sl(o.props, l);
    }, o.getStyles = function(l, c) {
      var d = o.props.unstyled, f = gA[l](c, d);
      f.boxSizing = "border-box";
      var p = o.props.styles[l];
      return p ? p(f, c) : f;
    }, o.getClassNames = function(l, c) {
      var d, f;
      return (d = (f = o.props.classNames)[l]) === null || d === void 0 ? void 0 : d.call(f, c);
    }, o.getElementId = function(l) {
      return "".concat(o.state.instancePrefix, "-").concat(l);
    }, o.getComponents = function() {
      return FP(o.props);
    }, o.buildCategorizedOptions = function() {
      return nl(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return th(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(l, c) {
      o.setState({
        ariaSelection: de({
          value: l
        }, c)
      });
    }, o.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(l) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var c = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && o.onMenuClose() : c && o.openMenu("first") : (c && (o.openAfterFocus = !0), o.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !o.props.isDisabled) {
        var c = o.props, d = c.isMulti, f = c.menuIsOpen;
        o.focusInput(), f ? (o.setState({
          inputIsHiddenAfterUpdate: !d
        }), o.onMenuClose()) : o.openMenu("first"), l.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (o.clearValue(), l.preventDefault(), o.openAfterFocus = !1, l.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(l) {
      typeof o.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && bc(l.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(l) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(l) {
      var c = l.touches, d = c && c.item(0);
      d && (o.initialTouchX = d.clientX, o.initialTouchY = d.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(l) {
      var c = l.touches, d = c && c.item(0);
      if (d) {
        var f = Math.abs(d.clientX - o.initialTouchX), p = Math.abs(d.clientY - o.initialTouchY), h = 5;
        o.userIsDragging = f > h || p > h;
      }
    }, o.onTouchEnd = function(l) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(l.target) && o.menuListRef && !o.menuListRef.contains(l.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(l) {
      o.userIsDragging || o.onControlMouseDown(l);
    }, o.onClearIndicatorTouchEnd = function(l) {
      o.userIsDragging || o.onClearIndicatorMouseDown(l);
    }, o.onDropdownIndicatorTouchEnd = function(l) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(l);
    }, o.handleInputChange = function(l) {
      var c = o.props.inputValue, d = l.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(d, {
        action: "input-change",
        prevInputValue: c
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(l) {
      o.props.onFocus && o.props.onFocus(l), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(l) {
      var c = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(l), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: c
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(l) {
      if (!(o.blockOptionHover || o.state.focusedOption === l)) {
        var c = o.getFocusableOptions(), d = c.indexOf(l);
        o.setState({
          focusedOption: l,
          focusedOptionId: d > -1 ? o.getFocusedOptionId(l) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return ih(o.props);
    }, o.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), o.focus();
    }, o.onKeyDown = function(l) {
      var c = o.props, d = c.isMulti, f = c.backspaceRemovesValue, p = c.escapeClearsValue, h = c.inputValue, g = c.isClearable, m = c.isDisabled, v = c.menuIsOpen, w = c.onKeyDown, C = c.tabSelectsValue, y = c.openMenuOnFocus, x = o.state, E = x.focusedOption, S = x.focusedValue, I = x.selectValue;
      if (!m && !(typeof w == "function" && (w(l), l.defaultPrevented))) {
        switch (o.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!d || h)
              return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!d || h)
              return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (h)
              return;
            if (S)
              o.removeValue(S);
            else {
              if (!f)
                return;
              d ? o.popValue() : g && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || l.shiftKey || !v || !C || !E || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            y && o.isOptionSelected(E, I))
              return;
            o.selectOption(E);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (v) {
              if (!E || o.isComposing)
                return;
              o.selectOption(E);
              break;
            }
            return;
          case "Escape":
            v ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: h
            }), o.onMenuClose()) : g && p && o.clearValue();
            break;
          case " ":
            if (h)
              return;
            if (!v) {
              o.openMenu("first");
              break;
            }
            if (!E)
              return;
            o.selectOption(E);
            break;
          case "ArrowUp":
            v ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            v ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!v)
              return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!v)
              return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!v)
              return;
            o.focusOption("first");
            break;
          case "End":
            if (!v)
              return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++MA), o.state.selectValue = El(r.value), r.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), i = o.buildFocusableOptions(), s = i.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = i[s], o.state.focusedOptionId = Qu(a, i[s]);
    }
    return o;
  }
  return UD(n, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && m4(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, i = a.isDisabled, s = a.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !i && o.isDisabled || // ensure focus is on the Input when the menu opens
      l && s && !o.menuIsOpen) && this.focusInput(), l && i && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !i && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (m4(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, i = this.state, s = i.selectValue, l = i.isFocused, c = this.buildFocusableOptions(), d = o === "first" ? 0 : c.length - 1;
      if (!this.props.isMulti) {
        var f = c.indexOf(s[0]);
        f > -1 && (d = f);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: c[d],
        focusedOptionId: this.getFocusedOptionId(c[d])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, i = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = i.indexOf(s);
        s || (l = -1);
        var c = i.length - 1, d = -1;
        if (i.length) {
          switch (o) {
            case "previous":
              l === 0 ? d = 0 : l === -1 ? d = c : d = l - 1;
              break;
            case "next":
              l > -1 && l < c && (d = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: d !== -1,
            focusedValue: i[d]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, i = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var l = 0, c = s.indexOf(i);
        i || (c = -1), o === "up" ? l = c > 0 ? c - 1 : s.length - 1 : o === "down" ? l = (c + 1) % s.length : o === "pageup" ? (l = c - a, l < 0 && (l = 0)) : o === "pagedown" ? (l = c + a, l > s.length - 1 && (l = s.length - 1)) : o === "last" && (l = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(qu) : de(de({}, qu), this.props.theme) : qu;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, i = this.getStyles, s = this.getClassNames, l = this.getValue, c = this.selectOption, d = this.setValue, f = this.props, p = f.isMulti, h = f.isRtl, g = f.options, m = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: i,
        getClassNames: s,
        getValue: l,
        hasValue: m,
        isMulti: p,
        isRtl: h,
        options: g,
        selectOption: c,
        selectProps: f,
        setValue: d,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, i = o.isMulti;
      return a === void 0 ? i : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return rh(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return oh(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return ah(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: i,
          selectValue: s
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, i = o.isSearchable, s = o.inputId, l = o.inputValue, c = o.tabIndex, d = o.form, f = o.menuIsOpen, p = o.required, h = this.getComponents(), g = h.Input, m = this.state, v = m.inputIsHidden, w = m.ariaSelection, C = this.commonProps, y = s || this.getElementId("input"), x = de(de(de({
          "aria-autocomplete": "list",
          "aria-expanded": f,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": p,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, f && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (w == null ? void 0 : w.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ b.createElement(g, ee({}, C, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: y,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: v,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: c,
          form: d,
          type: "text",
          value: l
        }, x)) : /* @__PURE__ */ b.createElement(QP, ee({
          id: y,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: xl,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: c,
          inputMode: "none",
          form: d,
          value: ""
        }, x));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), i = a.MultiValue, s = a.MultiValueContainer, l = a.MultiValueLabel, c = a.MultiValueRemove, d = a.SingleValue, f = a.Placeholder, p = this.commonProps, h = this.props, g = h.controlShouldRenderValue, m = h.isDisabled, v = h.isMulti, w = h.inputValue, C = h.placeholder, y = this.state, x = y.selectValue, E = y.focusedValue, S = y.isFocused;
      if (!this.hasValue() || !g)
        return w ? null : /* @__PURE__ */ b.createElement(f, ee({}, p, {
          key: "placeholder",
          isDisabled: m,
          isFocused: S,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), C);
      if (v)
        return x.map(function(D, N) {
          var A = D === E, L = "".concat(o.getOptionLabel(D), "-").concat(o.getOptionValue(D));
          return /* @__PURE__ */ b.createElement(i, ee({}, p, {
            components: {
              Container: s,
              Label: l,
              Remove: c
            },
            isFocused: A,
            isDisabled: m,
            key: L,
            index: N,
            removeProps: {
              onClick: function() {
                return o.removeValue(D);
              },
              onTouchEnd: function() {
                return o.removeValue(D);
              },
              onMouseDown: function(k) {
                k.preventDefault();
              }
            },
            data: D
          }), o.formatOptionLabel(D, "value"));
        });
      if (w)
        return null;
      var I = x[0];
      return /* @__PURE__ */ b.createElement(d, ee({}, p, {
        data: I,
        isDisabled: m
      }), this.formatOptionLabel(I, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, c = s.isLoading, d = this.state.isFocused;
      if (!this.isClearable() || !a || l || !this.hasValue() || c)
        return null;
      var f = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ b.createElement(a, ee({}, i, {
        innerProps: f,
        isFocused: d
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, c = s.isLoading, d = this.state.isFocused;
      if (!a || !c)
        return null;
      var f = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ b.createElement(a, ee({}, i, {
        innerProps: f,
        isDisabled: l,
        isFocused: d
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, i = o.IndicatorSeparator;
      if (!a || !i)
        return null;
      var s = this.commonProps, l = this.props.isDisabled, c = this.state.isFocused;
      return /* @__PURE__ */ b.createElement(i, ee({}, s, {
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a)
        return null;
      var i = this.commonProps, s = this.props.isDisabled, l = this.state.isFocused, c = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ b.createElement(a, ee({}, i, {
        innerProps: c,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), i = a.Group, s = a.GroupHeading, l = a.Menu, c = a.MenuList, d = a.MenuPortal, f = a.LoadingMessage, p = a.NoOptionsMessage, h = a.Option, g = this.commonProps, m = this.state.focusedOption, v = this.props, w = v.captureMenuScroll, C = v.inputValue, y = v.isLoading, x = v.loadingMessage, E = v.minMenuHeight, S = v.maxMenuHeight, I = v.menuIsOpen, D = v.menuPlacement, N = v.menuPosition, A = v.menuPortalTarget, L = v.menuShouldBlockScroll, F = v.menuShouldScrollIntoView, k = v.noOptionsMessage, G = v.onMenuScrollToTop, J = v.onMenuScrollToBottom;
      if (!I)
        return null;
      var $ = function(Y, U) {
        var K = Y.type, q = Y.data, W = Y.isDisabled, Q = Y.isSelected, te = Y.label, re = Y.value, z = m === q, R = W ? void 0 : function() {
          return o.onOptionHover(q);
        }, ce = W ? void 0 : function() {
          return o.selectOption(q);
        }, ve = "".concat(o.getElementId("option"), "-").concat(U), ke = {
          id: ve,
          onClick: ce,
          onMouseMove: R,
          onMouseOver: R,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : Q
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ b.createElement(h, ee({}, g, {
          innerProps: ke,
          data: q,
          isDisabled: W,
          isSelected: Q,
          key: ve,
          label: te,
          type: K,
          value: re,
          isFocused: z,
          innerRef: z ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(Y.data, "menu"));
      }, H;
      if (this.hasOptions())
        H = this.getCategorizedOptions().map(function(O) {
          if (O.type === "group") {
            var Y = O.data, U = O.options, K = O.index, q = "".concat(o.getElementId("group"), "-").concat(K), W = "".concat(q, "-heading");
            return /* @__PURE__ */ b.createElement(i, ee({}, g, {
              key: q,
              data: Y,
              options: U,
              Heading: s,
              headingProps: {
                id: W,
                data: O.data
              },
              label: o.formatGroupLabel(O.data)
            }), O.options.map(function(Q) {
              return $(Q, "".concat(K, "-").concat(Q.index));
            }));
          } else if (O.type === "option")
            return $(O, "".concat(O.index));
        });
      else if (y) {
        var V = x({
          inputValue: C
        });
        if (V === null)
          return null;
        H = /* @__PURE__ */ b.createElement(f, g, V);
      } else {
        var j = k({
          inputValue: C
        });
        if (j === null)
          return null;
        H = /* @__PURE__ */ b.createElement(p, g, j);
      }
      var B = {
        minMenuHeight: E,
        maxMenuHeight: S,
        menuPlacement: D,
        menuPosition: N,
        menuShouldScrollIntoView: F
      }, Z = /* @__PURE__ */ b.createElement(AN, ee({}, g, B), function(O) {
        var Y = O.ref, U = O.placerProps, K = U.placement, q = U.maxHeight;
        return /* @__PURE__ */ b.createElement(l, ee({}, g, B, {
          innerRef: Y,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: y,
          placement: K
        }), /* @__PURE__ */ b.createElement(iA, {
          captureEnabled: w,
          onTopArrive: G,
          onBottomArrive: J,
          lockEnabled: L
        }, function(W) {
          return /* @__PURE__ */ b.createElement(c, ee({}, g, {
            innerRef: function(te) {
              o.getMenuListRef(te), W(te);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": g.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: y,
            maxHeight: q,
            focusedOption: m
          }), H);
        }));
      });
      return A || N === "fixed" ? /* @__PURE__ */ b.createElement(d, ee({}, g, {
        appendTo: A,
        controlElement: this.controlRef,
        menuPlacement: D,
        menuPosition: N
      }), Z) : Z;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, i = a.delimiter, s = a.isDisabled, l = a.isMulti, c = a.name, d = a.required, f = this.state.selectValue;
      if (d && !this.hasValue() && !s)
        return /* @__PURE__ */ b.createElement(uA, {
          name: c,
          onFocus: this.onValueInputFocus
        });
      if (!(!c || s))
        if (l)
          if (i) {
            var p = f.map(function(m) {
              return o.getOptionValue(m);
            }).join(i);
            return /* @__PURE__ */ b.createElement("input", {
              name: c,
              type: "hidden",
              value: p
            });
          } else {
            var h = f.length > 0 ? f.map(function(m, v) {
              return /* @__PURE__ */ b.createElement("input", {
                key: "i-".concat(v),
                name: c,
                type: "hidden",
                value: o.getOptionValue(m)
              });
            }) : /* @__PURE__ */ b.createElement("input", {
              name: c,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ b.createElement("div", null, h);
          }
        else {
          var g = f[0] ? this.getOptionValue(f[0]) : "";
          return /* @__PURE__ */ b.createElement("input", {
            name: c,
            type: "hidden",
            value: g
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, i = a.ariaSelection, s = a.focusedOption, l = a.focusedValue, c = a.isFocused, d = a.selectValue, f = this.getFocusableOptions();
      return /* @__PURE__ */ b.createElement(zP, ee({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: s,
        focusedValue: l,
        isFocused: c,
        selectValue: d,
        focusableOptions: f,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, i = o.IndicatorsContainer, s = o.SelectContainer, l = o.ValueContainer, c = this.props, d = c.className, f = c.id, p = c.isDisabled, h = c.menuIsOpen, g = this.state.isFocused, m = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ b.createElement(s, ee({}, m, {
        className: d,
        innerProps: {
          id: f,
          onKeyDown: this.onKeyDown
        },
        isDisabled: p,
        isFocused: g
      }), this.renderLiveRegion(), /* @__PURE__ */ b.createElement(a, ee({}, m, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: p,
        isFocused: g,
        menuIsOpen: h
      }), /* @__PURE__ */ b.createElement(l, ee({}, m, {
        isDisabled: p
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ b.createElement(i, ee({}, m, {
        isDisabled: p
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var i = a.prevProps, s = a.clearFocusValueOnUpdate, l = a.inputIsHiddenAfterUpdate, c = a.ariaSelection, d = a.isFocused, f = a.prevWasFocused, p = a.instancePrefix, h = o.options, g = o.value, m = o.menuIsOpen, v = o.inputValue, w = o.isMulti, C = El(g), y = {};
      if (i && (g !== i.value || h !== i.options || m !== i.menuIsOpen || v !== i.inputValue)) {
        var x = m ? IA(o, C) : [], E = m ? P4(nl(o, C), "".concat(p, "-option")) : [], S = s ? SA(a, C) : null, I = DA(a, x), D = Qu(E, I);
        y = {
          selectValue: C,
          focusedOption: I,
          focusedOptionId: D,
          focusableOptionsWithIds: E,
          focusedValue: S,
          clearFocusValueOnUpdate: !1
        };
      }
      var N = l != null && o !== i ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, A = c, L = d && f;
      return d && !L && (A = {
        value: za(w, C, C[0] || null),
        options: C,
        action: "initial-input-focus"
      }, L = !f), (c == null ? void 0 : c.action) === "initial-input-focus" && (A = null), de(de(de({}, y), N), {}, {
        prevProps: o,
        ariaSelection: A,
        prevWasFocused: L
      });
    }
  }]), n;
}(Mn);
A2.defaultProps = EA;
var NA = /* @__PURE__ */ cn(function(e, t) {
  var n = y8(e);
  return /* @__PURE__ */ b.createElement(A2, ee({
    ref: t
  }, n));
}), sh = NA, PA = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], _4 = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0, o = String(t).toLowerCase(), a = String(r.getOptionValue(n)).toLowerCase(), i = String(r.getOptionLabel(n)).toLowerCase();
  return a === o || i === o;
}, ed = {
  formatCreateLabel: function(t) {
    return 'Create "'.concat(t, '"');
  },
  isValidNewOption: function(t, n, r, o) {
    return !(!t || n.some(function(a) {
      return _4(t, a, o);
    }) || r.some(function(a) {
      return _4(t, a, o);
    }));
  },
  getNewOptionData: function(t, n) {
    return {
      label: n,
      value: t,
      __isNew__: !0
    };
  }
};
function AA(e) {
  var t = e.allowCreateWhileLoading, n = t === void 0 ? !1 : t, r = e.createOptionPosition, o = r === void 0 ? "last" : r, a = e.formatCreateLabel, i = a === void 0 ? ed.formatCreateLabel : a, s = e.isValidNewOption, l = s === void 0 ? ed.isValidNewOption : s, c = e.getNewOptionData, d = c === void 0 ? ed.getNewOptionData : c, f = e.onCreateOption, p = e.options, h = p === void 0 ? [] : p, g = e.onChange, m = Pn(e, PA), v = m.getOptionValue, w = v === void 0 ? Q8 : v, C = m.getOptionLabel, y = C === void 0 ? q8 : C, x = m.inputValue, E = m.isLoading, S = m.isMulti, I = m.value, D = m.name, N = Xe(function() {
    return l(x, El(I), h, {
      getOptionValue: w,
      getOptionLabel: y
    }) ? d(x, i(x)) : void 0;
  }, [i, d, y, w, x, l, h, I]), A = Xe(function() {
    return (n || !E) && N ? o === "first" ? [N].concat(Vo(h)) : [].concat(Vo(h), [N]) : h;
  }, [n, o, E, N, h]), L = Ve(function(F, k) {
    if (k.action !== "select-option")
      return g(F, k);
    var G = Array.isArray(F) ? F : [F];
    if (G[G.length - 1] === N) {
      if (f)
        f(x);
      else {
        var J = d(x, x), $ = {
          action: "create-option",
          name: D,
          option: J
        };
        g(za(S, [].concat(Vo(El(I)), [J]), J), $);
      }
      return;
    }
    g(F, k);
  }, [d, x, S, D, N, f, g, I]);
  return de(de({}, m), {}, {
    options: A,
    onChange: L
  });
}
var _A = /* @__PURE__ */ cn(function(e, t) {
  var n = y8(e), r = AA(n);
  return /* @__PURE__ */ b.createElement(A2, ee({
    ref: t
  }, r));
}), _2 = _A;
const O2 = (e) => /* @__PURE__ */ u("div", { ...e.innerProps, className: "tw-cursor-pointer tw-mr-1", children: /* @__PURE__ */ u(rt, { size: 20, className: "tw-text-gray-700 hover:tw-text-gray-800 tw-transition-colors" }) }), T2 = (e) => /* @__PURE__ */ u(
  "div",
  {
    ...e.innerProps,
    className: "tw-cursor-pointer tw-px-1 tw-rounded-r tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-200 tw-transition-colors",
    children: /* @__PURE__ */ u(
      rt,
      {
        size: 16,
        strokeWidth: 2,
        className: "tw-text-gray-500 hover:tw-text-gray-700 tw-transition-colors"
      }
    )
  }
), lh = (e) => /* @__PURE__ */ u("div", { ...e, children: e.selectProps.menuIsOpen ? /* @__PURE__ */ u(mc, { size: 24, className: "tw-text-gray-700  " }) : /* @__PURE__ */ u(qn, { size: 24, className: "tw-text-gray-700" }) }), L2 = (e) => ({
  control: (t, n) => ({
    ...t,
    height: "54px",
    minHeight: "54px",
    borderRadius: "5px",
    border: e ? "1px solid #EF4444" : "1px solid rgb(204, 204, 204)",
    boxShadow: "none",
    outline: n.isFocused && e ? "1px solid #EF4444" : "none",
    outlineOffset: 2,
    "&:hover": {
      border: "1px solid #D1D5DB"
    },
    backgroundColor: (n.isDisabled, "white"),
    cursor: n.isDisabled ? "not-allowed" : "pointer",
    pointerEvents: n.isDisabled ? "none" : "auto",
    opacity: n.isDisabled ? 0.7 : 1,
    padding: "0 14px"
  }),
  valueContainer: (t) => ({
    ...t,
    height: "50px",
    padding: "5px 5px",
    maxHeight: "125px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "3px"
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
      marginTop: "4px",
      marginBottom: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#D1D5DB",
      borderRadius: "3px"
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#6B7280"
    }
  }),
  input: (t) => ({
    ...t,
    margin: "0"
  }),
  placeholder: (t) => ({
    ...t,
    color: "#6b7280",
    fontSize: "16px"
  }),
  singleValue: (t) => ({
    ...t,
    color: "#1e293b",
    fontSize: "16px"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  dropdownIndicator: (t) => ({
    ...t,
    color: "#94a3b8"
  }),
  multiValue: (t) => ({
    ...t,
    backgroundColor: "#F3F4F6",
    borderRadius: "4px",
    border: "1px solid #e2e8f0",
    margin: "4px"
  }),
  multiValueLabel: (t) => ({
    ...t,
    color: "#1e293b",
    padding: "6px 4px 6px 4px",
    fontSize: "14px",
    lineHeight: "16px"
  }),
  multiValueRemove: (t) => ({
    ...t,
    // Remove default styling since we're using a custom component
    padding: "0",
    margin: "0",
    border: "none",
    background: "transparent",
    "&:hover": {
      background: "transparent"
    }
  }),
  clearIndicator: (t, n) => ({
    ...t,
    color: "#94a3b8",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    "&:hover": {
      color: "#64748b",
      backgroundColor: "#f1f5f9"
    },
    "&:active": {
      backgroundColor: "#e2e8f0"
    }
  }),
  menu: (t) => ({
    ...t,
    borderRadius: "8px",
    overflowY: "auto",
    border: "1px solid #D1D5DB",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
  }),
  option: (t, n) => ({
    ...t,
    backgroundColor: n.isSelected ? "#e2e8f0" : "white",
    color: "#1e293b",
    "&:hover": {
      backgroundColor: "#f1f5f9"
    }
  }),
  menuPortal: (t) => ({
    ...t,
    zIndex: 1e6
  })
}), OA = (e) => /* @__PURE__ */ u("div", { ...e, children: e.selectProps.menuIsOpen ? /* @__PURE__ */ u(mc, { className: "tw-size-6 tw-text-[#6B7280]" }) : /* @__PURE__ */ u(qn, { className: "tw-size-6 tw-text-[#6B7280]" }) }), ch = (e) => {
  const [t, n] = ue(!1), [r, o] = ue(!0), a = le(null), i = le(null), s = le(null), l = e.isCreatable ? e.mobileCreatePlaceholder ?? "Tap here to search or add a new item" : e.mobileSearchPlaceholder ?? "Tap here to search", c = (L) => {
    var F, k, G, J;
    if (!t) {
      n(!0), o(!1), (k = (F = a.current) == null ? void 0 : F.inputRef) == null || k.setAttribute("disabled", "true");
      return;
    }
    if (t && !r) {
      o(!0), (J = (G = a.current) == null ? void 0 : G.inputRef) == null || J.setAttribute("disabled", "false");
      return;
    }
    t && n(!1);
  }, d = (L) => {
    var G, J, $, H, V, j;
    const F = (G = a.current) == null ? void 0 : G.controlRef, k = (J = a.current) == null ? void 0 : J.menuListRef;
    F != null && !F.contains(L.target) && k != null && !k.contains(L.target) && (n(!1), o(!0), (H = ($ = a.current) == null ? void 0 : $.inputRef) == null || H.setAttribute("disabled", "false"), (V = a.current) == null || V.focus(), (j = a.current) == null || j.blur());
  }, f = (L, F) => {
    var k, G, J;
    (k = e.onChange) == null || k.call(e, L, F), n(!1), o(!0), (J = (G = a.current) == null ? void 0 : G.inputRef) == null || J.setAttribute("disabled", "false");
  }, p = (L) => {
    i.current = L.touches[0].clientY;
  }, h = (L) => {
    L.stopPropagation(), s.current = L.changedTouches[0].clientY, !(Math.abs(s.current ?? 0 - (i.current ?? 0)) > 10) && c();
  };
  ye(() => {
    var F;
    if (!e.isMobile)
      return;
    const L = (F = a.current) == null ? void 0 : F.controlRef;
    return L != null && (L.addEventListener("touchstart", p), L.addEventListener("touchend", h)), document.addEventListener("touchend", d), () => {
      L != null && (L.removeEventListener("touchstart", p), L.removeEventListener("touchend", h)), document.removeEventListener("touchend", d);
    };
  }, [c, p, h, d]);
  const {
    isMobile: g,
    isCreatable: m,
    error: v,
    mobileSearchPlaceholder: w,
    mobileCreatePlaceholder: C,
    menuPortalTarget: y,
    components: x,
    isClearable: E,
    value: S,
    defaultValue: I,
    options: D,
    ...N
  } = e;
  return /* @__PURE__ */ T(Ee, { children: [
    /* @__PURE__ */ u(
      m ? _2 : sh,
      {
        ...N,
        isClearable: E,
        menuPortalTarget: y,
        ref: a,
        styles: { ...L2(v), ...e.styles },
        ...g === !0 && {
          menuIsOpen: t,
          isSearchable: r,
          closeMenuOnSelect: !0,
          onChange: f
        },
        components: {
          DropdownIndicator: OA,
          ClearIndicator: O2,
          MultiValueRemove: T2,
          ...x
        },
        placeholder: g === !0 && t ? l : e.placeholder,
        className: e.className,
        classNamePrefix: e.classNamePrefix,
        value: S,
        isDisabled: e.isDisabled,
        defaultValue: I,
        options: D
      }
    ),
    v != null && /* @__PURE__ */ u("div", { className: "tw-block tw-mt-2", children: /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: v }) })
  ] });
};
ch.defaultProps = {
  menuPortalTarget: document.body
};
const TA = (e) => /* @__PURE__ */ u("div", { className: P("tw-w-full tw-flex tw-items-center tw-gap-8px", e.className), children: e.steps.map((t, n) => /* @__PURE__ */ T(Ee, { children: [
  /* @__PURE__ */ T(
    "div",
    {
      className: P(
        "tw-flex tw-gap-8px tw-items-center tw-rounded-full",
        n === e.activeIndex && "tw-bg-brand-surface-subtle",
        !e.hideStepText && "tw-pr-8px"
      ),
      children: [
        /* @__PURE__ */ u(
          "div",
          {
            className: P(
              "tw-text-normal tw-rounded-full tw-flex tw-justify-center tw-items-center tw-w-26px tw-h-26px",
              n === e.activeIndex ? "tw-text-white tw-bg-brand-darkest" : "tw-text-[#374151] tw-bg-grayscale-default"
            ),
            children: n + 1
          }
        ),
        !e.hideStepText && /* @__PURE__ */ u("span", { className: "tw-text-[#1F2937]", children: t })
      ]
    },
    n
  ),
  n !== e.steps.length - 1 && /* @__PURE__ */ u("svg", { width: "54", height: "2", viewBox: "0 0 54 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ u("path", { d: "M0 1H54", stroke: "#6B7280", strokeDasharray: "4 4" }) })
] })) });
function LA(e, t) {
  return b.useReducer((n, r) => t[n][r] ?? n, e);
}
var ut = (e) => {
  const { present: t, children: n } = e, r = RA(t), o = typeof n == "function" ? n({ present: r.isPresent }) : b.Children.only(n), a = we(r.ref, VA(o));
  return typeof n == "function" || r.isPresent ? b.cloneElement(o, { ref: a }) : null;
};
ut.displayName = "Presence";
function RA(e) {
  const [t, n] = b.useState(), r = b.useRef(null), o = b.useRef(e), a = b.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = LA(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b.useEffect(() => {
    const c = Ds(r.current);
    a.current = s === "mounted" ? c : "none";
  }, [s]), at(() => {
    const c = r.current, d = o.current;
    if (d !== e) {
      const p = a.current, h = Ds(c);
      e ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(d && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), at(() => {
    if (t) {
      let c;
      const d = t.ownerDocument.defaultView ?? window, f = (h) => {
        const m = Ds(r.current).includes(h.animationName);
        if (h.target === t && m && (l("ANIMATION_END"), !o.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, p = (h) => {
        h.target === t && (a.current = Ds(r.current));
      };
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(c), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: b.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Ds(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function VA(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Cc = "Checkbox", [kA, gte] = st(Cc), [FA, R2] = kA(Cc);
function HA(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: l,
    required: c,
    value: d = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [p, h] = vt({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: Cc
  }), [g, m] = b.useState(null), [v, w] = b.useState(null), C = b.useRef(!1), y = g ? !!i || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), x = {
    checked: p,
    disabled: a,
    setChecked: h,
    control: g,
    setControl: m,
    name: s,
    form: i,
    value: d,
    hasConsumerStoppedPropagationRef: C,
    required: c,
    defaultChecked: cr(o) ? !1 : o,
    isFormControl: y,
    bubbleInput: v,
    setBubbleInput: w
  };
  return /* @__PURE__ */ u(
    FA,
    {
      scope: t,
      ...x,
      children: BA(f) ? f(x) : r
    }
  );
}
var uh = "CheckboxTrigger", dh = b.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: l,
      required: c,
      setControl: d,
      setChecked: f,
      hasConsumerStoppedPropagationRef: p,
      isFormControl: h,
      bubbleInput: g
    } = R2(uh, e), m = we(o, d), v = b.useRef(l);
    return b.useEffect(() => {
      const w = a == null ? void 0 : a.form;
      if (w) {
        const C = () => f(v.current);
        return w.addEventListener("reset", C), () => w.removeEventListener("reset", C);
      }
    }, [a, f]), /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": cr(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": vh(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...r,
        ref: m,
        onKeyDown: oe(t, (w) => {
          w.key === "Enter" && w.preventDefault();
        }),
        onClick: oe(n, (w) => {
          f((C) => cr(C) ? !0 : !C), g && h && (p.current = w.isPropagationStopped(), p.current || w.stopPropagation());
        })
      }
    );
  }
);
dh.displayName = uh;
var V2 = b.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l,
      onCheckedChange: c,
      form: d,
      ...f
    } = e;
    return /* @__PURE__ */ u(
      HA,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: c,
        name: r,
        form: d,
        value: l,
        internal_do_not_use_render: ({ isFormControl: p }) => /* @__PURE__ */ T(Ee, { children: [
          /* @__PURE__ */ u(
            dh,
            {
              ...f,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          p && /* @__PURE__ */ u(
            mh,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
V2.displayName = Cc;
var fh = "CheckboxIndicator", ph = b.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, a = R2(fh, n);
    return /* @__PURE__ */ u(
      ut,
      {
        present: r || cr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          ie.span,
          {
            "data-state": vh(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
ph.displayName = fh;
var hh = "CheckboxBubbleInput", mh = b.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: l,
      name: c,
      value: d,
      form: f,
      bubbleInput: p,
      setBubbleInput: h
    } = R2(hh, e), g = we(n, h), m = oc(a), v = tc(r);
    b.useEffect(() => {
      const C = p;
      if (!C)
        return;
      const y = window.HTMLInputElement.prototype, E = Object.getOwnPropertyDescriptor(
        y,
        "checked"
      ).set, S = !o.current;
      if (m !== a && E) {
        const I = new Event("click", { bubbles: S });
        C.indeterminate = cr(a), E.call(C, cr(a) ? !1 : a), C.dispatchEvent(I);
      }
    }, [p, m, a, o]);
    const w = b.useRef(cr(a) ? !1 : a);
    return /* @__PURE__ */ u(
      ie.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? w.current,
        required: s,
        disabled: l,
        name: c,
        value: d,
        form: f,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
mh.displayName = hh;
function BA(e) {
  return typeof e == "function";
}
function cr(e) {
  return e === "indeterminate";
}
function vh(e) {
  return cr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const gh = b.forwardRef(
  ({ className: e, size: t = "small", ...n }, r) => /* @__PURE__ */ u(
    V2,
    {
      ref: r,
      className: P(
        "tw-peer tw-shrink-0 tw-rounded-md tw-border tw-border-grayscale-border-darker tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-grayscale-surface-darkest data-[state=indeterminate]:tw-bg-gray-500",
        {
          "tw-h-16px tw-w-16px": t === "small",
          "tw-h-24px tw-w-24px": t === "large"
        },
        e
      ),
      ...n,
      children: /* @__PURE__ */ T(ph, { className: P("tw-flex tw-items-center tw-justify-center tw-text-current"), children: [
        n.checked === !0 && /* @__PURE__ */ u(
          sa,
          {
            className: P("tw-text-grayscale-text-negative", {
              "tw-h-12px tw-w-12px": t === "small",
              "tw-h-14px tw-w-14px": t === "large"
            })
          }
        ),
        n.checked === "indeterminate" && /* @__PURE__ */ u(
          DD,
          {
            className: P(" tw-text-grayscale-text-negative", {
              "tw-h-12px tw-w-12px": t === "small",
              "tw-h-14px tw-w-14px": t === "large"
            })
          }
        )
      ] })
    }
  )
);
gh.displayName = V2.displayName;
const GA = (e) => /* @__PURE__ */ T("div", { className: P("tw-items-center tw-flex tw-gap-2", e.className), children: [
  /* @__PURE__ */ u(
    gh,
    {
      className: P(e.checkboxClassName, "tw-rounded-sm"),
      id: e.id,
      checked: e.checked,
      onClick: e.onClick,
      size: e.size
    }
  ),
  e.label && /* @__PURE__ */ u(
    "label",
    {
      htmlFor: e.id,
      className: P(
        "tw-text-normal tw-font-sans tw-font-normal tw-leading-4 tw-peer-disabled:cursor-not-allowed tw-peer-disabled:opacity-70 tw-text-grayscale-text-body",
        e.labelClassName
      ),
      onClick: e.onClick,
      children: e.label
    }
  )
] });
var yc = "Dialog", [wh, wte] = st(yc), [WA, un] = wh(yc), bh = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, s = b.useRef(null), l = b.useRef(null), [c, d] = vt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: yc
  });
  return /* @__PURE__ */ u(
    WA,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Ue(),
      titleId: Ue(),
      descriptionId: Ue(),
      open: c,
      onOpenChange: d,
      onOpenToggle: b.useCallback(() => d((f) => !f), [d]),
      modal: i,
      children: n
    }
  );
};
bh.displayName = yc;
var Ch = "DialogTrigger", yh = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = un(Ch, n), a = we(t, o.triggerRef);
    return /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": H2(o.open),
        ...r,
        ref: a,
        onClick: oe(e.onClick, o.onOpenToggle)
      }
    );
  }
);
yh.displayName = Ch;
var k2 = "DialogPortal", [ZA, xh] = wh(k2, {
  forceMount: void 0
}), Eh = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = un(k2, t);
  return /* @__PURE__ */ u(ZA, { scope: t, forceMount: n, children: b.Children.map(r, (i) => /* @__PURE__ */ u(ut, { present: n || a.open, children: /* @__PURE__ */ u(ro, { asChild: !0, container: o, children: i }) })) });
};
Eh.displayName = k2;
var Dl = "DialogOverlay", Ih = b.forwardRef(
  (e, t) => {
    const n = xh(Dl, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = un(Dl, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u(ut, { present: r || a.open, children: /* @__PURE__ */ u(YA, { ...o, ref: t }) }) : null;
  }
);
Ih.displayName = Dl;
var $A = /* @__PURE__ */ mr("DialogOverlay.RemoveScroll"), YA = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = un(Dl, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(lc, { as: $A, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ u(
        ie.div,
        {
          "data-state": H2(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Jr = "DialogContent", Sh = b.forwardRef(
  (e, t) => {
    const n = xh(Jr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = un(Jr, e.__scopeDialog);
    return /* @__PURE__ */ u(ut, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u(jA, { ...o, ref: t }) : /* @__PURE__ */ u(zA, { ...o, ref: t }) });
  }
);
Sh.displayName = Jr;
var jA = b.forwardRef(
  (e, t) => {
    const n = un(Jr, e.__scopeDialog), r = b.useRef(null), o = we(t, n.contentRef, r);
    return b.useEffect(() => {
      const a = r.current;
      if (a)
        return ic(a);
    }, []), /* @__PURE__ */ u(
      Dh,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: oe(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: oe(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: oe(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), zA = b.forwardRef(
  (e, t) => {
    const n = un(Jr, e.__scopeDialog), r = b.useRef(!1), o = b.useRef(!1);
    return /* @__PURE__ */ u(
      Dh,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Dh = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = un(Jr, n), l = b.useRef(null), c = we(t, l);
    return Kl(), /* @__PURE__ */ T(Ee, { children: [
      /* @__PURE__ */ u(
        ki,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u(
            no,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": H2(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(Ee, { children: [
        /* @__PURE__ */ u(XA, { titleId: s.titleId }),
        /* @__PURE__ */ u(JA, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), F2 = "DialogTitle", Mh = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = un(F2, n);
    return /* @__PURE__ */ u(ie.h2, { id: o.titleId, ...r, ref: t });
  }
);
Mh.displayName = F2;
var Nh = "DialogDescription", Ph = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = un(Nh, n);
    return /* @__PURE__ */ u(ie.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Ph.displayName = Nh;
var Ah = "DialogClose", _h = b.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = un(Ah, n);
    return /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: oe(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
_h.displayName = Ah;
function H2(e) {
  return e ? "open" : "closed";
}
var Oh = "DialogTitleWarning", [bte, Th] = Fx(Oh, {
  contentName: Jr,
  titleName: F2,
  docsSlug: "dialog"
}), XA = ({ titleId: e }) => {
  const t = Th(Oh), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return b.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, UA = "DialogDescriptionWarning", JA = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Th(UA).contentName}}.`;
  return b.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, xc = bh, KA = yh, Ec = Eh, oo = Ih, ao = Sh, da = Mh, fa = Ph, Lh = _h;
const qA = xc, QA = Ec, e_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  oo,
  {
    className: P(
      "tw-fixed tw-inset-0 tw-z-9998 tw-bg-black/80 tw- data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
e_.displayName = oo.displayName;
const t_ = Xt(
  "tw-fixed tw-z-50 tw-gap-4 tw-bg-background tw-p-6 tw-shadow-lg tw-transition tw-ease-in-out data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-duration-300 data-[state=open]:tw-duration-500",
  {
    variants: {
      side: {
        top: "tw-inset-x-0 tw-top-0 tw-border-b data-[state=closed]:tw-slide-out-to-top data-[state=open]:tw-slide-in-from-top",
        bottom: "tw-inset-x-0 tw-bottom-0 tw-border-t data-[state=closed]:tw-slide-out-to-bottom data-[state=open]:tw-slide-in-from-bottom",
        left: "tw-inset-y-0 tw-left-0 tw-h-full tw-w-3/4 tw-border-r data-[state=closed]:tw-slide-out-to-left data-[state=open]:tw-slide-in-from-left sm:tw-max-w-sm",
        right: "tw-inset-y-0 tw-right-0 tw-h-full tw-w-3/4 tw- tw-border-l data-[state=closed]:tw-slide-out-to-right data-[state=open]:tw-slide-in-from-right sm:tw-max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Rh = b.forwardRef(
  ({ side: e = "right", className: t, backdropClassName: n, children: r, ...o }, a) => /* @__PURE__ */ T(QA, { children: [
    /* @__PURE__ */ u(
      "div",
      {
        className: P(
          "tw-fixed tw-inset-0 tw-z-9998 tw-bg-black/80 tw- data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0",
          n
        )
      }
    ),
    /* @__PURE__ */ u(ao, { ref: a, className: P(t_({ side: e }), t), ...o, children: r })
  ] })
);
Rh.displayName = ao.displayName;
const Vh = ({ className: e, ...t }) => /* @__PURE__ */ u("div", { className: P("tw-flex tw-flex-col tw-space-y-2 tw-text-left", e), ...t });
Vh.displayName = "SheetHeader";
const kh = ({ className: e, ...t }) => /* @__PURE__ */ u(
  "div",
  {
    className: P(
      "tw-flex tw-flex-col-reverse sm:tw-flex-row sm:tw-justify-end sm:tw-space-x-2 tw-relative tw-right-0 tw-bottom-0",
      e
    ),
    ...t
  }
);
kh.displayName = "SheetFooter";
const Fh = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  da,
  {
    ref: n,
    className: P("tw-text-lg tw-font-semibold tw-text-foreground", e),
    ...t
  }
));
Fh.displayName = da.displayName;
const Hh = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(fa, { ref: n, className: P("tw-text-sm tw-text-muted-foreground", e), ...t }));
Hh.displayName = fa.displayName;
const n_ = (e) => /* @__PURE__ */ u(qA, { open: e.open, modal: e.isModal ?? !1, children: /* @__PURE__ */ T(
  Rh,
  {
    className: P(
      "tw-flex tw-flex-col [&&]:tw-w-[calc(100%-16px)] [&&]:tw-max-w-[467px] tw-py-16px tw-px-16px [&&]:tw-gap-0 !tw-z-9999 tw-box-border ",
      e.className
    ),
    backdropClassName: e.backdropClassName,
    children: [
      /* @__PURE__ */ T("div", { className: "tw-overflow-auto tw-h-full tw-w-full", children: [
        /* @__PURE__ */ T("div", { className: "tw-sticky tw-top-0 tw-z-10000 tw-bg-white tw-flex tw-justify-between tw-w-full tw-px-2", children: [
          /* @__PURE__ */ u("div", { children: e.multipleSteps }),
          /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u(
            Lh,
            {
              className: "tw-rounded-sm tw-opacity-70 focus-visible:tw-outline-none tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 disabled:tw-pointer-events-none data-[state=open]:tw-bg-secondary",
              onClick: e.onClose,
              children: /* @__PURE__ */ u(rt, { className: "tw-h-6 tw-w-6 focus:tw-outline-none" })
            }
          ) })
        ] }),
        /* @__PURE__ */ u("div", { className: "tw-flex tw-justify-between tw-w-full tw-px-2", children: /* @__PURE__ */ u(Vh, { children: /* @__PURE__ */ u("div", { className: "tw-flex tw-flex-col tw-gap-2 tw-z-9999", children: e.header }) }) }),
        /* @__PURE__ */ u("div", { className: P("tw-flex-1 tw-pt-8px tw-my-8px tw-z-9999 tw-w-full tw-px-2", e.contentClassName), children: e.children })
      ] }),
      /* @__PURE__ */ u(kh, { className: "tw-pt-2", children: e.footer })
    ]
  }
) }), Cte = (e) => /* @__PURE__ */ u(n_, { ...e, header: /* @__PURE__ */ u(o_, { ...e }), multipleSteps: /* @__PURE__ */ u(r_, { ...e }), children: e.children }), r_ = (e) => e.steps == null ? /* @__PURE__ */ u(Ee, {}) : e.steps && e.steps.length === 0 ? /* @__PURE__ */ u(Ee, {}) : /* @__PURE__ */ u(
  TA,
  {
    className: "tw-mb-16px",
    steps: e.steps,
    hideStepText: e.hideStepText,
    activeIndex: e.activeIndex
  }
), o_ = (e) => /* @__PURE__ */ T(Ee, { children: [
  /* @__PURE__ */ u(Fh, { children: /* @__PURE__ */ u(De, { variant: "h4", className: e.titleClassName, children: e.title }) }),
  e.stepsDescription != null && /* @__PURE__ */ u(Hh, { className: "tw-text-base tw-font-normal tw-leading-5 tw-text-grayscale-text-label", children: e.stepsDescription[e.activeIndex] })
] }), Bh = b.forwardRef(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ u(
  "input",
  {
    type: t,
    className: P(
      "tw-w-full tw-h-[56px] tw-flex tw-text-grayscale-text-body tw-rounded-md tw-border focus-visible:tw-shadow-primary-focus tw-border-grayscale-border-dark tw-bg-background tw-pl-12px tw-pr-[12px] tw-py-16px tw-text-normal tw-ring-offset-background file:tw-border-0 file:tw-bg-transparent file:tw-text-sm file:tw-font-medium placeholder:tw-text-normal placeholder:tw-text-grayscale-text-label disabled:tw-cursor-not-allowed disabled:tw-bg-gray-50 disabled:tw-text-input-disabled-text",
      e
    ),
    ref: r,
    ...n
  }
));
Bh.displayName = "Input";
const a_ = "_root_177p8_1", i_ = "_input_177p8_1", s_ = "_hasError_177p8_5", td = {
  root: a_,
  input: i_,
  hasError: s_
}, O4 = (e) => {
  var o;
  const t = le(null), [n, r] = ue(0);
  return ea(() => {
    var a;
    (a = t.current) != null && a.offsetWidth && r(Math.ceil(t.current.offsetWidth));
  }, [(o = t.current) == null ? void 0 : o.offsetWidth]), /* @__PURE__ */ T("div", { className: P("tw-flex tw-flex-col tw-items-start tw-gap-8px tw-w-[300px]", td.root, e.className), children: [
    /* @__PURE__ */ T("div", { className: "tw-relative tw-w-full", children: [
      /* @__PURE__ */ u(
        Bh,
        {
          ...e,
          className: P(
            e.error && "tw-border-errorRed",
            td.input,
            e.error && td.hasError,
            e.rightIcon && "tw-pr-[40px]",
            e.inputClassName
          ),
          style: {
            ...e.unit && { paddingRight: `${n + 8}px` }
          }
        }
      ),
      e.unit ? /* @__PURE__ */ u(
        "div",
        {
          ref: t,
          className: P(
            "tw-absolute tw-right-[1px] tw-top-[1px] tw-flex tw-justify-center tw-items-center tw-h-[54px] tw-p-16px tw-bg-grayscale-surface-light tw-rounded-r-md tw-border-l tw-border-l-grayscale-border-dark tw-overflow-clip",
            e.error && "tw-border-l-errorRed"
          ),
          children: /* @__PURE__ */ u(De, { variant: "normal", children: e.unit })
        }
      ) : /* @__PURE__ */ u(Ee, { children: e.rightIcon && /* @__PURE__ */ u("div", { className: "tw-absolute tw-right-0 tw-top-0 tw-flex tw-justify-center tw-items-center tw-h-[56px] tw-w-[40px] tw-text-grayscale-text-label", children: e.rightIcon }) })
    ] }),
    e.error ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) : e.helperText && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: e.helperText })
  ] });
}, B2 = xc, l_ = Ec, Gh = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  oo,
  {
    ref: n,
    className: P(
      "tw-fixed tw-inset-0 tw-z-10000 tw-bg-black/80 tw- data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0",
      e
    ),
    ...t
  }
));
Gh.displayName = oo.displayName;
const Ic = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ T(l_, { children: [
  /* @__PURE__ */ u(Gh, {}),
  /* @__PURE__ */ u(
    ao,
    {
      ref: r,
      className: P(
        "tw-fixed tw-left-[50%] tw-top-[50%] tw-z-50 tw-grid tw-w-full tw-translate-x-[-50%] tw-translate-y-[-50%] tw-gap-4 tw-border tw-bg-background tw-p-6 tw-shadow-lg tw-duration-200 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[state=closed]:tw-slide-out-to-left-1/2 data-[state=closed]:tw-slide-out-to-top-[48%] data-[state=open]:tw-slide-in-from-left-1/2 data-[state=open]:tw-slide-in-from-top-[48%]",
        e
      ),
      ...n,
      children: t
    }
  )
] }));
Ic.displayName = ao.displayName;
const c_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  da,
  {
    ref: n,
    className: P("tw-text-lg tw-font-semibold tw-leading-none tw-tracking-tight", e),
    ...t
  }
));
c_.displayName = da.displayName;
const u_ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(fa, { ref: n, className: P("tw-text-sm tw-text-muted-foreground", e), ...t }));
u_.displayName = fa.displayName;
const yte = (e) => /* @__PURE__ */ u(B2, { open: e.open, children: /* @__PURE__ */ u(
  Ic,
  {
    className: P("tw-min-w-[400px] tw-max-w-3xl tw-z-10001 tw-p-24px tw-rounded-2xl", e.className),
    children: /* @__PURE__ */ u("div", { className: "tw-flex tw-flex-col tw-gap-16px", children: e.children })
  }
) }), xte = (e) => e.children, Ete = (e) => e.children;
var G2 = "ToastProvider", [W2, d_, f_] = Vi("Toast"), [Wh, Ite] = st("Toast", [f_]), [p_, Sc] = Wh(G2), Zh = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, l] = b.useState(null), [c, d] = b.useState(0), f = b.useRef(!1), p = b.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${G2}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ u(W2.Provider, { scope: t, children: /* @__PURE__ */ u(
    p_,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: c,
      viewport: s,
      onViewportChange: l,
      onToastAdd: b.useCallback(() => d((h) => h + 1), []),
      onToastRemove: b.useCallback(() => d((h) => h - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: p,
      children: i
    }
  ) });
};
Zh.displayName = G2;
var $h = "ToastViewport", h_ = ["F8"], Y1 = "toast.viewportPause", j1 = "toast.viewportResume", Yh = b.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = h_,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = Sc($h, n), s = d_(n), l = b.useRef(null), c = b.useRef(null), d = b.useRef(null), f = b.useRef(null), p = we(t, f, i.onViewportChange), h = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    b.useEffect(() => {
      const v = (w) => {
        var y;
        r.length !== 0 && r.every((x) => w[x] || w.code === x) && ((y = f.current) == null || y.focus());
      };
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
    }, [r]), b.useEffect(() => {
      const v = l.current, w = f.current;
      if (g && v && w) {
        const C = () => {
          if (!i.isClosePausedRef.current) {
            const S = new CustomEvent(Y1);
            w.dispatchEvent(S), i.isClosePausedRef.current = !0;
          }
        }, y = () => {
          if (i.isClosePausedRef.current) {
            const S = new CustomEvent(j1);
            w.dispatchEvent(S), i.isClosePausedRef.current = !1;
          }
        }, x = (S) => {
          !v.contains(S.relatedTarget) && y();
        }, E = () => {
          v.contains(document.activeElement) || y();
        };
        return v.addEventListener("focusin", C), v.addEventListener("focusout", x), v.addEventListener("pointermove", C), v.addEventListener("pointerleave", E), window.addEventListener("blur", C), window.addEventListener("focus", y), () => {
          v.removeEventListener("focusin", C), v.removeEventListener("focusout", x), v.removeEventListener("pointermove", C), v.removeEventListener("pointerleave", E), window.removeEventListener("blur", C), window.removeEventListener("focus", y);
        };
      }
    }, [g, i.isClosePausedRef]);
    const m = b.useCallback(
      ({ tabbingDirection: v }) => {
        const C = s().map((y) => {
          const x = y.ref.current, E = [x, ...A_(x)];
          return v === "forwards" ? E : E.reverse();
        });
        return (v === "forwards" ? C.reverse() : C).flat();
      },
      [s]
    );
    return b.useEffect(() => {
      const v = f.current;
      if (v) {
        const w = (C) => {
          var E, S, I;
          const y = C.altKey || C.ctrlKey || C.metaKey;
          if (C.key === "Tab" && !y) {
            const D = document.activeElement, N = C.shiftKey;
            if (C.target === v && N) {
              (E = c.current) == null || E.focus();
              return;
            }
            const F = m({ tabbingDirection: N ? "backwards" : "forwards" }), k = F.findIndex((G) => G === D);
            nd(F.slice(k + 1)) ? C.preventDefault() : N ? (S = c.current) == null || S.focus() : (I = d.current) == null || I.focus();
          }
        };
        return v.addEventListener("keydown", w), () => v.removeEventListener("keydown", w);
      }
    }, [s, m]), /* @__PURE__ */ T(
      Jx,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", h),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ u(
            z1,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const v = m({
                  tabbingDirection: "forwards"
                });
                nd(v);
              }
            }
          ),
          /* @__PURE__ */ u(W2.Slot, { scope: n, children: /* @__PURE__ */ u(ie.ol, { tabIndex: -1, ...a, ref: p }) }),
          g && /* @__PURE__ */ u(
            z1,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const v = m({
                  tabbingDirection: "backwards"
                });
                nd(v);
              }
            }
          )
        ]
      }
    );
  }
);
Yh.displayName = $h;
var jh = "ToastFocusProxy", z1 = b.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, a = Sc(jh, n);
    return /* @__PURE__ */ u(
      ac,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          var c;
          const s = i.relatedTarget;
          !((c = a.viewport) != null && c.contains(s)) && r();
        }
      }
    );
  }
);
z1.displayName = jh;
var Wi = "Toast", m_ = "toast.swipeStart", v_ = "toast.swipeMove", g_ = "toast.swipeCancel", w_ = "toast.swipeEnd", zh = b.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s, l] = vt({
      prop: r,
      defaultProp: o ?? !0,
      onChange: a,
      caller: Wi
    });
    return /* @__PURE__ */ u(ut, { present: n || s, children: /* @__PURE__ */ u(
      y_,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: Ct(e.onPause),
        onResume: Ct(e.onResume),
        onSwipeStart: oe(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: oe(e.onSwipeMove, (c) => {
          const { x: d, y: f } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: oe(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: oe(e.onSwipeEnd, (c) => {
          const { x: d, y: f } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), l(!1);
        })
      }
    ) });
  }
);
zh.displayName = Wi;
var [b_, C_] = Wh(Wi, {
  onClose() {
  }
}), y_ = b.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: p,
      onSwipeEnd: h,
      ...g
    } = e, m = Sc(Wi, n), [v, w] = b.useState(null), C = we(t, (G) => w(G)), y = b.useRef(null), x = b.useRef(null), E = o || m.duration, S = b.useRef(0), I = b.useRef(E), D = b.useRef(0), { onToastAdd: N, onToastRemove: A } = m, L = Ct(() => {
      var J;
      (v == null ? void 0 : v.contains(document.activeElement)) && ((J = m.viewport) == null || J.focus()), i();
    }), F = b.useCallback(
      (G) => {
        !G || G === 1 / 0 || (window.clearTimeout(D.current), S.current = (/* @__PURE__ */ new Date()).getTime(), D.current = window.setTimeout(L, G));
      },
      [L]
    );
    b.useEffect(() => {
      const G = m.viewport;
      if (G) {
        const J = () => {
          F(I.current), c == null || c();
        }, $ = () => {
          const H = (/* @__PURE__ */ new Date()).getTime() - S.current;
          I.current = I.current - H, window.clearTimeout(D.current), l == null || l();
        };
        return G.addEventListener(Y1, $), G.addEventListener(j1, J), () => {
          G.removeEventListener(Y1, $), G.removeEventListener(j1, J);
        };
      }
    }, [m.viewport, E, l, c, F]), b.useEffect(() => {
      a && !m.isClosePausedRef.current && F(E);
    }, [a, E, m.isClosePausedRef, F]), b.useEffect(() => (N(), () => A()), [N, A]);
    const k = b.useMemo(() => v ? Kh(v) : null, [v]);
    return m.viewport ? /* @__PURE__ */ T(Ee, { children: [
      k && /* @__PURE__ */ u(
        x_,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: k
        }
      ),
      /* @__PURE__ */ u(b_, { scope: n, onClose: L, children: Ri.createPortal(
        /* @__PURE__ */ u(W2.ItemSlot, { scope: n, children: /* @__PURE__ */ u(
          Ux,
          {
            asChild: !0,
            onEscapeKeyDown: oe(s, () => {
              m.isFocusedToastEscapeKeyDownRef.current || L(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ u(
              ie.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...g,
                ref: C,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: oe(e.onKeyDown, (G) => {
                  G.key === "Escape" && (s == null || s(G.nativeEvent), G.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, L()));
                }),
                onPointerDown: oe(e.onPointerDown, (G) => {
                  G.button === 0 && (y.current = { x: G.clientX, y: G.clientY });
                }),
                onPointerMove: oe(e.onPointerMove, (G) => {
                  if (!y.current)
                    return;
                  const J = G.clientX - y.current.x, $ = G.clientY - y.current.y, H = !!x.current, V = ["left", "right"].includes(m.swipeDirection), j = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, B = V ? j(0, J) : 0, Z = V ? 0 : j(0, $), O = G.pointerType === "touch" ? 10 : 2, Y = { x: B, y: Z }, U = { originalEvent: G, delta: Y };
                  H ? (x.current = Y, Ms(v_, f, U, {
                    discrete: !1
                  })) : T4(Y, m.swipeDirection, O) ? (x.current = Y, Ms(m_, d, U, {
                    discrete: !1
                  }), G.target.setPointerCapture(G.pointerId)) : (Math.abs(J) > O || Math.abs($) > O) && (y.current = null);
                }),
                onPointerUp: oe(e.onPointerUp, (G) => {
                  const J = x.current, $ = G.target;
                  if ($.hasPointerCapture(G.pointerId) && $.releasePointerCapture(G.pointerId), x.current = null, y.current = null, J) {
                    const H = G.currentTarget, V = { originalEvent: G, delta: J };
                    T4(J, m.swipeDirection, m.swipeThreshold) ? Ms(w_, h, V, {
                      discrete: !0
                    }) : Ms(
                      g_,
                      p,
                      V,
                      {
                        discrete: !0
                      }
                    ), H.addEventListener("click", (j) => j.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), x_ = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Sc(Wi, t), [a, i] = b.useState(!1), [s, l] = b.useState(!1);
  return N_(() => i(!0)), b.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ u(ro, { asChild: !0, children: /* @__PURE__ */ u(ac, { ...r, children: a && /* @__PURE__ */ T(Ee, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, E_ = "ToastTitle", I_ = b.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ u(ie.div, { ...r, ref: t });
  }
);
I_.displayName = E_;
var S_ = "ToastDescription", D_ = b.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ u(ie.div, { ...r, ref: t });
  }
);
D_.displayName = S_;
var Xh = "ToastAction", M_ = b.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ u(Jh, { altText: n, asChild: !0, children: /* @__PURE__ */ u(Z2, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Xh}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
M_.displayName = Xh;
var Uh = "ToastClose", Z2 = b.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = C_(Uh, n);
    return /* @__PURE__ */ u(Jh, { asChild: !0, children: /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: oe(e.onClick, o.onClose)
      }
    ) });
  }
);
Z2.displayName = Uh;
var Jh = b.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ u(
    ie.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function Kh(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), P_(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && t.push(i);
        } else
          t.push(...Kh(r));
    }
  }), t;
}
function Ms(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? a2(o, a) : o.dispatchEvent(a);
}
var T4 = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return t === "left" || t === "right" ? a && r > n : !a && o > n;
};
function N_(e = () => {
}) {
  const t = Ct(e);
  at(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function P_(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function A_(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function nd(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var __ = Zh, qh = Yh, Qh = zh, em = Z2;
const O_ = __, tm = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  qh,
  {
    id: "toast-viewport",
    ref: n,
    className: P(
      "tw-fixed tw-top-0 tw-right-[25px] tw-z-100000 tw-flex tw-max-h-screen tw-w-full tw-flex-col-reverse tw-p-4 sm:tw-flex-col md:tw-max-w-[420px]",
      e
    ),
    ...t
  }
));
tm.displayName = qh.displayName;
const T_ = Xt(
  "tw-w-[600px] tw-group tw-relative tw-flex tw-w-full tw-items-start tw-justify-between tw-flex tw-gap-16px tw-overflow-hidden tw-border-t-4 tw-p-16px  tw-shadow-lg tw-transition-all data-[swipe=cancel]:tw-translate-x-0 data-[swipe=end]:tw-translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:tw-translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:tw-transition-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[swipe=end]:tw-animate-out data-[state=closed]:tw-fade-out-80 data-[state=closed]:tw-slide-out-to-right-full data-[state=open]:tw-slide-in-from-top-full data-[state=open]:sm:tw-slide-in-from-top-full",
  {
    variants: {
      variant: {
        info: "tw-text-toast-text-info tw-border-toast-text-info tw-bg-toast-background-info",
        success: "tw-text-toast-text-success tw-border-toast-text-success tw-bg-toast-background-success",
        error: "tw-text-toast-text-error tw-border-toast-text-error tw-bg-toast-background-error",
        warning: "tw-text-toast-text-warning tw-border-toast-text-warning tw-bg-toast-background-warning"
      }
    },
    defaultVariants: {
      variant: "info"
    }
  }
), X1 = {
  info: "tw-text-toast-text-info",
  success: "tw-text-toast-text-success",
  error: "tw-text-toast-text-error",
  warning: "tw-text-toast-text-warning"
}, L_ = {
  info: /* @__PURE__ */ u(c8, { size: 24, className: "tw-text-toast-text-info" }),
  success: /* @__PURE__ */ u(i8, { size: 24, className: "tw-text-toast-text-success" }),
  error: /* @__PURE__ */ u(u8, { size: 24, className: "tw-text-toast-text-error" }),
  warning: /* @__PURE__ */ u(a8, { size: 24, className: "tw-text-toast-text-warning" })
}, nm = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  em,
  {
    ref: n,
    className: P(
      "tw-pointer-events-auto tw-absolute tw-right-[2px] tw-top-0 tw-rounded-md tw-p-1 focus:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 group-hover:tw-opacity-100 group-[.destructive]:tw-text-red-300 group-[.destructive]:hover:tw-text-red-50 group-[.destructive]:focus:tw-ring-red-400 group-[.destructive]:focus:tw-ring-offset-red-600",
      e,
      X1[t.variant]
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ u(rt, { className: "tw-h-5 tw-w-5" })
  }
));
nm.displayName = em.displayName;
const rm = b.forwardRef(({ className: e, variant: t, onDurationChange: n, ...r }, o) => /* @__PURE__ */ T(
  Qh,
  {
    ref: o,
    className: P("tw-pointer-events-none", T_({ variant: t }), e),
    onClick: (a) => {
      a.preventDefault(), console.log("click");
    },
    onOpenChange: (a) => {
      var i;
      a || (i = document.getElementById("toast-viewport")) == null || i.blur();
    },
    children: [
      L_[t],
      /* @__PURE__ */ T("div", { className: "tw-flex-1 tw-flex tw-flex-col tw-gap-8px", children: [
        /* @__PURE__ */ u(De, { className: X1[t], variant: "h5", children: r.title }),
        /* @__PURE__ */ u(De, { className: X1[t], variant: "normal", lineHeight: "1.20", children: r.subtitle })
      ] }),
      /* @__PURE__ */ u(nm, { variant: t })
    ]
  }
));
rm.displayName = Qh.displayName;
const R_ = 1, V_ = 1e6;
let rd = 0;
function k_() {
  return rd = (rd + 1) % Number.MAX_SAFE_INTEGER, rd.toString();
}
const od = /* @__PURE__ */ new Map(), L4 = (e) => {
  if (od.has(e))
    return;
  const t = setTimeout(() => {
    od.delete(e), ei({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, V_);
  od.set(e, t);
}, F_ = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, R_)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? L4(n) : e.toasts.forEach((r) => {
        L4(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, rl = [];
let ol = { toasts: [] };
function ei(e) {
  ol = F_(ol, e), rl.forEach((t) => {
    t(ol);
  });
}
function om({ ...e }) {
  const t = k_(), n = (o) => {
    ei({
      type: "UPDATE_TOAST",
      toast: { ...o, id: t }
    });
  }, r = () => {
    ei({ type: "DISMISS_TOAST", toastId: t });
  };
  return ei({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), {
    id: t,
    dismiss: r,
    update: n
  };
}
function am() {
  const [e, t] = b.useState(ol);
  return b.useEffect(() => (rl.push(t), () => {
    const n = rl.indexOf(t);
    n > -1 && rl.splice(n, 1);
  }), [e]), {
    ...e,
    toast: om,
    dismiss: (n) => {
      ei({ type: "DISMISS_TOAST", toastId: n });
    }
  };
}
function H_({ duration: e }) {
  const { toasts: t } = am();
  return /* @__PURE__ */ T(O_, { duration: e, children: [
    t.map(function({ id: n, title: r, description: o, subtitle: a, duration: i, ...s }) {
      return /* @__PURE__ */ u(rm, { title: r, subtitle: a, duration: i, ...s }, n);
    }),
    /* @__PURE__ */ u(tm, { className: "tw-pointer-events-none" })
  ] });
}
const Ste = (e) => /* @__PURE__ */ u(H_, { duration: e.duration }), Dte = am, Mte = om;
var Dc = "Collapsible", [B_, im] = st(Dc), [G_, $2] = B_(Dc), sm = b.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [l, c] = vt({
      prop: r,
      defaultProp: o ?? !1,
      onChange: i,
      caller: Dc
    });
    return /* @__PURE__ */ u(
      G_,
      {
        scope: n,
        disabled: a,
        contentId: Ue(),
        open: l,
        onOpenToggle: b.useCallback(() => c((d) => !d), [c]),
        children: /* @__PURE__ */ u(
          ie.div,
          {
            "data-state": j2(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
sm.displayName = Dc;
var lm = "CollapsibleTrigger", cm = b.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, o = $2(lm, n);
    return /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": j2(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: t,
        onClick: oe(e.onClick, o.onOpenToggle)
      }
    );
  }
);
cm.displayName = lm;
var Y2 = "CollapsibleContent", um = b.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = $2(Y2, e.__scopeCollapsible);
    return /* @__PURE__ */ u(ut, { present: n || o.open, children: ({ present: a }) => /* @__PURE__ */ u(W_, { ...r, ref: t, present: a }) });
  }
);
um.displayName = Y2;
var W_ = b.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: o, ...a } = e, i = $2(Y2, n), [s, l] = b.useState(r), c = b.useRef(null), d = we(t, c), f = b.useRef(0), p = f.current, h = b.useRef(0), g = h.current, m = i.open || s, v = b.useRef(m), w = b.useRef(void 0);
  return b.useEffect(() => {
    const C = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), at(() => {
    const C = c.current;
    if (C) {
      w.current = w.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const y = C.getBoundingClientRect();
      f.current = y.height, h.current = y.width, v.current || (C.style.transitionDuration = w.current.transitionDuration, C.style.animationName = w.current.animationName), l(r);
    }
  }, [i.open, r]), /* @__PURE__ */ u(
    ie.div,
    {
      "data-state": j2(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !m,
      ...a,
      ref: d,
      style: {
        "--radix-collapsible-content-height": p ? `${p}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: m && o
    }
  );
});
function j2(e) {
  return e ? "open" : "closed";
}
var Z_ = sm, $_ = cm, Y_ = um, dn = "Accordion", j_ = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [z2, z_, X_] = Vi(dn), [Mc, Nte] = st(dn, [
  X_,
  im
]), X2 = im(), dm = X.forwardRef(
  (e, t) => {
    const { type: n, ...r } = e, o = r, a = r;
    return /* @__PURE__ */ u(z2.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ u(q_, { ...a, ref: t }) : /* @__PURE__ */ u(K_, { ...o, ref: t }) });
  }
);
dm.displayName = dn;
var [fm, U_] = Mc(dn), [pm, J_] = Mc(
  dn,
  { collapsible: !1 }
), K_ = X.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, l] = vt({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: dn
    });
    return /* @__PURE__ */ u(
      fm,
      {
        scope: e.__scopeAccordion,
        value: X.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: l,
        onItemClose: X.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ u(pm, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ u(hm, { ...i, ref: t }) })
      }
    );
  }
), q_ = X.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i, s] = vt({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: dn
  }), l = X.useCallback(
    (d) => s((f = []) => [...f, d]),
    [s]
  ), c = X.useCallback(
    (d) => s((f = []) => f.filter((p) => p !== d)),
    [s]
  );
  return /* @__PURE__ */ u(
    fm,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ u(pm, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ u(hm, { ...a, ref: t }) })
    }
  );
}), [Q_, Nc] = Mc(dn), hm = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = X.useRef(null), l = we(s, t), c = z_(n), f = ra(o) === "ltr", p = oe(e.onKeyDown, (h) => {
      var D;
      if (!j_.includes(h.key))
        return;
      const g = h.target, m = c().filter((N) => {
        var A;
        return !((A = N.ref.current) != null && A.disabled);
      }), v = m.findIndex((N) => N.ref.current === g), w = m.length;
      if (v === -1)
        return;
      h.preventDefault();
      let C = v;
      const y = 0, x = w - 1, E = () => {
        C = v + 1, C > x && (C = y);
      }, S = () => {
        C = v - 1, C < y && (C = x);
      };
      switch (h.key) {
        case "Home":
          C = y;
          break;
        case "End":
          C = x;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? E() : S());
          break;
        case "ArrowDown":
          a === "vertical" && E();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? S() : E());
          break;
        case "ArrowUp":
          a === "vertical" && S();
          break;
      }
      const I = C % w;
      (D = m[I].ref.current) == null || D.focus();
    });
    return /* @__PURE__ */ u(
      Q_,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ u(z2.Slot, { scope: n, children: /* @__PURE__ */ u(
          ie.div,
          {
            ...i,
            "data-orientation": a,
            ref: l,
            onKeyDown: r ? void 0 : p
          }
        ) })
      }
    );
  }
), Ml = "AccordionItem", [eO, U2] = Mc(Ml), mm = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: r, ...o } = e, a = Nc(Ml, n), i = U_(Ml, n), s = X2(n), l = Ue(), c = r && i.value.includes(r) || !1, d = a.disabled || e.disabled;
    return /* @__PURE__ */ u(
      eO,
      {
        scope: n,
        open: c,
        disabled: d,
        triggerId: l,
        children: /* @__PURE__ */ u(
          Z_,
          {
            "data-orientation": a.orientation,
            "data-state": ym(c),
            ...s,
            ...o,
            ref: t,
            disabled: d,
            open: c,
            onOpenChange: (f) => {
              f ? i.onItemOpen(r) : i.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
mm.displayName = Ml;
var vm = "AccordionHeader", gm = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Nc(dn, n), a = U2(vm, n);
    return /* @__PURE__ */ u(
      ie.h3,
      {
        "data-orientation": o.orientation,
        "data-state": ym(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
gm.displayName = vm;
var U1 = "AccordionTrigger", wm = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Nc(dn, n), a = U2(U1, n), i = J_(U1, n), s = X2(n);
    return /* @__PURE__ */ u(z2.ItemSlot, { scope: n, children: /* @__PURE__ */ u(
      $_,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: t
      }
    ) });
  }
);
wm.displayName = U1;
var bm = "AccordionContent", Cm = X.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...r } = e, o = Nc(dn, n), a = U2(bm, n), i = X2(n);
    return /* @__PURE__ */ u(
      Y_,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...r,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Cm.displayName = bm;
function ym(e) {
  return e ? "open" : "closed";
}
var tO = dm, nO = mm, rO = gm, xm = wm, Em = Cm;
const J1 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(tO, { ref: n, className: P("tw-flex tw-flex-col tw-gap-4", e), ...t }));
J1.displayName = "Accordion";
const Im = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  nO,
  {
    ref: n,
    className: P(
      "tw-border tw-border-gray-100 tw-shadow-small tw-border-grayscale-border-dark tw-rounded-lg tw-px-16px",
      e
    ),
    ...t
  }
));
Im.displayName = "AccordionItem";
const Sm = b.forwardRef(
  ({
    className: e,
    triggerClassName: t,
    children: n,
    isReportVariant: r,
    withActionButton: o,
    actionButton: a,
    actionButtonClassName: i,
    ...s
  }, l) => /* @__PURE__ */ u(rO, { className: "tw-flex", children: /* @__PURE__ */ T(
    xm,
    {
      ref: l,
      className: P("tw-flex tw-items-center tw-flex-1 tw-group", e),
      ...s,
      children: [
        /* @__PURE__ */ T(
          "div",
          {
            className: P(
              "tw-flex tw-text-lg tw-font-semibold tw-flex-1 tw-items-center tw-py-4 tw-transition-all tw-gap-8px",
              r ? "tw-justify-start" : "tw-justify-between",
              t
            ),
            children: [
              n,
              /* @__PURE__ */ T("div", { className: P("tw-flex tw-items-center tw-gap-8px", i), children: [
                o && a,
                /* @__PURE__ */ u(qn, { className: "tw-text-grayscale-text-body tw-h-6 tw-w-6 tw-shrink-0 tw-transition-transform tw-duration-200 group-data-[state=open]:tw-rotate-180" })
              ] })
            ]
          }
        ),
        r && a
      ]
    }
  ) })
);
Sm.displayName = xm.displayName;
const Dm = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ u(
  Em,
  {
    ...n,
    ref: r,
    className: P(
      "tw-overflow-hidden tw-text-sm tw-transition-all data-[state=closed]:tw-animate-accordion-up data-[state=open]:tw-animate-accordion-down",
      e
    ),
    children: /* @__PURE__ */ u("div", { className: P("tw-pb-4 tw-pt-0", e), children: t })
  }
));
Dm.displayName = Em.displayName;
const Pte = (e) => e.type === "multiple" ? /* @__PURE__ */ u(J1, { className: e.className, type: "multiple", defaultValue: e.defaultValue, value: e.value, children: e.children }) : /* @__PURE__ */ u(J1, { className: e.className, type: "single", collapsible: !0, children: e.children }), Ate = (e) => /* @__PURE__ */ T(Im, { className: e.className, title: e.title, value: e.value, children: [
  /* @__PURE__ */ u(
    Sm,
    {
      isReportVariant: e.isReportVariant,
      actionButton: e.actionButton,
      triggerClassName: e.triggerClassName,
      withActionButton: e.withActionButton,
      actionButtonClassName: e.actionButtonClassName,
      children: e.titleContent ?? e.title
    }
  ),
  /* @__PURE__ */ u(Dm, { className: e.contentClassName, children: e.children })
] }), oO = Xt(
  "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2",
  {
    variants: {
      variant: {
        default: "tw-border-transparent tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/80",
        secondary: "tw-border-transparent tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
        destructive: "tw-border-transparent tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/80",
        outline: "tw-text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function R4({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ u("div", { className: P(oO({ variant: t }), e), ...n });
}
var V4 = 1, aO = 0.9, iO = 0.8, sO = 0.17, ad = 0.1, id = 0.999, lO = 0.9999, cO = 0.99, uO = /[\\\/_+.#"@\[\(\{&]/, dO = /[\\\/_+.#"@\[\(\{&]/g, fO = /[\s-]/, Mm = /[\s-]/g;
function K1(e, t, n, r, o, a, i) {
  if (a === t.length)
    return o === e.length ? V4 : cO;
  var s = `${o},${a}`;
  if (i[s] !== void 0)
    return i[s];
  for (var l = r.charAt(a), c = n.indexOf(l, o), d = 0, f, p, h, g; c >= 0; )
    f = K1(e, t, n, r, c + 1, a + 1, i), f > d && (c === o ? f *= V4 : uO.test(e.charAt(c - 1)) ? (f *= iO, h = e.slice(o, c - 1).match(dO), h && o > 0 && (f *= Math.pow(id, h.length))) : fO.test(e.charAt(c - 1)) ? (f *= aO, g = e.slice(o, c - 1).match(Mm), g && o > 0 && (f *= Math.pow(id, g.length))) : (f *= sO, o > 0 && (f *= Math.pow(id, c - o))), e.charAt(c) !== t.charAt(a) && (f *= lO)), (f < ad && n.charAt(c - 1) === r.charAt(a + 1) || r.charAt(a + 1) === r.charAt(a) && n.charAt(c - 1) !== r.charAt(a)) && (p = K1(e, t, n, r, c + 1, a + 2, i), p * ad > f && (f = p * ad)), f > d && (d = f), c = n.indexOf(l, c + 1);
  return i[s] = d, d;
}
function k4(e) {
  return e.toLowerCase().replace(Mm, " ");
}
function pO(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, K1(e, t, k4(e), k4(t), 0, 0, {});
}
var _a = '[cmdk-group=""]', sd = '[cmdk-group-items=""]', hO = '[cmdk-group-heading=""]', Nm = '[cmdk-item=""]', F4 = `${Nm}:not([aria-disabled="true"])`, q1 = "cmdk-item-select", Io = "data-value", mO = (e, t, n) => pO(e, t, n), Pm = b.createContext(void 0), Zi = () => b.useContext(Pm), Am = b.createContext(void 0), J2 = () => b.useContext(Am), _m = b.createContext(void 0), Om = b.forwardRef((e, t) => {
  let n = So(() => {
    var O, Y;
    return { search: "", value: (Y = (O = e.value) != null ? O : e.defaultValue) != null ? Y : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = So(() => /* @__PURE__ */ new Set()), o = So(() => /* @__PURE__ */ new Map()), a = So(() => /* @__PURE__ */ new Map()), i = So(() => /* @__PURE__ */ new Set()), s = Tm(e), { label: l, children: c, value: d, onValueChange: f, filter: p, shouldFilter: h, loop: g, disablePointerSelection: m = !1, vimBindings: v = !0, ...w } = e, C = Ue(), y = Ue(), x = Ue(), E = b.useRef(null), S = DO();
  Kr(() => {
    if (d !== void 0) {
      let O = d.trim();
      n.current.value = O, I.emit();
    }
  }, [d]), Kr(() => {
    S(6, k);
  }, []);
  let I = b.useMemo(() => ({ subscribe: (O) => (i.current.add(O), () => i.current.delete(O)), snapshot: () => n.current, setState: (O, Y, U) => {
    var K, q, W, Q;
    if (!Object.is(n.current[O], Y)) {
      if (n.current[O] = Y, O === "search")
        F(), A(), S(1, L);
      else if (O === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let te = document.getElementById(x);
          te ? te.focus() : (K = document.getElementById(C)) == null || K.focus();
        }
        if (S(7, () => {
          var te;
          n.current.selectedItemId = (te = G()) == null ? void 0 : te.id, I.emit();
        }), U || S(5, k), ((q = s.current) == null ? void 0 : q.value) !== void 0) {
          let te = Y ?? "";
          (Q = (W = s.current).onValueChange) == null || Q.call(W, te);
          return;
        }
      }
      I.emit();
    }
  }, emit: () => {
    i.current.forEach((O) => O());
  } }), []), D = b.useMemo(() => ({ value: (O, Y, U) => {
    var K;
    Y !== ((K = a.current.get(O)) == null ? void 0 : K.value) && (a.current.set(O, { value: Y, keywords: U }), n.current.filtered.items.set(O, N(Y, U)), S(2, () => {
      A(), I.emit();
    }));
  }, item: (O, Y) => (r.current.add(O), Y && (o.current.has(Y) ? o.current.get(Y).add(O) : o.current.set(Y, /* @__PURE__ */ new Set([O]))), S(3, () => {
    F(), A(), n.current.value || L(), I.emit();
  }), () => {
    a.current.delete(O), r.current.delete(O), n.current.filtered.items.delete(O);
    let U = G();
    S(4, () => {
      F(), (U == null ? void 0 : U.getAttribute("id")) === O && L(), I.emit();
    });
  }), group: (O) => (o.current.has(O) || o.current.set(O, /* @__PURE__ */ new Set()), () => {
    a.current.delete(O), o.current.delete(O);
  }), filter: () => s.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => s.current.disablePointerSelection, listId: C, inputId: x, labelId: y, listInnerRef: E }), []);
  function N(O, Y) {
    var U, K;
    let q = (K = (U = s.current) == null ? void 0 : U.filter) != null ? K : mO;
    return O ? q(O, n.current.search, Y) : 0;
  }
  function A() {
    if (!n.current.search || s.current.shouldFilter === !1)
      return;
    let O = n.current.filtered.items, Y = [];
    n.current.filtered.groups.forEach((K) => {
      let q = o.current.get(K), W = 0;
      q.forEach((Q) => {
        let te = O.get(Q);
        W = Math.max(te, W);
      }), Y.push([K, W]);
    });
    let U = E.current;
    J().sort((K, q) => {
      var W, Q;
      let te = K.getAttribute("id"), re = q.getAttribute("id");
      return ((W = O.get(re)) != null ? W : 0) - ((Q = O.get(te)) != null ? Q : 0);
    }).forEach((K) => {
      let q = K.closest(sd);
      q ? q.appendChild(K.parentElement === q ? K : K.closest(`${sd} > *`)) : U.appendChild(K.parentElement === U ? K : K.closest(`${sd} > *`));
    }), Y.sort((K, q) => q[1] - K[1]).forEach((K) => {
      var q;
      let W = (q = E.current) == null ? void 0 : q.querySelector(`${_a}[${Io}="${encodeURIComponent(K[0])}"]`);
      W == null || W.parentElement.appendChild(W);
    });
  }
  function L() {
    let O = J().find((U) => U.getAttribute("aria-disabled") !== "true"), Y = O == null ? void 0 : O.getAttribute(Io);
    I.setState("value", Y || void 0);
  }
  function F() {
    var O, Y, U, K;
    if (!n.current.search || s.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let q = 0;
    for (let W of r.current) {
      let Q = (Y = (O = a.current.get(W)) == null ? void 0 : O.value) != null ? Y : "", te = (K = (U = a.current.get(W)) == null ? void 0 : U.keywords) != null ? K : [], re = N(Q, te);
      n.current.filtered.items.set(W, re), re > 0 && q++;
    }
    for (let [W, Q] of o.current)
      for (let te of Q)
        if (n.current.filtered.items.get(te) > 0) {
          n.current.filtered.groups.add(W);
          break;
        }
    n.current.filtered.count = q;
  }
  function k() {
    var O, Y, U;
    let K = G();
    K && (((O = K.parentElement) == null ? void 0 : O.firstChild) === K && ((U = (Y = K.closest(_a)) == null ? void 0 : Y.querySelector(hO)) == null || U.scrollIntoView({ block: "nearest" })), K.scrollIntoView({ block: "nearest" }));
  }
  function G() {
    var O;
    return (O = E.current) == null ? void 0 : O.querySelector(`${Nm}[aria-selected="true"]`);
  }
  function J() {
    var O;
    return Array.from(((O = E.current) == null ? void 0 : O.querySelectorAll(F4)) || []);
  }
  function $(O) {
    let Y = J()[O];
    Y && I.setState("value", Y.getAttribute(Io));
  }
  function H(O) {
    var Y;
    let U = G(), K = J(), q = K.findIndex((Q) => Q === U), W = K[q + O];
    (Y = s.current) != null && Y.loop && (W = q + O < 0 ? K[K.length - 1] : q + O === K.length ? K[0] : K[q + O]), W && I.setState("value", W.getAttribute(Io));
  }
  function V(O) {
    let Y = G(), U = Y == null ? void 0 : Y.closest(_a), K;
    for (; U && !K; )
      U = O > 0 ? IO(U, _a) : SO(U, _a), K = U == null ? void 0 : U.querySelector(F4);
    K ? I.setState("value", K.getAttribute(Io)) : H(O);
  }
  let j = () => $(J().length - 1), B = (O) => {
    O.preventDefault(), O.metaKey ? j() : O.altKey ? V(1) : H(1);
  }, Z = (O) => {
    O.preventDefault(), O.metaKey ? $(0) : O.altKey ? V(-1) : H(-1);
  };
  return b.createElement(ie.div, { ref: t, tabIndex: -1, ...w, "cmdk-root": "", onKeyDown: (O) => {
    var Y;
    (Y = w.onKeyDown) == null || Y.call(w, O);
    let U = O.nativeEvent.isComposing || O.keyCode === 229;
    if (!(O.defaultPrevented || U))
      switch (O.key) {
        case "n":
        case "j": {
          v && O.ctrlKey && B(O);
          break;
        }
        case "ArrowDown": {
          B(O);
          break;
        }
        case "p":
        case "k": {
          v && O.ctrlKey && Z(O);
          break;
        }
        case "ArrowUp": {
          Z(O);
          break;
        }
        case "Home": {
          O.preventDefault(), $(0);
          break;
        }
        case "End": {
          O.preventDefault(), j();
          break;
        }
        case "Enter": {
          O.preventDefault();
          let K = G();
          if (K) {
            let q = new Event(q1);
            K.dispatchEvent(q);
          }
        }
      }
  } }, b.createElement("label", { "cmdk-label": "", htmlFor: D.inputId, id: D.labelId, style: NO }, l), Pc(e, (O) => b.createElement(Am.Provider, { value: I }, b.createElement(Pm.Provider, { value: D }, O))));
}), vO = b.forwardRef((e, t) => {
  var n, r;
  let o = Ue(), a = b.useRef(null), i = b.useContext(_m), s = Zi(), l = Tm(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : i == null ? void 0 : i.forceMount;
  Kr(() => {
    if (!c)
      return s.item(o, i == null ? void 0 : i.id);
  }, [c]);
  let d = Lm(o, a, [e.value, e.children, a], e.keywords), f = J2(), p = wr((S) => S.value && S.value === d.current), h = wr((S) => c || s.filter() === !1 ? !0 : S.search ? S.filtered.items.get(o) > 0 : !0);
  b.useEffect(() => {
    let S = a.current;
    if (!(!S || e.disabled))
      return S.addEventListener(q1, g), () => S.removeEventListener(q1, g);
  }, [h, e.onSelect, e.disabled]);
  function g() {
    var S, I;
    m(), (I = (S = l.current).onSelect) == null || I.call(S, d.current);
  }
  function m() {
    f.setState("value", d.current, !0);
  }
  if (!h)
    return null;
  let { disabled: v, value: w, onSelect: C, forceMount: y, keywords: x, ...E } = e;
  return b.createElement(ie.div, { ref: jn(a, t), ...E, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!p, "data-disabled": !!v, "data-selected": !!p, onPointerMove: v || s.getDisablePointerSelection() ? void 0 : m, onClick: v ? void 0 : g }, e.children);
}), gO = b.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...a } = e, i = Ue(), s = b.useRef(null), l = b.useRef(null), c = Ue(), d = Zi(), f = wr((h) => o || d.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(i) : !0);
  Kr(() => d.group(i), []), Lm(i, s, [e.value, e.heading, l]);
  let p = b.useMemo(() => ({ id: i, forceMount: o }), [o]);
  return b.createElement(ie.div, { ref: jn(s, t), ...a, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && b.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), Pc(e, (h) => b.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, b.createElement(_m.Provider, { value: p }, h))));
}), wO = b.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = b.useRef(null), a = wr((i) => !i.search);
  return !n && !a ? null : b.createElement(ie.div, { ref: jn(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), bO = b.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, a = J2(), i = wr((c) => c.search), s = wr((c) => c.selectedItemId), l = Zi();
  return b.useEffect(() => {
    e.value != null && a.setState("search", e.value);
  }, [e.value]), b.createElement(ie.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": s, id: l.inputId, type: "text", value: o ? e.value : i, onChange: (c) => {
    o || a.setState("search", c.target.value), n == null || n(c.target.value);
  } });
}), CO = b.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, a = b.useRef(null), i = b.useRef(null), s = wr((c) => c.selectedItemId), l = Zi();
  return b.useEffect(() => {
    if (i.current && a.current) {
      let c = i.current, d = a.current, f, p = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let h = c.offsetHeight;
          d.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return p.observe(c), () => {
        cancelAnimationFrame(f), p.unobserve(c);
      };
    }
  }, []), b.createElement(ie.div, { ref: jn(a, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": s, "aria-label": r, id: l.listId }, Pc(e, (c) => b.createElement("div", { ref: jn(i, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), yO = b.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: a, container: i, ...s } = e;
  return b.createElement(xc, { open: n, onOpenChange: r }, b.createElement(Ec, { container: i }, b.createElement(oo, { "cmdk-overlay": "", className: o }), b.createElement(ao, { "aria-label": e.label, "cmdk-dialog": "", className: a }, b.createElement(Om, { ref: t, ...s }))));
}), xO = b.forwardRef((e, t) => wr((n) => n.filtered.count === 0) ? b.createElement(ie.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), EO = b.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...a } = e;
  return b.createElement(ie.div, { ref: t, ...a, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Pc(e, (i) => b.createElement("div", { "aria-hidden": !0 }, i)));
}), yt = Object.assign(Om, { List: CO, Item: vO, Input: bO, Group: gO, Separator: wO, Dialog: yO, Empty: xO, Loading: EO });
function IO(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.nextElementSibling;
  }
}
function SO(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t))
      return n;
    n = n.previousElementSibling;
  }
}
function Tm(e) {
  let t = b.useRef(e);
  return Kr(() => {
    t.current = e;
  }), t;
}
var Kr = typeof window > "u" ? b.useEffect : b.useLayoutEffect;
function So(e) {
  let t = b.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function wr(e) {
  let t = J2(), n = () => e(t.snapshot());
  return b.useSyncExternalStore(t.subscribe, n, n);
}
function Lm(e, t, n, r = []) {
  let o = b.useRef(), a = Zi();
  return Kr(() => {
    var i;
    let s = (() => {
      var c;
      for (let d of n) {
        if (typeof d == "string")
          return d.trim();
        if (typeof d == "object" && "current" in d)
          return d.current ? (c = d.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    a.value(e, s, l), (i = t.current) == null || i.setAttribute(Io, s), o.current = s;
  }), o;
}
var DO = () => {
  let [e, t] = b.useState(), n = So(() => /* @__PURE__ */ new Map());
  return Kr(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function MO(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Pc({ asChild: e, children: t }, n) {
  return e && b.isValidElement(t) ? b.cloneElement(MO(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var NO = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const K2 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  yt,
  {
    ref: n,
    className: P(
      "tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-md tw-bg-popover tw-text-popover-foreground",
      e
    ),
    ...t
  }
));
K2.displayName = yt.displayName;
const Rm = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ T("div", { className: "!tw-py-1 tw-flex tw-items-center tw-border-b tw-px-3 !tw-text-normal", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ u(d8, { className: "tw-mr-2 tw-h-5 tw-w-5 tw-shrink-0 tw-opacity-50" }),
  /* @__PURE__ */ u(
    yt.Input,
    {
      ref: n,
      className: P(
        "tw-flex tw-h-11 tw-w-full tw-rounded-md tw-bg-transparent tw-text-sm tw-outline-none placeholder:tw-text-muted-foreground disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        e
      ),
      ...t
    }
  )
] }));
Rm.displayName = yt.Input.displayName;
const q2 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  yt.List,
  {
    ref: n,
    className: P("tw-max-h-[300px] tw-overflow-y-auto tw-overflow-x-hidden", e),
    ...t
  }
));
q2.displayName = yt.List.displayName;
const Q2 = b.forwardRef((e, t) => /* @__PURE__ */ u(yt.Empty, { ref: t, className: "tw-py-6 tw-text-center tw-text-sm", ...e }));
Q2.displayName = yt.Empty.displayName;
const Vm = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  yt.Group,
  {
    ref: n,
    className: P(
      "tw-overflow-hidden tw-p-1 tw-text-foreground [&_[cmdk-group-heading]]:tw-px-2 [&_[cmdk-group-heading]]:tw-py-1.5 [&_[cmdk-group-heading]]:tw-text-xs [&_[cmdk-group-heading]]:tw-font-medium [&_[cmdk-group-heading]]:tw-text-muted-foreground",
      e
    ),
    ...t
  }
));
Vm.displayName = yt.Group.displayName;
const PO = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(yt.Separator, { ref: n, className: P("tw--mx-1 tw-h-px tw-bg-border", e), ...t }));
PO.displayName = yt.Separator.displayName;
const e3 = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  yt.Item,
  {
    ref: n,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none aria-selected:tw-bg-accent aria-selected:tw-text-accent-foreground data-[disabled=true]:tw-pointer-events-none data-[disabled=true]:tw-opacity-50",
      e
    ),
    ...t
  }
));
e3.displayName = yt.Item.displayName;
function AO(e, t) {
  ye(() => {
    function n(r) {
      e.current && !e.current.contains(r.target) && t();
    }
    return document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [e, t]);
}
const km = Kn(null), Ac = () => {
  const e = Ht(km);
  if (e == null)
    throw new Error("useMultiSelect must be used within MultiSelectProvider");
  return e;
}, _O = ({
  values: e,
  onValuesChange: t,
  loop: n = !1,
  className: r,
  children: o,
  dir: a,
  allOptions: i,
  ...s
}) => {
  const [l, c] = ue(""), [d, f] = ue(!1), [p, h] = ue(-1), g = le(null), m = Ve(
    (w) => {
      if (w === "select-all") {
        t(i.length === e.length ? [] : [...i.map((C) => C.value.toString())]);
        return;
      }
      e.includes(w) ? t(e.filter((C) => C !== w)) : t([...e, w]);
    },
    [e, i, t]
  );
  ye(() => {
    var w;
    d && (c(""), (w = g.current) == null || w.focus());
  }, [d]);
  const v = Ve(
    (w) => {
      const C = () => {
        const x = p + 1;
        h(x > e.length - 1 ? n ? 0 : -1 : x);
      }, y = () => {
        const x = p - 1;
        h(x < 0 ? e.length - 1 : x);
      };
      if ((w.key === "Backspace" || w.key === "Delete") && e.length > 0) {
        if (l.length === 0)
          if (p !== -1 && p < e.length) {
            t(e.filter((E) => E !== e[p]));
            const x = p - 1 < 0 ? 0 : p - 1;
            h(x);
          } else
            t(e.filter((x) => x !== e[e.length - 1]));
      } else
        w.key === "Enter" ? d || f(!0) : w.key === "Escape" ? p !== -1 ? h(-1) : (f(!1), c("")) : a === "rtl" ? w.key === "ArrowRight" ? y() : w.key === "ArrowLeft" && (p !== -1 || n) && C() : w.key === "ArrowLeft" ? y() : w.key === "ArrowRight" && (p !== -1 || n) && C();
    },
    [e, l, p, n, a, d, f, c, t]
  );
  return /* @__PURE__ */ u(
    km.Provider,
    {
      value: {
        value: e,
        onValueChange: m,
        open: d,
        setOpen: f,
        inputValue: l,
        setInputValue: c,
        activeIndex: p,
        setActiveIndex: h,
        inputRef: g
      },
      children: /* @__PURE__ */ u(
        K2,
        {
          onKeyDown: v,
          className: P("tw-overflow-visible tw-bg-transparent tw-flex tw-flex-col tw-space-y-2", r),
          filter: (w, C) => C ? w.toLowerCase().includes(C.toLowerCase()) ? 1 : 0 : 1,
          dir: a,
          ...s,
          children: o
        }
      )
    }
  );
}, Fm = cn(({ className: e, children: t, allItemsText: n, showDiscreteBadgesForSelectAll: r, ...o }, a) => {
  const { value: i, onValueChange: s, activeIndex: l, open: c, setOpen: d } = Ac(), f = le(null), p = Ve(() => {
    d(!1);
  }, [d]);
  AO(f, p);
  const h = (m) => {
    var v;
    return (v = o.options.find((w) => w.value.toString() === m)) == null ? void 0 : v.label;
  }, g = Ve((m) => {
    m.preventDefault(), m.stopPropagation();
  }, []);
  return /* @__PURE__ */ T(
    "div",
    {
      ref: f,
      className: P(
        "tw-flex tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-normal tw-ring-offset-background data-[placeholder]:tw-text-muted-foreground focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>span]:tw-line-clamp-1",
        e
      ),
      ...o,
      onClick: () => {
        d(!c);
      },
      children: [
        /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-1 tw-flex-wrap tw-items-center tw-justify-start tw-gap-2 tw-overflow-y-auto", children: [
          o.options.length === i.length && r !== !0 ? /* @__PURE__ */ T(
            R4,
            {
              className: P(
                "tw-px-2 tw-py-1 tw-text-[#374151] tw-border-[#E5E7EB] tw-rounded-sm tw-text-sm tw-flex tw-items-center tw-gap-1 tw-bg-[#F9FAFB] hover:tw-bg-[#f3f4f6]  tw-text-grayscale-text-label hover:tw-text-grayscale-text-body"
              ),
              variant: "secondary",
              children: [
                /* @__PURE__ */ u("span", { className: "tw-text-sm", children: n ?? "All items" }),
                /* @__PURE__ */ T(
                  "button",
                  {
                    className: "tw-flex tw-items-center",
                    "aria-label": "Remove select all option",
                    "aria-roledescription": "button to remove option",
                    type: "button",
                    onMouseDown: g,
                    onClick: (m) => {
                      m.stopPropagation(), s("select-all");
                    },
                    children: [
                      /* @__PURE__ */ u("span", { className: "tw-sr-only", children: "Remove select all option" }),
                      /* @__PURE__ */ u(rt, { className: "tw-h-4 tw-w-4" })
                    ]
                  }
                )
              ]
            },
            "select-all"
          ) : i.map((m, v) => /* @__PURE__ */ T(
            R4,
            {
              className: P(
                "tw-px-2 tw-py-1 tw-text-[#374151] tw-border-[#E5E7EB] tw-rounded-sm tw-text-sm tw-flex tw-items-center tw-gap-1 tw-bg-[#F9FAFB] hover:tw-bg-[#f3f4f6]  tw-text-grayscale-text-label hover:tw-text-grayscale-text-body",
                l === v && "tw-ring-2 tw-ring-muted-foreground "
              ),
              variant: "secondary",
              children: [
                /* @__PURE__ */ u("span", { className: "tw-text-sm", children: h(m) }),
                /* @__PURE__ */ T(
                  "button",
                  {
                    className: "tw-flex tw-items-center",
                    "aria-label": `Remove ${m} option`,
                    "aria-roledescription": "button to remove option",
                    type: "button",
                    onMouseDown: g,
                    onClick: (w) => {
                      w.stopPropagation(), s(m);
                    },
                    children: [
                      /* @__PURE__ */ T("span", { className: "tw-sr-only", children: [
                        "Remove ",
                        h(m),
                        " option"
                      ] }),
                      /* @__PURE__ */ u(rt, { className: "tw-h-4 tw-w-4" })
                    ]
                  }
                )
              ]
            },
            m
          )),
          t
        ] }),
        /* @__PURE__ */ u("div", { className: "tw-flex tw-h-[38px] tw-justify-center tw-items-center", children: o.icon })
      ]
    }
  );
});
Fm.displayName = "MultiSelectorTrigger";
const Hm = cn(({ className: e, ...t }, n) => {
  const { inputRef: r, setOpen: o, inputValue: a, setInputValue: i, activeIndex: s, setActiveIndex: l } = Ac();
  return /* @__PURE__ */ u(
    yt.Input,
    {
      ...t,
      ref: r,
      value: a,
      onValueChange: s === -1 ? i : void 0,
      onBlur: () => {
        o(!1);
      },
      onFocus: () => {
        o(!0);
      },
      onClick: (c) => {
        c.stopPropagation(), o(!0), l(-1);
      },
      className: P(
        "tw-bg-transparent tw-outline-none placeholder:tw-text-muted-foreground tw-flex-1",
        e,
        s !== -1 && "tw-caret-transparent"
      )
    }
  );
});
Hm.displayName = "MultiSelectorInput";
const Bm = cn(
  ({ children: e, className: t }, n) => {
    const { open: r } = Ac();
    return /* @__PURE__ */ u("div", { ref: n, className: P("tw-relative tw-z-[99999] tw-max-h-[300px] tw-min-w-[8rem]", t), children: r && e });
  }
);
Bm.displayName = "MultiSelectorContent";
const Gm = cn(({ className: e, children: t, commandEmptyText: n }, r) => /* @__PURE__ */ T(
  q2,
  {
    ref: r,
    className: P(
      "tw-p-2 tw-flex tw-flex-col tw-gap-2 tw-rounded-md tw-scrollbar-thin tw-scrollbar-track-transparent tw-transition-colors tw-scrollbar-thumb-muted-foreground dark:tw-scrollbar-thumb-muted tw-scrollbar-thumb-rounded-lg tw-w-full tw-absolute tw-bg-background tw-shadow-md tw-z-10 tw-border tw-border-muted tw-top-0",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ u(Q2, { children: /* @__PURE__ */ u("span", { className: "tw-text-muted-foreground", children: n ?? "No results found" }) })
    ]
  }
));
Gm.displayName = "MultiSelectorList";
const Q1 = cn(({ className: e, value: t, optionsLength: n, children: r, ...o }, a) => {
  const { value: i, onValueChange: s, setInputValue: l } = Ac(), c = Ve((f) => {
    f.preventDefault(), f.stopPropagation();
  }, []), d = i.includes(t);
  return /* @__PURE__ */ T(
    e3,
    {
      ref: a,
      ...o,
      onSelect: () => {
        s(t), l("");
      },
      className: P(
        "tw-rounded-md tw-cursor-pointer tw-py-12px tw-pl-8 tw-pr-2 tw-text-[16px] tw-transition-colors tw-flex tw-items-center",
        e,
        o.disabled && "tw-text-muted-foreground tw-cursor-not-allowed tw-opacity-50"
      ),
      onMouseDown: c,
      children: [
        (d || t === "select-all" && n === i.length) && /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(sa, { className: "tw-h-4 tw-w-4" }) }),
        r
      ]
    }
  );
});
Q1.displayName = "MultiSelectorItem";
const _te = (e) => {
  const [t, n] = ue((/* @__PURE__ */ new Date()).getTime());
  return /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-start tw-gap-0px", children: [
    /* @__PURE__ */ T(
      _O,
      {
        onValuesChange: (r) => {
          e.onChange != null && e.onChange(r);
        },
        values: e.values.map((r) => r.toString()),
        allOptions: e.options,
        autoFocus: !1,
        children: [
          /* @__PURE__ */ u(
            Fm,
            {
              className: P(
                "tw-w-[400px] tw-min-h-[56px] tw-max-h-[125px]",
                e.error && "tw-border-errorRed",
                e.selectButtonClassName
              ),
              options: e.options,
              allItemsText: e.allItemsText,
              icon: /* @__PURE__ */ u(b2, { asChild: !0, children: /* @__PURE__ */ u("div", { className: "tw-h-full tw-flex tw-items-center tw-gap-2", children: e.values.length > 0 && e.allowClear && !e.isDisabled ? /* @__PURE__ */ u(
                rt,
                {
                  className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label tw-cursor-pointer",
                  onPointerDown: (r) => {
                    r.stopPropagation(), e.onChange != null && e.onChange([]), e.onClear != null && e.onClear(), n(+(/* @__PURE__ */ new Date()).getTime());
                  }
                }
              ) : /* @__PURE__ */ u(la, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) }) }),
              showDiscreteBadgesForSelectAll: e.showDiscreteBadgesForSelectAll,
              children: /* @__PURE__ */ u(
                Hm,
                {
                  placeholder: e.values.length > 0 ? "" : e.placeholder,
                  disabled: e.isDisabled
                }
              )
            }
          ),
          /* @__PURE__ */ u(Bm, { className: P("tw-w-[400px] tw-z-[99999]", e.selectContentClassName), children: /* @__PURE__ */ T(Gm, { commandEmptyText: e.options.length === 0 ? e.noOptionText : e.emptyResultText, children: [
            e.showSelectAll && /* @__PURE__ */ u(Q1, { value: "select-all", optionsLength: e.options.length, children: e.selectAllText ?? "Select All" }, "select-all"),
            e.options.map((r) => /* @__PURE__ */ u(
              Q1,
              {
                value: r.value.toString(),
                optionsLength: e.options.length,
                children: r.label
              },
              r.value
            ))
          ] }) })
        ]
      },
      t
    ),
    e.error ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) : e.helperText && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: e.helperText })
  ] });
}, Ote = (e) => /* @__PURE__ */ u(B2, { open: e.open, modal: !1, children: /* @__PURE__ */ T(
  Ic,
  {
    className: P("tw-w-screen tw-h-screen tw-z-10001 tw-flex tw-flex-col tw-p-0 tw-gap-0", e.dialogClassName),
    children: [
      /* @__PURE__ */ T(
        "div",
        {
          className: P(
            "tw-px-32px tw-py-16px tw-flex tw-items-center tw-gap-[14px] tw-border-b tw-border-grayscale-border-dark",
            e.headerClassName
          ),
          children: [
            !e.hideCloseButton && /* @__PURE__ */ u(
              rt,
              {
                className: "tw-cursor-pointer",
                size: 24,
                onClick: () => {
                  e.onClose != null && e.onClose();
                }
              }
            ),
            e.headerContent ? e.headerContent : /* @__PURE__ */ u(De, { className: "tw-text-h5 tw-font-normal", variant: "h5", children: e.title })
          ]
        }
      ),
      /* @__PURE__ */ u("div", { className: P("tw-flex-1 tw-flex tw-flex-col", e.className), children: e.children })
    ]
  }
) }), Tte = (e) => /* @__PURE__ */ u("div", { className: P("tw-pb-32px tw-flex-1 tw-overflow-scroll", e.className), children: e.children }), Lte = (e) => /* @__PURE__ */ u("div", { className: P("tw-flex tw-justify-end tw-items-center tw-gap-16px", e.className), children: e.children }), Rte = (e) => /* @__PURE__ */ T(
  "div",
  {
    ...e,
    className: P(
      "tw-p-24px tw-shadow-illustration-card tw-flex tw-flex-col tw-justify-between tw-gap-24px tw-rounded-md",
      e.className
    ),
    children: [
      /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-gap-8px", children: [
        /* @__PURE__ */ u(
          GA,
          {
            checked: e.checked,
            label: e.title,
            labelClassName: "tw-text-grayscale-text-subtitle tw-font-semibold"
          }
        ),
        /* @__PURE__ */ u(De, { variant: "label", children: e.description })
      ] }),
      /* @__PURE__ */ u("div", { children: e.illustration })
    ]
  }
), Wm = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  "textarea",
  {
    className: P(
      "tw-flex tw-min-h-[80px] tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-normal tw-ring-offset-background placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
      e
    ),
    ref: n,
    ...t
  }
));
Wm.displayName = "Textarea";
const OO = "_root_adrja_1", TO = "_input_adrja_1", LO = "_hasError_adrja_5", ld = {
  root: OO,
  input: TO,
  hasError: LO
}, Vte = (e) => /* @__PURE__ */ T("div", { className: P("tw-flex tw-flex-col tw-items-start tw-gap-8px tw-w-[300px]", ld.root, e.className), children: [
  /* @__PURE__ */ u(
    Wm,
    {
      ...e,
      className: P(
        e.error && "tw-border-errorRed",
        ld.input,
        e.error && ld.hasError,
        e.inputClassName
      )
    }
  ),
  e.error ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) : e.helperText && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: e.helperText })
] });
var cd = "rovingFocusGroup.onEntryFocus", RO = { bubbles: !1, cancelable: !0 }, $i = "RovingFocusGroup", [ef, Zm, VO] = Vi($i), [kO, pa] = st(
  $i,
  [VO]
), [FO, HO] = kO($i), $m = b.forwardRef(
  (e, t) => /* @__PURE__ */ u(ef.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(ef.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u(BO, { ...e, ref: t }) }) })
);
$m.displayName = $i;
var BO = b.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, p = b.useRef(null), h = we(t, p), g = ra(a), [m, v] = vt({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: $i
  }), [w, C] = b.useState(!1), y = Ct(c), x = Zm(n), E = b.useRef(!1), [S, I] = b.useState(0);
  return b.useEffect(() => {
    const D = p.current;
    if (D)
      return D.addEventListener(cd, y), () => D.removeEventListener(cd, y);
  }, [y]), /* @__PURE__ */ u(
    FO,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: m,
      onItemFocus: b.useCallback(
        (D) => v(D),
        [v]
      ),
      onItemShiftTab: b.useCallback(() => C(!0), []),
      onFocusableItemAdd: b.useCallback(
        () => I((D) => D + 1),
        []
      ),
      onFocusableItemRemove: b.useCallback(
        () => I((D) => D - 1),
        []
      ),
      children: /* @__PURE__ */ u(
        ie.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: oe(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: oe(e.onFocus, (D) => {
            const N = !E.current;
            if (D.target === D.currentTarget && N && !w) {
              const A = new CustomEvent(cd, RO);
              if (D.currentTarget.dispatchEvent(A), !A.defaultPrevented) {
                const L = x().filter(($) => $.focusable), F = L.find(($) => $.active), k = L.find(($) => $.id === m), J = [F, k, ...L].filter(
                  Boolean
                ).map(($) => $.ref.current);
                zm(J, d);
              }
            }
            E.current = !1;
          }),
          onBlur: oe(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), Ym = "RovingFocusGroupItem", jm = b.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, l = Ue(), c = a || l, d = HO(Ym, n), f = d.currentTabStopId === c, p = Zm(n), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: m } = d;
    return b.useEffect(() => {
      if (r)
        return h(), () => g();
    }, [r, h, g]), /* @__PURE__ */ u(
      ef.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ u(
          ie.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...s,
            ref: t,
            onMouseDown: oe(e.onMouseDown, (v) => {
              r ? d.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: oe(e.onFocus, () => d.onItemFocus(c)),
            onKeyDown: oe(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget)
                return;
              const w = ZO(v, d.orientation, d.dir);
              if (w !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey)
                  return;
                v.preventDefault();
                let y = p().filter((x) => x.focusable).map((x) => x.ref.current);
                if (w === "last")
                  y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const x = y.indexOf(v.currentTarget);
                  y = d.loop ? $O(y, x + 1) : y.slice(x + 1);
                }
                setTimeout(() => zm(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
jm.displayName = Ym;
var GO = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function WO(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ZO(e, t, n) {
  const r = WO(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return GO[r];
}
function zm(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function $O(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var t3 = $m, n3 = jm, _c = "Tabs", [YO, kte] = st(_c, [
  pa
]), Xm = pa(), [jO, r3] = YO(_c), Um = b.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, d = ra(s), [f, p] = vt({
      prop: r,
      onChange: o,
      defaultProp: a ?? "",
      caller: _c
    });
    return /* @__PURE__ */ u(
      jO,
      {
        scope: n,
        baseId: Ue(),
        value: f,
        onValueChange: p,
        orientation: i,
        dir: d,
        activationMode: l,
        children: /* @__PURE__ */ u(
          ie.div,
          {
            dir: d,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
Um.displayName = _c;
var Jm = "TabsList", Km = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, a = r3(Jm, n), i = Xm(n);
    return /* @__PURE__ */ u(
      t3,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ u(
          ie.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
Km.displayName = Jm;
var qm = "TabsTrigger", Qm = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...a } = e, i = r3(qm, n), s = Xm(n), l = nv(i.baseId, r), c = rv(i.baseId, r), d = r === i.value;
    return /* @__PURE__ */ u(
      n3,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ u(
          ie.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": c,
            "data-state": d ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...a,
            ref: t,
            onMouseDown: oe(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: oe(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(r);
            }),
            onFocus: oe(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !d && !o && f && i.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Qm.displayName = qm;
var ev = "TabsContent", tv = b.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: a, ...i } = e, s = r3(ev, n), l = nv(s.baseId, r), c = rv(s.baseId, r), d = r === s.value, f = b.useRef(d);
    return b.useEffect(() => {
      const p = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ u(ut, { present: o || d, children: ({ present: p }) => /* @__PURE__ */ u(
      ie.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !p,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: p && a
      }
    ) });
  }
);
tv.displayName = ev;
function nv(e, t) {
  return `${e}-trigger-${t}`;
}
function rv(e, t) {
  return `${e}-content-${t}`;
}
var zO = Um, ov = Km, av = Qm, iv = tv;
const Fte = zO, XO = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  ov,
  {
    ref: n,
    className: P(
      "tw-inline-flex tw-h-10 tw-items-center tw-gap-1 tw-justify-center tw-rounded-md tw-bg-grayscale-surface-subtle tw-p-1 tw-text-grayscale-text-disabled",
      e
    ),
    ...t
  }
));
XO.displayName = ov.displayName;
const UO = b.forwardRef(({ className: e, headerTab: t, ...n }, r) => /* @__PURE__ */ u(
  av,
  {
    ref: r,
    className: P(
      "tw-inline-flex tw-items-center tw-min-w-[138px]  tw-justify-center tw-whitespace-nowrap tw-px-3 tw-py-[6px] tw-text-sm tw-font-medium  tw-transition-all focus-visible:tw-outline-none  disabled:tw-pointer-events-none disabled:tw-opacity-50",
      t ? "data-[state=active]:tw-shadow-none  !tw-text-grayscale-text-body tw-border-b-2 data-[state=active]:tw-border-brand-border tw-border-white data-[state=active]:tw-bg-white tw-bg-white" : "data-[state=active]:tw-bg-grayscale-surface-bg data-[state=active]:tw-text-grayscale-text-body tw-rounded-sm  data-[state=active]:tw-shadow-sm tw-bg-grayscale-surface-light",
      e
    ),
    ...n
  }
));
UO.displayName = av.displayName;
const JO = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  iv,
  {
    ref: n,
    className: P(
      "tw-mt-2 tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2",
      e
    ),
    ...t
  }
));
JO.displayName = iv.displayName;
const KO = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { className: "tw-relative tw-w-full tw-overflow-auto", children: /* @__PURE__ */ u("table", { ref: n, className: P("tw-w-full tw-caption-bottom tw-text-sm", e), ...t }) })
);
KO.displayName = "Table";
const qO = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("thead", { ref: n, className: P("[&_tr]:tw-border-b", e), ...t })
);
qO.displayName = "TableHeader";
const QO = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("tbody", { ref: n, className: P("[&_tr:last-child]:tw-border-0", e), ...t })
);
QO.displayName = "TableBody";
const eT = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "tfoot",
    {
      ref: n,
      className: P("tw-border-t tw-bg-muted/50 tw-font-medium [&>tr]:last:tw-border-b-0", e),
      ...t
    }
  )
);
eT.displayName = "TableFooter";
const tT = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "tr",
    {
      ref: n,
      className: P(
        "tw-border-b tw-transition-colors hover:tw-bg-muted/50 data-[state=selected]:tw-bg-muted tw-text-title-main",
        e
      ),
      ...t
    }
  )
);
tT.displayName = "TableRow";
const nT = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "th",
    {
      ref: n,
      className: P(
        "tw-h-12 tw-px-4 tw-text-left tw-align-middle tw-font-medium tw-text-muted-foreground [&:has([role=checkbox])]:tw-pr-0",
        e
      ),
      ...t
    }
  )
);
nT.displayName = "TableHead";
const rT = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("td", { ref: n, className: P("tw-p-4 tw-align-middle [&:has([role=checkbox])]:tw-pr-0", e), ...t })
);
rT.displayName = "TableCell";
const oT = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("caption", { ref: n, className: P("tw-mt-4 tw-text-sm tw-text-muted-foreground", e), ...t })
);
oT.displayName = "TableCaption";
var tf = ["Enter", " "], aT = ["ArrowDown", "PageUp", "Home"], sv = ["ArrowUp", "PageDown", "End"], iT = [...aT, ...sv], sT = {
  ltr: [...tf, "ArrowRight"],
  rtl: [...tf, "ArrowLeft"]
}, lT = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Yi = "Menu", [pi, cT, uT] = Vi(Yi), [io, lv] = st(Yi, [
  uT,
  xr,
  pa
]), ji = xr(), cv = pa(), [uv, Sr] = io(Yi), [dT, zi] = io(Yi), dv = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = ji(t), [l, c] = b.useState(null), d = b.useRef(!1), f = Ct(a), p = ra(o);
  return b.useEffect(() => {
    const h = () => {
      d.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => d.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ u(Hi, { ...s, children: /* @__PURE__ */ u(
    uv,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ u(
        dT,
        {
          scope: t,
          onClose: b.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: p,
          modal: i,
          children: r
        }
      )
    }
  ) });
};
dv.displayName = Yi;
var fT = "MenuAnchor", o3 = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = ji(n);
    return /* @__PURE__ */ u(Bi, { ...o, ...r, ref: t });
  }
);
o3.displayName = fT;
var a3 = "MenuPortal", [pT, fv] = io(a3, {
  forceMount: void 0
}), pv = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Sr(a3, t);
  return /* @__PURE__ */ u(pT, { scope: t, forceMount: n, children: /* @__PURE__ */ u(ut, { present: n || a.open, children: /* @__PURE__ */ u(ro, { asChild: !0, container: o, children: r }) }) });
};
pv.displayName = a3;
var jt = "MenuContent", [hT, i3] = io(jt), hv = b.forwardRef(
  (e, t) => {
    const n = fv(jt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Sr(jt, e.__scopeMenu), i = zi(jt, e.__scopeMenu);
    return /* @__PURE__ */ u(pi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(ut, { present: r || a.open, children: /* @__PURE__ */ u(pi.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ u(mT, { ...o, ref: t }) : /* @__PURE__ */ u(vT, { ...o, ref: t }) }) }) });
  }
), mT = b.forwardRef(
  (e, t) => {
    const n = Sr(jt, e.__scopeMenu), r = b.useRef(null), o = we(t, r);
    return b.useEffect(() => {
      const a = r.current;
      if (a)
        return ic(a);
    }, []), /* @__PURE__ */ u(
      s3,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: oe(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), vT = b.forwardRef((e, t) => {
  const n = Sr(jt, e.__scopeMenu);
  return /* @__PURE__ */ u(
    s3,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), gT = /* @__PURE__ */ mr("MenuContent.ScrollLock"), s3 = b.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: p,
      onDismiss: h,
      disableOutsideScroll: g,
      ...m
    } = e, v = Sr(jt, n), w = zi(jt, n), C = ji(n), y = cv(n), x = cT(n), [E, S] = b.useState(null), I = b.useRef(null), D = we(t, I, v.onContentChange), N = b.useRef(0), A = b.useRef(""), L = b.useRef(0), F = b.useRef(null), k = b.useRef("right"), G = b.useRef(0), J = g ? lc : b.Fragment, $ = g ? { as: gT, allowPinchZoom: !0 } : void 0, H = (j) => {
      var W, Q;
      const B = A.current + j, Z = x().filter((te) => !te.disabled), O = document.activeElement, Y = (W = Z.find((te) => te.ref.current === O)) == null ? void 0 : W.textValue, U = Z.map((te) => te.textValue), K = PT(U, B, Y), q = (Q = Z.find((te) => te.textValue === K)) == null ? void 0 : Q.ref.current;
      (function te(re) {
        A.current = re, window.clearTimeout(N.current), re !== "" && (N.current = window.setTimeout(() => te(""), 1e3));
      })(B), q && setTimeout(() => q.focus());
    };
    b.useEffect(() => () => window.clearTimeout(N.current), []), Kl();
    const V = b.useCallback((j) => {
      var Z, O;
      return k.current === ((Z = F.current) == null ? void 0 : Z.side) && _T(j, (O = F.current) == null ? void 0 : O.area);
    }, []);
    return /* @__PURE__ */ u(
      hT,
      {
        scope: n,
        searchRef: A,
        onItemEnter: b.useCallback(
          (j) => {
            V(j) && j.preventDefault();
          },
          [V]
        ),
        onItemLeave: b.useCallback(
          (j) => {
            var B;
            V(j) || ((B = I.current) == null || B.focus(), S(null));
          },
          [V]
        ),
        onTriggerLeave: b.useCallback(
          (j) => {
            V(j) && j.preventDefault();
          },
          [V]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: b.useCallback((j) => {
          F.current = j;
        }, []),
        children: /* @__PURE__ */ u(J, { ...$, children: /* @__PURE__ */ u(
          ki,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: oe(a, (j) => {
              var B;
              j.preventDefault(), (B = I.current) == null || B.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ u(
              no,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: p,
                onDismiss: h,
                children: /* @__PURE__ */ u(
                  t3,
                  {
                    asChild: !0,
                    ...y,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: E,
                    onCurrentTabStopIdChange: S,
                    onEntryFocus: oe(l, (j) => {
                      w.isUsingKeyboardRef.current || j.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ u(
                      nc,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": _v(v.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...C,
                        ...m,
                        ref: D,
                        style: { outline: "none", ...m.style },
                        onKeyDown: oe(m.onKeyDown, (j) => {
                          const Z = j.target.closest("[data-radix-menu-content]") === j.currentTarget, O = j.ctrlKey || j.altKey || j.metaKey, Y = j.key.length === 1;
                          Z && (j.key === "Tab" && j.preventDefault(), !O && Y && H(j.key));
                          const U = I.current;
                          if (j.target !== U || !iT.includes(j.key))
                            return;
                          j.preventDefault();
                          const q = x().filter((W) => !W.disabled).map((W) => W.ref.current);
                          sv.includes(j.key) && q.reverse(), MT(q);
                        }),
                        onBlur: oe(e.onBlur, (j) => {
                          j.currentTarget.contains(j.target) || (window.clearTimeout(N.current), A.current = "");
                        }),
                        onPointerMove: oe(
                          e.onPointerMove,
                          hi((j) => {
                            const B = j.target, Z = G.current !== j.clientX;
                            if (j.currentTarget.contains(B) && Z) {
                              const O = j.clientX > G.current ? "right" : "left";
                              k.current = O, G.current = j.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
hv.displayName = jt;
var wT = "MenuGroup", l3 = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(ie.div, { role: "group", ...r, ref: t });
  }
);
l3.displayName = wT;
var bT = "MenuLabel", mv = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(ie.div, { ...r, ref: t });
  }
);
mv.displayName = bT;
var Nl = "MenuItem", H4 = "menu.itemSelect", Oc = b.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = b.useRef(null), i = zi(Nl, e.__scopeMenu), s = i3(Nl, e.__scopeMenu), l = we(t, a), c = b.useRef(!1), d = () => {
      const f = a.current;
      if (!n && f) {
        const p = new CustomEvent(H4, { bubbles: !0, cancelable: !0 });
        f.addEventListener(H4, (h) => r == null ? void 0 : r(h), { once: !0 }), a2(f, p), p.defaultPrevented ? c.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ u(
      vv,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: oe(e.onClick, d),
        onPointerDown: (f) => {
          var p;
          (p = e.onPointerDown) == null || p.call(e, f), c.current = !0;
        },
        onPointerUp: oe(e.onPointerUp, (f) => {
          var p;
          c.current || (p = f.currentTarget) == null || p.click();
        }),
        onKeyDown: oe(e.onKeyDown, (f) => {
          const p = s.searchRef.current !== "";
          n || p && f.key === " " || tf.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Oc.displayName = Nl;
var vv = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, i = i3(Nl, n), s = cv(n), l = b.useRef(null), c = we(t, l), [d, f] = b.useState(!1), [p, h] = b.useState("");
    return b.useEffect(() => {
      const g = l.current;
      g && h((g.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ u(
      pi.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? p,
        children: /* @__PURE__ */ u(n3, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ u(
          ie.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: c,
            onPointerMove: oe(
              e.onPointerMove,
              hi((g) => {
                r ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: oe(
              e.onPointerLeave,
              hi((g) => i.onItemLeave(g))
            ),
            onFocus: oe(e.onFocus, () => f(!0)),
            onBlur: oe(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), CT = "MenuCheckboxItem", gv = b.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ u(xv, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ u(
      Oc,
      {
        role: "menuitemcheckbox",
        "aria-checked": Pl(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": d3(n),
        onSelect: oe(
          o.onSelect,
          () => r == null ? void 0 : r(Pl(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
gv.displayName = CT;
var wv = "MenuRadioGroup", [yT, xT] = io(
  wv,
  { value: void 0, onValueChange: () => {
  } }
), bv = b.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = Ct(r);
    return /* @__PURE__ */ u(yT, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ u(l3, { ...o, ref: t }) });
  }
);
bv.displayName = wv;
var Cv = "MenuRadioItem", yv = b.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = xT(Cv, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ u(xv, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ u(
      Oc,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": d3(a),
        onSelect: oe(
          r.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
yv.displayName = Cv;
var c3 = "MenuItemIndicator", [xv, ET] = io(
  c3,
  { checked: !1 }
), Ev = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = ET(c3, n);
    return /* @__PURE__ */ u(
      ut,
      {
        present: r || Pl(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u(
          ie.span,
          {
            ...o,
            ref: t,
            "data-state": d3(a.checked)
          }
        )
      }
    );
  }
);
Ev.displayName = c3;
var IT = "MenuSeparator", Iv = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ u(
      ie.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Iv.displayName = IT;
var ST = "MenuArrow", Sv = b.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = ji(n);
    return /* @__PURE__ */ u(rc, { ...o, ...r, ref: t });
  }
);
Sv.displayName = ST;
var u3 = "MenuSub", [DT, Dv] = io(u3), Mv = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Sr(u3, t), i = ji(t), [s, l] = b.useState(null), [c, d] = b.useState(null), f = Ct(o);
  return b.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ u(Hi, { ...i, children: /* @__PURE__ */ u(
    uv,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: c,
      onContentChange: d,
      children: /* @__PURE__ */ u(
        DT,
        {
          scope: t,
          contentId: Ue(),
          triggerId: Ue(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Mv.displayName = u3;
var Xa = "MenuSubTrigger", Nv = b.forwardRef(
  (e, t) => {
    const n = Sr(Xa, e.__scopeMenu), r = zi(Xa, e.__scopeMenu), o = Dv(Xa, e.__scopeMenu), a = i3(Xa, e.__scopeMenu), i = b.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, c = { __scopeMenu: e.__scopeMenu }, d = b.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return b.useEffect(() => d, [d]), b.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [s, l]), /* @__PURE__ */ u(o3, { asChild: !0, ...c, children: /* @__PURE__ */ u(
      vv,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": _v(n.open),
        ...e,
        ref: jn(t, o.onTriggerChange),
        onClick: (f) => {
          var p;
          (p = e.onClick) == null || p.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: oe(
          e.onPointerMove,
          hi((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: oe(
          e.onPointerLeave,
          hi((f) => {
            var h, g;
            d();
            const p = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (p) {
              const m = (g = n.content) == null ? void 0 : g.dataset.side, v = m === "right", w = v ? -5 : 5, C = p[v ? "left" : "right"], y = p[v ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + w, y: f.clientY },
                  { x: C, y: p.top },
                  { x: y, y: p.top },
                  { x: y, y: p.bottom },
                  { x: C, y: p.bottom }
                ],
                side: m
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented)
                return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: oe(e.onKeyDown, (f) => {
          var h;
          const p = a.searchRef.current !== "";
          e.disabled || p && f.key === " " || sT[r.dir].includes(f.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Nv.displayName = Xa;
var Pv = "MenuSubContent", Av = b.forwardRef(
  (e, t) => {
    const n = fv(jt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Sr(jt, e.__scopeMenu), i = zi(jt, e.__scopeMenu), s = Dv(Pv, e.__scopeMenu), l = b.useRef(null), c = we(t, l);
    return /* @__PURE__ */ u(pi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(ut, { present: r || a.open, children: /* @__PURE__ */ u(pi.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ u(
      s3,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: oe(e.onFocusOutside, (d) => {
          d.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: oe(e.onEscapeKeyDown, (d) => {
          i.onClose(), d.preventDefault();
        }),
        onKeyDown: oe(e.onKeyDown, (d) => {
          var h;
          const f = d.currentTarget.contains(d.target), p = lT[i.dir].includes(d.key);
          f && p && (a.onOpenChange(!1), (h = s.trigger) == null || h.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
Av.displayName = Pv;
function _v(e) {
  return e ? "open" : "closed";
}
function Pl(e) {
  return e === "indeterminate";
}
function d3(e) {
  return Pl(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function MT(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function NT(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function PT(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = NT(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((c) => c !== n));
  const l = i.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function AT(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], l = t[i], c = s.x, d = s.y, f = l.x, p = l.y;
    d > r != p > r && n < (f - c) * (r - d) / (p - d) + c && (o = !o);
  }
  return o;
}
function _T(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return AT(n, t);
}
function hi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var OT = dv, TT = o3, LT = pv, RT = hv, VT = l3, kT = mv, FT = Oc, HT = gv, BT = bv, GT = yv, WT = Ev, ZT = Iv, $T = Sv, YT = Mv, jT = Nv, zT = Av, Tc = "DropdownMenu", [XT, Hte] = st(
  Tc,
  [lv]
), gt = lv(), [UT, Ov] = XT(Tc), Tv = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, l = gt(t), c = b.useRef(null), [d, f] = vt({
    prop: o,
    defaultProp: a ?? !1,
    onChange: i,
    caller: Tc
  });
  return /* @__PURE__ */ u(
    UT,
    {
      scope: t,
      triggerId: Ue(),
      triggerRef: c,
      contentId: Ue(),
      open: d,
      onOpenChange: f,
      onOpenToggle: b.useCallback(() => f((p) => !p), [f]),
      modal: s,
      children: /* @__PURE__ */ u(OT, { ...l, open: d, onOpenChange: f, dir: r, modal: s, children: n })
    }
  );
};
Tv.displayName = Tc;
var Lv = "DropdownMenuTrigger", Rv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Ov(Lv, n), i = gt(n);
    return /* @__PURE__ */ u(TT, { asChild: !0, ...i, children: /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: jn(t, a.triggerRef),
        onPointerDown: oe(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: oe(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Rv.displayName = Lv;
var JT = "DropdownMenuPortal", Vv = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = gt(t);
  return /* @__PURE__ */ u(LT, { ...r, ...n });
};
Vv.displayName = JT;
var kv = "DropdownMenuContent", Fv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ov(kv, n), a = gt(n), i = b.useRef(!1);
    return /* @__PURE__ */ u(
      RT,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: oe(e.onCloseAutoFocus, (s) => {
          var l;
          i.current || (l = o.triggerRef.current) == null || l.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: oe(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || c;
          (!o.modal || d) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Fv.displayName = kv;
var KT = "DropdownMenuGroup", Hv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
    return /* @__PURE__ */ u(VT, { ...o, ...r, ref: t });
  }
);
Hv.displayName = KT;
var qT = "DropdownMenuLabel", Bv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
    return /* @__PURE__ */ u(kT, { ...o, ...r, ref: t });
  }
);
Bv.displayName = qT;
var QT = "DropdownMenuItem", Gv = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
    return /* @__PURE__ */ u(FT, { ...o, ...r, ref: t });
  }
);
Gv.displayName = QT;
var eL = "DropdownMenuCheckboxItem", Wv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(HT, { ...o, ...r, ref: t });
});
Wv.displayName = eL;
var tL = "DropdownMenuRadioGroup", Zv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(BT, { ...o, ...r, ref: t });
});
Zv.displayName = tL;
var nL = "DropdownMenuRadioItem", $v = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(GT, { ...o, ...r, ref: t });
});
$v.displayName = nL;
var rL = "DropdownMenuItemIndicator", Yv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(WT, { ...o, ...r, ref: t });
});
Yv.displayName = rL;
var oL = "DropdownMenuSeparator", jv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(ZT, { ...o, ...r, ref: t });
});
jv.displayName = oL;
var aL = "DropdownMenuArrow", iL = b.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
    return /* @__PURE__ */ u($T, { ...o, ...r, ref: t });
  }
);
iL.displayName = aL;
var sL = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, i = gt(t), [s, l] = vt({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ u(YT, { ...i, open: s, onOpenChange: l, children: n });
}, lL = "DropdownMenuSubTrigger", zv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(jT, { ...o, ...r, ref: t });
});
zv.displayName = lL;
var cL = "DropdownMenuSubContent", Xv = b.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = gt(n);
  return /* @__PURE__ */ u(
    zT,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Xv.displayName = cL;
var Uv = Tv, Jv = Rv, f3 = Vv, Lc = Fv, uL = Hv, Rc = Bv, Vc = Gv, kc = Wv, dL = Zv, Fc = $v, Hc = Yv, Bc = jv, fL = sL, Gc = zv, Wc = Xv;
const Bte = Uv, Gte = Jv, Wte = uL, Zte = f3, $te = fL, Yte = dL, pL = b.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ T(
  Gc,
  {
    ref: o,
    className: P(
      "tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none focus:tw-bg-accent data-[state=open]:tw-bg-accent",
      t && "tw-pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ u(hc, { className: "tw-ml-auto tw-h-4 tw-w-4" })
    ]
  }
));
pL.displayName = Gc.displayName;
const hL = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Wc,
  {
    ref: n,
    className: P(
      "tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-p-1 tw-text-popover-foreground tw-shadow-lg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
hL.displayName = Wc.displayName;
const mL = b.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ u(f3, { children: /* @__PURE__ */ u(
  Lc,
  {
    ref: r,
    sideOffset: t,
    className: P(
      "tw-z-50 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-p-1 tw-text-popover-foreground tw-shadow-md data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
mL.displayName = Lc.displayName;
const vL = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ u(
  Vc,
  {
    ref: r,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50 hover:!tw-bg-gray-50",
      t && "tw-pl-8",
      e
    ),
    ...n
  }
));
vL.displayName = Vc.displayName;
const gL = b.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ T(
  kc,
  {
    ref: o,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(Hc, { children: /* @__PURE__ */ u(sa, { className: "tw-h-4 tw-w-4" }) }) }),
      t
    ]
  }
));
gL.displayName = kc.displayName;
const wL = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ T(
  Fc,
  {
    ref: r,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(Hc, { children: /* @__PURE__ */ u(v2, { className: "tw-h-2 tw-w-2 tw-fill-current" }) }) }),
      t
    ]
  }
));
wL.displayName = Fc.displayName;
const bL = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ u(
  Rc,
  {
    ref: r,
    className: P("tw-px-2 tw-py-1.5 tw-text-sm tw-font-semibold", t && "tw-pl-8", e),
    ...n
  }
));
bL.displayName = Rc.displayName;
const CL = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Bc,
  {
    ref: n,
    className: P("tw--mx-1 tw-my-1 tw-h-px tw-bg-muted", e),
    ...t
  }
));
CL.displayName = Bc.displayName;
const yL = ({ className: e, ...t }) => /* @__PURE__ */ u("span", { className: P("tw-ml-auto tw-text-xs tw-tracking-widest tw-opacity-60", e), ...t });
yL.displayName = "DropdownMenuShortcut";
const xL = Xt(
  "tw-inline-flex tw-items-center !tw-text-sm !tw-leading-4 tw-rounded-full tw-border tw-px-3 tw-py-1 tw-font-semibold tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2",
  {
    variants: {
      variant: {
        default: "tw-border-transparent tw-bg-gray-700 tw-text-gray-50 hover:bg-gray-700",
        secondary: "tw-border-transparent tw-bg-gray-100 tw-text-secondary-foreground hover:bg-gray-100",
        destructive: "tw-border-transparent tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive",
        outline: "tw-text-foreground !tw-border-gray-200",
        warning: "tw-text-badge-text-warning tw-bg-badge-background-warning tw-border-transparent",
        error: "tw-text-badge-text-error tw-bg-badge-background-error tw-border-transparent",
        success: "tw-text-badge-text-success tw-bg-badge-background-success tw-border-transparent",
        info: "tw-text-badge-text-info tw-bg-badge-background-info tw-border-transparent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function jte({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ u("div", { className: P(xL({ variant: t }), e), ...n });
}
function zte({ className: e, ...t }) {
  return /* @__PURE__ */ u("div", { className: P("tw-animate-pulse tw-rounded-md tw-bg-grayscale-surface-default", e), ...t });
}
var nf = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ud, B4;
function Kv() {
  if (B4)
    return ud;
  B4 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(d) {
        return i[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ud = o() ? Object.assign : function(a, i) {
    for (var s, l = r(a), c, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        c = e(s);
        for (var p = 0; p < c.length; p++)
          n.call(s, c[p]) && (l[c[p]] = s[c[p]]);
      }
    }
    return l;
  }, ud;
}
var dd, G4;
function p3() {
  if (G4)
    return dd;
  G4 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return dd = e, dd;
}
var fd, W4;
function qv() {
  return W4 || (W4 = 1, fd = Function.call.bind(Object.prototype.hasOwnProperty)), fd;
}
var pd, Z4;
function EL() {
  if (Z4)
    return pd;
  Z4 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = p3(), n = {}, r = qv();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = a[d](i, d, l, s, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = c ? c() : "";
            e(
              "Failed " + s + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, pd = o, pd;
}
var hd, $4;
function IL() {
  if ($4)
    return hd;
  $4 = 1;
  var e = E2, t = Kv(), n = p3(), r = qv(), o = EL(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return hd = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(B) {
      var Z = B && (c && B[c] || B[d]);
      if (typeof Z == "function")
        return Z;
    }
    var p = "<<anonymous>>", h = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: C(),
      arrayOf: y,
      element: x(),
      elementType: E(),
      instanceOf: S,
      node: A(),
      objectOf: D,
      oneOf: I,
      oneOfType: N,
      shape: F,
      exact: k
    };
    function g(B, Z) {
      return B === Z ? B !== 0 || 1 / B === 1 / Z : B !== B && Z !== Z;
    }
    function m(B, Z) {
      this.message = B, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(B) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, O = 0;
      function Y(K, q, W, Q, te, re, z) {
        if (Q = Q || p, re = re || W, z !== n) {
          if (l) {
            var R = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw R.name = "Invariant Violation", R;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = Q + ":" + W;
            !Z[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            O < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + Q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[ce] = !0, O++);
          }
        }
        return q[W] == null ? K ? q[W] === null ? new m("The " + te + " `" + re + "` is marked as required " + ("in `" + Q + "`, but its value is `null`.")) : new m("The " + te + " `" + re + "` is marked as required in " + ("`" + Q + "`, but its value is `undefined`.")) : null : B(q, W, Q, te, re);
      }
      var U = Y.bind(null, !1);
      return U.isRequired = Y.bind(null, !0), U;
    }
    function w(B) {
      function Z(O, Y, U, K, q, W) {
        var Q = O[Y], te = $(Q);
        if (te !== B) {
          var re = H(Q);
          return new m(
            "Invalid " + K + " `" + q + "` of type " + ("`" + re + "` supplied to `" + U + "`, expected ") + ("`" + B + "`."),
            { expectedType: B }
          );
        }
        return null;
      }
      return v(Z);
    }
    function C() {
      return v(i);
    }
    function y(B) {
      function Z(O, Y, U, K, q) {
        if (typeof B != "function")
          return new m("Property `" + q + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var W = O[Y];
        if (!Array.isArray(W)) {
          var Q = $(W);
          return new m("Invalid " + K + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + U + "`, expected an array."));
        }
        for (var te = 0; te < W.length; te++) {
          var re = B(W, te, U, K, q + "[" + te + "]", n);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return v(Z);
    }
    function x() {
      function B(Z, O, Y, U, K) {
        var q = Z[O];
        if (!s(q)) {
          var W = $(q);
          return new m("Invalid " + U + " `" + K + "` of type " + ("`" + W + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(B);
    }
    function E() {
      function B(Z, O, Y, U, K) {
        var q = Z[O];
        if (!e.isValidElementType(q)) {
          var W = $(q);
          return new m("Invalid " + U + " `" + K + "` of type " + ("`" + W + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(B);
    }
    function S(B) {
      function Z(O, Y, U, K, q) {
        if (!(O[Y] instanceof B)) {
          var W = B.name || p, Q = j(O[Y]);
          return new m("Invalid " + K + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + U + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return v(Z);
    }
    function I(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function Z(O, Y, U, K, q) {
        for (var W = O[Y], Q = 0; Q < B.length; Q++)
          if (g(W, B[Q]))
            return null;
        var te = JSON.stringify(B, function(z, R) {
          var ce = H(R);
          return ce === "symbol" ? String(R) : R;
        });
        return new m("Invalid " + K + " `" + q + "` of value `" + String(W) + "` " + ("supplied to `" + U + "`, expected one of " + te + "."));
      }
      return v(Z);
    }
    function D(B) {
      function Z(O, Y, U, K, q) {
        if (typeof B != "function")
          return new m("Property `" + q + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var W = O[Y], Q = $(W);
        if (Q !== "object")
          return new m("Invalid " + K + " `" + q + "` of type " + ("`" + Q + "` supplied to `" + U + "`, expected an object."));
        for (var te in W)
          if (r(W, te)) {
            var re = B(W, te, U, K, q + "." + te, n);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return v(Z);
    }
    function N(B) {
      if (!Array.isArray(B))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var Z = 0; Z < B.length; Z++) {
        var O = B[Z];
        if (typeof O != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(O) + " at index " + Z + "."
          ), i;
      }
      function Y(U, K, q, W, Q) {
        for (var te = [], re = 0; re < B.length; re++) {
          var z = B[re], R = z(U, K, q, W, Q, n);
          if (R == null)
            return null;
          R.data && r(R.data, "expectedType") && te.push(R.data.expectedType);
        }
        var ce = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new m("Invalid " + W + " `" + Q + "` supplied to " + ("`" + q + "`" + ce + "."));
      }
      return v(Y);
    }
    function A() {
      function B(Z, O, Y, U, K) {
        return G(Z[O]) ? null : new m("Invalid " + U + " `" + K + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return v(B);
    }
    function L(B, Z, O, Y, U) {
      return new m(
        (B || "React class") + ": " + Z + " type `" + O + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function F(B) {
      function Z(O, Y, U, K, q) {
        var W = O[Y], Q = $(W);
        if (Q !== "object")
          return new m("Invalid " + K + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var te in B) {
          var re = B[te];
          if (typeof re != "function")
            return L(U, K, q, te, H(re));
          var z = re(W, te, U, K, q + "." + te, n);
          if (z)
            return z;
        }
        return null;
      }
      return v(Z);
    }
    function k(B) {
      function Z(O, Y, U, K, q) {
        var W = O[Y], Q = $(W);
        if (Q !== "object")
          return new m("Invalid " + K + " `" + q + "` of type `" + Q + "` " + ("supplied to `" + U + "`, expected `object`."));
        var te = t({}, O[Y], B);
        for (var re in te) {
          var z = B[re];
          if (r(B, re) && typeof z != "function")
            return L(U, K, q, re, H(z));
          if (!z)
            return new m(
              "Invalid " + K + " `" + q + "` key `" + re + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(O[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(B), null, "  ")
            );
          var R = z(W, re, U, K, q + "." + re, n);
          if (R)
            return R;
        }
        return null;
      }
      return v(Z);
    }
    function G(B) {
      switch (typeof B) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !B;
        case "object":
          if (Array.isArray(B))
            return B.every(G);
          if (B === null || s(B))
            return !0;
          var Z = f(B);
          if (Z) {
            var O = Z.call(B), Y;
            if (Z !== B.entries) {
              for (; !(Y = O.next()).done; )
                if (!G(Y.value))
                  return !1;
            } else
              for (; !(Y = O.next()).done; ) {
                var U = Y.value;
                if (U && !G(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function J(B, Z) {
      return B === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function $(B) {
      var Z = typeof B;
      return Array.isArray(B) ? "array" : B instanceof RegExp ? "object" : J(Z, B) ? "symbol" : Z;
    }
    function H(B) {
      if (typeof B > "u" || B === null)
        return "" + B;
      var Z = $(B);
      if (Z === "object") {
        if (B instanceof Date)
          return "date";
        if (B instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function V(B) {
      var Z = H(B);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function j(B) {
      return !B.constructor || !B.constructor.name ? p : B.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, hd;
}
var md, Y4;
function SL() {
  if (Y4)
    return md;
  Y4 = 1;
  var e = p3();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, md = function() {
    function r(i, s, l, c, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, md;
}
if (process.env.NODE_ENV !== "production") {
  var DL = E2, ML = !0;
  nf.exports = IL()(DL.isElement, ML);
} else
  nf.exports = SL()();
var NL = nf.exports;
const M = /* @__PURE__ */ ua(NL);
var Qv = { exports: {} }, PL = Qv.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
typeof __g == "number" && (__g = PL);
var so = Qv.exports, eg = { exports: {} }, AL = eg.exports = { version: "2.6.12" };
typeof __e == "number" && (__e = AL);
var Dr = eg.exports, _L = function(e) {
  if (typeof e != "function")
    throw TypeError(e + " is not a function!");
  return e;
}, OL = _L, tg = function(e, t, n) {
  if (OL(e), t === void 0)
    return e;
  switch (n) {
    case 1:
      return function(r) {
        return e.call(t, r);
      };
    case 2:
      return function(r, o) {
        return e.call(t, r, o);
      };
    case 3:
      return function(r, o, a) {
        return e.call(t, r, o, a);
      };
  }
  return function() {
    return e.apply(t, arguments);
  };
}, Mr = {}, ha = function(e) {
  return typeof e == "object" ? e !== null : typeof e == "function";
}, TL = ha, Xi = function(e) {
  if (!TL(e))
    throw TypeError(e + " is not an object!");
  return e;
}, Ui = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, Nr = !Ui(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), vd, j4;
function ng() {
  if (j4)
    return vd;
  j4 = 1;
  var e = ha, t = so.document, n = e(t) && e(t.createElement);
  return vd = function(r) {
    return n ? t.createElement(r) : {};
  }, vd;
}
var rg = !Nr && !Ui(function() {
  return Object.defineProperty(ng()("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), Ns = ha, h3 = function(e, t) {
  if (!Ns(e))
    return e;
  var n, r;
  if (t && typeof (n = e.toString) == "function" && !Ns(r = n.call(e)) || typeof (n = e.valueOf) == "function" && !Ns(r = n.call(e)) || !t && typeof (n = e.toString) == "function" && !Ns(r = n.call(e)))
    return r;
  throw TypeError("Can't convert object to primitive value");
}, z4 = Xi, LL = rg, RL = h3, VL = Object.defineProperty;
Mr.f = Nr ? Object.defineProperty : function(t, n, r) {
  if (z4(t), n = RL(n, !0), z4(r), LL)
    try {
      return VL(t, n, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw TypeError("Accessors not supported!");
  return "value" in r && (t[n] = r.value), t;
};
var Zc = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, kL = Mr, FL = Zc, ma = Nr ? function(e, t, n) {
  return kL.f(e, t, FL(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, HL = {}.hasOwnProperty, lo = function(e, t) {
  return HL.call(e, t);
}, Ps = so, gd = Dr, X4 = tg, BL = ma, GL = lo, As = "prototype", pt = function(e, t, n) {
  var r = e & pt.F, o = e & pt.G, a = e & pt.S, i = e & pt.P, s = e & pt.B, l = e & pt.W, c = o ? gd : gd[t] || (gd[t] = {}), d = c[As], f = o ? Ps : a ? Ps[t] : (Ps[t] || {})[As], p, h, g;
  o && (n = t);
  for (p in n)
    h = !r && f && f[p] !== void 0, !(h && GL(c, p)) && (g = h ? f[p] : n[p], c[p] = o && typeof f[p] != "function" ? n[p] : s && h ? X4(g, Ps) : l && f[p] == g ? function(m) {
      var v = function(w, C, y) {
        if (this instanceof m) {
          switch (arguments.length) {
            case 0:
              return new m();
            case 1:
              return new m(w);
            case 2:
              return new m(w, C);
          }
          return new m(w, C, y);
        }
        return m.apply(this, arguments);
      };
      return v[As] = m[As], v;
    }(g) : i && typeof g == "function" ? X4(Function.call, g) : g, i && ((c.virtual || (c.virtual = {}))[p] = g, e & pt.R && d && !d[p] && BL(d, p, g)));
};
pt.F = 1;
pt.G = 2;
pt.S = 4;
pt.P = 8;
pt.B = 16;
pt.W = 32;
pt.U = 64;
pt.R = 128;
var va = pt, WL = {}.toString, og = function(e) {
  return WL.call(e).slice(8, -1);
}, wd, U4;
function ag() {
  if (U4)
    return wd;
  U4 = 1;
  var e = og;
  return wd = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
    return e(t) == "String" ? t.split("") : Object(t);
  }, wd;
}
var m3 = function(e) {
  if (e == null)
    throw TypeError("Can't call method on  " + e);
  return e;
}, ZL = ag(), $L = m3, ga = function(e) {
  return ZL($L(e));
}, YL = Math.ceil, jL = Math.floor, v3 = function(e) {
  return isNaN(e = +e) ? 0 : (e > 0 ? jL : YL)(e);
}, zL = v3, XL = Math.min, UL = function(e) {
  return e > 0 ? XL(zL(e), 9007199254740991) : 0;
}, JL = v3, KL = Math.max, qL = Math.min, QL = function(e, t) {
  return e = JL(e), e < 0 ? KL(e + t, 0) : qL(e, t);
}, eR = ga, tR = UL, nR = QL, rR = function(e) {
  return function(t, n, r) {
    var o = eR(t), a = tR(o.length), i = nR(r, a), s;
    if (e && n != n) {
      for (; a > i; )
        if (s = o[i++], s != s)
          return !0;
    } else
      for (; a > i; i++)
        if ((e || i in o) && o[i] === n)
          return e || i || 0;
    return !e && -1;
  };
}, ig = { exports: {} }, oR = !0, aR = Dr, J4 = so, K4 = "__core-js_shared__", q4 = J4[K4] || (J4[K4] = {});
(ig.exports = function(e, t) {
  return q4[e] || (q4[e] = t !== void 0 ? t : {});
})("versions", []).push({
  version: aR.version,
  mode: "pure",
  copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
});
var g3 = ig.exports, iR = 0, sR = Math.random(), $c = function(e) {
  return "Symbol(".concat(e === void 0 ? "" : e, ")_", (++iR + sR).toString(36));
}, bd, Q4;
function w3() {
  if (Q4)
    return bd;
  Q4 = 1;
  var e = g3("keys"), t = $c;
  return bd = function(n) {
    return e[n] || (e[n] = t(n));
  }, bd;
}
var e6 = lo, lR = ga, cR = rR(!1), uR = w3()("IE_PROTO"), sg = function(e, t) {
  var n = lR(e), r = 0, o = [], a;
  for (a in n)
    a != uR && e6(n, a) && o.push(a);
  for (; t.length > r; )
    e6(n, a = t[r++]) && (~cR(o, a) || o.push(a));
  return o;
}, b3 = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(","), dR = sg, fR = b3, Yc = Object.keys || function(t) {
  return dR(t, fR);
}, jc = {};
jc.f = Object.getOwnPropertySymbols;
var Cd = {}, t6;
function zc() {
  return t6 || (t6 = 1, Cd.f = {}.propertyIsEnumerable), Cd;
}
var pR = m3, C3 = function(e) {
  return Object(pR(e));
}, yd, n6;
function hR() {
  if (n6)
    return yd;
  n6 = 1;
  var e = Nr, t = Yc, n = jc, r = zc(), o = C3, a = ag(), i = Object.assign;
  return yd = !i || Ui(function() {
    var s = {}, l = {}, c = Symbol(), d = "abcdefghijklmnopqrst";
    return s[c] = 7, d.split("").forEach(function(f) {
      l[f] = f;
    }), i({}, s)[c] != 7 || Object.keys(i({}, l)).join("") != d;
  }) ? function(l, c) {
    for (var d = o(l), f = arguments.length, p = 1, h = n.f, g = r.f; f > p; )
      for (var m = a(arguments[p++]), v = h ? t(m).concat(h(m)) : t(m), w = v.length, C = 0, y; w > C; )
        y = v[C++], (!e || g.call(m, y)) && (d[y] = m[y]);
    return d;
  } : i, yd;
}
var xd = va;
xd(xd.S + xd.F, "Object", { assign: hR() });
var mR = Dr.Object.assign, vR = { default: mR, __esModule: !0 }, gR = vR, wR = bR(gR);
function bR(e) {
  return e && e.__esModule ? e : { default: e };
}
var Fo = wR.default || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, co = function(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}, Xc = {}, CR = v3, yR = m3, xR = function(e) {
  return function(t, n) {
    var r = String(yR(t)), o = CR(n), a = r.length, i, s;
    return o < 0 || o >= a ? e ? "" : void 0 : (i = r.charCodeAt(o), i < 55296 || i > 56319 || o + 1 === a || (s = r.charCodeAt(o + 1)) < 56320 || s > 57343 ? e ? r.charAt(o) : i : e ? r.slice(o, o + 2) : (i - 55296 << 10) + (s - 56320) + 65536);
  };
}, lg = ma, y3 = {}, Ed, r6;
function ER() {
  if (r6)
    return Ed;
  r6 = 1;
  var e = Mr, t = Xi, n = Yc;
  return Ed = Nr ? Object.defineProperties : function(o, a) {
    t(o);
    for (var i = n(a), s = i.length, l = 0, c; s > l; )
      e.f(o, c = i[l++], a[c]);
    return o;
  }, Ed;
}
var Id, o6;
function IR() {
  if (o6)
    return Id;
  o6 = 1;
  var e = so.document;
  return Id = e && e.documentElement, Id;
}
var Sd, a6;
function x3() {
  if (a6)
    return Sd;
  a6 = 1;
  var e = Xi, t = ER(), n = b3, r = w3()("IE_PROTO"), o = function() {
  }, a = "prototype", i = function() {
    var s = ng()("iframe"), l = n.length, c = "<", d = ">", f;
    for (s.style.display = "none", IR().appendChild(s), s.src = "javascript:", f = s.contentWindow.document, f.open(), f.write(c + "script" + d + "document.F=Object" + c + "/script" + d), f.close(), i = f.F; l--; )
      delete i[a][n[l]];
    return i();
  };
  return Sd = Object.create || function(l, c) {
    var d;
    return l !== null ? (o[a] = e(l), d = new o(), o[a] = null, d[r] = l) : d = i(), c === void 0 ? d : t(d, c);
  }, Sd;
}
var cg = { exports: {} }, rf = g3("wks"), SR = $c, of = so.Symbol, i6 = typeof of == "function", DR = cg.exports = function(e) {
  return rf[e] || (rf[e] = i6 && of[e] || (i6 ? of : SR)("Symbol." + e));
};
DR.store = rf;
var wa = cg.exports, MR = Mr.f, NR = lo, s6 = wa("toStringTag"), E3 = function(e, t, n) {
  e && !NR(e = n ? e : e.prototype, s6) && MR(e, s6, { configurable: !0, value: t });
}, PR = x3(), AR = Zc, _R = E3, ug = {};
ma(ug, wa("iterator"), function() {
  return this;
});
var OR = function(e, t, n) {
  e.prototype = PR(ug, { next: AR(1, n) }), _R(e, t + " Iterator");
}, TR = lo, LR = C3, l6 = w3()("IE_PROTO"), RR = Object.prototype, VR = Object.getPrototypeOf || function(e) {
  return e = LR(e), TR(e, l6) ? e[l6] : typeof e.constructor == "function" && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? RR : null;
}, Dd = va, kR = lg, FR = ma, c6 = y3, HR = OR, BR = E3, GR = VR, Md = wa("iterator"), Nd = !([].keys && "next" in [].keys()), WR = "@@iterator", u6 = "keys", _s = "values", ZR = function() {
  return this;
}, dg = function(e, t, n, r, o, a, i) {
  HR(n, t, r);
  var s = function(y) {
    if (!Nd && y in f)
      return f[y];
    switch (y) {
      case u6:
        return function() {
          return new n(this, y);
        };
      case _s:
        return function() {
          return new n(this, y);
        };
    }
    return function() {
      return new n(this, y);
    };
  }, l = t + " Iterator", c = o == _s, d = !1, f = e.prototype, p = f[Md] || f[WR] || o && f[o], h = p || s(o), g = o ? c ? s("entries") : h : void 0, m = t == "Array" && f.entries || p, v, w, C;
  if (m && (C = GR(m.call(new e())), C !== Object.prototype && C.next && BR(C, l, !0)), c && p && p.name !== _s && (d = !0, h = function() {
    return p.call(this);
  }), i && (Nd || d || !f[Md]) && FR(f, Md, h), c6[t] = h, c6[l] = ZR, o)
    if (v = {
      values: c ? h : s(_s),
      keys: a ? h : s(u6),
      entries: g
    }, i)
      for (w in v)
        w in f || kR(f, w, v[w]);
    else
      Dd(Dd.P + Dd.F * (Nd || d), t, v);
  return v;
}, $R = xR(!0);
dg(String, "String", function(e) {
  this._t = String(e), this._i = 0;
}, function() {
  var e = this._t, t = this._i, n;
  return t >= e.length ? { value: void 0, done: !0 } : (n = $R(e, t), this._i += n.length, { value: n, done: !1 });
});
var YR = function(e, t) {
  return { value: t, done: !!e };
}, Os = YR, d6 = y3, jR = ga;
dg(Array, "Array", function(e, t) {
  this._t = jR(e), this._i = 0, this._k = t;
}, function() {
  var e = this._t, t = this._k, n = this._i++;
  return !e || n >= e.length ? (this._t = void 0, Os(1)) : t == "keys" ? Os(0, n) : t == "values" ? Os(0, e[n]) : Os(0, [n, e[n]]);
}, "values");
d6.Arguments = d6.Array;
var zR = so, XR = ma, f6 = y3, p6 = wa("toStringTag"), h6 = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for (var Pd = 0; Pd < h6.length; Pd++) {
  var Ad = h6[Pd], m6 = zR[Ad], _d = m6 && m6.prototype;
  _d && !_d[p6] && XR(_d, p6, Ad), f6[Ad] = f6.Array;
}
var Uc = {};
Uc.f = wa;
var UR = Uc.f("iterator"), JR = { default: UR, __esModule: !0 }, fg = { exports: {} }, qr = $c("meta"), KR = ha, I3 = lo, qR = Mr.f, QR = 0, Jc = Object.isExtensible || function() {
  return !0;
}, eV = !Ui(function() {
  return Jc(Object.preventExtensions({}));
}), S3 = function(e) {
  qR(e, qr, { value: {
    i: "O" + ++QR,
    // object ID
    w: {}
    // weak collections IDs
  } });
}, tV = function(e, t) {
  if (!KR(e))
    return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!I3(e, qr)) {
    if (!Jc(e))
      return "F";
    if (!t)
      return "E";
    S3(e);
  }
  return e[qr].i;
}, nV = function(e, t) {
  if (!I3(e, qr)) {
    if (!Jc(e))
      return !0;
    if (!t)
      return !1;
    S3(e);
  }
  return e[qr].w;
}, rV = function(e) {
  return eV && oV.NEED && Jc(e) && !I3(e, qr) && S3(e), e;
}, oV = fg.exports = {
  KEY: qr,
  NEED: !1,
  fastKey: tV,
  getWeak: nV,
  onFreeze: rV
}, aV = fg.exports, v6 = Dr, iV = Uc, sV = Mr.f, D3 = function(e) {
  var t = v6.Symbol || (v6.Symbol = {});
  e.charAt(0) != "_" && !(e in t) && sV(t, e, { value: iV.f(e) });
}, lV = Yc, cV = jc, uV = zc(), dV = function(e) {
  var t = lV(e), n = cV.f;
  if (n)
    for (var r = n(e), o = uV.f, a = 0, i; r.length > a; )
      o.call(e, i = r[a++]) && t.push(i);
  return t;
}, fV = og, pV = Array.isArray || function(t) {
  return fV(t) == "Array";
}, pg = {}, M3 = {}, hV = sg, mV = b3.concat("length", "prototype");
M3.f = Object.getOwnPropertyNames || function(t) {
  return hV(t, mV);
};
var vV = ga, hg = M3.f, gV = {}.toString, mg = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], wV = function(e) {
  try {
    return hg(e);
  } catch {
    return mg.slice();
  }
};
pg.f = function(t) {
  return mg && gV.call(t) == "[object Window]" ? wV(t) : hg(vV(t));
};
var N3 = {}, bV = zc(), CV = Zc, yV = ga, xV = h3, EV = lo, IV = rg, g6 = Object.getOwnPropertyDescriptor;
N3.f = Nr ? g6 : function(t, n) {
  if (t = yV(t), n = xV(n, !0), IV)
    try {
      return g6(t, n);
    } catch {
    }
  if (EV(t, n))
    return CV(!bV.f.call(t, n), t[n]);
};
var Kc = so, nt = lo, af = Nr, ht = va, w6 = lg, SV = aV.KEY, P3 = Ui, A3 = g3, _3 = E3, DV = $c, Ji = wa, MV = Uc, NV = D3, PV = dV, AV = pV, sf = Xi, _V = ha, OV = C3, qc = ga, O3 = h3, lf = Zc, mi = x3(), vg = pg, gg = N3, Qc = jc, wg = Mr, TV = Yc, bg = gg.f, Hr = wg.f, Cg = vg.f, Mt = Kc.Symbol, Al = Kc.JSON, Ts = Al && Al.stringify, ur = "prototype", St = Ji("_hidden"), b6 = Ji("toPrimitive"), LV = {}.propertyIsEnumerable, Oa = A3("symbol-registry"), Un = A3("symbols"), Ki = A3("op-symbols"), $t = Object[ur], ba = typeof Mt == "function" && !!Qc.f, Od = Kc.QObject, cf = !Od || !Od[ur] || !Od[ur].findChild, uf = af && P3(function() {
  return mi(Hr({}, "a", {
    get: function() {
      return Hr(this, "a", { value: 7 }).a;
    }
  })).a != 7;
}) ? function(e, t, n) {
  var r = bg($t, t);
  r && delete $t[t], Hr(e, t, n), r && e !== $t && Hr($t, t, r);
} : Hr, C6 = function(e) {
  var t = Un[e] = mi(Mt[ur]);
  return t._k = e, t;
}, df = ba && typeof Mt.iterator == "symbol" ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  return e instanceof Mt;
}, eu = function(t, n, r) {
  return t === $t && eu(Ki, n, r), sf(t), n = O3(n, !0), sf(r), nt(Un, n) ? (r.enumerable ? (nt(t, St) && t[St][n] && (t[St][n] = !1), r = mi(r, { enumerable: lf(0, !1) })) : (nt(t, St) || Hr(t, St, lf(1, {})), t[St][n] = !0), uf(t, n, r)) : Hr(t, n, r);
}, yg = function(t, n) {
  sf(t);
  for (var r = PV(n = qc(n)), o = 0, a = r.length, i; a > o; )
    eu(t, i = r[o++], n[i]);
  return t;
}, RV = function(t, n) {
  return n === void 0 ? mi(t) : yg(mi(t), n);
}, y6 = function(t) {
  var n = LV.call(this, t = O3(t, !0));
  return this === $t && nt(Un, t) && !nt(Ki, t) ? !1 : n || !nt(this, t) || !nt(Un, t) || nt(this, St) && this[St][t] ? n : !0;
}, xg = function(t, n) {
  if (t = qc(t), n = O3(n, !0), !(t === $t && nt(Un, n) && !nt(Ki, n))) {
    var r = bg(t, n);
    return r && nt(Un, n) && !(nt(t, St) && t[St][n]) && (r.enumerable = !0), r;
  }
}, Eg = function(t) {
  for (var n = Cg(qc(t)), r = [], o = 0, a; n.length > o; )
    !nt(Un, a = n[o++]) && a != St && a != SV && r.push(a);
  return r;
}, Ig = function(t) {
  for (var n = t === $t, r = Cg(n ? Ki : qc(t)), o = [], a = 0, i; r.length > a; )
    nt(Un, i = r[a++]) && (!n || nt($t, i)) && o.push(Un[i]);
  return o;
};
ba || (Mt = function() {
  if (this instanceof Mt)
    throw TypeError("Symbol is not a constructor!");
  var t = DV(arguments.length > 0 ? arguments[0] : void 0), n = function(r) {
    this === $t && n.call(Ki, r), nt(this, St) && nt(this[St], t) && (this[St][t] = !1), uf(this, t, lf(1, r));
  };
  return af && cf && uf($t, t, { configurable: !0, set: n }), C6(t);
}, w6(Mt[ur], "toString", function() {
  return this._k;
}), gg.f = xg, wg.f = eu, M3.f = vg.f = Eg, zc().f = y6, Qc.f = Ig, af && !oR && w6($t, "propertyIsEnumerable", y6), MV.f = function(e) {
  return C6(Ji(e));
});
ht(ht.G + ht.W + ht.F * !ba, { Symbol: Mt });
for (var x6 = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(",")
), E6 = 0; x6.length > E6; )
  Ji(x6[E6++]);
for (var I6 = TV(Ji.store), S6 = 0; I6.length > S6; )
  NV(I6[S6++]);
ht(ht.S + ht.F * !ba, "Symbol", {
  // 19.4.2.1 Symbol.for(key)
  for: function(e) {
    return nt(Oa, e += "") ? Oa[e] : Oa[e] = Mt(e);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function(t) {
    if (!df(t))
      throw TypeError(t + " is not a symbol!");
    for (var n in Oa)
      if (Oa[n] === t)
        return n;
  },
  useSetter: function() {
    cf = !0;
  },
  useSimple: function() {
    cf = !1;
  }
});
ht(ht.S + ht.F * !ba, "Object", {
  // 19.1.2.2 Object.create(O [, Properties])
  create: RV,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: eu,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: yg,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: xg,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: Eg,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: Ig
});
var VV = P3(function() {
  Qc.f(1);
});
ht(ht.S + ht.F * VV, "Object", {
  getOwnPropertySymbols: function(t) {
    return Qc.f(OV(t));
  }
});
Al && ht(ht.S + ht.F * (!ba || P3(function() {
  var e = Mt();
  return Ts([e]) != "[null]" || Ts({ a: e }) != "{}" || Ts(Object(e)) != "{}";
})), "JSON", {
  stringify: function(t) {
    for (var n = [t], r = 1, o, a; arguments.length > r; )
      n.push(arguments[r++]);
    if (a = o = n[1], !(!_V(o) && t === void 0 || df(t)))
      return AV(o) || (o = function(i, s) {
        if (typeof a == "function" && (s = a.call(this, i, s)), !df(s))
          return s;
      }), n[1] = o, Ts.apply(Al, n);
  }
});
Mt[ur][b6] || ma(Mt[ur], b6, Mt[ur].valueOf);
_3(Mt, "Symbol");
_3(Math, "Math", !0);
_3(Kc.JSON, "JSON", !0);
D3("asyncIterator");
D3("observable");
var kV = Dr.Symbol, FV = { default: kV, __esModule: !0 };
Xc.__esModule = !0;
var HV = JR, Sg = Dg(HV), BV = FV, ir = Dg(BV), Td = typeof ir.default == "function" && typeof Sg.default == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof ir.default == "function" && e.constructor === ir.default && e !== ir.default.prototype ? "symbol" : typeof e;
};
function Dg(e) {
  return e && e.__esModule ? e : { default: e };
}
var GV = Xc.default = typeof ir.default == "function" && Td(Sg.default) === "symbol" ? function(e) {
  return typeof e > "u" ? "undefined" : Td(e);
} : function(e) {
  return e && typeof ir.default == "function" && e.constructor === ir.default && e !== ir.default.prototype ? "symbol" : typeof e > "u" ? "undefined" : Td(e);
}, WV = Xc, ZV = $V(WV);
function $V(e) {
  return e && e.__esModule ? e : { default: e };
}
var br = function(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && ((typeof t > "u" ? "undefined" : (0, ZV.default)(t)) === "object" || typeof t == "function") ? t : e;
}, Ld, D6;
function YV() {
  if (D6)
    return Ld;
  D6 = 1;
  var e = ha, t = Xi, n = function(r, o) {
    if (t(r), !e(o) && o !== null)
      throw TypeError(o + ": can't set as prototype!");
  };
  return Ld = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? (
      // eslint-disable-line
      function(r, o, a) {
        try {
          a = tg(Function.call, N3.f(Object.prototype, "__proto__").set, 2), a(r, []), o = !(r instanceof Array);
        } catch {
          o = !0;
        }
        return function(s, l) {
          return n(s, l), o ? s.__proto__ = l : a(s, l), s;
        };
      }({}, !1)
    ) : void 0),
    check: n
  }, Ld;
}
var M6 = va;
M6(M6.S, "Object", { setPrototypeOf: YV().set });
var jV = Dr.Object.setPrototypeOf, zV = { default: jV, __esModule: !0 }, N6 = va;
N6(N6.S, "Object", { create: x3() });
var XV = Dr.Object, UV = function(t, n) {
  return XV.create(t, n);
}, JV = { default: UV, __esModule: !0 }, KV = zV, P6 = T3(KV), qV = JV, QV = T3(qV), ek = Xc, tk = T3(ek);
function T3(e) {
  return e && e.__esModule ? e : { default: e };
}
var uo = function(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + (typeof t > "u" ? "undefined" : (0, tk.default)(t)));
  e.prototype = (0, QV.default)(t && t.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), t && (P6.default ? (0, P6.default)(e, t) : e.__proto__ = t);
};
function Mg() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Ng(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function Pg(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
Mg.__suppressDeprecationWarning = !0;
Ng.__suppressDeprecationWarning = !0;
Pg.__suppressDeprecationWarning = !0;
function L3(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, o = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? o = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (o = "UNSAFE_componentWillUpdate"), n !== null || r !== null || o !== null) {
    var a = e.displayName || e.name, i = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + a + " uses " + i + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (o !== null ? `
  ` + o : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = Mg, t.componentWillReceiveProps = Ng), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Pg;
    var s = t.componentDidUpdate;
    t.componentDidUpdate = function(c, d, f) {
      var p = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : f;
      s.call(this, c, d, p);
    };
  }
  return e;
}
function ff(e, t) {
  for (var n = t; n; ) {
    if (n === e)
      return !0;
    n = n.parentNode;
  }
  return !1;
}
var pf = { exports: {} }, hf = { exports: {} }, mf = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n() {
    return !1;
  }
  function r() {
    return !0;
  }
  function o() {
    this.timeStamp = Date.now(), this.target = void 0, this.currentTarget = void 0;
  }
  o.prototype = {
    isEventObject: 1,
    constructor: o,
    isDefaultPrevented: n,
    isPropagationStopped: n,
    isImmediatePropagationStopped: n,
    preventDefault: function() {
      this.isDefaultPrevented = r;
    },
    stopPropagation: function() {
      this.isPropagationStopped = r;
    },
    stopImmediatePropagation: function() {
      this.isImmediatePropagationStopped = r, this.stopPropagation();
    },
    halt: function(i) {
      i ? this.stopImmediatePropagation() : this.stopPropagation(), this.preventDefault();
    }
  }, t.default = o, e.exports = t.default;
})(mf, mf.exports);
var nk = mf.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var r = nk, o = n(r), a = Kv(), i = n(a), s = !0, l = !1, c = ["altKey", "bubbles", "cancelable", "ctrlKey", "currentTarget", "eventPhase", "metaKey", "shiftKey", "target", "timeStamp", "view", "type"];
  function d(v) {
    return v == null;
  }
  var f = [{
    reg: /^key/,
    props: ["char", "charCode", "key", "keyCode", "which"],
    fix: function(w, C) {
      d(w.which) && (w.which = d(C.charCode) ? C.keyCode : C.charCode), w.metaKey === void 0 && (w.metaKey = w.ctrlKey);
    }
  }, {
    reg: /^touch/,
    props: ["touches", "changedTouches", "targetTouches"]
  }, {
    reg: /^hashchange$/,
    props: ["newURL", "oldURL"]
  }, {
    reg: /^gesturechange$/i,
    props: ["rotation", "scale"]
  }, {
    reg: /^(mousewheel|DOMMouseScroll)$/,
    props: [],
    fix: function(w, C) {
      var y = void 0, x = void 0, E = void 0, S = C.wheelDelta, I = C.axis, D = C.wheelDeltaY, N = C.wheelDeltaX, A = C.detail;
      S && (E = S / 120), A && (E = 0 - (A % 3 === 0 ? A / 3 : A)), I !== void 0 && (I === w.HORIZONTAL_AXIS ? (x = 0, y = 0 - E) : I === w.VERTICAL_AXIS && (y = 0, x = E)), D !== void 0 && (x = D / 120), N !== void 0 && (y = -1 * N / 120), !y && !x && (x = E), y !== void 0 && (w.deltaX = y), x !== void 0 && (w.deltaY = x), E !== void 0 && (w.delta = E);
    }
  }, {
    reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
    props: ["buttons", "clientX", "clientY", "button", "offsetX", "relatedTarget", "which", "fromElement", "toElement", "offsetY", "pageX", "pageY", "screenX", "screenY"],
    fix: function(w, C) {
      var y = void 0, x = void 0, E = void 0, S = w.target, I = C.button;
      return S && d(w.pageX) && !d(C.clientX) && (y = S.ownerDocument || document, x = y.documentElement, E = y.body, w.pageX = C.clientX + (x && x.scrollLeft || E && E.scrollLeft || 0) - (x && x.clientLeft || E && E.clientLeft || 0), w.pageY = C.clientY + (x && x.scrollTop || E && E.scrollTop || 0) - (x && x.clientTop || E && E.clientTop || 0)), !w.which && I !== void 0 && (I & 1 ? w.which = 1 : I & 2 ? w.which = 3 : I & 4 ? w.which = 2 : w.which = 0), !w.relatedTarget && w.fromElement && (w.relatedTarget = w.fromElement === S ? w.toElement : w.fromElement), w;
    }
  }];
  function p() {
    return s;
  }
  function h() {
    return l;
  }
  function g(v) {
    var w = v.type, C = typeof v.stopPropagation == "function" || typeof v.cancelBubble == "boolean";
    o.default.call(this), this.nativeEvent = v;
    var y = h;
    "defaultPrevented" in v ? y = v.defaultPrevented ? p : h : "getPreventDefault" in v ? y = v.getPreventDefault() ? p : h : "returnValue" in v && (y = v.returnValue === l ? p : h), this.isDefaultPrevented = y;
    var x = [], E = void 0, S = void 0, I = void 0, D = c.concat();
    for (f.forEach(function(N) {
      w.match(N.reg) && (D = D.concat(N.props), N.fix && x.push(N.fix));
    }), S = D.length; S; )
      I = D[--S], this[I] = v[I];
    for (!this.target && C && (this.target = v.srcElement || document), this.target && this.target.nodeType === 3 && (this.target = this.target.parentNode), S = x.length; S; )
      E = x[--S], E(this, v);
    this.timeStamp = v.timeStamp || Date.now();
  }
  var m = o.default.prototype;
  (0, i.default)(g.prototype, m, {
    constructor: g,
    preventDefault: function() {
      var w = this.nativeEvent;
      w.preventDefault ? w.preventDefault() : w.returnValue = l, m.preventDefault.call(this);
    },
    stopPropagation: function() {
      var w = this.nativeEvent;
      w.stopPropagation ? w.stopPropagation() : w.cancelBubble = s, m.stopPropagation.call(this);
    }
  }), t.default = g, e.exports = t.default;
})(hf, hf.exports);
var rk = hf.exports;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = rk, o = n(r);
  function a(i, s, l, c) {
    function d(p) {
      var h = new o.default(p);
      l.call(i, h);
    }
    if (i.addEventListener) {
      var f = function() {
        var p = !1;
        return typeof c == "object" ? p = c.capture || !1 : typeof c == "boolean" && (p = c), i.addEventListener(s, d, c || !1), {
          v: {
            remove: function() {
              i.removeEventListener(s, d, p);
            }
          }
        };
      }();
      if (typeof f == "object")
        return f.v;
    } else if (i.attachEvent)
      return i.attachEvent("on" + s, d), {
        remove: function() {
          i.detachEvent("on" + s, d);
        }
      };
  }
  e.exports = t.default;
})(pf, pf.exports);
var ok = pf.exports;
const ak = /* @__PURE__ */ ua(ok);
function Ua(e, t, n, r) {
  var o = kt.unstable_batchedUpdates ? function(i) {
    kt.unstable_batchedUpdates(n, i);
  } : n;
  return ak(e, t, o, r);
}
function al(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? al = function(n) {
    return typeof n;
  } : al = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, al(e);
}
function ik(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function A6(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function sk(e, t, n) {
  return t && A6(e.prototype, t), n && A6(e, n), e;
}
function lk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && vf(e, t);
}
function vf(e, t) {
  return vf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, vf(e, t);
}
function ck(e) {
  var t = fk();
  return function() {
    var r = _l(e), o;
    if (t) {
      var a = _l(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return uk(this, o);
  };
}
function uk(e, t) {
  return t && (al(t) === "object" || typeof t == "function") ? t : dk(e);
}
function dk(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _l(e) {
  return _l = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, _l(e);
}
var R3 = /* @__PURE__ */ function(e) {
  lk(n, e);
  var t = ck(n);
  function n() {
    var r;
    ik(this, n);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = t.call.apply(t, [this].concat(a)), r.removeContainer = function() {
      r.container && (kt.unmountComponentAtNode(r.container), r.container.parentNode.removeChild(r.container), r.container = null);
    }, r.renderComponent = function(s, l) {
      var c = r.props, d = c.visible, f = c.getComponent, p = c.forceRender, h = c.getContainer, g = c.parent;
      (d || g._component || p) && (r.container || (r.container = h()), kt.unstable_renderSubtreeIntoContainer(g, f(s), r.container, function() {
        l && l.call(this);
      }));
    }, r;
  }
  return sk(n, [{
    key: "componentDidMount",
    value: function() {
      this.props.autoMount && this.renderComponent();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.props.autoMount && this.renderComponent();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.props.autoDestroy && this.removeContainer();
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]), n;
}(X.Component);
R3.propTypes = {
  autoMount: M.bool,
  autoDestroy: M.bool,
  visible: M.bool,
  forceRender: M.bool,
  parent: M.any,
  getComponent: M.func.isRequired,
  getContainer: M.func.isRequired,
  children: M.func.isRequired
};
R3.defaultProps = {
  autoMount: !0,
  autoDestroy: !0,
  forceRender: !1
};
function il(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? il = function(n) {
    return typeof n;
  } : il = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, il(e);
}
function pk(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _6(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function hk(e, t, n) {
  return t && _6(e.prototype, t), n && _6(e, n), e;
}
function mk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && gf(e, t);
}
function gf(e, t) {
  return gf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, gf(e, t);
}
function vk(e) {
  var t = bk();
  return function() {
    var r = Ol(e), o;
    if (t) {
      var a = Ol(this).constructor;
      o = Reflect.construct(r, arguments, a);
    } else
      o = r.apply(this, arguments);
    return gk(this, o);
  };
}
function gk(e, t) {
  return t && (il(t) === "object" || typeof t == "function") ? t : wk(e);
}
function wk(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function bk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ol(e) {
  return Ol = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ol(e);
}
var Ag = /* @__PURE__ */ function(e) {
  mk(n, e);
  var t = vk(n);
  function n() {
    return pk(this, n), t.apply(this, arguments);
  }
  return hk(n, [{
    key: "componentDidMount",
    value: function() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props.didUpdate;
      a && a(o);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function() {
      this._container = this.props.getContainer(), this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function() {
      this._container && this._container.parentNode.removeChild(this._container);
    }
  }, {
    key: "render",
    value: function() {
      return this._container ? kt.createPortal(this.props.children, this._container) : null;
    }
  }]), n;
}(X.Component);
Ag.propTypes = {
  getContainer: M.func.isRequired,
  children: M.node.isRequired,
  didUpdate: M.func
};
var _g = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var a = "", i = 0; i < arguments.length; i++) {
        var s = arguments[i];
        s && (a = o(a, r(s)));
      }
      return a;
    }
    function r(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return n.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var i = "";
      for (var s in a)
        t.call(a, s) && a[s] && (i = o(i, s));
      return i;
    }
    function o(a, i) {
      return i ? a ? a + " " + i : a + i : a;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(_g);
var Ck = _g.exports;
const _t = /* @__PURE__ */ ua(Ck);
function yk(e, t, n) {
  return n ? e[0] === t[0] : e[0] === t[0] && e[1] === t[1];
}
function xk(e, t, n) {
  var r = e[t] || {};
  return Fo({}, r, n);
}
function Ek(e, t, n, r) {
  var o = n.points;
  for (var a in e)
    if (e.hasOwnProperty(a) && yk(e[a].points, o, r))
      return t + "-placement-" + a;
  return "";
}
function O6(e, t) {
  this[e] = t;
}
var Rd = va;
Rd(Rd.S + Rd.F * !Nr, "Object", { defineProperty: Mr.f });
var Ik = Dr.Object, Sk = function(t, n, r) {
  return Ik.defineProperty(t, n, r);
}, Og = { default: Sk, __esModule: !0 }, Dk = Og, Mk = Nk(Dk);
function Nk(e) {
  return e && e.__esModule ? e : { default: e };
}
var V3 = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), (0, Mk.default)(t, o.key, o);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function T6(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function L6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? T6(Object(n), !0).forEach(function(r) {
      Pk(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : T6(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function wf(e) {
  "@babel/helpers - typeof";
  return wf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wf(e);
}
function Pk(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ta, Ak = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  // IE did it wrong again ...
  ms: "-ms-",
  O: "-o-"
};
function Tl() {
  if (Ta !== void 0)
    return Ta;
  Ta = "";
  var e = document.createElement("p").style, t = "Transform";
  for (var n in Ak)
    n + t in e && (Ta = n);
  return Ta;
}
function Tg() {
  return Tl() ? "".concat(Tl(), "TransitionProperty") : "transitionProperty";
}
function tu() {
  return Tl() ? "".concat(Tl(), "Transform") : "transform";
}
function R6(e, t) {
  var n = Tg();
  n && (e.style[n] = t, n !== "transitionProperty" && (e.style.transitionProperty = t));
}
function Vd(e, t) {
  var n = tu();
  n && (e.style[n] = t, n !== "transform" && (e.style.transform = t));
}
function _k(e) {
  return e.style.transitionProperty || e.style[Tg()];
}
function Ok(e) {
  var t = window.getComputedStyle(e, null), n = t.getPropertyValue("transform") || t.getPropertyValue(tu());
  if (n && n !== "none") {
    var r = n.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(r[12] || r[4], 0),
      y: parseFloat(r[13] || r[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var Tk = /matrix\((.*)\)/, Lk = /matrix3d\((.*)\)/;
function Rk(e, t) {
  var n = window.getComputedStyle(e, null), r = n.getPropertyValue("transform") || n.getPropertyValue(tu());
  if (r && r !== "none") {
    var o, a = r.match(Tk);
    if (a)
      a = a[1], o = a.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), o[4] = t.x, o[5] = t.y, Vd(e, "matrix(".concat(o.join(","), ")"));
    else {
      var i = r.match(Lk)[1];
      o = i.split(",").map(function(s) {
        return parseFloat(s, 10);
      }), o[12] = t.x, o[13] = t.y, Vd(e, "matrix3d(".concat(o.join(","), ")"));
    }
  } else
    Vd(e, "translateX(".concat(t.x, "px) translateY(").concat(t.y, "px) translateZ(0)"));
}
var Vk = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source, qi;
function V6(e) {
  var t = e.style.display;
  e.style.display = "none", e.offsetHeight, e.style.display = t;
}
function Ho(e, t, n) {
  var r = n;
  if (wf(t) === "object") {
    for (var o in t)
      t.hasOwnProperty(o) && Ho(e, o, t[o]);
    return;
  }
  if (typeof r < "u") {
    typeof r == "number" && (r = "".concat(r, "px")), e.style[t] = r;
    return;
  }
  return qi(e, t);
}
function kk(e) {
  var t, n, r, o = e.ownerDocument, a = o.body, i = o && o.documentElement;
  return t = e.getBoundingClientRect(), n = Math.floor(t.left), r = Math.floor(t.top), n -= i.clientLeft || a.clientLeft || 0, r -= i.clientTop || a.clientTop || 0, {
    left: n,
    top: r
  };
}
function Lg(e, t) {
  var n = e["page".concat(t ? "Y" : "X", "Offset")], r = "scroll".concat(t ? "Top" : "Left");
  if (typeof n != "number") {
    var o = e.document;
    n = o.documentElement[r], typeof n != "number" && (n = o.body[r]);
  }
  return n;
}
function Rg(e) {
  return Lg(e);
}
function Vg(e) {
  return Lg(e, !0);
}
function vi(e) {
  var t = kk(e), n = e.ownerDocument, r = n.defaultView || n.parentWindow;
  return t.left += Rg(r), t.top += Vg(r), t;
}
function k3(e) {
  return e != null && e == e.window;
}
function kg(e) {
  return k3(e) ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
}
function Fk(e, t, n) {
  var r = n, o = "", a = kg(e);
  return r = r || a.defaultView.getComputedStyle(e, null), r && (o = r.getPropertyValue(t) || r[t]), o;
}
var Hk = new RegExp("^(".concat(Vk, ")(?!px)[a-z%]+$"), "i"), Bk = /^(top|right|bottom|left)$/, kd = "currentStyle", Fd = "runtimeStyle", _r = "left", Gk = "px";
function Wk(e, t) {
  var n = e[kd] && e[kd][t];
  if (Hk.test(n) && !Bk.test(t)) {
    var r = e.style, o = r[_r], a = e[Fd][_r];
    e[Fd][_r] = e[kd][_r], r[_r] = t === "fontSize" ? "1em" : n || 0, n = r.pixelLeft + Gk, r[_r] = o, e[Fd][_r] = a;
  }
  return n === "" ? "auto" : n;
}
typeof window < "u" && (qi = window.getComputedStyle ? Fk : Wk);
function Ls(e, t) {
  return e === "left" ? t.useCssRight ? "right" : e : t.useCssBottom ? "bottom" : e;
}
function k6(e) {
  if (e === "left")
    return "right";
  if (e === "right")
    return "left";
  if (e === "top")
    return "bottom";
  if (e === "bottom")
    return "top";
}
function F6(e, t, n) {
  Ho(e, "position") === "static" && (e.style.position = "relative");
  var r = -999, o = -999, a = Ls("left", n), i = Ls("top", n), s = k6(a), l = k6(i);
  a !== "left" && (r = 999), i !== "top" && (o = 999);
  var c = "", d = vi(e);
  ("left" in t || "top" in t) && (c = _k(e) || "", R6(e, "none")), "left" in t && (e.style[s] = "", e.style[a] = "".concat(r, "px")), "top" in t && (e.style[l] = "", e.style[i] = "".concat(o, "px")), V6(e);
  var f = vi(e), p = {};
  for (var h in t)
    if (t.hasOwnProperty(h)) {
      var g = Ls(h, n), m = h === "left" ? r : o, v = d[h] - f[h];
      g === h ? p[g] = m + v : p[g] = m - v;
    }
  Ho(e, p), V6(e), ("left" in t || "top" in t) && R6(e, c);
  var w = {};
  for (var C in t)
    if (t.hasOwnProperty(C)) {
      var y = Ls(C, n), x = t[C] - d[C];
      C === y ? w[y] = p[y] + x : w[y] = p[y] - x;
    }
  Ho(e, w);
}
function Zk(e, t) {
  var n = vi(e), r = Ok(e), o = {
    x: r.x,
    y: r.y
  };
  "left" in t && (o.x = r.x + t.left - n.left), "top" in t && (o.y = r.y + t.top - n.top), Rk(e, o);
}
function $k(e, t, n) {
  if (n.ignoreShake) {
    var r = vi(e), o = r.left.toFixed(0), a = r.top.toFixed(0), i = t.left.toFixed(0), s = t.top.toFixed(0);
    if (o === i && a === s)
      return;
  }
  n.useCssRight || n.useCssBottom ? F6(e, t, n) : n.useCssTransform && tu() in document.body.style ? Zk(e, t) : F6(e, t, n);
}
function F3(e, t) {
  for (var n = 0; n < e.length; n++)
    t(e[n]);
}
function Fg(e) {
  return qi(e, "boxSizing") === "border-box";
}
var Yk = ["margin", "border", "padding"], bf = -1, jk = 2, Cf = 1, zk = 0;
function Xk(e, t, n) {
  var r = {}, o = e.style, a;
  for (a in t)
    t.hasOwnProperty(a) && (r[a] = o[a], o[a] = t[a]);
  n.call(e);
  for (a in t)
    t.hasOwnProperty(a) && (o[a] = r[a]);
}
function Ja(e, t, n) {
  var r = 0, o, a, i;
  for (a = 0; a < t.length; a++)
    if (o = t[a], o)
      for (i = 0; i < n.length; i++) {
        var s = void 0;
        o === "border" ? s = "".concat(o).concat(n[i], "Width") : s = o + n[i], r += parseFloat(qi(e, s)) || 0;
      }
  return r;
}
var bn = {
  getParent: function(t) {
    var n = t;
    do
      n.nodeType === 11 && n.host ? n = n.host : n = n.parentNode;
    while (n && n.nodeType !== 1 && n.nodeType !== 9);
    return n;
  }
};
F3(["Width", "Height"], function(e) {
  bn["doc".concat(e)] = function(t) {
    var n = t.document;
    return Math.max(
      // firefox chrome documentElement.scrollHeight< body.scrollHeight
      // ie standard mode : documentElement.scrollHeight> body.scrollHeight
      n.documentElement["scroll".concat(e)],
      // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
      n.body["scroll".concat(e)],
      bn["viewport".concat(e)](n)
    );
  }, bn["viewport".concat(e)] = function(t) {
    var n = "client".concat(e), r = t.document, o = r.body, a = r.documentElement, i = a[n];
    return r.compatMode === "CSS1Compat" && i || o && o[n] || i;
  };
});
function H6(e, t, n) {
  var r = n;
  if (k3(e))
    return t === "width" ? bn.viewportWidth(e) : bn.viewportHeight(e);
  if (e.nodeType === 9)
    return t === "width" ? bn.docWidth(e) : bn.docHeight(e);
  var o = t === "width" ? ["Left", "Right"] : ["Top", "Bottom"], a = Math.floor(t === "width" ? e.getBoundingClientRect().width : e.getBoundingClientRect().height), i = Fg(e), s = 0;
  (a == null || a <= 0) && (a = void 0, s = qi(e, t), (s == null || Number(s) < 0) && (s = e.style[t] || 0), s = Math.floor(parseFloat(s)) || 0), r === void 0 && (r = i ? Cf : bf);
  var l = a !== void 0 || i, c = a || s;
  return r === bf ? l ? c - Ja(e, ["border", "padding"], o) : s : l ? r === Cf ? c : c + (r === jk ? -Ja(e, ["border"], o) : Ja(e, ["margin"], o)) : s + Ja(e, Yk.slice(r), o);
}
var Uk = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function B6() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, o = t[0];
  return o.offsetWidth !== 0 ? r = H6.apply(void 0, t) : Xk(o, Uk, function() {
    r = H6.apply(void 0, t);
  }), r;
}
F3(["width", "height"], function(e) {
  var t = e.charAt(0).toUpperCase() + e.slice(1);
  bn["outer".concat(t)] = function(r, o) {
    return r && B6(r, e, o ? zk : Cf);
  };
  var n = e === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  bn[e] = function(r, o) {
    var a = o;
    if (a !== void 0) {
      if (r) {
        var i = Fg(r);
        return i && (a += Ja(r, ["padding", "border"], n)), Ho(r, e, a);
      }
      return;
    }
    return r && B6(r, e, bf);
  };
});
function Hg(e, t) {
  for (var n in t)
    t.hasOwnProperty(n) && (e[n] = t[n]);
  return e;
}
var ge = {
  getWindow: function(t) {
    if (t && t.document && t.setTimeout)
      return t;
    var n = t.ownerDocument || t;
    return n.defaultView || n.parentWindow;
  },
  getDocument: kg,
  offset: function(t, n, r) {
    if (typeof n < "u")
      $k(t, n, r || {});
    else
      return vi(t);
  },
  isWindow: k3,
  each: F3,
  css: Ho,
  clone: function(t) {
    var n, r = {};
    for (n in t)
      t.hasOwnProperty(n) && (r[n] = t[n]);
    var o = t.overflow;
    if (o)
      for (n in t)
        t.hasOwnProperty(n) && (r.overflow[n] = t.overflow[n]);
    return r;
  },
  mix: Hg,
  getWindowScrollLeft: function(t) {
    return Rg(t);
  },
  getWindowScrollTop: function(t) {
    return Vg(t);
  },
  merge: function() {
    for (var t = {}, n = 0; n < arguments.length; n++)
      ge.mix(t, n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
Hg(ge, bn);
var Hd = ge.getParent;
function yf(e) {
  if (ge.isWindow(e) || e.nodeType === 9)
    return null;
  var t = ge.getDocument(e), n = t.body, r, o = ge.css(e, "position"), a = o === "fixed" || o === "absolute";
  if (!a)
    return e.nodeName.toLowerCase() === "html" ? null : Hd(e);
  for (r = Hd(e); r && r !== n && r.nodeType !== 9; r = Hd(r))
    if (o = ge.css(r, "position"), o !== "static")
      return r;
  return null;
}
var G6 = ge.getParent;
function Jk(e) {
  if (ge.isWindow(e) || e.nodeType === 9)
    return !1;
  var t = ge.getDocument(e), n = t.body, r = null;
  for (
    r = G6(e);
    // 修复元素位于 document.documentElement 下导致崩溃问题
    r && r !== n && r !== t;
    r = G6(r)
  ) {
    var o = ge.css(r, "position");
    if (o === "fixed")
      return !0;
  }
  return !1;
}
function H3(e, t) {
  for (var n = {
    left: 0,
    right: 1 / 0,
    top: 0,
    bottom: 1 / 0
  }, r = yf(e), o = ge.getDocument(e), a = o.defaultView || o.parentWindow, i = o.body, s = o.documentElement; r; ) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || r.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    r !== i && r !== s && ge.css(r, "overflow") !== "visible") {
      var l = ge.offset(r);
      l.left += r.clientLeft, l.top += r.clientTop, n.top = Math.max(n.top, l.top), n.right = Math.min(
        n.right,
        // consider area without scrollBar
        l.left + r.clientWidth
      ), n.bottom = Math.min(n.bottom, l.top + r.clientHeight), n.left = Math.max(n.left, l.left);
    } else if (r === i || r === s)
      break;
    r = yf(r);
  }
  var c = null;
  if (!ge.isWindow(e) && e.nodeType !== 9) {
    c = e.style.position;
    var d = ge.css(e, "position");
    d === "absolute" && (e.style.position = "fixed");
  }
  var f = ge.getWindowScrollLeft(a), p = ge.getWindowScrollTop(a), h = ge.viewportWidth(a), g = ge.viewportHeight(a), m = s.scrollWidth, v = s.scrollHeight, w = window.getComputedStyle(i);
  if (w.overflowX === "hidden" && (m = a.innerWidth), w.overflowY === "hidden" && (v = a.innerHeight), e.style && (e.style.position = c), t || Jk(e))
    n.left = Math.max(n.left, f), n.top = Math.max(n.top, p), n.right = Math.min(n.right, f + h), n.bottom = Math.min(n.bottom, p + g);
  else {
    var C = Math.max(m, f + h);
    n.right = Math.min(n.right, C);
    var y = Math.max(v, p + g);
    n.bottom = Math.min(n.bottom, y);
  }
  return n.top >= 0 && n.left >= 0 && n.bottom > n.top && n.right > n.left ? n : null;
}
function Kk(e, t, n, r) {
  var o = ge.clone(e), a = {
    width: t.width,
    height: t.height
  };
  return r.adjustX && o.left < n.left && (o.left = n.left), r.resizeWidth && o.left >= n.left && o.left + a.width > n.right && (a.width -= o.left + a.width - n.right), r.adjustX && o.left + a.width > n.right && (o.left = Math.max(n.right - a.width, n.left)), r.adjustY && o.top < n.top && (o.top = n.top), r.resizeHeight && o.top >= n.top && o.top + a.height > n.bottom && (a.height -= o.top + a.height - n.bottom), r.adjustY && o.top + a.height > n.bottom && (o.top = Math.max(n.bottom - a.height, n.top)), ge.mix(o, a);
}
function B3(e) {
  var t, n, r;
  if (!ge.isWindow(e) && e.nodeType !== 9)
    t = ge.offset(e), n = ge.outerWidth(e), r = ge.outerHeight(e);
  else {
    var o = ge.getWindow(e);
    t = {
      left: ge.getWindowScrollLeft(o),
      top: ge.getWindowScrollTop(o)
    }, n = ge.viewportWidth(o), r = ge.viewportHeight(o);
  }
  return t.width = n, t.height = r, t;
}
function W6(e, t) {
  var n = t.charAt(0), r = t.charAt(1), o = e.width, a = e.height, i = e.left, s = e.top;
  return n === "c" ? s += a / 2 : n === "b" && (s += a), r === "c" ? i += o / 2 : r === "r" && (i += o), {
    left: i,
    top: s
  };
}
function Rs(e, t, n, r, o) {
  var a = W6(t, n[1]), i = W6(e, n[0]), s = [i.left - a.left, i.top - a.top];
  return {
    left: Math.round(e.left - s[0] + r[0] - o[0]),
    top: Math.round(e.top - s[1] + r[1] - o[1])
  };
}
function Z6(e, t, n) {
  return e.left < n.left || e.left + t.width > n.right;
}
function $6(e, t, n) {
  return e.top < n.top || e.top + t.height > n.bottom;
}
function qk(e, t, n) {
  return e.left > n.right || e.left + t.width < n.left;
}
function Qk(e, t, n) {
  return e.top > n.bottom || e.top + t.height < n.top;
}
function Vs(e, t, n) {
  var r = [];
  return ge.each(e, function(o) {
    r.push(o.replace(t, function(a) {
      return n[a];
    }));
  }), r;
}
function ks(e, t) {
  return e[t] = -e[t], e;
}
function Y6(e, t) {
  var n;
  return /%$/.test(e) ? n = parseInt(e.substring(0, e.length - 1), 10) / 100 * t : n = parseInt(e, 10), n || 0;
}
function j6(e, t) {
  e[0] = Y6(e[0], t.width), e[1] = Y6(e[1], t.height);
}
function Bg(e, t, n, r) {
  var o = n.points, a = n.offset || [0, 0], i = n.targetOffset || [0, 0], s = n.overflow, l = n.source || e;
  a = [].concat(a), i = [].concat(i), s = s || {};
  var c = {}, d = 0, f = !!(s && s.alwaysByViewport), p = H3(l, f), h = B3(l);
  j6(a, h), j6(i, t);
  var g = Rs(h, t, o, a, i), m = ge.merge(h, g);
  if (p && (s.adjustX || s.adjustY) && r) {
    if (s.adjustX && Z6(g, h, p)) {
      var v = Vs(o, /[lr]/gi, {
        l: "r",
        r: "l"
      }), w = ks(a, 0), C = ks(i, 0), y = Rs(h, t, v, w, C);
      qk(y, h, p) || (d = 1, o = v, a = w, i = C);
    }
    if (s.adjustY && $6(g, h, p)) {
      var x = Vs(o, /[tb]/gi, {
        t: "b",
        b: "t"
      }), E = ks(a, 1), S = ks(i, 1), I = Rs(h, t, x, E, S);
      Qk(I, h, p) || (d = 1, o = x, a = E, i = S);
    }
    d && (g = Rs(h, t, o, a, i), ge.mix(m, g));
    var D = Z6(g, h, p), N = $6(g, h, p);
    if (D || N) {
      var A = o;
      D && (A = Vs(o, /[lr]/gi, {
        l: "r",
        r: "l"
      })), N && (A = Vs(o, /[tb]/gi, {
        t: "b",
        b: "t"
      })), o = A, a = n.offset || [0, 0], i = n.targetOffset || [0, 0];
    }
    c.adjustX = s.adjustX && D, c.adjustY = s.adjustY && N, (c.adjustX || c.adjustY) && (m = Kk(g, h, p, c));
  }
  return m.width !== h.width && ge.css(l, "width", ge.width(l) + m.width - h.width), m.height !== h.height && ge.css(l, "height", ge.height(l) + m.height - h.height), ge.offset(l, {
    left: m.left,
    top: m.top
  }, {
    useCssRight: n.useCssRight,
    useCssBottom: n.useCssBottom,
    useCssTransform: n.useCssTransform,
    ignoreShake: n.ignoreShake
  }), {
    points: o,
    offset: a,
    targetOffset: i,
    overflow: c
  };
}
function eF(e, t) {
  var n = H3(e, t), r = B3(e);
  return !n || r.left + r.width <= n.left || r.top + r.height <= n.top || r.left >= n.right || r.top >= n.bottom;
}
function G3(e, t, n) {
  var r = n.target || t, o = B3(r), a = !eF(r, n.overflow && n.overflow.alwaysByViewport);
  return Bg(e, o, n, a);
}
G3.__getOffsetParent = yf;
G3.__getVisibleRectForElement = H3;
function tF(e, t, n) {
  var r, o, a = ge.getDocument(e), i = a.defaultView || a.parentWindow, s = ge.getWindowScrollLeft(i), l = ge.getWindowScrollTop(i), c = ge.viewportWidth(i), d = ge.viewportHeight(i);
  "pageX" in t ? r = t.pageX : r = s + t.clientX, "pageY" in t ? o = t.pageY : o = l + t.clientY;
  var f = {
    left: r,
    top: o,
    width: 0,
    height: 0
  }, p = r >= 0 && r <= s + c && o >= 0 && o <= l + d, h = [n.points[0], "cc"];
  return Bg(e, f, L6(L6({}, n), {}, {
    points: h
  }), p);
}
function nF(e, t) {
  var n = void 0;
  function r() {
    n && (clearTimeout(n), n = null);
  }
  function o() {
    r(), n = setTimeout(e, t);
  }
  return o.clear = r, o;
}
function rF(e, t) {
  return e === t ? !0 : !e || !t ? !1 : "pageX" in t && "pageY" in t ? e.pageX === t.pageX && e.pageY === t.pageY : "clientX" in t && "clientY" in t ? e.clientX === t.clientX && e.clientY === t.clientY : !1;
}
function z6(e) {
  return e && typeof e == "object" && e.window === e;
}
function X6(e, t) {
  var n = Math.floor(e), r = Math.floor(t);
  return Math.abs(n - r) <= 1;
}
function oF(e, t) {
  e !== document.activeElement && ff(t, e) && e.focus();
}
function Bd(e) {
  return typeof e != "function" || !e ? null : e();
}
function Gd(e) {
  return typeof e != "object" || !e ? null : e;
}
var Ll = function(e) {
  uo(t, e);
  function t() {
    var n, r, o, a;
    co(this, t);
    for (var i = arguments.length, s = Array(i), l = 0; l < i; l++)
      s[l] = arguments[l];
    return a = (r = (o = br(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(s))), o), o.forceAlign = function() {
      var c = o.props, d = c.disabled, f = c.target, p = c.align, h = c.onAlign;
      if (!d && f) {
        var g = kt.findDOMNode(o), m = void 0, v = Bd(f), w = Gd(f), C = document.activeElement;
        v ? m = G3(g, v, p) : w && (m = tF(g, w, p)), oF(C, g), h && h(g, m);
      }
    }, r), br(o, a);
  }
  return V3(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props;
      this.forceAlign(), !r.disabled && r.monitorWindowResize && this.startMonitorWindowResize();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var o = !1, a = this.props;
      if (!a.disabled) {
        var i = kt.findDOMNode(this), s = i ? i.getBoundingClientRect() : null;
        if (r.disabled)
          o = !0;
        else {
          var l = Bd(r.target), c = Bd(a.target), d = Gd(r.target), f = Gd(a.target);
          z6(l) && z6(c) ? o = !1 : (l !== c || // Element change
          l && !c && f || // Change from element to point
          d && f && c || // Change from point to element
          f && !rF(d, f)) && (o = !0);
          var p = this.sourceRect || {};
          !o && i && (!X6(p.width, s.width) || !X6(p.height, s.height)) && (o = !0);
        }
        this.sourceRect = s;
      }
      o && this.forceAlign(), a.monitorWindowResize && !a.disabled ? this.startMonitorWindowResize() : this.stopMonitorWindowResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: "startMonitorWindowResize",
    value: function() {
      this.resizeHandler || (this.bufferMonitor = nF(this.forceAlign, this.props.monitorBufferTime), this.resizeHandler = Ua(window, "resize", this.bufferMonitor));
    }
  }, {
    key: "stopMonitorWindowResize",
    value: function() {
      this.resizeHandler && (this.bufferMonitor.clear(), this.resizeHandler.remove(), this.resizeHandler = null);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props, a = o.childrenProps, i = o.children, s = X.Children.only(i);
      if (a) {
        var l = {}, c = Object.keys(a);
        return c.forEach(function(d) {
          l[d] = r.props[a[d]];
        }), X.cloneElement(s, l);
      }
      return s;
    }
  }]), t;
}(Mn);
Ll.propTypes = {
  childrenProps: M.object,
  align: M.object.isRequired,
  target: M.oneOfType([M.func, M.shape({
    clientX: M.number,
    clientY: M.number,
    pageX: M.number,
    pageY: M.number
  })]),
  onAlign: M.func,
  monitorBufferTime: M.number,
  monitorWindowResize: M.bool,
  disabled: M.bool,
  children: M.any
};
Ll.defaultProps = {
  target: function() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: !1,
  disabled: !1
};
var aF = Og, iF = sF(aF);
function sF(e) {
  return e && e.__esModule ? e : { default: e };
}
var lF = function(e, t, n) {
  return t in e ? (0, iF.default)(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}, cF = function(t) {
  var n = t.prototype;
  if (!n || !n.isReactComponent)
    throw new Error("Can only polyfill class components");
  return typeof n.componentWillReceiveProps != "function" || !X.Profiler || (n.UNSAFE_componentWillReceiveProps = n.componentWillReceiveProps, delete n.componentWillReceiveProps), t;
};
function ti(e) {
  var t = [];
  return X.Children.forEach(e, function(n) {
    t.push(n);
  }), t;
}
function Do(e, t) {
  var n = null;
  return e && e.forEach(function(r) {
    n || r && r.key === t && (n = r);
  }), n;
}
function Wd(e, t, n) {
  var r = null;
  return e && e.forEach(function(o) {
    if (o && o.key === t && o.props[n]) {
      if (r)
        throw new Error("two child with same key for <rc-animate> children");
      r = o;
    }
  }), r;
}
function uF(e, t, n) {
  var r = e.length === t.length;
  return r && e.forEach(function(o, a) {
    var i = t[a];
    o && i && (o && !i || !o && i || o.key !== i.key || n && o.props[n] !== i.props[n]) && (r = !1);
  }), r;
}
function dF(e, t) {
  var n = [], r = {}, o = [];
  return e.forEach(function(a) {
    a && Do(t, a.key) ? o.length && (r[a.key] = o, o = []) : o.push(a);
  }), t.forEach(function(a) {
    a && Object.prototype.hasOwnProperty.call(r, a.key) && (n = n.concat(r[a.key])), n.push(a);
  }), n = n.concat(o), n;
}
var Zd = {
  transitionstart: {
    transition: "transitionstart",
    WebkitTransition: "webkitTransitionStart",
    MozTransition: "mozTransitionStart",
    OTransition: "oTransitionStart",
    msTransition: "MSTransitionStart"
  },
  animationstart: {
    animation: "animationstart",
    WebkitAnimation: "webkitAnimationStart",
    MozAnimation: "mozAnimationStart",
    OAnimation: "oAnimationStart",
    msAnimation: "MSAnimationStart"
  }
}, $d = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
}, Mo = [], No = [];
function fF() {
  var e = document.createElement("div"), t = e.style;
  "AnimationEvent" in window || (delete Zd.animationstart.animation, delete $d.animationend.animation), "TransitionEvent" in window || (delete Zd.transitionstart.transition, delete $d.transitionend.transition);
  function n(r, o) {
    for (var a in r)
      if (r.hasOwnProperty(a)) {
        var i = r[a];
        for (var s in i)
          if (s in t) {
            o.push(i[s]);
            break;
          }
      }
  }
  n(Zd, Mo), n($d, No);
}
typeof window < "u" && typeof document < "u" && fF();
function U6(e, t, n) {
  e.addEventListener(t, n, !1);
}
function J6(e, t, n) {
  e.removeEventListener(t, n, !1);
}
var gi = {
  // Start events
  startEvents: Mo,
  addStartEventListener: function(t, n) {
    if (Mo.length === 0) {
      window.setTimeout(n, 0);
      return;
    }
    Mo.forEach(function(r) {
      U6(t, r, n);
    });
  },
  removeStartEventListener: function(t, n) {
    Mo.length !== 0 && Mo.forEach(function(r) {
      J6(t, r, n);
    });
  },
  // End events
  endEvents: No,
  addEndEventListener: function(t, n) {
    if (No.length === 0) {
      window.setTimeout(n, 0);
      return;
    }
    No.forEach(function(r) {
      U6(t, r, n);
    });
  },
  removeEndEventListener: function(t, n) {
    No.length !== 0 && No.forEach(function(r) {
      J6(t, r, n);
    });
  }
}, Yd, K6;
function q6() {
  return K6 || (K6 = 1, Yd = function(e, t) {
    if (e.indexOf)
      return e.indexOf(t);
    for (var n = 0; n < e.length; ++n)
      if (e[n] === t)
        return n;
    return -1;
  }), Yd;
}
try {
  var nu = q6();
} catch {
  var nu = q6();
}
var pF = /\s+/, hF = Object.prototype.toString, mF = function(e) {
  return new Cr(e);
};
function Cr(e) {
  if (!e || !e.nodeType)
    throw new Error("A DOM element reference is required");
  this.el = e, this.list = e.classList;
}
Cr.prototype.add = function(e) {
  if (this.list)
    return this.list.add(e), this;
  var t = this.array(), n = nu(t, e);
  return ~n || t.push(e), this.el.className = t.join(" "), this;
};
Cr.prototype.remove = function(e) {
  if (hF.call(e) == "[object RegExp]")
    return this.removeMatching(e);
  if (this.list)
    return this.list.remove(e), this;
  var t = this.array(), n = nu(t, e);
  return ~n && t.splice(n, 1), this.el.className = t.join(" "), this;
};
Cr.prototype.removeMatching = function(e) {
  for (var t = this.array(), n = 0; n < t.length; n++)
    e.test(t[n]) && this.remove(t[n]);
  return this;
};
Cr.prototype.toggle = function(e, t) {
  return this.list ? (typeof t < "u" ? t !== this.list.toggle(e, t) && this.list.toggle(e) : this.list.toggle(e), this) : (typeof t < "u" ? t ? this.add(e) : this.remove(e) : this.has(e) ? this.remove(e) : this.add(e), this);
};
Cr.prototype.array = function() {
  var e = this.el.getAttribute("class") || "", t = e.replace(/^\s+|\s+$/g, ""), n = t.split(pF);
  return n[0] === "" && n.shift(), n;
};
Cr.prototype.has = Cr.prototype.contains = function(e) {
  return this.list ? this.list.contains(e) : !!~nu(this.array(), e);
};
const vF = /* @__PURE__ */ ua(mF);
var W3 = gi.endEvents.length !== 0, gF = [
  "Webkit",
  "Moz",
  "O",
  // ms is special .... !
  "ms"
], Q6 = ["-webkit-", "-moz-", "-o-", "ms-", ""];
function Fs(e, t) {
  for (var n = window.getComputedStyle(e, null), r = "", o = 0; o < Q6.length && (r = n.getPropertyValue(Q6[o] + t), !r); o++)
    ;
  return r;
}
function Gg(e) {
  if (W3) {
    var t = parseFloat(Fs(e, "transition-delay")) || 0, n = parseFloat(Fs(e, "transition-duration")) || 0, r = parseFloat(Fs(e, "animation-delay")) || 0, o = parseFloat(Fs(e, "animation-duration")) || 0, a = Math.max(n + t, o + r);
    e.rcEndAnimTimeout = setTimeout(function() {
      e.rcEndAnimTimeout = null, e.rcEndListener && e.rcEndListener();
    }, a * 1e3 + 200);
  }
}
function Wg(e) {
  e.rcEndAnimTimeout && (clearTimeout(e.rcEndAnimTimeout), e.rcEndAnimTimeout = null);
}
var ru = function(t, n, r) {
  var o = (typeof n > "u" ? "undefined" : GV(n)) === "object", a = o ? n.name : n, i = o ? n.active : n + "-active", s = r, l = void 0, c = void 0, d = vF(t);
  return r && Object.prototype.toString.call(r) === "[object Object]" && (s = r.end, l = r.start, c = r.active), t.rcEndListener && t.rcEndListener(), t.rcEndListener = function(f) {
    f && f.target !== t || (t.rcAnimTimeout && (clearTimeout(t.rcAnimTimeout), t.rcAnimTimeout = null), Wg(t), d.remove(a), d.remove(i), gi.removeEndEventListener(t, t.rcEndListener), t.rcEndListener = null, s && s());
  }, gi.addEndEventListener(t, t.rcEndListener), l && l(), d.add(a), t.rcAnimTimeout = setTimeout(function() {
    t.rcAnimTimeout = null, d.add(i), c && setTimeout(c, 0), Gg(t);
  }, 30), {
    stop: function() {
      t.rcEndListener && t.rcEndListener();
    }
  };
};
ru.style = function(e, t, n) {
  e.rcEndListener && e.rcEndListener(), e.rcEndListener = function(r) {
    r && r.target !== e || (e.rcAnimTimeout && (clearTimeout(e.rcAnimTimeout), e.rcAnimTimeout = null), Wg(e), gi.removeEndEventListener(e, e.rcEndListener), e.rcEndListener = null, n && n());
  }, gi.addEndEventListener(e, e.rcEndListener), e.rcAnimTimeout = setTimeout(function() {
    for (var r in t)
      t.hasOwnProperty(r) && (e.style[r] = t[r]);
    e.rcAnimTimeout = null, Gg(e);
  }, 0);
};
ru.setTransition = function(e, t, n) {
  var r = t, o = n;
  n === void 0 && (o = r, r = ""), r = r || "", gF.forEach(function(a) {
    e.style[a + "Transition" + r] = o;
  });
};
ru.isCssAnimationSupported = W3;
var Bo = {
  isAppearSupported: function(t) {
    return t.transitionName && t.transitionAppear || t.animation.appear;
  },
  isEnterSupported: function(t) {
    return t.transitionName && t.transitionEnter || t.animation.enter;
  },
  isLeaveSupported: function(t) {
    return t.transitionName && t.transitionLeave || t.animation.leave;
  },
  allowAppearCallback: function(t) {
    return t.transitionAppear || t.animation.appear;
  },
  allowEnterCallback: function(t) {
    return t.transitionEnter || t.animation.enter;
  },
  allowLeaveCallback: function(t) {
    return t.transitionLeave || t.animation.leave;
  }
}, wF = {
  enter: "transitionEnter",
  appear: "transitionAppear",
  leave: "transitionLeave"
}, Zg = function(e) {
  uo(t, e);
  function t() {
    return co(this, t), br(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }
  return V3(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.stop();
    }
  }, {
    key: "componentWillEnter",
    value: function(r) {
      Bo.isEnterSupported(this.props) ? this.transition("enter", r) : r();
    }
  }, {
    key: "componentWillAppear",
    value: function(r) {
      Bo.isAppearSupported(this.props) ? this.transition("appear", r) : r();
    }
  }, {
    key: "componentWillLeave",
    value: function(r) {
      Bo.isLeaveSupported(this.props) ? this.transition("leave", r) : r();
    }
  }, {
    key: "transition",
    value: function(r, o) {
      var a = this, i = kt.findDOMNode(this), s = this.props, l = s.transitionName, c = typeof l == "object";
      this.stop();
      var d = function() {
        a.stopper = null, o();
      };
      if ((W3 || !s.animation[r]) && l && s[wF[r]]) {
        var f = c ? l[r] : l + "-" + r, p = f + "-active";
        c && l[r + "Active"] && (p = l[r + "Active"]), this.stopper = ru(i, {
          name: f,
          active: p
        }, d);
      } else
        this.stopper = s.animation[r](i, d);
    }
  }, {
    key: "stop",
    value: function() {
      var r = this.stopper;
      r && (this.stopper = null, r.stop());
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), t;
}(X.Component);
Zg.propTypes = {
  children: M.any,
  animation: M.any,
  transitionName: M.any
};
var bF = "rc_animate_" + Date.now();
function ni(e) {
  var t = e.children;
  return X.isValidElement(t) && !t.key ? X.cloneElement(t, {
    key: bF
  }) : t;
}
function Hs() {
}
var ou = function(e) {
  uo(t, e);
  function t(n) {
    co(this, t);
    var r = br(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return CF.call(r), r.currentlyAnimatingKeys = {}, r.keysToEnter = [], r.keysToLeave = [], r.state = {
      children: ti(ni(n))
    }, r.childrenRefs = {}, r;
  }
  return V3(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this, o = this.props.showProp, a = this.state.children;
      o && (a = a.filter(function(i) {
        return !!i.props[o];
      })), a.forEach(function(i) {
        i && r.performAppear(i.key);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function(r) {
      var o = this;
      this.nextProps = r;
      var a = ti(ni(r)), i = this.props;
      i.exclusive && Object.keys(this.currentlyAnimatingKeys).forEach(function(f) {
        o.stop(f);
      });
      var s = i.showProp, l = this.currentlyAnimatingKeys, c = i.exclusive ? ti(ni(i)) : this.state.children, d = [];
      s ? (c.forEach(function(f) {
        var p = f && Do(a, f.key), h = void 0;
        (!p || !p.props[s]) && f.props[s] ? h = X.cloneElement(p || f, lF({}, s, !0)) : h = p, h && d.push(h);
      }), a.forEach(function(f) {
        (!f || !Do(c, f.key)) && d.push(f);
      })) : d = dF(c, a), this.setState({
        children: d
      }), a.forEach(function(f) {
        var p = f && f.key;
        if (!(f && l[p])) {
          var h = f && Do(c, p);
          if (s) {
            var g = f.props[s];
            if (h) {
              var m = Wd(c, p, s);
              !m && g && o.keysToEnter.push(p);
            } else
              g && o.keysToEnter.push(p);
          } else
            h || o.keysToEnter.push(p);
        }
      }), c.forEach(function(f) {
        var p = f && f.key;
        if (!(f && l[p])) {
          var h = f && Do(a, p);
          if (s) {
            var g = f.props[s];
            if (h) {
              var m = Wd(a, p, s);
              !m && g && o.keysToLeave.push(p);
            } else
              g && o.keysToLeave.push(p);
          } else
            h || o.keysToLeave.push(p);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r = this.keysToEnter;
      this.keysToEnter = [], r.forEach(this.performEnter);
      var o = this.keysToLeave;
      this.keysToLeave = [], o.forEach(this.performLeave);
    }
  }, {
    key: "isValidChildByKey",
    value: function(r, o) {
      var a = this.props.showProp;
      return a ? Wd(r, o, a) : Do(r, o);
    }
  }, {
    key: "stop",
    value: function(r) {
      delete this.currentlyAnimatingKeys[r];
      var o = this.childrenRefs[r];
      o && o.stop();
    }
  }, {
    key: "render",
    value: function() {
      var r = this, o = this.props;
      this.nextProps = o;
      var a = this.state.children, i = null;
      a && (i = a.map(function(c) {
        if (c == null)
          return c;
        if (!c.key)
          throw new Error("must set key for <rc-animate> children");
        return X.createElement(
          Zg,
          {
            key: c.key,
            ref: function(f) {
              r.childrenRefs[c.key] = f;
            },
            animation: o.animation,
            transitionName: o.transitionName,
            transitionEnter: o.transitionEnter,
            transitionAppear: o.transitionAppear,
            transitionLeave: o.transitionLeave
          },
          c
        );
      }));
      var s = o.component;
      if (s) {
        var l = o;
        return typeof s == "string" && (l = Fo({
          className: o.className,
          style: o.style
        }, o.componentProps)), X.createElement(
          s,
          l,
          i
        );
      }
      return i[0] || null;
    }
  }]), t;
}(X.Component);
ou.isAnimate = !0;
ou.propTypes = {
  className: M.string,
  style: M.object,
  component: M.any,
  componentProps: M.object,
  animation: M.object,
  transitionName: M.oneOfType([M.string, M.object]),
  transitionEnter: M.bool,
  transitionAppear: M.bool,
  exclusive: M.bool,
  transitionLeave: M.bool,
  onEnd: M.func,
  onEnter: M.func,
  onLeave: M.func,
  onAppear: M.func,
  showProp: M.string,
  children: M.node
};
ou.defaultProps = {
  animation: {},
  component: "span",
  componentProps: {},
  transitionEnter: !0,
  transitionLeave: !0,
  transitionAppear: !1,
  onEnd: Hs,
  onEnter: Hs,
  onLeave: Hs,
  onAppear: Hs
};
var CF = function() {
  var t = this;
  this.performEnter = function(n) {
    t.childrenRefs[n] && (t.currentlyAnimatingKeys[n] = !0, t.childrenRefs[n].componentWillEnter(t.handleDoneAdding.bind(t, n, "enter")));
  }, this.performAppear = function(n) {
    t.childrenRefs[n] && (t.currentlyAnimatingKeys[n] = !0, t.childrenRefs[n].componentWillAppear(t.handleDoneAdding.bind(t, n, "appear")));
  }, this.handleDoneAdding = function(n, r) {
    var o = t.props;
    if (delete t.currentlyAnimatingKeys[n], !(o.exclusive && o !== t.nextProps)) {
      var a = ti(ni(o));
      t.isValidChildByKey(a, n) ? r === "appear" ? Bo.allowAppearCallback(o) && (o.onAppear(n), o.onEnd(n, !0)) : Bo.allowEnterCallback(o) && (o.onEnter(n), o.onEnd(n, !0)) : t.performLeave(n);
    }
  }, this.performLeave = function(n) {
    t.childrenRefs[n] && (t.currentlyAnimatingKeys[n] = !0, t.childrenRefs[n].componentWillLeave(t.handleDoneLeaving.bind(t, n)));
  }, this.handleDoneLeaving = function(n) {
    var r = t.props;
    if (delete t.currentlyAnimatingKeys[n], !(r.exclusive && r !== t.nextProps)) {
      var o = ti(ni(r));
      if (t.isValidChildByKey(o, n))
        t.performEnter(n);
      else {
        var a = function() {
          Bo.allowLeaveCallback(r) && (r.onLeave(n), r.onEnd(n, !1));
        };
        uF(t.state.children, o, r.showProp) ? a() : t.setState({
          children: o
        }, a);
      }
    }
  };
};
const jd = cF(ou);
var yF = function(e, t) {
  var n = {};
  for (var r in e)
    t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  return n;
}, Z3 = function(e) {
  uo(t, e);
  function t() {
    return co(this, t), br(this, e.apply(this, arguments));
  }
  return t.prototype.shouldComponentUpdate = function(r) {
    return r.hiddenClassName || r.visible;
  }, t.prototype.render = function() {
    var r = this.props, o = r.hiddenClassName, a = r.visible, i = yF(r, ["hiddenClassName", "visible"]);
    return o || X.Children.count(i.children) > 1 ? (!a && o && (i.className += " " + o), X.createElement("div", i)) : X.Children.only(i.children);
  }, t;
}(Mn);
Z3.propTypes = {
  children: M.any,
  className: M.string,
  visible: M.bool,
  hiddenClassName: M.string
};
var xf = function(e) {
  uo(t, e);
  function t() {
    return co(this, t), br(this, e.apply(this, arguments));
  }
  return t.prototype.render = function() {
    var r = this.props, o = r.className;
    return r.visible || (o += " " + r.hiddenClassName), X.createElement(
      "div",
      {
        className: o,
        onMouseEnter: r.onMouseEnter,
        onMouseLeave: r.onMouseLeave,
        onMouseDown: r.onMouseDown,
        onTouchStart: r.onTouchStart,
        style: r.style
      },
      X.createElement(
        Z3,
        { className: r.prefixCls + "-content", visible: r.visible },
        r.children
      )
    );
  }, t;
}(Mn);
xf.propTypes = {
  hiddenClassName: M.string,
  className: M.string,
  prefixCls: M.string,
  onMouseEnter: M.func,
  onMouseLeave: M.func,
  onMouseDown: M.func,
  onTouchStart: M.func,
  children: M.any
};
var $g = function(e) {
  uo(t, e);
  function t(n) {
    co(this, t);
    var r = br(this, e.call(this, n));
    return xF.call(r), r.state = {
      // Used for stretch
      stretchChecked: !1,
      targetWidth: void 0,
      targetHeight: void 0
    }, r.savePopupRef = O6.bind(r, "popupInstance"), r.saveAlignRef = O6.bind(r, "alignInstance"), r;
  }
  return t.prototype.componentDidMount = function() {
    this.rootNode = this.getPopupDomNode(), this.setStretchSize();
  }, t.prototype.componentDidUpdate = function() {
    this.setStretchSize();
  }, t.prototype.getPopupDomNode = function() {
    return kt.findDOMNode(this.popupInstance);
  }, t.prototype.getMaskTransitionName = function() {
    var r = this.props, o = r.maskTransitionName, a = r.maskAnimation;
    return !o && a && (o = r.prefixCls + "-" + a), o;
  }, t.prototype.getTransitionName = function() {
    var r = this.props, o = r.transitionName;
    return !o && r.animation && (o = r.prefixCls + "-" + r.animation), o;
  }, t.prototype.getClassName = function(r) {
    return this.props.prefixCls + " " + this.props.className + " " + r;
  }, t.prototype.getPopupElement = function() {
    var r = this, o = this.savePopupRef, a = this.state, i = a.stretchChecked, s = a.targetHeight, l = a.targetWidth, c = this.props, d = c.align, f = c.visible, p = c.prefixCls, h = c.style, g = c.getClassNameFromAlign, m = c.destroyPopupOnHide, v = c.stretch, w = c.children, C = c.onMouseEnter, y = c.onMouseLeave, x = c.onMouseDown, E = c.onTouchStart, S = this.getClassName(this.currentAlignClassName || g(d)), I = p + "-hidden";
    f || (this.currentAlignClassName = null);
    var D = {};
    v && (v.indexOf("height") !== -1 ? D.height = s : v.indexOf("minHeight") !== -1 && (D.minHeight = s), v.indexOf("width") !== -1 ? D.width = l : v.indexOf("minWidth") !== -1 && (D.minWidth = l), i || (D.visibility = "hidden", setTimeout(function() {
      r.alignInstance && r.alignInstance.forceAlign();
    }, 0)));
    var N = Fo({}, D, h, this.getZIndexStyle()), A = {
      className: S,
      prefixCls: p,
      ref: o,
      onMouseEnter: C,
      onMouseLeave: y,
      onMouseDown: x,
      onTouchStart: E,
      style: N
    };
    return m ? X.createElement(
      jd,
      {
        component: "",
        exclusive: !0,
        transitionAppear: !0,
        transitionName: this.getTransitionName()
      },
      f ? X.createElement(
        Ll,
        {
          target: this.getAlignTarget(),
          key: "popup",
          ref: this.saveAlignRef,
          monitorWindowResize: !0,
          align: d,
          onAlign: this.onAlign
        },
        X.createElement(
          xf,
          Fo({
            visible: !0
          }, A),
          w
        )
      ) : null
    ) : X.createElement(
      jd,
      {
        component: "",
        exclusive: !0,
        transitionAppear: !0,
        transitionName: this.getTransitionName(),
        showProp: "xVisible"
      },
      X.createElement(
        Ll,
        {
          target: this.getAlignTarget(),
          key: "popup",
          ref: this.saveAlignRef,
          monitorWindowResize: !0,
          xVisible: f,
          childrenProps: { visible: "xVisible" },
          disabled: !f,
          align: d,
          onAlign: this.onAlign
        },
        X.createElement(
          xf,
          Fo({
            hiddenClassName: I
          }, A),
          w
        )
      )
    );
  }, t.prototype.getZIndexStyle = function() {
    var r = {}, o = this.props;
    return o.zIndex !== void 0 && (r.zIndex = o.zIndex), r;
  }, t.prototype.getMaskElement = function() {
    var r = this.props, o = void 0;
    if (r.mask) {
      var a = this.getMaskTransitionName();
      o = X.createElement(Z3, {
        style: this.getZIndexStyle(),
        key: "mask",
        className: r.prefixCls + "-mask",
        hiddenClassName: r.prefixCls + "-mask-hidden",
        visible: r.visible
      }), a && (o = X.createElement(
        jd,
        {
          key: "mask",
          showProp: "visible",
          transitionAppear: !0,
          component: "",
          transitionName: a
        },
        o
      ));
    }
    return o;
  }, t.prototype.render = function() {
    return X.createElement(
      "div",
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  }, t;
}(Mn);
$g.propTypes = {
  visible: M.bool,
  style: M.object,
  getClassNameFromAlign: M.func,
  onAlign: M.func,
  getRootDomNode: M.func,
  align: M.any,
  destroyPopupOnHide: M.bool,
  className: M.string,
  prefixCls: M.string,
  onMouseEnter: M.func,
  onMouseLeave: M.func,
  onMouseDown: M.func,
  onTouchStart: M.func,
  stretch: M.string,
  children: M.node,
  point: M.shape({
    pageX: M.number,
    pageY: M.number
  })
};
var xF = function() {
  var t = this;
  this.onAlign = function(n, r) {
    var o = t.props, a = o.getClassNameFromAlign(r);
    t.currentAlignClassName !== a && (t.currentAlignClassName = a, n.className = t.getClassName(a)), o.onAlign(n, r);
  }, this.setStretchSize = function() {
    var n = t.props, r = n.stretch, o = n.getRootDomNode, a = n.visible, i = t.state, s = i.stretchChecked, l = i.targetHeight, c = i.targetWidth;
    if (!r || !a) {
      s && t.setState({ stretchChecked: !1 });
      return;
    }
    var d = o();
    if (d) {
      var f = d.offsetHeight, p = d.offsetWidth;
      (l !== f || c !== p || !s) && t.setState({
        stretchChecked: !0,
        targetHeight: f,
        targetWidth: p
      });
    }
  }, this.getTargetElement = function() {
    return t.props.getRootDomNode();
  }, this.getAlignTarget = function() {
    var n = t.props.point;
    return n || t.getTargetElement;
  };
};
function zd() {
}
function EF() {
  return "";
}
function IF() {
  return window.document;
}
var SF = ["onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur", "onContextMenu"], ep = !!A7, Yg = {
  rcTrigger: M.shape({
    onPopupMouseDown: M.func
  })
}, Ca = function(e) {
  uo(t, e);
  function t(n) {
    co(this, t);
    var r = br(this, e.call(this, n));
    DF.call(r);
    var o = void 0;
    return "popupVisible" in n ? o = !!n.popupVisible : o = !!n.defaultPopupVisible, r.state = {
      prevPopupVisible: o,
      popupVisible: o
    }, SF.forEach(function(a) {
      r["fire" + a] = function(i) {
        r.fireEvents(a, i);
      };
    }), r;
  }
  return t.prototype.getChildContext = function() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  }, t.prototype.componentDidMount = function() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  }, t.prototype.componentDidUpdate = function(r, o) {
    var a = this.props, i = this.state, s = function() {
      o.popupVisible !== i.popupVisible && a.afterPopupVisibleChange(i.popupVisible);
    };
    if (ep || this.renderComponent(null, s), i.popupVisible) {
      var l = void 0;
      !this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow()) && (l = a.getDocument(), this.clickOutsideHandler = Ua(l, "mousedown", this.onDocumentClick)), this.touchOutsideHandler || (l = l || a.getDocument(), this.touchOutsideHandler = Ua(l, "touchstart", this.onDocumentClick)), !this.contextMenuOutsideHandler1 && this.isContextMenuToShow() && (l = l || a.getDocument(), this.contextMenuOutsideHandler1 = Ua(l, "scroll", this.onContextMenuClose)), !this.contextMenuOutsideHandler2 && this.isContextMenuToShow() && (this.contextMenuOutsideHandler2 = Ua(window, "blur", this.onContextMenuClose));
      return;
    }
    this.clearOutsideHandler();
  }, t.prototype.componentWillUnmount = function() {
    this.clearDelayTimer(), this.clearOutsideHandler(), clearTimeout(this.mouseDownTimeout);
  }, t.getDerivedStateFromProps = function(r, o) {
    var a = r.popupVisible, i = {};
    return a !== void 0 && o.popupVisible !== a && (i.popupVisible = a, i.prevPopupVisible = o.popupVisible), i;
  }, t.prototype.getPopupDomNode = function() {
    return this._component && this._component.getPopupDomNode ? this._component.getPopupDomNode() : null;
  }, t.prototype.getPopupAlign = function() {
    var r = this.props, o = r.popupPlacement, a = r.popupAlign, i = r.builtinPlacements;
    return o && i ? xk(i, o, a) : a;
  }, t.prototype.setPopupVisible = function(r, o) {
    var a = this.props.alignPoint, i = this.state.popupVisible;
    this.clearDelayTimer(), i !== r && ("popupVisible" in this.props || this.setState({ popupVisible: r, prevPopupVisible: i }), this.props.onPopupVisibleChange(r)), a && o && this.setPoint(o);
  }, t.prototype.delaySetPopupVisible = function(r, o, a) {
    var i = this, s = o * 1e3;
    if (this.clearDelayTimer(), s) {
      var l = a ? { pageX: a.pageX, pageY: a.pageY } : null;
      this.delayTimer = setTimeout(function() {
        i.setPopupVisible(r, l), i.clearDelayTimer();
      }, s);
    } else
      this.setPopupVisible(r, a);
  }, t.prototype.clearDelayTimer = function() {
    this.delayTimer && (clearTimeout(this.delayTimer), this.delayTimer = null);
  }, t.prototype.clearOutsideHandler = function() {
    this.clickOutsideHandler && (this.clickOutsideHandler.remove(), this.clickOutsideHandler = null), this.contextMenuOutsideHandler1 && (this.contextMenuOutsideHandler1.remove(), this.contextMenuOutsideHandler1 = null), this.contextMenuOutsideHandler2 && (this.contextMenuOutsideHandler2.remove(), this.contextMenuOutsideHandler2 = null), this.touchOutsideHandler && (this.touchOutsideHandler.remove(), this.touchOutsideHandler = null);
  }, t.prototype.createTwoChains = function(r) {
    var o = this.props.children.props, a = this.props;
    return o[r] && a[r] ? this["fire" + r] : o[r] || a[r];
  }, t.prototype.isClickToShow = function() {
    var r = this.props, o = r.action, a = r.showAction;
    return o.indexOf("click") !== -1 || a.indexOf("click") !== -1;
  }, t.prototype.isContextMenuToShow = function() {
    var r = this.props, o = r.action, a = r.showAction;
    return o.indexOf("contextMenu") !== -1 || a.indexOf("contextMenu") !== -1;
  }, t.prototype.isClickToHide = function() {
    var r = this.props, o = r.action, a = r.hideAction;
    return o.indexOf("click") !== -1 || a.indexOf("click") !== -1;
  }, t.prototype.isMouseEnterToShow = function() {
    var r = this.props, o = r.action, a = r.showAction;
    return o.indexOf("hover") !== -1 || a.indexOf("mouseEnter") !== -1;
  }, t.prototype.isMouseLeaveToHide = function() {
    var r = this.props, o = r.action, a = r.hideAction;
    return o.indexOf("hover") !== -1 || a.indexOf("mouseLeave") !== -1;
  }, t.prototype.isFocusToShow = function() {
    var r = this.props, o = r.action, a = r.showAction;
    return o.indexOf("focus") !== -1 || a.indexOf("focus") !== -1;
  }, t.prototype.isBlurToHide = function() {
    var r = this.props, o = r.action, a = r.hideAction;
    return o.indexOf("focus") !== -1 || a.indexOf("blur") !== -1;
  }, t.prototype.forcePopupAlign = function() {
    this.state.popupVisible && this._component && this._component.alignInstance && this._component.alignInstance.forceAlign();
  }, t.prototype.fireEvents = function(r, o) {
    var a = this.props.children.props[r];
    a && a(o);
    var i = this.props[r];
    i && i(o);
  }, t.prototype.close = function() {
    this.setPopupVisible(!1);
  }, t.prototype.render = function() {
    var r = this, o = this.state.popupVisible, a = this.props, i = a.children, s = a.forceRender, l = a.alignPoint, c = a.className, d = X.Children.only(i), f = { key: "trigger" };
    this.isContextMenuToShow() ? f.onContextMenu = this.onContextMenu : f.onContextMenu = this.createTwoChains("onContextMenu"), this.isClickToHide() || this.isClickToShow() ? (f.onClick = this.onClick, f.onMouseDown = this.onMouseDown, f.onTouchStart = this.onTouchStart) : (f.onClick = this.createTwoChains("onClick"), f.onMouseDown = this.createTwoChains("onMouseDown"), f.onTouchStart = this.createTwoChains("onTouchStart")), this.isMouseEnterToShow() ? (f.onMouseEnter = this.onMouseEnter, l && (f.onMouseMove = this.onMouseMove)) : f.onMouseEnter = this.createTwoChains("onMouseEnter"), this.isMouseLeaveToHide() ? f.onMouseLeave = this.onMouseLeave : f.onMouseLeave = this.createTwoChains("onMouseLeave"), this.isFocusToShow() || this.isBlurToHide() ? (f.onFocus = this.onFocus, f.onBlur = this.onBlur) : (f.onFocus = this.createTwoChains("onFocus"), f.onBlur = this.createTwoChains("onBlur"));
    var p = _t(d && d.props && d.props.className, c);
    p && (f.className = p);
    var h = X.cloneElement(d, f);
    if (!ep)
      return X.createElement(
        R3,
        {
          parent: this,
          visible: o,
          autoMount: !1,
          forceRender: s,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function(m) {
          var v = m.renderComponent;
          return r.renderComponent = v, h;
        }
      );
    var g = void 0;
    return (o || this._component || s) && (g = X.createElement(
      Ag,
      { key: "portal", getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
      this.getComponent()
    )), [h, g];
  }, t;
}(X.Component);
Ca.propTypes = {
  children: M.any,
  action: M.oneOfType([M.string, M.arrayOf(M.string)]),
  showAction: M.any,
  hideAction: M.any,
  getPopupClassNameFromAlign: M.any,
  onPopupVisibleChange: M.func,
  afterPopupVisibleChange: M.func,
  popup: M.oneOfType([M.node, M.func]).isRequired,
  popupStyle: M.object,
  prefixCls: M.string,
  popupClassName: M.string,
  className: M.string,
  popupPlacement: M.string,
  builtinPlacements: M.object,
  popupTransitionName: M.oneOfType([M.string, M.object]),
  popupAnimation: M.any,
  mouseEnterDelay: M.number,
  mouseLeaveDelay: M.number,
  zIndex: M.number,
  focusDelay: M.number,
  blurDelay: M.number,
  getPopupContainer: M.func,
  getDocument: M.func,
  forceRender: M.bool,
  destroyPopupOnHide: M.bool,
  mask: M.bool,
  maskClosable: M.bool,
  onPopupAlign: M.func,
  popupAlign: M.object,
  popupVisible: M.bool,
  defaultPopupVisible: M.bool,
  maskTransitionName: M.oneOfType([M.string, M.object]),
  maskAnimation: M.string,
  stretch: M.string,
  alignPoint: M.bool
  // Maybe we can support user pass position in the future
};
Ca.contextTypes = Yg;
Ca.childContextTypes = Yg;
Ca.defaultProps = {
  prefixCls: "rc-trigger-popup",
  getPopupClassNameFromAlign: EF,
  getDocument: IF,
  onPopupVisibleChange: zd,
  afterPopupVisibleChange: zd,
  onPopupAlign: zd,
  popupClassName: "",
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: !1,
  popupAlign: {},
  defaultPopupVisible: !1,
  mask: !1,
  maskClosable: !0,
  action: [],
  showAction: [],
  hideAction: []
};
var DF = function() {
  var t = this;
  this.onMouseEnter = function(n) {
    var r = t.props.mouseEnterDelay;
    t.fireEvents("onMouseEnter", n), t.delaySetPopupVisible(!0, r, r ? null : n);
  }, this.onMouseMove = function(n) {
    t.fireEvents("onMouseMove", n), t.setPoint(n);
  }, this.onMouseLeave = function(n) {
    t.fireEvents("onMouseLeave", n), t.delaySetPopupVisible(!1, t.props.mouseLeaveDelay);
  }, this.onPopupMouseEnter = function() {
    t.clearDelayTimer();
  }, this.onPopupMouseLeave = function(n) {
    n.relatedTarget && !n.relatedTarget.setTimeout && t._component && t._component.getPopupDomNode && ff(t._component.getPopupDomNode(), n.relatedTarget) || t.delaySetPopupVisible(!1, t.props.mouseLeaveDelay);
  }, this.onFocus = function(n) {
    t.fireEvents("onFocus", n), t.clearDelayTimer(), t.isFocusToShow() && (t.focusTime = Date.now(), t.delaySetPopupVisible(!0, t.props.focusDelay));
  }, this.onMouseDown = function(n) {
    t.fireEvents("onMouseDown", n), t.preClickTime = Date.now();
  }, this.onTouchStart = function(n) {
    t.fireEvents("onTouchStart", n), t.preTouchTime = Date.now();
  }, this.onBlur = function(n) {
    t.fireEvents("onBlur", n), t.clearDelayTimer(), t.isBlurToHide() && t.delaySetPopupVisible(!1, t.props.blurDelay);
  }, this.onContextMenu = function(n) {
    n.preventDefault(), t.fireEvents("onContextMenu", n), t.setPopupVisible(!0, n);
  }, this.onContextMenuClose = function() {
    t.isContextMenuToShow() && t.close();
  }, this.onClick = function(n) {
    if (t.fireEvents("onClick", n), t.focusTime) {
      var r = void 0;
      if (t.preClickTime && t.preTouchTime ? r = Math.min(t.preClickTime, t.preTouchTime) : t.preClickTime ? r = t.preClickTime : t.preTouchTime && (r = t.preTouchTime), Math.abs(r - t.focusTime) < 20)
        return;
      t.focusTime = 0;
    }
    t.preClickTime = 0, t.preTouchTime = 0, t.isClickToShow() && (t.isClickToHide() || t.isBlurToHide()) && n && n.preventDefault && n.preventDefault();
    var o = !t.state.popupVisible;
    (t.isClickToHide() && !o || o && t.isClickToShow()) && t.setPopupVisible(!t.state.popupVisible, n);
  }, this.onPopupMouseDown = function() {
    var n = t.context.rcTrigger, r = n === void 0 ? {} : n;
    t.hasPopupMouseDown = !0, clearTimeout(t.mouseDownTimeout), t.mouseDownTimeout = setTimeout(function() {
      t.hasPopupMouseDown = !1;
    }, 0), r.onPopupMouseDown && r.onPopupMouseDown.apply(r, arguments);
  }, this.onDocumentClick = function(n) {
    if (!(t.props.mask && !t.props.maskClosable)) {
      var r = n.target, o = Vu(t);
      !ff(o, r) && !t.hasPopupMouseDown && t.close();
    }
  }, this.getRootDomNode = function() {
    return Vu(t);
  }, this.getPopupClassNameFromAlign = function(n) {
    var r = [], o = t.props, a = o.popupPlacement, i = o.builtinPlacements, s = o.prefixCls, l = o.alignPoint, c = o.getPopupClassNameFromAlign;
    return a && i && r.push(Ek(i, s, n, l)), c && r.push(c(n)), r.join(" ");
  }, this.getComponent = function() {
    var n = t.props, r = n.prefixCls, o = n.destroyPopupOnHide, a = n.popupClassName, i = n.action, s = n.onPopupAlign, l = n.popupAnimation, c = n.popupTransitionName, d = n.popupStyle, f = n.mask, p = n.maskAnimation, h = n.maskTransitionName, g = n.zIndex, m = n.popup, v = n.stretch, w = n.alignPoint, C = t.state, y = C.popupVisible, x = C.point, E = t.getPopupAlign(), S = {};
    return t.isMouseEnterToShow() && (S.onMouseEnter = t.onPopupMouseEnter), t.isMouseLeaveToHide() && (S.onMouseLeave = t.onPopupMouseLeave), S.onMouseDown = t.onPopupMouseDown, S.onTouchStart = t.onPopupMouseDown, X.createElement(
      $g,
      Fo({
        prefixCls: r,
        destroyPopupOnHide: o,
        visible: y,
        point: w && x,
        className: a,
        action: i,
        align: E,
        onAlign: s,
        animation: l,
        getClassNameFromAlign: t.getPopupClassNameFromAlign
      }, S, {
        stretch: v,
        getRootDomNode: t.getRootDomNode,
        style: d,
        mask: f,
        zIndex: g,
        transitionName: c,
        maskAnimation: p,
        maskTransitionName: h,
        ref: t.savePopup
      }),
      typeof m == "function" ? m() : m
    );
  }, this.getContainer = function() {
    var n = t.props, r = document.createElement("div");
    r.style.position = "absolute", r.style.top = "0", r.style.left = "0", r.style.width = "100%";
    var o = n.getPopupContainer ? n.getPopupContainer(Vu(t)) : n.getDocument().body;
    return o.appendChild(r), r;
  }, this.setPoint = function(n) {
    var r = t.props.alignPoint;
    !r || !n || t.setState({
      point: {
        pageX: n.pageX,
        pageY: n.pageY
      }
    });
  }, this.handlePortalUpdate = function() {
    t.state.prevPopupVisible !== t.state.popupVisible && t.props.afterPopupVisibleChange(t.state.popupVisible);
  }, this.savePopup = function(n) {
    t._component = n;
  };
};
L3(Ca);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var jg;
function ae() {
  return jg.apply(null, arguments);
}
function MF(e) {
  jg = e;
}
function on(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Zr(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ne(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function $3(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (Ne(e, t))
      return !1;
  return !0;
}
function It(e) {
  return e === void 0;
}
function Jn(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Qi(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function zg(e, t) {
  var n = [], r, o = e.length;
  for (r = 0; r < o; ++r)
    n.push(t(e[r], r));
  return n;
}
function sr(e, t) {
  for (var n in t)
    Ne(t, n) && (e[n] = t[n]);
  return Ne(t, "toString") && (e.toString = t.toString), Ne(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function An(e, t, n, r) {
  return vw(e, t, n, r, !0).utc();
}
function NF() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Ce(e) {
  return e._pf == null && (e._pf = NF()), e._pf;
}
var Ef;
Array.prototype.some ? Ef = Array.prototype.some : Ef = function(e) {
  var t = Object(this), n = t.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in t && e.call(this, t[r], r, t))
      return !0;
  return !1;
};
function Y3(e) {
  var t = null, n = !1, r = e._d && !isNaN(e._d.getTime());
  if (r && (t = Ce(e), n = Ef.call(t.parsedDateParts, function(o) {
    return o != null;
  }), r = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n), e._strict && (r = r && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = r;
  else
    return r;
  return e._isValid;
}
function au(e) {
  var t = An(NaN);
  return e != null ? sr(Ce(t), e) : Ce(t).userInvalidated = !0, t;
}
var tp = ae.momentProperties = [], Xd = !1;
function j3(e, t) {
  var n, r, o, a = tp.length;
  if (It(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), It(t._i) || (e._i = t._i), It(t._f) || (e._f = t._f), It(t._l) || (e._l = t._l), It(t._strict) || (e._strict = t._strict), It(t._tzm) || (e._tzm = t._tzm), It(t._isUTC) || (e._isUTC = t._isUTC), It(t._offset) || (e._offset = t._offset), It(t._pf) || (e._pf = Ce(t)), It(t._locale) || (e._locale = t._locale), a > 0)
    for (n = 0; n < a; n++)
      r = tp[n], o = t[r], It(o) || (e[r] = o);
  return e;
}
function es(e) {
  j3(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Xd === !1 && (Xd = !0, ae.updateOffset(this), Xd = !1);
}
function an(e) {
  return e instanceof es || e != null && e._isAMomentObject != null;
}
function Xg(e) {
  ae.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ut(e, t) {
  var n = !0;
  return sr(function() {
    if (ae.deprecationHandler != null && ae.deprecationHandler(null, e), n) {
      var r = [], o, a, i, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (i in arguments[0])
            Ne(arguments[0], i) && (o += i + ": " + arguments[0][i] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        r.push(o);
      }
      Xg(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var np = {};
function Ug(e, t) {
  ae.deprecationHandler != null && ae.deprecationHandler(e, t), np[e] || (Xg(t), np[e] = !0);
}
ae.suppressDeprecationWarnings = !1;
ae.deprecationHandler = null;
function _n(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function PF(e) {
  var t, n;
  for (n in e)
    Ne(e, n) && (t = e[n], _n(t) ? this[n] = t : this["_" + n] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function If(e, t) {
  var n = sr({}, e), r;
  for (r in t)
    Ne(t, r) && (Zr(e[r]) && Zr(t[r]) ? (n[r] = {}, sr(n[r], e[r]), sr(n[r], t[r])) : t[r] != null ? n[r] = t[r] : delete n[r]);
  for (r in e)
    Ne(e, r) && !Ne(t, r) && Zr(e[r]) && (n[r] = sr({}, n[r]));
  return n;
}
function z3(e) {
  e != null && this.set(e);
}
var Sf;
Object.keys ? Sf = Object.keys : Sf = function(e) {
  var t, n = [];
  for (t in e)
    Ne(e, t) && n.push(t);
  return n;
};
var AF = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function _F(e, t, n) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return _n(r) ? r.call(t, n) : r;
}
function Sn(e, t, n) {
  var r = "" + Math.abs(e), o = t - r.length, a = e >= 0;
  return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + r;
}
var X3 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, Bs = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Ud = {}, Go = {};
function he(e, t, n, r) {
  var o = r;
  typeof r == "string" && (o = function() {
    return this[r]();
  }), e && (Go[e] = o), t && (Go[t[0]] = function() {
    return Sn(o.apply(this, arguments), t[1], t[2]);
  }), n && (Go[n] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function OF(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function TF(e) {
  var t = e.match(X3), n, r;
  for (n = 0, r = t.length; n < r; n++)
    Go[t[n]] ? t[n] = Go[t[n]] : t[n] = OF(t[n]);
  return function(o) {
    var a = "", i;
    for (i = 0; i < r; i++)
      a += _n(t[i]) ? t[i].call(o, e) : t[i];
    return a;
  };
}
function sl(e, t) {
  return e.isValid() ? (t = Jg(t, e.localeData()), Ud[t] = Ud[t] || TF(t), Ud[t](e)) : e.localeData().invalidDate();
}
function Jg(e, t) {
  var n = 5;
  function r(o) {
    return t.longDateFormat(o) || o;
  }
  for (Bs.lastIndex = 0; n >= 0 && Bs.test(e); )
    e = e.replace(
      Bs,
      r
    ), Bs.lastIndex = 0, n -= 1;
  return e;
}
var LF = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function RF(e) {
  var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
  return t || !n ? t : (this._longDateFormat[e] = n.match(X3).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var VF = "Invalid date";
function kF() {
  return this._invalidDate;
}
var FF = "%d", HF = /\d{1,2}/;
function BF(e) {
  return this._ordinal.replace("%d", e);
}
var GF = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function WF(e, t, n, r) {
  var o = this._relativeTime[n];
  return _n(o) ? o(e, t, n, r) : o.replace(/%d/i, e);
}
function ZF(e, t) {
  var n = this._relativeTime[e > 0 ? "future" : "past"];
  return _n(n) ? n(t) : n.replace(/%s/i, t);
}
var rp = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Jt(e) {
  return typeof e == "string" ? rp[e] || rp[e.toLowerCase()] : void 0;
}
function U3(e) {
  var t = {}, n, r;
  for (r in e)
    Ne(e, r) && (n = Jt(r), n && (t[n] = e[r]));
  return t;
}
var $F = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function YF(e) {
  var t = [], n;
  for (n in e)
    Ne(e, n) && t.push({ unit: n, priority: $F[n] });
  return t.sort(function(r, o) {
    return r.priority - o.priority;
  }), t;
}
var Kg = /\d/, Bt = /\d\d/, qg = /\d{3}/, J3 = /\d{4}/, iu = /[+-]?\d{6}/, Ye = /\d\d?/, Qg = /\d\d\d\d?/, ew = /\d\d\d\d\d\d?/, su = /\d{1,3}/, K3 = /\d{1,4}/, lu = /[+-]?\d{1,6}/, ya = /\d+/, cu = /[+-]?\d+/, jF = /Z|[+-]\d\d:?\d\d/gi, uu = /Z|[+-]\d\d(?::?\d\d)?/gi, zF = /[+-]?\d+(\.\d{1,3})?/, ts = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, xa = /^[1-9]\d?/, q3 = /^([1-9]\d|\d)/, Rl;
Rl = {};
function se(e, t, n) {
  Rl[e] = _n(t) ? t : function(r, o) {
    return r && n ? n : t;
  };
}
function XF(e, t) {
  return Ne(Rl, e) ? Rl[e](t._strict, t._locale) : new RegExp(UF(e));
}
function UF(e) {
  return Zn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, n, r, o, a) {
        return n || r || o || a;
      }
    )
  );
}
function Zn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Zt(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function xe(e) {
  var t = +e, n = 0;
  return t !== 0 && isFinite(t) && (n = Zt(t)), n;
}
var Df = {};
function Be(e, t) {
  var n, r = t, o;
  for (typeof e == "string" && (e = [e]), Jn(t) && (r = function(a, i) {
    i[t] = xe(a);
  }), o = e.length, n = 0; n < o; n++)
    Df[e[n]] = r;
}
function ns(e, t) {
  Be(e, function(n, r, o, a) {
    o._w = o._w || {}, t(n, o._w, o, a);
  });
}
function JF(e, t, n) {
  t != null && Ne(Df, e) && Df[e](t, n._a, n, e);
}
function du(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var mt = 0, Bn = 1, gn = 2, tt = 3, Qt = 4, Gn = 5, Br = 6, KF = 7, qF = 8;
he("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Sn(e, 4) : "+" + e;
});
he(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
he(0, ["YYYY", 4], 0, "year");
he(0, ["YYYYY", 5], 0, "year");
he(0, ["YYYYYY", 6, !0], 0, "year");
se("Y", cu);
se("YY", Ye, Bt);
se("YYYY", K3, J3);
se("YYYYY", lu, iu);
se("YYYYYY", lu, iu);
Be(["YYYYY", "YYYYYY"], mt);
Be("YYYY", function(e, t) {
  t[mt] = e.length === 2 ? ae.parseTwoDigitYear(e) : xe(e);
});
Be("YY", function(e, t) {
  t[mt] = ae.parseTwoDigitYear(e);
});
Be("Y", function(e, t) {
  t[mt] = parseInt(e, 10);
});
function ri(e) {
  return du(e) ? 366 : 365;
}
ae.parseTwoDigitYear = function(e) {
  return xe(e) + (xe(e) > 68 ? 1900 : 2e3);
};
var tw = Ea("FullYear", !0);
function QF() {
  return du(this.year());
}
function Ea(e, t) {
  return function(n) {
    return n != null ? (nw(this, e, n), ae.updateOffset(this, t), this) : wi(this, e);
  };
}
function wi(e, t) {
  if (!e.isValid())
    return NaN;
  var n = e._d, r = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return r ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return r ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return r ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return r ? n.getUTCHours() : n.getHours();
    case "Date":
      return r ? n.getUTCDate() : n.getDate();
    case "Day":
      return r ? n.getUTCDay() : n.getDay();
    case "Month":
      return r ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return r ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function nw(e, t, n) {
  var r, o, a, i, s;
  if (!(!e.isValid() || isNaN(n))) {
    switch (r = e._d, o = e._isUTC, t) {
      case "Milliseconds":
        return void (o ? r.setUTCMilliseconds(n) : r.setMilliseconds(n));
      case "Seconds":
        return void (o ? r.setUTCSeconds(n) : r.setSeconds(n));
      case "Minutes":
        return void (o ? r.setUTCMinutes(n) : r.setMinutes(n));
      case "Hours":
        return void (o ? r.setUTCHours(n) : r.setHours(n));
      case "Date":
        return void (o ? r.setUTCDate(n) : r.setDate(n));
      case "FullYear":
        break;
      default:
        return;
    }
    a = n, i = e.month(), s = e.date(), s = s === 29 && i === 1 && !du(a) ? 28 : s, o ? r.setUTCFullYear(a, i, s) : r.setFullYear(a, i, s);
  }
}
function eH(e) {
  return e = Jt(e), _n(this[e]) ? this[e]() : this;
}
function tH(e, t) {
  if (typeof e == "object") {
    e = U3(e);
    var n = YF(e), r, o = n.length;
    for (r = 0; r < o; r++)
      this[n[r].unit](e[n[r].unit]);
  } else if (e = Jt(e), _n(this[e]))
    return this[e](t);
  return this;
}
function nH(e, t) {
  return (e % t + t) % t;
}
var Ke;
Array.prototype.indexOf ? Ke = Array.prototype.indexOf : Ke = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Q3(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var n = nH(t, 12);
  return e += (t - n) / 12, n === 1 ? du(e) ? 29 : 28 : 31 - n % 7 % 2;
}
he("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
he("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
he("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
se("M", Ye, xa);
se("MM", Ye, Bt);
se("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
se("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
Be(["M", "MM"], function(e, t) {
  t[Bn] = xe(e) - 1;
});
Be(["MMM", "MMMM"], function(e, t, n, r) {
  var o = n._locale.monthsParse(e, r, n._strict);
  o != null ? t[Bn] = o : Ce(n).invalidMonth = e;
});
var rH = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), rw = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), ow = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, oH = ts, aH = ts;
function iH(e, t) {
  return e ? on(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || ow).test(t) ? "format" : "standalone"][e.month()] : on(this._months) ? this._months : this._months.standalone;
}
function sH(e, t) {
  return e ? on(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[ow.test(t) ? "format" : "standalone"][e.month()] : on(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function lH(e, t, n) {
  var r, o, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      a = An([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
  return n ? t === "MMM" ? (o = Ke.call(this._shortMonthsParse, i), o !== -1 ? o : null) : (o = Ke.call(this._longMonthsParse, i), o !== -1 ? o : null) : t === "MMM" ? (o = Ke.call(this._shortMonthsParse, i), o !== -1 ? o : (o = Ke.call(this._longMonthsParse, i), o !== -1 ? o : null)) : (o = Ke.call(this._longMonthsParse, i), o !== -1 ? o : (o = Ke.call(this._shortMonthsParse, i), o !== -1 ? o : null));
}
function cH(e, t, n) {
  var r, o, a;
  if (this._monthsParseExact)
    return lH.call(this, e, t, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (o = An([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (n && t === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!n && this._monthsParse[r].test(e))
      return r;
  }
}
function aw(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = xe(t);
    else if (t = e.localeData().monthsParse(t), !Jn(t))
      return e;
  }
  var n = t, r = e.date();
  return r = r < 29 ? r : Math.min(r, Q3(e.year(), n)), e._isUTC ? e._d.setUTCMonth(n, r) : e._d.setMonth(n, r), e;
}
function iw(e) {
  return e != null ? (aw(this, e), ae.updateOffset(this, !0), this) : wi(this, "Month");
}
function uH() {
  return Q3(this.year(), this.month());
}
function dH(e) {
  return this._monthsParseExact ? (Ne(this, "_monthsRegex") || sw.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Ne(this, "_monthsShortRegex") || (this._monthsShortRegex = oH), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function fH(e) {
  return this._monthsParseExact ? (Ne(this, "_monthsRegex") || sw.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Ne(this, "_monthsRegex") || (this._monthsRegex = aH), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function sw() {
  function e(l, c) {
    return c.length - l.length;
  }
  var t = [], n = [], r = [], o, a, i, s;
  for (o = 0; o < 12; o++)
    a = An([2e3, o]), i = Zn(this.monthsShort(a, "")), s = Zn(this.months(a, "")), t.push(i), n.push(s), r.push(s), r.push(i);
  t.sort(e), n.sort(e), r.sort(e), this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function pH(e, t, n, r, o, a, i) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, r, o, a, i), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, r, o, a, i), s;
}
function bi(e) {
  var t, n;
  return e < 100 && e >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Vl(e, t, n) {
  var r = 7 + t - n, o = (7 + bi(e, 0, r).getUTCDay() - t) % 7;
  return -o + r - 1;
}
function lw(e, t, n, r, o) {
  var a = (7 + n - r) % 7, i = Vl(e, r, o), s = 1 + 7 * (t - 1) + a + i, l, c;
  return s <= 0 ? (l = e - 1, c = ri(l) + s) : s > ri(e) ? (l = e + 1, c = s - ri(e)) : (l = e, c = s), {
    year: l,
    dayOfYear: c
  };
}
function Ci(e, t, n) {
  var r = Vl(e.year(), t, n), o = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, a, i;
  return o < 1 ? (i = e.year() - 1, a = o + $n(i, t, n)) : o > $n(e.year(), t, n) ? (a = o - $n(e.year(), t, n), i = e.year() + 1) : (i = e.year(), a = o), {
    week: a,
    year: i
  };
}
function $n(e, t, n) {
  var r = Vl(e, t, n), o = Vl(e + 1, t, n);
  return (ri(e) - r + o) / 7;
}
he("w", ["ww", 2], "wo", "week");
he("W", ["WW", 2], "Wo", "isoWeek");
se("w", Ye, xa);
se("ww", Ye, Bt);
se("W", Ye, xa);
se("WW", Ye, Bt);
ns(
  ["w", "ww", "W", "WW"],
  function(e, t, n, r) {
    t[r.substr(0, 1)] = xe(e);
  }
);
function hH(e) {
  return Ci(e, this._week.dow, this._week.doy).week;
}
var mH = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function vH() {
  return this._week.dow;
}
function gH() {
  return this._week.doy;
}
function wH(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function bH(e) {
  var t = Ci(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
he("d", 0, "do", "day");
he("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
he("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
he("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
he("e", 0, 0, "weekday");
he("E", 0, 0, "isoWeekday");
se("d", Ye);
se("e", Ye);
se("E", Ye);
se("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
se("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
se("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
ns(["dd", "ddd", "dddd"], function(e, t, n, r) {
  var o = n._locale.weekdaysParse(e, r, n._strict);
  o != null ? t.d = o : Ce(n).invalidWeekday = e;
});
ns(["d", "e", "E"], function(e, t, n, r) {
  t[r] = xe(e);
});
function CH(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function yH(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function e0(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var xH = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), cw = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), EH = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), IH = ts, SH = ts, DH = ts;
function MH(e, t) {
  var n = on(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? e0(n, this._week.dow) : e ? n[e.day()] : n;
}
function NH(e) {
  return e === !0 ? e0(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function PH(e) {
  return e === !0 ? e0(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function AH(e, t, n) {
  var r, o, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      a = An([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
  return n ? t === "dddd" ? (o = Ke.call(this._weekdaysParse, i), o !== -1 ? o : null) : t === "ddd" ? (o = Ke.call(this._shortWeekdaysParse, i), o !== -1 ? o : null) : (o = Ke.call(this._minWeekdaysParse, i), o !== -1 ? o : null) : t === "dddd" ? (o = Ke.call(this._weekdaysParse, i), o !== -1 || (o = Ke.call(this._shortWeekdaysParse, i), o !== -1) ? o : (o = Ke.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : t === "ddd" ? (o = Ke.call(this._shortWeekdaysParse, i), o !== -1 || (o = Ke.call(this._weekdaysParse, i), o !== -1) ? o : (o = Ke.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : (o = Ke.call(this._minWeekdaysParse, i), o !== -1 || (o = Ke.call(this._weekdaysParse, i), o !== -1) ? o : (o = Ke.call(this._shortWeekdaysParse, i), o !== -1 ? o : null));
}
function _H(e, t, n) {
  var r, o, a;
  if (this._weekdaysParseExact)
    return AH.call(this, e, t, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (o = An([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && t === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (n && t === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (n && t === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!n && this._weekdaysParse[r].test(e))
      return r;
  }
}
function OH(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = wi(this, "Day");
  return e != null ? (e = CH(e, this.localeData()), this.add(e - t, "d")) : t;
}
function TH(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function LH(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = yH(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function RH(e) {
  return this._weekdaysParseExact ? (Ne(this, "_weekdaysRegex") || t0.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Ne(this, "_weekdaysRegex") || (this._weekdaysRegex = IH), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function VH(e) {
  return this._weekdaysParseExact ? (Ne(this, "_weekdaysRegex") || t0.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Ne(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = SH), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function kH(e) {
  return this._weekdaysParseExact ? (Ne(this, "_weekdaysRegex") || t0.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Ne(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = DH), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function t0() {
  function e(d, f) {
    return f.length - d.length;
  }
  var t = [], n = [], r = [], o = [], a, i, s, l, c;
  for (a = 0; a < 7; a++)
    i = An([2e3, 1]).day(a), s = Zn(this.weekdaysMin(i, "")), l = Zn(this.weekdaysShort(i, "")), c = Zn(this.weekdays(i, "")), t.push(s), n.push(l), r.push(c), o.push(s), o.push(l), o.push(c);
  t.sort(e), n.sort(e), r.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function n0() {
  return this.hours() % 12 || 12;
}
function FH() {
  return this.hours() || 24;
}
he("H", ["HH", 2], 0, "hour");
he("h", ["hh", 2], 0, n0);
he("k", ["kk", 2], 0, FH);
he("hmm", 0, 0, function() {
  return "" + n0.apply(this) + Sn(this.minutes(), 2);
});
he("hmmss", 0, 0, function() {
  return "" + n0.apply(this) + Sn(this.minutes(), 2) + Sn(this.seconds(), 2);
});
he("Hmm", 0, 0, function() {
  return "" + this.hours() + Sn(this.minutes(), 2);
});
he("Hmmss", 0, 0, function() {
  return "" + this.hours() + Sn(this.minutes(), 2) + Sn(this.seconds(), 2);
});
function uw(e, t) {
  he(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
uw("a", !0);
uw("A", !1);
function dw(e, t) {
  return t._meridiemParse;
}
se("a", dw);
se("A", dw);
se("H", Ye, q3);
se("h", Ye, xa);
se("k", Ye, xa);
se("HH", Ye, Bt);
se("hh", Ye, Bt);
se("kk", Ye, Bt);
se("hmm", Qg);
se("hmmss", ew);
se("Hmm", Qg);
se("Hmmss", ew);
Be(["H", "HH"], tt);
Be(["k", "kk"], function(e, t, n) {
  var r = xe(e);
  t[tt] = r === 24 ? 0 : r;
});
Be(["a", "A"], function(e, t, n) {
  n._isPm = n._locale.isPM(e), n._meridiem = e;
});
Be(["h", "hh"], function(e, t, n) {
  t[tt] = xe(e), Ce(n).bigHour = !0;
});
Be("hmm", function(e, t, n) {
  var r = e.length - 2;
  t[tt] = xe(e.substr(0, r)), t[Qt] = xe(e.substr(r)), Ce(n).bigHour = !0;
});
Be("hmmss", function(e, t, n) {
  var r = e.length - 4, o = e.length - 2;
  t[tt] = xe(e.substr(0, r)), t[Qt] = xe(e.substr(r, 2)), t[Gn] = xe(e.substr(o)), Ce(n).bigHour = !0;
});
Be("Hmm", function(e, t, n) {
  var r = e.length - 2;
  t[tt] = xe(e.substr(0, r)), t[Qt] = xe(e.substr(r));
});
Be("Hmmss", function(e, t, n) {
  var r = e.length - 4, o = e.length - 2;
  t[tt] = xe(e.substr(0, r)), t[Qt] = xe(e.substr(r, 2)), t[Gn] = xe(e.substr(o));
});
function HH(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var BH = /[ap]\.?m?\.?/i, GH = Ea("Hours", !0);
function WH(e, t, n) {
  return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var fw = {
  calendar: AF,
  longDateFormat: LF,
  invalidDate: VF,
  ordinal: FF,
  dayOfMonthOrdinalParse: HF,
  relativeTime: GF,
  months: rH,
  monthsShort: rw,
  week: mH,
  weekdays: xH,
  weekdaysMin: EH,
  weekdaysShort: cw,
  meridiemParse: BH
}, je = {}, La = {}, yi;
function ZH(e, t) {
  var n, r = Math.min(e.length, t.length);
  for (n = 0; n < r; n += 1)
    if (e[n] !== t[n])
      return n;
  return r;
}
function op(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function $H(e) {
  for (var t = 0, n, r, o, a; t < e.length; ) {
    for (a = op(e[t]).split("-"), n = a.length, r = op(e[t + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (o = fu(a.slice(0, n).join("-")), o)
        return o;
      if (r && r.length >= n && ZH(a, r) >= n - 1)
        break;
      n--;
    }
    t++;
  }
  return yi;
}
function YH(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function fu(e) {
  var t = null, n;
  if (je[e] === void 0 && typeof module < "u" && module && module.exports && YH(e))
    try {
      t = yi._abbr, n = require, n("./locale/" + e), dr(t);
    } catch {
      je[e] = null;
    }
  return je[e];
}
function dr(e, t) {
  var n;
  return e && (It(t) ? n = Qn(e) : n = r0(e, t), n ? yi = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), yi._abbr;
}
function r0(e, t) {
  if (t !== null) {
    var n, r = fw;
    if (t.abbr = e, je[e] != null)
      Ug(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = je[e]._config;
    else if (t.parentLocale != null)
      if (je[t.parentLocale] != null)
        r = je[t.parentLocale]._config;
      else if (n = fu(t.parentLocale), n != null)
        r = n._config;
      else
        return La[t.parentLocale] || (La[t.parentLocale] = []), La[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return je[e] = new z3(If(r, t)), La[e] && La[e].forEach(function(o) {
      r0(o.name, o.config);
    }), dr(e), je[e];
  } else
    return delete je[e], null;
}
function jH(e, t) {
  if (t != null) {
    var n, r, o = fw;
    je[e] != null && je[e].parentLocale != null ? je[e].set(If(je[e]._config, t)) : (r = fu(e), r != null && (o = r._config), t = If(o, t), r == null && (t.abbr = e), n = new z3(t), n.parentLocale = je[e], je[e] = n), dr(e);
  } else
    je[e] != null && (je[e].parentLocale != null ? (je[e] = je[e].parentLocale, e === dr() && dr(e)) : je[e] != null && delete je[e]);
  return je[e];
}
function Qn(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return yi;
  if (!on(e)) {
    if (t = fu(e), t)
      return t;
    e = [e];
  }
  return $H(e);
}
function zH() {
  return Sf(je);
}
function o0(e) {
  var t, n = e._a;
  return n && Ce(e).overflow === -2 && (t = n[Bn] < 0 || n[Bn] > 11 ? Bn : n[gn] < 1 || n[gn] > Q3(n[mt], n[Bn]) ? gn : n[tt] < 0 || n[tt] > 24 || n[tt] === 24 && (n[Qt] !== 0 || n[Gn] !== 0 || n[Br] !== 0) ? tt : n[Qt] < 0 || n[Qt] > 59 ? Qt : n[Gn] < 0 || n[Gn] > 59 ? Gn : n[Br] < 0 || n[Br] > 999 ? Br : -1, Ce(e)._overflowDayOfYear && (t < mt || t > gn) && (t = gn), Ce(e)._overflowWeeks && t === -1 && (t = KF), Ce(e)._overflowWeekday && t === -1 && (t = qF), Ce(e).overflow = t), e;
}
var XH = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, UH = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, JH = /Z|[+-]\d\d(?::?\d\d)?/, Gs = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Jd = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], KH = /^\/?Date\((-?\d+)/i, qH = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, QH = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function pw(e) {
  var t, n, r = e._i, o = XH.exec(r) || UH.exec(r), a, i, s, l, c = Gs.length, d = Jd.length;
  if (o) {
    for (Ce(e).iso = !0, t = 0, n = c; t < n; t++)
      if (Gs[t][1].exec(o[1])) {
        i = Gs[t][0], a = Gs[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, n = d; t < n; t++)
        if (Jd[t][1].exec(o[3])) {
          s = (o[2] || " ") + Jd[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (JH.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (s || "") + (l || ""), i0(e);
  } else
    e._isValid = !1;
}
function eB(e, t, n, r, o, a) {
  var i = [
    tB(e),
    rw.indexOf(t),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(o, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function tB(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function nB(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function rB(e, t, n) {
  if (e) {
    var r = cw.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (r !== o)
      return Ce(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function oB(e, t, n) {
  if (e)
    return QH[e];
  if (t)
    return 0;
  var r = parseInt(n, 10), o = r % 100, a = (r - o) / 100;
  return a * 60 + o;
}
function hw(e) {
  var t = qH.exec(nB(e._i)), n;
  if (t) {
    if (n = eB(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !rB(t[1], n, e))
      return;
    e._a = n, e._tzm = oB(t[8], t[9], t[10]), e._d = bi.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Ce(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function aB(e) {
  var t = KH.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (pw(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (hw(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ae.createFromInputFallback(e);
}
ae.createFromInputFallback = Ut(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Po(e, t, n) {
  return e ?? t ?? n;
}
function iB(e) {
  var t = new Date(ae.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function a0(e) {
  var t, n, r = [], o, a, i;
  if (!e._d) {
    for (o = iB(e), e._w && e._a[gn] == null && e._a[Bn] == null && sB(e), e._dayOfYear != null && (i = Po(e._a[mt], o[mt]), (e._dayOfYear > ri(i) || e._dayOfYear === 0) && (Ce(e)._overflowDayOfYear = !0), n = bi(i, 0, e._dayOfYear), e._a[Bn] = n.getUTCMonth(), e._a[gn] = n.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = r[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = r[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[tt] === 24 && e._a[Qt] === 0 && e._a[Gn] === 0 && e._a[Br] === 0 && (e._nextDay = !0, e._a[tt] = 0), e._d = (e._useUTC ? bi : pH).apply(
      null,
      r
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[tt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Ce(e).weekdayMismatch = !0);
  }
}
function sB(e) {
  var t, n, r, o, a, i, s, l, c;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, i = 4, n = Po(
    t.GG,
    e._a[mt],
    Ci($e(), 1, 4).year
  ), r = Po(t.W, 1), o = Po(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, c = Ci($e(), a, i), n = Po(t.gg, e._a[mt], c.year), r = Po(t.w, c.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), r < 1 || r > $n(n, a, i) ? Ce(e)._overflowWeeks = !0 : l != null ? Ce(e)._overflowWeekday = !0 : (s = lw(n, r, o, a, i), e._a[mt] = s.year, e._dayOfYear = s.dayOfYear);
}
ae.ISO_8601 = function() {
};
ae.RFC_2822 = function() {
};
function i0(e) {
  if (e._f === ae.ISO_8601) {
    pw(e);
    return;
  }
  if (e._f === ae.RFC_2822) {
    hw(e);
    return;
  }
  e._a = [], Ce(e).empty = !0;
  var t = "" + e._i, n, r, o, a, i, s = t.length, l = 0, c, d;
  for (o = Jg(e._f, e._locale).match(X3) || [], d = o.length, n = 0; n < d; n++)
    a = o[n], r = (t.match(XF(a, e)) || [])[0], r && (i = t.substr(0, t.indexOf(r)), i.length > 0 && Ce(e).unusedInput.push(i), t = t.slice(
      t.indexOf(r) + r.length
    ), l += r.length), Go[a] ? (r ? Ce(e).empty = !1 : Ce(e).unusedTokens.push(a), JF(a, r, e)) : e._strict && !r && Ce(e).unusedTokens.push(a);
  Ce(e).charsLeftOver = s - l, t.length > 0 && Ce(e).unusedInput.push(t), e._a[tt] <= 12 && Ce(e).bigHour === !0 && e._a[tt] > 0 && (Ce(e).bigHour = void 0), Ce(e).parsedDateParts = e._a.slice(0), Ce(e).meridiem = e._meridiem, e._a[tt] = lB(
    e._locale,
    e._a[tt],
    e._meridiem
  ), c = Ce(e).era, c !== null && (e._a[mt] = e._locale.erasConvertYear(c, e._a[mt])), a0(e), o0(e);
}
function lB(e, t, n) {
  var r;
  return n == null ? t : e.meridiemHour != null ? e.meridiemHour(t, n) : (e.isPM != null && (r = e.isPM(n), r && t < 12 && (t += 12), !r && t === 12 && (t = 0)), t);
}
function cB(e) {
  var t, n, r, o, a, i, s = !1, l = e._f.length;
  if (l === 0) {
    Ce(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, i = !1, t = j3({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], i0(t), Y3(t) && (i = !0), a += Ce(t).charsLeftOver, a += Ce(t).unusedTokens.length * 10, Ce(t).score = a, s ? a < r && (r = a, n = t) : (r == null || a < r || i) && (r = a, n = t, i && (s = !0));
  sr(e, n || t);
}
function uB(e) {
  if (!e._d) {
    var t = U3(e._i), n = t.day === void 0 ? t.date : t.day;
    e._a = zg(
      [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), a0(e);
  }
}
function dB(e) {
  var t = new es(o0(mw(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function mw(e) {
  var t = e._i, n = e._f;
  return e._locale = e._locale || Qn(e._l), t === null || n === void 0 && t === "" ? au({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), an(t) ? new es(o0(t)) : (Qi(t) ? e._d = t : on(n) ? cB(e) : n ? i0(e) : fB(e), Y3(e) || (e._d = null), e));
}
function fB(e) {
  var t = e._i;
  It(t) ? e._d = new Date(ae.now()) : Qi(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? aB(e) : on(t) ? (e._a = zg(t.slice(0), function(n) {
    return parseInt(n, 10);
  }), a0(e)) : Zr(t) ? uB(e) : Jn(t) ? e._d = new Date(t) : ae.createFromInputFallback(e);
}
function vw(e, t, n, r, o) {
  var a = {};
  return (t === !0 || t === !1) && (r = t, t = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (Zr(e) && $3(e) || on(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = n, a._i = e, a._f = t, a._strict = r, dB(a);
}
function $e(e, t, n, r) {
  return vw(e, t, n, r, !1);
}
var pB = Ut(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = $e.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : au();
  }
), hB = Ut(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = $e.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : au();
  }
);
function gw(e, t) {
  var n, r;
  if (t.length === 1 && on(t[0]) && (t = t[0]), !t.length)
    return $e();
  for (n = t[0], r = 1; r < t.length; ++r)
    (!t[r].isValid() || t[r][e](n)) && (n = t[r]);
  return n;
}
function mB() {
  var e = [].slice.call(arguments, 0);
  return gw("isBefore", e);
}
function vB() {
  var e = [].slice.call(arguments, 0);
  return gw("isAfter", e);
}
var gB = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Ra = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function wB(e) {
  var t, n = !1, r, o = Ra.length;
  for (t in e)
    if (Ne(e, t) && !(Ke.call(Ra, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (r = 0; r < o; ++r)
    if (e[Ra[r]]) {
      if (n)
        return !1;
      parseFloat(e[Ra[r]]) !== xe(e[Ra[r]]) && (n = !0);
    }
  return !0;
}
function bB() {
  return this._isValid;
}
function CB() {
  return fn(NaN);
}
function pu(e) {
  var t = U3(e), n = t.year || 0, r = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, d = t.millisecond || 0;
  this._isValid = wB(t), this._milliseconds = +d + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +o + r * 3 + n * 12, this._data = {}, this._locale = Qn(), this._bubble();
}
function ll(e) {
  return e instanceof pu;
}
function Mf(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function yB(e, t, n) {
  var r = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < r; i++)
    (n && e[i] !== t[i] || !n && xe(e[i]) !== xe(t[i])) && a++;
  return a + o;
}
function ww(e, t) {
  he(e, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + Sn(~~(n / 60), 2) + t + Sn(~~n % 60, 2);
  });
}
ww("Z", ":");
ww("ZZ", "");
se("Z", uu);
se("ZZ", uu);
Be(["Z", "ZZ"], function(e, t, n) {
  n._useUTC = !0, n._tzm = s0(uu, e);
});
var xB = /([\+\-]|\d\d)/gi;
function s0(e, t) {
  var n = (t || "").match(e), r, o, a;
  return n === null ? null : (r = n[n.length - 1] || [], o = (r + "").match(xB) || ["-", 0, 0], a = +(o[1] * 60) + xe(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function l0(e, t) {
  var n, r;
  return t._isUTC ? (n = t.clone(), r = (an(e) || Qi(e) ? e.valueOf() : $e(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), ae.updateOffset(n, !1), n) : $e(e).local();
}
function Nf(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ae.updateOffset = function() {
};
function EB(e, t, n) {
  var r = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = s0(uu, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !n && (e = e * 60);
    return !this._isUTC && t && (o = Nf(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), r !== e && (!t || this._changeInProgress ? yw(
      this,
      fn(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ae.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : Nf(this);
}
function IB(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function SB(e) {
  return this.utcOffset(0, e);
}
function DB(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Nf(this), "m")), this;
}
function MB() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = s0(jF, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function NB(e) {
  return this.isValid() ? (e = e ? $e(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function PB() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function AB() {
  if (!It(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return j3(e, this), e = mw(e), e._a ? (t = e._isUTC ? An(e._a) : $e(e._a), this._isDSTShifted = this.isValid() && yB(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function _B() {
  return this.isValid() ? !this._isUTC : !1;
}
function OB() {
  return this.isValid() ? this._isUTC : !1;
}
function bw() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var TB = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, LB = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function fn(e, t) {
  var n = e, r = null, o, a, i;
  return ll(e) ? n = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Jn(e) || !isNaN(+e) ? (n = {}, t ? n[t] = +e : n.milliseconds = +e) : (r = TB.exec(e)) ? (o = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: xe(r[gn]) * o,
    h: xe(r[tt]) * o,
    m: xe(r[Qt]) * o,
    s: xe(r[Gn]) * o,
    ms: xe(Mf(r[Br] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (r = LB.exec(e)) ? (o = r[1] === "-" ? -1 : 1, n = {
    y: Or(r[2], o),
    M: Or(r[3], o),
    w: Or(r[4], o),
    d: Or(r[5], o),
    h: Or(r[6], o),
    m: Or(r[7], o),
    s: Or(r[8], o)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (i = RB(
    $e(n.from),
    $e(n.to)
  ), n = {}, n.ms = i.milliseconds, n.M = i.months), a = new pu(n), ll(e) && Ne(e, "_locale") && (a._locale = e._locale), ll(e) && Ne(e, "_isValid") && (a._isValid = e._isValid), a;
}
fn.fn = pu.prototype;
fn.invalid = CB;
function Or(e, t) {
  var n = e && parseFloat(e.replace(",", "."));
  return (isNaN(n) ? 0 : n) * t;
}
function ap(e, t) {
  var n = {};
  return n.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
}
function RB(e, t) {
  var n;
  return e.isValid() && t.isValid() ? (t = l0(t, e), e.isBefore(t) ? n = ap(e, t) : (n = ap(t, e), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Cw(e, t) {
  return function(n, r) {
    var o, a;
    return r !== null && !isNaN(+r) && (Ug(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = n, n = r, r = a), o = fn(n, r), yw(this, o, e), this;
  };
}
function yw(e, t, n, r) {
  var o = t._milliseconds, a = Mf(t._days), i = Mf(t._months);
  e.isValid() && (r = r ?? !0, i && aw(e, wi(e, "Month") + i * n), a && nw(e, "Date", wi(e, "Date") + a * n), o && e._d.setTime(e._d.valueOf() + o * n), r && ae.updateOffset(e, a || i));
}
var VB = Cw(1, "add"), kB = Cw(-1, "subtract");
function xw(e) {
  return typeof e == "string" || e instanceof String;
}
function FB(e) {
  return an(e) || Qi(e) || xw(e) || Jn(e) || BB(e) || HB(e) || e === null || e === void 0;
}
function HB(e) {
  var t = Zr(e) && !$3(e), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, i = r.length;
  for (o = 0; o < i; o += 1)
    a = r[o], n = n || Ne(e, a);
  return t && n;
}
function BB(e) {
  var t = on(e), n = !1;
  return t && (n = e.filter(function(r) {
    return !Jn(r) && xw(e);
  }).length === 0), t && n;
}
function GB(e) {
  var t = Zr(e) && !$3(e), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < r.length; o += 1)
    a = r[o], n = n || Ne(e, a);
  return t && n;
}
function WB(e, t) {
  var n = e.diff(t, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function ZB(e, t) {
  arguments.length === 1 && (arguments[0] ? FB(arguments[0]) ? (e = arguments[0], t = void 0) : GB(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var n = e || $e(), r = l0(n, this).startOf("day"), o = ae.calendarFormat(this, r) || "sameElse", a = t && (_n(t[o]) ? t[o].call(this, n) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, $e(n))
  );
}
function $B() {
  return new es(this);
}
function YB(e, t) {
  var n = an(e) ? e : $e(e);
  return this.isValid() && n.isValid() ? (t = Jt(t) || "millisecond", t === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function jB(e, t) {
  var n = an(e) ? e : $e(e);
  return this.isValid() && n.isValid() ? (t = Jt(t) || "millisecond", t === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf()) : !1;
}
function zB(e, t, n, r) {
  var o = an(e) ? e : $e(e), a = an(t) ? t : $e(t);
  return this.isValid() && o.isValid() && a.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(o, n) : !this.isBefore(o, n)) && (r[1] === ")" ? this.isBefore(a, n) : !this.isAfter(a, n))) : !1;
}
function XB(e, t) {
  var n = an(e) ? e : $e(e), r;
  return this.isValid() && n.isValid() ? (t = Jt(t) || "millisecond", t === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(t).valueOf() <= r && r <= this.clone().endOf(t).valueOf())) : !1;
}
function UB(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function JB(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function KB(e, t, n) {
  var r, o, a;
  if (!this.isValid())
    return NaN;
  if (r = l0(e, this), !r.isValid())
    return NaN;
  switch (o = (r.utcOffset() - this.utcOffset()) * 6e4, t = Jt(t), t) {
    case "year":
      a = cl(this, r) / 12;
      break;
    case "month":
      a = cl(this, r);
      break;
    case "quarter":
      a = cl(this, r) / 3;
      break;
    case "second":
      a = (this - r) / 1e3;
      break;
    case "minute":
      a = (this - r) / 6e4;
      break;
    case "hour":
      a = (this - r) / 36e5;
      break;
    case "day":
      a = (this - r - o) / 864e5;
      break;
    case "week":
      a = (this - r - o) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return n ? a : Zt(a);
}
function cl(e, t) {
  if (e.date() < t.date())
    return -cl(t, e);
  var n = (t.year() - e.year()) * 12 + (t.month() - e.month()), r = e.clone().add(n, "months"), o, a;
  return t - r < 0 ? (o = e.clone().add(n - 1, "months"), a = (t - r) / (r - o)) : (o = e.clone().add(n + 1, "months"), a = (t - r) / (o - r)), -(n + a) || 0;
}
ae.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ae.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function qB() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function QB(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, n = t ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? sl(
    n,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : _n(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", sl(n, "Z")) : sl(
    n,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function eG() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", n, r, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(n + r + o + a);
}
function tG(e) {
  e || (e = this.isUtc() ? ae.defaultFormatUtc : ae.defaultFormat);
  var t = sl(this, e);
  return this.localeData().postformat(t);
}
function nG(e, t) {
  return this.isValid() && (an(e) && e.isValid() || $e(e).isValid()) ? fn({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function rG(e) {
  return this.from($e(), e);
}
function oG(e, t) {
  return this.isValid() && (an(e) && e.isValid() || $e(e).isValid()) ? fn({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function aG(e) {
  return this.to($e(), e);
}
function Ew(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Qn(e), t != null && (this._locale = t), this);
}
var Iw = Ut(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function Sw() {
  return this._locale;
}
var kl = 1e3, Wo = 60 * kl, Fl = 60 * Wo, Dw = (365 * 400 + 97) * 24 * Fl;
function Zo(e, t) {
  return (e % t + t) % t;
}
function Mw(e, t, n) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, n) - Dw : new Date(e, t, n).valueOf();
}
function Nw(e, t, n) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - Dw : Date.UTC(e, t, n);
}
function iG(e) {
  var t, n;
  if (e = Jt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Nw : Mw, e) {
    case "year":
      t = n(this.year(), 0, 1);
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = n(this.year(), this.month(), 1);
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Zo(
        t + (this._isUTC ? 0 : this.utcOffset() * Wo),
        Fl
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Zo(t, Wo);
      break;
    case "second":
      t = this._d.valueOf(), t -= Zo(t, kl);
      break;
  }
  return this._d.setTime(t), ae.updateOffset(this, !0), this;
}
function sG(e) {
  var t, n;
  if (e = Jt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Nw : Mw, e) {
    case "year":
      t = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Fl - Zo(
        t + (this._isUTC ? 0 : this.utcOffset() * Wo),
        Fl
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Wo - Zo(t, Wo) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += kl - Zo(t, kl) - 1;
      break;
  }
  return this._d.setTime(t), ae.updateOffset(this, !0), this;
}
function lG() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function cG() {
  return Math.floor(this.valueOf() / 1e3);
}
function uG() {
  return new Date(this.valueOf());
}
function dG() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function fG() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function pG() {
  return this.isValid() ? this.toISOString() : null;
}
function hG() {
  return Y3(this);
}
function mG() {
  return sr({}, Ce(this));
}
function vG() {
  return Ce(this).overflow;
}
function gG() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
he("N", 0, 0, "eraAbbr");
he("NN", 0, 0, "eraAbbr");
he("NNN", 0, 0, "eraAbbr");
he("NNNN", 0, 0, "eraName");
he("NNNNN", 0, 0, "eraNarrow");
he("y", ["y", 1], "yo", "eraYear");
he("y", ["yy", 2], 0, "eraYear");
he("y", ["yyy", 3], 0, "eraYear");
he("y", ["yyyy", 4], 0, "eraYear");
se("N", c0);
se("NN", c0);
se("NNN", c0);
se("NNNN", NG);
se("NNNNN", PG);
Be(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, n, r) {
    var o = n._locale.erasParse(e, r, n._strict);
    o ? Ce(n).era = o : Ce(n).invalidEra = e;
  }
);
se("y", ya);
se("yy", ya);
se("yyy", ya);
se("yyyy", ya);
se("yo", AG);
Be(["y", "yy", "yyy", "yyyy"], mt);
Be(["yo"], function(e, t, n, r) {
  var o;
  n._locale._eraYearOrdinalRegex && (o = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[mt] = n._locale.eraYearOrdinalParse(e, o) : t[mt] = parseInt(e, 10);
});
function wG(e, t) {
  var n, r, o, a = this._eras || Qn("en")._eras;
  for (n = 0, r = a.length; n < r; ++n) {
    switch (typeof a[n].since) {
      case "string":
        o = ae(a[n].since).startOf("day"), a[n].since = o.valueOf();
        break;
    }
    switch (typeof a[n].until) {
      case "undefined":
        a[n].until = 1 / 0;
        break;
      case "string":
        o = ae(a[n].until).startOf("day").valueOf(), a[n].until = o.valueOf();
        break;
    }
  }
  return a;
}
function bG(e, t, n) {
  var r, o, a = this.eras(), i, s, l;
  for (e = e.toUpperCase(), r = 0, o = a.length; r < o; ++r)
    if (i = a[r].name.toUpperCase(), s = a[r].abbr.toUpperCase(), l = a[r].narrow.toUpperCase(), n)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[r];
          break;
        case "NNNN":
          if (i === e)
            return a[r];
          break;
        case "NNNNN":
          if (l === e)
            return a[r];
          break;
      }
    else if ([i, s, l].indexOf(e) >= 0)
      return a[r];
}
function CG(e, t) {
  var n = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ae(e.since).year() : ae(e.since).year() + (t - e.offset) * n;
}
function yG() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].name;
  return "";
}
function xG() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].narrow;
  return "";
}
function EG() {
  var e, t, n, r = this.localeData().eras();
  for (e = 0, t = r.length; e < t; ++e)
    if (n = this.clone().startOf("day").valueOf(), r[e].since <= n && n <= r[e].until || r[e].until <= n && n <= r[e].since)
      return r[e].abbr;
  return "";
}
function IG() {
  var e, t, n, r, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (n = o[e].since <= o[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), o[e].since <= r && r <= o[e].until || o[e].until <= r && r <= o[e].since)
      return (this.year() - ae(o[e].since).year()) * n + o[e].offset;
  return this.year();
}
function SG(e) {
  return Ne(this, "_erasNameRegex") || u0.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function DG(e) {
  return Ne(this, "_erasAbbrRegex") || u0.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function MG(e) {
  return Ne(this, "_erasNarrowRegex") || u0.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function c0(e, t) {
  return t.erasAbbrRegex(e);
}
function NG(e, t) {
  return t.erasNameRegex(e);
}
function PG(e, t) {
  return t.erasNarrowRegex(e);
}
function AG(e, t) {
  return t._eraYearOrdinalRegex || ya;
}
function u0() {
  var e = [], t = [], n = [], r = [], o, a, i, s, l, c = this.eras();
  for (o = 0, a = c.length; o < a; ++o)
    i = Zn(c[o].name), s = Zn(c[o].abbr), l = Zn(c[o].narrow), t.push(i), e.push(s), n.push(l), r.push(i), r.push(s), r.push(l);
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
he(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
he(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function hu(e, t) {
  he(0, [e, e.length], 0, t);
}
hu("gggg", "weekYear");
hu("ggggg", "weekYear");
hu("GGGG", "isoWeekYear");
hu("GGGGG", "isoWeekYear");
se("G", cu);
se("g", cu);
se("GG", Ye, Bt);
se("gg", Ye, Bt);
se("GGGG", K3, J3);
se("gggg", K3, J3);
se("GGGGG", lu, iu);
se("ggggg", lu, iu);
ns(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, n, r) {
    t[r.substr(0, 2)] = xe(e);
  }
);
ns(["gg", "GG"], function(e, t, n, r) {
  t[r] = ae.parseTwoDigitYear(e);
});
function _G(e) {
  return Pw.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function OG(e) {
  return Pw.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function TG() {
  return $n(this.year(), 1, 4);
}
function LG() {
  return $n(this.isoWeekYear(), 1, 4);
}
function RG() {
  var e = this.localeData()._week;
  return $n(this.year(), e.dow, e.doy);
}
function VG() {
  var e = this.localeData()._week;
  return $n(this.weekYear(), e.dow, e.doy);
}
function Pw(e, t, n, r, o) {
  var a;
  return e == null ? Ci(this, r, o).year : (a = $n(e, r, o), t > a && (t = a), kG.call(this, e, t, n, r, o));
}
function kG(e, t, n, r, o) {
  var a = lw(e, t, n, r, o), i = bi(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
he("Q", 0, "Qo", "quarter");
se("Q", Kg);
Be("Q", function(e, t) {
  t[Bn] = (xe(e) - 1) * 3;
});
function FG(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
he("D", ["DD", 2], "Do", "date");
se("D", Ye, xa);
se("DD", Ye, Bt);
se("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
Be(["D", "DD"], gn);
Be("Do", function(e, t) {
  t[gn] = xe(e.match(Ye)[0]);
});
var Aw = Ea("Date", !0);
he("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
se("DDD", su);
se("DDDD", qg);
Be(["DDD", "DDDD"], function(e, t, n) {
  n._dayOfYear = xe(e);
});
function HG(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
he("m", ["mm", 2], 0, "minute");
se("m", Ye, q3);
se("mm", Ye, Bt);
Be(["m", "mm"], Qt);
var BG = Ea("Minutes", !1);
he("s", ["ss", 2], 0, "second");
se("s", Ye, q3);
se("ss", Ye, Bt);
Be(["s", "ss"], Gn);
var GG = Ea("Seconds", !1);
he("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
he(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
he(0, ["SSS", 3], 0, "millisecond");
he(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
he(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
he(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
he(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
he(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
he(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
se("S", su, Kg);
se("SS", su, Bt);
se("SSS", su, qg);
var lr, _w;
for (lr = "SSSS"; lr.length <= 9; lr += "S")
  se(lr, ya);
function WG(e, t) {
  t[Br] = xe(("0." + e) * 1e3);
}
for (lr = "S"; lr.length <= 9; lr += "S")
  Be(lr, WG);
_w = Ea("Milliseconds", !1);
he("z", 0, 0, "zoneAbbr");
he("zz", 0, 0, "zoneName");
function ZG() {
  return this._isUTC ? "UTC" : "";
}
function $G() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var ne = es.prototype;
ne.add = VB;
ne.calendar = ZB;
ne.clone = $B;
ne.diff = KB;
ne.endOf = sG;
ne.format = tG;
ne.from = nG;
ne.fromNow = rG;
ne.to = oG;
ne.toNow = aG;
ne.get = eH;
ne.invalidAt = vG;
ne.isAfter = YB;
ne.isBefore = jB;
ne.isBetween = zB;
ne.isSame = XB;
ne.isSameOrAfter = UB;
ne.isSameOrBefore = JB;
ne.isValid = hG;
ne.lang = Iw;
ne.locale = Ew;
ne.localeData = Sw;
ne.max = hB;
ne.min = pB;
ne.parsingFlags = mG;
ne.set = tH;
ne.startOf = iG;
ne.subtract = kB;
ne.toArray = dG;
ne.toObject = fG;
ne.toDate = uG;
ne.toISOString = QB;
ne.inspect = eG;
typeof Symbol < "u" && Symbol.for != null && (ne[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
ne.toJSON = pG;
ne.toString = qB;
ne.unix = cG;
ne.valueOf = lG;
ne.creationData = gG;
ne.eraName = yG;
ne.eraNarrow = xG;
ne.eraAbbr = EG;
ne.eraYear = IG;
ne.year = tw;
ne.isLeapYear = QF;
ne.weekYear = _G;
ne.isoWeekYear = OG;
ne.quarter = ne.quarters = FG;
ne.month = iw;
ne.daysInMonth = uH;
ne.week = ne.weeks = wH;
ne.isoWeek = ne.isoWeeks = bH;
ne.weeksInYear = RG;
ne.weeksInWeekYear = VG;
ne.isoWeeksInYear = TG;
ne.isoWeeksInISOWeekYear = LG;
ne.date = Aw;
ne.day = ne.days = OH;
ne.weekday = TH;
ne.isoWeekday = LH;
ne.dayOfYear = HG;
ne.hour = ne.hours = GH;
ne.minute = ne.minutes = BG;
ne.second = ne.seconds = GG;
ne.millisecond = ne.milliseconds = _w;
ne.utcOffset = EB;
ne.utc = SB;
ne.local = DB;
ne.parseZone = MB;
ne.hasAlignedHourOffset = NB;
ne.isDST = PB;
ne.isLocal = _B;
ne.isUtcOffset = OB;
ne.isUtc = bw;
ne.isUTC = bw;
ne.zoneAbbr = ZG;
ne.zoneName = $G;
ne.dates = Ut(
  "dates accessor is deprecated. Use date instead.",
  Aw
);
ne.months = Ut(
  "months accessor is deprecated. Use month instead",
  iw
);
ne.years = Ut(
  "years accessor is deprecated. Use year instead",
  tw
);
ne.zone = Ut(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  IB
);
ne.isDSTShifted = Ut(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  AB
);
function YG(e) {
  return $e(e * 1e3);
}
function jG() {
  return $e.apply(null, arguments).parseZone();
}
function Ow(e) {
  return e;
}
var Pe = z3.prototype;
Pe.calendar = _F;
Pe.longDateFormat = RF;
Pe.invalidDate = kF;
Pe.ordinal = BF;
Pe.preparse = Ow;
Pe.postformat = Ow;
Pe.relativeTime = WF;
Pe.pastFuture = ZF;
Pe.set = PF;
Pe.eras = wG;
Pe.erasParse = bG;
Pe.erasConvertYear = CG;
Pe.erasAbbrRegex = DG;
Pe.erasNameRegex = SG;
Pe.erasNarrowRegex = MG;
Pe.months = iH;
Pe.monthsShort = sH;
Pe.monthsParse = cH;
Pe.monthsRegex = fH;
Pe.monthsShortRegex = dH;
Pe.week = hH;
Pe.firstDayOfYear = gH;
Pe.firstDayOfWeek = vH;
Pe.weekdays = MH;
Pe.weekdaysMin = PH;
Pe.weekdaysShort = NH;
Pe.weekdaysParse = _H;
Pe.weekdaysRegex = RH;
Pe.weekdaysShortRegex = VH;
Pe.weekdaysMinRegex = kH;
Pe.isPM = HH;
Pe.meridiem = WH;
function Hl(e, t, n, r) {
  var o = Qn(), a = An().set(r, t);
  return o[n](a, e);
}
function Tw(e, t, n) {
  if (Jn(e) && (t = e, e = void 0), e = e || "", t != null)
    return Hl(e, t, n, "month");
  var r, o = [];
  for (r = 0; r < 12; r++)
    o[r] = Hl(e, r, n, "month");
  return o;
}
function d0(e, t, n, r) {
  typeof e == "boolean" ? (Jn(t) && (n = t, t = void 0), t = t || "") : (t = e, n = t, e = !1, Jn(t) && (n = t, t = void 0), t = t || "");
  var o = Qn(), a = e ? o._week.dow : 0, i, s = [];
  if (n != null)
    return Hl(t, (n + a) % 7, r, "day");
  for (i = 0; i < 7; i++)
    s[i] = Hl(t, (i + a) % 7, r, "day");
  return s;
}
function zG(e, t) {
  return Tw(e, t, "months");
}
function XG(e, t) {
  return Tw(e, t, "monthsShort");
}
function UG(e, t, n) {
  return d0(e, t, n, "weekdays");
}
function JG(e, t, n) {
  return d0(e, t, n, "weekdaysShort");
}
function KG(e, t, n) {
  return d0(e, t, n, "weekdaysMin");
}
dr("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, n = xe(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + n;
  }
});
ae.lang = Ut(
  "moment.lang is deprecated. Use moment.locale instead.",
  dr
);
ae.langData = Ut(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Qn
);
var Rn = Math.abs;
function qG() {
  var e = this._data;
  return this._milliseconds = Rn(this._milliseconds), this._days = Rn(this._days), this._months = Rn(this._months), e.milliseconds = Rn(e.milliseconds), e.seconds = Rn(e.seconds), e.minutes = Rn(e.minutes), e.hours = Rn(e.hours), e.months = Rn(e.months), e.years = Rn(e.years), this;
}
function Lw(e, t, n, r) {
  var o = fn(t, n);
  return e._milliseconds += r * o._milliseconds, e._days += r * o._days, e._months += r * o._months, e._bubble();
}
function QG(e, t) {
  return Lw(this, e, t, 1);
}
function eW(e, t) {
  return Lw(this, e, t, -1);
}
function ip(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function tW() {
  var e = this._milliseconds, t = this._days, n = this._months, r = this._data, o, a, i, s, l;
  return e >= 0 && t >= 0 && n >= 0 || e <= 0 && t <= 0 && n <= 0 || (e += ip(Pf(n) + t) * 864e5, t = 0, n = 0), r.milliseconds = e % 1e3, o = Zt(e / 1e3), r.seconds = o % 60, a = Zt(o / 60), r.minutes = a % 60, i = Zt(a / 60), r.hours = i % 24, t += Zt(i / 24), l = Zt(Rw(t)), n += l, t -= ip(Pf(l)), s = Zt(n / 12), n %= 12, r.days = t, r.months = n, r.years = s, this;
}
function Rw(e) {
  return e * 4800 / 146097;
}
function Pf(e) {
  return e * 146097 / 4800;
}
function nW(e) {
  if (!this.isValid())
    return NaN;
  var t, n, r = this._milliseconds;
  if (e = Jt(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + r / 864e5, n = this._months + Rw(t), e) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (t = this._days + Math.round(Pf(this._months)), e) {
      case "week":
        return t / 7 + r / 6048e5;
      case "day":
        return t + r / 864e5;
      case "hour":
        return t * 24 + r / 36e5;
      case "minute":
        return t * 1440 + r / 6e4;
      case "second":
        return t * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function er(e) {
  return function() {
    return this.as(e);
  };
}
var Vw = er("ms"), rW = er("s"), oW = er("m"), aW = er("h"), iW = er("d"), sW = er("w"), lW = er("M"), cW = er("Q"), uW = er("y"), dW = Vw;
function fW() {
  return fn(this);
}
function pW(e) {
  return e = Jt(e), this.isValid() ? this[e + "s"]() : NaN;
}
function fo(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var hW = fo("milliseconds"), mW = fo("seconds"), vW = fo("minutes"), gW = fo("hours"), wW = fo("days"), bW = fo("months"), CW = fo("years");
function yW() {
  return Zt(this.days() / 7);
}
var Hn = Math.round, Oo = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function xW(e, t, n, r, o) {
  return o.relativeTime(t || 1, !!n, e, r);
}
function EW(e, t, n, r) {
  var o = fn(e).abs(), a = Hn(o.as("s")), i = Hn(o.as("m")), s = Hn(o.as("h")), l = Hn(o.as("d")), c = Hn(o.as("M")), d = Hn(o.as("w")), f = Hn(o.as("y")), p = a <= n.ss && ["s", a] || a < n.s && ["ss", a] || i <= 1 && ["m"] || i < n.m && ["mm", i] || s <= 1 && ["h"] || s < n.h && ["hh", s] || l <= 1 && ["d"] || l < n.d && ["dd", l];
  return n.w != null && (p = p || d <= 1 && ["w"] || d < n.w && ["ww", d]), p = p || c <= 1 && ["M"] || c < n.M && ["MM", c] || f <= 1 && ["y"] || ["yy", f], p[2] = t, p[3] = +e > 0, p[4] = r, xW.apply(null, p);
}
function IW(e) {
  return e === void 0 ? Hn : typeof e == "function" ? (Hn = e, !0) : !1;
}
function SW(e, t) {
  return Oo[e] === void 0 ? !1 : t === void 0 ? Oo[e] : (Oo[e] = t, e === "s" && (Oo.ss = t - 1), !0);
}
function DW(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = Oo, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (n = e), typeof t == "object" && (r = Object.assign({}, Oo, t), t.s != null && t.ss == null && (r.ss = t.s - 1)), o = this.localeData(), a = EW(this, !n, r, o), n && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var Kd = Math.abs;
function Co(e) {
  return (e > 0) - (e < 0) || +e;
}
function mu() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Kd(this._milliseconds) / 1e3, t = Kd(this._days), n = Kd(this._months), r, o, a, i, s = this.asSeconds(), l, c, d, f;
  return s ? (r = Zt(e / 60), o = Zt(r / 60), e %= 60, r %= 60, a = Zt(n / 12), n %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", c = Co(this._months) !== Co(s) ? "-" : "", d = Co(this._days) !== Co(s) ? "-" : "", f = Co(this._milliseconds) !== Co(s) ? "-" : "", l + "P" + (a ? c + a + "Y" : "") + (n ? c + n + "M" : "") + (t ? d + t + "D" : "") + (o || r || e ? "T" : "") + (o ? f + o + "H" : "") + (r ? f + r + "M" : "") + (e ? f + i + "S" : "")) : "P0D";
}
var Ie = pu.prototype;
Ie.isValid = bB;
Ie.abs = qG;
Ie.add = QG;
Ie.subtract = eW;
Ie.as = nW;
Ie.asMilliseconds = Vw;
Ie.asSeconds = rW;
Ie.asMinutes = oW;
Ie.asHours = aW;
Ie.asDays = iW;
Ie.asWeeks = sW;
Ie.asMonths = lW;
Ie.asQuarters = cW;
Ie.asYears = uW;
Ie.valueOf = dW;
Ie._bubble = tW;
Ie.clone = fW;
Ie.get = pW;
Ie.milliseconds = hW;
Ie.seconds = mW;
Ie.minutes = vW;
Ie.hours = gW;
Ie.days = wW;
Ie.weeks = yW;
Ie.months = bW;
Ie.years = CW;
Ie.humanize = DW;
Ie.toISOString = mu;
Ie.toString = mu;
Ie.toJSON = mu;
Ie.locale = Ew;
Ie.localeData = Sw;
Ie.toIsoString = Ut(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  mu
);
Ie.lang = Iw;
he("X", 0, 0, "unix");
he("x", 0, 0, "valueOf");
se("x", cu);
se("X", zF);
Be("X", function(e, t, n) {
  n._d = new Date(parseFloat(e) * 1e3);
});
Be("x", function(e, t, n) {
  n._d = new Date(xe(e));
});
//! moment.js
ae.version = "2.30.1";
MF($e);
ae.fn = ne;
ae.min = mB;
ae.max = vB;
ae.now = gB;
ae.utc = An;
ae.unix = YG;
ae.months = zG;
ae.isDate = Qi;
ae.locale = dr;
ae.invalid = au;
ae.duration = fn;
ae.isMoment = an;
ae.weekdays = UG;
ae.parseZone = jG;
ae.localeData = Qn;
ae.isDuration = ll;
ae.monthsShort = XG;
ae.weekdaysMin = KG;
ae.defineLocale = r0;
ae.updateLocale = jH;
ae.locales = zH;
ae.weekdaysShort = JG;
ae.normalizeUnits = Jt;
ae.relativeTimeRounding = IW;
ae.relativeTimeThreshold = SW;
ae.calendarFormat = WB;
ae.prototype = ne;
ae.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function MW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function NW(e, t, n) {
  return t && sp(e.prototype, t), n && sp(e, n), e;
}
function PW(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : _f(e);
}
function Af(e) {
  return Af = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Af(e);
}
function _f(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function AW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Of(e, t);
}
function Of(e, t) {
  return Of = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Of(e, t);
}
function Bl(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var f0 = /* @__PURE__ */ function(e) {
  AW(t, e);
  function t(n) {
    var r;
    MW(this, t), r = PW(this, Af(t).call(this, n)), Bl(_f(r), "onInputChange", function(i) {
      var s = i.target.value;
      r.setState({
        str: s
      });
      var l = r.props, c = l.format, d = l.hourOptions, f = l.minuteOptions, p = l.secondOptions, h = l.disabledHours, g = l.disabledMinutes, m = l.disabledSeconds, v = l.onChange;
      if (s) {
        var w = r.props.value, C = r.getProtoValue().clone(), y = ae(s, c, !0);
        if (!y.isValid()) {
          r.setState({
            invalid: !0
          });
          return;
        }
        if (C.hour(y.hour()).minute(y.minute()).second(y.second()), d.indexOf(C.hour()) < 0 || f.indexOf(C.minute()) < 0 || p.indexOf(C.second()) < 0) {
          r.setState({
            invalid: !0
          });
          return;
        }
        var x = h(), E = g(C.hour()), S = m(C.hour(), C.minute());
        if (x && x.indexOf(C.hour()) >= 0 || E && E.indexOf(C.minute()) >= 0 || S && S.indexOf(C.second()) >= 0) {
          r.setState({
            invalid: !0
          });
          return;
        }
        if (w) {
          if (w.hour() !== C.hour() || w.minute() !== C.minute() || w.second() !== C.second()) {
            var I = w.clone();
            I.hour(C.hour()), I.minute(C.minute()), I.second(C.second()), v(I);
          }
        } else
          w !== C && v(C);
      } else
        v(null);
      r.setState({
        invalid: !1
      });
    }), Bl(_f(r), "onKeyDown", function(i) {
      var s = r.props, l = s.onEsc, c = s.onKeyDown;
      i.keyCode === 27 && l(), c(i);
    });
    var o = n.value, a = n.format;
    return r.state = {
      str: o && o.format(a) || "",
      invalid: !1
    }, r;
  }
  return NW(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this, o = this.props.focusOnOpen;
      if (o) {
        var a = window.requestAnimationFrame || window.setTimeout;
        a(function() {
          r.refInput.focus(), r.refInput.select();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var o = this.props, a = o.value, i = o.format;
      a !== r.value && this.setState({
        str: a && a.format(i) || "",
        invalid: !1
      });
    }
  }, {
    key: "getProtoValue",
    value: function() {
      var r = this.props, o = r.value, a = r.defaultOpenValue;
      return o || a;
    }
  }, {
    key: "getInput",
    value: function() {
      var r = this, o = this.props, a = o.prefixCls, i = o.placeholder, s = o.inputReadOnly, l = this.state, c = l.invalid, d = l.str, f = c ? "".concat(a, "-input-invalid") : "";
      return X.createElement("input", {
        className: _t("".concat(a, "-input"), f),
        ref: function(h) {
          r.refInput = h;
        },
        onKeyDown: this.onKeyDown,
        value: d,
        placeholder: i,
        onChange: this.onInputChange,
        readOnly: !!s
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props.prefixCls;
      return X.createElement("div", {
        className: "".concat(r, "-input-wrap")
      }, this.getInput());
    }
  }]), t;
}(Mn);
Bl(f0, "propTypes", {
  format: M.string,
  prefixCls: M.string,
  disabledDate: M.func,
  placeholder: M.string,
  clearText: M.string,
  value: M.object,
  inputReadOnly: M.bool,
  hourOptions: M.array,
  minuteOptions: M.array,
  secondOptions: M.array,
  disabledHours: M.func,
  disabledMinutes: M.func,
  disabledSeconds: M.func,
  onChange: M.func,
  onEsc: M.func,
  defaultOpenValue: M.object,
  currentSelectPanel: M.string,
  focusOnOpen: M.bool,
  onKeyDown: M.func,
  clearIcon: M.node
});
Bl(f0, "defaultProps", {
  inputReadOnly: !1
});
var vu = { exports: {} }, Ka = { exports: {} };
(function() {
  var e, t, n, r, o, a;
  typeof performance < "u" && performance !== null && performance.now ? Ka.exports = function() {
    return performance.now();
  } : typeof process < "u" && process !== null && process.hrtime ? (Ka.exports = function() {
    return (e() - o) / 1e6;
  }, t = process.hrtime, e = function() {
    var i;
    return i = t(), i[0] * 1e9 + i[1];
  }, r = e(), a = process.uptime() * 1e9, o = r - a) : Date.now ? (Ka.exports = function() {
    return Date.now() - n;
  }, n = Date.now()) : (Ka.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - n;
  }, n = (/* @__PURE__ */ new Date()).getTime());
}).call(A8);
var _W = Ka.exports, OW = _W, Yn = typeof window > "u" ? A8 : window, Ws = ["moz", "webkit"], $o = "AnimationFrame", zo = Yn["request" + $o], xi = Yn["cancel" + $o] || Yn["cancelRequest" + $o];
for (var Va = 0; !zo && Va < Ws.length; Va++)
  zo = Yn[Ws[Va] + "Request" + $o], xi = Yn[Ws[Va] + "Cancel" + $o] || Yn[Ws[Va] + "CancelRequest" + $o];
if (!zo || !xi) {
  var qd = 0, lp = 0, Tr = [], TW = 1e3 / 60;
  zo = function(e) {
    if (Tr.length === 0) {
      var t = OW(), n = Math.max(0, TW - (t - qd));
      qd = n + t, setTimeout(function() {
        var r = Tr.slice(0);
        Tr.length = 0;
        for (var o = 0; o < r.length; o++)
          if (!r[o].cancelled)
            try {
              r[o].callback(qd);
            } catch (a) {
              setTimeout(function() {
                throw a;
              }, 0);
            }
      }, Math.round(n));
    }
    return Tr.push({
      handle: ++lp,
      callback: e,
      cancelled: !1
    }), lp;
  }, xi = function(e) {
    for (var t = 0; t < Tr.length; t++)
      Tr[t].handle === e && (Tr[t].cancelled = !0);
  };
}
vu.exports = function(e) {
  return zo.call(Yn, e);
};
vu.exports.cancel = function() {
  xi.apply(Yn, arguments);
};
vu.exports.polyfill = function(e) {
  e || (e = Yn), e.requestAnimationFrame = zo, e.cancelAnimationFrame = xi;
};
var LW = vu.exports;
const cp = /* @__PURE__ */ ua(LW);
function RW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function up(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function VW(e, t, n) {
  return t && up(e.prototype, t), n && up(e, n), e;
}
function kW(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : Ao(e);
}
function Tf(e) {
  return Tf = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Tf(e);
}
function Ao(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function FW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Lf(e, t);
}
function Lf(e, t) {
  return Lf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Lf(e, t);
}
function kn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var HW = function e(t, n, r) {
  if (r <= 0) {
    cp(function() {
      t.scrollTop = n;
    });
    return;
  }
  var o = n - t.scrollTop, a = o / r * 10;
  cp(function() {
    t.scrollTop += a, t.scrollTop !== n && e(t, n, r - 10);
  });
}, qa = /* @__PURE__ */ function(e) {
  FW(t, e);
  function t() {
    var n, r;
    RW(this, t);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = kW(this, (n = Tf(t)).call.apply(n, [this].concat(a))), kn(Ao(r), "state", {
      active: !1
    }), kn(Ao(r), "onSelect", function(s) {
      var l = r.props, c = l.onSelect, d = l.type;
      c(d, s);
    }), kn(Ao(r), "handleMouseEnter", function(s) {
      var l = r.props.onMouseEnter;
      r.setState({
        active: !0
      }), l(s);
    }), kn(Ao(r), "handleMouseLeave", function() {
      r.setState({
        active: !1
      });
    }), kn(Ao(r), "saveList", function(s) {
      r.list = s;
    }), r;
  }
  return VW(t, [{
    key: "componentDidMount",
    value: function() {
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var o = this.props.selectedIndex;
      r.selectedIndex !== o && this.scrollToSelected(120);
    }
  }, {
    key: "getOptions",
    value: function() {
      var r = this, o = this.props, a = o.options, i = o.selectedIndex, s = o.prefixCls, l = o.onEsc;
      return a.map(function(c, d) {
        var f, p = _t((f = {}, kn(f, "".concat(s, "-select-option-selected"), i === d), kn(f, "".concat(s, "-select-option-disabled"), c.disabled), f)), h = c.disabled ? void 0 : function() {
          r.onSelect(c.value);
        }, g = function(v) {
          v.keyCode === 13 ? h() : v.keyCode === 27 && l();
        };
        return X.createElement("li", {
          role: "button",
          onClick: h,
          className: p,
          key: d,
          disabled: c.disabled,
          tabIndex: "0",
          onKeyDown: g
        }, c.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function(r) {
      var o = this.props.selectedIndex, a = kt.findDOMNode(this), i = kt.findDOMNode(this.list);
      if (i) {
        var s = o;
        s < 0 && (s = 0);
        var l = i.children[s], c = l.offsetTop;
        HW(a, c, r);
      }
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.prefixCls, a = r.options, i = this.state.active;
      if (a.length === 0)
        return null;
      var s = _t("".concat(o, "-select"), kn({}, "".concat(o, "-select-active"), i));
      return X.createElement("div", {
        className: s,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, X.createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]), t;
}(Mn);
kn(qa, "propTypes", {
  prefixCls: M.string,
  options: M.array,
  selectedIndex: M.number,
  type: M.string,
  onSelect: M.func,
  onMouseEnter: M.func,
  onEsc: M.func
});
function BW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function GW(e, t, n) {
  return t && dp(e.prototype, t), n && dp(e, n), e;
}
function WW(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : Vf(e);
}
function Rf(e) {
  return Rf = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Rf(e);
}
function Vf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ZW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && kf(e, t);
}
function kf(e, t) {
  return kf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, kf(e, t);
}
function Ff(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Qd = function(t, n) {
  var r = "".concat(t);
  t < 10 && (r = "0".concat(t));
  var o = !1;
  return n && n.indexOf(t) >= 0 && (o = !0), {
    value: r,
    disabled: o
  };
}, kw = /* @__PURE__ */ function(e) {
  ZW(t, e);
  function t() {
    var n, r;
    BW(this, t);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = WW(this, (n = Rf(t)).call.apply(n, [this].concat(a))), Ff(Vf(r), "onItemChange", function(s, l) {
      var c = r.props, d = c.onChange, f = c.defaultOpenValue, p = c.use12Hours, h = c.value, g = c.isAM, m = c.onAmPmChange, v = (h || f).clone();
      if (s === "hour")
        p ? g ? v.hour(+l % 12) : v.hour(+l % 12 + 12) : v.hour(+l);
      else if (s === "minute")
        v.minute(+l);
      else if (s === "ampm") {
        var w = l.toUpperCase();
        p && (w === "PM" && v.hour() < 12 && v.hour(v.hour() % 12 + 12), w === "AM" && v.hour() >= 12 && v.hour(v.hour() - 12)), m(w);
      } else
        v.second(+l);
      d(v);
    }), Ff(Vf(r), "onEnterSelectPanel", function(s) {
      var l = r.props.onCurrentSelectPanelChange;
      l(s);
    }), r;
  }
  return GW(t, [{
    key: "getHourSelect",
    value: function(r) {
      var o = this, a = this.props, i = a.prefixCls, s = a.hourOptions, l = a.disabledHours, c = a.showHour, d = a.use12Hours, f = a.onEsc;
      if (!c)
        return null;
      var p = l(), h, g;
      return d ? (h = [12].concat(s.filter(function(m) {
        return m < 12 && m > 0;
      })), g = r % 12 || 12) : (h = s, g = r), X.createElement(qa, {
        prefixCls: i,
        options: h.map(function(m) {
          return Qd(m, p);
        }),
        selectedIndex: h.indexOf(g),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function() {
          return o.onEnterSelectPanel("hour");
        },
        onEsc: f
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function(r) {
      var o = this, a = this.props, i = a.prefixCls, s = a.minuteOptions, l = a.disabledMinutes, c = a.defaultOpenValue, d = a.showMinute, f = a.value, p = a.onEsc;
      if (!d)
        return null;
      var h = f || c, g = l(h.hour());
      return X.createElement(qa, {
        prefixCls: i,
        options: s.map(function(m) {
          return Qd(m, g);
        }),
        selectedIndex: s.indexOf(r),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function() {
          return o.onEnterSelectPanel("minute");
        },
        onEsc: p
      });
    }
  }, {
    key: "getSecondSelect",
    value: function(r) {
      var o = this, a = this.props, i = a.prefixCls, s = a.secondOptions, l = a.disabledSeconds, c = a.showSecond, d = a.defaultOpenValue, f = a.value, p = a.onEsc;
      if (!c)
        return null;
      var h = f || d, g = l(h.hour(), h.minute());
      return X.createElement(qa, {
        prefixCls: i,
        options: s.map(function(m) {
          return Qd(m, g);
        }),
        selectedIndex: s.indexOf(r),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function() {
          return o.onEnterSelectPanel("second");
        },
        onEsc: p
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function() {
      var r = this, o = this.props, a = o.prefixCls, i = o.use12Hours, s = o.format, l = o.isAM, c = o.onEsc;
      if (!i)
        return null;
      var d = ["am", "pm"].map(function(p) {
        return s.match(/\sA/) ? p.toUpperCase() : p;
      }).map(function(p) {
        return {
          value: p
        };
      }), f = l ? 0 : 1;
      return X.createElement(qa, {
        prefixCls: a,
        options: d,
        selectedIndex: f,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function() {
          return r.onEnterSelectPanel("ampm");
        },
        onEsc: c
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.prefixCls, a = r.defaultOpenValue, i = r.value, s = i || a;
      return X.createElement("div", {
        className: "".concat(o, "-combobox")
      }, this.getHourSelect(s.hour()), this.getMinuteSelect(s.minute()), this.getSecondSelect(s.second()), this.getAMPMSelect(s.hour()));
    }
  }]), t;
}(Mn);
Ff(kw, "propTypes", {
  format: M.string,
  defaultOpenValue: M.object,
  prefixCls: M.string,
  value: M.object,
  onChange: M.func,
  onAmPmChange: M.func,
  showHour: M.bool,
  showMinute: M.bool,
  showSecond: M.bool,
  hourOptions: M.array,
  minuteOptions: M.array,
  secondOptions: M.array,
  disabledHours: M.func,
  disabledMinutes: M.func,
  disabledSeconds: M.func,
  onCurrentSelectPanelChange: M.func,
  use12Hours: M.bool,
  onEsc: M.func,
  isAM: M.bool
});
function fp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function $W(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? fp(Object(n), !0).forEach(function(r) {
      ar(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function YW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function pp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function jW(e, t, n) {
  return t && pp(e.prototype, t), n && pp(e, n), e;
}
function zW(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : _o(e);
}
function Hf(e) {
  return Hf = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Hf(e);
}
function _o(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function XW(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Bf(e, t);
}
function Bf(e, t) {
  return Bf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Bf(e, t);
}
function ar(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lr() {
}
function e1(e, t, n) {
  for (var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, o = [], a = 0; a < e; a += r)
    (!t || t.indexOf(a) < 0 || !n) && o.push(a);
  return o;
}
function UW(e, t, n, r) {
  var o = t.slice().sort(function(s, l) {
    return Math.abs(e.hour() - s) - Math.abs(e.hour() - l);
  })[0], a = n.slice().sort(function(s, l) {
    return Math.abs(e.minute() - s) - Math.abs(e.minute() - l);
  })[0], i = r.slice().sort(function(s, l) {
    return Math.abs(e.second() - s) - Math.abs(e.second() - l);
  })[0];
  return ae("".concat(o, ":").concat(a, ":").concat(i), "HH:mm:ss");
}
var gu = /* @__PURE__ */ function(e) {
  XW(t, e);
  function t() {
    var n, r;
    YW(this, t);
    for (var o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = zW(this, (n = Hf(t)).call.apply(n, [this].concat(a))), ar(_o(r), "state", {}), ar(_o(r), "onChange", function(s) {
      var l = r.props.onChange;
      r.setState({
        value: s
      }), l(s);
    }), ar(_o(r), "onAmPmChange", function(s) {
      var l = r.props.onAmPmChange;
      l(s);
    }), ar(_o(r), "onCurrentSelectPanelChange", function(s) {
      r.setState({
        currentSelectPanel: s
      });
    }), ar(_o(r), "disabledHours", function() {
      var s = r.props, l = s.use12Hours, c = s.disabledHours, d = c();
      return l && Array.isArray(d) && (r.isAM() ? d = d.filter(function(f) {
        return f < 12;
      }).map(function(f) {
        return f === 0 ? 12 : f;
      }) : d = d.map(function(f) {
        return f === 12 ? 12 : f - 12;
      })), d;
    }), r;
  }
  return jW(t, [{
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function() {
      var r = this.props.onEsc;
      r();
    }
  }, {
    key: "isAM",
    value: function() {
      var r = this.props.defaultOpenValue, o = this.state.value, a = o || r;
      return a.hour() >= 0 && a.hour() < 12;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.prefixCls, a = r.className, i = r.placeholder, s = r.disabledMinutes, l = r.disabledSeconds, c = r.hideDisabledOptions, d = r.showHour, f = r.showMinute, p = r.showSecond, h = r.format, g = r.defaultOpenValue, m = r.clearText, v = r.onEsc, w = r.addon, C = r.use12Hours, y = r.focusOnOpen, x = r.onKeyDown, E = r.hourStep, S = r.minuteStep, I = r.secondStep, D = r.inputReadOnly, N = r.clearIcon, A = this.state, L = A.value, F = A.currentSelectPanel, k = this.disabledHours(), G = s(L ? L.hour() : null), J = l(L ? L.hour() : null, L ? L.minute() : null), $ = e1(24, k, c, E), H = e1(60, G, c, S), V = e1(60, J, c, I), j = UW(g, $, H, V);
      return X.createElement("div", {
        className: _t(a, "".concat(o, "-inner"))
      }, X.createElement(f0, {
        clearText: m,
        prefixCls: o,
        defaultOpenValue: j,
        value: L,
        currentSelectPanel: F,
        onEsc: v,
        format: h,
        placeholder: i,
        hourOptions: $,
        minuteOptions: H,
        secondOptions: V,
        disabledHours: this.disabledHours,
        disabledMinutes: s,
        disabledSeconds: l,
        onChange: this.onChange,
        focusOnOpen: y,
        onKeyDown: x,
        inputReadOnly: D,
        clearIcon: N
      }), X.createElement(kw, {
        prefixCls: o,
        value: L,
        defaultOpenValue: j,
        format: h,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: d,
        showMinute: f,
        showSecond: p,
        hourOptions: $,
        minuteOptions: H,
        secondOptions: V,
        disabledHours: this.disabledHours,
        disabledMinutes: s,
        disabledSeconds: l,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: C,
        onEsc: v,
        isAM: this.isAM()
      }), w(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      return "value" in r ? $W({}, o, {
        value: r.value
      }) : null;
    }
  }]), t;
}(Mn);
ar(gu, "propTypes", {
  clearText: M.string,
  prefixCls: M.string,
  className: M.string,
  defaultOpenValue: M.object,
  value: M.object,
  placeholder: M.string,
  format: M.string,
  inputReadOnly: M.bool,
  disabledHours: M.func,
  disabledMinutes: M.func,
  disabledSeconds: M.func,
  hideDisabledOptions: M.bool,
  onChange: M.func,
  onAmPmChange: M.func,
  onEsc: M.func,
  showHour: M.bool,
  showMinute: M.bool,
  showSecond: M.bool,
  use12Hours: M.bool,
  hourStep: M.number,
  minuteStep: M.number,
  secondStep: M.number,
  addon: M.func,
  focusOnOpen: M.bool,
  onKeyDown: M.func,
  clearIcon: M.node
});
ar(gu, "defaultProps", {
  prefixCls: "rc-time-picker-panel",
  onChange: Lr,
  disabledHours: Lr,
  disabledMinutes: Lr,
  disabledSeconds: Lr,
  defaultOpenValue: ae(),
  use12Hours: !1,
  addon: Lr,
  onKeyDown: Lr,
  onAmPmChange: Lr,
  inputReadOnly: !1
});
L3(gu);
var Zs = {
  adjustX: 1,
  adjustY: 1
}, $s = [0, 0], JW = {
  bottomLeft: {
    points: ["tl", "tl"],
    overflow: Zs,
    offset: [0, -3],
    targetOffset: $s
  },
  bottomRight: {
    points: ["tr", "tr"],
    overflow: Zs,
    offset: [0, -3],
    targetOffset: $s
  },
  topRight: {
    points: ["br", "br"],
    overflow: Zs,
    offset: [0, 3],
    targetOffset: $s
  },
  topLeft: {
    points: ["bl", "bl"],
    overflow: Zs,
    offset: [0, 3],
    targetOffset: $s
  }
};
function hp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function KW(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hp(Object(n), !0).forEach(function(r) {
      pn(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qW(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function QW(e, t, n) {
  return t && mp(e.prototype, t), n && mp(e, n), e;
}
function eZ(e, t) {
  return t && (typeof t == "object" || typeof t == "function") ? t : Fn(e);
}
function Gf(e) {
  return Gf = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Gf(e);
}
function Fn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function tZ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && Wf(e, t);
}
function Wf(e, t) {
  return Wf = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, Wf(e, t);
}
function pn(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wt() {
}
function vp(e, t) {
  this[e] = t;
}
var wu = /* @__PURE__ */ function(e) {
  tZ(t, e);
  function t(n) {
    var r;
    qW(this, t), r = eZ(this, Gf(t).call(this, n)), pn(Fn(r), "onPanelChange", function(d) {
      r.setValue(d);
    }), pn(Fn(r), "onAmPmChange", function(d) {
      var f = r.props.onAmPmChange;
      f(d);
    }), pn(Fn(r), "onClear", function(d) {
      d.stopPropagation(), r.setValue(null), r.setOpen(!1);
    }), pn(Fn(r), "onVisibleChange", function(d) {
      r.setOpen(d);
    }), pn(Fn(r), "onEsc", function() {
      r.setOpen(!1), r.focus();
    }), pn(Fn(r), "onKeyDown", function(d) {
      d.keyCode === 40 && r.setOpen(!0);
    }), r.saveInputRef = vp.bind(Fn(r), "picker"), r.savePanelRef = vp.bind(Fn(r), "panelInstance");
    var o = n.defaultOpen, a = n.defaultValue, i = n.open, s = i === void 0 ? o : i, l = n.value, c = l === void 0 ? a : l;
    return r.state = {
      open: s,
      value: c
    }, r;
  }
  return QW(t, [{
    key: "setValue",
    value: function(r) {
      var o = this.props.onChange;
      "value" in this.props || this.setState({
        value: r
      }), o(r);
    }
  }, {
    key: "getFormat",
    value: function() {
      var r = this.props, o = r.format, a = r.showHour, i = r.showMinute, s = r.showSecond, l = r.use12Hours;
      if (o)
        return o;
      if (l) {
        var c = [a ? "h" : "", i ? "mm" : "", s ? "ss" : ""].filter(function(d) {
          return !!d;
        }).join(":");
        return c.concat(" a");
      }
      return [a ? "HH" : "", i ? "mm" : "", s ? "ss" : ""].filter(function(d) {
        return !!d;
      }).join(":");
    }
  }, {
    key: "getPanelElement",
    value: function() {
      var r = this.props, o = r.prefixCls, a = r.placeholder, i = r.disabledHours, s = r.disabledMinutes, l = r.disabledSeconds, c = r.hideDisabledOptions, d = r.inputReadOnly, f = r.showHour, p = r.showMinute, h = r.showSecond, g = r.defaultOpenValue, m = r.clearText, v = r.addon, w = r.use12Hours, C = r.focusOnOpen, y = r.onKeyDown, x = r.hourStep, E = r.minuteStep, S = r.secondStep, I = r.clearIcon, D = this.state.value;
      return X.createElement(gu, {
        clearText: m,
        prefixCls: "".concat(o, "-panel"),
        ref: this.savePanelRef,
        value: D,
        inputReadOnly: d,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: g,
        showHour: f,
        showMinute: p,
        showSecond: h,
        onEsc: this.onEsc,
        format: this.getFormat(),
        placeholder: a,
        disabledHours: i,
        disabledMinutes: s,
        disabledSeconds: l,
        hideDisabledOptions: c,
        use12Hours: w,
        hourStep: x,
        minuteStep: E,
        secondStep: S,
        addon: v,
        focusOnOpen: C,
        onKeyDown: y,
        clearIcon: I
      });
    }
  }, {
    key: "getPopupClassName",
    value: function() {
      var r = this.props, o = r.showHour, a = r.showMinute, i = r.showSecond, s = r.use12Hours, l = r.prefixCls, c = r.popupClassName, d = 0;
      return o && (d += 1), a && (d += 1), i && (d += 1), s && (d += 1), _t(c, pn({}, "".concat(l, "-panel-narrow"), (!o || !a || !i) && !s), "".concat(l, "-panel-column-").concat(d));
    }
  }, {
    key: "setOpen",
    value: function(r) {
      var o = this.props, a = o.onOpen, i = o.onClose, s = this.state.open;
      s !== r && ("open" in this.props || this.setState({
        open: r
      }), r ? a({
        open: r
      }) : i({
        open: r
      }));
    }
  }, {
    key: "focus",
    value: function() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function() {
      var r = this, o = this.state.value, a = this.props, i = a.prefixCls, s = a.allowEmpty, l = a.clearIcon, c = a.clearText, d = a.disabled;
      if (!s || !o || d)
        return null;
      if (X.isValidElement(l)) {
        var f = l.props || {}, p = f.onClick;
        return X.cloneElement(l, {
          onClick: function() {
            p && p.apply(void 0, arguments), r.onClear.apply(r, arguments);
          }
        });
      }
      return X.createElement("a", {
        role: "button",
        className: "".concat(i, "-clear"),
        title: c,
        onClick: this.onClear,
        tabIndex: 0
      }, l || X.createElement("i", {
        className: "".concat(i, "-clear-icon")
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, o = r.prefixCls, a = r.placeholder, i = r.placement, s = r.align, l = r.id, c = r.disabled, d = r.transitionName, f = r.style, p = r.className, h = r.getPopupContainer, g = r.name, m = r.autoComplete, v = r.onFocus, w = r.onBlur, C = r.autoFocus, y = r.inputReadOnly, x = r.inputIcon, E = r.popupStyle, S = this.state, I = S.open, D = S.value, N = this.getPopupClassName();
      return X.createElement(Ca, {
        prefixCls: "".concat(o, "-panel"),
        popupClassName: N,
        popupStyle: E,
        popup: this.getPanelElement(),
        popupAlign: s,
        builtinPlacements: JW,
        popupPlacement: i,
        action: c ? [] : ["click"],
        destroyPopupOnHide: !0,
        getPopupContainer: h,
        popupTransitionName: d,
        popupVisible: I,
        onPopupVisibleChange: this.onVisibleChange
      }, X.createElement("span", {
        className: _t(o, p),
        style: f
      }, X.createElement("input", {
        className: "".concat(o, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: a,
        name: g,
        onKeyDown: this.onKeyDown,
        disabled: c,
        value: D && D.format(this.getFormat()) || "",
        autoComplete: m,
        onFocus: v,
        onBlur: w,
        autoFocus: C,
        onChange: Wt,
        readOnly: !!y,
        id: l
      }), x || X.createElement("span", {
        className: "".concat(o, "-icon")
      }), this.renderClearButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, o) {
      var a = {};
      return "value" in r && (a.value = r.value), r.open !== void 0 && (a.open = r.open), Object.keys(a).length > 0 ? KW({}, o, {}, a) : null;
    }
  }]), t;
}(Mn);
pn(wu, "propTypes", {
  prefixCls: M.string,
  clearText: M.string,
  value: M.object,
  defaultOpenValue: M.object,
  inputReadOnly: M.bool,
  disabled: M.bool,
  allowEmpty: M.bool,
  defaultValue: M.object,
  open: M.bool,
  defaultOpen: M.bool,
  align: M.object,
  placement: M.any,
  transitionName: M.string,
  getPopupContainer: M.func,
  placeholder: M.string,
  format: M.string,
  showHour: M.bool,
  showMinute: M.bool,
  showSecond: M.bool,
  style: M.object,
  className: M.string,
  popupClassName: M.string,
  popupStyle: M.object,
  disabledHours: M.func,
  disabledMinutes: M.func,
  disabledSeconds: M.func,
  hideDisabledOptions: M.bool,
  onChange: M.func,
  onAmPmChange: M.func,
  onOpen: M.func,
  onClose: M.func,
  onFocus: M.func,
  onBlur: M.func,
  addon: M.func,
  name: M.string,
  autoComplete: M.string,
  use12Hours: M.bool,
  hourStep: M.number,
  minuteStep: M.number,
  secondStep: M.number,
  focusOnOpen: M.bool,
  onKeyDown: M.func,
  autoFocus: M.bool,
  id: M.string,
  inputIcon: M.node,
  clearIcon: M.node
});
pn(wu, "defaultProps", {
  clearText: "clear",
  prefixCls: "rc-time-picker",
  defaultOpen: !1,
  inputReadOnly: !1,
  style: {},
  className: "",
  popupClassName: "",
  popupStyle: {},
  align: {},
  defaultOpenValue: ae(),
  allowEmpty: !0,
  showHour: !0,
  showMinute: !0,
  showSecond: !0,
  disabledHours: Wt,
  disabledMinutes: Wt,
  disabledSeconds: Wt,
  hideDisabledOptions: !1,
  placement: "bottomLeft",
  onChange: Wt,
  onAmPmChange: Wt,
  onOpen: Wt,
  onClose: Wt,
  onFocus: Wt,
  onBlur: Wt,
  addon: Wt,
  use12Hours: !1,
  focusOnOpen: !1,
  onKeyDown: Wt
});
L3(wu);
const nZ = "_root_14ust_1", rZ = "_rcTimePicker_14ust_7", oZ = "_leftContent_14ust_21", aZ = "_hasError_14ust_29", iZ = "_rcTimePickerPopup_14ust_33", ka = {
  root: nZ,
  rcTimePicker: rZ,
  leftContent: oZ,
  hasError: aZ,
  rcTimePickerPopup: iZ
}, Xte = (e) => /* @__PURE__ */ T("div", { className: P(ka.root, e.className), children: [
  e.leftContent && /* @__PURE__ */ u("div", { className: "tw-absolute tw-h-[54px] tw-flex tw-justify-center tw-items-center tw-left-3 tw-cursor-pointer tw-z-9999", children: e.leftContent }),
  /* @__PURE__ */ u(
    s8,
    {
      className: P(
        "tw-text-grayscale-text-label tw-absolute tw-top-[18px] tw-cursor-pointer tw-z-9999",
        e.leftContent ? "tw-left-[92px]" : "tw-left-3"
      ),
      size: 20,
      color: e.disabled ? "#9CA3AF" : void 0,
      onClick: () => {
        e.onDelete != null && e.onDelete();
      }
    }
  ),
  /* @__PURE__ */ u(
    wu,
    {
      ...e,
      className: P(
        ka.rcTimePicker,
        e.buttonClassName,
        e.leftContent && ka.leftContent,
        e.hasError && ka.hasError,
        "disabled:tw-bg-gray-50"
      ),
      popupClassName: P(ka.rcTimePickerPopup, e.popupClassName),
      clearIcon: /* @__PURE__ */ u("div", {})
    }
  ),
  e.showDeleteIcon ? /* @__PURE__ */ u(
    LD,
    {
      className: "tw-text-grayscale-text-label tw-absolute tw-top-[18px] tw-right-3 tw-cursor-pointer",
      size: 20,
      color: e.disabled ? "#9CA3AF" : void 0,
      onClick: () => {
        e.onDelete != null && e.onDelete();
      }
    }
  ) : /* @__PURE__ */ u(
    la,
    {
      className: "tw-text-grayscale-text-label tw-absolute tw-top-[18px] tw-right-3 tw-cursor-pointer",
      size: 20,
      color: e.disabled ? "#9CA3AF" : void 0
    }
  )
] });
var sZ = "Label", Fw = b.forwardRef((e, t) => /* @__PURE__ */ u(
  ie.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Fw.displayName = sZ;
var Hw = Fw;
const lZ = Xt(
  "tw-text-normal tw-font-sans tw-font-normal tw-leading-4 tw-peer-disabled:cursor-not-allowed tw-peer-disabled:opacity-70 tw-text-grayscale-text-body"
), cZ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(Hw, { ref: n, className: P(lZ(), e), ...t }));
cZ.displayName = Hw.displayName;
var p0 = "Radio", [uZ, Bw] = st(p0), [dZ, fZ] = uZ(p0), Gw = b.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: c,
      ...d
    } = e, [f, p] = b.useState(null), h = we(t, (v) => p(v)), g = b.useRef(!1), m = f ? c || !!f.closest("form") : !0;
    return /* @__PURE__ */ T(dZ, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ u(
        ie.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Yw(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...d,
          ref: h,
          onClick: oe(e.onClick, (v) => {
            o || l == null || l(), m && (g.current = v.isPropagationStopped(), g.current || v.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ u(
        $w,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: s,
          checked: o,
          required: a,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Gw.displayName = p0;
var Ww = "RadioIndicator", Zw = b.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, a = fZ(Ww, n);
    return /* @__PURE__ */ u(ut, { present: r || a.checked, children: /* @__PURE__ */ u(
      ie.span,
      {
        "data-state": Yw(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
Zw.displayName = Ww;
var pZ = "RadioBubbleInput", $w = b.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, a) => {
    const i = b.useRef(null), s = we(i, a), l = oc(n), c = tc(t);
    return b.useEffect(() => {
      const d = i.current;
      if (!d)
        return;
      const f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && h) {
        const g = new Event("click", { bubbles: r });
        h.call(d, n), d.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ u(
      ie.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
$w.displayName = pZ;
function Yw(e) {
  return e ? "checked" : "unchecked";
}
var hZ = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], bu = "RadioGroup", [mZ, Ute] = st(bu, [
  pa,
  Bw
]), jw = pa(), zw = Bw(), [vZ, gZ] = mZ(bu), Xw = b.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: c,
      loop: d = !0,
      onValueChange: f,
      ...p
    } = e, h = jw(n), g = ra(c), [m, v] = vt({
      prop: a,
      defaultProp: o ?? null,
      onChange: f,
      caller: bu
    });
    return /* @__PURE__ */ u(
      vZ,
      {
        scope: n,
        name: r,
        required: i,
        disabled: s,
        value: m,
        onValueChange: v,
        children: /* @__PURE__ */ u(
          t3,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: g,
            loop: d,
            children: /* @__PURE__ */ u(
              ie.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: g,
                ...p,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Xw.displayName = bu;
var Uw = "RadioGroupItem", Jw = b.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, a = gZ(Uw, n), i = a.disabled || r, s = jw(n), l = zw(n), c = b.useRef(null), d = we(t, c), f = a.value === o.value, p = b.useRef(!1);
    return b.useEffect(() => {
      const h = (m) => {
        hZ.includes(m.key) && (p.current = !0);
      }, g = () => p.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ u(
      n3,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: f,
        children: /* @__PURE__ */ u(
          Gw,
          {
            disabled: i,
            required: a.required,
            checked: f,
            ...l,
            ...o,
            name: a.name,
            ref: d,
            onCheck: () => a.onValueChange(o.value),
            onKeyDown: oe((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: oe(o.onFocus, () => {
              var h;
              p.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
Jw.displayName = Uw;
var wZ = "RadioGroupIndicator", Kw = b.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = zw(n);
    return /* @__PURE__ */ u(Zw, { ...o, ...r, ref: t });
  }
);
Kw.displayName = wZ;
var qw = Xw, Qw = Jw, bZ = Kw;
const CZ = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(qw, { className: P("tw-grid tw-gap-2", e), ...t, ref: n }));
CZ.displayName = qw.displayName;
const yZ = b.forwardRef(({ className: e, indicatorClassName: t, indicatorIconClassName: n, ...r }, o) => /* @__PURE__ */ u(
  Qw,
  {
    ref: o,
    className: P(
      "tw-aspect-square tw-h-5 tw-w-5 tw-rounded-full tw-border tw-border-gray-300 tw-text-gray-400 focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand2-originalBrandDarker focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-border-brand2-originalBrandDarker data-[state=checked]:tw-text-brand2-originalBrandDarker",
      e
    ),
    ...r,
    children: /* @__PURE__ */ u(
      bZ,
      {
        className: P("tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full", t),
        children: /* @__PURE__ */ u(v2, { className: P("tw-h-3 tw-w-3 tw-fill-current", n) })
      }
    )
  }
));
yZ.displayName = Qw.displayName;
var Cu = "Switch", [xZ, Jte] = st(Cu), [EZ, IZ] = xZ(Cu), eb = b.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: d,
      ...f
    } = e, [p, h] = b.useState(null), g = we(t, (y) => h(y)), m = b.useRef(!1), v = p ? d || !!p.closest("form") : !0, [w, C] = vt({
      prop: o,
      defaultProp: a ?? !1,
      onChange: c,
      caller: Cu
    });
    return /* @__PURE__ */ T(EZ, { scope: n, checked: w, disabled: s, children: [
      /* @__PURE__ */ u(
        ie.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": ob(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: g,
          onClick: oe(e.onClick, (y) => {
            C((x) => !x), v && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ u(
        rb,
        {
          control: p,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: w,
          required: i,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
eb.displayName = Cu;
var tb = "SwitchThumb", nb = b.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = IZ(tb, n);
    return /* @__PURE__ */ u(
      ie.span,
      {
        "data-state": ob(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
nb.displayName = tb;
var SZ = "SwitchBubbleInput", rb = b.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, a) => {
    const i = b.useRef(null), s = we(i, a), l = oc(n), c = tc(t);
    return b.useEffect(() => {
      const d = i.current;
      if (!d)
        return;
      const f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && h) {
        const g = new Event("click", { bubbles: r });
        h.call(d, n), d.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ u(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: s,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
rb.displayName = SZ;
function ob(e) {
  return e ? "checked" : "unchecked";
}
var ab = eb, DZ = nb;
const MZ = b.forwardRef(
  ({ className: e, size: t = "medium", ...n }, r) => {
    const o = {
      small: {
        root: "tw-h-4 tw-w-7",
        thumb: "tw-h-3 tw-w-3 data-[state=checked]:tw-translate-x-3.5 data-[state=unchecked]:tw-translate-x-0.5"
      },
      medium: {
        root: "tw-h-6 tw-w-10",
        thumb: "tw-h-4 tw-w-4 data-[state=checked]:tw-translate-x-5 data-[state=unchecked]:tw-translate-x-1"
      },
      large: {
        root: "tw-h-8 tw-w-14",
        thumb: "tw-h-6 tw-w-6 data-[state=checked]:tw-translate-x-7 data-[state=unchecked]:tw-translate-x-1"
      }
    };
    return /* @__PURE__ */ u(
      ab,
      {
        className: P(
          "tw-peer tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-transition-all tw-duration-200 tw-shadow-[inset_0_2px_4px_rgba(0,0,0,0.15),inset_0_4px_8px_rgba(0,0,0,0.1),inset_0_1px_2px_rgba(0,0,0,0.2)] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-background disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-gradient-to-br data-[state=checked]:tw-from-brand2-originalBrandDarker data-[state=checked]:tw-to-brand2-originalBrand data-[state=checked]:tw-shadow-[inset_0_2px_4px_rgba(0,0,0,0.2),inset_0_4px_8px_rgba(0,0,0,0.15),inset_0_1px_2px_rgba(0,0,0,0.25)] data-[state=unchecked]:tw-bg-gradient-to-br data-[state=unchecked]:tw-from-gray-400 data-[state=unchecked]:tw-to-gray-300 data-[state=unchecked]:tw-shadow-[inset_0_2px_4px_rgba(0,0,0,0.15),inset_0_4px_8px_rgba(0,0,0,0.1),inset_0_1px_2px_rgba(0,0,0,0.2)]",
          o[t].root,
          e
        ),
        ...n,
        ref: r,
        children: /* @__PURE__ */ u(
          DZ,
          {
            className: P(
              'tw-pointer-events-none tw-block tw-rounded-full tw-bg-gradient-to-br tw-from-gray-50 tw-via-white tw-to-gray-100 tw-border tw-border-gray-200 tw-shadow-[0_1px_2px_rgba(0,0,0,0.08),0_2px_4px_rgba(0,0,0,0.06),0_4px_8px_rgba(0,0,0,0.04),inset_0_1px_1px_rgba(255,255,255,0.95),inset_0_-1px_1px_rgba(0,0,0,0.05),inset_0_0_0_1px_rgba(255,255,255,0.3)] tw-ring-0 tw-transition-all tw-duration-200 tw-ease-out data-[state=checked]:tw-shadow-[0_1px_3px_rgba(0,0,0,0.12),0_3px_6px_rgba(0,0,0,0.08),0_6px_12px_rgba(0,0,0,0.06),inset_0_1px_1px_rgba(255,255,255,0.95),inset_0_-1px_1px_rgba(0,0,0,0.08),inset_0_0_0_1px_rgba(255,255,255,0.3)] data-[state=unchecked]:tw-shadow-[0_1px_2px_rgba(0,0,0,0.08),0_2px_4px_rgba(0,0,0,0.06),0_4px_8px_rgba(0,0,0,0.04),inset_0_1px_1px_rgba(255,255,255,0.95),inset_0_-1px_1px_rgba(0,0,0,0.05),inset_0_0_0_1px_rgba(255,255,255,0.3)] tw-relative before:tw-content-[""] before:tw-absolute before:tw-inset-0 before:tw-rounded-full before:tw-bg-gradient-radial before:tw-from-white/20 before:tw-via-transparent before:tw-to-transparent before:tw-pointer-events-none',
              o[t].thumb
            )
          }
        )
      }
    );
  }
);
MZ.displayName = ab.displayName;
const Kte = (e) => /* @__PURE__ */ u(
  "div",
  {
    className: P(
      e.className,
      "tw-min-h-[100px] tw-overflow-y-scroll",
      e.type === "vertical" && "tw-scrollbar-section tw-overflow-x-hidden",
      e.type === "horizontal" && "tw-scrollbar-horizontal-section tw-overflow-y-hidden"
    ),
    children: e.children
  }
);
var [yu, qte] = st("Tooltip", [
  xr
]), xu = xr(), ib = "TooltipProvider", NZ = 700, Zf = "tooltip.open", [PZ, h0] = yu(ib), sb = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = NZ,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, i = b.useRef(!0), s = b.useRef(!1), l = b.useRef(0);
  return b.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ u(
    PZ,
    {
      scope: t,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: b.useCallback(() => {
        window.clearTimeout(l.current), i.current = !1;
      }, []),
      onClose: b.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => i.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: s,
      onPointerInTransitChange: b.useCallback((c) => {
        s.current = c;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
sb.displayName = ib;
var Ei = "Tooltip", [AZ, rs] = yu(Ei), lb = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, l = h0(Ei, e.__scopeTooltip), c = xu(t), [d, f] = b.useState(null), p = Ue(), h = b.useRef(0), g = i ?? l.disableHoverableContent, m = s ?? l.delayDuration, v = b.useRef(!1), [w, C] = vt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (I) => {
      I ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Zf))) : l.onClose(), a == null || a(I);
    },
    caller: Ei
  }), y = b.useMemo(() => w ? v.current ? "delayed-open" : "instant-open" : "closed", [w]), x = b.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, v.current = !1, C(!0);
  }, [C]), E = b.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, C(!1);
  }, [C]), S = b.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      v.current = !0, C(!0), h.current = 0;
    }, m);
  }, [m, C]);
  return b.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ u(Hi, { ...c, children: /* @__PURE__ */ u(
    AZ,
    {
      scope: t,
      contentId: p,
      open: w,
      stateAttribute: y,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: b.useCallback(() => {
        l.isOpenDelayedRef.current ? S() : x();
      }, [l.isOpenDelayedRef, S, x]),
      onTriggerLeave: b.useCallback(() => {
        g ? E() : (window.clearTimeout(h.current), h.current = 0);
      }, [E, g]),
      onOpen: x,
      onClose: E,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
lb.displayName = Ei;
var $f = "TooltipTrigger", cb = b.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = rs($f, n), a = h0($f, n), i = xu(n), s = b.useRef(null), l = we(t, s, o.onTriggerChange), c = b.useRef(!1), d = b.useRef(!1), f = b.useCallback(() => c.current = !1, []);
    return b.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u(Bi, { asChild: !0, ...i, children: /* @__PURE__ */ u(
      ie.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: oe(e.onPointerMove, (p) => {
          p.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: oe(e.onPointerLeave, () => {
          o.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: oe(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: oe(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: oe(e.onBlur, o.onClose),
        onClick: oe(e.onClick, o.onClose)
      }
    ) });
  }
);
cb.displayName = $f;
var m0 = "TooltipPortal", [_Z, OZ] = yu(m0, {
  forceMount: void 0
}), ub = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: o } = e, a = rs(m0, t);
  return /* @__PURE__ */ u(_Z, { scope: t, forceMount: n, children: /* @__PURE__ */ u(ut, { present: n || a.open, children: /* @__PURE__ */ u(ro, { asChild: !0, container: o, children: r }) }) });
};
ub.displayName = m0;
var Xo = "TooltipContent", db = b.forwardRef(
  (e, t) => {
    const n = OZ(Xo, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...a } = e, i = rs(Xo, e.__scopeTooltip);
    return /* @__PURE__ */ u(ut, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ u(fb, { side: o, ...a, ref: t }) : /* @__PURE__ */ u(TZ, { side: o, ...a, ref: t }) });
  }
), TZ = b.forwardRef((e, t) => {
  const n = rs(Xo, e.__scopeTooltip), r = h0(Xo, e.__scopeTooltip), o = b.useRef(null), a = we(t, o), [i, s] = b.useState(null), { trigger: l, onClose: c } = n, d = o.current, { onPointerInTransitChange: f } = r, p = b.useCallback(() => {
    s(null), f(!1);
  }, [f]), h = b.useCallback(
    (g, m) => {
      const v = g.currentTarget, w = { x: g.clientX, y: g.clientY }, C = FZ(w, v.getBoundingClientRect()), y = HZ(w, C), x = BZ(m.getBoundingClientRect()), E = WZ([...y, ...x]);
      s(E), f(!0);
    },
    [f]
  );
  return b.useEffect(() => () => p(), [p]), b.useEffect(() => {
    if (l && d) {
      const g = (v) => h(v, d), m = (v) => h(v, l);
      return l.addEventListener("pointerleave", g), d.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", m);
      };
    }
  }, [l, d, h, p]), b.useEffect(() => {
    if (i) {
      const g = (m) => {
        const v = m.target, w = { x: m.clientX, y: m.clientY }, C = (l == null ? void 0 : l.contains(v)) || (d == null ? void 0 : d.contains(v)), y = !GZ(w, i);
        C ? p() : y && (p(), c());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [l, d, i, c, p]), /* @__PURE__ */ u(fb, { ...e, ref: a });
}), [LZ, RZ] = yu(Ei, { isInside: !1 }), VZ = /* @__PURE__ */ Wy("TooltipContent"), fb = b.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, l = rs(Xo, n), c = xu(n), { onClose: d } = l;
    return b.useEffect(() => (document.addEventListener(Zf, d), () => document.removeEventListener(Zf, d)), [d]), b.useEffect(() => {
      if (l.trigger) {
        const f = (p) => {
          const h = p.target;
          h != null && h.contains(l.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, d]), /* @__PURE__ */ u(
      no,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ T(
          nc,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u(VZ, { children: r }),
              /* @__PURE__ */ u(LZ, { scope: n, isInside: !0, children: /* @__PURE__ */ u(NI, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
db.displayName = Xo;
var pb = "TooltipArrow", kZ = b.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = xu(n);
    return RZ(
      pb,
      n
    ).isInside ? null : /* @__PURE__ */ u(rc, { ...o, ...r, ref: t });
  }
);
kZ.displayName = pb;
function FZ(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), a = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function HZ(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function BZ(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function GZ(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], l = t[i], c = s.x, d = s.y, f = l.x, p = l.y;
    d > r != p > r && n < (f - c) * (r - d) / (p - d) + c && (o = !o);
  }
  return o;
}
function WZ(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), ZZ(t);
}
function ZZ(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        t.pop();
      else
        break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var $Z = sb, YZ = lb, jZ = cb, zZ = ub, hb = db;
const XZ = $Z, UZ = YZ, JZ = jZ, Qte = zZ, mb = b.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ u(
  hb,
  {
    ref: r,
    sideOffset: t,
    className: P(
      "tw-z-50 tw-font-sans tw-leading-5 tw-overflow-hidden tw-max-w-sm tw-rounded-md tw-border tw-border-gray-200 tw-bg-popover tw-px-3 tw-py-1.5 tw-text-base tw-text-grayscale-text-body tw-shadow-small tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
));
mb.displayName = hb.displayName;
function Me(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Ft(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function bt(e, t) {
  const n = Me(e);
  return isNaN(t) ? Ft(e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function sn(e, t) {
  const n = Me(e);
  if (isNaN(t))
    return Ft(e, NaN);
  if (!t)
    return n;
  const r = n.getDate(), o = Ft(e, n.getTime());
  o.setMonth(n.getMonth() + t + 1, 0);
  const a = o.getDate();
  return r >= a ? o : (n.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    r
  ), n);
}
const v0 = 6048e5, KZ = 864e5;
let qZ = {};
function os() {
  return qZ;
}
function Dn(e, t) {
  var s, l, c, d;
  const n = os(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = Me(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function Qr(e) {
  return Dn(e, { weekStartsOn: 1 });
}
function vb(e) {
  const t = Me(e), n = t.getFullYear(), r = Ft(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = Qr(r), a = Ft(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Qr(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function Uo(e) {
  const t = Me(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Gl(e) {
  const t = Me(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Cn(e, t) {
  const n = Uo(e), r = Uo(t), o = +n - Gl(n), a = +r - Gl(r);
  return Math.round((o - a) / KZ);
}
function QZ(e) {
  const t = vb(e), n = Ft(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Qr(n);
}
function Yf(e, t) {
  const n = t * 7;
  return bt(e, n);
}
function e$(e, t) {
  return sn(e, t * 12);
}
function t$(e) {
  let t;
  return e.forEach(function(n) {
    const r = Me(n);
    (t === void 0 || t < r || isNaN(Number(r))) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function n$(e) {
  let t;
  return e.forEach((n) => {
    const r = Me(n);
    (!t || t > r || isNaN(+r)) && (t = r);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function Dt(e, t) {
  const n = Uo(e), r = Uo(t);
  return +n == +r;
}
function g0(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function r$(e) {
  if (!g0(e) && typeof e != "number")
    return !1;
  const t = Me(e);
  return !isNaN(Number(t));
}
function Ii(e, t) {
  const n = Me(e), r = Me(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function o$(e, t, n) {
  const r = Dn(e, n), o = Dn(t, n), a = +r - Gl(r), i = +o - Gl(o);
  return Math.round((a - i) / v0);
}
function w0(e) {
  const t = Me(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Nt(e) {
  const t = Me(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function gb(e) {
  const t = Me(e), n = Ft(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function b0(e, t) {
  var s, l, c, d;
  const n = os(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = Me(e), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function wb(e) {
  return b0(e, { weekStartsOn: 1 });
}
const a$ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, i$ = (e, t, n) => {
  let r;
  const o = a$[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function t1(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const s$ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, l$ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, c$ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, u$ = {
  date: t1({
    formats: s$,
    defaultWidth: "full"
  }),
  time: t1({
    formats: l$,
    defaultWidth: "full"
  }),
  dateTime: t1({
    formats: c$,
    defaultWidth: "full"
  })
}, d$ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, f$ = (e, t, n, r) => d$[e];
function Fa(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const p$ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, h$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, m$ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, v$ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, g$ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, w$ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, b$ = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, C$ = {
  ordinalNumber: b$,
  era: Fa({
    values: p$,
    defaultWidth: "wide"
  }),
  quarter: Fa({
    values: h$,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Fa({
    values: m$,
    defaultWidth: "wide"
  }),
  day: Fa({
    values: v$,
    defaultWidth: "wide"
  }),
  dayPeriod: Fa({
    values: g$,
    defaultWidth: "wide",
    formattingValues: w$,
    defaultFormattingWidth: "wide"
  })
};
function Ha(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? x$(s, (f) => f.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      y$(s, (f) => f.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const d = t.slice(i.length);
    return { value: c, rest: d };
  };
}
function y$(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function x$(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function E$(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r)
      return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a)
      return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const I$ = /^(\d+)(th|st|nd|rd)?/i, S$ = /\d+/i, D$ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, M$ = {
  any: [/^b/i, /^(a|c)/i]
}, N$ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, P$ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, A$ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, _$ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, O$ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, T$ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, L$ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, R$ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, V$ = {
  ordinalNumber: E$({
    matchPattern: I$,
    parsePattern: S$,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ha({
    matchPatterns: D$,
    defaultMatchWidth: "wide",
    parsePatterns: M$,
    defaultParseWidth: "any"
  }),
  quarter: Ha({
    matchPatterns: N$,
    defaultMatchWidth: "wide",
    parsePatterns: P$,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ha({
    matchPatterns: A$,
    defaultMatchWidth: "wide",
    parsePatterns: _$,
    defaultParseWidth: "any"
  }),
  day: Ha({
    matchPatterns: O$,
    defaultMatchWidth: "wide",
    parsePatterns: T$,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ha({
    matchPatterns: L$,
    defaultMatchWidth: "any",
    parsePatterns: R$,
    defaultParseWidth: "any"
  })
}, bb = {
  code: "en-US",
  formatDistance: i$,
  formatLong: u$,
  formatRelative: f$,
  localize: C$,
  match: V$,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function k$(e) {
  const t = Me(e);
  return Cn(t, gb(t)) + 1;
}
function Cb(e) {
  const t = Me(e), n = +Qr(t) - +QZ(t);
  return Math.round(n / v0) + 1;
}
function yb(e, t) {
  var d, f, p, h;
  const n = Me(e), r = n.getFullYear(), o = os(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((h = (p = o.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = Ft(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = Dn(i, t), l = Ft(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = Dn(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function F$(e, t) {
  var s, l, c, d;
  const n = os(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = yb(e, t), a = Ft(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), Dn(a, t);
}
function xb(e, t) {
  const n = Me(e), r = +Dn(n, t) - +F$(n, t);
  return Math.round(r / v0) + 1;
}
function Re(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const rr = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Re(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Re(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Re(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Re(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Re(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Re(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Re(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Re(o, t.length);
  }
}, yo = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, gp = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return rr.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = yb(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return Re(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Re(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = vb(e);
    return Re(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Re(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Re(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Re(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return rr.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Re(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = xb(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Re(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Cb(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Re(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : rr.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = k$(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Re(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Re(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Re(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Re(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = yo.noon : r === 0 ? o = yo.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = yo.evening : r >= 12 ? o = yo.afternoon : r >= 4 ? o = yo.morning : o = yo.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return rr.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : rr.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Re(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Re(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : rr.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : rr.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return rr.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return bp(r);
      case "XXXX":
      case "XX":
        return Vr(r);
      case "XXXXX":
      case "XXX":
      default:
        return Vr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return bp(r);
      case "xxxx":
      case "xx":
        return Vr(r);
      case "xxxxx":
      case "xxx":
      default:
        return Vr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + wp(r, ":");
      case "OOOO":
      default:
        return "GMT" + Vr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + wp(r, ":");
      case "zzzz":
      default:
        return "GMT" + Vr(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Re(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Re(r, t.length);
  }
};
function wp(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Re(a, 2);
}
function bp(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Re(Math.abs(e) / 60, 2) : Vr(e, t);
}
function Vr(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Re(Math.trunc(r / 60), 2), a = Re(r % 60, 2);
  return n + o + t + a;
}
const Cp = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Eb = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, H$ = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Cp(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Cp(r, t)).replace("{{time}}", Eb(o, t));
}, B$ = {
  p: Eb,
  P: H$
}, G$ = /^D+$/, W$ = /^Y+$/, Z$ = ["D", "DD", "YY", "YYYY"];
function $$(e) {
  return G$.test(e);
}
function Y$(e) {
  return W$.test(e);
}
function j$(e, t, n) {
  const r = z$(e, t, n);
  if (console.warn(r), Z$.includes(e))
    throw new RangeError(r);
}
function z$(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const X$ = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, U$ = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, J$ = /^'([^]*?)'?$/, K$ = /''/g, q$ = /[a-zA-Z]/;
function En(e, t, n) {
  var d, f, p, h, g, m, v, w;
  const r = os(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? bb, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, i = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.weekStartsOn) ?? r.weekStartsOn ?? ((w = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) ?? 0, s = Me(e);
  if (!r$(s))
    throw new RangeError("Invalid time value");
  let l = t.match(U$).map((C) => {
    const y = C[0];
    if (y === "p" || y === "P") {
      const x = B$[y];
      return x(C, o.formatLong);
    }
    return C;
  }).join("").match(X$).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const y = C[0];
    if (y === "'")
      return { isToken: !1, value: Q$(C) };
    if (gp[y])
      return { isToken: !0, value: C };
    if (y.match(q$))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: C };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((C) => {
    if (!C.isToken)
      return C.value;
    const y = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Y$(y) || !(n != null && n.useAdditionalDayOfYearTokens) && $$(y)) && j$(y, t, String(e));
    const x = gp[y[0]];
    return x(s, y, o.localize, c);
  }).join("");
}
function Q$(e) {
  const t = e.match(J$);
  return t ? t[1].replace(K$, "'") : e;
}
function eY(e) {
  const t = Me(e), n = t.getFullYear(), r = t.getMonth(), o = Ft(e, 0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function tY(e) {
  return Math.trunc(+Me(e) / 1e3);
}
function nY(e) {
  const t = Me(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function rY(e, t) {
  return o$(
    nY(e),
    Nt(e),
    t
  ) + 1;
}
function jf(e, t) {
  const n = Me(e), r = Me(t);
  return n.getTime() > r.getTime();
}
function Ib(e, t) {
  const n = Me(e), r = Me(t);
  return +n < +r;
}
function C0(e, t) {
  const n = Me(e), r = Me(t);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function oY(e, t) {
  const n = Me(e), r = Me(t);
  return n.getFullYear() === r.getFullYear();
}
function n1(e, t) {
  return bt(e, -t);
}
function r1(e, t) {
  const n = Me(e), r = n.getFullYear(), o = n.getDate(), a = Ft(e, 0);
  a.setFullYear(r, t, 15), a.setHours(0, 0, 0, 0);
  const i = eY(a);
  return n.setMonth(t, Math.min(o, i)), n;
}
function yp(e, t) {
  const n = Me(e);
  return isNaN(+n) ? Ft(e, NaN) : (n.setFullYear(t), n);
}
var me = function() {
  return me = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, me.apply(this, arguments);
};
function aY(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Sb(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function as(e) {
  return e.mode === "multiple";
}
function is(e) {
  return e.mode === "range";
}
function Eu(e) {
  return e.mode === "single";
}
var iY = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function sY(e, t) {
  return En(e, "LLLL y", t);
}
function lY(e, t) {
  return En(e, "d", t);
}
function cY(e, t) {
  return En(e, "LLLL", t);
}
function uY(e) {
  return "".concat(e);
}
function dY(e, t) {
  return En(e, "cccccc", t);
}
function fY(e, t) {
  return En(e, "yyyy", t);
}
var pY = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: sY,
  formatDay: lY,
  formatMonthCaption: cY,
  formatWeekNumber: uY,
  formatWeekdayName: dY,
  formatYearCaption: fY
}), hY = function(e, t, n) {
  return En(e, "do MMMM (EEEE)", n);
}, mY = function() {
  return "Month: ";
}, vY = function() {
  return "Go to next month";
}, gY = function() {
  return "Go to previous month";
}, wY = function(e, t) {
  return En(e, "cccc", t);
}, bY = function(e) {
  return "Week n. ".concat(e);
}, CY = function() {
  return "Year: ";
}, yY = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: hY,
  labelMonthDropdown: mY,
  labelNext: vY,
  labelPrevious: gY,
  labelWeekNumber: bY,
  labelWeekday: wY,
  labelYearDropdown: CY
});
function xY() {
  var e = "buttons", t = iY, n = bb, r = {}, o = {}, a = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: pY,
    labels: yY,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function EY(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, a = e.fromDate, i = e.toDate;
  return r ? a = Nt(r) : t && (a = new Date(t, 0, 1)), o ? i = w0(o) : n && (i = new Date(n, 11, 31)), {
    fromDate: a ? Uo(a) : void 0,
    toDate: i ? Uo(i) : void 0
  };
}
var Db = Kn(void 0);
function IY(e) {
  var t, n = e.initialProps, r = xY(), o = EY(n), a = o.fromDate, i = o.toDate, s = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var l;
  (Eu(n) || as(n) || is(n)) && (l = n.onSelect);
  var c = me(me(me({}, r), n), { captionLayout: s, classNames: me(me({}, r.classNames), n.classNames), components: me({}, n.components), formatters: me(me({}, r.formatters), n.formatters), fromDate: a, labels: me(me({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: me(me({}, r.modifiers), n.modifiers), modifiersClassNames: me(me({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: me(me({}, r.styles), n.styles), toDate: i });
  return u(Db.Provider, { value: c, children: e.children });
}
function We() {
  var e = Ht(Db);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Mb(e) {
  var t = We(), n = t.locale, r = t.classNames, o = t.styles, a = t.formatters.formatCaption;
  return u("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: a(e.displayMonth, { locale: n }) });
}
function SY(e) {
  return u("svg", me({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: u("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Nb(e) {
  var t, n, r = e.onChange, o = e.value, a = e.children, i = e.caption, s = e.className, l = e.style, c = We(), d = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : SY;
  return T("div", { className: s, style: l, children: [u("span", { className: c.classNames.vhidden, children: e["aria-label"] }), u("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r, children: a }), T("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [i, u(d, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function DY(e) {
  var t, n = We(), r = n.fromDate, o = n.toDate, a = n.styles, i = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, d = n.labels.labelMonthDropdown;
  if (!r)
    return u(Ee, {});
  if (!o)
    return u(Ee, {});
  var f = [];
  if (oY(r, o))
    for (var p = Nt(r), h = r.getMonth(); h <= o.getMonth(); h++)
      f.push(r1(p, h));
  else
    for (var p = Nt(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      f.push(r1(p, h));
  var g = function(v) {
    var w = Number(v.target.value), C = r1(Nt(e.displayMonth), w);
    e.onChange(C);
  }, m = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Nb;
  return u(m, { name: "months", "aria-label": d(), className: l.dropdown_month, style: a.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: f.map(function(v) {
    return u("option", { value: v.getMonth(), children: s(v, { locale: i }) }, v.getMonth());
  }) });
}
function MY(e) {
  var t, n = e.displayMonth, r = We(), o = r.fromDate, a = r.toDate, i = r.locale, s = r.styles, l = r.classNames, c = r.components, d = r.formatters.formatYearCaption, f = r.labels.labelYearDropdown, p = [];
  if (!o)
    return u(Ee, {});
  if (!a)
    return u(Ee, {});
  for (var h = o.getFullYear(), g = a.getFullYear(), m = h; m <= g; m++)
    p.push(yp(gb(/* @__PURE__ */ new Date()), m));
  var v = function(C) {
    var y = yp(Nt(n), Number(C.target.value));
    e.onChange(y);
  }, w = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : Nb;
  return u(w, { name: "years", "aria-label": f(), className: l.dropdown_year, style: s.dropdown_year, onChange: v, value: n.getFullYear(), caption: d(n, { locale: i }), children: p.map(function(C) {
    return u("option", { value: C.getFullYear(), children: d(C, { locale: i }) }, C.getFullYear());
  }) });
}
function NY(e, t) {
  var n = ue(e), r = n[0], o = n[1], a = t === void 0 ? r : t;
  return [a, o];
}
function PY(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), a = e.toDate, i = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (a && Ii(a, o) < 0) {
    var c = -1 * (l - 1);
    o = sn(a, c);
  }
  return i && Ii(o, i) < 0 && (o = i), Nt(o);
}
function AY() {
  var e = We(), t = PY(e), n = NY(t, e.month), r = n[0], o = n[1], a = function(i) {
    var s;
    if (!e.disableNavigation) {
      var l = Nt(i);
      o(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [r, a];
}
function _Y(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = Nt(e), a = Nt(sn(o, r)), i = Ii(a, o), s = [], l = 0; l < i; l++) {
    var c = sn(o, l);
    s.push(c);
  }
  return n && (s = s.reverse()), s;
}
function OY(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = Nt(e);
    if (!n)
      return sn(s, i);
    var l = Ii(n, e);
    if (!(l < a))
      return sn(s, i);
  }
}
function TY(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = Nt(e);
    if (!n)
      return sn(s, -i);
    var l = Ii(s, n);
    if (!(l <= 0))
      return sn(s, -i);
  }
}
var Pb = Kn(void 0);
function LY(e) {
  var t = We(), n = AY(), r = n[0], o = n[1], a = _Y(r, t), i = OY(r, t), s = TY(r, t), l = function(f) {
    return a.some(function(p) {
      return C0(f, p);
    });
  }, c = function(f, p) {
    l(f) || (p && Ib(f, p) ? o(sn(f, 1 + t.numberOfMonths * -1)) : o(f));
  }, d = {
    currentMonth: r,
    displayMonths: a,
    goToMonth: o,
    goToDate: c,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: l
  };
  return u(Pb.Provider, { value: d, children: e.children });
}
function ss() {
  var e = Ht(Pb);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function xp(e) {
  var t, n = We(), r = n.classNames, o = n.styles, a = n.components, i = ss().goToMonth, s = function(d) {
    i(sn(d, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : Mb, c = u(l, { id: e.id, displayMonth: e.displayMonth });
  return T("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [u("div", { className: r.vhidden, children: c }), u(DY, { onChange: s, displayMonth: e.displayMonth }), u(MY, { onChange: s, displayMonth: e.displayMonth })] });
}
function RY(e) {
  return u("svg", me({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: u("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function VY(e) {
  return u("svg", me({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: u("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Wl = cn(function(e, t) {
  var n = We(), r = n.classNames, o = n.styles, a = [r.button_reset, r.button];
  e.className && a.push(e.className);
  var i = a.join(" "), s = me(me({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), u("button", me({}, e, { ref: t, type: "button", className: i, style: s }));
});
function kY(e) {
  var t, n, r = We(), o = r.dir, a = r.locale, i = r.classNames, s = r.styles, l = r.labels, c = l.labelPrevious, d = l.labelNext, f = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return u(Ee, {});
  var p = c(e.previousMonth, { locale: a }), h = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), g = d(e.nextMonth, { locale: a }), m = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), v = (t = f == null ? void 0 : f.IconRight) !== null && t !== void 0 ? t : VY, w = (n = f == null ? void 0 : f.IconLeft) !== null && n !== void 0 ? n : RY;
  return T("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && u(Wl, { name: "previous-month", "aria-label": p, className: h, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? u(v, { className: i.nav_icon, style: s.nav_icon }) : u(w, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && u(Wl, { name: "next-month", "aria-label": g, className: m, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? u(w, { className: i.nav_icon, style: s.nav_icon }) : u(v, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function Ep(e) {
  var t = We().numberOfMonths, n = ss(), r = n.previousMonth, o = n.nextMonth, a = n.goToMonth, i = n.displayMonths, s = i.findIndex(function(g) {
    return C0(e.displayMonth, g);
  }), l = s === 0, c = s === i.length - 1, d = t > 1 && (l || !c), f = t > 1 && (c || !l), p = function() {
    r && a(r);
  }, h = function() {
    o && a(o);
  };
  return u(kY, { displayMonth: e.displayMonth, hideNext: d, hidePrevious: f, nextMonth: o, previousMonth: r, onPreviousClick: p, onNextClick: h });
}
function FY(e) {
  var t, n = We(), r = n.classNames, o = n.disableNavigation, a = n.styles, i = n.captionLayout, s = n.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : Mb, c;
  return o ? c = u(l, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? c = u(xp, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? c = T(Ee, { children: [u(xp, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), u(Ep, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = T(Ee, { children: [u(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), u(Ep, { displayMonth: e.displayMonth, id: e.id })] }), u("div", { className: r.caption, style: a.caption, children: c });
}
function HY(e) {
  var t = We(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? u("tfoot", { className: o, style: r.tfoot, children: u("tr", { children: u("td", { colSpan: 8, children: n }) }) }) : u(Ee, {});
}
function BY(e, t, n) {
  for (var r = n ? Qr(/* @__PURE__ */ new Date()) : Dn(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], a = 0; a < 7; a++) {
    var i = bt(r, a);
    o.push(i);
  }
  return o;
}
function GY() {
  var e = We(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, a = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = BY(o, a, i);
  return T("tr", { style: n.head_row, className: t.head_row, children: [r && u("td", { style: n.head_cell, className: t.head_cell }), c.map(function(d, f) {
    return u("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(d, { locale: o }), children: s(d, { locale: o }) }, f);
  })] });
}
function WY() {
  var e, t = We(), n = t.classNames, r = t.styles, o = t.components, a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : GY;
  return u("thead", { style: r.head, className: n.head, children: u(a, {}) });
}
function ZY(e) {
  var t = We(), n = t.locale, r = t.formatters.formatDay;
  return u(Ee, { children: r(e.date, { locale: n }) });
}
var y0 = Kn(void 0);
function $Y(e) {
  if (!as(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return u(y0.Provider, { value: t, children: e.children });
  }
  return u(YY, { initialProps: e.initialProps, children: e.children });
}
function YY(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, a = t.max, i = function(c, d, f) {
    var p, h;
    (p = t.onDayClick) === null || p === void 0 || p.call(t, c, d, f);
    var g = !!(d.selected && o && (r == null ? void 0 : r.length) === o);
    if (!g) {
      var m = !!(!d.selected && a && (r == null ? void 0 : r.length) === a);
      if (!m) {
        var v = r ? Sb([], r, !0) : [];
        if (d.selected) {
          var w = v.findIndex(function(C) {
            return Dt(c, C);
          });
          v.splice(w, 1);
        } else
          v.push(c);
        (h = t.onSelect) === null || h === void 0 || h.call(t, v, c, d, f);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(c) {
    var d = a && r.length > a - 1, f = r.some(function(p) {
      return Dt(p, c);
    });
    return !!(d && !f);
  });
  var l = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return u(y0.Provider, { value: l, children: n });
}
function x0() {
  var e = Ht(y0);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function jY(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? Dt(o, e) && Dt(r, e) ? void 0 : Dt(o, e) ? { from: o, to: void 0 } : Dt(r, e) ? void 0 : jf(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? jf(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? Ib(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var E0 = Kn(void 0);
function zY(e) {
  if (!is(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return u(E0.Provider, { value: t, children: e.children });
  }
  return u(XY, { initialProps: e.initialProps, children: e.children });
}
function XY(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, a = o.from, i = o.to, s = t.min, l = t.max, c = function(h, g, m) {
    var v, w;
    (v = t.onDayClick) === null || v === void 0 || v.call(t, h, g, m);
    var C = jY(h, r);
    (w = t.onSelect) === null || w === void 0 || w.call(t, C, h, g, m);
  }, d = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (d.range_start = [a], i ? (d.range_end = [i], Dt(a, i) || (d.range_middle = [
    {
      after: a,
      before: i
    }
  ])) : d.range_end = [a]) : i && (d.range_start = [i], d.range_end = [i]), s && (a && !i && d.disabled.push({
    after: n1(a, s - 1),
    before: bt(a, s - 1)
  }), a && i && d.disabled.push({
    after: a,
    before: bt(a, s - 1)
  }), !a && i && d.disabled.push({
    after: n1(i, s - 1),
    before: bt(i, s - 1)
  })), l) {
    if (a && !i && (d.disabled.push({
      before: bt(a, -l + 1)
    }), d.disabled.push({
      after: bt(a, l - 1)
    })), a && i) {
      var f = Cn(i, a) + 1, p = l - f;
      d.disabled.push({
        before: n1(a, p)
      }), d.disabled.push({
        after: bt(i, p)
      });
    }
    !a && i && (d.disabled.push({
      before: bt(i, -l + 1)
    }), d.disabled.push({
      after: bt(i, l - 1)
    }));
  }
  return u(E0.Provider, { value: { selected: r, onDayClick: c, modifiers: d }, children: n });
}
function I0() {
  var e = Ht(E0);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function ul(e) {
  return Array.isArray(e) ? Sb([], e, !0) : e !== void 0 ? [e] : [];
}
function UY(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = ul(o);
  }), t;
}
var ln;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ln || (ln = {}));
var JY = ln.Selected, Vn = ln.Disabled, KY = ln.Hidden, qY = ln.Today, o1 = ln.RangeEnd, a1 = ln.RangeMiddle, i1 = ln.RangeStart, QY = ln.Outside;
function ej(e, t, n) {
  var r, o = (r = {}, r[JY] = ul(e.selected), r[Vn] = ul(e.disabled), r[KY] = ul(e.hidden), r[qY] = [e.today], r[o1] = [], r[a1] = [], r[i1] = [], r[QY] = [], r);
  return e.fromDate && o[Vn].push({ before: e.fromDate }), e.toDate && o[Vn].push({ after: e.toDate }), as(e) ? o[Vn] = o[Vn].concat(t.modifiers[Vn]) : is(e) && (o[Vn] = o[Vn].concat(n.modifiers[Vn]), o[i1] = n.modifiers[i1], o[a1] = n.modifiers[a1], o[o1] = n.modifiers[o1]), o;
}
var Ab = Kn(void 0);
function tj(e) {
  var t = We(), n = x0(), r = I0(), o = ej(t, n, r), a = UY(t.modifiers), i = me(me({}, o), a);
  return u(Ab.Provider, { value: i, children: e.children });
}
function _b() {
  var e = Ht(Ab);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function nj(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function rj(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function oj(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function aj(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function ij(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function sj(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var a = Cn(o, r) < 0;
    a && (n = [o, r], r = n[0], o = n[1]);
    var i = Cn(e, r) >= 0 && Cn(o, e) >= 0;
    return i;
  }
  return o ? Dt(o, e) : r ? Dt(r, e) : !1;
}
function lj(e) {
  return g0(e);
}
function cj(e) {
  return Array.isArray(e) && e.every(g0);
}
function uj(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (lj(n))
      return Dt(e, n);
    if (cj(n))
      return n.includes(e);
    if (rj(n))
      return sj(e, n);
    if (ij(n))
      return n.dayOfWeek.includes(e.getDay());
    if (nj(n)) {
      var r = Cn(n.before, e), o = Cn(n.after, e), a = r > 0, i = o < 0, s = jf(n.before, n.after);
      return s ? i && a : a || i;
    }
    return oj(n) ? Cn(e, n.after) > 0 : aj(n) ? Cn(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function S0(e, t, n) {
  var r = Object.keys(t).reduce(function(a, i) {
    var s = t[i];
    return uj(e, s) && a.push(i), a;
  }, []), o = {};
  return r.forEach(function(a) {
    return o[a] = !0;
  }), n && !C0(e, n) && (o.outside = !0), o;
}
function dj(e, t) {
  for (var n = Nt(e[0]), r = w0(e[e.length - 1]), o, a, i = n; i <= r; ) {
    var s = S0(i, t), l = !s.disabled && !s.hidden;
    if (!l) {
      i = bt(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !a && (a = i), o || (o = i), i = bt(i, 1);
  }
  return a || o;
}
var fj = 365;
function Ob(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, a = t.modifiers, i = t.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, l = o.weekStartsOn, c = o.fromDate, d = o.toDate, f = o.locale, p = {
    day: bt,
    week: Yf,
    month: sn,
    year: e$,
    startOfWeek: function(v) {
      return o.ISOWeek ? Qr(v) : Dn(v, { locale: f, weekStartsOn: l });
    },
    endOfWeek: function(v) {
      return o.ISOWeek ? wb(v) : b0(v, { locale: f, weekStartsOn: l });
    }
  }, h = p[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? h = t$([c, h]) : r === "after" && d && (h = n$([d, h]));
  var g = !0;
  if (a) {
    var m = S0(h, a);
    g = !m.disabled && !m.hidden;
  }
  return g ? h : s.count > fj ? s.lastFocused : Ob(h, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: a,
    retry: me(me({}, s), { count: s.count + 1 })
  });
}
var Tb = Kn(void 0);
function pj(e) {
  var t = ss(), n = _b(), r = ue(), o = r[0], a = r[1], i = ue(), s = i[0], l = i[1], c = dj(t.displayMonths, n), d = o ?? (s && t.isDateDisplayed(s)) ? s : c, f = function() {
    l(o), a(void 0);
  }, p = function(v) {
    a(v);
  }, h = We(), g = function(v, w) {
    if (o) {
      var C = Ob(o, {
        moveBy: v,
        direction: w,
        context: h,
        modifiers: n
      });
      Dt(o, C) || (t.goToDate(C, o), p(C));
    }
  }, m = {
    focusedDay: o,
    focusTarget: d,
    blur: f,
    focus: p,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return u(Tb.Provider, { value: m, children: e.children });
}
function D0() {
  var e = Ht(Tb);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function hj(e, t) {
  var n = _b(), r = S0(e, n, t);
  return r;
}
var M0 = Kn(void 0);
function mj(e) {
  if (!Eu(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return u(M0.Provider, { value: t, children: e.children });
  }
  return u(vj, { initialProps: e.initialProps, children: e.children });
}
function vj(e) {
  var t = e.initialProps, n = e.children, r = function(a, i, s) {
    var l, c, d;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, a, i, s), i.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, a, i, s);
      return;
    }
    (d = t.onSelect) === null || d === void 0 || d.call(t, a, a, i, s);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return u(M0.Provider, { value: o, children: n });
}
function Lb() {
  var e = Ht(M0);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function gj(e, t) {
  var n = We(), r = Lb(), o = x0(), a = I0(), i = D0(), s = i.focusDayAfter, l = i.focusDayBefore, c = i.focusWeekAfter, d = i.focusWeekBefore, f = i.blur, p = i.focus, h = i.focusMonthBefore, g = i.focusMonthAfter, m = i.focusYearBefore, v = i.focusYearAfter, w = i.focusStartOfWeek, C = i.focusEndOfWeek, y = function(H) {
    var V, j, B, Z;
    Eu(n) ? (V = r.onDayClick) === null || V === void 0 || V.call(r, e, t, H) : as(n) ? (j = o.onDayClick) === null || j === void 0 || j.call(o, e, t, H) : is(n) ? (B = a.onDayClick) === null || B === void 0 || B.call(a, e, t, H) : (Z = n.onDayClick) === null || Z === void 0 || Z.call(n, e, t, H);
  }, x = function(H) {
    var V;
    p(e), (V = n.onDayFocus) === null || V === void 0 || V.call(n, e, t, H);
  }, E = function(H) {
    var V;
    f(), (V = n.onDayBlur) === null || V === void 0 || V.call(n, e, t, H);
  }, S = function(H) {
    var V;
    (V = n.onDayMouseEnter) === null || V === void 0 || V.call(n, e, t, H);
  }, I = function(H) {
    var V;
    (V = n.onDayMouseLeave) === null || V === void 0 || V.call(n, e, t, H);
  }, D = function(H) {
    var V;
    (V = n.onDayPointerEnter) === null || V === void 0 || V.call(n, e, t, H);
  }, N = function(H) {
    var V;
    (V = n.onDayPointerLeave) === null || V === void 0 || V.call(n, e, t, H);
  }, A = function(H) {
    var V;
    (V = n.onDayTouchCancel) === null || V === void 0 || V.call(n, e, t, H);
  }, L = function(H) {
    var V;
    (V = n.onDayTouchEnd) === null || V === void 0 || V.call(n, e, t, H);
  }, F = function(H) {
    var V;
    (V = n.onDayTouchMove) === null || V === void 0 || V.call(n, e, t, H);
  }, k = function(H) {
    var V;
    (V = n.onDayTouchStart) === null || V === void 0 || V.call(n, e, t, H);
  }, G = function(H) {
    var V;
    (V = n.onDayKeyUp) === null || V === void 0 || V.call(n, e, t, H);
  }, J = function(H) {
    var V;
    switch (H.key) {
      case "ArrowLeft":
        H.preventDefault(), H.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        H.preventDefault(), H.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        H.preventDefault(), H.stopPropagation(), c();
        break;
      case "ArrowUp":
        H.preventDefault(), H.stopPropagation(), d();
        break;
      case "PageUp":
        H.preventDefault(), H.stopPropagation(), H.shiftKey ? m() : h();
        break;
      case "PageDown":
        H.preventDefault(), H.stopPropagation(), H.shiftKey ? v() : g();
        break;
      case "Home":
        H.preventDefault(), H.stopPropagation(), w();
        break;
      case "End":
        H.preventDefault(), H.stopPropagation(), C();
        break;
    }
    (V = n.onDayKeyDown) === null || V === void 0 || V.call(n, e, t, H);
  }, $ = {
    onClick: y,
    onFocus: x,
    onBlur: E,
    onKeyDown: J,
    onKeyUp: G,
    onMouseEnter: S,
    onMouseLeave: I,
    onPointerEnter: D,
    onPointerLeave: N,
    onTouchCancel: A,
    onTouchEnd: L,
    onTouchMove: F,
    onTouchStart: k
  };
  return $;
}
function wj() {
  var e = We(), t = Lb(), n = x0(), r = I0(), o = Eu(e) ? t.selected : as(e) ? n.selected : is(e) ? r.selected : void 0;
  return o;
}
function bj(e) {
  return Object.values(ln).includes(e);
}
function Cj(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (bj(r)) {
      var a = e.classNames["day_".concat(r)];
      a && n.push(a);
    }
  }), n;
}
function yj(e, t) {
  var n = me({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = me(me({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function xj(e, t, n) {
  var r, o, a, i = We(), s = D0(), l = hj(e, t), c = gj(e, l), d = wj(), f = !!(i.onDayClick || i.mode !== "default");
  ye(function() {
    var S;
    l.outside || s.focusedDay && f && Dt(s.focusedDay, e) && ((S = n.current) === null || S === void 0 || S.focus());
  }, [
    s.focusedDay,
    e,
    n,
    f,
    l.outside
  ]);
  var p = Cj(i, l).join(" "), h = yj(i, l), g = !!(l.outside && !i.showOutsideDays || l.hidden), m = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : ZY, v = u(m, { date: e, displayMonth: t, activeModifiers: l }), w = {
    style: h,
    className: p,
    children: v,
    role: "gridcell"
  }, C = s.focusTarget && Dt(s.focusTarget, e) && !l.outside, y = s.focusedDay && Dt(s.focusedDay, e), x = me(me(me({}, w), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = y || C ? 0 : -1, r)), c), E = {
    isButton: f,
    isHidden: g,
    activeModifiers: l,
    selectedDays: d,
    buttonProps: x,
    divProps: w
  };
  return E;
}
function Ej(e) {
  var t = le(null), n = xj(e.date, e.displayMonth, t);
  return n.isHidden ? u("div", { role: "gridcell" }) : n.isButton ? u(Wl, me({ name: "day", ref: t }, n.buttonProps)) : u("div", me({}, n.divProps));
}
function Ij(e) {
  var t = e.number, n = e.dates, r = We(), o = r.onWeekNumberClick, a = r.styles, i = r.classNames, s = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, d = c(Number(t), { locale: s });
  if (!o)
    return u("span", { className: i.weeknumber, style: a.weeknumber, children: d });
  var f = l(Number(t), { locale: s }), p = function(h) {
    o(t, n, h);
  };
  return u(Wl, { name: "week-number", "aria-label": f, className: i.weeknumber, style: a.weeknumber, onClick: p, children: d });
}
function Sj(e) {
  var t, n, r = We(), o = r.styles, a = r.classNames, i = r.showWeekNumber, s = r.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : Ej, c = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : Ij, d;
  return i && (d = u("td", { className: a.cell, style: o.cell, children: u(c, { number: e.weekNumber, dates: e.dates }) })), T("tr", { className: a.row, style: o.row, children: [d, e.dates.map(function(f) {
    return u("td", { className: a.cell, style: o.cell, role: "presentation", children: u(l, { displayMonth: e.displayMonth, date: f }) }, tY(f));
  })] });
}
function Ip(e, t, n) {
  for (var r = n != null && n.ISOWeek ? wb(t) : b0(t, n), o = n != null && n.ISOWeek ? Qr(e) : Dn(e, n), a = Cn(r, o), i = [], s = 0; s <= a; s++)
    i.push(bt(o, s));
  var l = i.reduce(function(c, d) {
    var f = n != null && n.ISOWeek ? Cb(d) : xb(d, n), p = c.find(function(h) {
      return h.weekNumber === f;
    });
    return p ? (p.dates.push(d), c) : (c.push({
      weekNumber: f,
      dates: [d]
    }), c);
  }, []);
  return l;
}
function Dj(e, t) {
  var n = Ip(Nt(e), w0(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = rY(e, t);
    if (r < 6) {
      var o = n[n.length - 1], a = o.dates[o.dates.length - 1], i = Yf(a, 6 - r), s = Ip(Yf(a, 1), i, t);
      n.push.apply(n, s);
    }
  }
  return n;
}
function Mj(e) {
  var t, n, r, o = We(), a = o.locale, i = o.classNames, s = o.styles, l = o.hideHead, c = o.fixedWeeks, d = o.components, f = o.weekStartsOn, p = o.firstWeekContainsDate, h = o.ISOWeek, g = Dj(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: a,
    weekStartsOn: f,
    firstWeekContainsDate: p
  }), m = (t = d == null ? void 0 : d.Head) !== null && t !== void 0 ? t : WY, v = (n = d == null ? void 0 : d.Row) !== null && n !== void 0 ? n : Sj, w = (r = d == null ? void 0 : d.Footer) !== null && r !== void 0 ? r : HY;
  return T("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && u(m, {}), u("tbody", { className: i.tbody, style: s.tbody, children: g.map(function(C) {
    return u(v, { displayMonth: e.displayMonth, dates: C.dates, weekNumber: C.weekNumber }, C.weekNumber);
  }) }), u(w, { displayMonth: e.displayMonth })] });
}
function Nj() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Pj = Nj() ? ea : ye, s1 = !1, Aj = 0;
function Sp() {
  return "react-day-picker-".concat(++Aj);
}
function _j(e) {
  var t, n = e ?? (s1 ? Sp() : null), r = ue(n), o = r[0], a = r[1];
  return Pj(function() {
    o === null && a(Sp());
  }, []), ye(function() {
    s1 === !1 && (s1 = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function Oj(e) {
  var t, n, r = We(), o = r.dir, a = r.classNames, i = r.styles, s = r.components, l = ss().displayMonths, c = _j(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), d = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, f = [a.month], p = i.month, h = e.displayIndex === 0, g = e.displayIndex === l.length - 1, m = !h && !g;
  o === "rtl" && (t = [h, g], g = t[0], h = t[1]), h && (f.push(a.caption_start), p = me(me({}, p), i.caption_start)), g && (f.push(a.caption_end), p = me(me({}, p), i.caption_end)), m && (f.push(a.caption_between), p = me(me({}, p), i.caption_between));
  var v = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : FY;
  return T("div", { className: f.join(" "), style: p, children: [u(v, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), u(Mj, { id: d, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function Tj(e) {
  var t = We(), n = t.classNames, r = t.styles;
  return u("div", { className: n.months, style: r.months, children: e.children });
}
function Lj(e) {
  var t, n, r = e.initialProps, o = We(), a = D0(), i = ss(), s = ue(!1), l = s[0], c = s[1];
  ye(function() {
    o.initialFocus && a.focusTarget && (l || (a.focus(a.focusTarget), c(!0)));
  }, [
    o.initialFocus,
    l,
    a.focus,
    a.focusTarget,
    a
  ]);
  var d = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && d.push(o.classNames.multiple_months), o.showWeekNumber && d.push(o.classNames.with_weeknumber);
  var f = me(me({}, o.styles.root), o.style), p = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, m) {
    var v;
    return me(me({}, g), (v = {}, v[m] = r[m], v));
  }, {}), h = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : Tj;
  return u("div", me({ className: d.join(" "), style: f, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, p, { children: u(h, { children: i.displayMonths.map(function(g, m) {
    return u(Oj, { displayIndex: m, displayMonth: g }, m);
  }) }) }));
}
function Rj(e) {
  var t = e.children, n = aY(e, ["children"]);
  return u(IY, { initialProps: n, children: u(LY, { children: u(mj, { initialProps: n, children: u($Y, { initialProps: n, children: u(zY, { initialProps: n, children: u(tj, { children: u(pj, { children: t }) }) }) }) }) }) });
}
function Vj(e) {
  return u(Rj, me({}, e, { children: u(Lj, { initialProps: e }) }));
}
const zf = Xt(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
  {
    variants: {
      variant: {
        default: "tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/90",
        destructive: "tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90",
        outline: "tw-border tw-border-input tw-bg-background hover:tw-bg-accent hover:tw-text-accent-foreground",
        secondary: "tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80",
        ghost: "hover:tw-bg-accent hover:tw-text-accent-foreground",
        link: "tw-text-primary tw-underline-offset-4 hover:tw-underline"
      },
      size: {
        default: "tw-h-10 tw-px-4 tw-py-2",
        sm: "tw-h-9 tw-rounded-md tw-px-3",
        lg: "tw-h-11 tw-rounded-md tw-px-8",
        icon: "tw-h-10 tw-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Rb = b.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, a) => /* @__PURE__ */ u(r ? ta : "button", { className: P(zf({ variant: t, size: n, className: e })), ref: a, ...o })
);
Rb.displayName = "Button";
function N0({ className: e, classNames: t, showOutsideDays: n = !0, ...r }) {
  return /* @__PURE__ */ u(
    Vj,
    {
      showOutsideDays: n,
      className: P("tw-p-3", e),
      classNames: {
        months: "tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-x-4 sm:tw-space-y-0",
        month: "tw-space-y-4",
        caption: "tw-flex tw-justify-center tw-pt-1 tw-relative tw-items-center",
        caption_label: "tw-text-sm tw-font-medium",
        nav: "tw-space-x-1 tw-flex tw-items-center",
        nav_button: P(
          zf({ variant: "outline" }),
          "tw-h-7 tw-w-7 tw-bg-transparent tw-p-0 tw-opacity-50 hover:tw-opacity-100"
        ),
        nav_button_previous: "tw-absolute tw-left-1",
        nav_button_next: "tw-absolute tw-right-1",
        table: "tw-w-full tw-border-collapse tw-space-y-1",
        head_row: "tw-flex",
        head_cell: "tw-text-muted-foreground tw-rounded-md tw-w-9 tw-font-normal tw-text-[0.8rem]",
        row: "tw-flex tw-w-full tw-mt-2",
        cell: "tw-h-9 tw-w-9 tw-text-center tw-text-sm tw-p-0 tw-relative [&:has([aria-selected].day-range-end)]:tw-rounded-r-md [&:has([aria-selected].day-outside)]:tw-bg-accent/50 [&:has([aria-selected])]:tw-bg-accent first:[&:has([aria-selected])]:tw-rounded-l-md last:[&:has([aria-selected])]:tw-rounded-r-md focus-within:tw-relative focus-within:tw-z-20",
        day: P(
          zf({ variant: "ghost" }),
          "tw-h-9 tw-w-9 tw-p-0 tw-font-normal aria-selected:tw-opacity-100 hover:!tw-rounded-md"
        ),
        day_range_end: "tw-day-range-end",
        day_range_start: "tw-day-range-end",
        day_selected: "tw-bg-gray-700 tw-text-gray-50 hover:!tw-bg-white hover:!tw-text-gray-700 hover:!tw-border hover:!tw-border-gray-700 focus:tw-bg-gray-700  focus:tw-text-gray-50",
        day_today: "tw-bg-accent tw-text-accent-foreground !tw-rounded-md hover:!tw-bg-white hover:tw-text-gray-700 hover:tw-border hover:tw-border-gray-700",
        day_outside: "tw-day-outside tw-text-muted-foreground tw-opacity-50 aria-selected:tw-bg-accent/50 aria-selected:tw-text-muted-foreground aria-selected:tw-opacity-30",
        day_disabled: "tw-text-muted-foreground tw-opacity-50",
        day_range_middle: "aria-selected:tw-bg-accent aria-selected:tw-text-accent-foreground",
        day_hidden: "tw-invisible",
        ...t
      },
      components: {
        IconLeft: ({ ...o }) => /* @__PURE__ */ u(eD, { className: "tw-h-4 tw-w-4" }),
        IconRight: ({ ...o }) => /* @__PURE__ */ u(hc, { className: "tw-h-4 tw-w-4" })
      },
      ...r
    }
  );
}
N0.displayName = "Calendar";
var Iu = "Popover", [Vb, ene] = st(Iu, [
  xr
]), ls = xr(), [kj, Pr] = Vb(Iu), kb = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !1
  } = e, s = ls(t), l = b.useRef(null), [c, d] = b.useState(!1), [f, p] = vt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Iu
  });
  return /* @__PURE__ */ u(Hi, { ...s, children: /* @__PURE__ */ u(
    kj,
    {
      scope: t,
      contentId: Ue(),
      triggerRef: l,
      open: f,
      onOpenChange: p,
      onOpenToggle: b.useCallback(() => p((h) => !h), [p]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: b.useCallback(() => d(!0), []),
      onCustomAnchorRemove: b.useCallback(() => d(!1), []),
      modal: i,
      children: n
    }
  ) });
};
kb.displayName = Iu;
var Fb = "PopoverAnchor", Fj = b.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Pr(Fb, n), a = ls(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
    return b.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ u(Bi, { ...a, ...r, ref: t });
  }
);
Fj.displayName = Fb;
var Hb = "PopoverTrigger", Bb = b.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Pr(Hb, n), a = ls(n), i = we(t, o.triggerRef), s = /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Yb(o.open),
        ...r,
        ref: i,
        onClick: oe(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ u(Bi, { asChild: !0, ...a, children: s });
  }
);
Bb.displayName = Hb;
var P0 = "PopoverPortal", [Hj, Bj] = Vb(P0, {
  forceMount: void 0
}), Gb = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = Pr(P0, t);
  return /* @__PURE__ */ u(Hj, { scope: t, forceMount: n, children: /* @__PURE__ */ u(ut, { present: n || a.open, children: /* @__PURE__ */ u(ro, { asChild: !0, container: o, children: r }) }) });
};
Gb.displayName = P0;
var Jo = "PopoverContent", Wb = b.forwardRef(
  (e, t) => {
    const n = Bj(Jo, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = Pr(Jo, e.__scopePopover);
    return /* @__PURE__ */ u(ut, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u(Wj, { ...o, ref: t }) : /* @__PURE__ */ u(Zj, { ...o, ref: t }) });
  }
);
Wb.displayName = Jo;
var Gj = /* @__PURE__ */ mr("PopoverContent.RemoveScroll"), Wj = b.forwardRef(
  (e, t) => {
    const n = Pr(Jo, e.__scopePopover), r = b.useRef(null), o = we(t, r), a = b.useRef(!1);
    return b.useEffect(() => {
      const i = r.current;
      if (i)
        return ic(i);
    }, []), /* @__PURE__ */ u(lc, { as: Gj, allowPinchZoom: !0, children: /* @__PURE__ */ u(
      Zb,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: oe(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), a.current || (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: oe(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, c = s.button === 2 || l;
            a.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: oe(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Zj = b.forwardRef(
  (e, t) => {
    const n = Pr(Jo, e.__scopePopover), r = b.useRef(!1), o = b.useRef(!1);
    return /* @__PURE__ */ u(
      Zb,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Zb = b.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: d,
      ...f
    } = e, p = Pr(Jo, n), h = ls(n);
    return Kl(), /* @__PURE__ */ u(
      ki,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u(
          no,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: d,
            onEscapeKeyDown: s,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => p.onOpenChange(!1),
            children: /* @__PURE__ */ u(
              nc,
              {
                "data-state": Yb(p.open),
                role: "dialog",
                id: p.contentId,
                ...h,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), $b = "PopoverClose", $j = b.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Pr($b, n);
    return /* @__PURE__ */ u(
      ie.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: oe(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
$j.displayName = $b;
var Yj = "PopoverArrow", jj = b.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = ls(n);
    return /* @__PURE__ */ u(rc, { ...o, ...r, ref: t });
  }
);
jj.displayName = Yj;
function Yb(e) {
  return e ? "open" : "closed";
}
var jb = kb, zb = Bb, Xb = Gb, Su = Wb;
const Ub = jb, Jb = zb, A0 = b.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ u(Xb, { children: /* @__PURE__ */ u(
  Su,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: P(
      "tw-z-50 tw-w-72 tw-rounded-md tw-border tw-bg-popover tw-p-4 tw-text-popover-foreground tw-shadow-md tw-outline-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
A0.displayName = Su.displayName;
function tne({ className: e, date: t, setDate: n, label: r }) {
  return /* @__PURE__ */ u("div", { className: P("tw-grid tw-gap-2", e), children: /* @__PURE__ */ T(Ub, { children: [
    /* @__PURE__ */ u(Jb, { asChild: !0, children: /* @__PURE__ */ T(
      Yr,
      {
        size: "sm",
        id: "date",
        variant: "outline",
        className: P(
          "tw-w-[300px] tw-justify-start tw-text-left tw-font-normal",
          t == null && "tw-text-muted-foreground"
        ),
        children: [
          /* @__PURE__ */ u(JS, { className: "tw-mr-2 tw-h-4 tw-w-4" }),
          (t == null ? void 0 : t.from) != null ? t.to != null ? /* @__PURE__ */ T(Ee, { children: [
            En(t.from, "LLL dd, y"),
            " - ",
            En(t.to, "LLL dd, y")
          ] }) : En(t.from, "LLL dd, y") : /* @__PURE__ */ u("span", { children: r })
        ]
      }
    ) }),
    /* @__PURE__ */ u(A0, { className: "tw-w-auto tw-p-0 tw-shadow-none", align: "start", children: /* @__PURE__ */ u(
      N0,
      {
        initialFocus: !0,
        mode: "range",
        defaultMonth: t == null ? void 0 : t.from,
        selected: t,
        onSelect: n,
        numberOfMonths: 2
      }
    ) })
  ] }) });
}
const zj = b.forwardRef(
  ({ className: e, appliedCount: t, label: n, appliedFilterLabel: r = n, onResetFilterClick: o, ...a }, i) => /* @__PURE__ */ u(
    "button",
    {
      className: P(
        e,
        "!tw-text-sm !tw-leading-4 tw-border tw-border-transparent  tw-py-1 tw-px-3 tw-font-sans tw-text-grayscale-text-body tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-gap-8px tw-rounded-md hover:tw-bg-gray-200 disabled:tw-pointer-events-none disable:tw-cursor-not-allowed",
        {
          "tw-border tw-bg-background tw-border-brand-dark hover:tw-bg-background": t && t > 0
        }
      ),
      ref: i,
      ...a,
      children: t && t > 0 ? /* @__PURE__ */ T(Ee, { children: [
        /* @__PURE__ */ u(e4, { color: "#374151", size: 16, strokeWidth: 2 }),
        /* @__PURE__ */ T("div", { className: "tw-flex tw-gap-1", children: [
          /* @__PURE__ */ u("span", { children: t }),
          /* @__PURE__ */ u("span", { children: r })
        ] }),
        /* @__PURE__ */ u(
          "div",
          {
            onClick: (s) => {
              s.stopPropagation(), o != null && o();
            },
            className: "tw-bg-gray-100 tw-p-0.5 tw-flex tw-items-center tw-rounded hover:tw-bg-gray-50 hover:tw-ease-in-out",
            children: /* @__PURE__ */ u(rt, { color: "#6B7280", size: 16, strokeWidth: 2 })
          }
        )
      ] }) : /* @__PURE__ */ T("div", { className: "tw-flex tw-p-0.5 tw-gap-1", children: [
        /* @__PURE__ */ u(e4, { color: "#374151", size: 16, strokeWidth: 2 }),
        /* @__PURE__ */ u("span", { children: n })
      ] })
    }
  )
);
zj.displayName = "FilterButton";
function Xj(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Dp(e) {
  return Xj(e) || Array.isArray(e);
}
function Uj() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function _0(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  const o = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return o !== a ? !1 : n.every((i) => {
    const s = e[i], l = t[i];
    return typeof s == "function" ? `${s}` == `${l}` : !Dp(s) || !Dp(l) ? s === l : _0(s, l);
  });
}
function Mp(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function Jj(e, t) {
  if (e.length !== t.length)
    return !1;
  const n = Mp(e), r = Mp(t);
  return n.every((o, a) => {
    const i = r[a];
    return _0(o, i);
  });
}
function O0(e) {
  return typeof e == "number";
}
function Xf(e) {
  return typeof e == "string";
}
function Du(e) {
  return typeof e == "boolean";
}
function Np(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ze(e) {
  return Math.abs(e);
}
function T0(e) {
  return Math.sign(e);
}
function oi(e, t) {
  return ze(e - t);
}
function Kj(e, t) {
  if (e === 0 || t === 0 || ze(e) <= ze(t))
    return 0;
  const n = oi(ze(e), ze(t));
  return ze(n / e);
}
function qj(e) {
  return Math.round(e * 100) / 100;
}
function Si(e) {
  return Di(e).map(Number);
}
function tn(e) {
  return e[cs(e)];
}
function cs(e) {
  return Math.max(0, e.length - 1);
}
function L0(e, t) {
  return t === cs(e);
}
function Pp(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function Di(e) {
  return Object.keys(e);
}
function Kb(e, t) {
  return [e, t].reduce((n, r) => (Di(r).forEach((o) => {
    const a = n[o], i = r[o], s = Np(a) && Np(i);
    n[o] = s ? Kb(a, i) : i;
  }), n), {});
}
function Uf(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function Qj(e, t) {
  const n = {
    start: r,
    center: o,
    end: a
  };
  function r() {
    return 0;
  }
  function o(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function i(l, c) {
    return Xf(e) ? n[e](l) : e(t, l, c);
  }
  return {
    measure: i
  };
}
function Mi() {
  let e = [];
  function t(o, a, i, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in o)
      o.addEventListener(a, i, s), l = () => o.removeEventListener(a, i, s);
    else {
      const c = o;
      c.addListener(i), l = () => c.removeListener(i);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((o) => o());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function ez(e, t, n, r) {
  const o = Mi(), a = 1e3 / 60;
  let i = null, s = 0, l = 0;
  function c() {
    o.add(e, "visibilitychange", () => {
      e.hidden && g();
    });
  }
  function d() {
    h(), o.clear();
  }
  function f(v) {
    if (!l)
      return;
    i || (i = v, n(), n());
    const w = v - i;
    for (i = v, s += w; s >= a; )
      n(), s -= a;
    const C = s / a;
    r(C), l && (l = t.requestAnimationFrame(f));
  }
  function p() {
    l || (l = t.requestAnimationFrame(f));
  }
  function h() {
    t.cancelAnimationFrame(l), i = null, s = 0, l = 0;
  }
  function g() {
    i = null, s = 0;
  }
  return {
    init: c,
    destroy: d,
    start: p,
    stop: h,
    update: n,
    render: r
  };
}
function tz(e, t) {
  const n = t === "rtl", r = e === "y", o = r ? "y" : "x", a = r ? "x" : "y", i = !r && n ? -1 : 1, s = d(), l = f();
  function c(g) {
    const {
      height: m,
      width: v
    } = g;
    return r ? m : v;
  }
  function d() {
    return r ? "top" : n ? "right" : "left";
  }
  function f() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function p(g) {
    return g * i;
  }
  return {
    scroll: o,
    cross: a,
    startEdge: s,
    endEdge: l,
    measureSize: c,
    direction: p
  };
}
function eo(e = 0, t = 0) {
  const n = ze(e - t);
  function r(c) {
    return c < e;
  }
  function o(c) {
    return c > t;
  }
  function a(c) {
    return r(c) || o(c);
  }
  function i(c) {
    return a(c) ? r(c) ? e : t : c;
  }
  function s(c) {
    return n ? c - n * Math.ceil((c - t) / n) : c;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: i,
    reachedAny: a,
    reachedMax: o,
    reachedMin: r,
    removeOffset: s
  };
}
function qb(e, t, n) {
  const {
    constrain: r
  } = eo(0, e), o = e + 1;
  let a = i(t);
  function i(p) {
    return n ? ze((o + p) % o) : r(p);
  }
  function s() {
    return a;
  }
  function l(p) {
    return a = i(p), f;
  }
  function c(p) {
    return d().set(s() + p);
  }
  function d() {
    return qb(e, s(), n);
  }
  const f = {
    get: s,
    set: l,
    add: c,
    clone: d
  };
  return f;
}
function nz(e, t, n, r, o, a, i, s, l, c, d, f, p, h, g, m, v, w, C) {
  const {
    cross: y,
    direction: x
  } = e, E = ["INPUT", "SELECT", "TEXTAREA"], S = {
    passive: !1
  }, I = Mi(), D = Mi(), N = eo(50, 225).constrain(h.measure(20)), A = {
    mouse: 300,
    touch: 400
  }, L = {
    mouse: 500,
    touch: 600
  }, F = g ? 43 : 25;
  let k = !1, G = 0, J = 0, $ = !1, H = !1, V = !1, j = !1;
  function B(R) {
    if (!C)
      return;
    function ce(ke) {
      (Du(C) || C(R, ke)) && q(ke);
    }
    const ve = t;
    I.add(ve, "dragstart", (ke) => ke.preventDefault(), S).add(ve, "touchmove", () => {
    }, S).add(ve, "touchend", () => {
    }).add(ve, "touchstart", ce).add(ve, "mousedown", ce).add(ve, "touchcancel", Q).add(ve, "contextmenu", Q).add(ve, "click", te, !0);
  }
  function Z() {
    I.clear(), D.clear();
  }
  function O() {
    const R = j ? n : t;
    D.add(R, "touchmove", W, S).add(R, "touchend", Q).add(R, "mousemove", W, S).add(R, "mouseup", Q);
  }
  function Y(R) {
    const ce = R.nodeName || "";
    return E.includes(ce);
  }
  function U() {
    return (g ? L : A)[j ? "mouse" : "touch"];
  }
  function K(R, ce) {
    const ve = f.add(T0(R) * -1), ke = d.byDistance(R, !g).distance;
    return g || ze(R) < N ? ke : v && ce ? ke * 0.5 : d.byIndex(ve.get(), 0).distance;
  }
  function q(R) {
    const ce = Uf(R, r);
    j = ce, V = g && ce && !R.buttons && k, k = oi(o.get(), i.get()) >= 2, !(ce && R.button !== 0) && (Y(R.target) || ($ = !0, a.pointerDown(R), c.useFriction(0).useDuration(0), o.set(i), O(), G = a.readPoint(R), J = a.readPoint(R, y), p.emit("pointerDown")));
  }
  function W(R) {
    if (!Uf(R, r) && R.touches.length >= 2)
      return Q(R);
    const ve = a.readPoint(R), ke = a.readPoint(R, y), Qe = oi(ve, G), et = oi(ke, J);
    if (!H && !j && (!R.cancelable || (H = Qe > et, !H)))
      return Q(R);
    const xt = a.pointerMove(R);
    Qe > m && (V = !0), c.useFriction(0.3).useDuration(0.75), s.start(), o.add(x(xt)), R.preventDefault();
  }
  function Q(R) {
    const ve = d.byDistance(0, !1).index !== f.get(), ke = a.pointerUp(R) * U(), Qe = K(x(ke), ve), et = Kj(ke, Qe), xt = F - 10 * et, dt = w + et / 50;
    H = !1, $ = !1, D.clear(), c.useDuration(xt).useFriction(dt), l.distance(Qe, !g), j = !1, p.emit("pointerUp");
  }
  function te(R) {
    V && (R.stopPropagation(), R.preventDefault(), V = !1);
  }
  function re() {
    return $;
  }
  return {
    init: B,
    destroy: Z,
    pointerDown: re
  };
}
function rz(e, t) {
  let r, o;
  function a(f) {
    return f.timeStamp;
  }
  function i(f, p) {
    const g = `client${(p || e.scroll) === "x" ? "X" : "Y"}`;
    return (Uf(f, t) ? f : f.touches[0])[g];
  }
  function s(f) {
    return r = f, o = f, i(f);
  }
  function l(f) {
    const p = i(f) - i(o), h = a(f) - a(r) > 170;
    return o = f, h && (r = f), p;
  }
  function c(f) {
    if (!r || !o)
      return 0;
    const p = i(o) - i(r), h = a(f) - a(r), g = a(f) - a(o) > 170, m = p / h;
    return h && !g && ze(m) > 0.1 ? m : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: c,
    readPoint: i
  };
}
function oz() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: o,
      offsetWidth: a,
      offsetHeight: i
    } = n;
    return {
      top: r,
      right: o + a,
      bottom: r + i,
      left: o,
      width: a,
      height: i
    };
  }
  return {
    measure: e
  };
}
function az(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function iz(e, t, n, r, o, a, i) {
  const s = [e].concat(r);
  let l, c, d = [], f = !1;
  function p(v) {
    return o.measureSize(i.measure(v));
  }
  function h(v) {
    if (!a)
      return;
    c = p(e), d = r.map(p);
    function w(C) {
      for (const y of C) {
        if (f)
          return;
        const x = y.target === e, E = r.indexOf(y.target), S = x ? c : d[E], I = p(x ? e : r[E]);
        if (ze(I - S) >= 0.5) {
          v.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((C) => {
      (Du(a) || a(v, C)) && w(C);
    }), n.requestAnimationFrame(() => {
      s.forEach((C) => l.observe(C));
    });
  }
  function g() {
    f = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: g
  };
}
function sz(e, t, n, r, o, a) {
  let i = 0, s = 0, l = o, c = a, d = e.get(), f = 0;
  function p() {
    const S = r.get() - e.get(), I = !l;
    let D = 0;
    return I ? (i = 0, n.set(r), e.set(r), D = S) : (n.set(e), i += S / l, i *= c, d += i, e.add(i), D = d - f), s = T0(D), f = d, E;
  }
  function h() {
    const S = r.get() - t.get();
    return ze(S) < 1e-3;
  }
  function g() {
    return l;
  }
  function m() {
    return s;
  }
  function v() {
    return i;
  }
  function w() {
    return y(o);
  }
  function C() {
    return x(a);
  }
  function y(S) {
    return l = S, E;
  }
  function x(S) {
    return c = S, E;
  }
  const E = {
    direction: m,
    duration: g,
    velocity: v,
    seek: p,
    settled: h,
    useBaseFriction: C,
    useBaseDuration: w,
    useFriction: x,
    useDuration: y
  };
  return E;
}
function lz(e, t, n, r, o) {
  const a = o.measure(10), i = o.measure(50), s = eo(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function d(h) {
    if (!c())
      return;
    const g = e.reachedMin(t.get()) ? "min" : "max", m = ze(e[g] - t.get()), v = n.get() - t.get(), w = s.constrain(m / i);
    n.subtract(v * w), !h && ze(v) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function f(h) {
    l = !h;
  }
  return {
    shouldConstrain: c,
    constrain: d,
    toggleActive: f
  };
}
function cz(e, t, n, r, o) {
  const a = eo(-t + e, 0), i = f(), s = d(), l = p();
  function c(g, m) {
    return oi(g, m) <= 1;
  }
  function d() {
    const g = i[0], m = tn(i), v = i.lastIndexOf(g), w = i.indexOf(m) + 1;
    return eo(v, w);
  }
  function f() {
    return n.map((g, m) => {
      const {
        min: v,
        max: w
      } = a, C = a.constrain(g), y = !m, x = L0(n, m);
      return y ? w : x || c(v, C) ? v : c(w, C) ? w : C;
    }).map((g) => parseFloat(g.toFixed(3)));
  }
  function p() {
    if (t <= e + o)
      return [a.max];
    if (r === "keepSnaps")
      return i;
    const {
      min: g,
      max: m
    } = s;
    return i.slice(g, m);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function uz(e, t, n) {
  const r = t[0], o = n ? r - e : tn(t);
  return {
    limit: eo(o, r)
  };
}
function dz(e, t, n, r) {
  const a = t.min + 0.1, i = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = eo(a, i);
  function c(p) {
    return p === 1 ? l(n.get()) : p === -1 ? s(n.get()) : !1;
  }
  function d(p) {
    if (!c(p))
      return;
    const h = e * (p * -1);
    r.forEach((g) => g.add(h));
  }
  return {
    loop: d
  };
}
function fz(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    const i = a - t;
    return n ? i / -n : 0;
  }
  return {
    get: r
  };
}
function pz(e, t, n, r, o) {
  const {
    startEdge: a,
    endEdge: i
  } = e, {
    groupSlides: s
  } = o, l = f().map(t.measure), c = p(), d = h();
  function f() {
    return s(r).map((m) => tn(m)[i] - m[0][a]).map(ze);
  }
  function p() {
    return r.map((m) => n[a] - m[a]).map((m) => -ze(m));
  }
  function h() {
    return s(c).map((m) => m[0]).map((m, v) => m + l[v]);
  }
  return {
    snaps: c,
    snapsAligned: d
  };
}
function hz(e, t, n, r, o, a) {
  const {
    groupSlides: i
  } = o, {
    min: s,
    max: l
  } = r, c = d();
  function d() {
    const p = i(a), h = !e || t === "keepSnaps";
    return n.length === 1 ? [a] : h ? p : p.slice(s, l).map((g, m, v) => {
      const w = !m, C = L0(v, m);
      if (w) {
        const y = tn(v[0]) + 1;
        return Pp(y);
      }
      if (C) {
        const y = cs(a) - tn(v)[0] + 1;
        return Pp(y, tn(v)[0]);
      }
      return g;
    });
  }
  return {
    slideRegistry: c
  };
}
function mz(e, t, n, r, o) {
  const {
    reachedAny: a,
    removeOffset: i,
    constrain: s
  } = r;
  function l(g) {
    return g.concat().sort((m, v) => ze(m) - ze(v))[0];
  }
  function c(g) {
    const m = e ? i(g) : s(g), v = t.map((C, y) => ({
      diff: d(C - m, 0),
      index: y
    })).sort((C, y) => ze(C.diff) - ze(y.diff)), {
      index: w
    } = v[0];
    return {
      index: w,
      distance: m
    };
  }
  function d(g, m) {
    const v = [g, g + n, g - n];
    if (!e)
      return g;
    if (!m)
      return l(v);
    const w = v.filter((C) => T0(C) === m);
    return w.length ? l(w) : tn(v) - n;
  }
  function f(g, m) {
    const v = t[g] - o.get(), w = d(v, m);
    return {
      index: g,
      distance: w
    };
  }
  function p(g, m) {
    const v = o.get() + g, {
      index: w,
      distance: C
    } = c(v), y = !e && a(v);
    if (!m || y)
      return {
        index: w,
        distance: g
      };
    const x = t[w] - C, E = g + d(x, 0);
    return {
      index: w,
      distance: E
    };
  }
  return {
    byDistance: p,
    byIndex: f,
    shortcut: d
  };
}
function vz(e, t, n, r, o, a, i) {
  function s(f) {
    const p = f.distance, h = f.index !== t.get();
    a.add(p), p && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), h && (n.set(t.get()), t.set(f.index), i.emit("select"));
  }
  function l(f, p) {
    const h = o.byDistance(f, p);
    s(h);
  }
  function c(f, p) {
    const h = t.clone().set(f), g = o.byIndex(h.get(), p);
    s(g);
  }
  return {
    distance: l,
    index: c
  };
}
function gz(e, t, n, r, o, a, i, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function d(h) {
    if (!s)
      return;
    function g(m) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10)
        return;
      i.emit("slideFocusStart"), e.scrollLeft = 0;
      const C = n.findIndex((y) => y.includes(m));
      O0(C) && (o.useDuration(0), r.index(C, 0), i.emit("slideFocus"));
    }
    a.add(document, "keydown", f, !1), t.forEach((m, v) => {
      a.add(m, "focus", (w) => {
        (Du(s) || s(h, w)) && g(v);
      }, l);
    });
  }
  function f(h) {
    h.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: d
  };
}
function Qa(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = i(l);
  }
  function o(l) {
    t += i(l);
  }
  function a(l) {
    t -= i(l);
  }
  function i(l) {
    return O0(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: o,
    subtract: a
  };
}
function Qb(e, t) {
  const n = e.scroll === "x" ? i : s, r = t.style;
  let o = null, a = !1;
  function i(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function s(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function l(p) {
    if (a)
      return;
    const h = qj(e.direction(p));
    h !== o && (r.transform = n(h), o = h);
  }
  function c(p) {
    a = !p;
  }
  function d() {
    a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: d,
    to: l,
    toggleActive: c
  };
}
function wz(e, t, n, r, o, a, i, s, l) {
  const d = Si(o), f = Si(o).reverse(), p = w().concat(C());
  function h(I, D) {
    return I.reduce((N, A) => N - o[A], D);
  }
  function g(I, D) {
    return I.reduce((N, A) => h(N, D) > 0 ? N.concat([A]) : N, []);
  }
  function m(I) {
    return a.map((D, N) => ({
      start: D - r[N] + 0.5 + I,
      end: D + t - 0.5 + I
    }));
  }
  function v(I, D, N) {
    const A = m(D);
    return I.map((L) => {
      const F = N ? 0 : -n, k = N ? n : 0, G = N ? "end" : "start", J = A[L][G];
      return {
        index: L,
        loopPoint: J,
        slideLocation: Qa(-1),
        translate: Qb(e, l[L]),
        target: () => s.get() > J ? F : k
      };
    });
  }
  function w() {
    const I = i[0], D = g(f, I);
    return v(D, n, !1);
  }
  function C() {
    const I = t - i[0] - 1, D = g(d, I);
    return v(D, -n, !0);
  }
  function y() {
    return p.every(({
      index: I
    }) => {
      const D = d.filter((N) => N !== I);
      return h(D, t) <= 0.1;
    });
  }
  function x() {
    p.forEach((I) => {
      const {
        target: D,
        translate: N,
        slideLocation: A
      } = I, L = D();
      L !== A.get() && (N.to(L), A.set(L));
    });
  }
  function E() {
    p.forEach((I) => I.translate.clear());
  }
  return {
    canLoop: y,
    clear: E,
    loop: x,
    loopPoints: p
  };
}
function bz(e, t, n) {
  let r, o = !1;
  function a(l) {
    if (!n)
      return;
    function c(d) {
      for (const f of d)
        if (f.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((d) => {
      o || (Du(n) || n(l, d)) && c(d);
    }), r.observe(e, {
      childList: !0
    });
  }
  function i() {
    r && r.disconnect(), o = !0;
  }
  return {
    init: a,
    destroy: i
  };
}
function Cz(e, t, n, r) {
  const o = {};
  let a = null, i = null, s, l = !1;
  function c() {
    s = new IntersectionObserver((g) => {
      l || (g.forEach((m) => {
        const v = t.indexOf(m.target);
        o[v] = m;
      }), a = null, i = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((g) => s.observe(g));
  }
  function d() {
    s && s.disconnect(), l = !0;
  }
  function f(g) {
    return Di(o).reduce((m, v) => {
      const w = parseInt(v), {
        isIntersecting: C
      } = o[w];
      return (g && C || !g && !C) && m.push(w), m;
    }, []);
  }
  function p(g = !0) {
    if (g && a)
      return a;
    if (!g && i)
      return i;
    const m = f(g);
    return g && (a = m), g || (i = m), m;
  }
  return {
    init: c,
    destroy: d,
    get: p
  };
}
function yz(e, t, n, r, o, a) {
  const {
    measureSize: i,
    startEdge: s,
    endEdge: l
  } = e, c = n[0] && o, d = g(), f = m(), p = n.map(i), h = v();
  function g() {
    if (!c)
      return 0;
    const C = n[0];
    return ze(t[s] - C[s]);
  }
  function m() {
    if (!c)
      return 0;
    const C = a.getComputedStyle(tn(r));
    return parseFloat(C.getPropertyValue(`margin-${l}`));
  }
  function v() {
    return n.map((C, y, x) => {
      const E = !y, S = L0(x, y);
      return E ? p[y] + d : S ? p[y] + f : x[y + 1][s] - C[s];
    }).map(ze);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: h,
    startGap: d,
    endGap: f
  };
}
function xz(e, t, n, r, o, a, i, s, l) {
  const {
    startEdge: c,
    endEdge: d,
    direction: f
  } = e, p = O0(n);
  function h(w, C) {
    return Si(w).filter((y) => y % C === 0).map((y) => w.slice(y, y + C));
  }
  function g(w) {
    return w.length ? Si(w).reduce((C, y, x) => {
      const E = tn(C) || 0, S = E === 0, I = y === cs(w), D = o[c] - a[E][c], N = o[c] - a[y][d], A = !r && S ? f(i) : 0, L = !r && I ? f(s) : 0, F = ze(N - L - (D + A));
      return x && F > t + l && C.push(y), I && C.push(w.length), C;
    }, []).map((C, y, x) => {
      const E = Math.max(x[y - 1] || 0);
      return w.slice(E, C);
    }) : [];
  }
  function m(w) {
    return p ? h(w, n) : g(w);
  }
  return {
    groupSlides: m
  };
}
function Ez(e, t, n, r, o, a, i) {
  const {
    align: s,
    axis: l,
    direction: c,
    startIndex: d,
    loop: f,
    duration: p,
    dragFree: h,
    dragThreshold: g,
    inViewThreshold: m,
    slidesToScroll: v,
    skipSnaps: w,
    containScroll: C,
    watchResize: y,
    watchSlides: x,
    watchDrag: E,
    watchFocus: S
  } = a, I = 2, D = oz(), N = D.measure(t), A = n.map(D.measure), L = tz(l, c), F = L.measureSize(N), k = az(F), G = Qj(s, F), J = !f && !!C, $ = f || !!C, {
    slideSizes: H,
    slideSizesWithGaps: V,
    startGap: j,
    endGap: B
  } = yz(L, N, A, n, $, o), Z = xz(L, F, v, f, N, A, j, B, I), {
    snaps: O,
    snapsAligned: Y
  } = pz(L, G, N, A, Z), U = -tn(O) + tn(V), {
    snapsContained: K,
    scrollContainLimit: q
  } = cz(F, U, Y, C, I), W = J ? K : Y, {
    limit: Q
  } = uz(U, W, f), te = qb(cs(W), d, f), re = te.clone(), z = Si(n), R = ({
    dragHandler: mo,
    scrollBody: Lu,
    scrollBounds: Ru,
    options: {
      loop: gs
    }
  }) => {
    gs || Ru.constrain(mo.pointerDown()), Lu.seek();
  }, ce = ({
    scrollBody: mo,
    translate: Lu,
    location: Ru,
    offsetLocation: gs,
    previousLocation: _y,
    scrollLooper: Oy,
    slideLooper: Ty,
    dragHandler: Ly,
    animation: Ry,
    eventHandler: m5,
    scrollBounds: Vy,
    options: {
      loop: v5
    }
  }, g5) => {
    const w5 = mo.settled(), ky = !Vy.shouldConstrain(), b5 = v5 ? w5 : w5 && ky, C5 = b5 && !Ly.pointerDown();
    C5 && Ry.stop();
    const Fy = Ru.get() * g5 + _y.get() * (1 - g5);
    gs.set(Fy), v5 && (Oy.loop(mo.direction()), Ty.loop()), Lu.to(gs.get()), C5 && m5.emit("settle"), b5 || m5.emit("scroll");
  }, ve = ez(r, o, () => R(Tu), (mo) => ce(Tu, mo)), ke = 0.68, Qe = W[te.get()], et = Qa(Qe), xt = Qa(Qe), dt = Qa(Qe), Kt = Qa(Qe), On = sz(et, dt, xt, Kt, p, ke), Da = mz(f, W, U, Q, Kt), Tn = vz(ve, te, re, On, Da, Kt, i), ho = fz(Q), p5 = Mi(), Py = Cz(t, n, i, m), {
    slideRegistry: h5
  } = hz(J, C, W, q, Z, z), Ay = gz(e, n, h5, Tn, On, p5, i, S), Tu = {
    ownerDocument: r,
    ownerWindow: o,
    eventHandler: i,
    containerRect: N,
    slideRects: A,
    animation: ve,
    axis: L,
    dragHandler: nz(L, e, r, o, Kt, rz(L, o), et, ve, Tn, On, Da, te, i, k, h, g, w, ke, E),
    eventStore: p5,
    percentOfView: k,
    index: te,
    indexPrevious: re,
    limit: Q,
    location: et,
    offsetLocation: dt,
    previousLocation: xt,
    options: a,
    resizeHandler: iz(t, i, o, n, L, y, D),
    scrollBody: On,
    scrollBounds: lz(Q, dt, Kt, On, k),
    scrollLooper: dz(U, Q, dt, [et, dt, xt, Kt]),
    scrollProgress: ho,
    scrollSnapList: W.map(ho.get),
    scrollSnaps: W,
    scrollTarget: Da,
    scrollTo: Tn,
    slideLooper: wz(L, F, U, H, V, O, W, dt, n),
    slideFocus: Ay,
    slidesHandler: bz(t, i, x),
    slidesInView: Py,
    slideIndexes: z,
    slideRegistry: h5,
    slidesToScroll: Z,
    target: Kt,
    translate: Qb(L, t)
  };
  return Tu;
}
function Iz() {
  let e = {}, t;
  function n(c) {
    t = c;
  }
  function r(c) {
    return e[c] || [];
  }
  function o(c) {
    return r(c).forEach((d) => d(t, c)), l;
  }
  function a(c, d) {
    return e[c] = r(c).concat([d]), l;
  }
  function i(c, d) {
    return e[c] = r(c).filter((f) => f !== d), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: o,
    off: i,
    on: a,
    clear: s
  };
  return l;
}
const Sz = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Dz(e) {
  function t(a, i) {
    return Kb(a, i || {});
  }
  function n(a) {
    const i = a.breakpoints || {}, s = Di(i).filter((l) => e.matchMedia(l).matches).map((l) => i[l]).reduce((l, c) => t(l, c), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((i) => Di(i.breakpoints || {})).reduce((i, s) => i.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Mz(e) {
  let t = [];
  function n(a, i) {
    return t = i.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(a, e)), i.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Zl(e, t, n) {
  const r = e.ownerDocument, o = r.defaultView, a = Dz(o), i = Mz(a), s = Mi(), l = Iz(), {
    mergeOptions: c,
    optionsAtMedia: d,
    optionsMediaQueries: f
  } = a, {
    on: p,
    off: h,
    emit: g
  } = l, m = L;
  let v = !1, w, C = c(Sz, Zl.globalOptions), y = c(C), x = [], E, S, I;
  function D() {
    const {
      container: z,
      slides: R
    } = y;
    S = (Xf(z) ? e.querySelector(z) : z) || e.children[0];
    const ve = Xf(R) ? S.querySelectorAll(R) : R;
    I = [].slice.call(ve || S.children);
  }
  function N(z) {
    const R = Ez(e, S, I, r, o, z, l);
    if (z.loop && !R.slideLooper.canLoop()) {
      const ce = Object.assign({}, z, {
        loop: !1
      });
      return N(ce);
    }
    return R;
  }
  function A(z, R) {
    v || (C = c(C, z), y = d(C), x = R || x, D(), w = N(y), f([C, ...x.map(({
      options: ce
    }) => ce)]).forEach((ce) => s.add(ce, "change", L)), y.active && (w.translate.to(w.location.get()), w.animation.init(), w.slidesInView.init(), w.slideFocus.init(re), w.eventHandler.init(re), w.resizeHandler.init(re), w.slidesHandler.init(re), w.options.loop && w.slideLooper.loop(), S.offsetParent && I.length && w.dragHandler.init(re), E = i.init(re, x)));
  }
  function L(z, R) {
    const ce = Z();
    F(), A(c({
      startIndex: ce
    }, z), R), l.emit("reInit");
  }
  function F() {
    w.dragHandler.destroy(), w.eventStore.clear(), w.translate.clear(), w.slideLooper.clear(), w.resizeHandler.destroy(), w.slidesHandler.destroy(), w.slidesInView.destroy(), w.animation.destroy(), i.destroy(), s.clear();
  }
  function k() {
    v || (v = !0, s.clear(), F(), l.emit("destroy"), l.clear());
  }
  function G(z, R, ce) {
    !y.active || v || (w.scrollBody.useBaseFriction().useDuration(R === !0 ? 0 : y.duration), w.scrollTo.index(z, ce || 0));
  }
  function J(z) {
    const R = w.index.add(1).get();
    G(R, z, -1);
  }
  function $(z) {
    const R = w.index.add(-1).get();
    G(R, z, 1);
  }
  function H() {
    return w.index.add(1).get() !== Z();
  }
  function V() {
    return w.index.add(-1).get() !== Z();
  }
  function j() {
    return w.scrollSnapList;
  }
  function B() {
    return w.scrollProgress.get(w.offsetLocation.get());
  }
  function Z() {
    return w.index.get();
  }
  function O() {
    return w.indexPrevious.get();
  }
  function Y() {
    return w.slidesInView.get();
  }
  function U() {
    return w.slidesInView.get(!1);
  }
  function K() {
    return E;
  }
  function q() {
    return w;
  }
  function W() {
    return e;
  }
  function Q() {
    return S;
  }
  function te() {
    return I;
  }
  const re = {
    canScrollNext: H,
    canScrollPrev: V,
    containerNode: Q,
    internalEngine: q,
    destroy: k,
    off: h,
    on: p,
    emit: g,
    plugins: K,
    previousScrollSnap: O,
    reInit: m,
    rootNode: W,
    scrollNext: J,
    scrollPrev: $,
    scrollProgress: B,
    scrollSnapList: j,
    scrollTo: G,
    selectedScrollSnap: Z,
    slideNodes: te,
    slidesInView: Y,
    slidesNotInView: U
  };
  return A(t, n), setTimeout(() => l.emit("init"), 0), re;
}
Zl.globalOptions = void 0;
function R0(e = {}, t = []) {
  const n = le(e), r = le(t), [o, a] = ue(), [i, s] = ue(), l = Ve(() => {
    o && o.reInit(n.current, r.current);
  }, [o]);
  return ye(() => {
    _0(n.current, e) || (n.current = e, l());
  }, [e, l]), ye(() => {
    Jj(r.current, t) || (r.current = t, l());
  }, [t, l]), ye(() => {
    if (Uj() && i) {
      Zl.globalOptions = R0.globalOptions;
      const c = Zl(i, n.current, r.current);
      return a(c), () => c.destroy();
    } else
      a(void 0);
  }, [i, a]), [s, o];
}
R0.globalOptions = void 0;
const eC = X.createContext(null);
function us() {
  const e = X.useContext(eC);
  if (e == null)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
const Nz = X.forwardRef(
  ({ orientation: e = "horizontal", opts: t, setApi: n, plugins: r, className: o, children: a, ...i }, s) => {
    const [l, c] = R0(
      {
        ...t,
        axis: e === "horizontal" ? "x" : "y"
      },
      r
    ), [d, f] = X.useState(!1), [p, h] = X.useState(!1), g = X.useCallback((C) => {
      C != null && (f(C.canScrollPrev()), h(C.canScrollNext()));
    }, []), m = X.useCallback(() => {
      c == null || c.scrollPrev();
    }, [c]), v = X.useCallback(() => {
      c == null || c.scrollNext();
    }, [c]), w = X.useCallback(
      (C) => {
        C.key === "ArrowLeft" ? (C.preventDefault(), m()) : C.key === "ArrowRight" && (C.preventDefault(), v());
      },
      [m, v]
    );
    return X.useEffect(() => {
      c == null || n == null || n(c);
    }, [c, n]), X.useEffect(() => {
      if (c != null)
        return g(c), c.on("reInit", g), c.on("select", g), () => {
          c == null || c.off("select", g);
        };
    }, [c, g]), /* @__PURE__ */ u(
      eC.Provider,
      {
        value: {
          carouselRef: l,
          api: c,
          opts: t,
          orientation: e || ((t == null ? void 0 : t.axis) === "y" ? "vertical" : "horizontal"),
          scrollPrev: m,
          scrollNext: v,
          canScrollPrev: d,
          canScrollNext: p
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            ref: s,
            onKeyDownCapture: w,
            className: P("tw-relative", o),
            role: "region",
            "aria-roledescription": "carousel",
            ...i,
            children: a
          }
        )
      }
    );
  }
);
Nz.displayName = "Carousel";
const Pz = X.forwardRef(
  ({ className: e, ...t }, n) => {
    const { carouselRef: r, orientation: o } = us();
    return /* @__PURE__ */ u("div", { ref: r, className: "tw-overflow-hidden", children: /* @__PURE__ */ u(
      "div",
      {
        ref: n,
        className: P("tw-flex", o === "horizontal" ? "tw--ml-4" : "tw--mt-4 tw-flex-col", e),
        ...t
      }
    ) });
  }
);
Pz.displayName = "CarouselContent";
const Az = X.forwardRef(
  ({ className: e, ...t }, n) => {
    const { orientation: r } = us();
    return /* @__PURE__ */ u(
      "div",
      {
        ref: n,
        role: "group",
        "aria-roledescription": "slide",
        className: P(
          "tw-min-w-0 tw-shrink-0 tw-grow-0 tw-basis-full",
          r === "horizontal" ? "tw-pl-4" : "tw-pt-4",
          e
        ),
        ...t
      }
    );
  }
);
Az.displayName = "CarouselItem";
const _z = X.forwardRef(
  ({ className: e, variant: t = "outline", size: n = "icon", ...r }, o) => {
    const { orientation: a, scrollPrev: i, canScrollPrev: s } = us();
    return /* @__PURE__ */ T(
      Yr,
      {
        ref: o,
        variant: t,
        size: n,
        className: P(
          "tw-absolute tw-h-8 tw-w-8",
          a === "horizontal" ? "tw--left-12 tw-top-1/2 tw--translate-y-1/2" : "tw--top-12 tw-left-1/2 tw--translate-x-1/2 tw-rotate-90",
          e
        ),
        disabled: !s,
        onClick: i,
        ...r,
        children: [
          /* @__PURE__ */ u(jS, { className: "tw-h-4 tw-w-4" }),
          /* @__PURE__ */ u("span", { className: "tw-sr-only", children: "Previous slide" })
        ]
      }
    );
  }
);
_z.displayName = "CarouselPrevious";
const Oz = X.forwardRef(
  ({ className: e, variant: t = "outline", size: n = "icon", ...r }, o) => {
    const { orientation: a, scrollNext: i, canScrollNext: s } = us();
    return /* @__PURE__ */ T(
      Yr,
      {
        ref: o,
        variant: t,
        size: n,
        className: P(
          "tw-absolute tw-h-8 tw-w-8",
          a === "horizontal" ? "tw--right-12 tw-top-1/2 tw--translate-y-1/2" : "tw--bottom-12 tw-left-1/2 tw--translate-x-1/2 tw-rotate-90",
          e
        ),
        disabled: !s,
        onClick: i,
        ...r,
        children: [
          /* @__PURE__ */ u(XS, { className: "tw-h-4 tw-w-4" }),
          /* @__PURE__ */ u("span", { className: "tw-sr-only", children: "Next slide" })
        ]
      }
    );
  }
);
Oz.displayName = "CarouselNext";
const Tz = X.forwardRef(
  ({ className: e, ...t }, n) => {
    const { api: r, canScrollNext: o } = us(), [a, i] = ue(0), [s, l] = ue(0);
    return ye(() => {
      if (r != null)
        return l(r.scrollSnapList().length), r.on("select", () => {
          i(r.selectedScrollSnap());
        }), () => {
          r.off("select", () => {
            i(r.selectedScrollSnap());
          });
        };
    }, [r]), s <= 1 ? null : /* @__PURE__ */ u("div", { ref: n, className: P("tw-flex tw-justify-center tw-gap-1 tw-mt-4", e), ...t, children: Array.from({ length: s }).map((c, d) => /* @__PURE__ */ u(
      "button",
      {
        className: P(
          "tw-h-2 tw-rounded-full tw-transition-colors tw-transition-all tw-ease-out tw-duration-300",
          d === a ? "tw-bg-gray-600 tw-w-5" : "tw-bg-gray-300 tw-w-2"
        ),
        onClick: () => r == null ? void 0 : r.scrollTo(d),
        "aria-label": `Go to slide ${d + 1}`
      },
      d
    )) });
  }
);
Tz.displayName = "CarouselDots";
const Lz = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  "div",
  {
    ref: n,
    className: P(
      "tw-rounded-md tw-border-gray-200 tw-border tw-bg-card tw-text-card-foreground tw-shadow-small",
      e
    ),
    ...t
  }
));
Lz.displayName = "Card";
const Rz = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { ref: n, className: P("tw-flex tw-flex-col tw-space-y-1.5 tw-p-6", e), ...t })
);
Rz.displayName = "CardHeader";
const Vz = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "h3",
    {
      ref: n,
      className: P("tw-text-2xl tw-font-semibold tw-leading-none tw-tracking-tight", e),
      ...t
    }
  )
);
Vz.displayName = "CardTitle";
const kz = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("p", { ref: n, className: P("tw-text-sm tw-text-muted-foreground", e), ...t })
);
kz.displayName = "CardDescription";
const Fz = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { ref: n, className: P("tw-px-4 tw-py-6 tw-pt-0", e), ...t })
);
Fz.displayName = "CardContent";
const Hz = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("div", { ref: n, className: P("tw-flex tw-items-center tw-p-6 tw-pt-0", e), ...t })
);
Hz.displayName = "CardFooter";
const Bz = (e) => /* @__PURE__ */ T("svg", { width: "88", height: "82", viewBox: "0 0 88 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "Illustration", clipPath: "url(#clip0_35_1295)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M81.3474 62.3357L85.2952 62.9465C86.6315 61.3447 87.5526 59.4443 87.9787 57.4101C85.092 59.7493 80.7022 58.5063 77.2019 59.7834C76.1133 60.19 75.1311 60.8339 74.328 61.6674C73.5249 62.5009 72.9216 63.5026 72.5627 64.5983L70.6334 66.6533C72.3798 67.3377 74.2554 67.6392 76.1308 67.537C78.0063 67.4348 79.837 66.9313 81.497 66.0612C82.4234 65.5639 83.2828 64.9531 84.0549 64.2432C82.6736 63.3822 81.3474 62.3357 81.3474 62.3357Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M79.9461 56.0852L83.7546 54.8889C84.2291 52.8652 84.1975 50.7575 83.6624 48.7487C82.1325 52.117 77.6435 52.9425 75.0859 55.631C74.2947 56.4756 73.7056 57.4856 73.3623 58.5862C73.019 59.6868 72.9303 60.8498 73.1027 61.9889L72.3016 64.68C74.1731 64.5216 75.9876 63.9633 77.6202 63.0438C79.2527 62.1243 80.6645 60.8653 81.7583 59.3536C82.3634 58.4995 82.8574 57.5734 83.2288 56.5971C81.6045 56.4363 79.9461 56.0852 79.9461 56.0852Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        d: "M88 67.8981C88.0001 67.9183 87.9961 67.9382 87.9883 67.9569C87.9805 67.9755 87.9691 67.9925 87.9547 68.0067C87.9403 68.021 87.9232 68.0323 87.9044 68.04C87.8856 68.0477 87.8654 68.0516 87.845 68.0515H0.154987C0.113882 68.0515 0.0744601 68.0354 0.0453944 68.0066C0.0163287 67.9778 0 67.9388 0 67.8981C0 67.8574 0.0163287 67.8184 0.0453944 67.7896C0.0744601 67.7608 0.113882 67.7447 0.154987 67.7447H87.845C87.8654 67.7446 87.8856 67.7485 87.9044 67.7562C87.9232 67.7639 87.9403 67.7752 87.9547 67.7895C87.9691 67.8037 87.9805 67.8207 87.9883 67.8393C87.9961 67.858 88.0001 67.8779 88 67.8981Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M36.3369 61.3568C51.8019 61.3568 64.3387 48.9455 64.3387 33.6353C64.3387 18.3252 51.8019 5.91382 36.3369 5.91382C20.8719 5.91382 8.33508 18.3252 8.33508 33.6353C8.33508 48.9455 20.8719 61.3568 36.3369 61.3568Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_5",
        d: "M60.4316 33.6353C60.4345 37.3573 59.5562 41.0282 57.8673 44.3536C56.1785 47.6789 53.726 50.5662 50.7065 52.7838C50.5047 52.9334 50.2989 53.0791 50.0918 53.2209C46.0541 55.9995 41.2544 57.4887 36.337 57.4887C31.4197 57.4887 26.62 55.9995 22.5823 53.2209C22.3752 53.0791 22.1694 52.9334 21.9675 52.7838C18.9502 50.5642 16.4992 47.6766 14.8106 44.3517C13.1219 41.0268 12.2424 37.3569 12.2424 33.6353C12.2424 29.9138 13.1219 26.2439 14.8106 22.919C16.4992 19.5941 18.9502 16.7065 21.9675 14.4869C22.1694 14.3373 22.3752 14.1916 22.5823 14.0498C26.62 11.2712 31.4197 9.78195 36.337 9.78195C41.2544 9.78195 46.0541 11.2712 50.0918 14.0498C50.2989 14.1916 50.5047 14.3373 50.7065 14.4869C53.726 16.7045 56.1785 19.5918 57.8673 22.9171C59.5562 26.2425 60.4345 29.9133 60.4316 33.6353Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M36.3369 55.4257C48.4931 55.4257 58.3477 45.6698 58.3477 33.6353C58.3477 21.6008 48.4931 11.845 36.3369 11.845C24.1807 11.845 14.3262 21.6008 14.3262 33.6353C14.3262 45.6698 24.1807 55.4257 36.3369 55.4257Z",
        fill: "#70D4BC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        opacity: "0.2",
        d: "M36.3944 11.9058C36.0608 11.9058 35.7291 11.9145 35.3991 11.929C40.9622 12.413 46.1315 14.9723 49.8596 19.0885C53.5878 23.2048 55.596 28.5701 55.4775 34.0975C55.359 39.6248 53.1226 44.9009 49.2214 48.8569C45.3202 52.8128 40.0459 55.1527 34.467 55.4025C35.1023 55.4571 35.7449 55.4866 36.3944 55.4866C42.2321 55.4866 47.8306 53.1908 51.9584 49.1043C56.0862 45.0179 58.4052 39.4754 58.4052 33.6962C58.4052 27.917 56.0862 22.3746 51.9584 18.2881C47.8306 14.2016 42.2321 11.9058 36.3944 11.9058Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M36.4021 10.2977C36.2122 10.298 36.0302 10.3728 35.896 10.5058C35.7617 10.6387 35.6861 10.8189 35.6858 11.0068V14.1013C35.6858 14.2894 35.7613 14.4698 35.8956 14.6028C36.0299 14.7358 36.2121 14.8105 36.4021 14.8105C36.5921 14.8105 36.7743 14.7358 36.9086 14.6028C37.043 14.4698 37.1184 14.2894 37.1184 14.1013V11.0068C37.1181 10.8189 37.0425 10.6387 36.9083 10.5058C36.774 10.3728 36.592 10.298 36.4021 10.2977Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M50.7065 14.4868C50.5046 14.3373 50.2989 14.1916 50.0918 14.0497C49.9675 14.0417 49.8433 14.0659 49.7314 14.12C49.6195 14.174 49.5237 14.256 49.4536 14.3579L47.694 16.9147C47.5871 17.0702 47.547 17.2613 47.5824 17.446C47.6178 17.6307 47.7259 17.794 47.8829 17.8998C48.0399 18.0057 48.2329 18.0454 48.4195 18.0104C48.6061 17.9753 48.771 17.8683 48.8779 17.7129L50.6375 15.156C50.7044 15.059 50.7458 14.947 50.7579 14.8301C50.7699 14.7132 50.7523 14.5952 50.7065 14.4868Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M58.7007 26.1454C58.6653 26.0592 58.6131 25.9807 58.5471 25.9145C58.4811 25.8483 58.4025 25.7956 58.3159 25.7594C58.2293 25.7232 58.1364 25.7043 58.0424 25.7037C57.9484 25.7032 57.8552 25.7209 57.7681 25.756L54.8716 26.9203C54.6958 26.9912 54.5556 27.1283 54.4818 27.3015C54.408 27.4747 54.4068 27.6698 54.4782 27.8439C54.5497 28.018 54.688 28.1569 54.8629 28.2301C55.0378 28.3033 55.2348 28.3047 55.4108 28.2342L58.3073 27.0699C58.4831 26.9986 58.6231 26.8613 58.6969 26.688C58.7706 26.5148 58.772 26.3196 58.7007 26.1454Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_11",
        d: "M24.98 16.9147L23.2204 14.3579C23.1503 14.256 23.0546 14.174 22.9427 14.12C22.8307 14.0659 22.7065 14.0417 22.5823 14.0497C22.3752 14.1916 22.1694 14.3373 21.9675 14.4868C21.9218 14.5952 21.9041 14.7132 21.9162 14.8301C21.9282 14.947 21.9696 15.059 22.0365 15.156L23.7961 17.7129C23.903 17.8683 24.0679 17.9753 24.2545 18.0104C24.4411 18.0454 24.6342 18.0057 24.7911 17.8998C24.9481 17.794 25.0562 17.6307 25.0917 17.446C25.1271 17.2613 25.0869 17.0702 24.98 16.9147Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        d: "M17.8023 26.9203L14.9058 25.756C14.7298 25.6852 14.5326 25.6866 14.3577 25.7597C14.1827 25.8329 14.0442 25.9718 13.9727 26.146C13.9012 26.3203 13.9026 26.5154 13.9764 26.6887C14.0503 26.8619 14.1906 26.999 14.3666 27.0698L17.2631 28.2341C17.4391 28.3047 17.6361 28.3033 17.811 28.2301C17.9859 28.1569 18.1242 28.018 18.1957 27.8438C18.2672 27.6697 18.2659 27.4746 18.1921 27.3015C18.1184 27.1283 17.9782 26.9912 17.8023 26.9203Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        d: "M36.4021 52.4602C36.2122 52.4605 36.0302 52.5353 35.896 52.6682C35.7617 52.8012 35.6861 52.9813 35.6858 53.1693V56.2638C35.6858 56.4519 35.7613 56.6323 35.8956 56.7653C36.0299 56.8983 36.2121 56.973 36.4021 56.973C36.5921 56.973 36.7743 56.8983 36.9086 56.7653C37.043 56.6323 37.1184 56.4519 37.1184 56.2638V53.1693C37.1181 52.9813 37.0425 52.8012 36.9083 52.6682C36.774 52.5353 36.592 52.4605 36.4021 52.4602Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_14",
        d: "M50.6375 52.1146L48.8779 49.5578C48.825 49.4808 48.7573 49.4149 48.6786 49.3639C48.6 49.3129 48.5119 49.2777 48.4195 49.2603C48.3271 49.2429 48.2322 49.2438 48.1401 49.2627C48.048 49.2817 47.9606 49.3184 47.8829 49.3708C47.8052 49.4232 47.7386 49.4903 47.687 49.5682C47.6355 49.646 47.5999 49.7332 47.5824 49.8247C47.5648 49.9161 47.5657 50.0101 47.5848 50.1013C47.604 50.1924 47.6411 50.279 47.694 50.3559L49.4536 52.9127C49.5237 53.0146 49.6195 53.0966 49.7314 53.1507C49.8433 53.2047 49.9675 53.2289 50.0918 53.2209C50.2989 53.0791 50.5046 52.9334 50.7065 52.7838C50.7523 52.6754 50.7699 52.5574 50.7579 52.4405C50.7458 52.3236 50.7044 52.2116 50.6375 52.1146Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_15",
        d: "M58.3073 40.2008L55.4108 39.0365C55.2348 38.9657 55.0376 38.9671 54.8627 39.0402C54.6877 39.1134 54.5492 39.2524 54.4777 39.4266C54.4062 39.6008 54.4076 39.796 54.4814 39.9692C54.5553 40.1424 54.6956 40.2795 54.8716 40.3504L57.7681 41.5147C57.9441 41.5852 58.1412 41.5838 58.316 41.5106C58.4909 41.4374 58.6293 41.2985 58.7007 41.1244C58.7722 40.9502 58.7709 40.7552 58.6971 40.582C58.6234 40.4088 58.4832 40.2717 58.3073 40.2008Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_16",
        d: "M24.7911 49.3708C24.6341 49.265 24.4411 49.2253 24.2545 49.2603C24.0679 49.2954 23.903 49.4024 23.7961 49.5578L22.0365 52.1146C21.9696 52.2116 21.9282 52.3236 21.9162 52.4405C21.9041 52.5574 21.9218 52.6754 21.9675 52.7838C22.1694 52.9333 22.3752 53.079 22.5823 53.2209C22.7065 53.2289 22.8307 53.2047 22.9427 53.1507C23.0546 53.0966 23.1503 53.0146 23.2204 52.9127L24.98 50.3559C25.0329 50.2789 25.07 50.1924 25.0892 50.1013C25.1084 50.0101 25.1092 49.9161 25.0917 49.8246C25.0741 49.7332 25.0386 49.646 24.987 49.5681C24.9354 49.4903 24.8689 49.4232 24.7911 49.3708Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_17",
        d: "M18.1957 39.4259C18.1603 39.3397 18.1081 39.2612 18.0421 39.195C17.9761 39.1288 17.8975 39.0761 17.8109 39.0399C17.7243 39.0038 17.6314 38.9848 17.5374 38.9843C17.4434 38.9837 17.3502 39.0014 17.2631 39.0365L14.3666 40.2008C14.1908 40.2717 14.0506 40.4088 13.9768 40.582C13.903 40.7552 13.9017 40.9503 13.9732 41.1244C14.0447 41.2985 14.183 41.4375 14.3579 41.5106C14.5328 41.5838 14.7298 41.5853 14.9058 41.5147L17.8023 40.3504C17.9781 40.2791 18.1181 40.1418 18.1919 39.9686C18.2656 39.7953 18.2669 39.6002 18.1957 39.4259Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_18",
        d: "M37.3315 33.2834C37.3976 33.6711 37.3058 34.0688 37.076 34.3895C36.8463 34.7102 36.4975 34.9275 36.1061 34.9939L23.3948 37.1344C23.2009 37.167 23.0024 37.1616 22.8106 37.1183C22.6189 37.075 22.4376 36.9947 22.2772 36.8821C22.1167 36.7694 21.9803 36.6266 21.8756 36.4617C21.7709 36.2969 21.7001 36.1132 21.6671 35.9213C21.6341 35.7293 21.6396 35.5328 21.6834 35.3429C21.7271 35.1531 21.8082 34.9736 21.922 34.8148C22.0357 34.656 22.18 34.5209 22.3465 34.4173C22.5131 34.3136 22.6986 34.2435 22.8925 34.2108L35.6038 32.0703C35.9953 32.0048 36.3971 32.0958 36.721 32.3232C37.0449 32.5506 37.2645 32.896 37.3315 33.2834Z",
        fill: "#D1D5DB"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_19",
        d: "M50.7098 47.2256C50.5272 47.4074 50.2792 47.51 50.0202 47.5111C49.7612 47.5121 49.5124 47.4113 49.3284 47.231L35.6449 33.7907C35.4613 33.61 35.3576 33.3645 35.3567 33.1082C35.3558 32.8519 35.4577 32.6057 35.6401 32.4237C35.8224 32.2418 36.0703 32.1389 36.3292 32.1378C36.5881 32.1367 36.8369 32.2373 37.0208 32.4177L50.7044 45.858C50.888 46.0388 50.9917 46.2843 50.9927 46.5407C50.9938 46.797 50.892 47.0434 50.7098 47.2256Z",
        fill: "#D1D5DB"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_20",
        d: "M36.3369 35.3115C37.272 35.3115 38.0301 34.5611 38.0301 33.6353C38.0301 32.7096 37.272 31.9592 36.3369 31.9592C35.4018 31.9592 34.6438 32.7096 34.6438 33.6353C34.6438 34.5611 35.4018 35.3115 36.3369 35.3115Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_21",
        d: "M24.6747 4.57016C22.0758 8.61525 18.1104 11.2997 13.2201 13.0633C13.1234 13.135 13.0135 13.1871 12.8965 13.2167C12.7795 13.2462 12.6578 13.2527 12.5383 13.2357C12.4188 13.2188 12.3038 13.1786 12.2 13.1177C12.0962 13.0567 12.0055 12.9761 11.9331 12.8804C9.2767 9.36915 9.87651 4.35083 13.3824 1.66781C14.23 1.02027 15.1991 0.545865 16.2334 0.272134C17.2677 -0.00159671 18.3466 -0.069202 19.4075 0.073245C20.4684 0.215692 21.4902 0.565353 22.4135 1.10193C23.3368 1.6385 24.1432 2.3513 24.786 3.19895L24.8595 3.29607C24.9319 3.39173 24.9845 3.50057 25.0144 3.61638C25.0443 3.73218 25.0508 3.85268 25.0337 3.97099C25.0165 4.0893 24.976 4.20311 24.9144 4.30592C24.8528 4.40872 24.7714 4.49851 24.6747 4.57016Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M47.8881 3.1989C48.5308 2.35126 49.3373 1.63846 50.2606 1.10188C51.1839 0.565305 52.2056 0.215647 53.2666 0.0731998C54.3275 -0.0692472 55.4064 -0.0016439 56.4407 0.272087C57.475 0.545818 58.4441 1.02022 59.2917 1.66776C62.7976 4.35078 63.3974 9.3691 60.741 12.8804C60.6686 12.9761 60.5779 13.0567 60.4741 13.1176C60.3702 13.1786 60.2553 13.2187 60.1358 13.2357C60.0163 13.2527 59.8945 13.2462 59.7776 13.2166C59.6606 13.187 59.5507 13.1349 59.454 13.0633C54.9142 11.3426 51.1912 8.36486 47.9993 4.57012C47.8042 4.42541 47.6751 4.20988 47.6404 3.97094C47.6058 3.732 47.6684 3.48922 47.8146 3.29602L47.8881 3.1989Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_23",
        d: "M46.7489 57.6522C46.5833 57.7443 46.4614 57.8976 46.4098 58.0785C46.3582 58.2594 46.3811 58.4532 46.4736 58.6174L50.6077 65.931C50.7005 66.0951 50.8553 66.216 51.0381 66.2671C51.2209 66.3182 51.4167 66.2953 51.5825 66.2034C51.7483 66.1116 51.8704 65.9583 51.922 65.7774C51.9737 65.5964 51.9506 65.4025 51.8579 65.2384L47.7238 57.9248C47.6308 57.7609 47.4759 57.6402 47.2932 57.5891C47.1105 57.538 46.9147 57.5607 46.7489 57.6522Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_24",
        d: "M24.9502 57.9248L20.8161 65.2385C20.7234 65.4026 20.7003 65.5964 20.752 65.7774C20.8036 65.9584 20.9257 66.1116 21.0915 66.2035C21.2573 66.2953 21.4531 66.3182 21.6359 66.2671C21.8187 66.216 21.9735 66.0952 22.0663 65.9311L26.2004 58.6174C26.2464 58.5361 26.2757 58.4467 26.2868 58.3542C26.2978 58.2617 26.2903 58.168 26.2648 58.0783C26.2392 57.9887 26.1961 57.9049 26.1378 57.8318C26.0796 57.7587 26.0073 57.6976 25.9252 57.6521C25.8431 57.6066 25.7528 57.5776 25.6593 57.5667C25.5659 57.5558 25.4712 57.5632 25.3807 57.5885C25.2901 57.6138 25.2055 57.6566 25.1316 57.7143C25.0578 57.772 24.9961 57.8435 24.9502 57.9248Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_25",
        d: "M51.4449 67.8037C52.6677 67.8037 53.659 66.8223 53.659 65.6118C53.659 64.4012 52.6677 63.4198 51.4449 63.4198C50.2221 63.4198 49.2308 64.4012 49.2308 65.6118C49.2308 66.8223 50.2221 67.8037 51.4449 67.8037Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_26",
        d: "M53.0078 11.716C54.2306 11.716 55.2219 10.7346 55.2219 9.52407C55.2219 8.3135 54.2306 7.33214 53.0078 7.33214C51.785 7.33214 50.7937 8.3135 50.7937 9.52407C50.7937 10.7346 51.785 11.716 53.0078 11.716Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_27",
        d: "M36.2068 6.55852C37.4296 6.55852 38.4209 5.57716 38.4209 4.36658C38.4209 3.15601 37.4296 2.17465 36.2068 2.17465C34.984 2.17465 33.9927 3.15601 33.9927 4.36658C33.9927 5.57716 34.984 6.55852 36.2068 6.55852Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_28",
        d: "M20.1871 11.4581C21.4099 11.4581 22.4012 10.4768 22.4012 9.26621C22.4012 8.05564 21.4099 7.07428 20.1871 7.07428C18.9643 7.07428 17.973 8.05564 17.973 9.26621C17.973 10.4768 18.9643 11.4581 20.1871 11.4581Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_29",
        d: "M21.6197 67.8037C22.8426 67.8037 23.8338 66.8223 23.8338 65.6118C23.8338 64.4012 22.8426 63.4198 21.6197 63.4198C20.3969 63.4198 19.4056 64.4012 19.4056 65.6118C19.4056 66.8223 20.3969 67.8037 21.6197 67.8037Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_30",
        d: "M49.7081 45.9928C49.7954 46.1281 49.9116 46.2428 50.0485 46.3288C50.1854 46.4148 50.3397 46.4701 50.5005 46.4907C50.6613 46.5113 50.8247 46.4968 50.9792 46.4481C51.1338 46.3994 51.2756 46.3178 51.3948 46.209L54.8691 48.0519L54.6827 46.0326L51.4121 44.5921C51.2142 44.406 50.9541 44.2982 50.6813 44.2892C50.4085 44.2801 50.1417 44.3705 49.9317 44.5432C49.7217 44.7158 49.5829 44.9588 49.5417 45.2259C49.5005 45.4931 49.5597 45.766 49.7081 45.9928Z",
        fill: "#FFB7B7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_31",
        d: "M52.2395 46.6975L53.601 44.837L60.1599 47.9065L68.3217 46.3905C68.7252 46.3155 69.1403 46.3294 69.5377 46.4312C69.9351 46.533 70.305 46.7201 70.6211 46.9793C70.9372 47.2385 71.1918 47.5635 71.3669 47.931C71.5419 48.2986 71.633 48.6998 71.6338 49.1062C71.6343 49.8402 71.3408 50.5444 70.8175 51.0644C70.2942 51.5843 69.584 51.8776 68.8426 51.8797L59.4891 51.8969L52.2395 46.6975Z",
        fill: "#D1D5DB"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_32",
        d: "M50.1427 78.8321L48.7651 78.1799L50.6574 72.4799L52.6903 73.4425L50.1427 78.8321Z",
        fill: "#FFB7B7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_33",
        d: "M59.3776 77.9132C59.2775 77.9753 59.1773 78.0364 59.0761 78.0975C58.8748 78.2197 58.6714 78.3399 58.468 78.4581C58.3658 78.5172 58.2626 78.5763 58.1604 78.6344V78.6374L58.1544 78.6384L58.1523 78.6394L57.9965 78.6775L57.7729 78.0925L57.6697 77.823L57.524 77.4414L57.2569 76.7432L55.8505 73.067L58.037 72.5331L58.1189 72.8647H58.12L58.1604 73.029L58.9243 76.0961L59.0802 76.7232L59.0852 76.7422L59.1793 77.1168L59.2603 77.4414L59.3503 77.804L59.3776 77.9132Z",
        fill: "#FFB7B7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_34",
        d: "M72.421 65.0034C72.2824 65.2237 72.1407 65.4431 71.9981 65.6605C71.733 66.0651 71.4608 66.4638 71.1815 66.8565C71.1815 66.8575 71.1805 66.8575 71.1795 66.8585C71.0166 67.0079 70.8366 67.138 70.6433 67.2461C70.6352 67.2521 70.6261 67.2561 70.618 67.2611C70.4756 67.3391 70.324 67.3993 70.1667 67.4404C70.11 67.4545 70.0524 67.4685 69.9957 67.4825C69.7913 67.5306 69.589 67.5717 69.3876 67.6077C69.0294 67.6708 68.6753 67.7159 68.3232 67.7439C68.2949 67.747 68.2665 67.749 68.2382 67.751C66.7903 67.8561 65.3808 67.6869 63.9097 67.4094C63.1832 67.2732 62.4415 67.1099 61.6736 66.9406C61.4226 66.8845 61.1707 66.8294 60.9157 66.7743C60.8965 66.7703 60.8763 66.7653 60.856 66.7613C60.4918 66.6822 60.1215 66.604 59.742 66.5269C59.2645 66.4297 58.7717 66.3356 58.2597 66.2464L58.2962 66.9606C58.3265 67.51 58.4418 68.0516 58.6382 68.5663C58.8567 69.1994 59.0297 69.7002 58.6645 70.743L58.4884 71.2478C58.5797 71.4985 58.611 71.7667 58.5799 72.0314C58.5488 72.2961 58.4562 72.5501 58.3093 72.7734L58.2739 72.8265L59.742 76.5036L59.8371 76.742H59.0854L58.1606 76.743H56.5933L54.3319 72.2515L54.2236 72.0371V72.0261L54.4574 63.3947C54.4604 63.3185 54.4665 63.2414 54.4766 63.1653C54.5178 62.8192 54.6282 62.4847 54.8014 62.1813C54.9746 61.878 55.2071 61.6118 55.4854 61.3983C55.752 61.192 56.0573 61.0403 56.3837 60.9519C56.7101 60.8635 57.051 60.8403 57.3865 60.8835L58.1606 60.9826L59.742 61.185L60.856 61.3282L60.8783 61.3312L64.1636 61.7519L64.3994 60.8003L64.4429 60.7843L65.826 60.2824L70.6099 58.5465L70.622 58.5425L70.9367 58.4283L70.9741 58.4884C70.9853 58.5065 70.9964 58.5245 71.0065 58.5425C71.3175 59.0945 71.5708 59.6765 71.7623 60.2794C72.0844 61.2644 72.3496 62.2667 72.5566 63.2815C72.5657 63.3256 72.5738 63.3656 72.5809 63.4017L72.5839 63.4127C72.5869 63.4297 72.589 63.4407 72.59 63.4438C72.7003 63.8985 72.6234 64.4534 72.421 65.0034Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_35",
        d: "M72.6229 61.8224C72.6078 61.7583 72.5885 61.6932 72.5683 61.63C72.4077 61.1521 72.2205 60.6833 72.0078 60.2257C71.769 59.7048 71.4826 59.1469 71.1417 58.5429C70.9767 58.2504 70.7993 57.9462 70.6094 57.6303C70.5143 57.4721 70.4155 57.3108 70.313 57.1465C70.309 57.139 70.3046 57.1316 70.2998 57.1245L70.2705 57.0764L65.5372 57.7035L63.7747 57.9369L63.6695 58.8063L63.6442 59.0217C63.6431 59.0217 63.6431 59.0217 63.6442 59.0227L63.5733 59.6097V59.6107L63.4792 60.386L63.4711 60.385L60.8556 60.0494L58.1602 59.7038L56.7123 59.5185C56.3767 59.4752 56.0358 59.4985 55.7094 59.5869C55.383 59.6752 55.0777 59.827 54.8111 60.0334C54.5329 60.2469 54.3004 60.5131 54.1273 60.8165C53.9541 61.1198 53.8436 61.4543 53.8023 61.8003C53.7932 61.8705 53.7871 61.9426 53.7841 62.0137L52.4181 65.2181C51.6008 67.1344 51.0802 69.162 50.8741 71.2321L49.8724 74.4025L50.0151 74.4155L52.1379 74.6108L52.6984 74.6629L53.9328 72.8789C54.0735 72.6756 54.207 72.4662 54.3315 72.2519C54.5364 71.9018 54.7185 71.5391 54.8768 71.166L57.547 64.8755C57.7534 64.9106 57.9578 64.944 58.1602 64.9757C59.0961 65.1259 59.9946 65.2485 60.8556 65.3433C63.6553 65.6528 66.0796 65.6768 68.2378 65.4144C68.8438 65.3413 69.4297 65.2451 69.9953 65.1259C70.2027 65.0828 70.4074 65.0364 70.6094 64.9867C70.657 64.9757 70.7035 64.9647 70.7501 64.9526C71.1682 64.8459 71.5527 64.637 71.8682 64.3451C72.1837 64.0532 72.4203 63.6876 72.5562 63.2818C72.7184 62.8116 72.7416 62.3052 72.6229 61.8224Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_36",
        d: "M50.5827 77.9013L49.0923 77.1941L48.8586 77.083L48.4853 77.9905L45.8788 78.5584C45.75 78.5864 45.6335 78.6544 45.5465 78.7526C45.4594 78.8508 45.4064 78.9739 45.3951 79.104C45.3838 79.2342 45.4148 79.3645 45.4837 79.4759C45.5525 79.5873 45.6555 79.674 45.7777 79.7234L48.3244 80.7521L49.1328 80.0319L48.9345 80.9985L49.8937 81.3862L50.945 78.0736L50.5827 77.9013Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_37", d: "M59.7419 76.5036L59.8373 76.7425H59.7419V76.5036Z", fill: "#374151" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_38",
        d: "M59.2229 76.7929L57.6613 77.3286L57.4161 77.4124L57.7959 78.3173L56.3475 80.5365C56.2758 80.6461 56.2414 80.7756 56.2493 80.906C56.2572 81.0364 56.307 81.1608 56.3915 81.2612C56.476 81.3615 56.5906 81.4325 56.7187 81.4637C56.8468 81.4949 56.9817 81.4848 57.1035 81.4348L59.6443 80.3918L59.7069 79.3169L60.253 80.1419L61.2101 79.7492L59.6028 76.6631L59.2229 76.7929Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_39",
        d: "M72.2335 63.2736C72.1407 63.2734 72.0494 63.251 71.9674 63.2083L63.7264 58.9453L63.6312 58.5593L63.4518 57.3381L63.4543 57.3266L64.238 53.7495C64.2236 53.7188 64.1936 53.6684 64.1597 53.6115C63.8098 53.0246 62.745 51.2384 64.7772 48.7789L68.3452 44.6607L71.4075 44.5302L71.4424 44.5738C72.2612 45.5913 72.8135 46.7933 73.05 48.0729C73.2865 49.3526 73.2001 50.6703 72.7982 51.9089L72.4794 57.6101L72.8214 58.7614C73.0213 59.438 72.9883 60.1613 72.7274 60.8172L72.8058 62.6815C72.8089 62.758 72.7963 62.8342 72.769 62.9057C72.7416 62.9773 72.7 63.0426 72.6466 63.0978C72.5932 63.1531 72.5291 63.1971 72.4581 63.2273C72.3871 63.2575 72.3107 63.2733 72.2335 63.2736Z",
        fill: "#D1D5DB"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_40",
        d: "M65.085 67.9754C65.2247 67.8938 65.3445 67.7828 65.4361 67.6503C65.5277 67.5179 65.5889 67.3672 65.6153 67.2088C65.6417 67.0504 65.6327 66.8882 65.5889 66.7336C65.5451 66.5791 65.4677 66.4359 65.362 66.3142L67.3433 62.9409L65.2983 63.055L63.7303 66.2408C63.5355 66.4302 63.4177 66.6837 63.3991 66.9533C63.3805 67.223 63.4624 67.49 63.6294 67.7038C63.7964 67.9176 64.0368 68.0634 64.3051 68.1134C64.5734 68.1635 64.8509 68.1144 65.085 67.9754Z",
        fill: "#FFB7B7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_41",
        d: "M65.8846 65.4954L64.0537 64.0837L67.3806 57.7011L66.134 49.5731C66.0724 49.1714 66.1009 48.7611 66.2174 48.3715C66.334 47.9818 66.5358 47.6224 66.8084 47.3186C67.0811 47.0149 67.418 46.7743 67.7951 46.6139C68.1723 46.4535 68.5805 46.3773 68.9907 46.3907C69.7317 46.4157 70.4324 46.7306 70.9391 47.2664C71.4458 47.8022 71.7171 48.5152 71.6935 49.2488L71.3855 58.5036L65.8846 65.4954Z",
        fill: "#D1D5DB"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "a1ca5f83-7fa1-45b1-9d3b-bf096f25c0e5",
        d: "M66.381 42.9495V39.9496C66.3803 38.8834 66.8074 37.8607 67.5684 37.1063C68.3294 36.352 69.362 35.9278 70.4389 35.9271C71.5158 35.9264 72.5489 36.3493 73.3109 37.1027C74.0729 37.8561 74.5014 38.8783 74.502 39.9444V39.9496C75.2177 41.426 74.77 42.1279 74.502 42.9495C74.5018 43.0926 74.4443 43.2297 74.3421 43.3309C74.2399 43.4321 74.1014 43.489 73.9568 43.4893H66.9264C66.7819 43.4891 66.6433 43.4322 66.541 43.331C66.4388 43.2298 66.3812 43.0926 66.381 42.9495Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_42",
        d: "M69.11 43.2943C70.7887 43.2943 72.1495 41.9472 72.1495 40.2853C72.1495 38.6235 70.7887 37.2763 69.11 37.2763C67.4314 37.2763 66.0706 38.6235 66.0706 40.2853C66.0706 41.9472 67.4314 43.2943 69.11 43.2943Z",
        fill: "#FFB7B7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_43",
        d: "M72.2911 41.0742C72.2635 41.0699 72.236 41.0641 72.2084 41.0598C71.7343 40.9766 71.2602 40.8947 70.7875 40.81L70.744 39.7493L70.1714 40.6995C68.865 41.1287 67.6428 40.8861 66.493 40.3507C66.1138 40.1725 65.7458 39.9717 65.3911 39.7493C65.4877 39.1627 65.7155 38.6048 66.058 38.1166C66.4004 37.6283 66.8487 37.222 67.3702 36.9274C67.4137 36.903 67.4557 36.8815 67.4992 36.8599L67.4998 36.8598L67.5003 36.8595L67.5006 36.8591L67.5007 36.8585C67.5746 36.8241 67.65 36.791 67.7254 36.7609C68.3157 36.5325 68.9593 36.4747 69.5814 36.5941C70.2035 36.7136 70.7786 37.0053 71.2399 37.4355C72.1678 38.3125 72.5854 39.7608 72.2911 41.0742Z",
        fill: "#374151"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1295", children: /* @__PURE__ */ u("rect", { width: "88", height: "81.4815", fill: "white" }) }) })
] }), Gz = (e) => /* @__PURE__ */ T("svg", { width: "117", height: "82", viewBox: "0 0 117 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "undraw_online_calendar_re_wk3t", clipPath: "url(#clip0_35_347)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M98.3939 56.5851C98.2733 56.4517 98.1833 56.2935 98.1304 56.1216C98.0774 55.9497 98.0628 55.7683 98.0876 55.5902C98.1124 55.4121 98.1759 55.2415 98.2737 55.0906C98.3715 54.9396 98.5012 54.812 98.6537 54.7166L97.6782 50.4549L99.8061 51.2509L100.406 55.1759C100.549 55.4426 100.59 55.7527 100.52 56.0473C100.45 56.3419 100.274 56.6005 100.026 56.7742C99.778 56.9479 99.4748 57.0246 99.174 56.9897C98.8732 56.9549 98.5957 56.8109 98.3939 56.5851Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M98.2466 53.2027L96.376 49.5863L96.6289 40.4799L96.7491 40.7332C96.8892 41.0283 100.171 47.9764 99.9372 50.3024L100.312 52.4281L98.2466 53.2027Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_3", d: "M97.0271 79.9293H98.5271L99.2406 74.144L97.0269 74.1441L97.0271 79.9293Z", fill: "#FFEDED" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M96.6445 79.4396L99.5984 79.4395H99.5986C100.098 79.4395 100.577 79.6378 100.93 79.9908C101.283 80.3438 101.481 80.8226 101.481 81.3218V81.383L96.6446 81.3832L96.6445 79.4396Z",
        fill: "#4B5563"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_5",
        d: "M82.207 78.7895L83.6521 79.1913L85.8897 73.8087L83.7568 73.2156L82.207 78.7895Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M81.9694 78.2151L84.8153 79.0064L84.8155 79.0064C85.2965 79.1402 85.7046 79.4595 85.9501 79.8942C86.1957 80.3289 86.2584 80.8433 86.1247 81.3243L86.1083 81.3832L81.4487 80.0877L81.9694 78.2151Z",
        fill: "#4B5563"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        d: "M95.5316 77.674L92.5045 56L85.9665 77.5514L80.8257 75.796L88.1937 46.938L88.2422 46.9346L95.9608 46.3977L101.537 75.9222L95.5316 77.674Z",
        fill: "#4B5563"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M94.7308 36.7249C94.7308 36.7249 91.9169 35.2568 88.1242 35.8685C88.1242 35.8685 86.1056 40.7386 88.1242 42.6773L88.6748 47.5523C88.6748 47.5523 93.8132 50.6109 95.526 47.0629L95.2813 43.0256C95.2813 43.0256 96.5048 41.0893 95.526 39.6717C94.9394 38.8058 94.6594 37.7684 94.7308 36.7249Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M95.0875 58.8985L95.5814 48.65L94.1836 36.4584L94.2478 36.4487C96.0813 36.1722 96.6694 39.331 96.6935 39.4656L99.885 57.5098L95.0875 58.8985Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M88.8652 59.0054L83.2231 58.3786L83.2246 58.3169C83.2446 57.4816 83.7302 37.8431 85.091 36.4522C86.4597 35.053 89.0427 35.6584 89.1519 35.685L89.2064 35.6982L88.7421 44.008L88.8652 59.0054Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_11",
        d: "M89.9043 47.2678C89.7334 47.3239 89.5523 47.3418 89.3737 47.3203C89.1951 47.2988 89.0235 47.2384 88.8707 47.1434C88.718 47.0484 88.588 46.921 88.4899 46.7703C88.3917 46.6196 88.3278 46.4492 88.3026 46.2711L84.0122 45.4306L85.6043 43.8098L89.4344 44.8565C89.7363 44.834 90.0361 44.9231 90.2768 45.1068C90.5175 45.2906 90.6824 45.5562 90.7403 45.8534C90.7982 46.1507 90.7451 46.4588 90.591 46.7195C90.437 46.9801 90.1926 47.1752 89.9043 47.2678Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        d: "M87.6151 46.284L86.2172 45.9835C84.1534 46.6042 80.5511 44.4191 79.0951 43.4485C78.8212 43.2659 78.7323 42.9041 78.831 42.3732C78.9767 41.6307 79.386 40.9659 79.9834 40.5014L85.1111 36.4357L86.4053 36.2193L86.7898 38.3977L83.5227 41.9067L88.332 44.5244L87.6151 46.284Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        d: "M87.062 34.0242V31.1994C87.062 30.0043 87.5368 28.8581 88.3819 28.013C89.227 27.1679 90.3731 26.6931 91.5683 26.6931C92.7634 26.6931 93.9096 27.1679 94.7547 28.013C95.5998 28.8581 96.0746 30.0043 96.0746 31.1994V34.0242C96.0744 34.1847 96.0105 34.3386 95.8971 34.4521C95.7836 34.5656 95.6297 34.6294 95.4692 34.6296H87.6673C87.5068 34.6294 87.353 34.5656 87.2395 34.4521C87.126 34.3386 87.0622 34.1847 87.062 34.0242Z",
        fill: "#4B5563"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_14",
        d: "M91.3873 34.6016C93.212 34.6016 94.6912 33.1225 94.6912 31.2978C94.6912 29.4731 93.212 27.994 91.3873 27.994C89.5627 27.994 88.0835 29.4731 88.0835 31.2978C88.0835 33.1225 89.5627 34.6016 91.3873 34.6016Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_15",
        d: "M87.9928 31.2851C87.9612 31.2486 87.9378 31.2058 87.9243 31.1596C87.9107 31.1133 87.9072 31.0647 87.9141 31.017L88.3054 28.2917C88.3132 28.2363 88.3347 28.1836 88.3679 28.1385C88.4011 28.0935 88.445 28.0574 88.4957 28.0336C90.4933 27.0987 92.519 27.0975 94.5166 28.03C94.5696 28.0552 94.6152 28.0936 94.6489 28.1416C94.6826 28.1896 94.7032 28.2455 94.7088 28.3039L94.9701 31.0327C94.9745 31.0794 94.9692 31.1265 94.9544 31.1709C94.9396 31.2154 94.9157 31.2563 94.8842 31.291C94.8527 31.3257 94.8142 31.3534 94.7714 31.3723C94.7285 31.3913 94.6822 31.4011 94.6353 31.4011H93.9727C93.9088 31.4009 93.8462 31.3826 93.7922 31.3482C93.7383 31.3139 93.6952 31.2649 93.668 31.207L93.3821 30.5944C93.3635 30.5547 93.3326 30.5221 93.294 30.5016C93.2554 30.481 93.2111 30.4735 93.1678 30.4803C93.1246 30.4872 93.0847 30.5078 93.0543 30.5393C93.0238 30.5707 93.0044 30.6112 92.999 30.6547L92.9425 31.1064C92.9323 31.1877 92.8927 31.2625 92.8313 31.3167C92.7699 31.371 92.6908 31.401 92.6088 31.4011H88.2469C88.1987 31.4011 88.1511 31.3907 88.1073 31.3707C88.0634 31.3507 88.0244 31.3215 87.9928 31.2851Z",
        fill: "#4B5563"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_16", d: "M74.1181 5.42996H0V51.5841H74.1181V5.42996Z", fill: "#E5E7EB" }),
    /* @__PURE__ */ u("path", { id: "Vector_17", d: "M18.545 14.3213H4.97021V23.1449H18.545V14.3213Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_18", d: "M35.4126 14.3213H21.8379V23.1449H35.4126V14.3213Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_19", d: "M52.2803 14.3213H38.7056V23.1449H52.2803V14.3213Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_20", d: "M69.148 14.3213H55.5732V23.1449H69.148V14.3213Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_21", d: "M18.545 26.8101H4.97021V35.6337H18.545V26.8101Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_22", d: "M35.4126 26.8101H21.8379V35.6337H35.4126V26.8101Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_23", d: "M52.2803 26.8101H38.7056V35.6337H52.2803V26.8101Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_24", d: "M69.148 26.8101H55.5732V35.6337H69.148V26.8101Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_25", d: "M18.545 39.2989H4.97021V48.1225H18.545V39.2989Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_26", d: "M35.4126 39.2989H21.8379V48.1225H35.4126V39.2989Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_27", d: "M52.2803 39.2989H38.7056V48.1225H52.2803V39.2989Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_28", d: "M69.148 39.2989H55.5732V48.1225H69.148V39.2989Z", fill: "white" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_29",
        d: "M19.4117 10.8599C20.5363 10.8599 21.4479 9.94826 21.4479 8.82369C21.4479 7.69912 20.5363 6.78748 19.4117 6.78748C18.2871 6.78748 17.3755 7.69912 17.3755 8.82369C17.3755 9.94826 18.2871 10.8599 19.4117 10.8599Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_30",
        d: "M53.0772 10.8599C54.2018 10.8599 55.1134 9.94825 55.1134 8.82368C55.1134 7.69912 54.2018 6.78748 53.0772 6.78748C51.9527 6.78748 51.041 7.69912 51.041 8.82368C51.041 9.94825 51.9527 10.8599 53.0772 10.8599Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_31", d: "M20.2266 0H18.5977V9.36657H20.2266V0Z", fill: "#E5E7EB" }),
    /* @__PURE__ */ u("path", { id: "Vector_32", d: "M53.8917 0H52.2627V9.36657H53.8917V0Z", fill: "#E5E7EB" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_33",
        d: "M65.4303 18.7331C65.4296 19.4703 65.1629 20.1824 64.6792 20.7387C64.1955 21.295 63.5273 21.6581 62.7974 21.7612C62.0675 21.8643 61.3248 21.7006 60.706 21.3C60.0871 20.8995 59.6336 20.2891 59.4287 19.5809C59.2238 18.8728 59.2814 18.1145 59.5908 17.4454C59.9002 16.7763 60.4407 16.2413 61.1129 15.9388C61.7851 15.6362 62.5439 15.5864 63.25 15.7985C63.956 16.0106 64.5617 16.4704 64.9559 17.0933C65.2663 17.5838 65.4309 18.1526 65.4303 18.7331Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_34",
        d: "M64.9558 17.0934L61.934 20.1146C61.7441 19.8205 60.686 18.4541 60.686 18.4541C60.8216 18.3171 60.9663 18.1893 61.1191 18.0718L61.9965 19.2416L64.6019 16.6363C64.734 16.7771 64.8525 16.9302 64.9558 17.0934Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_35",
        d: "M31.695 31.2219C31.6943 31.9591 31.4276 32.6712 30.9439 33.2275C30.4602 33.7838 29.792 34.1469 29.062 34.25C28.3321 34.3531 27.5895 34.1894 26.9706 33.7888C26.3518 33.3883 25.8982 32.7778 25.6933 32.0697C25.4885 31.3616 25.546 30.6033 25.8554 29.9342C26.1648 29.2651 26.7053 28.7301 27.3775 28.4276C28.0498 28.125 28.8086 28.0752 29.5146 28.2873C30.2206 28.4994 30.8264 28.9592 31.2206 29.5821C31.531 30.0726 31.6955 30.6414 31.695 31.2219Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_36",
        d: "M31.2204 29.5822L28.1987 32.6034C28.0088 32.3093 26.9507 30.9429 26.9507 30.9429C27.0863 30.8059 27.231 30.6781 27.3838 30.5606L28.2612 31.7304L30.8666 29.1251C30.9987 29.2659 31.1172 29.419 31.2204 29.5822Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_37",
        d: "M14.8273 31.2219C14.8266 31.9591 14.5599 32.6712 14.0762 33.2275C13.5925 33.7838 12.9243 34.1469 12.1944 34.25C11.4645 34.3531 10.7218 34.1894 10.103 33.7888C9.48409 33.3883 9.03055 32.7779 8.82567 32.0697C8.6208 31.3616 8.67835 30.6033 8.98776 29.9342C9.29716 29.2651 9.83764 28.7301 10.5099 28.4276C11.1821 28.125 11.9409 28.0752 12.647 28.2873C13.353 28.4994 13.9587 28.9592 14.3529 29.5821C14.6633 30.0727 14.8279 30.6414 14.8273 31.2219Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_38",
        d: "M14.3527 29.5822L11.331 32.6034C11.1411 32.3093 10.083 30.9429 10.083 30.9429C10.2186 30.8059 10.3633 30.6781 10.5161 30.5606L11.3935 31.7304L13.9989 29.1251C14.131 29.2659 14.2495 29.419 14.3527 29.5822Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_39",
        d: "M116.401 81.4816H65.1501C65.1145 81.4816 65.0803 81.4674 65.055 81.4422C65.0298 81.4169 65.0156 81.3827 65.0156 81.347C65.0156 81.3114 65.0298 81.2772 65.055 81.2519C65.0803 81.2267 65.1145 81.2125 65.1501 81.2125H116.401C116.436 81.2125 116.47 81.2267 116.496 81.2519C116.521 81.2772 116.535 81.3114 116.535 81.347C116.535 81.3827 116.521 81.4169 116.496 81.4422C116.47 81.4674 116.436 81.4816 116.401 81.4816Z",
        fill: "#6B7280"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_347", children: /* @__PURE__ */ u("rect", { width: "116.535", height: "81.4815", fill: "white" }) }) })
] }), Wz = (e) => /* @__PURE__ */ T("svg", { width: "88", height: "80", viewBox: "0 0 88 80", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ T("g", { clipPath: "url(#clip0_3_5882)", children: [
    /* @__PURE__ */ u("path", { d: "M87.7253 79.8801H3.81689", stroke: "#090814", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    /* @__PURE__ */ u("path", { d: "M22.3081 21.3619H17.0972V27.6151H22.3081V21.3619Z", fill: "#D9D9D9" }),
    /* @__PURE__ */ u("path", { d: "M28.0405 22.4041H22.8296V27.615H28.0405V22.4041Z", fill: "#D9D9D9" }),
    /* @__PURE__ */ u("path", { d: "M33.7725 22.4041H28.5615V27.615H33.7725V22.4041Z", fill: "#D9D9D9" }),
    /* @__PURE__ */ u("path", { d: "M45.2363 23.4463H40.0254V27.6151H45.2363V23.4463Z", fill: "#D9D9D9" }),
    /* @__PURE__ */ u("path", { d: "M39.5044 7.81351H34.2935V27.6151H39.5044V7.81351Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M62.3138 0.119904H0.120117V27.6194H62.3138V0.119904Z",
        stroke: "#090814",
        strokeWidth: "1.5",
        strokeMiterlimit: "10"
      }
    ),
    /* @__PURE__ */ u("path", { d: "M74.4833 71.1087L72.2742 73.4282L69.9199 71.2518L72.129 68.9322L74.4833 71.1087Z", fill: "#FFE6D8" }),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M76.2477 73.4844L71.552 78.415C71.1507 78.8364 70.6494 79.1693 70.1024 79.3778L68.7932 79.8768C68.5225 79.98 68.2109 79.9202 67.9992 79.7246C67.751 79.4951 67.6882 79.1275 67.8464 78.8306L69.1057 76.4685L70.4494 71.6782L70.4641 71.6872C70.8296 71.9123 71.3841 72.25 71.4236 72.2643C72.1194 72.289 72.6176 72.114 72.9043 71.7443C73.4045 71.0995 73.0872 70.0701 73.0839 70.0598L73.0814 70.0519L73.0877 70.0465C73.2335 69.922 73.3871 69.8722 73.5442 69.8984C73.8777 69.9542 74.1162 70.3287 74.1511 70.3864C74.464 70.3732 75.4248 71.1257 75.5022 71.1867C75.9739 71.1854 76.3197 71.2972 76.5299 71.5192C76.7138 71.7132 76.7938 71.9885 76.7679 72.3376C76.7367 72.7577 76.5519 73.1649 76.2477 73.4844Z",
        fill: "#090814"
      }
    ),
    /* @__PURE__ */ u("path", { d: "M71.933 73.7793H68.7046V76.96H71.933V73.7793Z", fill: "#FFE6D8" }),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M71.382 79.8534H64.5195C63.933 79.8534 63.3435 79.7211 62.8149 79.4707L61.5497 78.8715C61.2882 78.7477 61.1191 78.4828 61.1191 78.1969C61.1191 77.8615 61.3482 77.5649 61.6763 77.4754L64.2863 76.7639L68.7514 74.4515L68.7548 74.4682C68.8383 74.8849 68.9677 75.5143 68.9841 75.5525C69.442 76.0693 69.9124 76.3075 70.3822 76.2606C71.2017 76.1787 71.7465 75.2464 71.7519 75.237L71.7561 75.2298L71.7644 75.2306C71.9563 75.2502 72.0983 75.3264 72.1863 75.4573C72.3733 75.735 72.2592 76.1627 72.2405 76.2272C72.4643 76.443 72.5648 77.6482 72.5726 77.7455C72.8963 78.0836 73.0501 78.4086 73.0297 78.7115C73.0119 78.9763 72.8628 79.2222 72.5867 79.4425C72.2545 79.7075 71.8266 79.8534 71.382 79.8534Z",
        fill: "#090814"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M72.3162 33.7195L60.8763 33.7251L57.063 57.514L68.5029 71.1108L72.3162 67.7116L63.2754 57.514L72.3162 33.7195Z",
        fill: "#090814"
      }
    ),
    /* @__PURE__ */ u("path", { d: "M65.5547 37.2262L72.3163 33.7195V74.51L68.503 74.6147L65.5547 37.2262Z", fill: "#090814" }),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M58.7818 43.2591L58.8623 39.5458L56.6943 39.4988L56.6137 43.212C56.2092 43.5875 55.9422 44.171 55.9279 44.8325C55.9027 45.99 56.6589 46.9451 57.6168 46.9659C58.5747 46.9867 59.3716 46.0652 59.3967 44.9078C59.4111 44.2463 59.1696 43.6518 58.7818 43.2591Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M69.0626 6.9952C69.0626 6.9952 72.1747 6.98847 71.0121 3.98978C69.8495 0.991092 67.6847 2.33377 67.6847 2.33377C67.6847 2.33377 66.7725 2.8156 66.9606 3.89061",
        fill: "#090814"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M69.3737 8.43361C69.3737 6.13448 67.5099 4.27069 65.2108 4.27069C62.9117 4.27069 61.0479 6.13448 61.0479 8.43361C61.0479 10.2982 62.2738 11.8763 63.9635 12.4062L64.7683 17.7248L68.8709 14.306C68.8709 14.306 67.9846 13.1771 67.5093 11.9041C68.6327 11.1586 69.3737 9.88288 69.3737 8.43361Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M67.2108 11.9502C67.2108 11.9502 67.7637 9.83076 66.8597 8.8562C65.9578 7.88387 65.8413 9.39678 65.8413 9.39678L65.1906 9.25531C65.1906 9.25531 65.3038 7.78403 64.0305 7.52938L64.8511 5.77516C64.8511 5.77516 61.7097 6.3851 61.6231 6.08085C60.9418 3.68684 67.4412 1.64179 69.2366 5.29416C72.0291 10.9748 67.2108 11.9502 67.2108 11.9502Z",
        fill: "#090814"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M63.534 15.6589C60.5117 16.2494 58.2432 18.7659 57.9681 21.833L56.0869 42.8085H59.3881L63.534 15.6589Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M60.4126 32.3709L59.8984 38.2934L73.8544 34.1887L72.1539 29.908L75.3204 22.6369L68.8565 13.372L63.6963 13.7238L61.7026 16.3039",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M71.7935 37.9954L73.74 34.8322L71.8931 33.6957L69.9466 36.8589C69.4078 36.9784 68.8825 37.3468 68.5357 37.9104C67.9289 38.8964 68.0986 40.1027 68.9146 40.6049C69.7305 41.107 70.8839 40.7148 71.4907 39.7288C71.8374 39.1653 71.9296 38.5303 71.7935 37.9954Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M67.8008 13.4892L68.9261 13.4426L70.85 14.8966C73.1297 15.2853 73.7908 15.3943 74.4893 16.9002C74.7828 17.533 74.9774 18.2071 75.0862 18.8961L76.7138 29.2044L72.6228 39.0557L69.9118 36.0064L72.8098 28.3045L72.3284 26.4622",
        fill: "#3FC1A3"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_3_5882", children: /* @__PURE__ */ u("rect", { width: "87.7253", height: "80", fill: "white" }) }) })
] }), Zz = (e) => /* @__PURE__ */ T("svg", { width: "152", height: "82", viewBox: "0 0 152 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T(
    "g",
    {
      id: "undraw_undraw_undraw_undraw_undraw_undraw_undraw_undraw_users_per_minute_1e4q_t22j_-1-_0ngf_-1-_27dv_30ul_legv_-1-_il1l_-2-_0jip",
      clipPath: "url(#clip0_35_1140)",
      children: [
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector",
            d: "M135.396 81.1473H35.4011C33.8912 81.1473 32.6641 79.9202 32.6641 78.4103V22.1458C32.6641 20.6359 33.8912 19.4088 35.4011 19.4088H135.396C136.906 19.4088 138.133 20.6359 138.133 22.1458V78.4103C138.133 79.9202 136.906 81.1473 135.396 81.1473ZM35.4011 21.1904C34.8733 21.1904 34.4457 21.618 34.4457 22.1458V78.4103C34.4457 78.9381 34.8733 79.3657 35.4011 79.3657H135.396C135.924 79.3657 136.352 78.9381 136.352 78.4103V22.1458C136.352 21.618 135.924 21.1904 135.396 21.1904H35.4011Z",
            fill: "#E5E7EB"
          }
        ),
        /* @__PURE__ */ u("path", { id: "Vector_2", d: "M60.4513 46.9577H55.6274V59.2243H60.4513V46.9577Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_3", d: "M68.2682 45.7794H63.4443V59.2242H68.2682V45.7794Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_4", d: "M76.0855 50.3807H71.2617V59.2243H76.0855V50.3807Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_5", d: "M83.9024 47.6501H79.0786V59.2242H83.9024V47.6501Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_6", d: "M91.7193 49.9886H86.8955V59.222H91.7193V49.9886Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_7", d: "M99.5362 43.0981H94.7124V59.2242H99.5362V43.0981Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_8", d: "M107.353 45.7794H102.529V59.2242H107.353V45.7794Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u("path", { id: "Vector_9", d: "M115.17 43.4432H110.346V59.2242H115.17V43.4432Z", fill: "#3FC1A3" }),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_10",
            d: "M39.3835 27.2101H74.9853C75.306 27.2101 75.5666 27.4707 75.5666 27.7914C75.5666 28.1121 75.306 28.3727 74.9853 28.3727H39.3835C39.0628 28.3727 38.8022 28.1121 38.8022 27.7914C38.8022 27.4707 39.0628 27.2101 39.3835 27.2101Z",
            fill: "#E5E7EB"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_11",
            d: "M151.133 81.1473C151.133 81.3322 150.984 81.4814 150.799 81.4814H0.334059C0.149213 81.4814 0 81.3322 0 81.1473C0 80.9625 0.149213 80.8133 0.334059 80.8133H150.799C150.984 80.8133 151.133 80.9625 151.133 81.1473Z",
            fill: "#6B7280"
          }
        ),
        /* @__PURE__ */ u("path", { id: "Vector_12", d: "M29.7759 13.5137L34.1521 14.9524V8.65204H30.1812L29.7759 13.5137Z", fill: "#FECACA" }),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_13",
            d: "M33.6106 10.3959C36.0189 10.3959 37.9712 8.44364 37.9712 6.03536C37.9712 3.62707 36.0189 1.67477 33.6106 1.67477C31.2023 1.67477 29.25 3.62707 29.25 6.03536C29.25 8.44364 31.2023 10.3959 33.6106 10.3959Z",
            fill: "#FECACA"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_14",
            d: "M32.4993 6.37606L33.1006 7.10653L34.1874 5.20462C34.1874 5.20462 35.5749 5.27589 35.5749 4.24699C35.5749 3.21809 36.8487 3.18913 36.8487 3.18913C36.8487 3.18913 38.6504 0.0422963 34.9179 0.870763C34.9179 0.870763 32.3278 -0.904205 31.0406 0.612424C31.0406 0.612424 27.092 2.60119 28.2211 6.06427L30.0985 9.63202L30.5239 8.8236C30.5239 8.8236 30.2655 5.43178 32.4993 6.37606Z",
            fill: "#4B5563"
          }
        ),
        /* @__PURE__ */ u("path", { id: "Vector_15", d: "M32.0965 73.1969H28.5732V78.1944H32.0965V73.1969Z", fill: "#FECACA" }),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_16",
            d: "M31.7065 81.0561C31.103 81.1118 28.0898 81.3479 27.9383 80.6575C27.8003 80.0228 28.0029 79.3591 28.0319 79.27C28.3214 76.3882 28.4283 76.3548 28.4929 76.3348C28.5953 76.3058 28.896 76.4461 29.3815 76.7601L29.4126 76.7802L29.4193 76.8158C29.4282 76.8603 29.6443 77.9182 30.6643 77.7578C31.3636 77.6465 31.5907 77.4928 31.6642 77.4171C31.6041 77.3904 31.5306 77.3436 31.4794 77.2612C31.4036 77.1432 31.3903 76.9917 31.4393 76.8113C31.5707 76.3325 31.9649 75.6243 31.9805 75.5954L32.025 75.5152L36.0292 78.2166L38.5013 78.9226C38.6884 78.9761 38.8376 79.1097 38.9133 79.2878C39.018 79.5373 38.9534 79.8268 38.7529 80.0072C38.3031 80.4103 37.4122 81.1029 36.4747 81.1875C36.2252 81.2098 35.8956 81.2187 35.5259 81.2187C33.9781 81.2187 31.7221 81.0584 31.7043 81.0561H31.7065Z",
            fill: "#4B5563"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_17",
            d: "M21.1045 65.6943L17.9189 69.5449L20.6336 71.7907L23.8192 67.94L21.1045 65.6943Z",
            fill: "#FECACA"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_18",
            d: "M18.5136 73.7491C18.0148 73.4061 15.5405 71.669 15.8634 71.041C16.1619 70.4641 16.7409 70.0833 16.8211 70.0321C18.8811 67.9966 18.9858 68.0389 19.0481 68.0656C19.1461 68.1079 19.2864 68.4086 19.4624 68.9587L19.4735 68.9921L19.4557 69.0232C19.4334 69.0633 18.9256 70.0165 19.8142 70.5421C20.4244 70.9029 20.6984 70.9274 20.8008 70.9162C20.7719 70.8583 20.7451 70.7737 20.7563 70.6779C20.7719 70.5399 20.8587 70.4129 21.0146 70.306C21.4222 70.021 22.1749 69.727 22.2083 69.7136L22.2929 69.6802L23.6559 74.3147L25.1102 76.4349C25.2193 76.5952 25.2505 76.7935 25.1948 76.9805C25.1169 77.2389 24.883 77.4215 24.6113 77.4326C24.0078 77.4571 22.8809 77.4215 22.1037 76.8892C21.8988 76.7489 21.6382 76.5463 21.3531 76.3102C20.1617 75.3236 18.5248 73.7624 18.5114 73.7491H18.5136Z",
            fill: "#4B5563"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_19",
            d: "M37.9224 34.6485H25.8384L28.5242 74.5931H32.553L37.9246 34.6485H37.9224Z",
            fill: "#4B5563"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_20",
            d: "M35.4616 36.8489L37.9225 34.6485L36.691 56.6185L22.9299 69.7092L19.498 66.8741L27.5177 56.4693L35.4616 36.8489Z",
            fill: "#4B5563"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_21",
            d: "M35.4614 11.1532L29.4928 10.1844L27.6399 13.4248C25.2837 17.5448 24.3238 22.3152 24.9006 27.0254L25.8382 34.6531H37.9223L35.4614 11.1554V11.1532Z",
            fill: "#3FC1A3"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "uuid-b665f492-9b4b-4e5e-8d83-e9db200bf715-44-44-44-72-164-43-39-154",
            d: "M30.6153 41.842C30.8625 43.0736 30.4015 44.1983 29.5886 44.3541C28.7735 44.5078 27.9139 43.6348 27.6667 42.401C27.562 41.9088 27.5798 41.4011 27.7201 40.9178L26.7402 35.682L29.3014 35.2833L29.994 40.488C30.3102 40.8866 30.524 41.3498 30.6153 41.8442V41.842Z",
            fill: "#FECACA"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_22",
            d: "M27.4998 40.4234L23.7383 28.8026V28.7848L25.1591 16.8188C25.3774 14.9859 26.9319 13.6052 28.7759 13.6052C29.905 13.6052 30.9517 14.1152 31.6466 15.006C32.3414 15.8968 32.5842 17.0348 32.3102 18.1328L29.8003 28.1701L30.3994 39.5616L27.4976 40.4234H27.4998Z",
            fill: "#3FC1A3"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1140", children: /* @__PURE__ */ u("rect", { width: "151.133", height: "81.4815", fill: "white" }) }) })
] }), $z = (e) => /* @__PURE__ */ T("svg", { width: "113", height: "82", viewBox: "0 0 113 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "Illustration", clipPath: "url(#clip0_35_1466)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        opacity: "0.1",
        d: "M110.539 65.3616C107.754 71.109 102.096 74.952 96.2345 77.4865C91.5414 79.5023 86.5805 80.8261 81.5071 81.4166C80.5354 81.5319 79.5605 81.6214 78.5825 81.685C76.0835 81.8479 73.5764 81.8451 71.0778 81.6767C69.5748 81.5767 68.0771 81.417 66.5846 81.1974C61.3987 80.4409 56.3428 78.9686 51.5614 76.8227C50.1815 76.2013 48.8295 75.5228 47.5055 74.7874C45.294 73.5617 43.1751 72.1759 41.1657 70.6413C40.7211 70.3016 40.2821 69.9545 39.8487 69.6L39.6704 69.4543C39.3296 69.1733 38.992 68.886 38.6491 68.607C38.0792 68.1296 37.4742 67.6957 36.8392 67.3089C36.7963 67.2837 36.7533 67.2585 36.7092 67.2344C36.5918 67.1663 36.4722 67.1023 36.3506 67.0415C36.1 66.9152 35.8431 66.8018 35.5809 66.7017C34.3698 66.2404 33.0727 66.0726 31.7578 66.1009C31.5397 66.1009 31.3216 66.1156 31.1024 66.1303C30.7962 66.1512 30.489 66.1827 30.1828 66.2225L30.0696 66.2383C29.0939 66.3763 28.1292 66.5834 27.1828 66.858C25.7211 67.2774 24.2855 67.8017 22.8406 68.2746C22.2271 68.477 21.6127 68.67 20.993 68.843L20.8566 68.8807C19.9753 69.1286 19.078 69.3164 18.1712 69.4428C16.1105 69.7062 14.0174 69.5377 12.0254 68.9478L11.9562 68.9279L11.8283 68.8901L11.6532 68.8356C11.3596 68.7434 11.0684 68.6423 10.7797 68.5326L10.6046 68.4655C10.325 68.3578 10.0513 68.2421 9.78354 68.1184L9.60843 68.0387C9.3288 67.9087 9.05512 67.7713 8.78738 67.6266C8.69091 67.5763 8.59549 67.5217 8.50111 67.4704C8.2159 67.311 7.93627 67.1439 7.66224 66.9691C7.37143 66.7839 7.08692 66.5906 6.80869 66.3893C6.68006 66.297 6.55284 66.2023 6.42701 66.1051C5.70164 65.5503 5.02238 64.9377 4.39589 64.2732C4.36128 64.2386 4.32878 64.203 4.29627 64.1684C4.12955 63.988 3.96597 63.8045 3.80763 63.6168C3.74891 63.5476 3.69019 63.4784 3.63251 63.4071C3.44447 63.1778 3.26306 62.9432 3.0883 62.7035C3.06208 62.6689 3.03692 62.6332 3.01175 62.5986C2.29529 61.6078 1.70132 60.5339 1.24278 59.4004C1.2281 59.3658 1.21447 59.3302 1.20188 59.2956C1.06207 58.9355 0.934493 58.5696 0.819149 58.1977C0.771962 58.0425 0.726872 57.8831 0.687026 57.7279C0.673394 57.6818 0.660811 57.6346 0.649277 57.5885C0.0704554 55.3099 0.00439453 52.9411 0.00439453 50.586C0.00439453 50.3112 0.00439453 50.0369 0.00439453 49.7628C0.021172 45.9533 0.0798927 42.0788 0.641937 38.3217C0.641937 38.2955 0.649277 38.2692 0.653471 38.2441C0.841584 36.9792 1.09746 35.7254 1.41999 34.488C1.75755 33.1897 2.18896 31.9175 2.7108 30.6816C4.00371 27.6407 5.88384 24.8735 7.97158 22.3087C10.4882 19.2227 13.3718 16.3747 16.5836 14.0248C17.045 13.6872 17.5127 13.3593 17.9867 13.0412L18.2058 12.8976C18.2824 12.8462 18.3589 12.7927 18.4355 12.7476C18.5927 12.6428 18.75 12.5442 18.9094 12.4446L19.0877 12.3334L19.4274 12.1237L19.5323 12.0639L19.7137 11.9591L19.893 11.8542C20.1027 11.7305 20.3149 11.6096 20.5295 11.4914C21.4459 10.9804 22.3841 10.5134 23.3439 10.0905C23.627 9.96536 23.9119 9.84478 24.1985 9.72873C25.4998 9.19876 26.8365 8.76043 28.1989 8.41695C28.7022 8.28972 29.2087 8.17787 29.7183 8.0814C30.3195 7.96535 30.9238 7.86923 31.5313 7.79304C32.498 7.67141 33.4702 7.59896 34.4443 7.57598C41.2937 7.40925 48.2122 9.63855 53.58 13.9116C55.7191 15.6145 57.6412 17.6309 60.0435 18.9364C62.1407 20.0731 64.5954 20.5439 66.8415 19.6494C68.6975 18.9102 69.9055 18.5432 71.9901 18.6554C76.3036 18.8984 80.5562 19.7877 84.6056 21.2936C84.7692 21.3534 84.9328 21.4153 85.0953 21.4771C95.6557 25.5194 104.735 33.5464 109.452 43.8614C109.576 44.134 109.698 44.4087 109.816 44.6856C112.629 51.255 113.644 58.9569 110.539 65.3616Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        opacity: "0.1",
        d: "M20.9895 29.0867V68.845L20.8532 68.8828C19.9718 69.1307 19.0746 69.3185 18.1678 69.4448C16.107 69.7083 14.014 69.5397 12.022 68.9499L11.9528 68.93L11.8249 68.8922L11.6498 68.8377C11.3562 68.7454 11.065 68.6444 10.7763 68.5347L10.6012 68.4676C10.3215 68.3599 10.0479 68.2442 9.78012 68.1205L9.60501 68.0408C9.32538 67.9108 9.0517 67.7734 8.78396 67.6287C8.68749 67.5784 8.59207 67.5238 8.4977 67.4724C8.21248 67.3131 7.93286 67.146 7.65883 66.9712C7.36802 66.786 7.0835 66.5927 6.80527 66.3913C6.67665 66.2991 6.54942 66.2043 6.42359 66.1072C5.69822 65.5524 5.01896 64.9397 4.39247 64.2753C4.35787 64.2407 4.32536 64.205 4.29285 64.1704C4.12613 63.9901 3.96255 63.8066 3.80421 63.6189C3.74549 63.5497 3.68677 63.4805 3.6291 63.4092C3.44105 63.1799 3.25964 62.9453 3.08488 62.7056C3.05866 62.671 3.0335 62.6353 3.00833 62.6007C2.29187 61.6099 1.6979 60.536 1.23936 59.4025C1.22468 59.3679 1.21105 59.3322 1.19847 59.2976C1.05865 58.9376 0.931076 58.5717 0.815731 58.1998C0.768544 58.0446 0.723455 57.8852 0.683608 57.73C0.669976 57.6839 0.657393 57.6367 0.645859 57.5905C0.0670375 55.312 0.000976562 52.9432 0.000976562 50.5881C0.000976562 50.3133 0.000976562 50.0389 0.000976562 49.7649C0.017754 45.9554 0.0764748 42.0808 0.638519 38.3238C0.638519 38.2975 0.645859 38.2713 0.650053 38.2462C0.838166 36.9813 1.09404 35.7275 1.41657 34.4901H12.1248V29.0867H14.2597V24.7466H18.8546V29.0867H20.9895Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        opacity: "0.1",
        d: "M110.539 65.3618C107.754 71.1091 102.096 74.9522 96.2341 77.4867C91.541 79.5024 86.5801 80.8263 81.5067 81.4168C80.535 81.5321 79.5602 81.6216 78.5822 81.6852C76.0831 81.8481 73.5761 81.8453 71.0774 81.6768C69.5744 81.5769 68.0767 81.4171 66.5842 81.1976C61.3983 80.4411 56.3424 78.9688 51.5611 76.8229C50.1811 76.2014 48.8291 75.523 47.5051 74.7876C45.2937 73.5619 43.1748 72.1761 41.1654 70.6415C40.7208 70.3017 40.2817 69.9546 39.8483 69.6002L39.6701 69.4545C39.3293 69.1734 38.9916 68.8861 38.6487 68.6072C38.0788 68.1298 37.4738 67.6958 36.8389 67.309C36.7959 67.2839 36.7529 67.2587 36.7088 67.2346C36.5914 67.1664 36.4719 67.1025 36.3502 67.0417C36.0996 66.9153 35.8428 66.8019 35.5806 66.7019V50.4372H55.0413V54.058H63.5821V27.5727H73.6349V38.1635H78.6073V31.8929H82.7157V25.1945H84.6032V21.2938C84.7667 21.3536 84.9303 21.4154 85.0929 21.4773V25.1945H86.93V31.8971H91.0352V38.1677H97.0887V62.0577H106.711V44.6836H109.811C112.629 51.2551 113.644 58.957 110.539 65.3618Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_4", opacity: "0.1", d: "M71.0796 31.5583H66.5864V36.0516H71.0796V31.5583Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_5", opacity: "0.1", d: "M71.0796 40.8718H66.5864V45.365H71.0796V40.8718Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_6", opacity: "0.1", d: "M71.0796 50.1865H66.5864V54.6797H71.0796V50.1865Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_7", opacity: "0.1", d: "M71.0796 59.5012H66.5864V63.9944H71.0796V59.5012Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_8", opacity: "0.1", d: "M71.0796 68.8147H66.5864V73.3079H71.0796V68.8147Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        opacity: "0.1",
        d: "M71.0796 78.1273V81.6758C69.5767 81.5758 68.0789 81.4161 66.5864 81.1966V78.1273H71.0796Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_10", opacity: "0.1", d: "M52.7903 56.2443H37.0625V58.2796H52.7903V56.2443Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_11", opacity: "0.1", d: "M52.7903 62.4256H37.0625V64.4609H52.7903V62.4256Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        opacity: "0.1",
        d: "M52.7901 68.6072V70.6414H41.1675C40.7229 70.3017 40.2839 69.9546 39.8505 69.6002L39.6722 69.4544C39.3314 69.1734 38.9938 68.8861 38.6509 68.6072H52.7901Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        opacity: "0.1",
        d: "M52.7901 74.7875V76.8228H51.5633C50.1833 76.2014 48.8313 75.5229 47.5073 74.7875H52.7901Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_14", opacity: "0.1", d: "M81.509 43.7251H78.5845V46.6496H81.509V43.7251Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_15", opacity: "0.1", d: "M18.174 30.0956H15.2495V33.0202H18.174V30.0956Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_16", opacity: "0.1", d: "M18.174 36.8905H15.2495V39.815H18.174V36.8905Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_17", opacity: "0.1", d: "M18.174 43.6843H15.2495V46.6088H18.174V43.6843Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_18", opacity: "0.1", d: "M18.174 50.4791H15.2495V53.4036H18.174V50.4791Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_19", opacity: "0.1", d: "M18.174 57.274H15.2495V60.1985H18.174V57.274Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_20", opacity: "0.1", d: "M18.174 64.0678H15.2495V66.9923H18.174V64.0678Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_21", opacity: "0.1", d: "M92.6755 43.7251H89.751V46.6496H92.6755V43.7251Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_22", opacity: "0.1", d: "M81.509 50.9395H78.5845V53.864H81.509V50.9395Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_23", opacity: "0.1", d: "M92.6755 50.9395H89.751V53.864H92.6755V50.9395Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_24", opacity: "0.1", d: "M81.509 58.1548H78.5845V61.0793H81.509V58.1548Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_25", opacity: "0.1", d: "M92.6755 58.1548H89.751V61.0793H92.6755V58.1548Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_26", opacity: "0.1", d: "M81.509 65.3702H78.5845V68.2947H81.509V65.3702Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_27", opacity: "0.1", d: "M92.6755 65.3702H89.751V68.2947H92.6755V65.3702Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_28", opacity: "0.1", d: "M81.509 72.5844H78.5845V75.5089H81.509V72.5844Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_29", opacity: "0.1", d: "M92.6755 72.5844H89.751V75.5089H92.6755V72.5844Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_30", opacity: "0.1", d: "M78.5845 81.6851V79.7987H81.509V81.4167L78.5845 81.6851Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_31",
        opacity: "0.1",
        d: "M0.639648 38.2474V39.9251H11.825V38.2474H0.639648ZM1.63581 39.8203H0.814763V38.3522H1.63581V39.8203ZM2.63197 39.8203H1.81092V38.3522H2.63197V39.8203ZM3.62813 39.8203H2.80708V38.3522H3.62813V39.8203ZM4.62429 39.8203H3.80324V38.3522H4.62429V39.8203ZM5.62045 39.8203H4.7994V38.3522H5.62045V39.8203ZM6.61661 39.8203H5.79556V38.3522H6.61661V39.8203ZM7.61277 39.8203H6.79172V38.3522H7.61277V39.8203ZM8.60893 39.8203H7.78788V38.3522H8.60893V39.8203ZM9.60509 39.8203H8.78404V38.3522H9.60509V39.8203ZM10.6012 39.8203H9.7802V38.3522H10.6012V39.8203ZM11.6498 39.8203H10.7764V38.3522H11.6498V39.8203Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_32",
        opacity: "0.1",
        d: "M0.639648 43.1191V44.7916H11.825V43.1191H0.639648ZM1.63581 44.6868H0.814763V43.224H1.63581V44.6868ZM2.63197 44.6868H1.81092V43.224H2.63197V44.6868ZM3.62813 44.6868H2.80708V43.224H3.62813V44.6868ZM4.62429 44.6868H3.80324V43.224H4.62429V44.6868ZM5.62045 44.6868H4.7994V43.224H5.62045V44.6868ZM6.61661 44.6868H5.79556V43.224H6.61661V44.6868ZM7.61277 44.6868H6.79172V43.224H7.61277V44.6868ZM8.60893 44.6868H7.78788V43.224H8.60893V44.6868ZM9.60509 44.6868H8.78404V43.224H9.60509V44.6868ZM10.6012 44.6868H9.7802V43.224H10.6012V44.6868ZM11.6498 44.6868H10.7764V43.224H11.6498V44.6868Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_33",
        opacity: "0.1",
        d: "M0.639648 47.9897V49.6622H11.825V47.9897H0.639648ZM1.63581 49.5574H0.814763V48.0946H1.63581V49.5574ZM2.63197 49.5574H1.81092V48.0946H2.63197V49.5574ZM3.62813 49.5574H2.80708V48.0946H3.62813V49.5574ZM4.62429 49.5574H3.80324V48.0946H4.62429V49.5574ZM5.62045 49.5574H4.7994V48.0946H5.62045V49.5574ZM6.61661 49.5574H5.79556V48.0946H6.61661V49.5574ZM7.61277 49.5574H6.79172V48.0946H7.61277V49.5574ZM8.60893 49.5574H7.78788V48.0946H8.60893V49.5574ZM9.60509 49.5574H8.78404V48.0946H9.60509V49.5574ZM10.6012 49.5574H9.7802V48.0946H10.6012V49.5574ZM11.6498 49.5574H10.7764V48.0946H11.6498V49.5574Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_34",
        opacity: "0.1",
        d: "M0.639648 52.8563V54.5341H11.825V52.8563H0.639648ZM1.63581 54.4292H0.814763V52.9612H1.63581V54.4292ZM2.63197 54.4292H1.81092V52.9612H2.63197V54.4292ZM3.62813 54.4292H2.80708V52.9612H3.62813V54.4292ZM4.62429 54.4292H3.80324V52.9612H4.62429V54.4292ZM5.62045 54.4292H4.7994V52.9612H5.62045V54.4292ZM6.61661 54.4292H5.79556V52.9612H6.61661V54.4292ZM7.61277 54.4292H6.79172V52.9612H7.61277V54.4292ZM8.60893 54.4292H7.78788V52.9612H8.60893V54.4292ZM9.60509 54.4292H8.78404V52.9612H9.60509V54.4292ZM10.6012 54.4292H9.7802V52.9612H10.6012V54.4292ZM11.6498 54.4292H10.7764V52.9612H11.6498V54.4292Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_35",
        opacity: "0.1",
        d: "M0.682617 57.7311C0.722464 57.8884 0.767553 58.0457 0.81474 58.2009V57.836H1.63579V59.304H1.19748C1.21006 59.3386 1.22369 59.3742 1.23837 59.4089H11.8291V57.7311H0.682617ZM2.63195 59.304H1.8109V57.836H2.63195V59.304ZM3.62811 59.304H2.80706V57.836H3.62811V59.304ZM4.62427 59.304H3.80322V57.836H4.62427V59.304ZM5.62043 59.304H4.79938V57.836H5.62043V59.304ZM6.61659 59.304H5.79554V57.836H6.61659V59.304ZM7.61274 59.304H6.7917V57.836H7.61274V59.304ZM8.6089 59.304H7.78786V57.836H8.6089V59.304ZM9.60506 59.304H8.78402V57.836H9.60506V59.304ZM10.6012 59.304H9.78018V57.836H10.6012V59.304ZM11.6498 59.304H10.7763V57.836H11.6498V59.304Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_36",
        opacity: "0.1",
        d: "M3.00732 62.6019C3.03249 62.6365 3.05766 62.6721 3.08387 62.7067H3.62809V63.4103C3.68576 63.4806 3.74448 63.5498 3.8032 63.6201V62.7078H4.62425V64.1758H4.29185C4.32435 64.2104 4.35686 64.2461 4.39146 64.2807H11.8249V62.6029L3.00732 62.6019ZM5.62041 64.1748H4.79936V62.7067H5.62041V64.1748ZM6.61657 64.1748H5.79552V62.7067H6.61657V64.1748ZM7.61273 64.1748H6.79168V62.7067H7.61273V64.1748ZM8.60889 64.1748H7.78784V62.7067H8.60889V64.1748ZM9.60505 64.1748H8.784V62.7067H9.60505V64.1748ZM10.6012 64.1748H9.78016V62.7067H10.6012V64.1748ZM11.6498 64.1748H10.7763V62.7067H11.6498V64.1748Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_37",
        opacity: "0.1",
        d: "M8.49756 67.4725C8.59193 67.526 8.68735 67.5773 8.78382 67.6287V67.5773H9.60487V68.0408L9.77998 68.1205V67.5773H10.601V68.4676L10.7761 68.5347V67.5773H11.6496V68.8356L11.8247 68.8902V67.4725H8.49756Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_38",
        opacity: "0.1",
        d: "M42.9879 23.7232C42.9879 23.7232 40.4881 23.5722 40.7859 25.3234C40.7706 25.4124 40.7839 25.5039 40.8238 25.5849C40.8637 25.6659 40.9283 25.7322 41.0082 25.7742C41.0082 25.7742 41.0082 25.6442 41.264 25.6883C41.3538 25.703 41.4449 25.7072 41.5356 25.7008C41.6583 25.6928 41.775 25.6449 41.868 25.5645C41.868 25.5645 42.5706 25.2741 42.8443 24.1259C42.8443 24.1259 43.0456 23.8753 43.0382 23.8113L42.6188 23.9916C42.6188 23.9916 42.7635 24.2957 42.6503 24.5484C42.6503 24.5484 42.6366 24.0032 42.5548 24.0158C42.5391 24.0158 42.3357 24.1206 42.3357 24.1206C42.3357 24.1206 42.5842 24.6512 42.3965 25.036C42.3965 25.036 42.4678 24.3838 42.2591 24.1594L41.955 24.3345C41.955 24.3345 42.2455 24.8819 42.0484 25.3286C42.0484 25.3286 42.0998 24.6439 41.8932 24.3775L41.6237 24.5872C41.6237 24.5872 41.8963 25.1262 41.7286 25.4974C41.7286 25.4974 41.7065 24.6994 41.5639 24.6386C41.4616 24.7249 41.3704 24.8235 41.2923 24.9322C41.2923 24.9322 41.479 25.3234 41.3636 25.5299C41.3636 25.5299 41.2923 24.9993 41.2336 24.9962C41.2336 24.9962 40.9998 25.3485 40.9757 25.5897C40.9864 25.366 41.0559 25.149 41.177 24.9605C41.0419 24.9861 40.9173 25.0506 40.8184 25.1461C40.8184 25.1461 40.8551 24.8976 41.2378 24.8756C41.2378 24.8756 41.4318 24.6093 41.4842 24.5925C41.4842 24.5925 41.1057 24.561 40.876 24.6627C40.876 24.6627 41.0784 24.4279 41.5534 24.5348L41.8187 24.3178C41.8187 24.3178 41.3207 24.2496 41.1099 24.3251C41.1099 24.3251 41.3521 24.1154 41.89 24.2685L42.1794 24.0955C41.9571 24.0468 41.7294 24.027 41.5021 24.0367C41.5021 24.0367 41.7684 23.8931 42.2644 24.0493L42.4741 23.956C42.4741 23.956 42.1595 23.8952 42.0725 23.8857C41.9855 23.8763 41.976 23.8511 41.976 23.8511C42.173 23.8183 42.3752 23.8408 42.5601 23.9161C42.5601 23.9161 42.9952 23.7505 42.9879 23.7232Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_39",
        opacity: "0.1",
        d: "M36.4257 32.2452C36.4257 32.2452 35.5711 34.5982 37.3349 34.8131C37.4156 34.8529 37.5069 34.8661 37.5956 34.8508C37.6843 34.8356 37.7659 34.7926 37.8288 34.7282C37.8288 34.7282 37.7061 34.6873 37.8193 34.4577C37.859 34.3761 37.8893 34.2903 37.9095 34.2018C37.936 34.0817 37.9228 33.9562 37.8717 33.8443C37.8717 33.8443 37.7931 33.0882 36.7697 32.5C36.7697 32.5 36.5872 32.2347 36.5233 32.2242L36.5757 32.6803C36.5757 32.6803 36.9081 32.6279 37.1189 32.8082C37.1189 32.8082 36.5946 32.6667 36.5809 32.7485C36.5809 32.7642 36.6197 32.9886 36.6197 32.9886C36.6197 32.9886 37.1986 32.9005 37.5142 33.1899C37.5142 33.1899 36.9081 32.9362 36.6344 33.0735L36.7162 33.407C36.7162 33.407 37.3233 33.2854 37.6956 33.5999C37.6956 33.5999 37.0539 33.3577 36.7393 33.4793L36.8641 33.7939C36.8641 33.7939 37.4586 33.6891 37.7669 33.9502C37.7669 33.9502 36.9951 33.7404 36.8976 33.8642C36.9513 33.9863 37.0196 34.1014 37.101 34.2071C37.101 34.2071 37.5299 34.14 37.6945 34.3119C37.6945 34.3119 37.165 34.2291 37.1461 34.2836C37.1461 34.2836 37.4177 34.6087 37.6421 34.703C37.4314 34.6285 37.2438 34.5002 37.0979 34.3308C37.084 34.4679 37.1106 34.6061 37.1744 34.7282C37.1744 34.7282 36.9458 34.6234 37.0329 34.2511C37.0329 34.2511 36.8315 33.99 36.8315 33.9365C36.8315 33.9365 36.6931 34.2899 36.7267 34.5395C36.7267 34.5395 36.5589 34.2784 36.7959 33.8537L36.6638 33.5391C36.6638 33.5391 36.4541 33.9973 36.4687 34.2217C36.4687 34.2217 36.3387 33.9292 36.6365 33.4563L36.5537 33.1302C36.4439 33.3282 36.3604 33.5397 36.3052 33.7593C36.3052 33.7593 36.2422 33.4626 36.5327 33.0316L36.5023 32.8072C36.5023 32.8072 36.3555 33.0882 36.3209 33.1732C36.2863 33.2581 36.2601 33.2549 36.2601 33.2549C36.2842 33.0566 36.363 32.869 36.4876 32.7128C36.4876 32.7128 36.4541 32.2452 36.4257 32.2452Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_40",
        opacity: "0.1",
        d: "M52.9966 30.2613C52.9966 30.2613 52.1431 32.6185 53.9058 32.8282C53.9868 32.8679 54.0783 32.881 54.1672 32.8655C54.2561 32.8501 54.3378 32.8069 54.4007 32.7422C54.4007 32.7422 54.277 32.7013 54.3913 32.4728C54.4313 32.391 54.4612 32.3048 54.4804 32.2158C54.5073 32.0958 54.4944 31.9703 54.4437 31.8583C54.4437 31.8583 54.3651 31.1022 53.3416 30.514C53.3416 30.514 53.1581 30.2497 53.0942 30.2393L53.1476 30.6943C53.1476 30.6943 53.48 30.643 53.6908 30.8233C53.6908 30.8233 53.1665 30.6818 53.1518 30.7625C53.1518 30.7793 53.1906 31.0026 53.1906 31.0026C53.1906 31.0026 53.7695 30.9156 54.0861 31.204C54.0861 31.204 53.48 30.9512 53.2053 31.0876L53.2882 31.4221C53.2882 31.4221 53.8953 31.2994 54.2675 31.615C54.2675 31.615 53.6248 31.3717 53.3102 31.4934L53.435 31.8079C53.435 31.8079 54.0295 31.7031 54.3378 31.9642C54.3378 31.9642 53.5671 31.7545 53.4685 31.8793C53.5239 32.0018 53.5943 32.117 53.6782 32.2221C53.6782 32.2221 54.1061 32.154 54.2717 32.327C54.2717 32.327 53.7422 32.2442 53.7233 32.2997C53.7233 32.2997 53.9939 32.6237 54.2183 32.7192C54.0077 32.6449 53.8203 32.5165 53.6751 32.3469C53.6612 32.4839 53.6874 32.622 53.7506 32.7443C53.7506 32.7443 53.523 32.6395 53.6101 32.2683C53.6101 32.2683 53.4087 32.0061 53.4077 31.9537C53.4077 31.9537 53.2703 32.3081 53.3028 32.5566C53.3028 32.5566 53.1351 32.2966 53.372 31.8709L53.2399 31.5563C53.2399 31.5563 53.0302 32.0145 53.0449 32.2379C53.0449 32.2379 52.9149 31.9464 53.2127 31.4734L53.1288 31.1463C53.019 31.3444 52.9355 31.5558 52.8803 31.7754C52.8803 31.7754 52.8184 31.4787 53.1088 31.0477L53.0784 30.8233C53.0784 30.8233 52.9316 31.1043 52.896 31.1893C52.8603 31.2742 52.8352 31.2711 52.8352 31.2711C52.86 31.0728 52.9391 30.8852 53.0638 30.729C53.0638 30.729 53.026 30.2623 52.9966 30.2613Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_41",
        opacity: "0.1",
        d: "M29.309 49.5008C29.309 49.5008 28.4544 51.8549 30.2182 52.0699C30.299 52.1096 30.3904 52.1227 30.4791 52.1073C30.5679 52.0918 30.6494 52.0486 30.7121 51.9839C30.7121 51.9839 30.5894 51.943 30.7026 51.7144C30.7429 51.6327 30.7732 51.5464 30.7928 51.4575C30.8199 51.3374 30.8066 51.2117 30.755 51.0999C30.755 51.0999 30.6764 50.3439 29.653 49.7567C29.653 49.7567 29.4705 49.4914 29.4066 49.4809L29.459 49.936C29.459 49.936 29.7924 49.8846 30.0022 50.065C30.0022 50.065 29.4779 49.9234 29.4642 50.0041C29.4642 50.0209 29.503 50.2443 29.503 50.2443C29.503 50.2443 30.0819 50.1572 30.3975 50.4456C30.3975 50.4456 29.7914 50.1929 29.5177 50.3292L29.5995 50.6637C29.5995 50.6637 30.2066 50.541 30.5789 50.8566C30.5789 50.8566 29.9371 50.6134 29.6226 50.735L29.7474 51.0496C29.7474 51.0496 30.3419 50.9447 30.6502 51.2058C30.6502 51.2058 29.8795 50.9961 29.7809 51.1209C29.8346 51.243 29.9029 51.3581 29.9843 51.4638C29.9843 51.4638 30.4132 51.3956 30.5789 51.5686C30.5789 51.5686 30.0483 51.4858 30.0294 51.5414C30.0294 51.5414 30.301 51.8654 30.5254 51.9608C30.3146 51.8868 30.127 51.7588 29.9812 51.5896C29.9673 51.7264 29.9939 51.8642 30.0577 51.986C30.0577 51.986 29.8291 51.8811 29.9162 51.5099C29.9162 51.5099 29.7159 51.2478 29.7148 51.1953C29.7148 51.1953 29.5764 51.5498 29.61 51.7983C29.61 51.7983 29.4422 51.5382 29.6792 51.1125L29.5471 50.7979C29.5471 50.7979 29.3374 51.2562 29.3531 51.4795C29.3531 51.4795 29.2231 51.188 29.5209 50.7151L29.437 50.389C29.327 50.5869 29.2435 50.7985 29.1885 51.0181C29.1885 51.0181 29.1255 50.7203 29.416 50.2904L29.3856 50.065C29.3856 50.065 29.2388 50.346 29.2042 50.4309C29.1696 50.5159 29.1434 50.5127 29.1434 50.5127C29.1676 50.3142 29.2468 50.1265 29.372 49.9706C29.372 49.9706 29.3374 49.5008 29.309 49.5008Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_42",
        opacity: "0.1",
        d: "M25.918 27.3137C25.918 27.3137 25.0645 29.6667 26.8272 29.8817C26.9081 29.9213 26.9995 29.9345 27.0884 29.9192C27.1772 29.904 27.259 29.8611 27.3221 29.7968C27.3221 29.7968 27.1984 29.7559 27.3127 29.5262C27.3522 29.4443 27.3821 29.3581 27.4018 29.2693C27.4286 29.1496 27.4157 29.0245 27.3651 28.9128C27.3651 28.9128 27.2864 28.1568 26.262 27.5685C26.262 27.5685 26.0795 27.3032 26.0156 27.2927L26.069 27.7489C26.069 27.7489 26.4014 27.6964 26.6111 27.8768C26.6111 27.8768 26.0869 27.7352 26.0732 27.817C26.0732 27.8327 26.112 28.0571 26.112 28.0571C26.112 28.0571 26.6908 27.9691 27.0075 28.2585C27.0075 28.2585 26.4014 28.0047 26.1267 28.1421L26.2085 28.4755C26.2085 28.4755 26.8156 28.3528 27.1889 28.6685C27.1889 28.6685 26.5461 28.4252 26.2316 28.5479L26.3563 28.8625C26.3563 28.8625 26.9509 28.7576 27.2592 29.0198C27.2592 29.0198 26.4885 28.81 26.3899 28.9338C26.4436 29.0559 26.5119 29.171 26.5933 29.2767C26.5933 29.2767 27.0222 29.2095 27.1879 29.3815C27.1879 29.3815 26.6583 29.2987 26.6395 29.3532C26.6395 29.3532 26.91 29.6783 27.1344 29.7726C26.9238 29.6978 26.7363 29.5695 26.5902 29.4004C26.5763 29.5375 26.6029 29.6757 26.6667 29.7978C26.6667 29.7978 26.4381 29.6929 26.5262 29.3207C26.5262 29.3207 26.3249 29.0596 26.3238 29.0061C26.3238 29.0061 26.1865 29.3595 26.219 29.6091C26.219 29.6091 26.0502 29.348 26.2882 28.9233L26.155 28.6087C26.155 28.6087 25.9453 29.0669 25.961 29.2913C25.961 29.2913 25.831 28.9988 26.1288 28.5259L26.0449 28.1998C25.9352 28.3978 25.8516 28.6093 25.7964 28.8289C25.7964 28.8289 25.7345 28.5322 26.0239 28.1012L25.9946 27.8768C25.9946 27.8768 25.8467 28.1578 25.8121 28.2417C25.7775 28.3256 25.7513 28.3245 25.7513 28.3245C25.7755 28.1261 25.8547 27.9383 25.9799 27.7824C25.9799 27.7824 25.9474 27.3137 25.918 27.3137Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_43",
        opacity: "0.1",
        d: "M32.2559 40.1275C32.2559 40.1275 32.9154 42.5393 34.4799 41.7004C34.5688 41.6863 34.651 41.6444 34.7146 41.5807C34.7783 41.5171 34.8202 41.4349 34.8343 41.346C34.8343 41.346 34.7106 41.3837 34.6718 41.131C34.657 41.0413 34.6317 40.9537 34.5963 40.8699C34.5498 40.7561 34.4668 40.6609 34.3604 40.5994C34.3604 40.5994 33.8602 40.0269 32.6826 40.1359C32.6826 40.1359 32.3806 40.0258 32.3219 40.0541L32.6281 40.3949C32.6281 40.3949 32.8703 40.1611 33.1461 40.1852C33.1461 40.1852 32.6334 40.3739 32.6711 40.4463C32.6795 40.461 32.841 40.6204 32.841 40.6204C32.841 40.6204 33.2604 40.2146 33.6882 40.268C33.6882 40.268 33.0475 40.4106 32.9028 40.6812L33.1618 40.9066C33.1618 40.9066 33.5876 40.4568 34.0741 40.4987C34.0741 40.4987 33.4083 40.6707 33.2216 40.9517L33.5068 41.1394C33.5068 41.1394 33.9263 40.7084 34.3352 40.7472C34.3352 40.7472 33.5865 41.023 33.575 41.1782C33.6895 41.2471 33.8121 41.3017 33.9399 41.3407C33.9399 41.3407 34.2545 41.0387 34.4841 41.0817C34.4841 41.0817 34.0028 41.3198 34.0196 41.3753C34.0196 41.3753 34.4285 41.4802 34.6645 41.4299C34.4496 41.4908 34.2226 41.4944 34.006 41.4404C34.0734 41.5604 34.1748 41.6578 34.2975 41.7203C34.2975 41.7203 34.05 41.7654 33.9074 41.412C33.9074 41.412 33.5928 41.3145 33.5593 41.2705C33.5593 41.2705 33.6515 41.6396 33.8214 41.8241C33.8214 41.8241 33.5341 41.7077 33.4827 41.2233L33.1922 41.0419C33.1922 41.0419 33.2877 41.5358 33.4261 41.7109C33.4261 41.7109 33.1514 41.5473 33.122 40.9895L32.8661 40.7714C32.8911 40.9976 32.9453 41.2197 33.0276 41.432C33.0276 41.432 32.8064 41.2223 32.7948 40.7063L32.6407 40.5396C32.6407 40.5396 32.6826 40.8542 32.7026 40.9433C32.7225 41.0325 32.7026 41.0482 32.7026 41.0482C32.6081 40.872 32.5645 40.6731 32.5767 40.4736C32.5767 40.4736 32.28 40.1118 32.2559 40.1275Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_44",
        opacity: "0.1",
        d: "M50.1489 42.2812C50.1489 42.2812 50.8085 44.693 52.3719 43.8541C52.4611 43.8403 52.5436 43.7985 52.6075 43.7348C52.6714 43.6711 52.7134 43.5888 52.7274 43.4997C52.7274 43.4997 52.6026 43.5374 52.5638 43.29C52.5499 43.2002 52.5249 43.1125 52.4894 43.0289C52.4421 42.9152 52.3589 42.8201 52.2524 42.7583C52.2524 42.7583 51.7522 42.1858 50.5747 42.2959C50.5747 42.2959 50.2727 42.1847 50.215 42.2131L50.5201 42.5538C50.5201 42.5538 50.7623 42.32 51.0381 42.3441C51.0381 42.3441 50.5254 42.5329 50.5642 42.6052C50.5715 42.6199 50.734 42.7793 50.734 42.7793C50.734 42.7793 51.1535 42.3735 51.5813 42.427C51.5813 42.427 50.9396 42.5696 50.7949 42.8401L51.0549 43.0656C51.0549 43.0656 51.4743 42.6157 51.9661 42.6577C51.9661 42.6577 51.3013 42.8296 51.1147 43.1106L51.3999 43.2983C51.3999 43.2983 51.8193 42.8674 52.2272 42.9062C52.2272 42.9062 51.4785 43.1819 51.468 43.3371C51.5822 43.4061 51.7044 43.4607 51.8319 43.4997C51.8319 43.4997 52.1465 43.1977 52.3761 43.2407C52.3761 43.2407 51.8959 43.4787 51.9116 43.5343C51.9116 43.5343 52.3206 43.6391 52.5575 43.5888C52.3423 43.6497 52.115 43.6533 51.898 43.5993C51.9658 43.719 52.0671 43.8164 52.1895 43.8793C52.1895 43.8793 51.942 43.9244 51.7994 43.571C51.7994 43.571 51.4848 43.4735 51.4523 43.4294C51.4523 43.4294 51.5435 43.7985 51.7134 43.9831C51.7134 43.9831 51.4261 43.8667 51.3747 43.3822L51.0843 43.1987C51.0843 43.1987 51.1797 43.6926 51.3191 43.8677C51.3191 43.8677 51.0444 43.7041 51.0151 43.1463L50.7582 42.9282C50.783 43.1546 50.8377 43.3767 50.9207 43.5888C50.9207 43.5888 50.6984 43.3791 50.6869 42.8632L50.5327 42.6965C50.5327 42.6965 50.5747 43.011 50.5946 43.1002C50.6145 43.1893 50.5946 43.205 50.5946 43.205C50.5001 43.0289 50.4565 42.8299 50.4687 42.6304C50.4687 42.6304 50.173 42.2655 50.1489 42.2812Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_45",
        d: "M43.4355 66.5015C43.4355 66.5015 48.8756 64.6697 47.7494 58.1789L40.8392 56.3848L39.2349 61.7105L43.4355 66.5015Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_46",
        opacity: "0.1",
        d: "M39.2349 61.7105L43.4345 66.5015C43.4345 66.5015 48.8745 64.6697 47.7484 58.1789L39.2349 61.7105Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_47",
        d: "M16.3758 13.7585C16.3758 13.7585 17.1098 14.9528 18.1133 14.3562C19.1168 13.7595 18.1542 12.1112 18.1542 12.1112C18.1542 12.1112 16.2322 11.848 16.3758 13.7585Z",
        fill: "#FED253"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_48",
        opacity: "0.1",
        d: "M18.1134 14.3562C17.995 14.4328 17.8622 14.4844 17.7232 14.5078C17.5842 14.5313 17.4419 14.526 17.3049 14.4925C16.9369 14.3992 16.6537 14.1161 16.5017 13.9305C16.4563 13.8761 16.4143 13.819 16.3759 13.7595C16.3245 13.078 16.5363 12.6722 16.8299 12.4331C17.2336 12.1049 17.7925 12.0912 18.0337 12.1017C18.1081 12.1017 18.1511 12.1122 18.1511 12.1122L18.171 12.1458C18.1994 12.1992 18.2612 12.3177 18.3273 12.4761C18.5517 12.9951 18.8191 13.9357 18.1134 14.3562Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_49",
        d: "M43.9708 57.8737L47.7457 58.1789L54.7712 58.2365L49.2357 65.0524C49.2357 65.0524 47.4793 65.1478 47.1176 65.3953C46.7558 65.6427 41.6764 65.5106 41.6764 65.5106L40.8564 62.0167L43.9708 57.8737Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_50",
        opacity: "0.05",
        d: "M43.9708 57.8737L47.7457 58.1789L54.7712 58.2365L49.2357 65.0524C49.2357 65.0524 47.4793 65.1478 47.1176 65.3953C46.7558 65.6427 41.6764 65.5106 41.6764 65.5106L40.8564 62.0167L43.9708 57.8737Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_51",
        d: "M40.1524 39.5486L41.0301 41.0376L41.2209 43.6339C41.2209 43.6339 41.8322 45.8475 42.2905 46.4966C42.7487 47.1456 42.9395 48.8643 42.9395 48.8643C42.9395 48.8643 43.1304 50.4676 43.359 50.8105C43.5876 51.1533 43.8938 53.6417 43.8938 53.6417C43.8938 53.6417 45.9175 57.6882 47.7494 58.1841C47.7494 58.1841 38.6634 61.1621 43.4355 66.5068C43.4355 66.5068 40.0381 67.3457 39.2359 66.3925C38.4338 65.4393 36.3345 51.3127 36.3345 51.3127L36.9835 39.4008L40.1524 39.5486Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_52",
        opacity: "0.05",
        d: "M40.1524 39.5486L41.0301 41.0376L41.2209 43.6339C41.2209 43.6339 41.8322 45.8475 42.2905 46.4966C42.7487 47.1456 42.9395 48.8643 42.9395 48.8643C42.9395 48.8643 43.1304 50.4676 43.359 50.8105C43.5876 51.1533 43.8938 53.6417 43.8938 53.6417C43.8938 53.6417 45.9175 57.6882 47.7494 58.1841C47.7494 58.1841 38.6634 61.1621 43.4355 66.5068C43.4355 66.5068 40.0381 67.3457 39.2359 66.3925C38.4338 65.4393 36.3345 51.3127 36.3345 51.3127L36.9835 39.4008L40.1524 39.5486Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_53",
        d: "M29.1288 25.0372C28.8738 26.3598 28.9495 27.7249 29.349 29.0113L27.9355 33.0578C27.9355 33.0578 17.1697 27.0641 18.0861 25.6128C18.6052 24.7897 18.6712 22.6118 18.6293 20.8816C18.5989 19.5667 18.5056 18.5118 18.5056 18.5118C18.5056 18.5118 31.7178 19.811 29.9593 22.8267C29.5614 23.5122 29.2807 24.2593 29.1288 25.0372Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_54",
        opacity: "0.1",
        d: "M29.9591 22.8267C29.5612 23.5122 29.2805 24.2593 29.1286 25.0372C27.1679 25.6644 25.0504 25.5932 23.1363 24.8356C21.2221 24.078 19.6295 22.6808 18.6291 20.8816C18.5987 19.5667 18.5054 18.5118 18.5054 18.5118C18.5054 18.5118 31.7145 19.811 29.9591 22.8267Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_55",
        d: "M35.3037 16.336C35.3046 17.7357 34.9752 19.1159 34.3423 20.3643C33.7094 21.6128 32.7908 22.6943 31.6612 23.5209C30.5317 24.3476 29.223 24.896 27.8415 25.1216C26.4601 25.3473 25.0449 25.2437 23.711 24.8195C22.3772 24.3952 21.1622 23.6622 20.1649 22.68C19.1677 21.6978 18.4162 20.4942 17.9717 19.1669C17.5272 17.8396 17.4022 16.4262 17.6068 15.0415C17.8114 13.6568 18.3398 12.3399 19.1491 11.1979C19.275 11.021 19.4074 10.8483 19.5465 10.6799C20.3392 9.71644 21.3256 8.93047 22.4417 8.37296C23.0472 8.07002 23.6859 7.83848 24.3449 7.68299C25.5348 7.4011 26.7699 7.36707 27.9735 7.58301C29.1771 7.79896 30.3234 8.26026 31.3411 8.93822C32.3588 9.61618 33.2261 10.4963 33.889 11.5238C34.552 12.5513 34.9964 13.7043 35.1946 14.9109C35.2687 15.3823 35.3052 15.8588 35.3037 16.336Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_56",
        d: "M38.8159 52.9118C38.6827 53.6227 38.8494 54.9219 39.1021 56.2442C39.1126 56.3019 39.1242 56.3596 39.1357 56.4172C39.1472 56.4749 39.164 56.564 39.1787 56.6364C39.2951 57.2047 39.422 57.7678 39.5457 58.2795C39.6694 58.7912 39.7806 59.2295 39.875 59.5903C40.0176 60.1303 40.1151 60.47 40.1151 60.47C40.1151 60.47 40.1277 60.8035 40.1444 61.3341C40.1539 61.6403 40.1644 62.0136 40.1748 62.4257C40.1748 62.5452 40.1822 62.6668 40.1853 62.7927C40.1906 63.0118 40.1958 63.2394 40.2011 63.4721C40.2011 63.5476 40.2011 63.6231 40.2063 63.6997C40.2063 63.9503 40.2157 64.2062 40.2199 64.461C40.2252 64.8112 40.2294 65.1614 40.2315 65.5012C40.2315 65.6312 40.2315 65.7591 40.2315 65.8849C40.2315 66.21 40.2315 66.5214 40.2315 66.8077C40.2199 67.6204 40.1874 68.2338 40.1182 68.411C40.0941 68.4718 40.0721 68.5379 40.0511 68.6071C39.9602 68.9326 39.8943 69.2646 39.854 69.6001L39.6757 69.4543C39.3349 69.1733 38.9973 68.886 38.6544 68.6071C38.0845 68.1297 37.4795 67.6957 36.8445 67.3089C36.8015 67.2838 36.7585 67.2586 36.7145 67.2345C36.5971 67.1663 36.4775 67.1024 36.3559 67.0415C36.1053 66.9152 35.8484 66.8018 35.5862 66.7018C34.3751 66.2404 33.078 66.0726 31.7631 66.101C31.2388 66.3012 30.898 66.4449 30.898 66.4449L30.2311 66.6462L30.1199 66.6798C29.3974 66.9 28.3814 67.2125 28.0154 67.3425C27.424 67.5522 22.2891 68.6207 22.2891 68.6207C21.8199 68.7488 21.3407 68.8365 20.8567 68.8829C19.9753 69.1308 19.0781 69.3186 18.1712 69.4449C16.1105 69.7084 14.0175 69.5398 12.0255 68.95C11.966 68.9535 11.9063 68.9518 11.8472 68.9447C11.8839 68.9447 11.9196 68.9363 11.9521 68.93L11.8241 68.8923L11.649 68.8378C11.3554 68.7455 11.0643 68.6445 10.7755 68.5347L10.6004 68.4676C10.3208 68.36 10.0471 68.2443 9.77938 68.1205L9.60427 68.0408C9.32464 67.9108 9.05096 67.7735 8.78322 67.6287C8.68675 67.5784 8.59133 67.5239 8.49696 67.4725C8.21174 67.3131 7.93212 67.146 7.65809 66.9713C7.61195 66.576 7.58783 66.3117 7.58783 66.3117L7.17888 64.2754L7.15791 64.1705L6.8643 62.7025L6.84333 62.5976L6.20474 59.4036L6.18377 59.2988L5.89016 57.8307L5.86919 57.7259L5.22221 54.534L5.20124 54.4291L4.90764 52.9611L4.88666 52.8562L4.24493 49.658L4.22396 49.5532L3.93035 48.0904L3.90938 47.9855L3.79299 47.4088L3.61787 46.5353C3.61787 46.5353 3.05897 45.7363 2.42982 44.7915L2.35956 44.6867C2.18026 44.4214 1.9957 44.1456 1.81639 43.875C1.75662 43.7859 1.69895 43.6978 1.64128 43.6108C1.5539 43.4787 1.46931 43.3497 1.38752 43.2239L1.3309 43.1368L1.31936 43.119C0.415479 41.7202 1.02051 41.112 1.02051 41.112C1.02051 41.112 1.4001 40.5982 1.8898 39.9187C1.91391 39.8841 1.93908 39.8495 1.96529 39.8139C2.17501 39.5203 2.4057 39.1994 2.6322 38.8785L2.80731 38.629C2.87337 38.5356 2.93838 38.4423 3.0013 38.35C3.02647 38.3154 3.05058 38.2798 3.07365 38.2452C3.55705 37.5468 3.95552 36.9376 4.03731 36.7216C4.16524 36.3808 4.98104 35.3731 5.79369 34.4891C6.43438 33.7908 7.07192 33.17 7.35819 33.0211C8.00727 32.6782 8.27466 31.5698 8.27466 31.5698C8.27466 31.5698 9.68711 31.0749 9.87795 30.6932C10.0688 30.3115 12.7416 28.5961 12.7416 28.5961C12.7416 28.5961 13.8227 27.8998 14.26 27.4803C14.3219 27.4255 14.3759 27.3623 14.4204 27.2927C14.5725 27.02 15.5655 26.7956 15.9692 26.7149C16.0741 26.6939 16.1391 26.6824 16.1391 26.6824C16.3021 26.3862 16.5081 26.1159 16.7504 25.8802C16.915 25.7344 17.1206 25.2322 17.2936 24.7456C17.4813 24.215 17.627 23.7044 17.627 23.7044C17.9332 22.6736 18.5435 22.9788 18.5435 22.9788C18.5427 23.1195 18.556 23.2601 18.5833 23.3982C18.8381 24.6565 20.2223 25.1808 20.949 25.7691C21.7511 26.4171 23.0105 28.098 24.0035 28.4409C24.8256 28.725 25.7788 29.7967 26.0808 30.1543L26.1038 30.1815C26.1542 30.2402 26.1793 30.2738 26.1793 30.2738C26.1793 30.2738 26.7424 30.2444 27.0853 30.2381H27.2101C27.2798 30.2311 27.3461 30.2042 27.4009 30.1605C27.7417 29.9288 28.2492 29.2493 28.4705 29.0931C28.7368 28.9012 29.0053 25.8089 29.0053 25.8089L29.0189 25.8026C29.97 25.357 30.9903 29.8177 30.9903 29.8177C30.9903 29.8177 32.7844 30.3524 32.9375 30.7341C32.9668 30.8096 33.1021 30.9438 33.3055 31.1064C34.2318 31.8142 35.2177 32.4405 36.2521 32.9781C36.2751 32.9896 36.2972 33.0012 36.3202 33.0106C36.341 33.0218 36.3624 33.032 36.3842 33.041C36.423 33.0599 36.4607 33.0767 36.4964 33.0924C36.553 33.1176 36.6054 33.1385 36.6537 33.1553L36.7166 33.1773C36.8669 33.2273 37.0084 33.3006 37.136 33.3944C37.1738 33.4217 37.2115 33.45 37.2482 33.4804C37.391 33.5992 37.5223 33.7312 37.6404 33.8747C37.6582 33.8956 37.675 33.9176 37.6918 33.9386C37.7715 34.0382 37.8428 34.1368 37.9015 34.228C37.9979 34.3688 38.0858 34.5151 38.1647 34.6663C38.1647 34.6663 39.7292 37.3392 40.2262 37.6433C40.7233 37.9474 41.0284 41.0418 41.0284 41.0418L39.3507 47.2609C39.3507 47.2609 39.272 48.8338 39.1252 50.4382C39.0434 51.3379 38.9396 52.2533 38.8159 52.9118Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_57",
        d: "M26.1791 30.4626C26.1791 30.4626 25.054 31.0728 24.1752 31.1305C24.0602 31.1359 23.9449 31.1292 23.8313 31.1106C22.9106 30.9711 21.5601 30.214 21.5601 30.214L23.1445 28.4765L25.0718 29.4318L25.7806 30.0914L26.1791 30.4626Z",
        fill: "#63667E"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_58",
        opacity: "0.1",
        d: "M35.1909 14.911C35.151 14.9674 35.1057 15.0197 35.0556 15.0673C34.504 15.5916 33.5247 15.3745 32.7728 15.2529C32.1195 15.1461 31.4813 14.9616 30.8717 14.7034C30.3411 14.4769 29.7047 14.2001 29.2275 14.5251C29.044 14.6489 28.9182 14.8471 28.7274 14.9561C28.5365 15.0652 28.2933 15.0725 28.0678 15.0756C27.3338 15.0756 26.5998 15.084 25.8836 14.9184C24.8151 14.6688 23.7099 14.0407 22.6938 14.4549C21.899 14.7778 21.468 15.6429 21.253 16.4745C21.1482 16.8824 21.0706 17.3133 20.8336 17.6594C20.5966 18.0054 20.1384 18.2508 19.7483 18.0882C19.1726 17.8481 19.0877 16.8708 18.3935 16.8215C17.6312 16.7681 17.6406 17.5556 17.8629 18.1249C18.1922 18.9638 18.6232 19.8027 18.642 20.6772C17.8227 19.2098 17.4356 17.5404 17.5254 15.8622C17.6152 14.1839 18.1783 12.5654 19.1496 11.1938C19.3186 11.0891 19.4509 10.9345 19.5281 10.7513C19.5359 10.7265 19.5422 10.7013 19.547 10.6758C19.6046 10.3832 19.4421 10.076 19.4327 9.76978C19.396 9.02214 20.2055 8.50099 20.9479 8.40662C21.4418 8.3437 21.9472 8.39194 22.4421 8.37621C22.6914 8.37072 22.9393 8.33766 23.1814 8.27764C23.5989 8.15252 23.9899 7.9517 24.3348 7.68519C25.5247 7.4033 26.7599 7.36927 27.9635 7.58521C29.1671 7.80115 30.3134 8.26245 31.3311 8.94041C32.3487 9.61837 33.216 10.4985 33.879 11.526C34.5419 12.5535 34.9863 13.7065 35.1846 14.9131L35.1909 14.911Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_59",
        d: "M35.3701 14.2932C35.3179 14.5006 35.2089 14.6894 35.0556 14.8385C34.504 15.3628 33.5246 15.1447 32.7728 15.023C32.1194 14.9186 31.4811 14.7355 30.8717 14.4778C30.3411 14.2523 29.7046 13.9755 29.2275 14.3006C29.044 14.4243 28.9182 14.6225 28.7273 14.7315C28.5365 14.8406 28.2932 14.8479 28.0678 14.85C27.3337 14.8553 26.5997 14.8595 25.8835 14.6938C24.815 14.4432 23.7098 13.8161 22.6937 14.2293C21.8989 14.5522 21.4679 15.4184 21.253 16.2499C21.1481 16.6578 21.0705 17.0888 20.8335 17.4338C20.5966 17.7787 20.1383 18.0262 19.7482 17.8637C19.1726 17.6236 19.0876 16.6463 18.3935 16.597C17.6311 16.5435 17.6406 17.331 17.8629 17.9004C18.253 18.8934 18.7835 19.8812 18.6095 20.934C18.4365 20.934 18.1502 20.9277 17.9803 20.9235C18.1124 20.698 17.8608 20.4296 17.6102 20.353C17.3596 20.2765 17.067 20.2775 16.8762 20.0951C16.6853 19.9126 16.6843 19.6306 16.7042 19.3778C16.7477 18.8377 16.8798 18.3084 17.0953 17.8112C17.2327 17.4967 17.4099 17.1559 17.305 16.8266C17.2421 16.6774 17.1663 16.5339 17.0785 16.3978C16.8604 15.9783 16.9118 15.454 17.0985 15.021C17.1781 14.8364 17.2358 14.6623 17.3019 14.4967C17.3853 14.2612 17.506 14.0406 17.6595 13.8434C17.8996 13.5445 18.1345 13.0947 17.8692 12.8168C17.8021 12.7466 17.9363 12.6983 17.8933 12.6071C17.8857 12.5915 17.8804 12.5749 17.8776 12.5578C17.8652 12.4474 17.8919 12.3361 17.9531 12.2432C17.9654 12.2191 17.9791 12.1957 17.994 12.173C18.006 12.149 18.0197 12.1259 18.0348 12.1038C18.267 11.7161 18.5756 11.3797 18.9419 11.115C19.1694 10.9503 19.4358 10.792 19.5259 10.5256C19.6308 10.2111 19.4462 9.87657 19.4305 9.54417C19.3938 8.79653 20.2033 8.27538 20.9457 8.181C21.6881 8.08663 22.4578 8.24287 23.1813 8.05098C24.2079 7.78044 24.9293 6.87446 25.8615 6.36589C26.3715 6.09322 26.937 5.9407 27.5149 5.91998C28.0929 5.89926 28.6679 6.0109 29.196 6.24636C30.2845 6.74339 31.1055 7.74794 32.2422 8.12543C32.6448 8.25965 33.0811 8.31313 33.4439 8.53543C33.8633 8.79338 34.1181 9.24427 34.3362 9.68888C34.6686 10.3631 34.7357 11.0405 34.9654 11.7546C35.1478 12.3208 35.4005 13.0611 35.4215 13.7134C35.4333 13.9081 35.416 14.1036 35.3701 14.2932Z",
        fill: "#896363"
      }
    ),
    /* @__PURE__ */ T("g", { id: "Group", opacity: "0.1", children: [
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_60",
          d: "M18.0055 12.9794C18.0223 12.9123 18.0239 12.8423 18.0103 12.7745C17.9967 12.7066 17.9682 12.6427 17.9268 12.5872C17.9541 12.669 17.8356 12.7162 17.9006 12.7844C17.9524 12.8388 17.9886 12.9062 18.0055 12.9794Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_61",
          d: "M17.9233 12.3471C17.911 12.3836 17.9036 12.4215 17.9014 12.4599C17.9212 12.4265 17.9484 12.392 17.9233 12.3471Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_62",
          d: "M35.085 14.5827C34.5324 15.107 33.5541 14.89 32.8001 14.7673C32.1472 14.6622 31.5096 14.478 30.9011 14.2189C30.3695 13.9924 29.7341 13.7155 29.2559 14.0406C29.0734 14.1643 28.9476 14.3625 28.7557 14.4716C28.5638 14.5806 28.3216 14.588 28.0962 14.5901C27.3621 14.5901 26.6281 14.5995 25.9109 14.4328C24.8434 14.1832 23.7382 13.5572 22.7221 13.9693C21.9273 14.2933 21.4963 15.1584 21.2814 15.9899C21.1765 16.3978 21.1 16.8288 20.8619 17.1748C20.6239 17.5209 20.1657 17.7662 19.7767 17.6048C19.201 17.3636 19.116 16.3873 18.4219 16.3381C17.8798 16.2993 17.7288 16.6872 17.7655 17.1182C17.7969 16.789 17.9752 16.5352 18.4219 16.5667C19.116 16.6159 19.201 17.5932 19.7767 17.8334C20.1657 17.9959 20.625 17.7516 20.8619 17.4034C21.0989 17.0553 21.1765 16.6264 21.2814 16.2196C21.4963 15.388 21.9273 14.5219 22.7221 14.1989C23.7382 13.7858 24.8434 14.4087 25.9109 14.6624C26.6239 14.8291 27.3642 14.8239 28.0962 14.8187C28.3216 14.8187 28.5596 14.8124 28.7557 14.7012C28.9518 14.5901 29.0703 14.394 29.2559 14.2692C29.7341 13.9452 30.3695 14.222 30.9011 14.4475C31.5097 14.7065 32.1473 14.8909 32.8001 14.9969C33.5541 15.1186 34.5324 15.3377 35.085 14.8113C35.3849 14.5251 35.4751 14.1109 35.4552 13.6579C35.4384 14.0175 35.3335 14.3436 35.085 14.5827Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_63",
          d: "M19.4673 9.35443C19.4615 9.40665 19.4594 9.45921 19.461 9.51172C19.4715 9.72983 19.5543 9.94793 19.5805 10.1608C19.6193 9.8997 19.4987 9.62706 19.4673 9.35443Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_64",
          d: "M17.3361 16.7942C17.3448 16.8256 17.3514 16.8574 17.356 16.8896C17.373 16.7815 17.3662 16.6709 17.3361 16.5656C17.2736 16.4158 17.1978 16.2719 17.1096 16.1357C17.0308 15.9806 16.9841 15.8112 16.9723 15.6376C16.9509 15.8882 16.9984 16.1398 17.1096 16.3653C17.198 16.5011 17.2738 16.6447 17.3361 16.7942Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_65",
          d: "M18.6377 20.6719L18.0242 20.6625C18.0386 20.6995 18.0443 20.7394 18.041 20.7789C18.0378 20.8185 18.0256 20.8569 18.0054 20.8911C18.1784 20.8911 18.4657 20.8974 18.6345 20.9016C18.6639 20.7221 18.6741 20.54 18.6649 20.3584C18.6626 20.4634 18.6534 20.5681 18.6377 20.6719Z",
          fill: "black"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_66",
          d: "M17.6341 20.092C17.3835 20.0165 17.092 20.0155 16.9053 19.832C16.7955 19.7118 16.7335 19.5554 16.7313 19.3926C16.7155 19.6338 16.7313 19.8938 16.9053 20.0616C17.092 20.2451 17.3835 20.2462 17.6341 20.3217C17.7156 20.3454 17.7915 20.3855 17.8569 20.4396C17.9224 20.4937 17.9761 20.5606 18.0147 20.6362C18.1206 20.4192 17.8774 20.1644 17.6341 20.092Z",
          fill: "black"
        }
      )
    ] }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_67",
        opacity: "0.1",
        d: "M36.7113 67.2345C36.5939 67.1664 36.4743 67.1024 36.3527 67.0416C36.1021 66.9153 35.8452 66.8019 35.583 66.7018C34.3719 66.2405 33.0748 66.0727 31.7599 66.101C31.2356 66.3013 30.8948 66.4449 30.8948 66.4449L30.2279 66.6463L30.1167 66.6798C30.1094 66.6064 30.101 66.533 30.0937 66.4586C30.0863 66.3841 30.0779 66.3128 30.0695 66.2394C29.8347 64.0154 29.6501 61.7305 29.6501 61.7305V59.757V59.5274L29.6375 53.713L29.5327 51.7962L29.4834 50.9478L29.474 50.7864L29.4551 50.455L29.4446 50.2579C29.4214 50.1954 29.4018 50.1317 29.3859 50.067C29.3785 50.0408 29.3712 50.0115 29.3649 49.981C29.3387 49.8762 29.3104 49.7409 29.281 49.5941C29.0891 48.6294 28.849 47.003 28.8343 46.6727C28.8154 46.2323 28.4337 43.5983 28.4337 43.5983C28.395 42.1481 27.1754 39.4175 26.8682 38.9027C26.561 38.3878 26.2181 35.2945 26.3334 35.1278C26.3932 35.0386 26.432 34.5112 26.4561 34.0247C26.4561 33.9691 26.4614 33.9146 26.4635 33.8611C26.4792 33.4804 26.4865 33.1627 26.4865 33.1627L27.6861 32.9257L28.008 32.8628L28.0332 32.8576L28.0437 32.8785C28.0783 32.9425 28.1863 33.147 28.3132 33.4154C28.3278 33.4437 28.3415 33.4741 28.3562 33.5046C28.3624 33.5192 28.3698 33.5339 28.3771 33.5486C28.612 34.0624 28.8836 34.7387 28.8721 35.1278C28.8532 35.8156 29.6365 37.4766 29.6365 37.4766C29.712 37.8583 31.3729 41.6563 31.3729 41.6563C31.3729 41.6563 32.7288 45.3788 32.6522 45.9901C32.5757 46.6014 33.3013 50.6479 33.3013 50.6479L34.0458 54.8098C34.4076 55.6298 34.8847 57.5193 34.8847 57.5193L35.0661 58.591L35.1007 58.7955L35.5841 61.655L35.8211 63.0559C35.8211 63.0559 35.9207 63.8004 36.0717 64.6288C36.0843 64.7032 36.0989 64.7787 36.1136 64.8542C36.2066 65.3995 36.3388 65.9375 36.5089 66.4638C36.5933 66.716 36.6609 66.9734 36.7113 67.2345Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_68",
        d: "M36.8409 67.3089C36.7979 67.2837 36.7549 67.2585 36.7109 67.2344C36.5934 67.1663 36.4739 67.1023 36.3523 67.0415C36.1017 66.9152 35.8448 66.8018 35.5826 66.7017C34.3715 66.2404 33.0744 66.0726 31.7594 66.1009C31.2352 66.3012 30.8944 66.4448 30.8944 66.4448L30.2275 66.6462C30.2191 66.5728 30.2117 66.4994 30.2033 66.4249C30.1949 66.3505 30.1887 66.2907 30.1824 66.2236C29.9475 64.0048 29.7629 61.7304 29.7629 61.7304V59.7381V59.5084L29.7503 53.7087L29.6455 51.8778L29.6245 51.4982L29.6098 51.2413L29.591 50.9016L29.5721 50.5566L29.5585 50.3081V50.2536C29.5585 50.2483 29.5585 50.242 29.5511 50.2357C29.5312 50.1791 29.5071 50.0931 29.4809 49.9841L29.4683 49.9317C29.463 49.9075 29.4567 49.8813 29.4515 49.8551C29.2544 48.9607 28.965 47.0323 28.9492 46.6705C28.9304 46.2301 28.5487 43.5961 28.5487 43.5961C28.5099 42.1459 27.2904 39.4154 26.9831 38.9005C26.6759 38.3856 26.334 35.2923 26.4483 35.1256C26.5144 35.0207 26.5532 34.3842 26.5784 33.8589C26.5784 33.8169 26.5784 33.776 26.5784 33.7372C26.592 33.4132 26.5972 33.1605 26.5972 33.1605L27.7129 32.9403L27.9961 32.8847L28.0401 32.8763L28.145 32.8554C28.145 32.8554 28.2823 33.1091 28.447 33.4583L28.4679 33.5024C28.7081 34.0204 28.9922 34.725 28.9838 35.1256C28.965 35.8134 29.7483 37.4744 29.7483 37.4744C29.8237 37.8561 31.4847 41.6541 31.4847 41.6541C31.4847 41.6541 32.8405 45.3766 32.764 45.9879C32.6874 46.5992 33.4131 50.6457 33.4131 50.6457L34.1576 54.8076C34.5193 55.6276 34.9964 57.5172 34.9964 57.5172L35.1653 58.5154L35.1999 58.7178L35.5805 60.9743L35.9318 63.0537C35.9318 63.0537 36.0366 63.7951 36.1813 64.6266C36.195 64.7021 36.2086 64.7776 36.2233 64.8541C36.3162 65.4019 36.4483 65.9422 36.6186 66.4711C36.7116 66.745 36.7858 67.0249 36.8409 67.3089Z",
        fill: "#63667E"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_69",
        d: "M35.8952 13.4544C35.8952 13.4544 35.4947 13.9703 35.1329 13.9703C34.7711 13.9703 33.3629 13.9127 32.6289 13.6841C31.8948 13.4555 28.2961 13.2825 28.2961 13.2825C28.2961 13.2825 23.1999 13.3013 23.028 13.1294C22.856 12.9574 19.8591 12.0409 19.554 12.0986C19.49 12.1112 19.3338 12.1385 19.1251 12.1731L18.886 12.2119C18.5243 12.2695 18.0723 12.3366 17.6592 12.3859C17.1485 12.4457 16.6997 12.4761 16.5571 12.4237V11.9843C16.5571 11.9843 17.1485 11.1245 17.1863 10.878C17.224 10.6316 17.7211 7.05909 19.0192 5.78086C19.5555 4.75566 20.4234 3.94247 21.4813 3.47396C23.2377 2.70954 24.9941 2.06151 24.9941 2.06151L25.3013 2.01747L26.2922 1.87067C26.3224 1.84068 26.355 1.81332 26.3898 1.78888C26.6645 1.57916 27.4971 1.12302 28.5824 2.10345L28.7742 2.40964C28.7742 2.40964 32.114 3.19189 33.6596 5.92137C35.2052 8.65085 35.2828 11.3237 35.3971 12.5453C35.3971 12.5453 35.3206 12.8892 35.4737 13.0224C35.5291 13.0714 35.582 13.1232 35.632 13.1776C35.6457 13.1912 35.6593 13.2049 35.6719 13.2196C35.7159 13.2636 35.7568 13.3097 35.7904 13.3475C35.7944 13.3504 35.7979 13.354 35.8008 13.358C35.809 13.3679 35.8178 13.3773 35.8271 13.3863L35.8952 13.4544Z",
        fill: "#FED253"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_70",
        opacity: "0.05",
        d: "M35.8954 13.4545C35.8954 13.4545 35.4948 13.9704 35.1331 13.9704C34.7713 13.9704 33.363 13.9127 32.629 13.6842C31.895 13.4556 28.2962 13.2825 28.2962 13.2825C28.2962 13.2825 23.2001 13.3014 23.0281 13.1294C22.8562 12.9575 19.8593 12.041 19.5542 12.0987C19.4902 12.1113 19.334 12.1385 19.1253 12.1731L19.0708 11.8376L19.0571 11.7547C19.0571 11.7547 24.8411 10.5143 28.6968 11.1644C32.5525 11.8145 35.3973 12.538 35.3973 12.538C35.3973 12.538 35.3208 12.882 35.4738 13.0152C35.5293 13.0641 35.5821 13.1159 35.6322 13.1703C35.6458 13.184 35.6594 13.1976 35.672 13.2123C35.7161 13.2563 35.757 13.3025 35.7905 13.3402C35.7945 13.3432 35.7981 13.3467 35.801 13.3507C35.8092 13.3606 35.818 13.3701 35.8272 13.379L35.8954 13.4545Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_71",
        opacity: "0.1",
        d: "M35.3697 14.2934C34.6556 14.3489 33.3397 14.1749 32.764 14.0899C32.6004 14.0658 32.44 14.0365 32.2785 14.0008C31.6609 13.8666 29.7619 13.4901 28.6084 13.6642C27.2148 13.8739 23.2826 13.4922 23.2826 13.4922C23.2826 13.4922 20.8583 12.9963 19.8842 12.5957C19.5266 12.4478 18.9289 12.4017 18.3343 12.4751C18.1827 12.494 18.0322 12.521 17.8834 12.5558C17.0718 12.7477 16.3871 13.185 16.5056 13.9305C16.4602 13.8762 16.4182 13.8191 16.3798 13.7596C16.3284 13.078 16.5402 12.6722 16.8338 12.4332L16.903 12.4048C17.2617 12.3029 17.6267 12.2248 17.9956 12.171C18.0533 12.1616 18.1131 12.1532 18.1739 12.1458C19.2173 12.0053 20.7262 11.9739 21.9992 12.6146C21.9992 12.6146 23.182 13.1693 23.9841 13.1693C24.7863 13.1693 31.3138 13.2269 32.8416 13.6653C33.1457 13.7531 33.4559 13.8187 33.7696 13.8613C34.3266 13.9331 34.8926 13.8798 35.4264 13.7051C35.4373 13.9029 35.4182 14.1013 35.3697 14.2934Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_72",
        opacity: "0.1",
        d: "M35.8952 13.4546C35.8952 13.4546 35.4947 13.9705 35.1329 13.9705C34.7711 13.9705 33.3629 13.9128 32.6289 13.6842C31.8948 13.4556 28.2961 13.2826 28.2961 13.2826C28.2961 13.2826 23.1999 13.3015 23.028 13.1295C22.856 12.9575 19.8591 12.0411 19.554 12.0987C19.49 12.1113 19.3338 12.1386 19.1251 12.1732L18.886 12.212C18.4708 12.2098 18.0575 12.2685 17.6592 12.386C17.1485 12.4458 16.6997 12.4762 16.5571 12.4238V12.3368C16.6671 12.2729 16.7817 12.2176 16.9 12.1711C17.6076 11.9729 18.3362 11.8596 19.0706 11.8334C19.986 11.7999 21.0566 11.9068 21.9972 12.3808C21.9972 12.3808 23.18 12.9355 23.9822 12.9355C24.7844 12.9355 31.3118 12.9921 32.8396 13.4315C33.1439 13.5185 33.454 13.5837 33.7676 13.6265C34.4557 13.7132 35.1545 13.6129 35.7904 13.3361C35.7944 13.339 35.7979 13.3425 35.8008 13.3465C35.8091 13.3565 35.8178 13.3659 35.8271 13.3749L35.8952 13.4546Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_73",
        d: "M16.5207 13.9126C16.5207 13.9126 15.2414 12.9385 16.9023 12.2894C16.9023 12.2894 19.8038 11.3929 21.9995 12.4991C21.9995 12.4991 23.1823 13.0517 23.9845 13.0517C24.7867 13.0517 31.3142 13.1094 32.8419 13.5488C33.1462 13.6359 33.4563 13.7011 33.7699 13.7438C34.5828 13.8424 35.4061 13.6859 36.1261 13.2961C36.231 13.2384 36.3254 13.209 36.3537 13.2426C36.4491 13.3579 36.3736 14.0259 35.5337 14.159C34.8783 14.2639 33.3893 14.0657 32.7633 13.9745C32.6008 13.9504 32.4393 13.92 32.2789 13.8854C31.6612 13.7511 29.7622 13.3747 28.6035 13.5488C27.211 13.7585 23.2778 13.3768 23.2778 13.3768C23.2778 13.3768 20.8545 12.8808 19.8803 12.4792C18.9062 12.0776 16.1578 12.4236 16.5207 13.9126Z",
        fill: "#FED253"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_74",
        opacity: "0.1",
        d: "M27.3055 3.67739C27.2006 3.5264 25.8532 2.4474 25.3037 2.01119L26.2946 1.86438C26.3247 1.8344 26.3574 1.80703 26.3921 1.78259C27.1125 2.53863 27.3055 3.67739 27.3055 3.67739Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_75",
        opacity: "0.1",
        d: "M22.935 9.46456L22.4956 10.1136L24.1754 10.057L24.2132 9.33139L22.935 9.46456Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_76",
        opacity: "0.1",
        d: "M33.1846 10.2478L33.3754 10.8392L34.445 11.0112L33.9867 10.3045L33.1846 10.2478Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_77",
        opacity: "0.1",
        d: "M14.8218 30.1018C14.9361 30.2926 18.6963 35.2399 19.6893 35.1025C20.6823 34.9652 14.8218 30.1018 14.8218 30.1018Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_78",
        opacity: "0.1",
        d: "M27.4204 34.6235C27.4204 34.6235 28.3369 35.5022 28.2027 35.8451C28.0684 36.188 27.4204 34.6235 27.4204 34.6235Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_79",
        opacity: "0.1",
        d: "M17.4182 40.656C17.4182 40.656 16.616 44.4162 17.0365 44.5358C17.4569 44.6553 17.4182 40.656 17.4182 40.656Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_80",
        opacity: "0.1",
        d: "M27.7256 55.2586C27.8588 55.6403 28.9661 58.1223 29.2146 58.2555C29.4631 58.3886 27.7256 55.2586 27.7256 55.2586Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_81",
        opacity: "0.1",
        d: "M40.5922 45.0653C40.5534 45.1984 39.5992 45.9817 39.8089 46.268C40.0186 46.5543 40.5922 45.0653 40.5922 45.0653Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_82",
        opacity: "0.1",
        d: "M33.1846 52.032C33.1657 52.1285 32.9749 54.1292 33.3377 54.514C33.7005 54.8988 33.1846 52.032 33.1846 52.032Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_83",
        opacity: "0.1",
        d: "M42.9659 62.4256C42.6891 62.5798 42.4028 62.7287 42.1113 62.8713C41.7967 63.0244 41.4822 63.1701 41.1613 63.3075C41.0334 63.3631 40.9054 63.4176 40.7786 63.47C40.5856 63.5497 40.3948 63.6263 40.206 63.6997C39.6324 63.9241 39.0798 64.1191 38.588 64.2837C38.3972 64.3477 38.2147 64.4064 38.0449 64.4609C37.1892 64.7325 36.6209 64.8804 36.6209 64.8804C36.4911 64.8526 36.3582 64.8416 36.2256 64.8479C36.1889 64.8479 36.1511 64.8479 36.1123 64.8479C35.9347 64.8607 35.758 64.8831 35.5828 64.915C34.4115 65.1247 32.7568 65.7129 31.7596 66.0978C31.2353 66.2981 30.8945 66.4417 30.8945 66.4417L30.2276 66.643L30.1165 66.6766C29.394 66.8968 28.3779 67.2093 28.012 67.3393C27.4206 67.549 22.2856 68.6175 22.2856 68.6175C21.8165 68.7456 21.3373 68.8333 20.8533 68.8797C19.6604 68.9891 18.4615 69.0165 17.265 68.9615C16.0633 69.0391 14.1192 68.7748 12.9878 68.5966L12.8074 68.5683C12.3702 68.497 12.0923 68.4456 12.0923 68.4456L12.2391 68.2432L15.2496 64.0897L15.2674 64.0646L18.0724 60.1963L18.1773 60.0558L18.4321 59.7045C18.4321 59.7045 18.5852 59.4948 19.1745 59.4812C19.2437 59.4812 19.3192 59.4812 19.402 59.4812C19.897 59.521 20.3854 59.6206 20.8564 59.7779L20.9927 59.8188C23.0238 60.4008 26.1633 60.255 26.1633 60.255C26.1633 60.255 28.1168 59.9405 29.652 59.7517L29.7663 59.737C30.2679 59.6662 30.773 59.6224 31.2794 59.606C32.2147 59.6248 34.2385 59.1289 34.2385 59.1289C34.6737 59.0355 34.8572 58.9569 35.1025 58.7818C35.135 58.7587 35.1696 58.7335 35.2074 58.7063C35.3123 58.6276 35.4328 58.5312 35.588 58.4116C35.8712 58.1946 36.2686 57.8999 36.8935 57.4868C36.9481 57.4511 37.0057 57.4155 37.0676 57.3819C37.1295 57.3483 37.2081 57.3033 37.2836 57.2655C37.8888 56.9789 38.527 56.7676 39.1836 56.6364C39.7284 56.5193 40.2811 56.4432 40.8373 56.4088H40.9201C42.493 56.3249 44.0994 56.5944 45.039 57.4784C45.2033 57.6337 45.3464 57.81 45.4647 58.0027C45.5221 58.0942 45.5733 58.1895 45.6178 58.2879C45.7035 58.4756 45.7672 58.6727 45.8076 58.8751C45.8153 58.9128 45.8216 58.9506 45.8265 58.9883C45.8265 58.9999 45.8265 59.0104 45.8265 59.0219C45.8265 59.0523 45.8328 59.0827 45.8349 59.1131C45.9187 60.3683 44.6164 61.5029 42.9659 62.4256Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_84",
        d: "M12.0923 68.2203C12.0923 68.2203 15.4897 68.8494 17.265 68.7351C17.265 68.7351 20.5292 68.9071 22.2856 68.3922C22.2856 68.3922 27.4237 67.3227 28.012 67.1129C28.6002 66.9032 30.8945 66.2154 30.8945 66.2154C30.8945 66.2154 35.3615 64.3447 36.6209 64.6498C36.6209 64.6498 46.5091 62.0923 45.8023 58.6372C45.0956 55.1821 38.8544 55.9654 36.8893 57.2625C34.9243 58.5596 35.2116 58.6949 34.2364 58.9046C34.2364 58.9046 32.2126 59.4006 31.2773 59.3817C30.3419 59.3628 26.1612 60.0308 26.1612 60.0308C26.1612 60.0308 22.8781 60.1839 20.8553 59.5537C18.8326 58.9235 18.431 59.4771 18.431 59.4771L12.0923 68.2203Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_85",
        opacity: "0.1",
        d: "M19.4599 59.2527C19.4604 59.2569 19.4604 59.2611 19.4599 59.2653C19.4526 59.3433 19.4324 59.4194 19.4001 59.4908C18.9975 60.4785 16.7115 63.143 16.7115 63.143C16.6073 63.4595 16.4816 63.7685 16.3351 64.0679C16.0201 64.7077 15.6573 65.3229 15.2498 65.9081C14.6457 66.7837 13.9862 67.6198 13.2753 68.4111H13.2701C13.1796 68.4782 13.0854 68.5402 12.988 68.5967C12.7416 68.7435 12.3714 68.9249 12.0223 68.9469C11.9628 68.9505 11.9031 68.9487 11.844 68.9417C11.8807 68.9417 11.9163 68.9333 11.9489 68.927L11.8209 68.8893L11.6458 68.8347C11.3522 68.7425 11.061 68.6415 10.7723 68.5317L10.5972 68.4646C10.3176 68.3569 10.0439 68.2412 9.77617 68.1175L9.60106 68.0378C9.32144 67.9078 9.04775 67.7704 8.78001 67.6257C8.68354 67.5754 8.58812 67.5209 8.49375 67.4695C8.20853 67.3101 7.92891 67.143 7.65488 66.9683C7.36407 66.783 7.07955 66.5897 6.80133 66.3884C6.59161 65.9994 6.41859 65.6544 6.32422 65.4688C6.15225 65.1238 6.13757 64.6299 6.15854 64.2723C6.15854 64.2356 6.15854 64.201 6.16483 64.1675C6.18266 63.9431 6.20992 63.7889 6.20992 63.7889C6.05455 63.5812 5.91437 63.3625 5.79049 63.1346C5.71931 63.0215 5.67884 62.8917 5.67304 62.7582C5.67779 62.7046 5.67281 62.6506 5.65836 62.5988C5.57762 62.2674 5.23054 61.698 4.90967 61.3405C4.67059 61.0773 4.65591 60.0937 4.67898 59.3964C4.69261 58.977 4.71883 58.6687 4.71883 58.6687C4.67184 58.6383 4.63668 58.5928 4.61921 58.5397C4.5349 58.3102 4.47788 58.0716 4.44934 57.8287C4.44934 57.7941 4.4399 57.7595 4.43466 57.7239C4.36755 57.2426 4.33714 56.7592 4.33714 56.7592C3.56119 56.194 3.19208 55.3121 3.02011 54.5257L2.99809 54.4208C2.90365 53.9375 2.86355 53.4451 2.87855 52.9528C2.87855 52.9056 2.87855 52.87 2.87855 52.8479C2.87855 52.8259 2.87855 52.8217 2.87855 52.8217C2.87855 52.8217 2.98131 50.5494 3.26863 49.6623C3.28016 49.6246 3.29275 49.59 3.30533 49.5575C3.3265 49.5018 3.35394 49.4486 3.38712 49.3991C3.49198 49.2597 3.56643 48.9965 3.62829 48.685C3.67129 48.469 3.70694 48.2289 3.73315 47.9898C3.75727 47.7906 3.77615 47.5924 3.79083 47.4089C3.83172 46.9182 3.8443 46.5354 3.8443 46.5354L3.65031 45.5791C3.59684 45.318 3.55594 45.0548 3.52763 44.7916C3.52763 44.757 3.51924 44.7224 3.51505 44.6868C3.466 44.2007 3.45724 43.7115 3.48883 43.224C3.48883 43.1883 3.48883 43.1537 3.49512 43.1191C3.577 42.0088 3.86728 40.9238 4.35077 39.9209L4.4032 39.8161C4.47311 39.6763 4.54651 39.5389 4.62341 39.404C4.67898 39.3044 4.7377 39.2058 4.79852 39.1083C4.95975 38.8471 5.13476 38.5948 5.32281 38.3522C5.35008 38.3166 5.37839 38.282 5.4067 38.2474C5.7339 37.8417 6.09753 37.4669 6.49304 37.1275C7.55212 36.2173 8.52416 35.822 9.40707 35.7916C13.268 35.6553 15.4333 42.4837 15.7835 43.6801C15.8171 43.7955 15.8339 43.8584 15.8339 43.8584C15.8339 43.8584 17.3984 45.4239 16.9401 46.1108C16.8513 46.262 16.7972 46.431 16.7818 46.6057C16.656 47.5295 17.0167 49.051 17.0167 49.051C17.0167 49.051 17.1446 49.4704 17.5179 50.475L17.628 50.7686C17.8618 51.3978 17.9164 52.4537 17.7822 53.3995C17.6532 54.3055 17.3501 55.1066 16.8646 55.3121C15.8716 55.7316 16.139 56.151 16.3676 56.496C16.5034 56.7433 16.6168 57.0023 16.7063 57.2699C16.85 57.6568 16.9831 58.0636 17.0335 58.222C17.0481 58.266 17.0555 58.2901 17.0555 58.2901C17.1946 58.2363 17.3391 58.1976 17.4865 58.1748C17.6741 58.1486 17.8598 58.1674 17.8954 58.3279C17.9143 58.4139 18.0223 58.5156 18.1743 58.6173C18.6252 58.9277 19.4599 59.2527 19.4599 59.2527Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_86",
        d: "M19.2312 59.2527C19.2248 59.3325 19.2046 59.4105 19.1715 59.4834C18.7709 60.4722 16.4829 63.1429 16.4829 63.1429C16.3782 63.4593 16.2525 63.7683 16.1065 64.0678C15.8534 64.5845 15.5672 65.0843 15.2498 65.5641C14.5924 66.5557 13.8642 67.4984 13.0708 68.3849L13.0467 68.4111C13.0467 68.4111 12.9544 68.4813 12.8076 68.5715C12.5453 68.7389 12.2562 68.8602 11.953 68.9301L11.8251 68.8924L11.6499 68.8378C11.3563 68.7456 11.0652 68.6446 10.7765 68.5348L10.6014 68.4677C10.3217 68.36 10.0481 68.2443 9.78031 68.1206L9.6052 68.0409C9.32557 67.9109 9.05189 67.7735 8.78415 67.6288C8.68768 67.5785 8.59226 67.524 8.49789 67.4726C8.21267 67.3132 7.93305 67.1461 7.65902 66.9713C7.36821 66.7861 7.08369 66.5928 6.80546 66.3915C6.67684 66.2992 6.54961 66.2045 6.42378 66.1073C6.28222 65.8389 6.16897 65.6124 6.09871 65.4719C5.92675 65.1269 5.91207 64.633 5.93304 64.2754C5.93304 64.2387 5.93304 64.2041 5.93933 64.1706C5.95716 63.9462 5.98442 63.792 5.98442 63.792C5.98442 63.792 5.89948 63.6777 5.79672 63.5225C5.73905 63.4366 5.67718 63.3369 5.62161 63.2384C5.51675 63.0538 5.43496 62.8672 5.45069 62.7613C5.45281 62.7432 5.45281 62.7249 5.45069 62.7067C5.44911 62.6713 5.44384 62.6362 5.43496 62.6019C5.35422 62.2705 5.00608 61.7011 4.68522 61.3436C4.44614 61.0804 4.43146 60.0968 4.45348 59.3995C4.45348 59.3638 4.45348 59.3292 4.45348 59.2946C4.46816 58.9329 4.49018 58.6718 4.49018 58.6718C4.37169 58.6204 4.28046 58.2397 4.22174 57.8329L4.20601 57.728C4.1389 57.2467 4.10849 56.7633 4.10849 56.7633C3.33254 56.1981 2.96343 55.3163 2.79251 54.5298C2.67344 53.979 2.6276 53.4149 2.6562 52.8521C2.6562 52.8353 2.6562 52.8259 2.6562 52.8259C2.6562 52.8259 2.74637 50.5421 3.03369 49.6539C3.04522 49.6161 3.05781 49.5815 3.07039 49.549C3.09555 49.4946 3.12686 49.4432 3.16371 49.3959C3.3231 49.1736 3.42901 48.6389 3.49821 48.0915L3.5108 47.9866C3.59783 47.2526 3.62195 46.5322 3.62195 46.5322L3.42691 45.5759C3.37378 45.3138 3.33289 45.0513 3.30422 44.7884C3.29898 44.7538 3.29584 44.7182 3.29164 44.6836C3.24261 44.1975 3.23384 43.7083 3.26543 43.2208C3.26543 43.1851 3.26543 43.1505 3.27277 43.1159C3.35414 42.0055 3.64445 40.9204 4.12841 39.9177C4.14519 39.8821 4.16197 39.8475 4.18084 39.8129C4.31567 39.5405 4.4655 39.2759 4.62964 39.0201C4.68627 38.931 4.74394 38.8429 4.80476 38.7559C4.90018 38.6175 4.99979 38.4812 5.1036 38.3491L5.18749 38.2442C5.51189 37.8401 5.87234 37.4663 6.26439 37.1274C7.41784 36.1386 8.46643 35.7569 9.41016 35.7915C13.1274 35.9247 15.2141 42.5078 15.557 43.6801C15.5905 43.7954 15.6073 43.8583 15.6073 43.8583C15.6073 43.8583 17.1729 45.4239 16.7146 46.1107C16.6258 46.2619 16.5717 46.431 16.5563 46.6056C16.4294 47.5295 16.7912 49.051 16.7912 49.051C16.7912 49.051 16.9191 49.4704 17.2924 50.4749C17.326 50.5683 17.3627 50.6658 17.3973 50.7685C17.6311 51.3977 17.6856 52.4536 17.5514 53.3995C17.4224 54.3065 17.1204 55.1066 16.6339 55.3121C15.6419 55.7315 15.9083 56.151 16.1379 56.4959C16.2737 56.7432 16.3871 57.0022 16.4766 57.2698C16.658 57.7637 16.8247 58.2901 16.8247 58.2901C16.8934 58.2636 16.9634 58.2408 17.0345 58.2219C17.1803 58.1739 17.3348 58.1579 17.4874 58.1747C17.5297 58.178 17.5698 58.1946 17.602 58.2221C17.6342 58.2496 17.6569 58.2866 17.6668 58.3278C17.6951 58.4537 17.9121 58.6099 18.1753 58.7578C18.5171 58.9437 18.8697 59.109 19.2312 59.2527Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_87",
        opacity: "0.1",
        d: "M5.42969 49.1694C5.7925 49.1506 9.68696 47.6427 10.4891 48.1576C11.2913 48.6724 16.2564 52.0132 16.2564 52.0132C16.2564 52.0132 13.1452 47.9478 10.4346 46.9936C7.724 46.0394 5.42969 49.1694 5.42969 49.1694Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_88",
        opacity: "0.1",
        d: "M11.0278 55.3163C11.0278 55.3163 14.9223 56.0985 15.5137 56.6333L11.0278 55.3163Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_89",
        opacity: "0.1",
        d: "M10.2782 61.1402C10.2216 61.1978 8.81021 64.3656 8.92346 64.3656C9.0367 64.3656 10.2405 62.4782 10.2405 62.4782L10.2782 61.1402Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_90",
        opacity: "0.1",
        d: "M12.9323 57.339C12.9323 57.339 11.7873 57.7406 11.9204 57.7784C12.0536 57.8161 12.8935 57.511 12.9323 57.339Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_91",
        opacity: "0.1",
        d: "M11.7871 62.131C11.978 62.5316 12.5882 63.7343 12.7225 63.5435C12.8567 63.3526 11.7871 62.131 11.7871 62.131Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_92",
        opacity: "0.1",
        d: "M26.0816 30.3818L25.9181 30.6146C25.9181 30.6146 24.6189 29.6992 24.0851 29.2409C23.5514 28.7827 22.291 30.882 21.298 31.4545C20.305 32.027 18.6262 32.1801 18.6262 32.1801C18.6262 32.1801 17.328 30.882 17.3679 30.5024C17.4077 30.1228 16.7576 30.0064 16.7188 29.739C16.68 29.4716 16.4514 28.7083 16.1463 28.3266C15.9848 28.1252 15.9617 27.495 15.9764 26.9466C16.0813 26.9257 16.1463 26.9141 16.1463 26.9141C16.3092 26.618 16.5153 26.3476 16.7576 26.112C17.1015 25.8068 17.6353 23.9361 17.6353 23.9361C17.9404 22.9054 18.5507 23.2105 18.5507 23.2105C18.5507 24.776 20.155 25.3486 20.9561 25.9977C21.7573 26.6467 23.0177 28.3266 24.0107 28.6705C24.8254 28.9484 25.7786 30.0232 26.0816 30.3818Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_93",
        d: "M26.0815 30.1521L25.9179 30.3859C25.9179 30.3859 24.6135 29.4726 24.0798 29.0112C23.546 28.5499 22.2856 30.6523 21.2926 31.2248C20.2996 31.7973 18.6208 31.9515 18.6208 31.9515C18.6208 31.9515 17.3227 30.6523 17.3625 30.2738C17.4023 29.8952 16.7522 29.7778 16.7134 29.5093C16.6746 29.2409 16.446 28.4786 16.1409 28.0969C15.9794 27.8955 15.9563 27.2653 15.971 26.7169L16.1409 26.6855C16.3039 26.3893 16.5099 26.119 16.7522 25.8833C17.0962 25.5771 17.6299 23.7075 17.6299 23.7075C17.935 22.6767 18.5453 22.9808 18.5453 22.9808C18.5453 24.5464 20.1497 25.1199 20.9508 25.769C21.7519 26.4181 23.0123 28.0969 24.0053 28.4408C24.8253 28.7229 25.7785 29.7935 26.0815 30.1521Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_94",
        opacity: "0.1",
        d: "M26.1793 30.4627C26.1793 30.4627 25.0542 31.0729 24.1755 31.1306C24.0605 31.136 23.9452 31.1293 23.8315 31.1107C23.8315 31.1107 24.8015 30.3861 25.7022 30.2383L26.1793 30.4627Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_95",
        opacity: "0.1",
        d: "M28.4705 33.5736C28.4705 33.5736 27.0517 33.021 26.583 33.8526C26.5987 33.4709 26.605 33.1542 26.605 33.1542L28.1517 32.848C28.1517 32.848 28.3006 33.1238 28.4747 33.495C28.4705 33.5443 28.4705 33.5736 28.4705 33.5736Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_96",
        d: "M23.8315 31.1107C23.8315 31.1107 25.5313 30.0904 26.3482 30.1764C27.2049 30.2655 28.8648 30.3284 28.8648 30.3284C28.8648 30.3284 28.2922 31.6266 28.3688 31.894C28.4453 32.1614 28.4642 33.4595 28.4642 33.4595C28.4642 33.4595 26.7466 32.7916 26.4604 34.032C26.4604 34.032 25.525 32.6385 24.8948 32.218C24.4766 31.9159 24.1164 31.5407 23.8315 31.1107Z",
        fill: "#63667E"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_97",
        opacity: "0.1",
        d: "M33.4333 32.2954C32.9373 32.2954 31.181 31.187 30.7993 30.4625C30.4176 29.7379 29.8828 30.538 29.3868 30.8064C29.0722 30.9784 27.8255 30.6187 27.1533 30.3576C27.4941 30.1259 28.2491 29.4737 28.4703 29.3174C28.7367 29.1255 29.0051 26.0332 29.0051 26.0332C29.9593 25.5372 30.9901 30.042 30.9901 30.042C30.9901 30.042 32.7853 30.5768 32.9373 30.9585C32.9667 31.034 33.102 31.1682 33.3054 31.3307C33.5151 31.8592 33.6305 32.2954 33.4333 32.2954Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_98",
        d: "M33.4334 32.0659C32.9374 32.0659 31.181 30.9586 30.7994 30.234C30.4177 29.5094 29.8829 30.3095 29.3869 30.5769C29.0723 30.7489 28.073 30.4165 27.4009 30.1574C27.7417 29.9268 28.2492 29.2473 28.4704 29.09C28.7368 28.8991 29.0052 25.8069 29.0052 25.8069C29.9594 25.3109 30.9902 29.8156 30.9902 29.8156C30.9902 29.8156 32.7854 30.3504 32.9374 30.7321C32.9668 30.8076 33.1021 30.9418 33.3055 31.1043C33.5152 31.6297 33.6305 32.0659 33.4334 32.0659Z",
        fill: "#CED7E7"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_99",
        d: "M40.2167 65.5128L56.8169 51.6714C56.9826 51.5315 57.1936 51.4569 57.4104 51.4617L63.6034 51.6242C63.6034 51.6242 64.0323 51.9388 63.4031 52.6267L47.7435 65.4771C47.5743 65.6155 47.3642 65.6943 47.1458 65.7015L40.374 65.9259C40.3254 65.9274 40.2775 65.9138 40.237 65.8868C40.1965 65.8598 40.1654 65.8209 40.1481 65.7754C40.1308 65.7299 40.1281 65.6802 40.1404 65.6331C40.1527 65.586 40.1794 65.544 40.2167 65.5128Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_100",
        d: "M48.2466 63.8099C48.2466 63.8099 51.8726 69.0025 55.9013 64.1727C59.93 59.3429 58.765 56.8054 57.5434 56.6711C56.3218 56.5369 49.4483 61.825 48.2466 63.8099Z",
        fill: "#FFEDED"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_101",
        opacity: "0.1",
        d: "M72.7031 5.73266C72.7031 5.73266 77.3767 -3.33764 82.9007 1.34012C82.9007 1.34012 84.1065 1.77948 84.0153 3.05456C84.0153 3.05456 83.5508 2.79975 83.1817 3.77389C83.0461 4.11955 82.8701 4.44794 82.6574 4.75223C82.3746 5.16329 81.9662 5.47161 81.4935 5.63095C81.4935 5.63095 79.0146 7.488 74.4228 6.05562C74.4228 6.05562 73.1247 6.24227 72.9149 6.08079L74.4239 4.97768C74.4239 4.97768 75.1904 6.11539 76.3113 6.24542C76.3113 6.24542 74.4239 5.06051 74.6399 4.80361C74.6839 4.75118 75.4662 4.2552 75.4662 4.2552C75.4662 4.2552 76.8073 6.22759 78.5459 6.37335C78.5459 6.37335 76.11 5.26289 75.7608 4.06645L76.9845 3.38382C76.9845 3.38382 78.2994 5.53867 80.2739 5.77985C80.2739 5.77985 77.7678 4.53098 77.2624 3.25275L78.5574 2.74732C78.5574 2.74732 79.8818 4.82353 81.5249 5.01333C81.5249 5.01333 78.7755 3.27791 78.8615 2.65085C78.8615 2.65085 80.0789 2.25868 80.4522 2.31006C80.4522 2.31006 81.4368 3.77809 82.4015 3.8043C82.4015 3.8043 80.6871 2.44953 80.8003 2.24086C80.8003 2.24086 82.5221 2.15173 83.4218 2.56802C83.4218 2.56802 82.1425 1.85602 80.8003 1.97137C80.8003 1.97137 81.4075 1.25728 82.1992 1.09999C82.1992 1.09999 81.2502 0.709916 80.383 1.99758C80.383 1.99758 79.0439 2.12027 78.8783 2.26917C78.8783 2.26917 79.5557 0.876641 80.3893 0.284188C80.3893 0.284188 79.1467 0.503344 78.5312 2.39081L77.2184 2.87001C77.2184 2.87001 78.0163 0.982549 78.7199 0.399533C78.7199 0.399533 77.4868 0.818969 76.8975 3.02101L75.6895 3.67742C75.6895 3.67742 76.2526 1.99968 76.8954 1.18073C76.8954 1.18073 75.8353 1.81618 75.3498 3.87771L74.5948 4.40934C74.5948 4.40934 75.0279 3.19088 75.1841 2.85218C75.3403 2.51349 75.2617 2.44323 75.2617 2.44323C74.7369 3.0637 74.3946 3.81766 74.2729 4.62115C74.2729 4.62115 72.7902 5.81655 72.7031 5.73266Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_102",
        opacity: "0.1",
        d: "M92.0317 10.5834C92.0317 10.5834 94.1436 6.48447 96.6392 8.59843C96.6392 8.59843 97.1845 8.79661 97.1426 9.37229C97.1426 9.37229 96.9328 9.25799 96.7661 9.6984C96.7057 9.85439 96.6269 10.0026 96.5312 10.1399C96.4036 10.3251 96.2198 10.4645 96.0069 10.5373C96.0069 10.5373 94.886 11.3761 92.8108 10.7292C92.8108 10.7292 92.2247 10.8131 92.1303 10.7407L92.8119 10.2416C92.8119 10.2416 93.1579 10.7564 93.6654 10.8141C93.6654 10.8141 92.814 10.2793 92.9105 10.1629C92.9293 10.1399 93.2827 9.91546 93.2827 9.91546C93.2827 9.91546 93.8888 10.8068 94.6752 10.8728C94.6752 10.8728 93.5742 10.3705 93.4169 9.82423L93.9706 9.51699C93.9706 9.51699 94.5641 10.4911 95.4564 10.6002C95.4564 10.6002 94.324 10.036 94.0933 9.45827L94.6784 9.22968C94.6784 9.22968 95.2761 10.1682 96.0185 10.2542C96.0185 10.2542 94.7759 9.46981 94.8157 9.18669C94.8157 9.18669 95.3652 9.00948 95.534 9.03255C95.534 9.03255 95.9786 9.6963 96.4148 9.70679C96.4148 9.70679 95.6399 9.09546 95.6913 9.00109C95.6913 9.00109 96.4694 8.96124 96.8741 9.14894C96.8741 9.14894 96.2964 8.82702 95.6913 8.87945C95.8582 8.68962 96.0769 8.55261 96.3205 8.48518C96.3205 8.48518 95.8916 8.30902 95.4994 8.89099C95.4994 8.89099 94.8944 8.94656 94.8199 9.01367C94.8199 9.01367 95.1261 8.38452 95.5026 8.11713C95.5026 8.11713 94.9405 8.21569 94.6637 9.06925L94.0765 9.28945C94.0765 9.28945 94.4362 8.43695 94.7549 8.1727C94.7549 8.1727 94.1971 8.3625 93.9307 9.35656L93.3855 9.65226C93.3855 9.65226 93.6392 8.89308 93.9297 8.52398C93.9297 8.52398 93.4505 8.81129 93.2324 9.74244L92.8905 9.98257C92.8905 9.98257 93.0866 9.43206 93.1569 9.27896C93.2271 9.12587 93.1915 9.09441 93.1915 9.09441C92.9543 9.37576 92.7997 9.71729 92.7448 10.0811C92.7448 10.0811 92.0684 10.6212 92.0317 10.5834Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_103",
        opacity: "0.1",
        d: "M69.1479 15.3523C69.1479 15.3523 71.2598 11.2534 73.7617 13.3673C73.7617 13.3673 74.306 13.5655 74.2651 14.1423C74.2651 14.1423 74.0553 14.0269 73.8886 14.4673C73.8278 14.6231 73.749 14.7713 73.6537 14.9088C73.5248 15.095 73.339 15.2344 73.1242 15.3062C73.1242 15.3062 72.0043 16.1451 69.9291 15.4981C69.9291 15.4981 69.343 15.583 69.2486 15.5096L69.9302 15.0105C69.9302 15.0105 70.2762 15.5253 70.7827 15.5841C70.7827 15.5841 69.9312 15.0482 70.0277 14.9318C70.0476 14.9088 70.401 14.6844 70.401 14.6844C70.401 14.6844 71.0071 15.5757 71.7925 15.6417C71.7925 15.6417 70.6925 15.1395 70.5342 14.5932L71.0878 14.287C71.0878 14.287 71.6824 15.2601 72.5747 15.3691C72.5747 15.3691 71.4423 14.805 71.2116 14.2272L71.7967 13.9986C71.7967 13.9986 72.3954 14.9371 73.1378 15.0231C73.1378 15.0231 71.8953 14.2387 71.9341 13.9556C71.9341 13.9556 72.4846 13.7784 72.6534 13.8015C72.6534 13.8015 73.098 14.4652 73.5342 14.4768C73.5342 14.4768 72.7593 13.8644 72.8107 13.77C72.8107 13.77 73.5877 13.7302 73.9935 13.9179C73.9935 13.9179 73.4147 13.5959 72.8096 13.6484C72.9765 13.4585 73.1952 13.3215 73.4388 13.2541C73.4388 13.2541 73.011 13.0779 72.6188 13.6599C72.6188 13.6599 72.0137 13.7155 71.9393 13.7826C71.9393 13.7826 72.2444 13.1534 72.6219 12.886C72.6219 12.886 72.0599 12.9846 71.7831 13.8382L71.1885 14.0584C71.1885 14.0584 71.5492 13.2059 71.8669 12.9427C71.8669 12.9427 71.3101 13.1314 71.0438 14.1255L70.4975 14.4212C70.4975 14.4212 70.7523 13.662 71.0428 13.2929C71.0428 13.2929 70.5635 13.5802 70.3444 14.5114L70.0025 14.7515C70.0025 14.7515 70.1986 14.201 70.2689 14.0479C70.3391 13.8948 70.3045 13.8633 70.3045 13.8633C70.0669 14.1444 69.9122 14.486 69.8578 14.8501C69.8578 14.8501 69.1846 15.3901 69.1479 15.3523Z",
        fill: "#3FC1A3"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1466", children: /* @__PURE__ */ u("rect", { width: "112.444", height: "81.8047", fill: "white" }) }) })
] }), Yz = (e) => /* @__PURE__ */ T("svg", { width: "157", height: "82", viewBox: "0 0 157 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "Illustration", clipPath: "url(#clip0_35_811)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M37.6492 79.756L33.7955 73.6402L37.651 80.4222L37.6531 81.1191C37.928 81.1159 38.2002 81.1053 38.4695 81.0875L38.1552 72.1356L38.1593 72.0664L38.1523 72.0532L38.1223 71.2073L42.1518 64.5044L38.1182 70.5738L38.1061 70.753L37.8687 63.9895L41.3327 57.0545L37.8416 62.801L37.6792 48.7822L37.6784 48.7355L37.6779 48.7814L37.5988 59.8343L34.2887 55.4119L37.6017 60.7863L37.6171 66.8401L34.5458 60.9934L37.6188 67.7301L37.6273 71.0963L33.166 62.9555L37.6308 72.2706L37.6492 79.756Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M70.7195 79.756L66.8658 73.6402L70.7213 80.4222L70.7234 81.1191C70.9983 81.1159 71.2705 81.1053 71.5399 81.0875L71.2255 72.1356L71.2297 72.0664L71.2226 72.0532L71.1926 71.2073L75.2221 64.5044L71.1885 70.5738L71.1764 70.753L70.939 63.9895L74.403 57.0545L70.9119 62.801L70.7495 48.7822L70.7488 48.7355L70.7482 48.7814L70.6691 59.8343L67.3591 55.4119L70.6721 60.7863L70.6874 66.8401L67.6162 60.9933L70.6891 67.7301L70.6976 71.0963L66.2363 62.9555L70.7011 72.2706L70.7195 79.756Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        d: "M4.54735 80.1493L1.76457 75.7332L4.54864 80.6304L4.55013 81.1336C4.74866 81.1313 4.94518 81.1237 5.1397 81.1108L4.91273 74.6467L4.91571 74.5967L4.9106 74.5872L4.88899 73.9764L7.79863 69.1363L4.88599 73.5189L4.87727 73.6483L4.70582 68.7644L7.20718 63.7567L4.68627 67.9062L4.56901 57.7833L4.56847 57.7496L4.56807 57.7828L4.51097 65.764L2.12079 62.5706L4.51309 66.4514L4.52419 70.8228L2.30644 66.6009L4.52541 71.4655L4.53155 73.8962L1.31006 68.0178L4.53407 74.7442L4.54735 80.1493Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M151.149 79.756L147.295 73.6402L151.151 80.4222L151.153 81.1191C151.428 81.1159 151.7 81.1053 151.97 81.0875L151.655 72.1356L151.659 72.0664L151.652 72.0532L151.622 71.2073L155.652 64.5044L151.618 70.5738L151.606 70.753L151.369 63.9895L154.833 57.0545L151.342 62.801L151.179 48.7822L151.178 48.7355L151.178 48.7814L151.099 59.8343L147.789 55.4119L151.102 60.7863L151.117 66.8401L148.046 60.9934L151.119 67.7301L151.127 71.0963L146.666 62.9555L151.131 72.2706L151.149 79.756Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_5", d: "M46.6363 70.5225H67.425V69.6416H46.6363V70.5225Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_6", d: "M45.5791 69.6416H66.3679V68.7607H45.5791V69.6416Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_7", d: "M46.8125 68.7607H67.6013V67.8799H46.8125V68.7607Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_8", d: "M48.9265 67.8799H69.7153V66.999H48.9265V67.8799Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_9", d: "M31.2384 68.231H31.9602V63.1063H31.2384V68.231Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M31.2368 63.0413L31.5083 63.7101L58.2182 52.869L57.9467 52.2002L31.2368 63.0413Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_11", d: "M17.8852 75.882H24.1648V73.4279H17.8852V75.882Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u("path", { id: "Vector_12", d: "M18.4628 78.336H49.4275V75.5932H18.4628V78.336Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u("path", { id: "Vector_13", d: "M23.5513 76.9647H30.9857V67.6175H25.4279L23.5513 72.3318V76.9647Z", fill: "#E2E2E2" }),
    /* @__PURE__ */ u("path", { id: "Vector_14", d: "M26.6549 71.3709H29.8308V68.195H26.6549V71.3709Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_15", d: "M24.2729 71.407H26.294V68.2312H25.4278L24.2729 71.407Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_16", d: "M28.9647 74.5466H29.6865V73.1752H28.9647V74.5466Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_17",
        d: "M25.6807 71.6233H25.6446C25.4627 71.6233 25.2883 71.5511 25.1597 71.4225C25.0311 71.2939 24.9589 71.1195 24.9589 70.9376C24.9589 70.7558 25.0311 70.5814 25.1597 70.4528C25.2883 70.3242 25.4627 70.2519 25.6446 70.2519H25.6807V71.6233Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_18",
        d: "M52.531 76.9646H52.4949C52.3131 76.9646 52.1386 76.8923 52.0101 76.7638C51.8815 76.6352 51.8092 76.4608 51.8092 76.2789C51.8092 76.097 51.8815 75.9226 52.0101 75.794C52.1386 75.6654 52.3131 75.5932 52.4949 75.5932H52.531V76.9646Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_19",
        d: "M20.6642 75.583C20.1274 75.5898 19.5991 75.7176 19.1185 75.9569C18.6379 76.1961 18.2175 76.5406 17.8884 76.9647H16.4778L17.8492 73.1446L24.237 71.8847L24.0566 76.9647H23.4399C23.1109 76.5406 22.6904 76.1961 22.2098 75.9569C21.7293 75.7176 21.2009 75.5898 20.6642 75.583Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_20",
        d: "M20.5919 81.0066C22.326 81.0066 23.7317 79.6009 23.7317 77.8668C23.7317 76.1328 22.326 74.727 20.5919 74.727C18.8579 74.727 17.4521 76.1328 17.4521 77.8668C17.4521 79.6009 18.8579 81.0066 20.5919 81.0066Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_21",
        d: "M20.592 79.5195C21.5046 79.5195 22.2445 78.7796 22.2445 77.8669C22.2445 76.9543 21.5046 76.2144 20.592 76.2144C19.6793 76.2144 18.9395 76.9543 18.9395 77.8669C18.9395 78.7796 19.6793 79.5195 20.592 79.5195Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M48.9584 80.9705C50.4732 80.9705 51.7012 79.7426 51.7012 78.2278C51.7012 76.7129 50.4732 75.485 48.9584 75.485C47.4436 75.485 46.2156 76.7129 46.2156 78.2278C46.2156 79.7426 47.4436 80.9705 48.9584 80.9705Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_23",
        d: "M48.9582 79.6713C49.7555 79.6713 50.4018 79.025 50.4018 78.2277C50.4018 77.4305 49.7555 76.7842 48.9582 76.7842C48.161 76.7842 47.5146 77.4305 47.5146 78.2277C47.5146 79.025 48.161 79.6713 48.9582 79.6713Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_24", d: "M30.7692 77.2534H32.2849V66.3183H30.7692V77.2534Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u("path", { id: "Vector_25", d: "M30.7691 75.918H52.5671V75.2684H30.7691V75.918Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u("path", { id: "Vector_26", d: "M25.2475 71.84H25.9692V71.5512H25.2475V71.84Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_27",
        d: "M57.1506 70.5172C57.1438 70.5096 57.1386 70.5008 57.1354 70.4911C57.1323 70.4814 57.1312 70.4712 57.1322 70.4611L58.1277 61.0476C58.1296 61.0299 58.1379 61.0136 58.1511 61.0016C58.1643 60.9897 58.1814 60.9831 58.1992 60.983H58.1995C58.2172 60.983 58.2343 60.9895 58.2475 61.0013C58.2607 61.0131 58.2692 61.0294 58.2712 61.047L59.3478 70.4409C59.349 70.451 59.348 70.4611 59.345 70.4708C59.3419 70.4804 59.3369 70.4893 59.3302 70.4969C59.3235 70.5045 59.3153 70.5106 59.3061 70.5148C59.2969 70.519 59.2869 70.5212 59.2768 70.5213L57.2047 70.5408H57.204C57.194 70.5408 57.184 70.5387 57.1748 70.5346C57.1656 70.5306 57.1574 70.5246 57.1506 70.5172ZM58.2024 61.7143L57.2843 70.3957L59.1953 70.3777L58.2024 61.7143Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_28",
        d: "M17.8625 73.2003L17.8963 73.213C18.0664 73.2774 18.204 73.4066 18.2788 73.5724C18.3535 73.7382 18.3594 73.9269 18.2951 74.097C18.2308 74.2671 18.1015 74.4046 17.9357 74.4794C17.7699 74.5542 17.5813 74.5601 17.4112 74.4957L17.3774 74.483L17.8625 73.2003Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_29", d: "M57.8724 62.7455H58.5942V52.2074H57.8724V62.7455Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_30",
        d: "M31.5991 64.2612C32.1572 64.2612 32.6096 63.8088 32.6096 63.2507C32.6096 62.6927 32.1572 62.2402 31.5991 62.2402C31.041 62.2402 30.5886 62.6927 30.5886 63.2507C30.5886 63.8088 31.041 64.2612 31.5991 64.2612Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_31", d: "M33.0708 75.2793H53.8596V74.3984H33.0708V75.2793Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_32", d: "M34.304 74.3984H55.0928V73.5175H34.304V74.3984Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_33", d: "M33.4231 73.6936H54.2119V72.8127H33.4231V73.6936Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u("path", { id: "Vector_34", d: "M34.6563 72.8127H55.4451V71.9319H34.6563V72.8127Z", fill: "#3FC1A3" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_35",
        d: "M67.3587 21.5362C68.0212 21.5355 68.6616 21.7741 69.1621 22.2082C69.5575 22.1002 69.9721 22.082 70.3754 22.1549C70.7094 21.6703 71.1895 21.3051 71.7458 21.1128C72.302 20.9205 72.9051 20.9111 73.4671 21.086C74.029 21.2609 74.5203 21.6109 74.8692 22.0849C75.218 22.5589 75.4062 23.132 75.4061 23.7205H64.6599C64.7917 23.1025 65.1316 22.5484 65.6228 22.1508C66.114 21.7533 66.7267 21.5363 67.3587 21.5362Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_36",
        d: "M51.1918 30.2301C51.8181 30.2294 52.4236 30.455 52.8967 30.8654C53.2706 30.7633 53.6625 30.746 54.0439 30.815C54.3596 30.3568 54.8135 30.0116 55.3394 29.8298C55.8652 29.648 56.4354 29.6391 56.9667 29.8045C57.4979 29.9698 57.9624 30.3007 58.2922 30.7488C58.622 31.1969 58.7999 31.7387 58.7999 32.2951H48.6404C48.765 31.7108 49.0863 31.187 49.5507 30.8111C50.015 30.4353 50.5943 30.2302 51.1918 30.2301Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_37",
        d: "M35.0282 15.8907C35.6798 15.89 36.3098 16.1247 36.8021 16.5517C37.1911 16.4455 37.5989 16.4276 37.9956 16.4993C38.3241 16.0226 38.7964 15.6634 39.3436 15.4743C39.8907 15.2851 40.484 15.2759 41.0367 15.4479C41.5895 15.6199 42.0728 15.9642 42.4159 16.4305C42.7591 16.8967 42.9442 17.4604 42.9441 18.0394H32.3735C32.5031 17.4314 32.8375 16.8864 33.3206 16.4953C33.8038 16.1042 34.4066 15.8908 35.0282 15.8907Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_38",
        d: "M104.825 43.1959V65.2013H113.382V42.8903L111.396 42.9612V38.4586H109.955L109.717 28.4864C110.299 28.1075 110.708 27.2077 110.708 26.157C110.709 25.8553 110.674 25.5547 110.604 25.2613C110.879 24.9636 111.047 24.583 111.083 24.1791C111.119 23.7753 111.019 23.371 110.801 23.0296C110.984 23.1893 111.196 23.3112 111.427 23.3881C111.657 23.465 111.9 23.4954 112.143 23.4774C112.385 23.4595 112.621 23.3937 112.837 23.2838C113.054 23.1739 113.246 23.022 113.404 22.8371C113.561 22.6522 113.68 22.4378 113.754 22.2065C113.828 21.9752 113.855 21.7315 113.834 21.4896C113.813 21.2477 113.744 21.0124 113.631 20.7973C113.518 20.5823 113.364 20.3918 113.177 20.2369C113.491 20.1209 113.768 19.9209 113.977 19.6587C114.186 19.3965 114.318 19.0821 114.361 18.7497C114.404 18.4173 114.354 18.0795 114.219 17.7732C114.083 17.4668 113.866 17.2034 113.591 17.0118C113.316 16.8202 112.994 16.7076 112.659 16.6862C112.325 16.6648 111.991 16.7355 111.694 16.8905C111.396 17.0456 111.147 17.2791 110.974 17.5657C110.8 17.8523 110.708 18.1811 110.708 18.5162C110.708 18.5431 110.709 18.5697 110.71 18.5962C110.458 18.5193 110.193 18.4975 109.932 18.5322C109.671 18.567 109.421 18.6575 109.198 18.7975C108.975 18.9376 108.785 19.1241 108.64 19.3441C108.496 19.5642 108.4 19.8128 108.36 20.0731C108.132 19.937 107.876 19.8523 107.611 19.8249C107.347 19.7976 107.079 19.8281 106.827 19.9145C106.576 20.0008 106.346 20.1409 106.154 20.3251C105.962 20.5092 105.812 20.7329 105.715 20.9807C105.618 21.2285 105.576 21.4945 105.592 21.7601C105.608 22.0257 105.682 22.2846 105.808 22.5189C105.934 22.7531 106.11 22.9571 106.323 23.1167C106.536 23.2762 106.781 23.3875 107.042 23.4428C107.041 23.4561 107.041 23.4693 107.041 23.4827C107.211 23.9967 107.428 24.4941 107.688 24.9687C107.561 25.3518 107.497 25.7532 107.499 26.157C107.499 27.2077 107.908 28.1075 108.49 28.4864L108.252 38.4586H106.811V43.1249L104.825 43.1959ZM110.168 22.1837L110.173 22.1838C110.2 22.1838 110.226 22.1829 110.252 22.1818C110.269 22.236 110.288 22.289 110.309 22.341C110.265 22.2859 110.218 22.2334 110.168 22.1837Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_39", d: "M100.113 80.8648H126.091V50.8111H100.113V80.8648Z", fill: "#3F3D56" }),
    /* @__PURE__ */ u("path", { id: "Vector_40", d: "M109.6 80.8648H116.604V74.7522H109.6V80.8648Z", fill: "#E2E2E2" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_41",
        d: "M91.4549 11.2673C91.4545 11.2895 91.4533 11.3115 91.4533 11.3338C91.4529 11.7425 91.5347 12.1472 91.6939 12.5236C91.8531 12.9 92.0864 13.2406 92.3799 13.525C92.4258 13.6228 92.4768 13.7181 92.5327 13.8105C92.3203 14.449 92.2138 15.118 92.2174 15.7909C92.2174 18.1119 93.4146 19.9934 94.8916 19.9934C96.3686 19.9934 97.5659 18.1119 97.5659 15.7909C97.567 15.2882 97.5085 14.7871 97.3916 14.2981C97.8502 13.8019 98.1313 13.1675 98.1908 12.4945C98.2503 11.8214 98.0849 11.1476 97.7205 10.5786C98.0252 10.8448 98.3798 11.0479 98.7637 11.1761C99.1475 11.3042 99.553 11.3548 99.9566 11.3249C100.36 11.2951 100.754 11.1854 101.115 11.0021C101.475 10.8189 101.796 10.5659 102.059 10.2577C102.321 9.94945 102.519 9.59222 102.642 9.20671C102.765 8.82119 102.811 8.41507 102.775 8.01192C102.74 7.60877 102.625 7.21661 102.438 6.85822C102.25 6.49982 101.992 6.18232 101.681 5.92415C102.205 5.73076 102.666 5.39747 103.014 4.96048C103.362 4.5235 103.583 3.99952 103.654 3.44548C103.725 2.89143 103.643 2.32851 103.417 1.81785C103.19 1.3072 102.828 0.86834 102.37 0.548951C101.912 0.229563 101.375 0.0418581 100.817 0.00622619C100.26 -0.0294057 99.7035 0.0883983 99.2083 0.346842C98.7131 0.605285 98.2982 0.994484 98.0086 1.47216C97.7191 1.94984 97.566 2.49773 97.5659 3.05631C97.5659 3.10106 97.5674 3.14545 97.5693 3.18973C97.1496 3.06154 96.7073 3.02515 96.2723 3.08304C95.8374 3.14093 95.42 3.29173 95.0485 3.52522C94.677 3.7587 94.36 4.06939 94.1192 4.4362C93.8784 4.80301 93.7194 5.21734 93.6529 5.65106C93.2717 5.42428 92.8458 5.28317 92.4046 5.23753C91.9635 5.19188 91.5177 5.24279 91.0982 5.38673C90.6787 5.53066 90.2955 5.76417 89.9753 6.07105C89.6551 6.37792 89.4055 6.75081 89.2439 7.16382C89.0823 7.57683 89.0124 8.02007 89.0393 8.46276C89.0662 8.90546 89.189 9.33701 89.3994 9.72744C89.6098 10.1179 89.9026 10.4579 90.2576 10.7238C90.6125 10.9897 91.0211 11.1751 91.4549 11.2673ZM96.6745 9.16893C96.7185 9.16893 96.7623 9.16745 96.806 9.1656C96.8334 9.25594 96.8649 9.34437 96.9004 9.43092C96.8275 9.33912 96.7495 9.25158 96.6666 9.16873L96.6745 9.16893Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_42",
        d: "M93.363 40.8782H96.4197L96.3105 36.2941V36.2923L95.9105 19.4833C95.6037 19.6709 95.251 19.7701 94.8914 19.7701C94.5317 19.7701 94.1791 19.6709 93.8722 19.4833L93.4723 36.2923V36.2941L93.363 40.8782Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_43",
        d: "M87.7605 44.1885V80.8649H102.022V43.6794L98.7116 43.7974V36.2941H91.0709V44.0705L87.7605 44.1885Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_44",
        d: "M127.876 11.2673C127.875 11.2895 127.874 11.3115 127.874 11.3338C127.874 11.7425 127.956 12.1472 128.115 12.5236C128.274 12.9 128.507 13.2406 128.801 13.525C128.847 13.6228 128.898 13.7181 128.954 13.8105C128.741 14.449 128.635 15.118 128.638 15.7909C128.638 18.1119 129.836 19.9934 131.313 19.9934C132.789 19.9934 133.987 18.1119 133.987 15.7909C133.988 15.2882 133.929 14.7871 133.813 14.2981C134.271 13.8019 134.552 13.1675 134.612 12.4945C134.671 11.8214 134.506 11.1476 134.141 10.5786C134.446 10.8449 134.801 11.0479 135.185 11.1761C135.568 11.3042 135.974 11.3548 136.378 11.325C136.781 11.2951 137.175 11.1854 137.536 11.0022C137.896 10.819 138.217 10.5659 138.48 10.2577C138.742 9.94948 138.94 9.59224 139.063 9.20672C139.186 8.8212 139.232 8.41508 139.196 8.01193C139.161 7.60877 139.046 7.21661 138.858 6.85822C138.67 6.49982 138.413 6.18232 138.102 5.92415C138.626 5.73076 139.087 5.39747 139.435 4.96048C139.783 4.5235 140.004 3.99952 140.075 3.44548C140.146 2.89144 140.064 2.32851 139.838 1.81785C139.611 1.3072 139.249 0.86834 138.791 0.548951C138.333 0.229562 137.796 0.0418582 137.238 0.00622621C136.681 -0.0294058 136.124 0.0883983 135.629 0.346842C135.134 0.605285 134.719 0.994484 134.43 1.47216C134.14 1.94984 133.987 2.49773 133.987 3.05631C133.987 3.10106 133.988 3.14545 133.99 3.18973C133.571 3.06154 133.128 3.02515 132.693 3.08304C132.258 3.14093 131.841 3.29173 131.469 3.52522C131.098 3.7587 130.781 4.06939 130.54 4.4362C130.299 4.80301 130.14 5.21734 130.074 5.65106C129.693 5.42428 129.267 5.28317 128.826 5.23753C128.384 5.19188 127.939 5.24279 127.519 5.38673C127.1 5.53066 126.716 5.76417 126.396 6.07105C126.076 6.37792 125.826 6.75081 125.665 7.16382C125.503 7.57683 125.433 8.02007 125.46 8.46276C125.487 8.90546 125.61 9.33701 125.82 9.72744C126.031 10.1179 126.324 10.4579 126.678 10.7238C127.033 10.9897 127.442 11.1751 127.876 11.2673ZM133.095 9.16893C133.139 9.16893 133.183 9.16745 133.227 9.1656C133.254 9.25593 133.286 9.34437 133.321 9.43092C133.248 9.33912 133.17 9.25158 133.087 9.16873L133.095 9.16893Z",
        fill: "#E2E2E2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_45",
        d: "M129.784 40.8781H132.84L132.331 19.4839C131.673 19.7206 130.952 19.7206 130.294 19.4839L129.784 40.8781Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_46",
        d: "M124.182 44.1885V80.8649H138.445V43.6794L137.273 43.7217L135.133 43.7974V36.2941H127.492V44.0705L124.182 44.1885Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_47", d: "M116.978 57.9619H120.501V54.4383H116.978V57.9619Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_48", d: "M111.34 57.9619H114.864V54.4383H111.34V57.9619Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_49", d: "M105.703 57.9619H109.226V54.4383H105.703V57.9619Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_50", d: "M116.978 63.5995H120.501V60.076H116.978V63.5995Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_51", d: "M111.34 63.5995H114.864V60.076H111.34V63.5995Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_52", d: "M105.703 63.5995H109.226V60.076H105.703V63.5995Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_53", d: "M116.978 69.2372H120.501V65.7137H116.978V69.2372Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_54", d: "M111.34 69.2372H114.864V65.7137H111.34V69.2372Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_55", d: "M105.703 69.2372H109.226V65.7137H105.703V69.2372Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_56", d: "M93.1298 56.5526H96.6533V53.0291H93.1298V56.5526Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_57", d: "M93.1298 62.1901H96.6533V58.6666H93.1298V62.1901Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_58", d: "M93.1298 67.8278H96.6533V64.3042H93.1298V67.8278Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_59", d: "M93.1298 73.4654H96.6533V69.9419H93.1298V73.4654Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_60", d: "M129.521 56.5526H133.045V53.0291H129.521V56.5526Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_61", d: "M129.521 62.1901H133.045V58.6666H129.521V62.1901Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_62", d: "M129.521 67.8278H133.045V64.3042H129.521V67.8278Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_63", d: "M129.521 73.4654H133.045V69.9419H129.521V73.4654Z", fill: "white" }),
    /* @__PURE__ */ u("path", { id: "Vector_64", d: "M156.444 80.7407H0V81.093H156.444V80.7407Z", fill: "#3F3D56" })
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_811", children: /* @__PURE__ */ u("rect", { width: "156.444", height: "81.1336", fill: "white" }) }) })
] }), jz = (e) => /* @__PURE__ */ T("svg", { width: "134", height: "82", viewBox: "0 0 134 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "undraw_analysis_dq08 1", clipPath: "url(#clip0_35_387)", children: [
    /* @__PURE__ */ u("path", { id: "Vector", d: "M133.927 6.34186H0.348633V6.69041H133.927V6.34186Z", fill: "#DEDFE0" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M9.78547 3.60231H2.06325C1.06988 3.60231 0.26123 2.79366 0.26123 1.80028C0.26123 0.806903 1.06988 0 2.06325 0H9.78721C10.7806 0 11.5892 0.808645 11.5892 1.80202C11.5892 2.7954 10.7806 3.60405 9.78721 3.60405L9.78547 3.60231Z",
        fill: "#DEDFE0"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_3", d: "M133.927 20.7493H0.348633V21.0979H133.927V20.7493Z", fill: "#DEDFE0" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M9.78547 18.0097H2.06325C1.06988 18.0097 0.26123 17.2011 0.26123 16.2077C0.26123 15.2143 1.06988 14.4057 2.06325 14.4057H9.78721C10.7806 14.4057 11.5892 15.2143 11.5892 16.2077C11.5892 17.2011 10.7806 18.0097 9.78721 18.0097H9.78547Z",
        fill: "#DEDFE0"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_5", d: "M133.927 35.1552H0.348633V35.5038H133.927V35.1552Z", fill: "#DEDFE0" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M9.78547 32.4172H2.06325C1.06988 32.4172 0.26123 31.6085 0.26123 30.6152C0.26123 29.6218 1.06988 28.8131 2.06325 28.8131H9.78721C10.7806 28.8131 11.5892 29.6218 11.5892 30.6152C11.5892 31.6085 10.7806 32.4172 9.78721 32.4172H9.78547Z",
        fill: "#DEDFE0"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        d: "M48.1005 6.86471H0.348554C0.156849 6.86471 0 6.70786 0 6.51616C0 6.32445 0.156849 6.1676 0.348554 6.1676H48.1005C48.2922 6.1676 48.449 6.32445 48.449 6.51616C48.449 6.70786 48.2922 6.86471 48.1005 6.86471Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M73.0308 21.2722H0.348554C0.156849 21.2722 0 21.1153 0 20.9236C0 20.7319 0.156849 20.5751 0.348554 20.5751H73.0308C73.2225 20.5751 73.3793 20.7319 73.3793 20.9236C73.3793 21.1153 73.2225 21.2722 73.0308 21.2722Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M24.2245 35.678H0.348554C0.156849 35.678 0 35.5212 0 35.3295C0 35.1378 0.156849 34.9809 0.348554 34.9809H24.2245C24.4162 34.9809 24.5731 35.1378 24.5731 35.3295C24.5731 35.5212 24.4162 35.678 24.2245 35.678Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ T("g", { id: "Group", children: [
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_10",
          d: "M100.569 28.6966L97.6843 29.6795L97.6372 25.5125L100.264 25.4829L100.569 28.6966Z",
          fill: "#FFE6D8"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_11",
          d: "M97.9768 26.6627C99.5708 26.6627 100.863 25.3706 100.863 23.7767C100.863 22.1827 99.5708 20.8906 97.9768 20.8906C96.3829 20.8906 95.0908 22.1827 95.0908 23.7767C95.0908 25.3706 96.3829 26.6627 97.9768 26.6627Z",
          fill: "#FFE6D8"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_12",
          d: "M98.7646 23.4822C98.2819 23.4735 97.9595 22.989 97.766 22.5446C97.5726 22.1002 97.3739 21.5913 96.926 21.4118C96.5583 21.2654 95.9239 22.2884 95.6311 22.0217C95.3261 21.7429 95.605 20.2894 95.9222 20.0263C96.2394 19.7631 96.6768 19.7073 97.0881 19.6829C98.0937 19.6254 99.1045 19.6951 100.093 19.8903C100.703 20.0106 101.333 20.1953 101.778 20.631C102.341 21.1835 102.492 22.0252 102.541 22.813C102.592 23.6181 102.553 24.4634 102.17 25.1744C101.785 25.8837 100.971 26.4135 100.181 26.2427C100.098 25.8157 100.173 25.3766 100.199 24.9409C100.225 24.5069 100.187 24.0381 99.9183 23.6948C99.65 23.3515 99.0818 23.2208 98.7768 23.531",
          fill: "#2F2E43"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_13",
          d: "M102.325 24.4424C102.611 24.228 102.954 24.0468 103.31 24.0869C103.695 24.1287 104.022 24.4424 104.125 24.8153C104.228 25.1883 104.122 25.6013 103.888 25.9098C103.655 26.2183 103.304 26.4239 102.931 26.5285C102.715 26.5895 102.48 26.6156 102.273 26.5285C101.968 26.4013 101.8 26.0161 101.915 25.7059",
          fill: "#2F2E43"
        }
      ),
      /* @__PURE__ */ T("g", { id: "Group_2", children: [
        /* @__PURE__ */ u(
          "path",
          {
            id: "uuid-c8983f9d-ef50-4d77-8f7b-49f8a94dcf30-219",
            d: "M91.5878 51.7081C91.4066 52.6579 91.7673 53.5206 92.3965 53.6338C93.0239 53.7471 93.6809 53.0674 93.8622 52.1176C93.9406 51.7394 93.9231 51.3473 93.8116 50.9761L96.0319 36.0911L93.0413 35.563L92.0566 50.6607C91.8161 50.9691 91.6541 51.3281 91.5878 51.7098V51.7081Z",
            fill: "#FFE6D8"
          }
        ),
        /* @__PURE__ */ u(
          "path",
          {
            id: "Vector_14",
            d: "M97.6316 27.7676L95.5943 27.7902C94.1565 28.0238 93.7731 28.7976 93.4629 30.2197C92.9871 32.3894 92.3807 35.2807 92.5079 35.3207C92.7118 35.387 96.1973 36.9799 97.961 36.586L97.6316 27.7676Z",
            fill: "#3FC1A3"
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_15",
          d: "M100.132 75.0688L97.4204 75.0991L97.4634 78.9451L100.175 78.9149L100.132 75.0688Z",
          fill: "#FFE6D8"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_16",
          d: "M94.8418 81.3109C94.556 81.3143 94.3033 81.3109 94.1116 81.2952C93.3901 81.2377 92.6982 80.7131 92.3479 80.4064C92.191 80.2687 92.1388 80.0456 92.2172 79.8539C92.273 79.7162 92.388 79.6117 92.5309 79.5681L94.4288 79.0034L97.4873 76.8895L97.5222 76.9504C97.5361 76.9731 97.8446 77.5151 97.9492 77.8828C97.9892 78.0223 97.9805 78.139 97.923 78.2296C97.8829 78.2924 97.8272 78.329 97.7818 78.3516C97.8376 78.4091 98.0136 78.5259 98.5539 78.6061C99.3399 78.7228 99.4985 77.9055 99.5037 77.8706L99.5089 77.8427L99.5316 77.8271C99.9028 77.5813 100.131 77.4698 100.211 77.4924C100.262 77.5064 100.344 77.5308 100.591 79.7476C100.614 79.8173 100.776 80.3262 100.675 80.8159C100.565 81.3492 98.2419 81.1906 97.7784 81.154C97.7644 81.1558 96.0286 81.2987 94.8383 81.3109H94.8418Z",
          fill: "#2F2E43"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_17",
          d: "M107.814 71.9575L105.529 73.4181L107.601 76.6588L109.885 75.1982L107.814 71.9575Z",
          fill: "#FFE6D8"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_18",
          d: "M104.854 80.6713C104.535 80.6747 104.242 80.6399 104.033 80.605C103.827 80.5702 103.665 80.4098 103.631 80.2042C103.604 80.0561 103.648 79.9079 103.746 79.7964L105.056 78.3133L106.532 74.9009L106.595 74.9341C106.618 74.9463 107.167 75.2425 107.451 75.4987C107.559 75.5963 107.613 75.6991 107.613 75.8072C107.613 75.8821 107.585 75.9431 107.557 75.9849C107.635 76.0041 107.846 76.0093 108.346 75.7915C109.075 75.4743 108.777 74.697 108.763 74.6657L108.753 74.6395L108.765 74.6151C108.949 74.2108 109.085 73.9947 109.164 73.9703C109.214 73.9564 109.296 73.932 110.68 75.6817C110.736 75.7288 111.144 76.0738 111.316 76.5426C111.504 77.0533 109.451 78.1477 109.037 78.3621C109.024 78.3725 106.879 79.9672 105.997 80.4238C105.647 80.605 105.23 80.6643 104.85 80.6678L104.854 80.6713Z",
          fill: "#2F2E43"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_19",
          d: "M101.765 42.881L94.1739 42.9646L93.564 50.0333L96.8683 76.0947L100.744 76.0511L99.0275 60.9971L105.465 74.5349L108.883 72.0846L103.832 59.4356C103.832 59.4356 105.464 48.3498 104.055 45.6084C102.647 42.867 101.767 42.8775 101.767 42.8775V42.881H101.765Z",
          fill: "#2F2E43"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_20",
          d: "M105.547 43.2696L93.4893 43.4038L96.9347 27.7764L102.187 27.7171L105.547 43.2696Z",
          fill: "#3FC1A3"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "uuid-97a43cd7-1586-4870-a70d-869ca8f8714f-220",
          d: "M106.724 51.5407C106.926 52.4871 106.585 53.3567 105.959 53.4839C105.333 53.6112 104.662 52.9472 104.46 52.0008C104.373 51.6244 104.382 51.2323 104.485 50.8576L101.933 36.0249L104.911 35.4306L106.231 50.5038C106.478 50.807 106.647 51.1626 106.724 51.5425V51.5407Z",
          fill: "#FFE6D8"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_21",
          d: "M100.15 27.7398L102.187 27.7171C103.63 27.9193 104.029 28.6843 104.373 30.0995C104.896 32.2588 105.567 35.1343 105.441 35.1779C105.237 35.2476 101.79 36.9172 100.018 36.5634L100.152 27.7398H100.15Z",
          fill: "#3FC1A3"
        }
      )
    ] }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M118.547 81.3107C118.547 81.4048 118.47 81.4815 118.376 81.4815H81.2343C81.1402 81.4815 81.0635 81.4048 81.0635 81.3107C81.0635 81.2166 81.1402 81.1399 81.2343 81.1399H118.376C118.47 81.1399 118.547 81.2166 118.547 81.3107Z",
        fill: "#3F3D58"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_387", children: /* @__PURE__ */ u("rect", { width: "133.927", height: "81.4815", fill: "white" }) }) })
] }), zz = (e) => /* @__PURE__ */ T("svg", { width: "146", height: "82", viewBox: "0 0 146 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "undraw_coffee_break_h3uu 1", clipPath: "url(#clip0_35_1672)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M100.905 25.854H98.1397C98.051 25.8543 97.9654 25.8214 97.8996 25.7618C97.8339 25.7022 97.7928 25.6202 97.7845 25.5319L97.231 19.8581H101.814L101.26 25.5318C101.252 25.6201 101.211 25.7022 101.145 25.7618C101.08 25.8214 100.994 25.8543 100.905 25.854Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M101.807 20.5719H97.2383C97.1436 20.5718 97.0529 20.5341 96.986 20.4672C96.9191 20.4003 96.8815 20.3096 96.8813 20.215V19.3584C96.8815 19.2638 96.9191 19.1731 96.986 19.1062C97.0529 19.0393 97.1436 19.0016 97.2383 19.0015H101.807C101.901 19.0016 101.992 19.0393 102.059 19.1062C102.126 19.1731 102.163 19.2638 102.163 19.3584V20.215C102.163 20.3096 102.126 20.4003 102.059 20.4672C101.992 20.5341 101.901 20.5718 101.807 20.5719Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        d: "M68.5502 19.759H57.5947V16.4332C61.0566 14.024 64.1239 14.2335 68.159 16.6289L68.5502 19.759Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M55.0579 78.832L52.6594 78.8319L52.3008 69.5807L55.0582 69.5809L55.0579 78.832Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_5",
        d: "M55.6695 81.1569L47.936 81.1566V81.0588C47.936 80.6635 48.0139 80.2721 48.1652 79.9069C48.3164 79.5417 48.5381 79.2099 48.8177 78.9304C49.0972 78.6508 49.429 78.4291 49.7942 78.2779C50.1594 78.1266 50.5509 78.0487 50.9461 78.0488L55.6697 78.0489L55.6695 81.1569Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M68.5668 78.832L70.9653 78.8319L71.3239 69.5807L68.5664 69.5809L68.5668 78.832Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        d: "M67.9551 78.0489L72.6784 78.0488C73.0737 78.0487 73.4653 78.1266 73.8305 78.2779C74.1957 78.4291 74.5276 78.6508 74.8071 78.9303C75.0866 79.2099 75.3083 79.5417 75.4596 79.9069C75.6109 80.2721 75.6887 80.6635 75.6887 81.0588V81.1566L67.9552 81.1569L67.9551 78.0489Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M68.6297 77.6464C68.4296 77.6457 68.2356 77.5772 68.0794 77.4521C67.9233 77.3269 67.8142 77.1525 67.7701 76.9573L61.8254 51.0281C61.8124 50.9623 61.7765 50.9031 61.7241 50.8611C61.6717 50.8191 61.6062 50.7969 61.539 50.7985H61.5375C61.4701 50.7973 61.4044 50.8199 61.3522 50.8625C61.2999 50.905 61.2643 50.9648 61.2519 51.031L55.7928 76.7853C55.7502 76.9823 55.6416 77.1589 55.485 77.2858C55.3284 77.4127 55.1331 77.4823 54.9315 77.483H52.331C52.2111 77.483 52.0923 77.4585 51.9822 77.4109C51.872 77.3634 51.7727 77.2938 51.6904 77.2065C51.6081 77.1192 51.5445 77.016 51.5036 76.9032C51.4626 76.7905 51.4451 76.6705 51.4522 76.5507L53.3892 43.9081L54.1686 43.6776L54.1832 43.6777L69.4931 43.8117L72.7539 76.4183C72.7652 76.5346 72.7534 76.652 72.7189 76.7637C72.6844 76.8753 72.628 76.979 72.5531 77.0686C72.4781 77.1583 72.386 77.2321 72.2822 77.2857C72.1785 77.3394 72.065 77.3719 71.9485 77.3812L68.7002 77.6435C68.6766 77.6454 68.6531 77.6464 68.6297 77.6464Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M62.3079 13.7984C64.9616 13.7984 67.1129 11.6471 67.1129 8.99341C67.1129 6.3397 64.9616 4.18845 62.3079 4.18845C59.6542 4.18845 57.5029 6.3397 57.5029 8.99341C57.5029 11.6471 59.6542 13.7984 62.3079 13.7984Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M59.3639 47.487C58.521 47.4975 57.6813 47.3793 56.874 47.1366C56.1559 46.9201 55.4898 46.5589 54.9165 46.0752C54.3433 45.5916 53.8751 44.9958 53.5408 44.3244C53.4348 44.1224 53.4113 43.8871 53.4752 43.6682C54.0052 41.8595 56.566 32.4582 54.9321 24.9846C54.7014 23.9463 54.6823 22.8723 54.8757 21.8265C55.0692 20.7807 55.4712 19.7846 56.058 18.8976C56.631 18.0175 57.3755 17.2618 58.247 16.6757C59.1184 16.0896 60.099 15.685 61.1302 15.486L61.1302 15.4858C61.4012 15.4329 61.6737 15.3895 61.94 15.3567C63.0799 15.2163 64.2367 15.3297 65.3277 15.6887C66.4186 16.0476 67.4168 16.6433 68.2507 17.433C69.1094 18.2382 69.7794 19.2233 70.2128 20.3177C70.6463 21.4122 70.8324 22.5889 70.7579 23.7637L69.5021 43.9148C69.4934 44.0659 69.4456 44.2121 69.3634 44.3391C69.2811 44.4661 69.1673 44.5695 69.033 44.6392C67.5868 45.3971 63.2423 47.487 59.3639 47.487Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_11",
        d: "M67.7356 5.45663C67.2364 4.20224 66.3222 3.15699 65.1454 2.49534C63.9686 1.83369 62.6004 1.59568 61.2693 1.82103L62.7843 3.04527C60.902 3.10865 58.9207 2.97388 57.5767 4.29328C58.0045 4.28141 58.5653 5.19658 58.9932 5.18471C58.1932 5.20053 57.4679 5.76259 57.1146 6.48043C56.7873 7.21793 56.7108 8.04234 56.8966 8.82747C57.0546 9.61181 58.2598 11.4493 58.5842 12.1807C58.5284 10.2693 62.2913 5.71018 64.1288 6.18598C63.1953 6.53236 62.3852 7.14742 61.8007 7.95359C63.0508 7.32271 64.4646 7.09139 65.8505 7.29096C66.1669 7.36353 66.4934 7.3818 66.816 7.34501C67.0137 7.3059 67.198 7.21676 67.3515 7.0861C67.5049 6.95544 67.6222 6.78762 67.6923 6.59867C67.7624 6.40973 67.7829 6.20597 67.7518 6.00686C67.7207 5.80774 67.6391 5.61993 67.5148 5.46134L67.7356 5.45663Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        d: "M59.0333 46.277C58.9119 46.2767 58.7919 46.2514 58.6807 46.2026L49.5641 42.2233C49.3704 42.1403 49.2133 41.9901 49.1215 41.8005C49.0297 41.6108 49.0095 41.3944 49.0646 41.191L55.0999 18.392C55.2121 17.9678 55.4078 17.5702 55.6755 17.2225C55.9432 16.8749 56.2776 16.5841 56.6591 16.3672C57.0406 16.1504 57.4615 16.0118 57.8972 15.9596C58.3329 15.9074 58.7746 15.9427 59.1966 16.0633L61.6098 16.752L59.9109 45.4477C59.9022 45.5893 59.8595 45.7267 59.7864 45.8483C59.7133 45.9698 59.612 46.072 59.4911 46.1461C59.3535 46.2313 59.195 46.2766 59.0333 46.277Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        d: "M75.9059 41.1906L75.5048 39.6784L74.9238 37.4794L74.644 36.425L74.063 34.2319L69.8706 18.3914C69.7587 17.967 69.5632 17.5692 69.2956 17.2214C69.0279 16.8735 68.6935 16.5827 68.3119 16.3658C67.9303 16.149 67.5093 16.0105 67.0735 15.9586C66.6377 15.9066 66.1959 15.9423 65.774 16.0634L63.3618 16.752L64.5571 36.9356L64.6804 39.0425L64.7587 40.3709V40.3728L64.8838 42.4681L65.06 45.4476C65.0743 45.6713 65.1729 45.8813 65.3359 46.0352C65.4989 46.1891 65.7141 46.2755 65.9383 46.2771C66.0595 46.2764 66.1793 46.2511 66.2905 46.2027L75.407 42.2235C75.6007 42.1405 75.758 41.9902 75.8497 41.8004C75.9414 41.6106 75.9613 41.394 75.9059 41.1906Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_14",
        d: "M74.644 36.425L64.6806 39.0426L64.5571 36.9356L74.0632 34.232L74.644 36.425Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_15",
        d: "M75.5048 39.6784L64.8838 42.4682L64.7588 40.3729V40.371L74.9239 37.4795L75.5048 39.6784Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_16",
        d: "M60.2907 37.3895L60.1672 39.4573L50.3955 36.5463L50.9685 34.3826L60.2907 37.3895Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_17",
        d: "M60.0871 40.819L50.1157 37.6008L49.5425 39.7704L59.9658 42.8751L60.0871 40.819Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_18",
        d: "M50.2897 42.9815C50.587 42.9039 50.8637 42.7621 51.1002 42.566C51.3368 42.3699 51.5274 42.1244 51.6588 41.8466C51.7902 41.5689 51.8591 41.2657 51.8606 40.9585C51.8621 40.6512 51.7963 40.3474 51.6677 40.0684L56.3555 25.3517L53.0314 24.6555L48.7335 39.0841C48.2791 39.3312 47.9311 39.7365 47.7554 40.223C47.5798 40.7096 47.5887 41.2436 47.7805 41.724C47.9724 42.2044 48.3337 42.5978 48.7962 42.8295C49.2587 43.0613 49.7901 43.1154 50.2897 42.9815Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_19",
        d: "M56.4854 18.1169C57.4399 18.2142 57.9768 19.2875 57.7395 20.6237L56.6006 27.0363C56.5153 27.517 56.1197 27.8976 55.7909 27.8154L51.9387 26.8525C51.6423 26.7784 51.5332 26.3573 51.7011 25.9359L54.0137 20.1347C54.5159 18.8748 55.56 18.0225 56.4854 18.1169Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_20",
        d: "M62.2901 1.1036e-10C63.9163 0.000174424 65.4786 0.633283 66.6462 1.76526C67.8137 2.89724 68.4949 4.43921 68.5454 6.06465H69.7242C69.8279 6.06465 69.9275 6.10588 70.0008 6.17925C70.0742 6.25263 70.1154 6.35215 70.1154 6.45592V8.02099C70.1154 8.12476 70.0742 8.22427 70.0008 8.29765C69.9275 8.37103 69.8279 8.41225 69.7242 8.41225H56.4211C56.3173 8.41225 56.2178 8.37103 56.1444 8.29765C56.071 8.22427 56.0298 8.12476 56.0298 8.02099V6.26027C56.0298 5.43816 56.1917 4.6241 56.5063 3.86456C56.8209 3.10503 57.2821 2.4149 57.8634 1.83358C58.4447 1.25226 59.1348 0.791129 59.8944 0.476523C60.6539 0.161917 61.468 -4.88122e-06 62.2901 1.1036e-10Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_21",
        d: "M63.038 38.6973H60.2725C60.1838 38.6976 60.0982 38.6647 60.0325 38.6051C59.9667 38.5455 59.9257 38.4635 59.9173 38.3751L59.3638 32.7014H63.9467L63.3932 38.3751C63.3849 38.4634 63.3438 38.5455 63.2781 38.6051C63.2123 38.6647 63.1267 38.6976 63.038 38.6973Z",
        fill: "#6B7280"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M63.9394 33.4152H59.3711C59.2764 33.4151 59.1857 33.3774 59.1188 33.3105C59.0519 33.2436 59.0143 33.1529 59.0142 33.0583V32.2017C59.0143 32.1071 59.0519 32.0164 59.1188 31.9495C59.1857 31.8826 59.2764 31.8449 59.3711 31.8448H63.9394C64.034 31.8449 64.1247 31.8826 64.1916 31.9495C64.2585 32.0164 64.2962 32.1071 64.2963 32.2017V33.0583C64.2962 33.1529 64.2585 33.2436 64.1916 33.3105C64.1247 33.3774 64.034 33.4151 63.9394 33.4152Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_23",
        d: "M61.7145 35.6546C61.822 35.667 61.9284 35.6879 62.0327 35.717L69.3975 29.4011L68.967 27.0838L72.3794 25.977L73.5402 30.0053C73.634 30.3308 73.6196 30.6779 73.4994 30.9945C73.3791 31.3111 73.1594 31.5801 72.8732 31.7612L63.5459 37.6636C63.5525 38.0805 63.432 38.4896 63.2004 38.8365C62.9689 39.1833 62.6372 39.4514 62.2495 39.6051C61.8619 39.7588 61.4366 39.7909 61.0303 39.697C60.624 39.6031 60.2559 39.3878 59.9749 39.0796C59.694 38.7714 59.5135 38.385 59.4575 37.9718C59.4016 37.5585 59.4727 37.138 59.6616 36.7662C59.8504 36.3944 60.148 36.0889 60.5147 35.8903C60.8814 35.6917 61.2999 35.6095 61.7145 35.6546Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_24",
        d: "M69.4167 18.6464C70.4363 18.361 71.4551 19.1371 71.7964 20.4592L73.4345 26.8036C73.5573 27.2792 73.3188 27.7846 72.9463 27.8382L68.5824 28.4659C68.2466 28.5142 67.9507 28.1698 67.9384 27.7163L67.769 21.473C67.7322 20.1171 68.4282 18.9232 69.4167 18.6464Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_25",
        d: "M128.074 59.1733C126.065 56.5007 124.477 53.5363 123.365 50.3832C123.3 50.1945 123.305 49.9892 123.377 49.8036C123.45 49.6181 123.587 49.4644 123.762 49.3699L130.638 45.6858C130.749 45.6257 130.872 45.5919 130.999 45.5867C131.125 45.5816 131.251 45.6054 131.366 45.6562C131.484 45.7074 131.589 45.7849 131.672 45.8827C131.756 45.9804 131.816 46.0959 131.848 46.2204C132.648 49.2589 134.153 52.0664 136.239 54.4157C136.325 54.5113 136.388 54.6252 136.423 54.7489C136.458 54.8725 136.465 55.0025 136.442 55.129C136.42 55.2536 136.371 55.3715 136.296 55.4738C136.222 55.5761 136.126 55.6601 136.014 55.7195L129.138 59.4036C128.962 59.4974 128.759 59.5257 128.564 59.4835C128.369 59.4414 128.196 59.3314 128.074 59.1733Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_26",
        d: "M128.543 58.8208C128.58 58.8669 128.632 58.8987 128.69 58.9107C128.748 58.9226 128.809 58.914 128.861 58.8863L135.736 55.2021C135.77 55.1847 135.799 55.1598 135.821 55.1294C135.843 55.0989 135.858 55.0637 135.864 55.0266C135.871 54.9874 135.869 54.9471 135.858 54.9088C135.847 54.8705 135.827 54.8353 135.801 54.806C133.652 52.3875 132.104 49.4973 131.28 46.3693C131.271 46.3306 131.252 46.2947 131.226 46.2643C131.201 46.2339 131.168 46.2099 131.132 46.1942C131.097 46.1788 131.06 46.1716 131.022 46.1731C130.984 46.1747 130.948 46.185 130.915 46.2032L124.039 49.8872C123.987 49.9154 123.946 49.9608 123.924 50.0157C123.902 50.0706 123.9 50.1315 123.918 50.1879C125.01 53.2847 126.57 56.196 128.543 58.8208Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_27",
        d: "M131.089 50.9435L127.344 52.5965C127.202 52.6592 127.04 52.6628 126.895 52.6066C126.75 52.5503 126.633 52.4388 126.57 52.2966L126.478 52.0867C126.415 51.9443 126.411 51.7829 126.467 51.6378C126.524 51.4927 126.635 51.3758 126.777 51.3128L130.522 49.6598C130.665 49.5971 130.826 49.5935 130.971 49.6497C131.116 49.7059 131.233 49.8174 131.296 49.9597L131.389 50.1695C131.451 50.3119 131.455 50.4734 131.399 50.6185C131.343 50.7636 131.231 50.8805 131.089 50.9435Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_28",
        d: "M132.458 53.4868L128.713 55.1398C128.571 55.2025 128.409 55.2061 128.264 55.1499C128.119 55.0936 128.002 54.9822 127.939 54.8399L127.847 54.63C127.784 54.4876 127.78 54.3262 127.837 54.1811C127.893 54.036 128.004 53.9191 128.147 53.8561L131.891 52.2031C132.034 52.1404 132.195 52.1368 132.34 52.193C132.485 52.2492 132.602 52.3607 132.665 52.503L132.758 52.7128C132.821 52.8553 132.824 53.0167 132.768 53.1618C132.712 53.3069 132.6 53.4238 132.458 53.4868Z",
        fill: "#CCCCCC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_29",
        d: "M123.676 51.3674C123.417 51.2012 123.198 50.9803 123.035 50.7204C122.871 50.4605 122.766 50.1678 122.727 49.863C122.689 49.5581 122.718 49.2486 122.812 48.9561C122.906 48.6636 123.063 48.3953 123.272 48.1701L121.693 25.7588L126.242 26.1999L126.367 48.1474C126.722 48.5236 126.927 49.017 126.942 49.5341C126.958 50.0511 126.783 50.5559 126.451 50.9528C126.12 51.3497 125.654 51.6112 125.142 51.6876C124.631 51.764 124.109 51.65 123.676 51.3674Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_30",
        d: "M122.723 33.2895C122.616 33.2129 122.528 33.1133 122.465 32.9982C122.402 32.8831 122.366 32.7553 122.359 32.6242L122.026 26.5838C121.993 25.9854 122.182 25.3959 122.558 24.9291C122.934 24.4622 123.47 24.1511 124.061 24.0557C124.653 23.9602 125.259 24.0872 125.763 24.4122C126.266 24.7372 126.632 25.2371 126.789 25.8156L128.253 31.216C128.314 31.4414 128.283 31.6816 128.167 31.8841C128.05 32.0866 127.859 32.2348 127.634 32.2961L123.468 33.4254C123.342 33.46 123.209 33.4657 123.08 33.4422C122.951 33.4187 122.829 33.3665 122.723 33.2895Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_31", d: "M114.969 78.9202H112.571L111.43 69.6691H114.969L114.969 78.9202Z", fill: "#FFE6D8" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_32",
        d: "M110.858 78.235H115.483V81.1473H107.945C107.945 80.7649 108.021 80.3862 108.167 80.0328C108.313 79.6795 108.528 79.3584 108.798 79.088C109.069 78.8175 109.39 78.603 109.743 78.4566C110.097 78.3103 110.475 78.235 110.858 78.235Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_33", d: "M123.969 78.9202H121.57L120.429 69.6691H123.969L123.969 78.9202Z", fill: "#FFE6D8" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_34",
        d: "M119.857 78.235H124.482V81.1473H116.944C116.944 80.7649 117.02 80.3862 117.166 80.0328C117.312 79.6795 117.527 79.3584 117.797 79.088C118.068 78.8175 118.389 78.603 118.742 78.4566C119.096 78.3103 119.474 78.235 119.857 78.235Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_35",
        d: "M114.856 74.2597L112.216 74.1338C111.991 74.1232 111.779 74.0267 111.623 73.8643C111.467 73.7019 111.379 73.4859 111.377 73.2607C110.681 62.5167 109.717 50.9962 111.193 46.5456C111.192 46.4188 111.219 46.2933 111.271 46.1777C111.323 46.0621 111.4 45.9591 111.495 45.8758C111.591 45.7925 111.703 45.7308 111.825 45.6949C111.946 45.6591 112.074 45.65 112.2 45.6682L122.763 47.2015C122.972 47.2307 123.163 47.3343 123.301 47.4931C123.44 47.652 123.516 47.8555 123.517 48.0662C124.865 53.3359 124.926 62.8917 124.875 72.8206C124.876 72.9367 124.854 73.0519 124.81 73.1595C124.766 73.2671 124.702 73.3649 124.62 73.4474C124.538 73.5298 124.441 73.5953 124.333 73.6399C124.226 73.6846 124.111 73.7076 123.995 73.7076H121.149C120.939 73.7084 120.735 73.6338 120.576 73.4974C120.416 73.3609 120.311 73.1716 120.279 72.964L118.523 61.7997C118.497 61.6364 118.413 61.4878 118.286 61.3815C118.16 61.2752 117.999 61.2183 117.834 61.2214C117.668 61.2245 117.51 61.2872 117.387 61.3981C117.264 61.509 117.186 61.6606 117.166 61.8248L115.772 73.485C115.746 73.6986 115.643 73.8953 115.482 74.0381C115.321 74.181 115.113 74.2602 114.898 74.2609C114.884 74.2609 114.87 74.2605 114.856 74.2597Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_36",
        d: "M116.715 48.0673C114.387 46.7739 112.568 46.434 111.691 46.3465C111.575 46.3353 111.462 46.3005 111.359 46.2442C111.256 46.1879 111.166 46.1114 111.094 46.0192C111.02 45.9264 110.966 45.8196 110.934 45.7052C110.903 45.5908 110.895 45.4713 110.912 45.3538L113.443 26.563C113.588 25.4637 114.013 24.42 114.676 23.5311C115.339 22.6423 116.219 21.9379 117.231 21.485C118.211 21.0346 119.289 20.8423 120.364 20.9266C121.439 21.0109 122.475 21.3688 123.373 21.9664C123.46 22.0241 123.545 22.083 123.628 22.1431C124.662 22.9006 125.448 23.947 125.888 25.1507C126.328 26.3544 126.402 27.6613 126.1 28.9068C124.548 35.2561 124.015 45.6652 123.924 47.6875C123.917 47.8598 123.859 48.0262 123.757 48.1657C123.656 48.3051 123.515 48.4113 123.353 48.471C122.398 48.818 121.39 48.9974 120.374 49.0013C119.095 49.0091 117.834 48.6874 116.715 48.0673Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_37",
        d: "M118.832 18.9335C121.486 18.9335 123.637 16.7823 123.637 14.1286C123.637 11.4749 121.486 9.32361 118.832 9.32361C116.178 9.32361 114.027 11.4749 114.027 14.1286C114.027 16.7823 116.178 18.9335 118.832 18.9335Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_38",
        d: "M122.232 17.9301C121.336 18.8849 119.671 18.3723 119.554 17.0679C119.545 16.9666 119.546 16.8647 119.556 16.7635C119.617 16.1857 119.95 15.6612 119.87 15.051C119.852 14.8992 119.796 14.7545 119.706 14.6306C118.992 13.6741 117.315 15.0585 116.641 14.1926C116.227 13.6616 116.713 12.8256 116.396 12.2322C115.978 11.449 114.737 11.8354 113.96 11.4064C113.095 10.9292 113.146 9.60164 113.716 8.79418C114.41 7.80943 115.628 7.28398 116.831 7.20825C118.034 7.13252 119.228 7.45764 120.351 7.89521C121.627 8.39238 122.892 9.07948 123.677 10.2012C124.632 11.5654 124.723 13.3995 124.246 14.9946C123.955 15.965 122.964 17.1504 122.232 17.9301Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_39",
        d: "M126.037 22.6016C125.953 22.2064 125.231 21.6664 124.198 21.2263C122.538 20.5538 120.742 20.283 118.958 20.436C117.173 20.589 115.449 21.1614 113.928 22.1066C113.821 22.1123 113.72 22.1528 113.639 22.2217C113.558 22.2906 113.502 22.3842 113.48 22.4881L110.005 37.8551L109.553 39.8565L109.254 41.1809L108.802 43.1764L108.561 44.2426C108.546 44.3107 108.545 44.3814 108.559 44.4498C108.574 44.5183 108.602 44.5829 108.643 44.6394C108.684 44.6959 108.737 44.7429 108.798 44.7774C108.859 44.8119 108.926 44.833 108.996 44.8393L123.999 46.1344C124.013 46.1344 124.028 46.1363 124.042 46.1363C124.166 46.1356 124.285 46.0879 124.375 46.003C124.465 45.918 124.519 45.8021 124.527 45.6785L124.67 43.5051L124.822 41.1809L124.889 40.1734L125.04 37.8551L126.039 22.627V22.6133L126.037 22.6016Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_40",
        d: "M101.42 23.5689C101.444 23.6745 101.459 23.7818 101.466 23.8898L109.87 28.738L111.913 27.562L114.091 30.4129L109.721 33.5275L100.133 25.9637C99.7421 26.1084 99.3163 26.1307 98.9123 26.0275C98.5083 25.9243 98.1453 25.7005 97.8716 25.386C97.5979 25.0714 97.4264 24.681 97.38 24.2667C97.3335 23.8523 97.4143 23.4337 97.6116 23.0663C97.809 22.699 98.1134 22.4005 98.4845 22.2104C98.8556 22.0204 99.2758 21.9478 99.6892 22.0023C100.103 22.0569 100.49 22.236 100.799 22.5158C101.108 22.7957 101.324 23.163 101.42 23.5689Z",
        fill: "#FFE6D8"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_41",
        d: "M110.171 28.3257C110.157 28.1953 110.172 28.0633 110.216 27.9396C110.26 27.8159 110.331 27.7036 110.424 27.611L114.701 23.3328C115.125 22.909 115.69 22.657 116.289 22.6256C116.887 22.5942 117.476 22.7854 117.942 23.1625C118.408 23.5396 118.718 24.0759 118.812 24.6678C118.906 25.2598 118.777 25.8655 118.451 26.3683L115.405 31.062C115.277 31.2576 115.078 31.3948 114.849 31.4434C114.621 31.492 114.383 31.448 114.187 31.3212L110.567 28.9719C110.457 28.9007 110.364 28.8057 110.295 28.6939C110.227 28.582 110.184 28.4562 110.171 28.3257Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("path", { id: "Vector_42", d: "M125.04 37.8551L124.889 40.1733L109.553 39.8564L110.005 37.8551H125.04Z", fill: "#CCCCCC" }),
    /* @__PURE__ */ u("path", { id: "Vector_43", d: "M124.822 41.181L124.67 43.5051L108.802 43.1764L109.254 41.181H124.822Z", fill: "#CCCCCC" }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_44",
        d: "M118.926 4.793C117.3 4.79317 115.737 5.42628 114.57 6.55826C113.402 7.69025 112.721 9.23221 112.671 10.8576H111.492C111.388 10.8577 111.289 10.8989 111.215 10.9723C111.142 11.0456 111.101 11.1451 111.101 11.2489V12.814C111.101 12.9178 111.142 13.0173 111.215 13.0906C111.289 13.164 111.388 13.2053 111.492 13.2053H124.795C124.899 13.2053 124.998 13.164 125.072 13.0906C125.145 13.0173 125.186 12.9178 125.186 12.814V11.0533C125.186 10.2312 125.024 9.41709 124.71 8.65756C124.395 7.89803 123.934 7.2079 123.353 6.62658C122.771 6.04526 122.081 5.58413 121.322 5.26952C120.562 4.95492 119.748 4.79299 118.926 4.793Z",
        fill: "#3FC1A3"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_45",
        d: "M21.1509 67.1133C19.9128 67.5486 18.5834 67.6576 17.2909 67.4299C15.9984 67.2022 14.7863 66.6455 13.7714 65.8134C11.1867 63.644 10.3763 60.0699 9.71692 56.7605L7.7666 46.9718L11.8498 49.7833C14.7862 51.8052 17.7887 53.8919 19.8219 56.8205C21.855 59.7491 22.7425 63.7469 21.1089 66.9158",
        fill: "#70D4BC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_46",
        d: "M20.8017 78.9647C21.215 75.9544 21.6399 72.9054 21.35 69.8628C21.0926 67.1607 20.2682 64.5215 18.5899 62.3575C17.699 61.211 16.615 60.2287 15.3866 59.4548C15.0662 59.2526 14.7714 59.7602 15.0904 59.9616C17.2159 61.3049 18.8599 63.2885 19.7854 65.6264C20.8075 68.2263 20.9717 71.0604 20.7955 73.8222C20.689 75.4923 20.4632 77.1516 20.2357 78.8087C20.2178 78.8836 20.229 78.9626 20.267 79.0296C20.3051 79.0966 20.3672 79.1466 20.4407 79.1696C20.5157 79.1899 20.5957 79.1797 20.6633 79.1413C20.7309 79.1029 20.7806 79.0395 20.8017 78.9647Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_47",
        d: "M16.8212 73.6377C16.2902 74.4448 15.5603 75.1015 14.7018 75.5446C13.8433 75.9877 12.8851 76.2022 11.9197 76.1675C9.43841 76.0497 7.36984 74.318 5.50774 72.6739L0 67.8109L3.64521 67.6365C6.26662 67.511 8.95567 67.394 11.4525 68.2024C13.9493 69.0108 16.252 70.9564 16.7085 73.5407",
        fill: "#9DE8D6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_48",
        d: "M21.9697 80.695C19.9805 77.1753 17.6733 73.2636 13.5506 72.0134C12.4043 71.6669 11.2024 71.5428 10.0095 71.6477C9.63349 71.6802 9.72738 72.2597 10.1027 72.2273C12.1022 72.0613 14.098 72.5893 15.7538 73.7224C17.3473 74.807 18.5879 76.3149 19.638 77.9139C20.2812 78.8934 20.8573 79.9144 21.4336 80.934C21.6177 81.2599 22.156 81.0247 21.9697 80.695Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_49",
        d: "M145.298 81.4814H6.00667C5.95478 81.4814 5.90503 81.4608 5.86834 81.4241C5.83165 81.3875 5.81104 81.3377 5.81104 81.2858C5.81104 81.2339 5.83165 81.1842 5.86834 81.1475C5.90503 81.1108 5.95478 81.0902 6.00667 81.0902H145.298C145.35 81.0902 145.4 81.1108 145.436 81.1475C145.473 81.1842 145.494 81.2339 145.494 81.2858C145.494 81.3377 145.473 81.3875 145.436 81.4241C145.4 81.4608 145.35 81.4814 145.298 81.4814Z",
        fill: "#CCCCCC"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1672", children: /* @__PURE__ */ u("rect", { width: "145.494", height: "81.4815", fill: "white" }) }) })
] }), Xz = (e) => /* @__PURE__ */ T("svg", { width: "72", height: "81", viewBox: "0 0 72 81", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "Illustration", clipPath: "url(#clip0_35_1064)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M40.8994 62.1088C58.0502 62.1088 71.9538 48.2053 71.9538 31.0544C71.9538 13.9035 58.0502 0 40.8994 0C23.7485 0 9.84497 13.9035 9.84497 31.0544C9.84497 48.2053 23.7485 62.1088 40.8994 62.1088Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M61.1929 13.8875H4.30556C4.18358 13.8849 4.0868 13.7839 4.08941 13.6619C4.09194 13.5436 4.18725 13.4483 4.30556 13.4457H61.1929C61.3149 13.4483 61.4117 13.5494 61.4091 13.6713C61.4066 13.7897 61.3113 13.885 61.1929 13.8875Z",
        fill: "#CACACA"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        d: "M41.8058 21.3313H26.0799C24.8987 21.3313 23.9412 22.2888 23.9412 23.47V23.47C23.9412 24.6512 24.8987 25.6087 26.0799 25.6087H41.8058C42.987 25.6087 43.9445 24.6512 43.9445 23.47C43.9445 22.2888 42.987 21.3313 41.8058 21.3313Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M15.921 29.8863H51.9649C53.1461 29.8863 54.1037 30.8438 54.1037 32.025C54.1037 33.2062 53.1461 34.1637 51.9649 34.1637H15.921C14.7398 34.1637 13.7822 33.2062 13.7822 32.025C13.7822 30.8438 14.7398 29.8863 15.921 29.8863Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_5",
        d: "M15.921 38.4412H51.9649C53.1461 38.4412 54.1037 39.3988 54.1037 40.58C54.1037 41.7612 53.1461 42.7187 51.9649 42.7187H15.921C14.7398 42.7187 13.7822 41.7612 13.7822 40.58C13.7822 39.3988 14.7398 38.4412 15.921 38.4412Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M11.4543 80.4186L11.3694 80.4103C8.49133 80.1134 5.88952 78.5655 4.25524 76.1778C3.8076 75.5125 3.44551 74.7935 3.17751 74.0377L3.15175 73.9656L3.22801 73.9595C4.13849 73.8862 5.07383 73.7317 5.48934 73.6582L2.81001 72.7504L2.79344 72.6709C2.6346 71.9246 2.9458 71.1567 3.5794 70.7316C4.21472 70.286 5.05721 70.2718 5.70725 70.6956C5.99896 70.8819 6.30408 71.0665 6.59913 71.245C7.61307 71.8583 8.66153 72.4925 9.44761 73.3603C10.6396 74.7024 11.1621 76.5109 10.8695 78.282L11.4543 80.4186Z",
        fill: "#F2F2F2"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        d: "M21.1935 79.0862L22.5139 79.086L23.1422 73.9924L21.1931 73.9925L21.1935 79.0862Z",
        fill: "#A0616A"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M21.1468 80.4637L25.2076 80.4635V80.4122C25.2076 79.5393 24.4999 78.8317 23.627 78.8316L22.8852 78.2689L21.5012 78.8317L21.1467 78.8317L21.1468 80.4637Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M10.6106 75.4286L11.6668 76.2209L15.2262 72.5236L13.6671 71.3541L10.6106 75.4286Z",
        fill: "#A0616A"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M9.74658 76.5026L12.9949 78.9395L13.0258 78.8984C13.5496 78.2002 13.4082 77.2095 12.71 76.6856L12.4543 75.7902L11.0095 75.4099L10.7259 75.1972L9.74658 76.5026Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_11",
        d: "M15.0002 55.183C15.0002 55.183 15.0731 57.1715 15.165 58.7662C15.1801 59.0277 14.5674 59.3118 14.5833 59.5963C14.5938 59.7851 14.709 59.9686 14.7197 60.1654C14.731 60.3732 14.5719 60.557 14.5833 60.7718C14.5943 60.9817 14.7757 61.2224 14.7867 61.4372C14.9044 63.7491 15.3313 66.5167 14.9039 67.2904C14.6932 67.6717 12.0081 72.9541 12.0081 72.9541C12.0081 72.9541 13.5041 75.1982 13.9316 74.4502C14.4961 73.4622 18.8472 68.8399 18.8472 67.9572C18.8472 67.0756 19.8539 60.4683 19.8539 60.4683L20.5558 64.3785L20.8776 65.1532L20.7765 65.608L20.9845 66.2218L20.9957 66.8292L21.1982 67.9572C21.1982 67.9572 20.5891 76.7456 20.9321 76.9903C21.2762 77.2361 22.9422 77.6774 23.1388 77.2361C23.3344 76.7947 24.6073 68.0641 24.6073 68.0641C24.6073 68.0641 24.8124 64.0632 25.0347 60.3444C25.0475 60.1285 25.1993 59.8678 25.2111 59.6551C25.225 59.4083 25.1288 59.0877 25.1416 58.8483C25.1555 58.5737 25.2773 58.3802 25.2891 58.1174C25.3799 56.0859 24.87 53.6121 24.7076 53.3685C24.2171 52.6333 23.7757 52.0455 23.7757 52.0455C23.7757 52.0455 17.1693 49.8749 15.4039 52.0805L15.0002 55.183Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        d: "M21.5893 34.7349L18.9704 34.2111L17.7482 35.8698C15.4677 38.1121 15.4334 40.0912 15.8405 43.2634V47.7156L15.5458 50.7003C15.5458 50.7003 14.5028 52.882 15.5786 53.39C16.6544 53.898 23.721 53.8547 24.3957 53.6519C25.0704 53.4491 24.4856 53.2002 24.3084 52.2551C23.9756 50.48 24.1982 51.3363 24.2211 50.7711C24.5495 42.6635 23.7846 39.335 23.707 38.4601L22.375 36.0444L21.5893 34.7349Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        d: "M35.3927 41.2719C35.1197 41.7891 34.4792 41.987 33.9621 41.7141C33.9069 41.685 33.8544 41.6511 33.8053 41.6127L28.1494 45.2039L28.1657 43.2487L33.66 40.0603C34.0513 39.6215 34.7243 39.5831 35.163 39.9744C35.5302 40.3019 35.6251 40.8383 35.3927 41.2719Z",
        fill: "#A0616A"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_14",
        d: "M19.5214 36.9993L18.8775 36.9311C18.2826 36.8693 17.6988 37.1242 17.3395 37.6024C17.2019 37.7838 17.1031 37.9915 17.0492 38.2127L17.0488 38.2144C16.8873 38.8802 17.1406 39.5779 17.6917 39.9849L19.9156 41.6246C21.4763 43.7335 24.4095 45.1326 27.8502 46.2693L33.1982 42.9478L31.3066 40.6568L27.6384 42.6228L22.1857 38.4019L22.1826 38.3993L20.1073 37.0623L19.5214 36.9993Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_15",
        d: "M20.7045 33.4489C22.3912 33.4489 23.7585 32.0815 23.7585 30.3948C23.7585 28.7081 22.3912 27.3408 20.7045 27.3408C19.0177 27.3408 17.6504 28.7081 17.6504 30.3948C17.6504 32.0815 19.0177 33.4489 20.7045 33.4489Z",
        fill: "#A0616A"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_16",
        d: "M20.775 33.4496C20.7504 33.4504 20.7257 33.4509 20.7011 33.4516C20.6905 33.479 20.6791 33.5061 20.666 33.5327L20.775 33.4496Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_17",
        d: "M21.613 30.4796C21.6178 30.5097 21.6252 30.5393 21.6349 30.5681C21.6309 30.5379 21.6236 30.5082 21.613 30.4796Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_18",
        d: "M23.7975 27.4714C23.6718 27.8618 23.5596 27.3666 23.1461 27.4557C22.6486 27.5628 22.0697 27.526 21.6623 27.2211C21.0553 26.7757 20.2687 26.6559 19.5566 26.9002C18.8595 27.1468 17.6917 27.3207 17.5101 28.0374C17.4469 28.2866 17.4218 28.5569 17.2688 28.7634C17.135 28.944 16.9238 29.0469 16.7472 29.1858C16.1509 29.655 16.6067 30.9879 16.8889 31.6923C17.1711 32.3966 17.8185 32.9096 18.5303 33.1724C19.219 33.4267 19.9664 33.4716 20.7011 33.4516C20.8289 33.1202 20.7737 32.7374 20.6682 32.3939C20.5541 32.0219 20.3851 31.663 20.3374 31.2769C20.2897 30.8908 20.3944 30.4522 20.7182 30.2365C21.0157 30.0382 21.5 30.159 21.6132 30.4796C21.5472 30.0787 21.9532 29.6909 22.3718 29.6227C22.8213 29.5494 23.2708 29.7117 23.719 29.7925C24.1672 29.8733 24.0081 27.9863 23.7975 27.4714Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_19",
        d: "M40.8782 35.4469C41.1629 32.0068 38.605 28.9873 35.165 28.7026C31.725 28.4179 28.7055 30.9758 28.4208 34.4158C28.1361 37.8559 30.694 40.8754 34.134 41.1601C37.574 41.4448 40.5935 38.8869 40.8782 35.4469Z",
        fill: "#70D4BC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_20",
        d: "M36.291 32.3272L34.6492 33.969L33.0074 32.3272C32.7417 32.0615 32.3108 32.0615 32.045 32.3272C31.7793 32.593 31.7793 33.0239 32.045 33.2896L33.6868 34.9314L32.045 36.5732C31.7795 36.8392 31.7799 37.27 32.0459 37.5356C32.3116 37.8007 32.7418 37.8007 33.0074 37.5356L34.6492 35.8938L36.291 37.5356C36.557 37.8011 36.9879 37.8007 37.2534 37.5347C37.5185 37.269 37.5185 36.8388 37.2534 36.5732L35.6116 34.9314L37.2534 33.2896C37.5191 33.0239 37.5191 32.593 37.2534 32.3272C36.9876 32.0615 36.5567 32.0615 36.291 32.3272Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_21",
        d: "M32.1864 29.6782C32.3706 30.2332 32.0701 30.8325 31.5151 31.0167C31.4559 31.0363 31.3951 31.0507 31.3334 31.0597L30.0093 37.6272L28.6096 36.2618L30.1125 30.0898C30.0669 29.5036 30.505 28.9914 31.0912 28.9457C31.5817 28.9075 32.0344 29.2103 32.1864 29.6782Z",
        fill: "#A0616A"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M18.1154 38.173L17.6204 38.5904C17.164 38.977 16.9437 39.5747 17.0401 40.165C17.0757 40.3899 17.1572 40.605 17.2795 40.7971L17.2805 40.7986C17.6491 41.376 18.3279 41.6762 19.0031 41.5604L21.726 41.0907C24.3283 41.4245 27.3685 40.2765 30.5707 38.5806L31.8765 32.422L28.9137 32.2009L27.7928 36.209L20.972 37.2215L20.968 37.222L18.5665 37.7939L18.1154 38.173Z",
        fill: "#374151"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_23",
        d: "M33.6196 80.5691L0.395104 80.6067C0.314706 80.6064 0.24974 80.541 0.250001 80.4606C0.250259 80.3806 0.315072 80.3158 0.395104 80.3155L33.6196 80.278C33.7 80.2782 33.765 80.3436 33.7647 80.424C33.7645 80.504 33.6997 80.5688 33.6196 80.5691Z",
        fill: "#CACACA"
      }
    ),
    /* @__PURE__ */ T("g", { id: "Group", children: [
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_24",
          d: "M7.19163 11.0895C7.76265 11.0895 8.22555 10.6163 8.22555 10.0326C8.22555 9.44882 7.76265 8.9756 7.19163 8.9756C6.62062 8.9756 6.15771 9.44882 6.15771 10.0326C6.15771 10.6163 6.62062 11.0895 7.19163 11.0895Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_25",
          d: "M10.7634 11.0895C11.3344 11.0895 11.7973 10.6163 11.7973 10.0326C11.7973 9.44883 11.3344 8.97562 10.7634 8.97562C10.1924 8.97562 9.72949 9.44883 9.72949 10.0326C9.72949 10.6163 10.1924 11.0895 10.7634 11.0895Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_26",
          d: "M14.3349 11.0895C14.906 11.0895 15.3689 10.6163 15.3689 10.0326C15.3689 9.44883 14.906 8.97562 14.3349 8.97562C13.7639 8.97562 13.301 9.44883 13.301 10.0326C13.301 10.6163 13.7639 11.0895 14.3349 11.0895Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_27",
          d: "M18.4076 10.868C18.3758 10.868 18.3441 10.8557 18.3202 10.8312L17.6225 10.118C17.576 10.0705 17.576 9.99459 17.6225 9.94707L18.3202 9.23398C18.3675 9.18574 18.445 9.18497 18.493 9.23207C18.5413 9.27929 18.5422 9.35672 18.4949 9.40495L17.881 10.0326L18.4949 10.6602C18.5422 10.7085 18.5413 10.7859 18.493 10.8331C18.4693 10.8564 18.4384 10.868 18.4076 10.868Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_28",
          d: "M19.5798 10.868C19.5489 10.868 19.5181 10.8564 19.4943 10.8331C19.446 10.7859 19.4452 10.7085 19.4924 10.6602L20.1063 10.0326L19.4924 9.40495C19.4452 9.35672 19.446 9.27929 19.4943 9.23207C19.5425 9.18479 19.62 9.18568 19.6672 9.23398L20.3648 9.94707C20.4113 9.99459 20.4113 10.0705 20.3648 10.118L19.6672 10.8312C19.6432 10.8557 19.6115 10.868 19.5798 10.868Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_29",
          d: "M56.0762 9.09801H54.779C54.631 9.09801 54.5112 9.21782 54.5112 9.36576V10.6642C54.5112 10.8121 54.631 10.9319 54.779 10.9319H56.0762C56.2241 10.9319 56.3452 10.8121 56.3452 10.6642V9.36576C56.3452 9.21782 56.2241 9.09801 56.0762 9.09801Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_30",
          d: "M52.8975 9.09801H51.6003C51.4523 9.09801 51.3325 9.21782 51.3325 9.36576V10.6642C51.3325 10.8121 51.4523 10.9319 51.6003 10.9319H52.8975C53.0454 10.9319 53.1664 10.8121 53.1664 10.6642V9.36576C53.1664 9.21782 53.0454 9.09801 52.8975 9.09801Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_31",
          d: "M59.0715 9.15912H57.7743C57.6264 9.15912 57.5066 9.27893 57.5066 9.42687V10.7253C57.5066 10.8732 57.6264 10.993 57.7743 10.993H59.0715C59.2195 10.993 59.3405 10.8732 59.3405 10.7253V9.42687C59.3405 9.27893 59.2195 9.15912 59.0715 9.15912Z",
          fill: "#374151"
        }
      ),
      /* @__PURE__ */ u(
        "path",
        {
          id: "Vector_32",
          d: "M39.5192 9.65306H29.1502C28.9692 9.65306 28.8237 9.79978 28.8237 9.9795C28.8237 10.1592 28.9692 10.3059 29.1502 10.3059H39.5192C39.6989 10.3059 39.8456 10.1592 39.8456 9.9795C39.8456 9.79978 39.6989 9.65306 39.5192 9.65306Z",
          fill: "#374151"
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1064", children: /* @__PURE__ */ u("rect", { width: "71.7037", height: "80.6067", fill: "white", transform: "translate(0.25)" }) }) })
] }), Uz = (e) => /* @__PURE__ */ T("svg", { width: "146", height: "82", viewBox: "0 0 146 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { id: "Illustration", clipPath: "url(#clip0_35_1725)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        id: "Path 133",
        d: "M12.2663 67.1234C13.5034 69.0875 15.0106 70.8673 16.7433 72.4102C16.7828 72.4464 16.8235 72.4811 16.8642 72.5166L20.5636 70.3144C20.5363 70.2771 20.506 70.2353 20.4737 70.1896C18.5421 67.4954 9.81847 49.5714 9.76517 45.6022C9.75844 45.9307 6.62569 58.267 12.2663 67.1234Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Path 134",
        d: "M16.0294 72.8351C16.0866 72.8608 16.1449 72.8858 16.2036 72.9097L18.9791 71.2575C18.9357 71.2324 18.8852 71.2028 18.8272 71.1696C17.8771 70.6135 15.0501 68.9427 12.2666 67.1231C9.27577 65.1673 6.33356 63.041 5.823 61.9414C5.92924 62.1945 9.22226 69.8841 16.0294 72.8351Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Path 133_2",
        d: "M133.275 74.3491C133.213 76.6708 132.825 78.9722 132.122 81.1854C132.106 81.2367 132.089 81.2873 132.072 81.3387H127.769C127.773 81.2926 127.778 81.2413 127.783 81.1854C128.069 77.8807 126.43 58.0071 124.452 54.5675C124.626 54.8465 133.609 63.8486 133.275 74.3491Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Path 134_2",
        d: "M132.952 81.1853C132.916 81.2367 132.879 81.288 132.84 81.3386H129.612C129.636 81.2949 129.665 81.2435 129.698 81.1853C130.231 80.221 131.809 77.3379 133.275 74.349C134.849 71.1371 136.294 67.8034 136.172 66.5968C136.21 66.8688 137.299 75.1647 132.952 81.1853Z",
        fill: "#E6E6E6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector",
        d: "M69.8272 81.2187H20.0629C18.8834 81.2174 17.7526 80.7474 16.9185 79.9118C16.0845 79.0762 15.6153 77.9432 15.614 76.7615V4.45721C15.6153 3.27549 16.0845 2.14256 16.9185 1.30696C17.7526 0.471359 18.8834 0.00133395 20.0629 0H69.8272C71.0067 0.00133395 72.1375 0.471358 72.9716 1.30696C73.8056 2.14255 74.2748 3.27549 74.2761 4.4572V76.7615C74.2747 77.9432 73.8056 79.0762 72.9716 79.9118C72.1375 80.7474 71.0067 81.2174 69.8272 81.2187Z",
        fill: "#CACACA"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_2",
        d: "M69.9147 78.3748H19.9752C19.6116 78.3744 19.263 78.2295 19.0059 77.9719C18.7488 77.7144 18.6042 77.3651 18.6038 77.0008V4.21767C18.6042 3.85339 18.7488 3.50416 19.0059 3.24658C19.263 2.989 19.6116 2.84411 19.9752 2.84369H69.9147C70.2783 2.8441 70.6269 2.989 70.884 3.24658C71.1411 3.50416 71.2857 3.85339 71.2861 4.21767V77.0008C71.2857 77.3651 71.1411 77.7144 70.884 77.9719C70.6269 78.2295 70.2783 78.3744 69.9147 78.3748Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_3",
        d: "M44.7559 1.74425C44.9649 1.74425 45.1344 1.57448 45.1344 1.36507C45.1344 1.15566 44.9649 0.985901 44.7559 0.985901C44.5469 0.985901 44.3774 1.15566 44.3774 1.36507C44.3774 1.57448 44.5469 1.74425 44.7559 1.74425Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_4",
        d: "M144.851 81.4815H0.185555C0.136343 81.4815 0.0891464 81.4619 0.0543478 81.427C0.0195492 81.3922 0 81.3449 0 81.2956C0 81.2463 0.0195492 81.199 0.0543478 81.1641C0.0891464 81.1293 0.136343 81.1097 0.185555 81.1097H144.851C144.901 81.1097 144.948 81.1293 144.983 81.1641C145.017 81.199 145.037 81.2463 145.037 81.2956C145.037 81.3449 145.017 81.3922 144.983 81.427C144.948 81.4619 144.901 81.4815 144.851 81.4815Z",
        fill: "#CACACA"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_5",
        d: "M44.9446 60.321C47.6127 60.321 49.7756 58.1541 49.7756 55.481C49.7756 52.8079 47.6127 50.6409 44.9446 50.6409C42.2765 50.6409 40.1135 52.8079 40.1135 55.481C40.1135 58.1541 42.2765 60.321 44.9446 60.321Z",
        fill: "#E4E4E4"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_6",
        d: "M47.9692 46.191H41.92L38.2681 28.2935C38.1742 27.359 38.2769 26.4151 38.5695 25.5227C38.8621 24.6303 39.338 23.8093 39.9667 23.1125C40.5954 22.4157 41.3628 21.8586 42.2195 21.4771C43.0763 21.0957 44.0033 20.8983 44.9408 20.8977C45.8783 20.8972 46.8056 21.0935 47.6628 21.4739C48.5199 21.8543 49.288 22.4105 49.9175 23.1066C50.547 23.8026 51.024 24.6231 51.3176 25.5151C51.6112 26.4072 51.715 27.3509 51.6223 28.2856L47.9692 46.191Z",
        fill: "#E4E4E4"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_7",
        d: "M68.7129 22.1342H90.8226C91.8895 22.1342 92.9247 22.4979 93.758 23.1654C94.5912 23.833 95.173 24.7647 95.4076 25.8074L106.579 75.4524C106.701 75.9939 106.703 76.5555 106.586 77.0979C106.468 77.6403 106.233 78.1504 105.898 78.5923C105.563 79.0342 105.135 79.3973 104.645 79.6562C104.155 79.915 103.614 80.0632 103.06 80.0905L80.3316 81.2125C79.1145 81.2726 77.9172 80.887 76.9631 80.1276C76.0089 79.3682 75.3632 78.287 75.1463 77.0857L68.809 41.9862L67.6103 35.3469L65.8414 25.5494C65.7656 25.1297 65.7832 24.6985 65.8928 24.2864C66.0025 23.8744 66.2015 23.4916 66.4758 23.1655C66.75 22.8393 67.0927 22.5778 67.4794 22.3995C67.8661 22.2213 68.2873 22.1307 68.7129 22.1342Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_8",
        d: "M87.9118 23.2045H90.4927C91.2339 23.2045 91.9527 23.4585 92.53 23.9243C93.1072 24.39 93.5081 25.0395 93.6661 25.765L104.389 75.0049C104.451 75.2884 104.451 75.5819 104.389 75.8654C104.327 76.1489 104.205 76.4156 104.031 76.6474C103.857 76.8793 103.635 77.0707 103.38 77.2087C103.125 77.3466 102.844 77.4279 102.555 77.4468L79.8992 78.9344C79.26 78.9764 78.6278 78.7811 78.1232 78.3859C77.6186 77.9906 77.2769 77.4231 77.1634 76.7915L68.0132 25.8973C67.954 25.5679 67.9676 25.2295 68.0532 24.9059C68.1388 24.5824 68.2942 24.2816 68.5085 24.0248C68.7228 23.768 68.9907 23.5615 69.2933 23.4197C69.596 23.278 69.926 23.2045 70.2601 23.2045H72.7084C72.9454 23.2045 73.1758 23.2828 73.3639 23.4272C73.5519 23.5716 73.6873 23.7741 73.7489 24.0034C73.8033 24.2058 73.9227 24.3845 74.0888 24.512C74.2548 24.6395 74.4582 24.7086 74.6674 24.7086H86.2906C86.7002 24.7086 87.0948 24.5537 87.3954 24.2748C87.6959 23.996 87.8804 23.6137 87.9118 23.2045Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_9",
        d: "M99.3463 38.9883C99.4187 39.0353 99.4873 39.0878 99.5515 39.1456L107.041 37.2329L107.551 35.4228L110.379 35.8382L109.785 39.1307C109.737 39.3967 109.605 39.6399 109.407 39.8239C109.209 40.0078 108.957 40.1225 108.689 40.1508L99.9446 41.0734C99.8021 41.3741 99.5716 41.6241 99.2838 41.7903C98.9959 41.9565 98.6644 42.0309 98.3334 42.0038C98.0023 41.9766 97.6873 41.8491 97.4303 41.6382C97.1733 41.4273 96.9865 41.143 96.8947 40.8231C96.803 40.5032 96.8105 40.163 96.9165 39.8475C97.0225 39.5321 97.2218 39.2565 97.4879 39.0573C97.7541 38.8581 98.0744 38.7448 98.4064 38.7325C98.7384 38.7202 99.0662 38.8094 99.3463 38.9883Z",
        fill: "#FFB6B6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_10",
        d: "M94.0017 45.7771C96.6698 45.7771 98.8328 43.6101 98.8328 40.937C98.8328 38.2639 96.6698 36.0969 94.0017 36.0969C91.3336 36.0969 89.1707 38.2639 89.1707 40.937C89.1707 43.6101 91.3336 45.7771 94.0017 45.7771Z",
        fill: "#70D4BC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_11",
        d: "M97.0263 31.647H90.9771L87.3252 13.7496C87.2314 12.815 87.334 11.8711 87.6266 10.9788C87.9192 10.0864 88.3951 9.26533 89.0238 8.56853C89.6525 7.87173 90.4199 7.31464 91.2767 6.93318C92.1334 6.55172 93.0604 6.35435 93.9979 6.35379C94.9355 6.35323 95.8627 6.54951 96.7199 6.92995C97.5771 7.31039 98.3452 7.86657 98.9747 8.56262C99.6042 9.25868 100.081 10.0792 100.375 10.9712C100.668 11.8632 100.772 12.807 100.679 13.7417L97.0263 31.647Z",
        fill: "#70D4BC"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_12",
        d: "M110.884 37.4813L108.955 39.1488L106.256 41.4798L105.064 35.3688L104.939 34.7333L104.841 34.229L107.576 29.4561L109.856 29.5872L110.012 29.5966L110.015 29.631L110.051 29.951L110.518 34.1635L110.529 34.2649L110.884 37.4813Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_13",
        d: "M98.274 79.2738L96.3634 79.2737L95.4543 71.8905L98.2743 71.8907L98.274 79.2738Z",
        fill: "#FFB6B6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_14",
        d: "M98.7613 81.1293L92.6008 81.1291V81.051C92.6009 80.4139 92.8535 79.8029 93.3032 79.3524C93.7529 78.9019 94.3627 78.6488 94.9987 78.6487H94.9988L98.7614 78.6489L98.7613 81.1293Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_15",
        d: "M118.222 79.43L116.311 79.4298L115.402 72.0467L118.222 72.0468L118.222 79.43Z",
        fill: "#FFB6B6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_16",
        d: "M118.709 81.2853L112.548 81.285V81.207C112.548 80.5699 112.801 79.9588 113.251 79.5083C113.7 79.0578 114.31 78.8047 114.946 78.8047H114.946L118.709 78.8048L118.709 81.2853Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_17",
        d: "M119.749 76.1785L114.606 76.9592L107.124 51.5909L99.1777 77.1153L93.4116 76.3346L100.892 46.6696V44.3276L101.905 40.8146L101.799 39.8638L101.062 33.2141L100.742 30.3304L100.722 30.1441C100.704 29.9878 100.746 29.8305 100.838 29.7031C100.93 29.5756 101.066 29.487 101.219 29.4545L103.619 28.9486H107.542L109.856 29.5872L110.015 29.6309L110.087 29.6512L110.051 29.951L109.508 34.5069L109.479 34.7567L108.955 39.1487L108.84 40.112C113.359 43.3908 113.515 46.6696 113.515 46.6696L119.749 76.1785Z",
        fill: "#2F2E41"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_18",
        d: "M105.106 26.9732C107.22 26.9732 108.934 25.2564 108.934 23.1385C108.934 21.0206 107.22 19.3037 105.106 19.3037C102.992 19.3037 101.279 21.0206 101.279 23.1385C101.279 25.2564 102.992 26.9732 105.106 26.9732Z",
        fill: "#FFB6B6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_19",
        d: "M109.127 39.2309L101.555 40.2229L101.696 41.3066L109.268 40.3146L109.127 39.2309Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_20",
        d: "M91.3986 40.5495C91.471 40.5964 91.5396 40.649 91.6037 40.7068L99.0928 38.794L99.6037 36.9839L102.431 37.3994L101.838 40.6919C101.79 40.9579 101.657 41.2011 101.459 41.385C101.261 41.569 101.01 41.6837 100.741 41.712L91.9968 42.6346C91.8543 42.9353 91.6238 43.1853 91.336 43.3515C91.0482 43.5177 90.7167 43.5921 90.3856 43.565C90.0545 43.5378 89.7395 43.4103 89.4825 43.1994C89.2256 42.9885 89.0388 42.7042 88.947 42.3843C88.8552 42.0644 88.8628 41.7241 88.9687 41.4087C89.0747 41.0933 89.274 40.8176 89.5402 40.6185C89.8063 40.4193 90.1267 40.306 90.4586 40.2937C90.7906 40.2814 91.1184 40.3706 91.3986 40.5495Z",
        fill: "#FFB6B6"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_21",
        d: "M102.918 30.4318L101.593 29.4169C101.235 29.2808 100.744 29.6675 100.658 30.0415L98.7881 37.6919L102.684 40.5023L103.23 39.6436L102.918 30.4318Z",
        fill: "#3F3D56"
      }
    ),
    /* @__PURE__ */ u("g", { id: "Group", opacity: "0.2", children: /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_22",
        d: "M110.518 34.1634C110.187 34.2949 109.85 34.4095 109.508 34.5069C109.399 34.5397 109.287 34.5709 109.176 34.6006C108.447 34.8033 107.697 34.9248 106.942 34.9628C106.616 34.9766 106.29 34.9677 105.966 34.9363C105.618 34.9015 105.274 34.8335 104.939 34.7333C104.928 34.7302 104.916 34.727 104.905 34.7239C104.208 34.5257 103.569 34.162 103.042 33.6638C102.925 33.549 102.815 33.4264 102.714 33.2969C102.423 32.9398 102.209 32.5259 102.087 32.0815C101.964 31.6371 101.936 31.1721 102.003 30.716C102.016 30.6334 102.034 30.5515 102.056 30.4709C102.115 30.2512 102.192 30.037 102.288 29.8307C102.33 29.7339 102.377 29.6387 102.427 29.545L104.188 28.9486H107.542L109.856 29.5872L110.012 29.5966L110.015 29.6309L110.086 29.6512L110.051 29.951L110.518 34.1634Z",
        fill: "black"
      }
    ) }),
    /* @__PURE__ */ u(
      "path",
      {
        id: "Vector_23",
        d: "M102.173 19.9638C101.457 19.8759 100.672 19.938 100.114 20.3959C99.556 20.8537 99.3759 21.8054 99.9042 22.2973C100.372 22.7327 101.103 22.6303 101.729 22.7542C102.269 22.8753 102.753 23.1744 103.102 23.6034C103.452 24.0324 103.648 24.5667 103.659 25.1206C103.65 26.7091 102.128 27.9121 101.855 29.4768C101.669 30.5447 102.118 31.6686 102.895 32.423C103.672 33.1773 104.741 33.585 105.817 33.6954C106.894 33.8058 107.982 33.6372 109.029 33.3601C110.079 33.0819 111.113 32.6871 111.995 32.0505C112.876 31.4138 113.599 30.5164 113.882 29.4653C114.165 28.4142 113.962 27.209 113.233 26.402C112.397 25.4778 111.008 25.16 110.286 24.145C109.476 23.0071 109.775 21.3867 109.12 20.1531C108.682 19.3295 107.854 18.7677 106.971 18.4718C106.088 18.1759 105.144 18.1175 104.214 18.0888C103.724 18.0737 103.22 18.0687 102.764 18.2474C102.308 18.4261 101.908 18.8334 101.884 19.3233C101.86 19.8131 102.173 19.9638 102.173 19.9638Z",
        fill: "#2F2E41"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_35_1725", children: /* @__PURE__ */ u("rect", { width: "145.037", height: "81.4815", fill: "white" }) }) })
] }), Jz = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AvailabilityIcon: Bz,
  HistoricalIcon: Gz,
  OeeIcon: $z,
  ParetoForMachinesIcon: Wz,
  ParetoForStopsIcon: Zz,
  ProductionIcon: Yz,
  ProductionPerShiftIcon: jz,
  ShiftAnalysisIcon: zz,
  StopAnnotationIcon: Xz,
  StopsIcon: Uz
}, Symbol.toStringTag, { value: "Module" }));
function nne({ className: e, fill: t, width: n, height: r, ...o }) {
  const a = Xe(() => Jz[Ox(o.name)], [o.name]);
  return /* @__PURE__ */ u(
    a,
    {
      className: P(e),
      width: n || r || 100,
      height: r || n || 100,
      fill: t,
      ...o
    }
  );
}
const Kz = Xt(
  "tw-group tw-flex tw-w-full tw-items-center tw-justify-between tw-flex tw-gap-8px tw-overflow-hidden tw-border-l-2 tw-px-8px tw-py-8px",
  {
    variants: {
      variant: {
        info: "tw-text-system-text-default tw-border-toast-text-info tw-bg-[#F9FAFB]",
        success: "tw-text-toast-text-success tw-border-toast-text-success tw-bg-toast-background-success",
        error: "tw-text-toast-text-error tw-border-toast-text-error tw-bg-toast-background-error",
        warning: "tw-text-toast-text-warning tw-border-toast-text-warning tw-bg-toast-background-warning"
      }
    },
    defaultVariants: {
      variant: "info"
    }
  }
), Ap = {
  info: "tw-text-toast-text-info",
  success: "tw-text-toast-text-success",
  error: "tw-text-toast-text-error",
  warning: "tw-text-toast-text-warning"
}, qz = {
  info: /* @__PURE__ */ u(c8, { size: 24, className: "tw-text-toast-text-info" }),
  success: /* @__PURE__ */ u(i8, { size: 24, className: "tw-text-toast-text-success" }),
  error: /* @__PURE__ */ u(u8, { size: 24, className: "tw-text-toast-text-error" }),
  warning: /* @__PURE__ */ u(a8, { size: 24, className: "tw-text-toast-text-warning" })
}, rne = ({ className: e, variant: t, title: n, subtitle: r }) => /* @__PURE__ */ T("div", { className: P(Kz({ variant: t }), e), children: [
  qz[t],
  /* @__PURE__ */ T("div", { className: "tw-flex-1 tw-flex tw-justify-center tw-flex-col tw-gap-8px", children: [
    /* @__PURE__ */ u(De, { className: Ap[t], variant: "normal", children: n }),
    r && /* @__PURE__ */ u(De, { className: Ap[t], variant: "normal", lineHeight: "16px", children: r })
  ] })
] }), one = b.forwardRef(({ className: e, children: t, label: n, ...r }, o) => /* @__PURE__ */ u(
  "div",
  {
    ref: o,
    className: P("tw-bg-gray-50 tw-border-gray-200 tw-border tw-rounded tw-px-2 tw-py-1 tw-w-fit", e),
    ...r,
    children: n ? /* @__PURE__ */ u("p", { className: "tw-leading-4 tw-font-sans tw-text-sm tw-text-grayscale-text-body tw-font-normal", children: n }) : t
  }
)), ane = (e) => {
  var l;
  const [t, n] = ue((/* @__PURE__ */ new Date()).getTime()), [r, o] = ue(e.options), [a, i] = ue(void 0), s = (c) => {
    e.onOpenChange != null && e.onOpenChange(c), o(e.options);
  };
  return /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-start tw-gap-8px", children: [
    /* @__PURE__ */ T(
      p8,
      {
        onValueChange: (c) => {
          e.onChange != null && e.onChange(c);
        },
        value: (l = e.value) == null ? void 0 : l.toString(),
        disabled: e.isDisabled,
        onOpenChange: s,
        children: [
          /* @__PURE__ */ T(
            g2,
            {
              className: P(
                "tw-w-[300px] tw-h-[56px]",
                e.error && "tw-border-errorRed",
                e.smallerVariant && "tw-w-[120px]",
                e.selectButtonClassName
              ),
              children: [
                /* @__PURE__ */ u(h8, { placeholder: e.placeholder }),
                /* @__PURE__ */ u(b2, { asChild: !0, children: e.value && e.allowClear && !e.isDisabled ? /* @__PURE__ */ u(
                  rt,
                  {
                    className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label",
                    onPointerDown: (c) => {
                      c.stopPropagation(), e.onChange != null && e.onChange(null), e.onClear != null && e.onClear(), n(+(/* @__PURE__ */ new Date()).getTime());
                    }
                  }
                ) : e.smallerVariant ? /* @__PURE__ */ u(qn, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) : /* @__PURE__ */ u(la, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) })
              ]
            }
          ),
          /* @__PURE__ */ T(
            w8,
            {
              className: P("tw-w-[200%]", e.selectContentClassName),
              isSearchEnabled: e.isSearchEnabled,
              searchPlaceholder: e.searchPlaceholder,
              optionsLength: e.options.length,
              showScrollDownButton: r.length > 0,
              onInputChange: (c) => {
                const d = [...e.options];
                o(
                  d.filter(
                    (f) => f.label.trim().toLocaleLowerCase().includes(c.trim().toLocaleLowerCase())
                  )
                );
              },
              smallerVariant: e.smallerVariant,
              selectedImageUrl: a,
              children: [
                e.options.map((c) => /* @__PURE__ */ u(
                  w2,
                  {
                    className: P(
                      "data-[highlighted]:tw-bg-grayscale-surface-light tw-text-grayscale-text-body tw-overflow-x-hidden tw-text-ellipsis",
                      !r.map((d) => d.value).includes(c.value) && "tw-hidden"
                    ),
                    value: c.value.toString(),
                    onMouseEnter: () => {
                      i(c.imageUrl);
                    },
                    onMouseLeave: () => {
                      i(void 0);
                    },
                    children: c.label
                  },
                  c.value
                )),
                e.options.length === 0 && /* @__PURE__ */ u("div", { className: "tw-py-12px tw-text-center", role: "presentation", children: /* @__PURE__ */ u(De, { variant: "label", lineHeight: "20px", children: e.noOptionText ?? "No option" }) }),
                e.options.length > 0 && r.length === 0 && /* @__PURE__ */ u("div", { className: "tw-py-12px tw-text-center", role: "presentation", children: /* @__PURE__ */ u(De, { variant: "label", lineHeight: "20px", children: e.emptyResultText }) })
              ]
            }
          )
        ]
      },
      t
    ),
    e.error ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) : e.helperText && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: e.helperText })
  ] });
};
var V0 = "Progress", k0 = 100, [Qz, ine] = st(V0), [eX, tX] = Qz(V0), tC = b.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: a = nX,
      ...i
    } = e;
    (o || o === 0) && !_p(o) && console.error(rX(`${o}`, "Progress"));
    const s = _p(o) ? o : k0;
    r !== null && !Op(r, s) && console.error(oX(`${r}`, "Progress"));
    const l = Op(r, s) ? r : null, c = $l(l) ? a(l, s) : void 0;
    return /* @__PURE__ */ u(eX, { scope: n, value: l, max: s, children: /* @__PURE__ */ u(
      ie.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": $l(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": oC(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
tC.displayName = V0;
var nC = "ProgressIndicator", rC = b.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = tX(nC, n);
    return /* @__PURE__ */ u(
      ie.div,
      {
        "data-state": oC(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
rC.displayName = nC;
function nX(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function oC(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function $l(e) {
  return typeof e == "number";
}
function _p(e) {
  return $l(e) && !isNaN(e) && e > 0;
}
function Op(e, t) {
  return $l(e) && !isNaN(e) && e <= t && e >= 0;
}
function rX(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${k0}\`.`;
}
function oX(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${k0} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var F0 = tC, aC = rC;
const aX = ({
  className: e,
  value: t,
  size: n = 72,
  strokeWidth: r = 6,
  showPercentage: o = !0,
  customText: a,
  ...i
}) => {
  const s = n / 2, l = s - r / 2, c = 2 * Math.PI * l, d = c - (t || 0) / 100 * c, f = n / 5;
  return /* @__PURE__ */ u(F0, { className: P("tw-relative", e), style: { width: n, height: n }, ...i, children: /* @__PURE__ */ T("svg", { width: n, height: n, children: [
    /* @__PURE__ */ u(
      "circle",
      {
        className: "tw-stroke-grayscale-surface-subtle",
        strokeWidth: r,
        fill: "transparent",
        r: l,
        cx: s,
        cy: s
      }
    ),
    /* @__PURE__ */ u(aC, { asChild: !0, children: /* @__PURE__ */ u(
      "circle",
      {
        className: "tw-stroke-brand-dark tw-transition-all",
        strokeWidth: r,
        strokeLinecap: "round",
        fill: "transparent",
        r: l,
        cx: s,
        cy: s,
        style: {
          strokeDasharray: c,
          strokeDashoffset: d,
          transform: "rotate(-90deg)",
          transformOrigin: "50% 50%"
        }
      }
    ) }),
    /* @__PURE__ */ u(
      "text",
      {
        x: "50%",
        y: "50%",
        textAnchor: "middle",
        dominantBaseline: "central",
        className: "tw-fill-grayscale-text-body tw-font-semibold",
        style: { fontSize: `${f}px` },
        children: a || (o ? `${Math.round(t || 0)}%` : "")
      }
    )
  ] }) });
};
aX.displayName = "RadialProgress";
const iX = b.forwardRef(({ className: e, value: t, ...n }, r) => /* @__PURE__ */ u(
  F0,
  {
    ref: r,
    className: P(
      "tw-relative tw-h-2 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-grayscale-surface-subtle tw-border tw-border-grayscale-default",
      e
    ),
    ...n,
    children: /* @__PURE__ */ u(
      aC,
      {
        className: "tw-h-full tw-w-full tw-flex-1 tw-bg-brand-dark tw-transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
iX.displayName = F0.displayName;
const sX = Uv, lX = Jv, cX = b.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ T(
  Gc,
  {
    ref: o,
    className: P(
      "tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none focus:tw-bg-accent data-[state=open]:tw-bg-accent",
      t && "tw-pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ u(hc, { className: "tw-ml-auto tw-h-4 tw-w-4" })
    ]
  }
));
cX.displayName = Gc.displayName;
const uX = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Wc,
  {
    ref: n,
    className: P(
      "tw-z-[999999] tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-p-1 tw-text-popover-foreground tw-shadow-lg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
uX.displayName = Wc.displayName;
const iC = b.forwardRef(({ className: e, sideOffset: t = 4, align: n, ...r }, o) => /* @__PURE__ */ u(f3, { children: /* @__PURE__ */ u(
  Lc,
  {
    align: n,
    ref: o,
    sideOffset: t,
    className: P(
      "tw-z-[999999] -tw-left-3 tw-min-w-[8rem] tw-overflow-hidden tw-rounded-md tw-border tw-bg-popover tw-p-1 tw-text-popover-foreground tw-shadow-md data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
iC.displayName = Lc.displayName;
const dX = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ u(
  Vc,
  {
    ref: r,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-px-2 tw-py-1.5 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
      t && "tw-pl-8",
      e
    ),
    ...n
  }
));
dX.displayName = Vc.displayName;
const fX = b.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ T(
  kc,
  {
    ref: o,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(Hc, { children: /* @__PURE__ */ u(sa, { className: "tw-h-4 tw-w-4" }) }) }),
      t
    ]
  }
));
fX.displayName = kc.displayName;
const pX = b.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ T(
  Fc,
  {
    ref: r,
    className: P(
      "tw-relative tw-flex tw-cursor-default tw-select-none tw-items-center tw-rounded-sm tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-sm tw-outline-none tw-transition-colors focus:tw-bg-accent focus:tw-text-accent-foreground data-[disabled]:tw-pointer-events-none data-[disabled]:tw-opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ u("span", { className: "tw-absolute tw-left-2 tw-flex tw-h-3.5 tw-w-3.5 tw-items-center tw-justify-center", children: /* @__PURE__ */ u(Hc, { children: /* @__PURE__ */ u(v2, { className: "tw-h-2 tw-w-2 tw-fill-current" }) }) }),
      t
    ]
  }
));
pX.displayName = Fc.displayName;
const hX = b.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ u(
  Rc,
  {
    ref: r,
    className: P("tw-px-2 tw-py-1.5 tw-text-sm tw-font-semibold", t && "tw-pl-8", e),
    ...n
  }
));
hX.displayName = Rc.displayName;
const mX = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  Bc,
  {
    ref: n,
    className: P("tw--mx-1 tw-my-1 tw-h-px tw-bg-muted", e),
    ...t
  }
));
mX.displayName = Bc.displayName;
const vX = (e) => /* @__PURE__ */ T("svg", { width: "100", height: "16", viewBox: "0 0 100 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ T("g", { clipPath: "url(#clip0_1972_1032)", children: [
    /* @__PURE__ */ u(
      "path",
      {
        d: "M5.91048 1.17272H0V14.8269H3.15991V11.0623H5.9103C9.55798 11.0623 11.8401 9.17017 11.8401 6.12737C11.8401 3.08457 9.55797 1.17272 5.91048 1.17272ZM5.73482 8.48741H3.15991V3.74745H5.73482C7.66601 3.74745 8.64118 4.6254 8.64118 6.12737C8.64118 7.62934 7.66601 8.48759 5.73482 8.48759V8.48741Z",
        fill: "#050006"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M96.9415 10.435C97.8376 10.0454 98.5292 9.4839 99.0162 8.74999C99.5033 8.01644 99.7469 7.14266 99.7469 6.12972C99.7469 5.11678 99.5061 4.23992 99.0261 3.49968C98.5452 2.75945 97.8598 2.18801 96.9704 1.78518C96.0809 1.3829 95.0324 1.18121 93.8241 1.18121H87.9214V14.8186H91.0771V11.0195H93.9799L96.6099 14.8186H99.9997L96.9415 10.435ZM95.8115 7.88289C95.3174 8.29873 94.5967 8.50638 93.6488 8.50638H91.0771V3.75269H93.6488C94.5967 3.75269 95.3174 3.95745 95.8115 4.36642C96.3049 4.77539 96.5515 5.36328 96.5515 6.12954C96.5515 6.89579 96.3047 7.4676 95.8115 7.88289Z",
        fill: "#050006"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M27.0605 8.7012C27.0605 9.96118 26.801 10.8868 26.2814 11.4774C25.7613 12.0686 25.0086 12.3637 24.0213 12.3637C21.9952 12.3637 20.9819 11.1431 20.9819 8.70101V1.18121H17.8262V8.81812C17.8262 10.8185 18.3689 12.3575 19.4528 13.4354C20.5377 14.5137 22.0538 15.0526 24.002 15.0526C25.9501 15.0526 27.4664 14.5139 28.5507 13.4354C29.6356 12.3575 30.1777 10.8185 30.1777 8.81812V1.18121H27.0605V8.7012Z",
        fill: "#050006"
      }
    ),
    /* @__PURE__ */ u("path", { d: "M40.347 1.18121H37.1909V14.8186H47.1853V12.2469H40.347V1.18121Z", fill: "#050006" }),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M60.6275 7.49326C59.9651 7.24675 59.1145 6.99971 58.0757 6.75302C57.0752 6.53218 56.3319 6.30827 55.845 6.08074C55.358 5.85394 55.1144 5.50605 55.1144 5.03852C55.1144 4.571 55.3251 4.19456 55.7476 3.90865C56.1692 3.62312 56.8222 3.47998 57.7054 3.47998C58.965 3.47998 60.2252 3.83745 61.4848 4.55166L62.4589 2.1553C61.8358 1.76548 61.1078 1.46711 60.2769 1.2591C59.4454 1.05164 58.5947 0.94754 57.7245 0.94754C56.4781 0.94754 55.4223 1.13585 54.5588 1.51229C53.695 1.88928 53.0491 2.39891 52.6204 3.04155C52.1918 3.68456 51.9774 4.40238 51.9774 5.1943C51.9774 6.10369 52.2143 6.83073 52.6887 7.37633C53.1628 7.92157 53.7308 8.31825 54.3935 8.56457C55.0558 8.81144 55.9063 9.05848 56.9454 9.30499C57.6204 9.46077 58.1566 9.6039 58.5528 9.73365C58.9489 9.86359 59.2735 10.0356 59.5269 10.2498C59.7802 10.4639 59.9066 10.7338 59.9066 11.0582C59.9066 11.5 59.6928 11.8541 59.2639 12.1199C58.8352 12.3863 58.1729 12.5191 57.2765 12.5191C56.4711 12.5191 55.6659 12.3897 54.8608 12.1297C54.0554 11.8698 53.361 11.5255 52.7764 11.097L51.7051 13.4739C52.3152 13.9412 53.1236 14.3213 54.1302 14.6133C55.1364 14.9055 56.1788 15.0519 57.2572 15.0519C58.5042 15.0519 59.5626 14.8632 60.4328 14.4866C61.3028 14.1102 61.9554 13.6004 62.3906 12.9575C62.8257 12.3145 63.0433 11.6034 63.0433 10.8243C63.0433 9.91528 62.806 9.19456 62.332 8.6618C61.8576 8.12957 61.2902 7.74012 60.6275 7.49326Z",
        fill: "#050006"
      }
    ),
    /* @__PURE__ */ u(
      "path",
      {
        d: "M73.3994 1.18121L67.321 14.8184H70.5551L74.9384 4.27895L79.3025 14.8184H82.6146L76.5165 1.18121H73.3994Z",
        fill: "#050006"
      }
    )
  ] }),
  /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_1972_1032", children: /* @__PURE__ */ u("rect", { width: "100", height: "14.1049", fill: "white", transform: "translate(0 0.94754)" }) }) })
] }), gX = ({ children: e }) => /* @__PURE__ */ u(Ee, { children: e }), wX = ({ children: e }) => /* @__PURE__ */ u(Ee, { children: e }), sne = (e) => {
  function t(o) {
    return o.split(" ").map((a) => a[0]).join("").toUpperCase().slice(0, 2);
  }
  let n = null, r = null;
  return b.Children.forEach(e.children, (o) => {
    b.isValidElement(o) && (o.type === wX ? n = o.props.children : o.type === gX && (r = o.props.children));
  }), /* @__PURE__ */ T(
    "div",
    {
      className: P(
        "tw-h-[60px] tw-font-sans tw-w-full tw-border-b tw-border-b-gray-200 tw-flex tw-items-center tw-justify-between tw-px-24px tw-py-12px",
        e.className
      ),
      children: [
        /* @__PURE__ */ T("div", { className: P("tw-flex tw-items-center tw-gap-16px tw-mr-[75px]", e.logoContainerClassName), children: [
          /* @__PURE__ */ u(ID, { className: "tw-cursor-pointer", size: 24, onClick: e.onHamburgerClick }),
          /* @__PURE__ */ u(vX, { className: "tw-cursor-pointer", onClick: e.onLogoClick })
        ] }),
        /* @__PURE__ */ T(
          "div",
          {
            className: P(
              "tw-h-full tw-flex tw-flex-1 tw-border-l tw-border-l-gray-200 tw-pl-24px",
              e.titleContainerClassName
            ),
            children: [
              /* @__PURE__ */ u("div", { className: P("tw-flex-1 tw-flex tw-items-center", e.titleClassName), children: /* @__PURE__ */ u(De, { variant: "h5", className: "tw-font-normal", lineHeight: "20px", children: e.title }) }),
              r,
              /* @__PURE__ */ T(
                sX,
                {
                  onOpenChange: (o) => {
                    e.onOpenChange != null && e.onOpenChange(o);
                  },
                  children: [
                    /* @__PURE__ */ u(lX, { className: "tw-cursor-pointer tw-rounded-full tw-bg-[#e5e7ea] tw-h-32px tw-w-32px tw-flex tw-items-center tw-justify-center", children: t(e.userName) }),
                    /* @__PURE__ */ u(iC, { align: "end", className: "tw-px-0 tw-py-0", children: n })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
};
function sC(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, wl(e, t);
}
function Et(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var Tp = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), l1 = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, Lp = {
  INIT: "@@redux/INIT" + l1(),
  REPLACE: "@@redux/REPLACE" + l1(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + l1();
  }
};
function bX(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function CX(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (EX(e))
    return "date";
  if (xX(e))
    return "error";
  var n = yX(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function yX(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function xX(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function EX(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function kr(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = CX(e)), t;
}
function lC(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Et(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Et(1) : "Expected the enhancer to be a function. Instead, received: '" + kr(n) + "'");
    return n(lC)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Et(2) : "Expected the root reducer to be a function. Instead, received: '" + kr(e) + "'");
  var o = e, a = t, i = [], s = i, l = !1;
  function c() {
    s === i && (s = i.slice());
  }
  function d() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? Et(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return a;
  }
  function f(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Et(4) : "Expected the listener to be a function. Instead, received: '" + kr(m) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? Et(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var v = !0;
    return c(), s.push(m), function() {
      if (v) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? Et(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        v = !1, c();
        var C = s.indexOf(m);
        s.splice(C, 1), i = null;
      }
    };
  }
  function p(m) {
    if (!bX(m))
      throw new Error(process.env.NODE_ENV === "production" ? Et(7) : "Actions must be plain objects. Instead, the actual type was: '" + kr(m) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof m.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Et(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? Et(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, a = o(a, m);
    } finally {
      l = !1;
    }
    for (var v = i = s, w = 0; w < v.length; w++) {
      var C = v[w];
      C();
    }
    return m;
  }
  function h(m) {
    if (typeof m != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Et(10) : "Expected the nextReducer to be a function. Instead, received: '" + kr(m));
    o = m, p({
      type: Lp.REPLACE
    });
  }
  function g() {
    var m, v = f;
    return m = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(C) {
        if (typeof C != "object" || C === null)
          throw new Error(process.env.NODE_ENV === "production" ? Et(11) : "Expected the observer to be an object. Instead, received: '" + kr(C) + "'");
        function y() {
          C.next && C.next(d());
        }
        y();
        var x = v(y);
        return {
          unsubscribe: x
        };
      }
    }, m[Tp] = function() {
      return this;
    }, m;
  }
  return p({
    type: Lp.INIT
  }), r = {
    dispatch: p,
    subscribe: f,
    getState: d,
    replaceReducer: h
  }, r[Tp] = g, r;
}
function Rp(e, t) {
  return function() {
    return t(e.apply(this, arguments));
  };
}
function Vp(e, t) {
  if (typeof e == "function")
    return Rp(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(process.env.NODE_ENV === "production" ? Et(16) : "bindActionCreators expected an object or a function, but instead received: '" + kr(e) + `'. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?`);
  var n = {};
  for (var r in e) {
    var o = e[r];
    typeof o == "function" && (n[r] = Rp(o, t));
  }
  return n;
}
function cC() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.length === 0 ? function(r) {
    return r;
  } : t.length === 1 ? t[0] : t.reduce(function(r, o) {
    return function() {
      return r(o.apply(void 0, arguments));
    };
  });
}
function IX() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    return function() {
      var o = r.apply(void 0, arguments), a = function() {
        throw new Error(process.env.NODE_ENV === "production" ? Et(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
      }, i = {
        getState: o.getState,
        dispatch: function() {
          return a.apply(void 0, arguments);
        }
      }, s = t.map(function(l) {
        return l(i);
      });
      return a = cC.apply(void 0, s)(o.dispatch), de(de({}, o), {}, {
        dispatch: a
      });
    };
  };
}
var H0 = /* @__PURE__ */ X.createContext(null);
process.env.NODE_ENV !== "production" && (H0.displayName = "ReactRedux");
function SX(e) {
  e();
}
var uC = SX, DX = function(t) {
  return uC = t;
}, MX = function() {
  return uC;
};
function NX() {
  var e = MX(), t = null, n = null;
  return {
    clear: function() {
      t = null, n = null;
    },
    notify: function() {
      e(function() {
        for (var o = t; o; )
          o.callback(), o = o.next;
      });
    },
    get: function() {
      for (var o = [], a = t; a; )
        o.push(a), a = a.next;
      return o;
    },
    subscribe: function(o) {
      var a = !0, i = n = {
        callback: o,
        next: null,
        prev: n
      };
      return i.prev ? i.prev.next = i : t = i, function() {
        !a || t === null || (a = !1, i.next ? i.next.prev = i.prev : n = i.prev, i.prev ? i.prev.next = i.next : t = i.next);
      };
    }
  };
}
var kp = {
  notify: function() {
  },
  get: function() {
    return [];
  }
};
function dC(e, t) {
  var n, r = kp;
  function o(f) {
    return l(), r.subscribe(f);
  }
  function a() {
    r.notify();
  }
  function i() {
    d.onStateChange && d.onStateChange();
  }
  function s() {
    return !!n;
  }
  function l() {
    n || (n = t ? t.addNestedSub(i) : e.subscribe(i), r = NX());
  }
  function c() {
    n && (n(), n = void 0, r.clear(), r = kp);
  }
  var d = {
    addNestedSub: o,
    notifyNestedSubs: a,
    handleChangeWrapper: i,
    isSubscribed: s,
    trySubscribe: l,
    tryUnsubscribe: c,
    getListeners: function() {
      return r;
    }
  };
  return d;
}
var fC = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ea : ye;
function pC(e) {
  var t = e.store, n = e.context, r = e.children, o = Xe(function() {
    var s = dC(t);
    return {
      store: t,
      subscription: s
    };
  }, [t]), a = Xe(function() {
    return t.getState();
  }, [t]);
  fC(function() {
    var s = o.subscription;
    return s.onStateChange = s.notifyNestedSubs, s.trySubscribe(), a !== t.getState() && s.notifyNestedSubs(), function() {
      s.tryUnsubscribe(), s.onStateChange = null;
    };
  }, [o, a]);
  var i = n || H0;
  return /* @__PURE__ */ X.createElement(i.Provider, {
    value: o
  }, r);
}
process.env.NODE_ENV !== "production" && (pC.propTypes = {
  store: M.shape({
    subscribe: M.func.isRequired,
    dispatch: M.func.isRequired,
    getState: M.func.isRequired
  }),
  context: M.object,
  children: M.any
});
var Jf = { exports: {} }, Fe = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fp;
function PX() {
  if (Fp)
    return Fe;
  Fp = 1;
  var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, a = 60109, i = 60110, s = 60112, l = 60113, c = 60120, d = 60115, f = 60116, p = 60121, h = 60122, g = 60117, m = 60129, v = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var w = Symbol.for;
    e = w("react.element"), t = w("react.portal"), n = w("react.fragment"), r = w("react.strict_mode"), o = w("react.profiler"), a = w("react.provider"), i = w("react.context"), s = w("react.forward_ref"), l = w("react.suspense"), c = w("react.suspense_list"), d = w("react.memo"), f = w("react.lazy"), p = w("react.block"), h = w("react.server.block"), g = w("react.fundamental"), m = w("react.debug_trace_mode"), v = w("react.legacy_hidden");
  }
  function C(k) {
    if (typeof k == "object" && k !== null) {
      var G = k.$$typeof;
      switch (G) {
        case e:
          switch (k = k.type, k) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case i:
                case s:
                case f:
                case d:
                case a:
                  return k;
                default:
                  return G;
              }
          }
        case t:
          return G;
      }
    }
  }
  var y = a, x = e, E = s, S = n, I = f, D = d, N = t, A = o, L = r, F = l;
  return Fe.ContextConsumer = i, Fe.ContextProvider = y, Fe.Element = x, Fe.ForwardRef = E, Fe.Fragment = S, Fe.Lazy = I, Fe.Memo = D, Fe.Portal = N, Fe.Profiler = A, Fe.StrictMode = L, Fe.Suspense = F, Fe.isAsyncMode = function() {
    return !1;
  }, Fe.isConcurrentMode = function() {
    return !1;
  }, Fe.isContextConsumer = function(k) {
    return C(k) === i;
  }, Fe.isContextProvider = function(k) {
    return C(k) === a;
  }, Fe.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === e;
  }, Fe.isForwardRef = function(k) {
    return C(k) === s;
  }, Fe.isFragment = function(k) {
    return C(k) === n;
  }, Fe.isLazy = function(k) {
    return C(k) === f;
  }, Fe.isMemo = function(k) {
    return C(k) === d;
  }, Fe.isPortal = function(k) {
    return C(k) === t;
  }, Fe.isProfiler = function(k) {
    return C(k) === o;
  }, Fe.isStrictMode = function(k) {
    return C(k) === r;
  }, Fe.isSuspense = function(k) {
    return C(k) === l;
  }, Fe.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === n || k === o || k === m || k === r || k === l || k === c || k === v || typeof k == "object" && k !== null && (k.$$typeof === f || k.$$typeof === d || k.$$typeof === a || k.$$typeof === i || k.$$typeof === s || k.$$typeof === g || k.$$typeof === p || k[0] === h);
  }, Fe.typeOf = C, Fe;
}
var He = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hp;
function AX() {
  return Hp || (Hp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, t = 60106, n = 60107, r = 60108, o = 60114, a = 60109, i = 60110, s = 60112, l = 60113, c = 60120, d = 60115, f = 60116, p = 60121, h = 60122, g = 60117, m = 60129, v = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var w = Symbol.for;
      e = w("react.element"), t = w("react.portal"), n = w("react.fragment"), r = w("react.strict_mode"), o = w("react.profiler"), a = w("react.provider"), i = w("react.context"), s = w("react.forward_ref"), l = w("react.suspense"), c = w("react.suspense_list"), d = w("react.memo"), f = w("react.lazy"), p = w("react.block"), h = w("react.server.block"), g = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), m = w("react.debug_trace_mode"), w("react.offscreen"), v = w("react.legacy_hidden");
    }
    var C = !1;
    function y(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === n || z === o || z === m || z === r || z === l || z === c || z === v || C || typeof z == "object" && z !== null && (z.$$typeof === f || z.$$typeof === d || z.$$typeof === a || z.$$typeof === i || z.$$typeof === s || z.$$typeof === g || z.$$typeof === p || z[0] === h));
    }
    function x(z) {
      if (typeof z == "object" && z !== null) {
        var R = z.$$typeof;
        switch (R) {
          case e:
            var ce = z.type;
            switch (ce) {
              case n:
              case o:
              case r:
              case l:
              case c:
                return ce;
              default:
                var ve = ce && ce.$$typeof;
                switch (ve) {
                  case i:
                  case s:
                  case f:
                  case d:
                  case a:
                    return ve;
                  default:
                    return R;
                }
            }
          case t:
            return R;
        }
      }
    }
    var E = i, S = a, I = e, D = s, N = n, A = f, L = d, F = t, k = o, G = r, J = l, $ = !1, H = !1;
    function V(z) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(z) {
      return H || (H = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(z) {
      return x(z) === i;
    }
    function Z(z) {
      return x(z) === a;
    }
    function O(z) {
      return typeof z == "object" && z !== null && z.$$typeof === e;
    }
    function Y(z) {
      return x(z) === s;
    }
    function U(z) {
      return x(z) === n;
    }
    function K(z) {
      return x(z) === f;
    }
    function q(z) {
      return x(z) === d;
    }
    function W(z) {
      return x(z) === t;
    }
    function Q(z) {
      return x(z) === o;
    }
    function te(z) {
      return x(z) === r;
    }
    function re(z) {
      return x(z) === l;
    }
    He.ContextConsumer = E, He.ContextProvider = S, He.Element = I, He.ForwardRef = D, He.Fragment = N, He.Lazy = A, He.Memo = L, He.Portal = F, He.Profiler = k, He.StrictMode = G, He.Suspense = J, He.isAsyncMode = V, He.isConcurrentMode = j, He.isContextConsumer = B, He.isContextProvider = Z, He.isElement = O, He.isForwardRef = Y, He.isFragment = U, He.isLazy = K, He.isMemo = q, He.isPortal = W, He.isProfiler = Q, He.isStrictMode = te, He.isSuspense = re, He.isValidElementType = y, He.typeOf = x;
  }()), He;
}
process.env.NODE_ENV === "production" ? Jf.exports = PX() : Jf.exports = AX();
var Bp = Jf.exports, _X = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"], OX = ["reactReduxForwardedRef"], TX = [], LX = [null, null], RX = function(t) {
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
};
function VX(e, t) {
  var n = e[1];
  return [t.payload, n + 1];
}
function Gp(e, t, n) {
  fC(function() {
    return e.apply(void 0, t);
  }, n);
}
function kX(e, t, n, r, o, a, i) {
  e.current = r, t.current = o, n.current = !1, a.current && (a.current = null, i());
}
function FX(e, t, n, r, o, a, i, s, l, c) {
  if (e) {
    var d = !1, f = null, p = function() {
      if (!d) {
        var m = t.getState(), v, w;
        try {
          v = r(m, o.current);
        } catch (C) {
          w = C, f = C;
        }
        w || (f = null), v === a.current ? i.current || l() : (a.current = v, s.current = v, i.current = !0, c({
          type: "STORE_UPDATED",
          payload: {
            error: w
          }
        }));
      }
    };
    n.onStateChange = p, n.trySubscribe(), p();
    var h = function() {
      if (d = !0, n.tryUnsubscribe(), n.onStateChange = null, f)
        throw f;
    };
    return h;
  }
}
var HX = function() {
  return [null, 0];
};
function BX(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.getDisplayName, o = r === void 0 ? function(S) {
    return "ConnectAdvanced(" + S + ")";
  } : r, a = n.methodName, i = a === void 0 ? "connectAdvanced" : a, s = n.renderCountProp, l = s === void 0 ? void 0 : s, c = n.shouldHandleStateChanges, d = c === void 0 ? !0 : c, f = n.storeKey, p = f === void 0 ? "store" : f, h = n.withRef, g = h === void 0 ? !1 : h, m = n.forwardRef, v = m === void 0 ? !1 : m, w = n.context, C = w === void 0 ? H0 : w, y = ci(n, _X);
  if (process.env.NODE_ENV !== "production") {
    if (l !== void 0)
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (g)
      throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var x = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (p !== "store")
      throw new Error("storeKey has been removed and does not do anything. " + x);
  }
  var E = C;
  return function(I) {
    if (process.env.NODE_ENV !== "production" && !Bp.isValidElementType(I))
      throw new Error("You must pass a component to the function returned by " + (i + ". Instead received " + RX(I)));
    var D = I.displayName || I.name || "Component", N = o(D), A = ee({}, y, {
      getDisplayName: o,
      methodName: i,
      renderCountProp: l,
      shouldHandleStateChanges: d,
      storeKey: p,
      displayName: N,
      wrappedComponentName: D,
      WrappedComponent: I
    }), L = y.pure;
    function F(H) {
      return e(H.dispatch, A);
    }
    var k = L ? Xe : function(H) {
      return H();
    };
    function G(H) {
      var V = Xe(function() {
        var Tn = H.reactReduxForwardedRef, ho = ci(H, OX);
        return [H.context, Tn, ho];
      }, [H]), j = V[0], B = V[1], Z = V[2], O = Xe(function() {
        return j && j.Consumer && Bp.isContextConsumer(/* @__PURE__ */ X.createElement(j.Consumer, null)) ? j : E;
      }, [j, E]), Y = Ht(O), U = !!H.store && !!H.store.getState && !!H.store.dispatch, K = !!Y && !!Y.store;
      if (process.env.NODE_ENV !== "production" && !U && !K)
        throw new Error('Could not find "store" in the context of ' + ('"' + N + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + N + " in connect options."));
      var q = U ? H.store : Y.store, W = Xe(function() {
        return F(q);
      }, [q]), Q = Xe(function() {
        if (!d)
          return LX;
        var Tn = dC(q, U ? null : Y.subscription), ho = Tn.notifyNestedSubs.bind(Tn);
        return [Tn, ho];
      }, [q, U, Y]), te = Q[0], re = Q[1], z = Xe(function() {
        return U ? Y : ee({}, Y, {
          subscription: te
        });
      }, [U, Y, te]), R = Hy(VX, TX, HX), ce = R[0], ve = ce[0], ke = R[1];
      if (ve && ve.error)
        throw ve.error;
      var Qe = le(), et = le(Z), xt = le(), dt = le(!1), Kt = k(function() {
        return xt.current && Z === et.current ? xt.current : W(q.getState(), Z);
      }, [q, ve, Z]);
      Gp(kX, [et, Qe, dt, Z, Kt, xt, re]), Gp(FX, [d, q, te, W, et, Qe, dt, xt, re, ke], [q, te, W]);
      var On = Xe(function() {
        return /* @__PURE__ */ X.createElement(I, ee({}, Kt, {
          ref: B
        }));
      }, [B, I, Kt]), Da = Xe(function() {
        return d ? /* @__PURE__ */ X.createElement(O.Provider, {
          value: z
        }, On) : On;
      }, [O, On, z]);
      return Da;
    }
    var J = L ? X.memo(G) : G;
    if (J.WrappedComponent = I, J.displayName = G.displayName = N, v) {
      var $ = X.forwardRef(function(V, j) {
        return /* @__PURE__ */ X.createElement(J, ee({}, V, {
          reactReduxForwardedRef: j
        }));
      });
      return $.displayName = N, $.WrappedComponent = I, d4($, I);
    }
    return d4(J, I);
  };
}
function Wp(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function c1(e, t) {
  if (Wp(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var o = 0; o < n.length; o++)
    if (!Object.prototype.hasOwnProperty.call(t, n[o]) || !Wp(e[n[o]], t[n[o]]))
      return !1;
  return !0;
}
function GX(e, t) {
  var n = {}, r = function(i) {
    var s = e[i];
    typeof s == "function" && (n[i] = function() {
      return t(s.apply(void 0, arguments));
    });
  };
  for (var o in e)
    r(o);
  return n;
}
function WX(e) {
  if (typeof e != "object" || e === null)
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t; Object.getPrototypeOf(n) !== null; )
    n = Object.getPrototypeOf(n);
  return t === n;
}
function hC(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function mC(e, t, n) {
  WX(e) || hC(n + "() in " + t + " must return a plain object. Instead received " + e + ".");
}
function B0(e) {
  return function(n, r) {
    var o = e(n, r);
    function a() {
      return o;
    }
    return a.dependsOnOwnProps = !1, a;
  };
}
function Zp(e) {
  return e.dependsOnOwnProps !== null && e.dependsOnOwnProps !== void 0 ? !!e.dependsOnOwnProps : e.length !== 1;
}
function vC(e, t) {
  return function(r, o) {
    var a = o.displayName, i = function(l, c) {
      return i.dependsOnOwnProps ? i.mapToProps(l, c) : i.mapToProps(l);
    };
    return i.dependsOnOwnProps = !0, i.mapToProps = function(l, c) {
      i.mapToProps = e, i.dependsOnOwnProps = Zp(e);
      var d = i(l, c);
      return typeof d == "function" && (i.mapToProps = d, i.dependsOnOwnProps = Zp(d), d = i(l, c)), process.env.NODE_ENV !== "production" && mC(d, a, t), d;
    }, i;
  };
}
function ZX(e) {
  return typeof e == "function" ? vC(e, "mapDispatchToProps") : void 0;
}
function $X(e) {
  return e ? void 0 : B0(function(t) {
    return {
      dispatch: t
    };
  });
}
function YX(e) {
  return e && typeof e == "object" ? B0(function(t) {
    return GX(e, t);
  }) : void 0;
}
const jX = [ZX, $X, YX];
function zX(e) {
  return typeof e == "function" ? vC(e, "mapStateToProps") : void 0;
}
function XX(e) {
  return e ? void 0 : B0(function() {
    return {};
  });
}
const UX = [zX, XX];
function JX(e, t, n) {
  return ee({}, n, e, t);
}
function KX(e) {
  return function(n, r) {
    var o = r.displayName, a = r.pure, i = r.areMergedPropsEqual, s = !1, l;
    return function(d, f, p) {
      var h = e(d, f, p);
      return s ? (!a || !i(h, l)) && (l = h) : (s = !0, l = h, process.env.NODE_ENV !== "production" && mC(l, o, "mergeProps")), l;
    };
  };
}
function qX(e) {
  return typeof e == "function" ? KX(e) : void 0;
}
function QX(e) {
  return e ? void 0 : function() {
    return JX;
  };
}
const eU = [qX, QX];
function u1(e, t, n) {
  if (e)
    (t === "mapStateToProps" || t === "mapDispatchToProps") && (Object.prototype.hasOwnProperty.call(e, "dependsOnOwnProps") || hC("The selector for " + t + " of " + n + " did not specify a value for dependsOnOwnProps."));
  else
    throw new Error("Unexpected value for " + t + " in " + n + ".");
}
function tU(e, t, n, r) {
  u1(e, "mapStateToProps", r), u1(t, "mapDispatchToProps", r), u1(n, "mergeProps", r);
}
var nU = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function rU(e, t, n, r) {
  return function(a, i) {
    return n(e(a, i), t(r, i), i);
  };
}
function oU(e, t, n, r, o) {
  var a = o.areStatesEqual, i = o.areOwnPropsEqual, s = o.areStatePropsEqual, l = !1, c, d, f, p, h;
  function g(y, x) {
    return c = y, d = x, f = e(c, d), p = t(r, d), h = n(f, p, d), l = !0, h;
  }
  function m() {
    return f = e(c, d), t.dependsOnOwnProps && (p = t(r, d)), h = n(f, p, d), h;
  }
  function v() {
    return e.dependsOnOwnProps && (f = e(c, d)), t.dependsOnOwnProps && (p = t(r, d)), h = n(f, p, d), h;
  }
  function w() {
    var y = e(c, d), x = !s(y, f);
    return f = y, x && (h = n(f, p, d)), h;
  }
  function C(y, x) {
    var E = !i(x, d), S = !a(y, c, x, d);
    return c = y, d = x, E && S ? m() : E ? v() : S ? w() : h;
  }
  return function(x, E) {
    return l ? C(x, E) : g(x, E);
  };
}
function aU(e, t) {
  var n = t.initMapStateToProps, r = t.initMapDispatchToProps, o = t.initMergeProps, a = ci(t, nU), i = n(e, a), s = r(e, a), l = o(e, a);
  process.env.NODE_ENV !== "production" && tU(i, s, l, a.displayName);
  var c = a.pure ? oU : rU;
  return c(i, s, l, e, a);
}
var iU = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
function d1(e, t, n) {
  for (var r = t.length - 1; r >= 0; r--) {
    var o = t[r](e);
    if (o)
      return o;
  }
  return function(a, i) {
    throw new Error("Invalid value of type " + typeof e + " for " + n + " argument when connecting component " + i.wrappedComponentName + ".");
  };
}
function sU(e, t) {
  return e === t;
}
function lU(e) {
  var t = e === void 0 ? {} : e, n = t.connectHOC, r = n === void 0 ? BX : n, o = t.mapStateToPropsFactories, a = o === void 0 ? UX : o, i = t.mapDispatchToPropsFactories, s = i === void 0 ? jX : i, l = t.mergePropsFactories, c = l === void 0 ? eU : l, d = t.selectorFactory, f = d === void 0 ? aU : d;
  return function(h, g, m, v) {
    v === void 0 && (v = {});
    var w = v, C = w.pure, y = C === void 0 ? !0 : C, x = w.areStatesEqual, E = x === void 0 ? sU : x, S = w.areOwnPropsEqual, I = S === void 0 ? c1 : S, D = w.areStatePropsEqual, N = D === void 0 ? c1 : D, A = w.areMergedPropsEqual, L = A === void 0 ? c1 : A, F = ci(w, iU), k = d1(h, a, "mapStateToProps"), G = d1(g, s, "mapDispatchToProps"), J = d1(m, c, "mergeProps");
    return r(f, ee({
      // used in error messages
      methodName: "connect",
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function(H) {
        return "Connect(" + H + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: !!h,
      // passed through to selectorFactory
      initMapStateToProps: k,
      initMapDispatchToProps: G,
      initMergeProps: J,
      pure: y,
      areStatesEqual: E,
      areOwnPropsEqual: I,
      areStatePropsEqual: N,
      areMergedPropsEqual: L
    }, F));
  };
}
const gC = /* @__PURE__ */ lU();
DX(By);
function cU(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function wC(e, t) {
  var n = ue(function() {
    return {
      inputs: t,
      result: e()
    };
  })[0], r = le(!0), o = le(n), a = r.current || !!(t && o.current.inputs && cU(t, o.current.inputs)), i = a ? o.current : {
    inputs: t,
    result: e()
  };
  return ye(function() {
    r.current = !1, o.current = i;
  }, [i]), i.result;
}
function uU(e, t) {
  return wC(function() {
    return e;
  }, t);
}
var Se = wC, fe = uU, dU = process.env.NODE_ENV === "production", f1 = "Invariant failed";
function $p(e, t) {
  if (!e) {
    if (dU)
      throw new Error(f1);
    var n = typeof t == "function" ? t() : t, r = n ? "".concat(f1, ": ").concat(n) : f1;
    throw new Error(r);
  }
}
var en = function(t) {
  var n = t.top, r = t.right, o = t.bottom, a = t.left, i = r - a, s = o - n, l = {
    top: n,
    right: r,
    bottom: o,
    left: a,
    width: i,
    height: s,
    x: a,
    y: n,
    center: {
      x: (r + a) / 2,
      y: (o + n) / 2
    }
  };
  return l;
}, G0 = function(t, n) {
  return {
    top: t.top - n.top,
    left: t.left - n.left,
    bottom: t.bottom + n.bottom,
    right: t.right + n.right
  };
}, Yp = function(t, n) {
  return {
    top: t.top + n.top,
    left: t.left + n.left,
    bottom: t.bottom - n.bottom,
    right: t.right - n.right
  };
}, fU = function(t, n) {
  return {
    top: t.top + n.y,
    left: t.left + n.x,
    bottom: t.bottom + n.y,
    right: t.right + n.x
  };
}, p1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, W0 = function(t) {
  var n = t.borderBox, r = t.margin, o = r === void 0 ? p1 : r, a = t.border, i = a === void 0 ? p1 : a, s = t.padding, l = s === void 0 ? p1 : s, c = en(G0(n, o)), d = en(Yp(n, i)), f = en(Yp(d, l));
  return {
    marginBox: c,
    borderBox: en(n),
    paddingBox: d,
    contentBox: f,
    margin: o,
    border: i,
    padding: l
  };
}, Gt = function(t) {
  var n = t.slice(0, -2), r = t.slice(-2);
  if (r !== "px")
    return 0;
  var o = Number(n);
  return isNaN(o) && (process.env.NODE_ENV !== "production" ? $p(!1, "Could not parse value [raw: " + t + ", without suffix: " + n + "]") : $p(!1)), o;
}, pU = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, Yl = function(t, n) {
  var r = t.borderBox, o = t.border, a = t.margin, i = t.padding, s = fU(r, n);
  return W0({
    borderBox: s,
    border: o,
    margin: a,
    padding: i
  });
}, jl = function(t, n) {
  return n === void 0 && (n = pU()), Yl(t, n);
}, bC = function(t, n) {
  var r = {
    top: Gt(n.marginTop),
    right: Gt(n.marginRight),
    bottom: Gt(n.marginBottom),
    left: Gt(n.marginLeft)
  }, o = {
    top: Gt(n.paddingTop),
    right: Gt(n.paddingRight),
    bottom: Gt(n.paddingBottom),
    left: Gt(n.paddingLeft)
  }, a = {
    top: Gt(n.borderTopWidth),
    right: Gt(n.borderRightWidth),
    bottom: Gt(n.borderBottomWidth),
    left: Gt(n.borderLeftWidth)
  };
  return W0({
    borderBox: t,
    margin: r,
    padding: o,
    border: a
  });
}, CC = function(t) {
  var n = t.getBoundingClientRect(), r = window.getComputedStyle(t);
  return bC(n, r);
}, jp = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function hU(e, t) {
  return !!(e === t || jp(e) && jp(t));
}
function mU(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!hU(e[n], t[n]))
      return !1;
  return !0;
}
function ot(e, t) {
  t === void 0 && (t = mU);
  var n, r = [], o, a = !1;
  function i() {
    for (var s = [], l = 0; l < arguments.length; l++)
      s[l] = arguments[l];
    return a && n === this && t(s, r) || (o = e.apply(this, s), a = !0, n = this, r = s), o;
  }
  return i;
}
var vU = function(t) {
  var n = [], r = null, o = function() {
    for (var i = arguments.length, s = new Array(i), l = 0; l < i; l++)
      s[l] = arguments[l];
    n = s, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, n);
    }));
  };
  return o.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, o;
};
const Ni = vU;
var gU = process.env.NODE_ENV === "production", wU = /[ \t]{2,}/g, bU = /^[ \t]*/gm, zp = function(t) {
  return t.replace(wU, " ").replace(bU, "").trim();
}, CU = function(t) {
  return zp(`
  %creact-beautiful-dnd

  %c` + zp(t) + `

  %c👷‍ This is a development only message. It will be removed in production builds.
`);
}, yU = function(t) {
  return [CU(t), "color: #00C584; font-size: 1.2em; font-weight: bold;", "line-height: 1.5", "color: #723874;"];
}, xU = "__react-beautiful-dnd-disable-dev-warnings";
function yC(e, t) {
  var n;
  gU || typeof window < "u" && window[xU] || (n = console)[e].apply(n, yU(t));
}
var Ge = yC.bind(null, "warn"), Kf = yC.bind(null, "error");
function fr() {
}
function EU(e, t) {
  return ee({}, e, {}, t);
}
function Yt(e, t, n) {
  var r = t.map(function(o) {
    var a = EU(n, o.options);
    return e.addEventListener(o.eventName, o.fn, a), function() {
      e.removeEventListener(o.eventName, o.fn, a);
    };
  });
  return function() {
    r.forEach(function(a) {
      a();
    });
  };
}
var IU = process.env.NODE_ENV === "production", Xp = "Invariant failed";
function Pi(e) {
  this.message = e;
}
Pi.prototype.toString = function() {
  return this.message;
};
function _(e, t) {
  if (!e)
    throw IU ? new Pi(Xp) : new Pi(Xp + ": " + (t || ""));
}
var SU = function(e) {
  sC(t, e);
  function t() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(a)) || this, r.callbacks = null, r.unbind = fr, r.onWindowError = function(s) {
      var l = r.getCallbacks();
      l.isDragging() && (l.tryAbort(), process.env.NODE_ENV !== "production" && Ge(`
        An error was caught by our window 'error' event listener while a drag was occurring.
        The active drag has been aborted.
      `));
      var c = s.error;
      c instanceof Pi && (s.preventDefault(), process.env.NODE_ENV !== "production" && Kf(c.message));
    }, r.getCallbacks = function() {
      if (!r.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return r.callbacks;
    }, r.setCallbacks = function(s) {
      r.callbacks = s;
    }, r;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.unbind = Yt(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }, n.componentDidCatch = function(o) {
    if (o instanceof Pi) {
      process.env.NODE_ENV !== "production" && Kf(o.message), this.setState({});
      return;
    }
    throw o;
  }, n.componentWillUnmount = function() {
    this.unbind();
  }, n.render = function() {
    return this.props.children(this.setCallbacks);
  }, t;
}(X.Component), DU = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, zl = function(t) {
  return t + 1;
}, MU = function(t) {
  return `
  You have lifted an item in position ` + zl(t.source.index) + `
`;
}, xC = function(t, n) {
  var r = t.droppableId === n.droppableId, o = zl(t.index), a = zl(n.index);
  return r ? `
      You have moved the item from position ` + o + `
      to position ` + a + `
    ` : `
    You have moved the item from position ` + o + `
    in list ` + t.droppableId + `
    to list ` + n.droppableId + `
    in position ` + a + `
  `;
}, EC = function(t, n, r) {
  var o = n.droppableId === r.droppableId;
  return o ? `
      The item ` + t + `
      has been combined with ` + r.draggableId : `
      The item ` + t + `
      in list ` + n.droppableId + `
      has been combined with ` + r.draggableId + `
      in list ` + r.droppableId + `
    `;
}, NU = function(t) {
  var n = t.destination;
  if (n)
    return xC(t.source, n);
  var r = t.combine;
  return r ? EC(t.draggableId, t.source, r) : "You are over an area that cannot be dropped on";
}, Up = function(t) {
  return `
  The item has returned to its starting position
  of ` + zl(t.index) + `
`;
}, PU = function(t) {
  if (t.reason === "CANCEL")
    return `
      Movement cancelled.
      ` + Up(t.source) + `
    `;
  var n = t.destination, r = t.combine;
  return n ? `
      You have dropped the item.
      ` + xC(t.source, n) + `
    ` : r ? `
      You have dropped the item.
      ` + EC(t.draggableId, t.source, r) + `
    ` : `
    The item has been dropped while not over a drop area.
    ` + Up(t.source) + `
  `;
}, dl = {
  dragHandleUsageInstructions: DU,
  onDragStart: MU,
  onDragUpdate: NU,
  onDragEnd: PU
}, it = {
  x: 0,
  y: 0
}, ct = function(t, n) {
  return {
    x: t.x + n.x,
    y: t.y + n.y
  };
}, Ot = function(t, n) {
  return {
    x: t.x - n.x,
    y: t.y - n.y
  };
}, pr = function(t, n) {
  return t.x === n.x && t.y === n.y;
}, Ia = function(t) {
  return {
    x: t.x !== 0 ? -t.x : 0,
    y: t.y !== 0 ? -t.y : 0
  };
}, to = function(t, n, r) {
  var o;
  return r === void 0 && (r = 0), o = {}, o[t] = n, o[t === "x" ? "y" : "x"] = r, o;
}, Ai = function(t, n) {
  return Math.sqrt(Math.pow(n.x - t.x, 2) + Math.pow(n.y - t.y, 2));
}, Jp = function(t, n) {
  return Math.min.apply(Math, n.map(function(r) {
    return Ai(t, r);
  }));
}, IC = function(t) {
  return function(n) {
    return {
      x: t(n.x),
      y: t(n.y)
    };
  };
}, AU = function(e, t) {
  var n = en({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return n.width <= 0 || n.height <= 0 ? null : n;
}, ds = function(t, n) {
  return {
    top: t.top + n.y,
    left: t.left + n.x,
    bottom: t.bottom + n.y,
    right: t.right + n.x
  };
}, Kp = function(t) {
  return [{
    x: t.left,
    y: t.top
  }, {
    x: t.right,
    y: t.top
  }, {
    x: t.left,
    y: t.bottom
  }, {
    x: t.right,
    y: t.bottom
  }];
}, _U = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, OU = function(t, n) {
  return n ? ds(t, n.scroll.diff.displacement) : t;
}, TU = function(t, n, r) {
  if (r && r.increasedBy) {
    var o;
    return ee({}, t, (o = {}, o[n.end] = t[n.end] + r.increasedBy[n.line], o));
  }
  return t;
}, LU = function(t, n) {
  return n && n.shouldClipSubject ? AU(n.pageMarginBox, t) : en(t);
}, Ko = function(e) {
  var t = e.page, n = e.withPlaceholder, r = e.axis, o = e.frame, a = OU(t.marginBox, o), i = TU(a, r, n), s = LU(i, o);
  return {
    page: t,
    withPlaceholder: n,
    active: s
  };
}, Z0 = function(e, t) {
  e.frame || (process.env.NODE_ENV, _(!1));
  var n = e.frame, r = Ot(t, n.scroll.initial), o = Ia(r), a = ee({}, n, {
    scroll: {
      initial: n.scroll.initial,
      current: t,
      diff: {
        value: r,
        displacement: o
      },
      max: n.scroll.max
    }
  }), i = Ko({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: a
  }), s = ee({}, e, {
    frame: a,
    subject: i
  });
  return s;
};
function RU(e) {
  return Number.isInteger ? Number.isInteger(e) : typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
function Xl(e) {
  return Object.values ? Object.values(e) : Object.keys(e).map(function(t) {
    return e[t];
  });
}
function $0(e, t) {
  if (e.findIndex)
    return e.findIndex(t);
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
  return -1;
}
function Ar(e, t) {
  if (e.find)
    return e.find(t);
  var n = $0(e, t);
  if (n !== -1)
    return e[n];
}
function SC(e) {
  return Array.prototype.slice.call(e);
}
var DC = ot(function(e) {
  return e.reduce(function(t, n) {
    return t[n.descriptor.id] = n, t;
  }, {});
}), MC = ot(function(e) {
  return e.reduce(function(t, n) {
    return t[n.descriptor.id] = n, t;
  }, {});
}), Mu = ot(function(e) {
  return Xl(e);
}), VU = ot(function(e) {
  return Xl(e);
}), po = ot(function(e, t) {
  var n = VU(t).filter(function(r) {
    return e === r.descriptor.droppableId;
  }).sort(function(r, o) {
    return r.descriptor.index - o.descriptor.index;
  });
  return n;
});
function Y0(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function Nu(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var Pu = ot(function(e, t) {
  return t.filter(function(n) {
    return n.descriptor.id !== e.descriptor.id;
  });
}), kU = function(e) {
  var t = e.isMovingForward, n = e.draggable, r = e.destination, o = e.insideDestination, a = e.previousImpact;
  if (!r.isCombineEnabled)
    return null;
  var i = Y0(a);
  if (!i)
    return null;
  function s(m) {
    var v = {
      type: "COMBINE",
      combine: {
        draggableId: m,
        droppableId: r.descriptor.id
      }
    };
    return ee({}, a, {
      at: v
    });
  }
  var l = a.displaced.all, c = l.length ? l[0] : null;
  if (t)
    return c ? s(c) : null;
  var d = Pu(n, o);
  if (!c) {
    if (!d.length)
      return null;
    var f = d[d.length - 1];
    return s(f.descriptor.id);
  }
  var p = $0(d, function(m) {
    return m.descriptor.id === c;
  });
  p === -1 && (process.env.NODE_ENV !== "production" ? _(!1, "Could not find displaced item in set") : _(!1));
  var h = p - 1;
  if (h < 0)
    return null;
  var g = d[h];
  return s(g.descriptor.id);
}, Sa = function(e, t) {
  return e.descriptor.droppableId === t.descriptor.id;
}, NC = {
  point: it,
  value: 0
}, _i = {
  invisible: {},
  visible: {},
  all: []
}, FU = {
  displaced: _i,
  displacedBy: NC,
  at: null
}, zt = function(e, t) {
  return function(n) {
    return e <= n && n <= t;
  };
}, PC = function(e) {
  var t = zt(e.top, e.bottom), n = zt(e.left, e.right);
  return function(r) {
    var o = t(r.top) && t(r.bottom) && n(r.left) && n(r.right);
    if (o)
      return !0;
    var a = t(r.top) || t(r.bottom), i = n(r.left) || n(r.right), s = a && i;
    if (s)
      return !0;
    var l = r.top < e.top && r.bottom > e.bottom, c = r.left < e.left && r.right > e.right, d = l && c;
    if (d)
      return !0;
    var f = l && i || c && a;
    return f;
  };
}, HU = function(e) {
  var t = zt(e.top, e.bottom), n = zt(e.left, e.right);
  return function(r) {
    var o = t(r.top) && t(r.bottom) && n(r.left) && n(r.right);
    return o;
  };
}, j0 = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, AC = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
}, BU = function(e) {
  return function(t) {
    var n = zt(t.top, t.bottom), r = zt(t.left, t.right);
    return function(o) {
      return e === j0 ? n(o.top) && n(o.bottom) : r(o.left) && r(o.right);
    };
  };
}, GU = function(t, n) {
  var r = n.frame ? n.frame.scroll.diff.displacement : it;
  return ds(t, r);
}, WU = function(t, n, r) {
  return n.subject.active ? r(n.subject.active)(t) : !1;
}, ZU = function(t, n, r) {
  return r(n)(t);
}, z0 = function(t) {
  var n = t.target, r = t.destination, o = t.viewport, a = t.withDroppableDisplacement, i = t.isVisibleThroughFrameFn, s = a ? GU(n, r) : n;
  return WU(s, r, i) && ZU(s, o, i);
}, $U = function(t) {
  return z0(ee({}, t, {
    isVisibleThroughFrameFn: PC
  }));
}, _C = function(t) {
  return z0(ee({}, t, {
    isVisibleThroughFrameFn: HU
  }));
}, YU = function(t) {
  return z0(ee({}, t, {
    isVisibleThroughFrameFn: BU(t.destination.axis)
  }));
}, jU = function(t, n, r) {
  if (typeof r == "boolean")
    return r;
  if (!n)
    return !0;
  var o = n.invisible, a = n.visible;
  if (o[t])
    return !1;
  var i = a[t];
  return i ? i.shouldAnimate : !0;
};
function zU(e, t) {
  var n = e.page.marginBox, r = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return en(G0(n, r));
}
function Oi(e) {
  var t = e.afterDragging, n = e.destination, r = e.displacedBy, o = e.viewport, a = e.forceShouldAnimate, i = e.last;
  return t.reduce(function(l, c) {
    var d = zU(c, r), f = c.descriptor.id;
    l.all.push(f);
    var p = $U({
      target: d,
      destination: n,
      viewport: o,
      withDroppableDisplacement: !0
    });
    if (!p)
      return l.invisible[c.descriptor.id] = !0, l;
    var h = jU(f, i, a), g = {
      draggableId: f,
      shouldAnimate: h
    };
    return l.visible[f] = g, l;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function XU(e, t) {
  if (!e.length)
    return 0;
  var n = e[e.length - 1].descriptor.index;
  return t.inHomeList ? n : n + 1;
}
function qp(e) {
  var t = e.insideDestination, n = e.inHomeList, r = e.displacedBy, o = e.destination, a = XU(t, {
    inHomeList: n
  });
  return {
    displaced: _i,
    displacedBy: r,
    at: {
      type: "REORDER",
      destination: {
        droppableId: o.descriptor.id,
        index: a
      }
    }
  };
}
function Ul(e) {
  var t = e.draggable, n = e.insideDestination, r = e.destination, o = e.viewport, a = e.displacedBy, i = e.last, s = e.index, l = e.forceShouldAnimate, c = Sa(t, r);
  if (s == null)
    return qp({
      insideDestination: n,
      inHomeList: c,
      displacedBy: a,
      destination: r
    });
  var d = Ar(n, function(m) {
    return m.descriptor.index === s;
  });
  if (!d)
    return qp({
      insideDestination: n,
      inHomeList: c,
      displacedBy: a,
      destination: r
    });
  var f = Pu(t, n), p = n.indexOf(d), h = f.slice(p), g = Oi({
    afterDragging: h,
    destination: r,
    displacedBy: a,
    last: i,
    viewport: o.frame,
    forceShouldAnimate: l
  });
  return {
    displaced: g,
    displacedBy: a,
    at: {
      type: "REORDER",
      destination: {
        droppableId: r.descriptor.id,
        index: s
      }
    }
  };
}
function yr(e, t) {
  return !!t.effected[e];
}
var UU = function(e) {
  var t = e.isMovingForward, n = e.destination, r = e.draggables, o = e.combine, a = e.afterCritical;
  if (!n.isCombineEnabled)
    return null;
  var i = o.draggableId, s = r[i], l = s.descriptor.index, c = yr(i, a);
  return c ? t ? l : l - 1 : t ? l + 1 : l;
}, JU = function(e) {
  var t = e.isMovingForward, n = e.isInHomeList, r = e.insideDestination, o = e.location;
  if (!r.length)
    return null;
  var a = o.index, i = t ? a + 1 : a - 1, s = r[0].descriptor.index, l = r[r.length - 1].descriptor.index, c = n ? l : l + 1;
  return i < s || i > c ? null : i;
}, KU = function(e) {
  var t = e.isMovingForward, n = e.isInHomeList, r = e.draggable, o = e.draggables, a = e.destination, i = e.insideDestination, s = e.previousImpact, l = e.viewport, c = e.afterCritical, d = s.at;
  if (d || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot move in direction without previous impact location") : _(!1)), d.type === "REORDER") {
    var f = JU({
      isMovingForward: t,
      isInHomeList: n,
      location: d.destination,
      insideDestination: i
    });
    return f == null ? null : Ul({
      draggable: r,
      insideDestination: i,
      destination: a,
      viewport: l,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: f
    });
  }
  var p = UU({
    isMovingForward: t,
    destination: a,
    displaced: s.displaced,
    draggables: o,
    combine: d.combine,
    afterCritical: c
  });
  return p == null ? null : Ul({
    draggable: r,
    insideDestination: i,
    destination: a,
    viewport: l,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: p
  });
}, qU = function(e) {
  var t = e.displaced, n = e.afterCritical, r = e.combineWith, o = e.displacedBy, a = !!(t.visible[r] || t.invisible[r]);
  return yr(r, n) ? a ? it : Ia(o.point) : a ? o.point : it;
}, QU = function(e) {
  var t = e.afterCritical, n = e.impact, r = e.draggables, o = Nu(n);
  o || (process.env.NODE_ENV, _(!1));
  var a = o.draggableId, i = r[a].page.borderBox.center, s = qU({
    displaced: n.displaced,
    afterCritical: t,
    combineWith: a,
    displacedBy: n.displacedBy
  });
  return ct(i, s);
}, OC = function(t, n) {
  return n.margin[t.start] + n.borderBox[t.size] / 2;
}, eJ = function(t, n) {
  return n.margin[t.end] + n.borderBox[t.size] / 2;
}, X0 = function(t, n, r) {
  return n[t.crossAxisStart] + r.margin[t.crossAxisStart] + r.borderBox[t.crossAxisSize] / 2;
}, Qp = function(t) {
  var n = t.axis, r = t.moveRelativeTo, o = t.isMoving;
  return to(n.line, r.marginBox[n.end] + OC(n, o), X0(n, r.marginBox, o));
}, e7 = function(t) {
  var n = t.axis, r = t.moveRelativeTo, o = t.isMoving;
  return to(n.line, r.marginBox[n.start] - eJ(n, o), X0(n, r.marginBox, o));
}, tJ = function(t) {
  var n = t.axis, r = t.moveInto, o = t.isMoving;
  return to(n.line, r.contentBox[n.start] + OC(n, o), X0(n, r.contentBox, o));
}, nJ = function(e) {
  var t = e.impact, n = e.draggable, r = e.draggables, o = e.droppable, a = e.afterCritical, i = po(o.descriptor.id, r), s = n.page, l = o.axis;
  if (!i.length)
    return tJ({
      axis: l,
      moveInto: o.page,
      isMoving: s
    });
  var c = t.displaced, d = t.displacedBy, f = c.all[0];
  if (f) {
    var p = r[f];
    if (yr(f, a))
      return e7({
        axis: l,
        moveRelativeTo: p.page,
        isMoving: s
      });
    var h = Yl(p.page, d.point);
    return e7({
      axis: l,
      moveRelativeTo: h,
      isMoving: s
    });
  }
  var g = i[i.length - 1];
  if (g.descriptor.id === n.descriptor.id)
    return s.borderBox.center;
  if (yr(g.descriptor.id, a)) {
    var m = Yl(g.page, Ia(a.displacedBy.point));
    return Qp({
      axis: l,
      moveRelativeTo: m,
      isMoving: s
    });
  }
  return Qp({
    axis: l,
    moveRelativeTo: g.page,
    isMoving: s
  });
}, qf = function(e, t) {
  var n = e.frame;
  return n ? ct(t, n.scroll.diff.displacement) : t;
}, rJ = function(t) {
  var n = t.impact, r = t.draggable, o = t.droppable, a = t.draggables, i = t.afterCritical, s = r.page.borderBox.center, l = n.at;
  return !o || !l ? s : l.type === "REORDER" ? nJ({
    impact: n,
    draggable: r,
    draggables: a,
    droppable: o,
    afterCritical: i
  }) : QU({
    impact: n,
    draggables: a,
    afterCritical: i
  });
}, Au = function(e) {
  var t = rJ(e), n = e.droppable, r = n ? qf(n, t) : t;
  return r;
}, TC = function(e, t) {
  var n = Ot(t, e.scroll.initial), r = Ia(n), o = en({
    top: t.y,
    bottom: t.y + e.frame.height,
    left: t.x,
    right: t.x + e.frame.width
  }), a = {
    frame: o,
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: n,
        displacement: r
      }
    }
  };
  return a;
};
function t7(e, t) {
  return e.map(function(n) {
    return t[n];
  });
}
function oJ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n].visible[e];
    if (r)
      return r;
  }
  return null;
}
var aJ = function(e) {
  var t = e.impact, n = e.viewport, r = e.destination, o = e.draggables, a = e.maxScrollChange, i = TC(n, ct(n.scroll.current, a)), s = r.frame ? Z0(r, ct(r.frame.scroll.current, a)) : r, l = t.displaced, c = Oi({
    afterDragging: t7(l.all, o),
    destination: r,
    displacedBy: t.displacedBy,
    viewport: i.frame,
    last: l,
    forceShouldAnimate: !1
  }), d = Oi({
    afterDragging: t7(l.all, o),
    destination: s,
    displacedBy: t.displacedBy,
    viewport: n.frame,
    last: l,
    forceShouldAnimate: !1
  }), f = {}, p = {}, h = [l, c, d];
  l.all.forEach(function(m) {
    var v = oJ(m, h);
    if (v) {
      p[m] = v;
      return;
    }
    f[m] = !0;
  });
  var g = ee({}, t, {
    displaced: {
      all: l.all,
      invisible: f,
      visible: p
    }
  });
  return g;
}, iJ = function(e, t) {
  return ct(e.scroll.diff.displacement, t);
}, U0 = function(e) {
  var t = e.pageBorderBoxCenter, n = e.draggable, r = e.viewport, o = iJ(r, t), a = Ot(o, n.page.borderBox.center);
  return ct(n.client.borderBox.center, a);
}, LC = function(e) {
  var t = e.draggable, n = e.destination, r = e.newPageBorderBoxCenter, o = e.viewport, a = e.withDroppableDisplacement, i = e.onlyOnMainAxis, s = i === void 0 ? !1 : i, l = Ot(r, t.page.borderBox.center), c = ds(t.page.borderBox, l), d = {
    target: c,
    destination: n,
    withDroppableDisplacement: a,
    viewport: o
  };
  return s ? YU(d) : _C(d);
}, sJ = function(e) {
  var t = e.isMovingForward, n = e.draggable, r = e.destination, o = e.draggables, a = e.previousImpact, i = e.viewport, s = e.previousPageBorderBoxCenter, l = e.previousClientSelection, c = e.afterCritical;
  if (!r.isEnabled)
    return null;
  var d = po(r.descriptor.id, o), f = Sa(n, r), p = kU({
    isMovingForward: t,
    draggable: n,
    destination: r,
    insideDestination: d,
    previousImpact: a
  }) || KU({
    isMovingForward: t,
    isInHomeList: f,
    draggable: n,
    draggables: o,
    destination: r,
    insideDestination: d,
    previousImpact: a,
    viewport: i,
    afterCritical: c
  });
  if (!p)
    return null;
  var h = Au({
    impact: p,
    draggable: n,
    droppable: r,
    draggables: o,
    afterCritical: c
  }), g = LC({
    draggable: n,
    destination: r,
    newPageBorderBoxCenter: h,
    viewport: i.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  });
  if (g) {
    var m = U0({
      pageBorderBoxCenter: h,
      draggable: n,
      viewport: i
    });
    return {
      clientSelection: m,
      impact: p,
      scrollJumpRequest: null
    };
  }
  var v = Ot(h, s), w = aJ({
    impact: p,
    viewport: i,
    destination: r,
    draggables: o,
    maxScrollChange: v
  });
  return {
    clientSelection: l,
    impact: w,
    scrollJumpRequest: v
  };
}, wt = function(t) {
  var n = t.subject.active;
  return n || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot get clipped area from droppable") : _(!1)), n;
}, lJ = function(e) {
  var t = e.isMovingForward, n = e.pageBorderBoxCenter, r = e.source, o = e.droppables, a = e.viewport, i = r.subject.active;
  if (!i)
    return null;
  var s = r.axis, l = zt(i[s.start], i[s.end]), c = Mu(o).filter(function(f) {
    return f !== r;
  }).filter(function(f) {
    return f.isEnabled;
  }).filter(function(f) {
    return !!f.subject.active;
  }).filter(function(f) {
    return PC(a.frame)(wt(f));
  }).filter(function(f) {
    var p = wt(f);
    return t ? i[s.crossAxisEnd] < p[s.crossAxisEnd] : p[s.crossAxisStart] < i[s.crossAxisStart];
  }).filter(function(f) {
    var p = wt(f), h = zt(p[s.start], p[s.end]);
    return l(p[s.start]) || l(p[s.end]) || h(i[s.start]) || h(i[s.end]);
  }).sort(function(f, p) {
    var h = wt(f)[s.crossAxisStart], g = wt(p)[s.crossAxisStart];
    return t ? h - g : g - h;
  }).filter(function(f, p, h) {
    return wt(f)[s.crossAxisStart] === wt(h[0])[s.crossAxisStart];
  });
  if (!c.length)
    return null;
  if (c.length === 1)
    return c[0];
  var d = c.filter(function(f) {
    var p = zt(wt(f)[s.start], wt(f)[s.end]);
    return p(n[s.line]);
  });
  return d.length === 1 ? d[0] : d.length > 1 ? d.sort(function(f, p) {
    return wt(f)[s.start] - wt(p)[s.start];
  })[0] : c.sort(function(f, p) {
    var h = Jp(n, Kp(wt(f))), g = Jp(n, Kp(wt(p)));
    return h !== g ? h - g : wt(f)[s.start] - wt(p)[s.start];
  })[0];
}, n7 = function(t, n) {
  var r = t.page.borderBox.center;
  return yr(t.descriptor.id, n) ? Ot(r, n.displacedBy.point) : r;
}, cJ = function(t, n) {
  var r = t.page.borderBox;
  return yr(t.descriptor.id, n) ? ds(r, Ia(n.displacedBy.point)) : r;
}, uJ = function(e) {
  var t = e.pageBorderBoxCenter, n = e.viewport, r = e.destination, o = e.insideDestination, a = e.afterCritical, i = o.filter(function(s) {
    return _C({
      target: cJ(s, a),
      destination: r,
      viewport: n.frame,
      withDroppableDisplacement: !0
    });
  }).sort(function(s, l) {
    var c = Ai(t, qf(r, n7(s, a))), d = Ai(t, qf(r, n7(l, a)));
    return c < d ? -1 : d < c ? 1 : s.descriptor.index - l.descriptor.index;
  });
  return i[0] || null;
}, fs = ot(function(t, n) {
  var r = n[t.line];
  return {
    value: r,
    point: to(t.line, r)
  };
}), dJ = function(t, n, r) {
  var o = t.axis;
  if (t.descriptor.mode === "virtual")
    return to(o.line, n[o.line]);
  var a = t.subject.page.contentBox[o.size], i = po(t.descriptor.id, r), s = i.reduce(function(d, f) {
    return d + f.client.marginBox[o.size];
  }, 0), l = s + n[o.line], c = l - a;
  return c <= 0 ? null : to(o.line, c);
}, RC = function(t, n) {
  return ee({}, t, {
    scroll: ee({}, t.scroll, {
      max: n
    })
  });
}, VC = function(t, n, r) {
  var o = t.frame;
  Sa(n, t) && (process.env.NODE_ENV !== "production" ? _(!1, "Should not add placeholder space to home list") : _(!1)), t.subject.withPlaceholder && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot add placeholder size to a subject when it already has one") : _(!1));
  var a = fs(t.axis, n.displaceBy).point, i = dJ(t, a, r), s = {
    placeholderSize: a,
    increasedBy: i,
    oldFrameMaxScroll: t.frame ? t.frame.scroll.max : null
  };
  if (!o) {
    var l = Ko({
      page: t.subject.page,
      withPlaceholder: s,
      axis: t.axis,
      frame: t.frame
    });
    return ee({}, t, {
      subject: l
    });
  }
  var c = i ? ct(o.scroll.max, i) : o.scroll.max, d = RC(o, c), f = Ko({
    page: t.subject.page,
    withPlaceholder: s,
    axis: t.axis,
    frame: d
  });
  return ee({}, t, {
    subject: f,
    frame: d
  });
}, fJ = function(t) {
  var n = t.subject.withPlaceholder;
  n || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot remove placeholder form subject when there was none") : _(!1));
  var r = t.frame;
  if (!r) {
    var o = Ko({
      page: t.subject.page,
      axis: t.axis,
      frame: null,
      withPlaceholder: null
    });
    return ee({}, t, {
      subject: o
    });
  }
  var a = n.oldFrameMaxScroll;
  a || (process.env.NODE_ENV !== "production" ? _(!1, "Expected droppable with frame to have old max frame scroll when removing placeholder") : _(!1));
  var i = RC(r, a), s = Ko({
    page: t.subject.page,
    axis: t.axis,
    frame: i,
    withPlaceholder: null
  });
  return ee({}, t, {
    subject: s,
    frame: i
  });
}, pJ = function(e) {
  var t = e.previousPageBorderBoxCenter, n = e.moveRelativeTo, r = e.insideDestination, o = e.draggable, a = e.draggables, i = e.destination, s = e.viewport, l = e.afterCritical;
  if (!n) {
    if (r.length)
      return null;
    var c = {
      displaced: _i,
      displacedBy: NC,
      at: {
        type: "REORDER",
        destination: {
          droppableId: i.descriptor.id,
          index: 0
        }
      }
    }, d = Au({
      impact: c,
      draggable: o,
      droppable: i,
      draggables: a,
      afterCritical: l
    }), f = Sa(o, i) ? i : VC(i, o, a), p = LC({
      draggable: o,
      destination: f,
      newPageBorderBoxCenter: d,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    });
    return p ? c : null;
  }
  var h = t[i.axis.line] <= n.page.borderBox.center[i.axis.line], g = function() {
    var v = n.descriptor.index;
    return n.descriptor.id === o.descriptor.id || h ? v : v + 1;
  }(), m = fs(i.axis, o.displaceBy);
  return Ul({
    draggable: o,
    insideDestination: r,
    destination: i,
    viewport: s,
    displacedBy: m,
    last: _i,
    index: g
  });
}, hJ = function(e) {
  var t = e.isMovingForward, n = e.previousPageBorderBoxCenter, r = e.draggable, o = e.isOver, a = e.draggables, i = e.droppables, s = e.viewport, l = e.afterCritical, c = lJ({
    isMovingForward: t,
    pageBorderBoxCenter: n,
    source: o,
    droppables: i,
    viewport: s
  });
  if (!c)
    return null;
  var d = po(c.descriptor.id, a), f = uJ({
    pageBorderBoxCenter: n,
    viewport: s,
    destination: c,
    insideDestination: d,
    afterCritical: l
  }), p = pJ({
    previousPageBorderBoxCenter: n,
    destination: c,
    draggable: r,
    draggables: a,
    moveRelativeTo: f,
    insideDestination: d,
    viewport: s,
    afterCritical: l
  });
  if (!p)
    return null;
  var h = Au({
    impact: p,
    draggable: r,
    droppable: c,
    draggables: a,
    afterCritical: l
  }), g = U0({
    pageBorderBoxCenter: h,
    draggable: r,
    viewport: s
  });
  return {
    clientSelection: g,
    impact: p,
    scrollJumpRequest: null
  };
}, Rt = function(e) {
  var t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
}, mJ = function(t, n) {
  var r = Rt(t);
  return r ? n[r] : null;
}, vJ = function(e) {
  var t = e.state, n = e.type, r = mJ(t.impact, t.dimensions.droppables), o = !!r, a = t.dimensions.droppables[t.critical.droppable.id], i = r || a, s = i.axis.direction, l = s === "vertical" && (n === "MOVE_UP" || n === "MOVE_DOWN") || s === "horizontal" && (n === "MOVE_LEFT" || n === "MOVE_RIGHT");
  if (l && !o)
    return null;
  var c = n === "MOVE_DOWN" || n === "MOVE_RIGHT", d = t.dimensions.draggables[t.critical.draggable.id], f = t.current.page.borderBoxCenter, p = t.dimensions, h = p.draggables, g = p.droppables;
  return l ? sJ({
    isMovingForward: c,
    previousPageBorderBoxCenter: f,
    draggable: d,
    destination: i,
    draggables: h,
    viewport: t.viewport,
    previousClientSelection: t.current.client.selection,
    previousImpact: t.impact,
    afterCritical: t.afterCritical
  }) : hJ({
    isMovingForward: c,
    previousPageBorderBoxCenter: f,
    draggable: d,
    isOver: i,
    draggables: h,
    droppables: g,
    viewport: t.viewport,
    afterCritical: t.afterCritical
  });
};
function Fr(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function kC(e) {
  var t = zt(e.top, e.bottom), n = zt(e.left, e.right);
  return function(o) {
    return t(o.y) && n(o.x);
  };
}
function gJ(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function wJ(e) {
  var t = e.pageBorderBox, n = e.draggable, r = e.candidates, o = n.page.borderBox.center, a = r.map(function(i) {
    var s = i.axis, l = to(i.axis.line, t.center[s.line], i.page.borderBox.center[s.crossAxisLine]);
    return {
      id: i.descriptor.id,
      distance: Ai(o, l)
    };
  }).sort(function(i, s) {
    return s.distance - i.distance;
  });
  return a[0] ? a[0].id : null;
}
function bJ(e) {
  var t = e.pageBorderBox, n = e.draggable, r = e.droppables, o = Mu(r).filter(function(a) {
    if (!a.isEnabled)
      return !1;
    var i = a.subject.active;
    if (!i || !gJ(t, i))
      return !1;
    if (kC(i)(t.center))
      return !0;
    var s = a.axis, l = i.center[s.crossAxisLine], c = t[s.crossAxisStart], d = t[s.crossAxisEnd], f = zt(i[s.crossAxisStart], i[s.crossAxisEnd]), p = f(c), h = f(d);
    return !p && !h ? !0 : p ? c < l : d > l;
  });
  return o.length ? o.length === 1 ? o[0].descriptor.id : wJ({
    pageBorderBox: t,
    draggable: n,
    candidates: o
  }) : null;
}
var FC = function(t, n) {
  return en(ds(t, n));
}, CJ = function(e, t) {
  var n = e.frame;
  return n ? FC(t, n.scroll.diff.value) : t;
};
function HC(e) {
  var t = e.displaced, n = e.id;
  return !!(t.visible[n] || t.invisible[n]);
}
function yJ(e) {
  var t = e.draggable, n = e.closest, r = e.inHomeList;
  return n ? r && n.descriptor.index > t.descriptor.index ? n.descriptor.index - 1 : n.descriptor.index : null;
}
var xJ = function(e) {
  var t = e.pageBorderBoxWithDroppableScroll, n = e.draggable, r = e.destination, o = e.insideDestination, a = e.last, i = e.viewport, s = e.afterCritical, l = r.axis, c = fs(r.axis, n.displaceBy), d = c.value, f = t[l.start], p = t[l.end], h = Pu(n, o), g = Ar(h, function(v) {
    var w = v.descriptor.id, C = v.page.borderBox.center[l.line], y = yr(w, s), x = HC({
      displaced: a,
      id: w
    });
    return y ? x ? p <= C : f < C - d : x ? p <= C + d : f < C;
  }), m = yJ({
    draggable: n,
    closest: g,
    inHomeList: Sa(n, r)
  });
  return Ul({
    draggable: n,
    insideDestination: o,
    destination: r,
    viewport: i,
    last: a,
    displacedBy: c,
    index: m
  });
}, EJ = 4, IJ = function(e) {
  var t = e.draggable, n = e.pageBorderBoxWithDroppableScroll, r = e.previousImpact, o = e.destination, a = e.insideDestination, i = e.afterCritical;
  if (!o.isCombineEnabled)
    return null;
  var s = o.axis, l = fs(o.axis, t.displaceBy), c = l.value, d = n[s.start], f = n[s.end], p = Pu(t, a), h = Ar(p, function(m) {
    var v = m.descriptor.id, w = m.page.borderBox, C = w[s.size], y = C / EJ, x = yr(v, i), E = HC({
      displaced: r.displaced,
      id: v
    });
    return x ? E ? f > w[s.start] + y && f < w[s.end] - y : d > w[s.start] - c + y && d < w[s.end] - c - y : E ? f > w[s.start] + c + y && f < w[s.end] + c - y : d > w[s.start] + y && d < w[s.end] - y;
  });
  if (!h)
    return null;
  var g = {
    displacedBy: l,
    displaced: r.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: h.descriptor.id,
        droppableId: o.descriptor.id
      }
    }
  };
  return g;
}, BC = function(e) {
  var t = e.pageOffset, n = e.draggable, r = e.draggables, o = e.droppables, a = e.previousImpact, i = e.viewport, s = e.afterCritical, l = FC(n.page.borderBox, t), c = bJ({
    pageBorderBox: l,
    draggable: n,
    droppables: o
  });
  if (!c)
    return FU;
  var d = o[c], f = po(d.descriptor.id, r), p = CJ(d, l);
  return IJ({
    pageBorderBoxWithDroppableScroll: p,
    draggable: n,
    previousImpact: a,
    destination: d,
    insideDestination: f,
    afterCritical: s
  }) || xJ({
    pageBorderBoxWithDroppableScroll: p,
    draggable: n,
    destination: d,
    insideDestination: f,
    last: a.displaced,
    viewport: i,
    afterCritical: s
  });
}, J0 = function(e, t) {
  var n;
  return ee({}, e, (n = {}, n[t.descriptor.id] = t, n));
}, SJ = function(t) {
  var n = t.previousImpact, r = t.impact, o = t.droppables, a = Rt(n), i = Rt(r);
  if (!a || a === i)
    return o;
  var s = o[a];
  if (!s.subject.withPlaceholder)
    return o;
  var l = fJ(s);
  return J0(o, l);
}, DJ = function(e) {
  var t = e.draggable, n = e.draggables, r = e.droppables, o = e.previousImpact, a = e.impact, i = SJ({
    previousImpact: o,
    impact: a,
    droppables: r
  }), s = Rt(a);
  if (!s)
    return i;
  var l = r[s];
  if (Sa(t, l) || l.subject.withPlaceholder)
    return i;
  var c = VC(l, t, n);
  return J0(i, c);
}, ai = function(e) {
  var t = e.state, n = e.clientSelection, r = e.dimensions, o = e.viewport, a = e.impact, i = e.scrollJumpRequest, s = o || t.viewport, l = r || t.dimensions, c = n || t.current.client.selection, d = Ot(c, t.initial.client.selection), f = {
    offset: d,
    selection: c,
    borderBoxCenter: ct(t.initial.client.borderBoxCenter, d)
  }, p = {
    selection: ct(f.selection, s.scroll.current),
    borderBoxCenter: ct(f.borderBoxCenter, s.scroll.current),
    offset: ct(f.offset, s.scroll.diff.value)
  }, h = {
    client: f,
    page: p
  };
  if (t.phase === "COLLECTING")
    return ee({
      phase: "COLLECTING"
    }, t, {
      dimensions: l,
      viewport: s,
      current: h
    });
  var g = l.draggables[t.critical.draggable.id], m = a || BC({
    pageOffset: p.offset,
    draggable: g,
    draggables: l.draggables,
    droppables: l.droppables,
    previousImpact: t.impact,
    viewport: s,
    afterCritical: t.afterCritical
  }), v = DJ({
    draggable: g,
    impact: m,
    previousImpact: t.impact,
    draggables: l.draggables,
    droppables: l.droppables
  }), w = ee({}, t, {
    current: h,
    dimensions: {
      draggables: l.draggables,
      droppables: v
    },
    impact: m,
    viewport: s,
    scrollJumpRequest: i || null,
    forceShouldAnimate: i ? !1 : null
  });
  return w;
};
function MJ(e, t) {
  return e.map(function(n) {
    return t[n];
  });
}
var GC = function(e) {
  var t = e.impact, n = e.viewport, r = e.draggables, o = e.destination, a = e.forceShouldAnimate, i = t.displaced, s = MJ(i.all, r), l = Oi({
    afterDragging: s,
    destination: o,
    displacedBy: t.displacedBy,
    viewport: n.frame,
    forceShouldAnimate: a,
    last: i
  });
  return ee({}, t, {
    displaced: l
  });
}, WC = function(e) {
  var t = e.impact, n = e.draggable, r = e.droppable, o = e.draggables, a = e.viewport, i = e.afterCritical, s = Au({
    impact: t,
    draggable: n,
    draggables: o,
    droppable: r,
    afterCritical: i
  });
  return U0({
    pageBorderBoxCenter: s,
    draggable: n,
    viewport: a
  });
}, ZC = function(e) {
  var t = e.state, n = e.dimensions, r = e.viewport;
  t.movementMode !== "SNAP" && (process.env.NODE_ENV, _(!1));
  var o = t.impact, a = r || t.viewport, i = n || t.dimensions, s = i.draggables, l = i.droppables, c = s[t.critical.draggable.id], d = Rt(o);
  d || (process.env.NODE_ENV !== "production" ? _(!1, "Must be over a destination in SNAP movement mode") : _(!1));
  var f = l[d], p = GC({
    impact: o,
    viewport: a,
    destination: f,
    draggables: s
  }), h = WC({
    impact: p,
    draggable: c,
    droppable: f,
    draggables: s,
    viewport: a,
    afterCritical: t.afterCritical
  });
  return ai({
    impact: p,
    clientSelection: h,
    state: t,
    dimensions: i,
    viewport: a
  });
}, NJ = function(e) {
  return {
    index: e.index,
    droppableId: e.droppableId
  };
}, $C = function(e) {
  var t = e.draggable, n = e.home, r = e.draggables, o = e.viewport, a = fs(n.axis, t.displaceBy), i = po(n.descriptor.id, r), s = i.indexOf(t);
  s === -1 && (process.env.NODE_ENV !== "production" ? _(!1, "Expected draggable to be inside home list") : _(!1));
  var l = i.slice(s + 1), c = l.reduce(function(h, g) {
    return h[g.descriptor.id] = !0, h;
  }, {}), d = {
    inVirtualList: n.descriptor.mode === "virtual",
    displacedBy: a,
    effected: c
  }, f = Oi({
    afterDragging: l,
    destination: n,
    displacedBy: a,
    last: null,
    viewport: o.frame,
    forceShouldAnimate: !1
  }), p = {
    displaced: f,
    displacedBy: a,
    at: {
      type: "REORDER",
      destination: NJ(t.descriptor)
    }
  };
  return {
    impact: p,
    afterCritical: d
  };
}, PJ = function(e, t) {
  return {
    draggables: e.draggables,
    droppables: J0(e.droppables, t)
  };
}, ps = function(t) {
  process.env.NODE_ENV;
}, hs = function(t) {
  process.env.NODE_ENV;
}, AJ = function(e) {
  var t = e.draggable, n = e.offset, r = e.initialWindowScroll, o = Yl(t.client, n), a = jl(o, r), i = ee({}, t, {
    placeholder: ee({}, t.placeholder, {
      client: o
    }),
    client: o,
    page: a
  });
  return i;
}, _J = function(e) {
  var t = e.frame;
  return t || (process.env.NODE_ENV !== "production" ? _(!1, "Expected Droppable to have a frame") : _(!1)), t;
}, OJ = function(e) {
  var t = e.additions, n = e.updatedDroppables, r = e.viewport, o = r.scroll.diff.value;
  return t.map(function(a) {
    var i = a.descriptor.droppableId, s = n[i], l = _J(s), c = l.scroll.diff.value, d = ct(o, c), f = AJ({
      draggable: a,
      offset: d,
      initialWindowScroll: r.scroll.initial
    });
    return f;
  });
}, TJ = function(e) {
  var t = e.state, n = e.published;
  ps();
  var r = n.modified.map(function(y) {
    var x = t.dimensions.droppables[y.droppableId], E = Z0(x, y.scroll);
    return E;
  }), o = ee({}, t.dimensions.droppables, {}, DC(r)), a = MC(OJ({
    additions: n.additions,
    updatedDroppables: o,
    viewport: t.viewport
  })), i = ee({}, t.dimensions.draggables, {}, a);
  n.removals.forEach(function(y) {
    delete i[y];
  });
  var s = {
    droppables: o,
    draggables: i
  }, l = Rt(t.impact), c = l ? s.droppables[l] : null, d = s.draggables[t.critical.draggable.id], f = s.droppables[t.critical.droppable.id], p = $C({
    draggable: d,
    home: f,
    draggables: i,
    viewport: t.viewport
  }), h = p.impact, g = p.afterCritical, m = c && c.isCombineEnabled ? t.impact : h, v = BC({
    pageOffset: t.current.page.offset,
    draggable: s.draggables[t.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: m,
    viewport: t.viewport,
    afterCritical: g
  });
  hs();
  var w = ee({
    phase: "DRAGGING"
  }, t, {
    phase: "DRAGGING",
    impact: v,
    onLiftImpact: h,
    dimensions: s,
    afterCritical: g,
    forceShouldAnimate: !1
  });
  if (t.phase === "COLLECTING")
    return w;
  var C = ee({
    phase: "DROP_PENDING"
  }, w, {
    phase: "DROP_PENDING",
    reason: t.reason,
    isWaiting: !1
  });
  return C;
}, Qf = function(t) {
  return t.movementMode === "SNAP";
}, h1 = function(t, n, r) {
  var o = PJ(t.dimensions, n);
  return !Qf(t) || r ? ai({
    state: t,
    dimensions: o
  }) : ZC({
    state: t,
    dimensions: o
  });
};
function m1(e) {
  return e.isDragging && e.movementMode === "SNAP" ? ee({
    phase: "DRAGGING"
  }, e, {
    scrollJumpRequest: null
  }) : e;
}
var r7 = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
}, LJ = function(e, t) {
  if (e === void 0 && (e = r7), t.type === "FLUSH")
    return ee({}, r7, {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? _(!1, "INITIAL_PUBLISH must come after a IDLE phase") : _(!1));
    var n = t.payload, r = n.critical, o = n.clientSelection, a = n.viewport, i = n.dimensions, s = n.movementMode, l = i.draggables[r.draggable.id], c = i.droppables[r.droppable.id], d = {
      selection: o,
      borderBoxCenter: l.client.borderBox.center,
      offset: it
    }, f = {
      client: d,
      page: {
        selection: ct(d.selection, a.scroll.initial),
        borderBoxCenter: ct(d.selection, a.scroll.initial),
        offset: ct(d.selection, a.scroll.diff.value)
      }
    }, p = Mu(i.droppables).every(function(z) {
      return !z.isFixedOnPage;
    }), h = $C({
      draggable: l,
      home: c,
      draggables: i.draggables,
      viewport: a
    }), g = h.impact, m = h.afterCritical, v = {
      phase: "DRAGGING",
      isDragging: !0,
      critical: r,
      movementMode: s,
      dimensions: i,
      initial: f,
      current: f,
      isWindowScrollAllowed: p,
      impact: g,
      afterCritical: m,
      onLiftImpact: g,
      viewport: a,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return v;
  }
  if (t.type === "COLLECTION_STARTING") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? _(!1, "Collection cannot start from phase " + e.phase) : _(!1));
    var w = ee({
      phase: "COLLECTING"
    }, e, {
      phase: "COLLECTING"
    });
    return w;
  }
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? _(!1, "Unexpected " + t.type + " received in phase " + e.phase) : _(!1)), TJ({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    Fr(e) || (process.env.NODE_ENV !== "production" ? _(!1, t.type + " not permitted in phase " + e.phase) : _(!1));
    var C = t.payload.client;
    return pr(C, e.current.client.selection) ? e : ai({
      state: e,
      clientSelection: C,
      impact: Qf(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return m1(e);
    Fr(e) || (process.env.NODE_ENV !== "production" ? _(!1, t.type + " not permitted in phase " + e.phase) : _(!1));
    var y = t.payload, x = y.id, E = y.newScroll, S = e.dimensions.droppables[x];
    if (!S)
      return e;
    var I = Z0(S, E);
    return h1(e, I, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Fr(e) || (process.env.NODE_ENV !== "production" ? _(!1, "Attempting to move in an unsupported phase " + e.phase) : _(!1));
    var D = t.payload, N = D.id, A = D.isEnabled, L = e.dimensions.droppables[N];
    L || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find Droppable[id: " + N + "] to toggle its enabled state") : _(!1)), L.isEnabled === A && (process.env.NODE_ENV !== "production" ? _(!1, "Trying to set droppable isEnabled to " + String(A) + `
      but it is already ` + String(L.isEnabled)) : _(!1));
    var F = ee({}, L, {
      isEnabled: A
    });
    return h1(e, F, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    Fr(e) || (process.env.NODE_ENV !== "production" ? _(!1, "Attempting to move in an unsupported phase " + e.phase) : _(!1));
    var k = t.payload, G = k.id, J = k.isCombineEnabled, $ = e.dimensions.droppables[G];
    $ || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find Droppable[id: " + G + "] to toggle its isCombineEnabled state") : _(!1)), $.isCombineEnabled === J && (process.env.NODE_ENV !== "production" ? _(!1, "Trying to set droppable isCombineEnabled to " + String(J) + `
      but it is already ` + String($.isCombineEnabled)) : _(!1));
    var H = ee({}, $, {
      isCombineEnabled: J
    });
    return h1(e, H, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    Fr(e) || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot move by window in phase " + e.phase) : _(!1)), e.isWindowScrollAllowed || (process.env.NODE_ENV !== "production" ? _(!1, "Window scrolling is currently not supported for fixed lists") : _(!1));
    var V = t.payload.newScroll;
    if (pr(e.viewport.scroll.current, V))
      return m1(e);
    var j = TC(e.viewport, V);
    return Qf(e) ? ZC({
      state: e,
      viewport: j
    }) : ai({
      state: e,
      viewport: j
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!Fr(e))
      return e;
    var B = t.payload.maxScroll;
    if (pr(B, e.viewport.scroll.max))
      return e;
    var Z = ee({}, e.viewport, {
      scroll: ee({}, e.viewport.scroll, {
        max: B
      })
    });
    return ee({
      phase: "DRAGGING"
    }, e, {
      viewport: Z
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? _(!1, t.type + " received while not in DRAGGING phase") : _(!1));
    var O = vJ({
      state: e,
      type: t.type
    });
    return O ? ai({
      state: e,
      impact: O.impact,
      clientSelection: O.clientSelection,
      scrollJumpRequest: O.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    var Y = t.payload.reason;
    e.phase !== "COLLECTING" && (process.env.NODE_ENV !== "production" ? _(!1, "Can only move into the DROP_PENDING phase from the COLLECTING phase") : _(!1));
    var U = ee({
      phase: "DROP_PENDING"
    }, e, {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: Y
    });
    return U;
  }
  if (t.type === "DROP_ANIMATE") {
    var K = t.payload, q = K.completed, W = K.dropDuration, Q = K.newHomeClientOffset;
    e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot animate drop from phase " + e.phase) : _(!1));
    var te = {
      phase: "DROP_ANIMATING",
      completed: q,
      dropDuration: W,
      newHomeClientOffset: Q,
      dimensions: e.dimensions
    };
    return te;
  }
  if (t.type === "DROP_COMPLETE") {
    var re = t.payload.completed;
    return {
      phase: "IDLE",
      completed: re,
      shouldFlush: !1
    };
  }
  return e;
}, RJ = function(t) {
  return {
    type: "BEFORE_INITIAL_CAPTURE",
    payload: t
  };
}, VJ = function(t) {
  return {
    type: "LIFT",
    payload: t
  };
}, kJ = function(t) {
  return {
    type: "INITIAL_PUBLISH",
    payload: t
  };
}, FJ = function(t) {
  return {
    type: "PUBLISH_WHILE_DRAGGING",
    payload: t
  };
}, HJ = function() {
  return {
    type: "COLLECTION_STARTING",
    payload: null
  };
}, BJ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_SCROLL",
    payload: t
  };
}, GJ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_ENABLED",
    payload: t
  };
}, WJ = function(t) {
  return {
    type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
    payload: t
  };
}, YC = function(t) {
  return {
    type: "MOVE",
    payload: t
  };
}, ZJ = function(t) {
  return {
    type: "MOVE_BY_WINDOW_SCROLL",
    payload: t
  };
}, $J = function(t) {
  return {
    type: "UPDATE_VIEWPORT_MAX_SCROLL",
    payload: t
  };
}, YJ = function() {
  return {
    type: "MOVE_UP",
    payload: null
  };
}, jJ = function() {
  return {
    type: "MOVE_DOWN",
    payload: null
  };
}, zJ = function() {
  return {
    type: "MOVE_RIGHT",
    payload: null
  };
}, XJ = function() {
  return {
    type: "MOVE_LEFT",
    payload: null
  };
}, K0 = function() {
  return {
    type: "FLUSH",
    payload: null
  };
}, UJ = function(t) {
  return {
    type: "DROP_ANIMATE",
    payload: t
  };
}, q0 = function(t) {
  return {
    type: "DROP_COMPLETE",
    payload: t
  };
}, jC = function(t) {
  return {
    type: "DROP",
    payload: t
  };
}, JJ = function(t) {
  return {
    type: "DROP_PENDING",
    payload: t
  };
}, zC = function() {
  return {
    type: "DROP_ANIMATION_FINISHED",
    payload: null
  };
};
function KJ(e) {
  if (!(e.length <= 1)) {
    for (var t = e.map(function(s) {
      return s.descriptor.index;
    }), n = {}, r = 1; r < t.length; r++) {
      var o = t[r], a = t[r - 1];
      o !== a + 1 && (n[o] = !0);
    }
    if (Object.keys(n).length) {
      var i = t.map(function(s) {
        var l = !!n[s];
        return l ? "[🔥" + s + "]" : "" + s;
      }).join(", ");
      process.env.NODE_ENV !== "production" && Ge(`
    Detected non-consecutive <Draggable /> indexes.

    (This can cause unexpected bugs)

    ` + i + `
  `);
    }
  }
}
function qJ(e, t) {
  if (process.env.NODE_ENV !== "production") {
    var n = po(e.droppable.id, t.draggables);
    KJ(n);
  }
}
var QJ = function(e) {
  return function(t) {
    var n = t.getState, r = t.dispatch;
    return function(o) {
      return function(a) {
        if (a.type !== "LIFT") {
          o(a);
          return;
        }
        var i = a.payload, s = i.id, l = i.clientSelection, c = i.movementMode, d = n();
        d.phase === "DROP_ANIMATING" && r(q0({
          completed: d.completed
        })), n().phase !== "IDLE" && (process.env.NODE_ENV !== "production" ? _(!1, "Unexpected phase to start a drag") : _(!1)), r(K0()), r(RJ({
          draggableId: s,
          movementMode: c
        }));
        var f = {
          shouldPublishImmediately: c === "SNAP"
        }, p = {
          draggableId: s,
          scrollOptions: f
        }, h = e.startPublishing(p), g = h.critical, m = h.dimensions, v = h.viewport;
        qJ(g, m), r(kJ({
          critical: g,
          dimensions: m,
          clientSelection: l,
          movementMode: c,
          viewport: v
        }));
      };
    };
  };
}, eK = function(e) {
  return function() {
    return function(t) {
      return function(n) {
        n.type === "INITIAL_PUBLISH" && e.dragging(), n.type === "DROP_ANIMATE" && e.dropping(n.payload.completed.result.reason), (n.type === "FLUSH" || n.type === "DROP_COMPLETE") && e.resting(), t(n);
      };
    };
  };
}, Q0 = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, Ti = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, e5 = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, Rr = e5.outOfTheWay + "s " + Q0.outOfTheWay, ii = {
  fluid: "opacity " + Rr,
  snap: "transform " + Rr + ", opacity " + Rr,
  drop: function(t) {
    var n = t + "s " + Q0.drop;
    return "transform " + n + ", opacity " + n;
  },
  outOfTheWay: "transform " + Rr,
  placeholder: "height " + Rr + ", width " + Rr + ", margin " + Rr
}, o7 = function(t) {
  return pr(t, it) ? null : "translate(" + t.x + "px, " + t.y + "px)";
}, e2 = {
  moveTo: o7,
  drop: function(t, n) {
    var r = o7(t);
    return r ? n ? r + " scale(" + Ti.scale.drop + ")" : r : null;
  }
}, t2 = e5.minDropTime, XC = e5.maxDropTime, tK = XC - t2, a7 = 1500, nK = 0.6, rK = function(e) {
  var t = e.current, n = e.destination, r = e.reason, o = Ai(t, n);
  if (o <= 0)
    return t2;
  if (o >= a7)
    return XC;
  var a = o / a7, i = t2 + tK * a, s = r === "CANCEL" ? i * nK : i;
  return Number(s.toFixed(2));
}, oK = function(e) {
  var t = e.impact, n = e.draggable, r = e.dimensions, o = e.viewport, a = e.afterCritical, i = r.draggables, s = r.droppables, l = Rt(t), c = l ? s[l] : null, d = s[n.descriptor.droppableId], f = WC({
    impact: t,
    draggable: n,
    draggables: i,
    afterCritical: a,
    droppable: c || d,
    viewport: o
  }), p = Ot(f, n.client.borderBox.center);
  return p;
}, aK = function(e) {
  var t = e.draggables, n = e.reason, r = e.lastImpact, o = e.home, a = e.viewport, i = e.onLiftImpact;
  if (!r.at || n !== "DROP") {
    var s = GC({
      draggables: t,
      impact: i,
      destination: o,
      viewport: a,
      forceShouldAnimate: !0
    });
    return {
      impact: s,
      didDropInsideDroppable: !1
    };
  }
  if (r.at.type === "REORDER")
    return {
      impact: r,
      didDropInsideDroppable: !0
    };
  var l = ee({}, r, {
    displaced: _i
  });
  return {
    impact: l,
    didDropInsideDroppable: !0
  };
}, iK = function(e) {
  var t = e.getState, n = e.dispatch;
  return function(r) {
    return function(o) {
      if (o.type !== "DROP") {
        r(o);
        return;
      }
      var a = t(), i = o.payload.reason;
      if (a.phase === "COLLECTING") {
        n(JJ({
          reason: i
        }));
        return;
      }
      if (a.phase !== "IDLE") {
        var s = a.phase === "DROP_PENDING" && a.isWaiting;
        s && (process.env.NODE_ENV !== "production" ? _(!1, "A DROP action occurred while DROP_PENDING and still waiting") : _(!1)), a.phase === "DRAGGING" || a.phase === "DROP_PENDING" || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot drop in phase: " + a.phase) : _(!1));
        var l = a.critical, c = a.dimensions, d = c.draggables[a.critical.draggable.id], f = aK({
          reason: i,
          lastImpact: a.impact,
          afterCritical: a.afterCritical,
          onLiftImpact: a.onLiftImpact,
          home: a.dimensions.droppables[a.critical.droppable.id],
          viewport: a.viewport,
          draggables: a.dimensions.draggables
        }), p = f.impact, h = f.didDropInsideDroppable, g = h ? Y0(p) : null, m = h ? Nu(p) : null, v = {
          index: l.draggable.index,
          droppableId: l.droppable.id
        }, w = {
          draggableId: d.descriptor.id,
          type: d.descriptor.type,
          source: v,
          reason: i,
          mode: a.movementMode,
          destination: g,
          combine: m
        }, C = oK({
          impact: p,
          draggable: d,
          dimensions: c,
          viewport: a.viewport,
          afterCritical: a.afterCritical
        }), y = {
          critical: a.critical,
          afterCritical: a.afterCritical,
          result: w,
          impact: p
        }, x = !pr(a.current.client.offset, C) || !!w.combine;
        if (!x) {
          n(q0({
            completed: y
          }));
          return;
        }
        var E = rK({
          current: a.current.client.offset,
          destination: C,
          reason: i
        }), S = {
          newHomeClientOffset: C,
          dropDuration: E,
          completed: y
        };
        n(UJ(S));
      }
    };
  };
}, UC = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};
function sK(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function(n) {
      n.target !== window && n.target !== window.document || e();
    }
  };
}
function lK(e) {
  var t = e.onWindowScroll;
  function n() {
    t(UC());
  }
  var r = Ni(n), o = sK(r), a = fr;
  function i() {
    return a !== fr;
  }
  function s() {
    i() && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot start scroll listener when already active") : _(!1)), a = Yt(window, [o]);
  }
  function l() {
    i() || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot stop scroll listener when not active") : _(!1)), r.cancel(), a(), a = fr;
  }
  return {
    start: s,
    stop: l,
    isActive: i
  };
}
var cK = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, uK = function(e) {
  var t = lK({
    onWindowScroll: function(r) {
      e.dispatch(ZJ({
        newScroll: r
      }));
    }
  });
  return function(n) {
    return function(r) {
      !t.isActive() && r.type === "INITIAL_PUBLISH" && t.start(), t.isActive() && cK(r) && t.stop(), n(r);
    };
  };
}, dK = function(e) {
  var t = !1, n = !1, r = setTimeout(function() {
    n = !0;
  }), o = function(i) {
    if (t) {
      process.env.NODE_ENV !== "production" && Ge("Announcement already made. Not making a second announcement");
      return;
    }
    if (n) {
      process.env.NODE_ENV !== "production" && Ge(`
        Announcements cannot be made asynchronously.
        Default message has already been announced.
      `);
      return;
    }
    t = !0, e(i), clearTimeout(r);
  };
  return o.wasCalled = function() {
    return t;
  }, o;
}, fK = function() {
  var e = [], t = function(a) {
    var i = $0(e, function(c) {
      return c.timerId === a;
    });
    i === -1 && (process.env.NODE_ENV !== "production" ? _(!1, "Could not find timer") : _(!1));
    var s = e.splice(i, 1), l = s[0];
    l.callback();
  }, n = function(a) {
    var i = setTimeout(function() {
      return t(i);
    }), s = {
      timerId: i,
      callback: a
    };
    e.push(s);
  }, r = function() {
    if (e.length) {
      var a = [].concat(e);
      e.length = 0, a.forEach(function(i) {
        clearTimeout(i.timerId), i.callback();
      });
    }
  };
  return {
    add: n,
    flush: r
  };
}, pK = function(t, n) {
  return t == null && n == null ? !0 : t == null || n == null ? !1 : t.droppableId === n.droppableId && t.index === n.index;
}, hK = function(t, n) {
  return t == null && n == null ? !0 : t == null || n == null ? !1 : t.draggableId === n.draggableId && t.droppableId === n.droppableId;
}, mK = function(t, n) {
  if (t === n)
    return !0;
  var r = t.draggable.id === n.draggable.id && t.draggable.droppableId === n.draggable.droppableId && t.draggable.type === n.draggable.type && t.draggable.index === n.draggable.index, o = t.droppable.id === n.droppable.id && t.droppable.type === n.droppable.type;
  return r && o;
}, Ba = function(t, n) {
  ps(), n(), hs();
}, Ys = function(t, n) {
  return {
    draggableId: t.draggable.id,
    type: t.droppable.type,
    source: {
      droppableId: t.droppable.id,
      index: t.draggable.index
    },
    mode: n
  };
}, v1 = function(t, n, r, o) {
  if (!t) {
    r(o(n));
    return;
  }
  var a = dK(r), i = {
    announce: a
  };
  t(n, i), a.wasCalled() || r(o(n));
}, vK = function(e, t) {
  var n = fK(), r = null, o = function(p, h) {
    r && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fire onBeforeCapture as a drag start has already been published") : _(!1)), Ba("onBeforeCapture", function() {
      var g = e().onBeforeCapture;
      if (g) {
        var m = {
          draggableId: p,
          mode: h
        };
        g(m);
      }
    });
  }, a = function(p, h) {
    r && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : _(!1)), Ba("onBeforeDragStart", function() {
      var g = e().onBeforeDragStart;
      g && g(Ys(p, h));
    });
  }, i = function(p, h) {
    r && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fire onBeforeDragStart as a drag start has already been published") : _(!1));
    var g = Ys(p, h);
    r = {
      mode: h,
      lastCritical: p,
      lastLocation: g.source,
      lastCombine: null
    }, n.add(function() {
      Ba("onDragStart", function() {
        return v1(e().onDragStart, g, t, dl.onDragStart);
      });
    });
  }, s = function(p, h) {
    var g = Y0(h), m = Nu(h);
    r || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fire onDragMove when onDragStart has not been called") : _(!1));
    var v = !mK(p, r.lastCritical);
    v && (r.lastCritical = p);
    var w = !pK(r.lastLocation, g);
    w && (r.lastLocation = g);
    var C = !hK(r.lastCombine, m);
    if (C && (r.lastCombine = m), !(!v && !w && !C)) {
      var y = ee({}, Ys(p, r.mode), {
        combine: m,
        destination: g
      });
      n.add(function() {
        Ba("onDragUpdate", function() {
          return v1(e().onDragUpdate, y, t, dl.onDragUpdate);
        });
      });
    }
  }, l = function() {
    r || (process.env.NODE_ENV !== "production" ? _(!1, "Can only flush responders while dragging") : _(!1)), n.flush();
  }, c = function(p) {
    r || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fire onDragEnd when there is no matching onDragStart") : _(!1)), r = null, Ba("onDragEnd", function() {
      return v1(e().onDragEnd, p, t, dl.onDragEnd);
    });
  }, d = function() {
    if (r) {
      var p = ee({}, Ys(r.lastCritical, r.mode), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      c(p);
    }
  };
  return {
    beforeCapture: o,
    beforeStart: a,
    start: i,
    update: s,
    flush: l,
    drop: c,
    abort: d
  };
}, gK = function(e, t) {
  var n = vK(e, t);
  return function(r) {
    return function(o) {
      return function(a) {
        if (a.type === "BEFORE_INITIAL_CAPTURE") {
          n.beforeCapture(a.payload.draggableId, a.payload.movementMode);
          return;
        }
        if (a.type === "INITIAL_PUBLISH") {
          var i = a.payload.critical;
          n.beforeStart(i, a.payload.movementMode), o(a), n.start(i, a.payload.movementMode);
          return;
        }
        if (a.type === "DROP_COMPLETE") {
          var s = a.payload.completed.result;
          n.flush(), o(a), n.drop(s);
          return;
        }
        if (o(a), a.type === "FLUSH") {
          n.abort();
          return;
        }
        var l = r.getState();
        l.phase === "DRAGGING" && n.update(l.critical, l.impact);
      };
    };
  };
}, wK = function(e) {
  return function(t) {
    return function(n) {
      if (n.type !== "DROP_ANIMATION_FINISHED") {
        t(n);
        return;
      }
      var r = e.getState();
      r.phase !== "DROP_ANIMATING" && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot finish a drop animating when no drop is occurring") : _(!1)), e.dispatch(q0({
        completed: r.completed
      }));
    };
  };
}, bK = function(e) {
  var t = null, n = null;
  function r() {
    n && (cancelAnimationFrame(n), n = null), t && (t(), t = null);
  }
  return function(o) {
    return function(a) {
      if ((a.type === "FLUSH" || a.type === "DROP_COMPLETE" || a.type === "DROP_ANIMATION_FINISHED") && r(), o(a), a.type === "DROP_ANIMATE") {
        var i = {
          eventName: "scroll",
          options: {
            capture: !0,
            passive: !1,
            once: !0
          },
          fn: function() {
            var l = e.getState();
            l.phase === "DROP_ANIMATING" && e.dispatch(zC());
          }
        };
        n = requestAnimationFrame(function() {
          n = null, t = Yt(window, [i]);
        });
      }
    };
  };
}, CK = function(e) {
  return function() {
    return function(t) {
      return function(n) {
        (n.type === "DROP_COMPLETE" || n.type === "FLUSH" || n.type === "DROP_ANIMATE") && e.stopPublishing(), t(n);
      };
    };
  };
}, yK = function(e) {
  var t = !1;
  return function() {
    return function(n) {
      return function(r) {
        if (r.type === "INITIAL_PUBLISH") {
          t = !0, e.tryRecordFocus(r.payload.critical.draggable.id), n(r), e.tryRestoreFocusRecorded();
          return;
        }
        if (n(r), !!t) {
          if (r.type === "FLUSH") {
            t = !1, e.tryRestoreFocusRecorded();
            return;
          }
          if (r.type === "DROP_COMPLETE") {
            t = !1;
            var o = r.payload.completed.result;
            o.combine && e.tryShiftRecord(o.draggableId, o.combine.draggableId), e.tryRestoreFocusRecorded();
          }
        }
      };
    };
  };
}, xK = function(t) {
  return t.type === "DROP_COMPLETE" || t.type === "DROP_ANIMATE" || t.type === "FLUSH";
}, EK = function(e) {
  return function(t) {
    return function(n) {
      return function(r) {
        if (xK(r)) {
          e.stop(), n(r);
          return;
        }
        if (r.type === "INITIAL_PUBLISH") {
          n(r);
          var o = t.getState();
          o.phase !== "DRAGGING" && (process.env.NODE_ENV !== "production" ? _(!1, "Expected phase to be DRAGGING after INITIAL_PUBLISH") : _(!1)), e.start(o);
          return;
        }
        n(r), e.scroll(t.getState());
      };
    };
  };
}, IK = function(e) {
  return function(t) {
    return function(n) {
      if (t(n), n.type === "PUBLISH_WHILE_DRAGGING") {
        var r = e.getState();
        r.phase === "DROP_PENDING" && (r.isWaiting || e.dispatch(jC({
          reason: r.reason
        })));
      }
    };
  };
}, SK = process.env.NODE_ENV !== "production" && typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: "react-beautiful-dnd"
}) : cC, DK = function(e) {
  var t = e.dimensionMarshal, n = e.focusMarshal, r = e.styleMarshal, o = e.getResponders, a = e.announce, i = e.autoScroller;
  return lC(LJ, SK(IX(eK(r), CK(t), QJ(t), iK, wK, bK, IK, EK(i), uK, yK(n), gK(o, a))));
}, g1 = function() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function MK(e) {
  var t = e.registry, n = e.callbacks, r = g1(), o = null, a = function() {
    o || (n.collectionStarting(), o = requestAnimationFrame(function() {
      o = null, ps();
      var d = r, f = d.additions, p = d.removals, h = d.modified, g = Object.keys(f).map(function(w) {
        return t.draggable.getById(w).getDimension(it);
      }).sort(function(w, C) {
        return w.descriptor.index - C.descriptor.index;
      }), m = Object.keys(h).map(function(w) {
        var C = t.droppable.getById(w), y = C.callbacks.getScrollWhileDragging();
        return {
          droppableId: w,
          scroll: y
        };
      }), v = {
        additions: g,
        removals: Object.keys(p),
        modified: m
      };
      r = g1(), hs(), n.publish(v);
    }));
  }, i = function(d) {
    var f = d.descriptor.id;
    r.additions[f] = d, r.modified[d.descriptor.droppableId] = !0, r.removals[f] && delete r.removals[f], a();
  }, s = function(d) {
    var f = d.descriptor;
    r.removals[f.id] = !0, r.modified[f.droppableId] = !0, r.additions[f.id] && delete r.additions[f.id], a();
  }, l = function() {
    o && (cancelAnimationFrame(o), o = null, r = g1());
  };
  return {
    add: i,
    remove: s,
    stop: l
  };
}
var JC = function(e) {
  var t = e.scrollHeight, n = e.scrollWidth, r = e.height, o = e.width, a = Ot({
    x: n,
    y: t
  }, {
    x: o,
    y: r
  }), i = {
    x: Math.max(0, a.x),
    y: Math.max(0, a.y)
  };
  return i;
}, KC = function() {
  var e = document.documentElement;
  return e || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find document.documentElement") : _(!1)), e;
}, qC = function() {
  var e = KC(), t = JC({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
  return t;
}, NK = function() {
  var e = UC(), t = qC(), n = e.y, r = e.x, o = KC(), a = o.clientWidth, i = o.clientHeight, s = r + a, l = n + i, c = en({
    top: n,
    left: r,
    right: s,
    bottom: l
  }), d = {
    frame: c,
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: it,
        displacement: it
      }
    }
  };
  return d;
}, PK = function(e) {
  var t = e.critical, n = e.scrollOptions, r = e.registry;
  ps();
  var o = NK(), a = o.scroll.current, i = t.droppable, s = r.droppable.getAllByType(i.type).map(function(f) {
    return f.callbacks.getDimensionAndWatchScroll(a, n);
  }), l = r.draggable.getAllByType(t.draggable.type).map(function(f) {
    return f.getDimension(a);
  }), c = {
    draggables: MC(l),
    droppables: DC(s)
  };
  hs();
  var d = {
    dimensions: c,
    critical: t,
    viewport: o
  };
  return d;
};
function i7(e, t, n) {
  if (n.descriptor.id === t.id || n.descriptor.type !== t.type)
    return !1;
  var r = e.droppable.getById(n.descriptor.droppableId);
  return r.descriptor.mode !== "virtual" ? (process.env.NODE_ENV !== "production" && Ge(`
      You are attempting to add or remove a Draggable [id: ` + n.descriptor.id + `]
      while a drag is occurring. This is only supported for virtual lists.

      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md
    `), !1) : !0;
}
var AK = function(e, t) {
  var n = null, r = MK({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), o = function(h, g) {
    e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot update is enabled flag of Droppable " + h + " as it is not registered") : _(!1)), n && t.updateDroppableIsEnabled({
      id: h,
      isEnabled: g
    });
  }, a = function(h, g) {
    n && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot update isCombineEnabled flag of Droppable " + h + " as it is not registered") : _(!1)), t.updateDroppableIsCombineEnabled({
      id: h,
      isCombineEnabled: g
    }));
  }, i = function(h, g) {
    n && (e.droppable.exists(h) || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot update the scroll on Droppable " + h + " as it is not registered") : _(!1)), t.updateDroppableScroll({
      id: h,
      newScroll: g
    }));
  }, s = function(h, g) {
    n && e.droppable.getById(h).callbacks.scroll(g);
  }, l = function() {
    if (n) {
      r.stop();
      var h = n.critical.droppable;
      e.droppable.getAllByType(h.type).forEach(function(g) {
        return g.callbacks.dragStopped();
      }), n.unsubscribe(), n = null;
    }
  }, c = function(h) {
    n || (process.env.NODE_ENV !== "production" ? _(!1, "Should only be subscribed when a collection is occurring") : _(!1));
    var g = n.critical.draggable;
    h.type === "ADDITION" && i7(e, g, h.value) && r.add(h.value), h.type === "REMOVAL" && i7(e, g, h.value) && r.remove(h.value);
  }, d = function(h) {
    n && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot start capturing critical dimensions as there is already a collection") : _(!1));
    var g = e.draggable.getById(h.draggableId), m = e.droppable.getById(g.descriptor.droppableId), v = {
      draggable: g.descriptor,
      droppable: m.descriptor
    }, w = e.subscribe(c);
    return n = {
      critical: v,
      unsubscribe: w
    }, PK({
      critical: v,
      registry: e,
      scrollOptions: h.scrollOptions
    });
  }, f = {
    updateDroppableIsEnabled: o,
    updateDroppableIsCombineEnabled: a,
    scrollDroppable: s,
    updateDroppableScroll: i,
    startPublishing: d,
    stopPublishing: l
  };
  return f;
}, QC = function(e, t) {
  return e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP";
}, _K = function(e) {
  window.scrollBy(e.x, e.y);
}, OK = ot(function(e) {
  return Mu(e).filter(function(t) {
    return !(!t.isEnabled || !t.frame);
  });
}), TK = function(t, n) {
  var r = Ar(OK(n), function(o) {
    return o.frame || (process.env.NODE_ENV !== "production" ? _(!1, "Invalid result") : _(!1)), kC(o.frame.pageMarginBox)(t);
  });
  return r;
}, LK = function(e) {
  var t = e.center, n = e.destination, r = e.droppables;
  if (n) {
    var o = r[n];
    return o.frame ? o : null;
  }
  var a = TK(t, r);
  return a;
}, hr = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function(t) {
    return Math.pow(t, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
}, RK = function(e, t) {
  var n = e[t.size] * hr.startFromPercentage, r = e[t.size] * hr.maxScrollAtPercentage, o = {
    startScrollingFrom: n,
    maxScrollValueAt: r
  };
  return o;
}, ey = function(e) {
  var t = e.startOfRange, n = e.endOfRange, r = e.current, o = n - t;
  if (o === 0)
    return process.env.NODE_ENV !== "production" && Ge(`
      Detected distance range of 0 in the fluid auto scroller
      This is unexpected and would cause a divide by 0 issue.
      Not allowing an auto scroll
    `), 0;
  var a = r - t, i = a / o;
  return i;
}, t5 = 1, VK = function(e, t) {
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return hr.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return t5;
  var n = ey({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), r = 1 - n, o = hr.maxPixelScroll * hr.ease(r);
  return Math.ceil(o);
}, s7 = hr.durationDampening.accelerateAt, l7 = hr.durationDampening.stopDampeningAt, kK = function(e, t) {
  var n = t, r = l7, o = Date.now(), a = o - n;
  if (a >= l7)
    return e;
  if (a < s7)
    return t5;
  var i = ey({
    startOfRange: s7,
    endOfRange: r,
    current: a
  }), s = e * hr.ease(i);
  return Math.ceil(s);
}, c7 = function(e) {
  var t = e.distanceToEdge, n = e.thresholds, r = e.dragStartTime, o = e.shouldUseTimeDampening, a = VK(t, n);
  return a === 0 ? 0 : o ? Math.max(kK(a, r), t5) : a;
}, u7 = function(e) {
  var t = e.container, n = e.distanceToEdges, r = e.dragStartTime, o = e.axis, a = e.shouldUseTimeDampening, i = RK(t, o), s = n[o.end] < n[o.start];
  return s ? c7({
    distanceToEdge: n[o.end],
    thresholds: i,
    dragStartTime: r,
    shouldUseTimeDampening: a
  }) : -1 * c7({
    distanceToEdge: n[o.start],
    thresholds: i,
    dragStartTime: r,
    shouldUseTimeDampening: a
  });
}, FK = function(e) {
  var t = e.container, n = e.subject, r = e.proposedScroll, o = n.height > t.height, a = n.width > t.width;
  return !a && !o ? r : a && o ? null : {
    x: a ? 0 : r.x,
    y: o ? 0 : r.y
  };
}, HK = IC(function(e) {
  return e === 0 ? 0 : e;
}), ty = function(e) {
  var t = e.dragStartTime, n = e.container, r = e.subject, o = e.center, a = e.shouldUseTimeDampening, i = {
    top: o.y - n.top,
    right: n.right - o.x,
    bottom: n.bottom - o.y,
    left: o.x - n.left
  }, s = u7({
    container: n,
    distanceToEdges: i,
    dragStartTime: t,
    axis: j0,
    shouldUseTimeDampening: a
  }), l = u7({
    container: n,
    distanceToEdges: i,
    dragStartTime: t,
    axis: AC,
    shouldUseTimeDampening: a
  }), c = HK({
    x: l,
    y: s
  });
  if (pr(c, it))
    return null;
  var d = FK({
    container: n,
    subject: r,
    proposedScroll: c
  });
  return d ? pr(d, it) ? null : d : null;
}, BK = IC(function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}), n5 = function() {
  var e = function(n, r) {
    return n < 0 ? n : n > r ? n - r : 0;
  };
  return function(t) {
    var n = t.current, r = t.max, o = t.change, a = ct(n, o), i = {
      x: e(a.x, r.x),
      y: e(a.y, r.y)
    };
    return pr(i, it) ? null : i;
  };
}(), ny = function(t) {
  var n = t.max, r = t.current, o = t.change, a = {
    x: Math.max(r.x, n.x),
    y: Math.max(r.y, n.y)
  }, i = BK(o), s = n5({
    max: a,
    current: r,
    change: i
  });
  return !s || i.x !== 0 && s.x === 0 || i.y !== 0 && s.y === 0;
}, r5 = function(t, n) {
  return ny({
    current: t.scroll.current,
    max: t.scroll.max,
    change: n
  });
}, GK = function(t, n) {
  if (!r5(t, n))
    return null;
  var r = t.scroll.max, o = t.scroll.current;
  return n5({
    current: o,
    max: r,
    change: n
  });
}, o5 = function(t, n) {
  var r = t.frame;
  return r ? ny({
    current: r.scroll.current,
    max: r.scroll.max,
    change: n
  }) : !1;
}, WK = function(t, n) {
  var r = t.frame;
  return !r || !o5(t, n) ? null : n5({
    current: r.scroll.current,
    max: r.scroll.max,
    change: n
  });
}, ZK = function(e) {
  var t = e.viewport, n = e.subject, r = e.center, o = e.dragStartTime, a = e.shouldUseTimeDampening, i = ty({
    dragStartTime: o,
    container: t.frame,
    subject: n,
    center: r,
    shouldUseTimeDampening: a
  });
  return i && r5(t, i) ? i : null;
}, $K = function(e) {
  var t = e.droppable, n = e.subject, r = e.center, o = e.dragStartTime, a = e.shouldUseTimeDampening, i = t.frame;
  if (!i)
    return null;
  var s = ty({
    dragStartTime: o,
    container: i.pageMarginBox,
    subject: n,
    center: r,
    shouldUseTimeDampening: a
  });
  return s && o5(t, s) ? s : null;
}, d7 = function(e) {
  var t = e.state, n = e.dragStartTime, r = e.shouldUseTimeDampening, o = e.scrollWindow, a = e.scrollDroppable, i = t.current.page.borderBoxCenter, s = t.dimensions.draggables[t.critical.draggable.id], l = s.page.marginBox;
  if (t.isWindowScrollAllowed) {
    var c = t.viewport, d = ZK({
      dragStartTime: n,
      viewport: c,
      subject: l,
      center: i,
      shouldUseTimeDampening: r
    });
    if (d) {
      o(d);
      return;
    }
  }
  var f = LK({
    center: i,
    destination: Rt(t.impact),
    droppables: t.dimensions.droppables
  });
  if (f) {
    var p = $K({
      dragStartTime: n,
      droppable: f,
      subject: l,
      center: i,
      shouldUseTimeDampening: r
    });
    p && a(f.descriptor.id, p);
  }
}, YK = function(e) {
  var t = e.scrollWindow, n = e.scrollDroppable, r = Ni(t), o = Ni(n), a = null, i = function(d) {
    a || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot fluid scroll if not dragging") : _(!1));
    var f = a, p = f.shouldUseTimeDampening, h = f.dragStartTime;
    d7({
      state: d,
      scrollWindow: r,
      scrollDroppable: o,
      dragStartTime: h,
      shouldUseTimeDampening: p
    });
  }, s = function(d) {
    ps(), a && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot start auto scrolling when already started") : _(!1));
    var f = Date.now(), p = !1, h = function() {
      p = !0;
    };
    d7({
      state: d,
      dragStartTime: 0,
      shouldUseTimeDampening: !1,
      scrollWindow: h,
      scrollDroppable: h
    }), a = {
      dragStartTime: f,
      shouldUseTimeDampening: p
    }, hs(), p && i(d);
  }, l = function() {
    a && (r.cancel(), o.cancel(), a = null);
  };
  return {
    start: s,
    stop: l,
    scroll: i
  };
}, jK = function(e) {
  var t = e.move, n = e.scrollDroppable, r = e.scrollWindow, o = function(c, d) {
    var f = ct(c.current.client.selection, d);
    t({
      client: f
    });
  }, a = function(c, d) {
    if (!o5(c, d))
      return d;
    var f = WK(c, d);
    if (!f)
      return n(c.descriptor.id, d), null;
    var p = Ot(d, f);
    n(c.descriptor.id, p);
    var h = Ot(d, p);
    return h;
  }, i = function(c, d, f) {
    if (!c || !r5(d, f))
      return f;
    var p = GK(d, f);
    if (!p)
      return r(f), null;
    var h = Ot(f, p);
    r(h);
    var g = Ot(f, h);
    return g;
  }, s = function(c) {
    var d = c.scrollJumpRequest;
    if (d) {
      var f = Rt(c.impact);
      f || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot perform a jump scroll when there is no destination") : _(!1));
      var p = a(c.dimensions.droppables[f], d);
      if (p) {
        var h = c.viewport, g = i(c.isWindowScrollAllowed, h, p);
        g && o(c, g);
      }
    }
  };
  return s;
}, zK = function(e) {
  var t = e.scrollDroppable, n = e.scrollWindow, r = e.move, o = YK({
    scrollWindow: n,
    scrollDroppable: t
  }), a = jK({
    move: r,
    scrollWindow: n,
    scrollDroppable: t
  }), i = function(c) {
    if (c.phase === "DRAGGING") {
      if (c.movementMode === "FLUID") {
        o.scroll(c);
        return;
      }
      c.scrollJumpRequest && a(c);
    }
  }, s = {
    scroll: i,
    start: o.start,
    stop: o.stop
  };
  return s;
}, qo = "data-rbd", Qo = function() {
  var e = qo + "-drag-handle";
  return {
    base: e,
    draggableId: e + "-draggable-id",
    contextId: e + "-context-id"
  };
}(), n2 = function() {
  var e = qo + "-draggable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), XK = function() {
  var e = qo + "-droppable";
  return {
    base: e,
    contextId: e + "-context-id",
    id: e + "-id"
  };
}(), f7 = {
  contextId: qo + "-scroll-container-context-id"
}, UK = function(t) {
  return function(n) {
    return "[" + n + '="' + t + '"]';
  };
}, Ga = function(t, n) {
  return t.map(function(r) {
    var o = r.styles[n];
    return o ? r.selector + " { " + o + " }" : "";
  }).join(" ");
}, JK = "pointer-events: none;", KK = function(e) {
  var t = UK(e), n = function() {
    var s = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(Qo.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: s,
        dragging: JK,
        dropAnimating: s
      }
    };
  }(), r = function() {
    var s = `
      transition: ` + ii.outOfTheWay + `;
    `;
    return {
      selector: t(n2.contextId),
      styles: {
        dragging: s,
        dropAnimating: s,
        userCancel: s
      }
    };
  }(), o = {
    selector: t(XK.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, a = {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }, i = [r, n, o, a];
  return {
    always: Ga(i, "always"),
    resting: Ga(i, "resting"),
    dragging: Ga(i, "dragging"),
    dropAnimating: Ga(i, "dropAnimating"),
    userCancel: Ga(i, "userCancel")
  };
}, Vt = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ea : ye, w1 = function() {
  var t = document.querySelector("head");
  return t || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find the head to append a style to") : _(!1)), t;
}, p7 = function(t) {
  var n = document.createElement("style");
  return t && n.setAttribute("nonce", t), n.type = "text/css", n;
};
function qK(e, t) {
  var n = Se(function() {
    return KK(e);
  }, [e]), r = le(null), o = le(null), a = fe(ot(function(f) {
    var p = o.current;
    p || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot set dynamic style element if it is not set") : _(!1)), p.textContent = f;
  }), []), i = fe(function(f) {
    var p = r.current;
    p || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot set dynamic style element if it is not set") : _(!1)), p.textContent = f;
  }, []);
  Vt(function() {
    !r.current && !o.current || (process.env.NODE_ENV !== "production" ? _(!1, "style elements already mounted") : _(!1));
    var f = p7(t), p = p7(t);
    return r.current = f, o.current = p, f.setAttribute(qo + "-always", e), p.setAttribute(qo + "-dynamic", e), w1().appendChild(f), w1().appendChild(p), i(n.always), a(n.resting), function() {
      var h = function(m) {
        var v = m.current;
        v || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot unmount ref as it is not set") : _(!1)), w1().removeChild(v), m.current = null;
      };
      h(r), h(o);
    };
  }, [t, i, a, n.always, n.resting, e]);
  var s = fe(function() {
    return a(n.dragging);
  }, [a, n.dragging]), l = fe(function(f) {
    if (f === "DROP") {
      a(n.dropAnimating);
      return;
    }
    a(n.userCancel);
  }, [a, n.dropAnimating, n.userCancel]), c = fe(function() {
    o.current && a(n.resting);
  }, [a, n.resting]), d = Se(function() {
    return {
      dragging: s,
      dropping: l,
      resting: c
    };
  }, [s, l, c]);
  return d;
}
var ry = function(e) {
  return e && e.ownerDocument ? e.ownerDocument.defaultView : window;
};
function ms(e) {
  return e instanceof ry(e).HTMLElement;
}
function oy(e, t) {
  var n = "[" + Qo.contextId + '="' + e + '"]', r = SC(document.querySelectorAll(n));
  if (!r.length)
    return process.env.NODE_ENV !== "production" && Ge('Unable to find any drag handles in the context "' + e + '"'), null;
  var o = Ar(r, function(a) {
    return a.getAttribute(Qo.draggableId) === t;
  });
  return o ? ms(o) ? o : (process.env.NODE_ENV !== "production" && Ge("drag handle needs to be a HTMLElement"), null) : (process.env.NODE_ENV !== "production" && Ge('Unable to find drag handle with id "' + t + '" as no handle with a matching id was found'), null);
}
function QK(e) {
  var t = le({}), n = le(null), r = le(null), o = le(!1), a = fe(function(p, h) {
    var g = {
      id: p,
      focus: h
    };
    return t.current[p] = g, function() {
      var v = t.current, w = v[p];
      w !== g && delete v[p];
    };
  }, []), i = fe(function(p) {
    var h = oy(e, p);
    h && h !== document.activeElement && h.focus();
  }, [e]), s = fe(function(p, h) {
    n.current === p && (n.current = h);
  }, []), l = fe(function() {
    r.current || o.current && (r.current = requestAnimationFrame(function() {
      r.current = null;
      var p = n.current;
      p && i(p);
    }));
  }, [i]), c = fe(function(p) {
    n.current = null;
    var h = document.activeElement;
    h && h.getAttribute(Qo.draggableId) === p && (n.current = p);
  }, []);
  Vt(function() {
    return o.current = !0, function() {
      o.current = !1;
      var p = r.current;
      p && cancelAnimationFrame(p);
    };
  }, []);
  var d = Se(function() {
    return {
      register: a,
      tryRecordFocus: c,
      tryRestoreFocusRecorded: l,
      tryShiftRecord: s
    };
  }, [a, c, l, s]);
  return d;
}
function eq() {
  var e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function n(f) {
    return t.push(f), function() {
      var h = t.indexOf(f);
      h !== -1 && t.splice(h, 1);
    };
  }
  function r(f) {
    t.length && t.forEach(function(p) {
      return p(f);
    });
  }
  function o(f) {
    return e.draggables[f] || null;
  }
  function a(f) {
    var p = o(f);
    return p || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find draggable entry with id [" + f + "]") : _(!1)), p;
  }
  var i = {
    register: function(p) {
      e.draggables[p.descriptor.id] = p, r({
        type: "ADDITION",
        value: p
      });
    },
    update: function(p, h) {
      var g = e.draggables[h.descriptor.id];
      g && g.uniqueId === p.uniqueId && (delete e.draggables[h.descriptor.id], e.draggables[p.descriptor.id] = p);
    },
    unregister: function(p) {
      var h = p.descriptor.id, g = o(h);
      g && p.uniqueId === g.uniqueId && (delete e.draggables[h], r({
        type: "REMOVAL",
        value: p
      }));
    },
    getById: a,
    findById: o,
    exists: function(p) {
      return !!o(p);
    },
    getAllByType: function(p) {
      return Xl(e.draggables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function s(f) {
    return e.droppables[f] || null;
  }
  function l(f) {
    var p = s(f);
    return p || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find droppable entry with id [" + f + "]") : _(!1)), p;
  }
  var c = {
    register: function(p) {
      e.droppables[p.descriptor.id] = p;
    },
    unregister: function(p) {
      var h = s(p.descriptor.id);
      h && p.uniqueId === h.uniqueId && delete e.droppables[p.descriptor.id];
    },
    getById: l,
    findById: s,
    exists: function(p) {
      return !!s(p);
    },
    getAllByType: function(p) {
      return Xl(e.droppables).filter(function(h) {
        return h.descriptor.type === p;
      });
    }
  };
  function d() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: i,
    droppable: c,
    subscribe: n,
    clean: d
  };
}
function tq() {
  var e = Se(eq, []);
  return ye(function() {
    return function() {
      requestAnimationFrame(e.clean);
    };
  }, [e]), e;
}
var a5 = X.createContext(null), Li = function() {
  var e = document.body;
  return e || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot find document.body") : _(!1)), e;
}, nq = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, rq = function(t) {
  return "rbd-announcement-" + t;
};
function oq(e) {
  var t = Se(function() {
    return rq(e);
  }, [e]), n = le(null);
  ye(function() {
    var a = document.createElement("div");
    return n.current = a, a.id = t, a.setAttribute("aria-live", "assertive"), a.setAttribute("aria-atomic", "true"), ee(a.style, nq), Li().appendChild(a), function() {
      setTimeout(function() {
        var l = Li();
        l.contains(a) && l.removeChild(a), a === n.current && (n.current = null);
      });
    };
  }, [t]);
  var r = fe(function(o) {
    var a = n.current;
    if (a) {
      a.textContent = o;
      return;
    }
    process.env.NODE_ENV !== "production" && Ge(`
      A screen reader message was trying to be announced but it was unable to do so.
      This can occur if you unmount your <DragDropContext /> in your onDragEnd.
      Consider calling provided.announce() before the unmount so that the instruction will
      not be lost for users relying on a screen reader.

      Message not passed to screen reader:

      "` + o + `"
    `);
  }, []);
  return r;
}
var aq = 0, iq = {
  separator: "::"
};
function i5(e, t) {
  return t === void 0 && (t = iq), Se(function() {
    return "" + e + t.separator + aq++;
  }, [t.separator, e]);
}
function sq(e) {
  var t = e.contextId, n = e.uniqueId;
  return "rbd-hidden-text-" + t + "-" + n;
}
function lq(e) {
  var t = e.contextId, n = e.text, r = i5("hidden-text", {
    separator: "-"
  }), o = Se(function() {
    return sq({
      contextId: t,
      uniqueId: r
    });
  }, [r, t]);
  return ye(function() {
    var i = document.createElement("div");
    return i.id = o, i.textContent = n, i.style.display = "none", Li().appendChild(i), function() {
      var l = Li();
      l.contains(i) && l.removeChild(i);
    };
  }, [o, n]), o;
}
var _u = X.createContext(null), cq = {
  react: "^16.8.5 || ^17.0.0 || ^18.0.0",
  "react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
}, uq = /(\d+)\.(\d+)\.(\d+)/, h7 = function(t) {
  var n = uq.exec(t);
  n == null && (process.env.NODE_ENV !== "production" ? _(!1, "Unable to parse React version " + t) : _(!1));
  var r = Number(n[1]), o = Number(n[2]), a = Number(n[3]);
  return {
    major: r,
    minor: o,
    patch: a,
    raw: t
  };
}, dq = function(t, n) {
  return n.major > t.major ? !0 : n.major < t.major ? !1 : n.minor > t.minor ? !0 : n.minor < t.minor ? !1 : n.patch >= t.patch;
}, fq = function(e, t) {
  var n = h7(e), r = h7(t);
  dq(n, r) || process.env.NODE_ENV !== "production" && Ge(`
    React version: [` + r.raw + `]
    does not satisfy expected peer dependency version: [` + n.raw + `]

    This can result in run time bugs, and even fatal crashes
  `);
}, b1 = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md
`, pq = function(e) {
  var t = e.doctype;
  if (!t) {
    process.env.NODE_ENV !== "production" && Ge(`
      No <!doctype html> found.

      ` + b1 + `
    `);
    return;
  }
  t.name.toLowerCase() !== "html" && process.env.NODE_ENV !== "production" && Ge(`
      Unexpected <!doctype> found: (` + t.name + `)

      ` + b1 + `
    `), t.publicId !== "" && process.env.NODE_ENV !== "production" && Ge(`
      Unexpected <!doctype> publicId found: (` + t.publicId + `)
      A html5 doctype does not have a publicId

      ` + b1 + `
    `);
};
function s5(e) {
  process.env.NODE_ENV !== "production" && e();
}
function vs(e, t) {
  s5(function() {
    ye(function() {
      try {
        e();
      } catch (n) {
        Kf(`
          A setup problem was encountered.

          > ` + n.message + `
        `);
      }
    }, t);
  });
}
function hq() {
  vs(function() {
    fq(cq.react, X.version), pq(document);
  }, []);
}
function l5(e) {
  var t = le(e);
  return ye(function() {
    t.current = e;
  }), t;
}
function mq() {
  var e = null;
  function t() {
    return !!e;
  }
  function n(i) {
    return i === e;
  }
  function r(i) {
    e && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot claim lock as it is already claimed") : _(!1));
    var s = {
      abandon: i
    };
    return e = s, s;
  }
  function o() {
    e || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot release lock when there is no lock") : _(!1)), e = null;
  }
  function a() {
    e && (e.abandon(), o());
  }
  return {
    isClaimed: t,
    isActive: n,
    claim: r,
    release: o,
    tryAbandon: a
  };
}
var vq = 9, gq = 13, c5 = 27, ay = 32, wq = 33, bq = 34, Cq = 35, yq = 36, xq = 37, Eq = 38, Iq = 39, Sq = 40, js, Dq = (js = {}, js[gq] = !0, js[vq] = !0, js), iy = function(e) {
  Dq[e.keyCode] && e.preventDefault();
}, Ou = function() {
  var e = "visibilitychange";
  if (typeof document > "u")
    return e;
  var t = [e, "ms" + e, "webkit" + e, "moz" + e, "o" + e], n = Ar(t, function(r) {
    return "on" + r in document;
  });
  return n || e;
}(), sy = 0, m7 = 5;
function Mq(e, t) {
  return Math.abs(t.x - e.x) >= m7 || Math.abs(t.y - e.y) >= m7;
}
var v7 = {
  type: "IDLE"
};
function Nq(e) {
  var t = e.cancel, n = e.completed, r = e.getPhase, o = e.setPhase;
  return [{
    eventName: "mousemove",
    fn: function(i) {
      var s = i.button, l = i.clientX, c = i.clientY;
      if (s === sy) {
        var d = {
          x: l,
          y: c
        }, f = r();
        if (f.type === "DRAGGING") {
          i.preventDefault(), f.actions.move(d);
          return;
        }
        f.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot be IDLE") : _(!1));
        var p = f.point;
        if (Mq(p, d)) {
          i.preventDefault();
          var h = f.actions.fluidLift(d);
          o({
            type: "DRAGGING",
            actions: h
          });
        }
      }
    }
  }, {
    eventName: "mouseup",
    fn: function(i) {
      var s = r();
      if (s.type !== "DRAGGING") {
        t();
        return;
      }
      i.preventDefault(), s.actions.drop({
        shouldBlockNextClick: !0
      }), n();
    }
  }, {
    eventName: "mousedown",
    fn: function(i) {
      r().type === "DRAGGING" && i.preventDefault(), t();
    }
  }, {
    eventName: "keydown",
    fn: function(i) {
      var s = r();
      if (s.type === "PENDING") {
        t();
        return;
      }
      if (i.keyCode === c5) {
        i.preventDefault(), t();
        return;
      }
      iy(i);
    }
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: function() {
      r().type === "PENDING" && t();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: function(i) {
      var s = r();
      if (s.type === "IDLE" && (process.env.NODE_ENV !== "production" ? _(!1, "Unexpected phase") : _(!1)), s.actions.shouldRespectForcePress()) {
        t();
        return;
      }
      i.preventDefault();
    }
  }, {
    eventName: Ou,
    fn: t
  }];
}
function Pq(e) {
  var t = le(v7), n = le(fr), r = Se(function() {
    return {
      eventName: "mousedown",
      fn: function(f) {
        if (!f.defaultPrevented && f.button === sy && !(f.ctrlKey || f.metaKey || f.shiftKey || f.altKey)) {
          var p = e.findClosestDraggableId(f);
          if (p) {
            var h = e.tryGetLock(p, i, {
              sourceEvent: f
            });
            if (h) {
              f.preventDefault();
              var g = {
                x: f.clientX,
                y: f.clientY
              };
              n.current(), c(h, g);
            }
          }
        }
      }
    };
  }, [e]), o = Se(function() {
    return {
      eventName: "webkitmouseforcewillbegin",
      fn: function(f) {
        if (!f.defaultPrevented) {
          var p = e.findClosestDraggableId(f);
          if (p) {
            var h = e.findOptionsForDraggable(p);
            h && (h.shouldRespectForcePress || e.canGetLock(p) && f.preventDefault());
          }
        }
      }
    };
  }, [e]), a = fe(function() {
    var f = {
      passive: !1,
      capture: !0
    };
    n.current = Yt(window, [o, r], f);
  }, [o, r]), i = fe(function() {
    var d = t.current;
    d.type !== "IDLE" && (t.current = v7, n.current(), a());
  }, [a]), s = fe(function() {
    var d = t.current;
    i(), d.type === "DRAGGING" && d.actions.cancel({
      shouldBlockNextClick: !0
    }), d.type === "PENDING" && d.actions.abort();
  }, [i]), l = fe(function() {
    var f = {
      capture: !0,
      passive: !1
    }, p = Nq({
      cancel: s,
      completed: i,
      getPhase: function() {
        return t.current;
      },
      setPhase: function(g) {
        t.current = g;
      }
    });
    n.current = Yt(window, p, f);
  }, [s, i]), c = fe(function(f, p) {
    t.current.type !== "IDLE" && (process.env.NODE_ENV !== "production" ? _(!1, "Expected to move from IDLE to PENDING drag") : _(!1)), t.current = {
      type: "PENDING",
      point: p,
      actions: f
    }, l();
  }, [l]);
  Vt(function() {
    return a(), function() {
      n.current();
    };
  }, [a]);
}
var xo;
function Aq() {
}
var _q = (xo = {}, xo[bq] = !0, xo[wq] = !0, xo[yq] = !0, xo[Cq] = !0, xo);
function Oq(e, t) {
  function n() {
    t(), e.cancel();
  }
  function r() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: function(a) {
      if (a.keyCode === c5) {
        a.preventDefault(), n();
        return;
      }
      if (a.keyCode === ay) {
        a.preventDefault(), r();
        return;
      }
      if (a.keyCode === Sq) {
        a.preventDefault(), e.moveDown();
        return;
      }
      if (a.keyCode === Eq) {
        a.preventDefault(), e.moveUp();
        return;
      }
      if (a.keyCode === Iq) {
        a.preventDefault(), e.moveRight();
        return;
      }
      if (a.keyCode === xq) {
        a.preventDefault(), e.moveLeft();
        return;
      }
      if (_q[a.keyCode]) {
        a.preventDefault();
        return;
      }
      iy(a);
    }
  }, {
    eventName: "mousedown",
    fn: n
  }, {
    eventName: "mouseup",
    fn: n
  }, {
    eventName: "click",
    fn: n
  }, {
    eventName: "touchstart",
    fn: n
  }, {
    eventName: "resize",
    fn: n
  }, {
    eventName: "wheel",
    fn: n,
    options: {
      passive: !0
    }
  }, {
    eventName: Ou,
    fn: n
  }];
}
function Tq(e) {
  var t = le(Aq), n = Se(function() {
    return {
      eventName: "keydown",
      fn: function(a) {
        if (a.defaultPrevented || a.keyCode !== ay)
          return;
        var i = e.findClosestDraggableId(a);
        if (!i)
          return;
        var s = e.tryGetLock(i, d, {
          sourceEvent: a
        });
        if (!s)
          return;
        a.preventDefault();
        var l = !0, c = s.snapLift();
        t.current();
        function d() {
          l || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot stop capturing a keyboard drag when not capturing") : _(!1)), l = !1, t.current(), r();
        }
        t.current = Yt(window, Oq(c, d), {
          capture: !0,
          passive: !1
        });
      }
    };
  }, [e]), r = fe(function() {
    var a = {
      passive: !1,
      capture: !0
    };
    t.current = Yt(window, [n], a);
  }, [n]);
  Vt(function() {
    return r(), function() {
      t.current();
    };
  }, [r]);
}
var C1 = {
  type: "IDLE"
}, Lq = 120, Rq = 0.15;
function Vq(e) {
  var t = e.cancel, n = e.getPhase;
  return [{
    eventName: "orientationchange",
    fn: t
  }, {
    eventName: "resize",
    fn: t
  }, {
    eventName: "contextmenu",
    fn: function(o) {
      o.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: function(o) {
      if (n().type !== "DRAGGING") {
        t();
        return;
      }
      o.keyCode === c5 && o.preventDefault(), t();
    }
  }, {
    eventName: Ou,
    fn: t
  }];
}
function kq(e) {
  var t = e.cancel, n = e.completed, r = e.getPhase;
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: function(a) {
      var i = r();
      if (i.type !== "DRAGGING") {
        t();
        return;
      }
      i.hasMoved = !0;
      var s = a.touches[0], l = s.clientX, c = s.clientY, d = {
        x: l,
        y: c
      };
      a.preventDefault(), i.actions.move(d);
    }
  }, {
    eventName: "touchend",
    fn: function(a) {
      var i = r();
      if (i.type !== "DRAGGING") {
        t();
        return;
      }
      a.preventDefault(), i.actions.drop({
        shouldBlockNextClick: !0
      }), n();
    }
  }, {
    eventName: "touchcancel",
    fn: function(a) {
      if (r().type !== "DRAGGING") {
        t();
        return;
      }
      a.preventDefault(), t();
    }
  }, {
    eventName: "touchforcechange",
    fn: function(a) {
      var i = r();
      i.type === "IDLE" && (process.env.NODE_ENV, _(!1));
      var s = a.touches[0];
      if (s) {
        var l = s.force >= Rq;
        if (l) {
          var c = i.actions.shouldRespectForcePress();
          if (i.type === "PENDING") {
            c && t();
            return;
          }
          if (c) {
            if (i.hasMoved) {
              a.preventDefault();
              return;
            }
            t();
            return;
          }
          a.preventDefault();
        }
      }
    }
  }, {
    eventName: Ou,
    fn: t
  }];
}
function Fq(e) {
  var t = le(C1), n = le(fr), r = fe(function() {
    return t.current;
  }, []), o = fe(function(h) {
    t.current = h;
  }, []), a = Se(function() {
    return {
      eventName: "touchstart",
      fn: function(h) {
        if (!h.defaultPrevented) {
          var g = e.findClosestDraggableId(h);
          if (g) {
            var m = e.tryGetLock(g, s, {
              sourceEvent: h
            });
            if (m) {
              var v = h.touches[0], w = v.clientX, C = v.clientY, y = {
                x: w,
                y: C
              };
              n.current(), f(m, y);
            }
          }
        }
      }
    };
  }, [e]), i = fe(function() {
    var h = {
      capture: !0,
      passive: !1
    };
    n.current = Yt(window, [a], h);
  }, [a]), s = fe(function() {
    var p = t.current;
    p.type !== "IDLE" && (p.type === "PENDING" && clearTimeout(p.longPressTimerId), o(C1), n.current(), i());
  }, [i, o]), l = fe(function() {
    var p = t.current;
    s(), p.type === "DRAGGING" && p.actions.cancel({
      shouldBlockNextClick: !0
    }), p.type === "PENDING" && p.actions.abort();
  }, [s]), c = fe(function() {
    var h = {
      capture: !0,
      passive: !1
    }, g = {
      cancel: l,
      completed: s,
      getPhase: r
    }, m = Yt(window, kq(g), h), v = Yt(window, Vq(g), h);
    n.current = function() {
      m(), v();
    };
  }, [l, r, s]), d = fe(function() {
    var h = r();
    h.type !== "PENDING" && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot start dragging from phase " + h.type) : _(!1));
    var g = h.actions.fluidLift(h.point);
    o({
      type: "DRAGGING",
      actions: g,
      hasMoved: !1
    });
  }, [r, o]), f = fe(function(h, g) {
    r().type !== "IDLE" && (process.env.NODE_ENV !== "production" ? _(!1, "Expected to move from IDLE to PENDING drag") : _(!1));
    var m = setTimeout(d, Lq);
    o({
      type: "PENDING",
      point: g,
      actions: h,
      longPressTimerId: m
    }), c();
  }, [c, r, o, d]);
  Vt(function() {
    return i(), function() {
      n.current();
      var g = r();
      g.type === "PENDING" && (clearTimeout(g.longPressTimerId), o(C1));
    };
  }, [r, i, o]), Vt(function() {
    var h = Yt(window, [{
      eventName: "touchmove",
      fn: function() {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
    return h;
  }, []);
}
function Hq(e) {
  s5(function() {
    var t = l5(e);
    vs(function() {
      t.current.length !== e.length && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot change the amount of sensor hooks after mounting") : _(!1));
    });
  });
}
var Bq = {
  input: !0,
  button: !0,
  textarea: !0,
  select: !0,
  option: !0,
  optgroup: !0,
  video: !0,
  audio: !0
};
function ly(e, t) {
  if (t == null)
    return !1;
  var n = !!Bq[t.tagName.toLowerCase()];
  if (n)
    return !0;
  var r = t.getAttribute("contenteditable");
  return r === "true" || r === "" ? !0 : t === e ? !1 : ly(e, t.parentElement);
}
function Gq(e, t) {
  var n = t.target;
  return ms(n) ? ly(e, n) : !1;
}
var Wq = function(e) {
  return en(e.getBoundingClientRect()).center;
};
function Zq(e) {
  return e instanceof ry(e).Element;
}
var $q = function() {
  var e = "matches";
  if (typeof document > "u")
    return e;
  var t = [e, "msMatchesSelector", "webkitMatchesSelector"], n = Ar(t, function(r) {
    return r in Element.prototype;
  });
  return n || e;
}();
function cy(e, t) {
  return e == null ? null : e[$q](t) ? e : cy(e.parentElement, t);
}
function Yq(e, t) {
  return e.closest ? e.closest(t) : cy(e, t);
}
function jq(e) {
  return "[" + Qo.contextId + '="' + e + '"]';
}
function zq(e, t) {
  var n = t.target;
  if (!Zq(n))
    return process.env.NODE_ENV !== "production" && Ge("event.target must be a Element"), null;
  var r = jq(e), o = Yq(n, r);
  return o ? ms(o) ? o : (process.env.NODE_ENV !== "production" && Ge("drag handle must be a HTMLElement"), null) : null;
}
function Xq(e, t) {
  var n = zq(e, t);
  return n ? n.getAttribute(Qo.draggableId) : null;
}
function Uq(e, t) {
  var n = "[" + n2.contextId + '="' + e + '"]', r = SC(document.querySelectorAll(n)), o = Ar(r, function(a) {
    return a.getAttribute(n2.id) === t;
  });
  return o ? ms(o) ? o : (process.env.NODE_ENV !== "production" && Ge("Draggable element is not a HTMLElement"), null) : null;
}
function Jq(e) {
  e.preventDefault();
}
function zs(e) {
  var t = e.expected, n = e.phase, r = e.isLockActive, o = e.shouldWarn;
  return r() ? t !== n ? (o && process.env.NODE_ENV !== "production" && Ge(`
        Cannot perform action.
        The actions you used belong to an outdated phase

        Current phase: ` + t + `
        You called an action from outdated phase: ` + n + `

        Tips:

        - Do not use preDragActions actions after calling preDragActions.lift()
      `), !1) : !0 : (o && process.env.NODE_ENV !== "production" && Ge(`
        Cannot perform action.
        The sensor no longer has an action lock.

        Tips:

        - Throw away your action handlers when forceStop() is called
        - Check actions.isActive() if you really need to
      `), !1);
}
function uy(e) {
  var t = e.lockAPI, n = e.store, r = e.registry, o = e.draggableId;
  if (t.isClaimed())
    return !1;
  var a = r.draggable.findById(o);
  return a ? !(!a.options.isEnabled || !QC(n.getState(), o)) : (process.env.NODE_ENV !== "production" && Ge("Unable to find draggable with id: " + o), !1);
}
function Kq(e) {
  var t = e.lockAPI, n = e.contextId, r = e.store, o = e.registry, a = e.draggableId, i = e.forceSensorStop, s = e.sourceEvent, l = uy({
    lockAPI: t,
    store: r,
    registry: o,
    draggableId: a
  });
  if (!l)
    return null;
  var c = o.draggable.getById(a), d = Uq(n, c.descriptor.id);
  if (!d)
    return process.env.NODE_ENV !== "production" && Ge("Unable to find draggable element with id: " + a), null;
  if (s && !c.options.canDragInteractiveElements && Gq(d, s))
    return null;
  var f = t.claim(i || fr), p = "PRE_DRAG";
  function h() {
    return c.options.shouldRespectForcePress;
  }
  function g() {
    return t.isActive(f);
  }
  function m(S, I) {
    zs({
      expected: S,
      phase: p,
      isLockActive: g,
      shouldWarn: !0
    }) && r.dispatch(I());
  }
  var v = m.bind(null, "DRAGGING");
  function w(S) {
    function I() {
      t.release(), p = "COMPLETED";
    }
    p !== "PRE_DRAG" && (I(), p !== "PRE_DRAG" && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot lift in phase " + p) : _(!1))), r.dispatch(VJ(S.liftActionArgs)), p = "DRAGGING";
    function D(N, A) {
      if (A === void 0 && (A = {
        shouldBlockNextClick: !1
      }), S.cleanup(), A.shouldBlockNextClick) {
        var L = Yt(window, [{
          eventName: "click",
          fn: Jq,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(L);
      }
      I(), r.dispatch(jC({
        reason: N
      }));
    }
    return ee({
      isActive: function() {
        return zs({
          expected: "DRAGGING",
          phase: p,
          isLockActive: g,
          shouldWarn: !1
        });
      },
      shouldRespectForcePress: h,
      drop: function(A) {
        return D("DROP", A);
      },
      cancel: function(A) {
        return D("CANCEL", A);
      }
    }, S.actions);
  }
  function C(S) {
    var I = Ni(function(N) {
      v(function() {
        return YC({
          client: N
        });
      });
    }), D = w({
      liftActionArgs: {
        id: a,
        clientSelection: S,
        movementMode: "FLUID"
      },
      cleanup: function() {
        return I.cancel();
      },
      actions: {
        move: I
      }
    });
    return ee({}, D, {
      move: I
    });
  }
  function y() {
    var S = {
      moveUp: function() {
        return v(YJ);
      },
      moveRight: function() {
        return v(zJ);
      },
      moveDown: function() {
        return v(jJ);
      },
      moveLeft: function() {
        return v(XJ);
      }
    };
    return w({
      liftActionArgs: {
        id: a,
        clientSelection: Wq(d),
        movementMode: "SNAP"
      },
      cleanup: fr,
      actions: S
    });
  }
  function x() {
    var S = zs({
      expected: "PRE_DRAG",
      phase: p,
      isLockActive: g,
      shouldWarn: !0
    });
    S && t.release();
  }
  var E = {
    isActive: function() {
      return zs({
        expected: "PRE_DRAG",
        phase: p,
        isLockActive: g,
        shouldWarn: !1
      });
    },
    shouldRespectForcePress: h,
    fluidLift: C,
    snapLift: y,
    abort: x
  };
  return E;
}
var qq = [Pq, Tq, Fq];
function Qq(e) {
  var t = e.contextId, n = e.store, r = e.registry, o = e.customSensors, a = e.enableDefaultSensors, i = [].concat(a ? qq : [], o || []), s = ue(function() {
    return mq();
  })[0], l = fe(function(C, y) {
    C.isDragging && !y.isDragging && s.tryAbandon();
  }, [s]);
  Vt(function() {
    var C = n.getState(), y = n.subscribe(function() {
      var x = n.getState();
      l(C, x), C = x;
    });
    return y;
  }, [s, n, l]), Vt(function() {
    return s.tryAbandon;
  }, [s.tryAbandon]);
  var c = fe(function(w) {
    return uy({
      lockAPI: s,
      registry: r,
      store: n,
      draggableId: w
    });
  }, [s, r, n]), d = fe(function(w, C, y) {
    return Kq({
      lockAPI: s,
      registry: r,
      contextId: t,
      store: n,
      draggableId: w,
      forceSensorStop: C,
      sourceEvent: y && y.sourceEvent ? y.sourceEvent : null
    });
  }, [t, s, r, n]), f = fe(function(w) {
    return Xq(t, w);
  }, [t]), p = fe(function(w) {
    var C = r.draggable.findById(w);
    return C ? C.options : null;
  }, [r.draggable]), h = fe(function() {
    s.isClaimed() && (s.tryAbandon(), n.getState().phase !== "IDLE" && n.dispatch(K0()));
  }, [s, n]), g = fe(s.isClaimed, [s]), m = Se(function() {
    return {
      canGetLock: c,
      tryGetLock: d,
      findClosestDraggableId: f,
      findOptionsForDraggable: p,
      tryReleaseLock: h,
      isLockClaimed: g
    };
  }, [c, d, f, p, h, g]);
  Hq(i);
  for (var v = 0; v < i.length; v++)
    i[v](m);
}
var eQ = function(t) {
  return {
    onBeforeCapture: t.onBeforeCapture,
    onBeforeDragStart: t.onBeforeDragStart,
    onDragStart: t.onDragStart,
    onDragEnd: t.onDragEnd,
    onDragUpdate: t.onDragUpdate
  };
};
function Wa(e) {
  return e.current || (process.env.NODE_ENV !== "production" ? _(!1, "Could not find store from lazy ref") : _(!1)), e.current;
}
function tQ(e) {
  var t = e.contextId, n = e.setCallbacks, r = e.sensors, o = e.nonce, a = e.dragHandleUsageInstructions, i = le(null);
  hq();
  var s = l5(e), l = fe(function() {
    return eQ(s.current);
  }, [s]), c = oq(t), d = lq({
    contextId: t,
    text: a
  }), f = qK(t, o), p = fe(function(N) {
    Wa(i).dispatch(N);
  }, []), h = Se(function() {
    return Vp({
      publishWhileDragging: FJ,
      updateDroppableScroll: BJ,
      updateDroppableIsEnabled: GJ,
      updateDroppableIsCombineEnabled: WJ,
      collectionStarting: HJ
    }, p);
  }, [p]), g = tq(), m = Se(function() {
    return AK(g, h);
  }, [g, h]), v = Se(function() {
    return zK(ee({
      scrollWindow: _K,
      scrollDroppable: m.scrollDroppable
    }, Vp({
      move: YC
    }, p)));
  }, [m.scrollDroppable, p]), w = QK(t), C = Se(function() {
    return DK({
      announce: c,
      autoScroller: v,
      dimensionMarshal: m,
      focusMarshal: w,
      getResponders: l,
      styleMarshal: f
    });
  }, [c, v, m, w, l, f]);
  process.env.NODE_ENV !== "production" && i.current && i.current !== C && process.env.NODE_ENV !== "production" && Ge("unexpected store change"), i.current = C;
  var y = fe(function() {
    var N = Wa(i), A = N.getState();
    A.phase !== "IDLE" && N.dispatch(K0());
  }, []), x = fe(function() {
    var N = Wa(i).getState();
    return N.isDragging || N.phase === "DROP_ANIMATING";
  }, []), E = Se(function() {
    return {
      isDragging: x,
      tryAbort: y
    };
  }, [x, y]);
  n(E);
  var S = fe(function(N) {
    return QC(Wa(i).getState(), N);
  }, []), I = fe(function() {
    return Fr(Wa(i).getState());
  }, []), D = Se(function() {
    return {
      marshal: m,
      focus: w,
      contextId: t,
      canLift: S,
      isMovementAllowed: I,
      dragHandleUsageInstructionsId: d,
      registry: g
    };
  }, [t, m, d, w, S, I, g]);
  return Qq({
    contextId: t,
    store: C,
    registry: g,
    customSensors: r,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), ye(function() {
    return y;
  }, [y]), X.createElement(_u.Provider, {
    value: D
  }, X.createElement(pC, {
    context: a5,
    store: C
  }, e.children));
}
var nQ = 0;
function rQ() {
  return Se(function() {
    return "" + nQ++;
  }, []);
}
function oQ(e) {
  var t = rQ(), n = e.dragHandleUsageInstructions || dl.dragHandleUsageInstructions;
  return X.createElement(SU, null, function(r) {
    return X.createElement(tQ, {
      nonce: e.nonce,
      contextId: t,
      setCallbacks: r,
      dragHandleUsageInstructions: n,
      enableDefaultSensors: e.enableDefaultSensors,
      sensors: e.sensors,
      onBeforeCapture: e.onBeforeCapture,
      onBeforeDragStart: e.onBeforeDragStart,
      onDragStart: e.onDragStart,
      onDragUpdate: e.onDragUpdate,
      onDragEnd: e.onDragEnd
    }, e.children);
  });
}
var u5 = function(t) {
  return function(n) {
    return t === n;
  };
}, aQ = u5("scroll"), iQ = u5("auto"), sQ = u5("visible"), g7 = function(t, n) {
  return n(t.overflowX) || n(t.overflowY);
}, lQ = function(t, n) {
  return n(t.overflowX) && n(t.overflowY);
}, dy = function(t) {
  var n = window.getComputedStyle(t), r = {
    overflowX: n.overflowX,
    overflowY: n.overflowY
  };
  return g7(r, aQ) || g7(r, iQ);
}, cQ = function() {
  if (process.env.NODE_ENV === "production")
    return !1;
  var t = Li(), n = document.documentElement;
  if (n || (process.env.NODE_ENV, _(!1)), !dy(t))
    return !1;
  var r = window.getComputedStyle(n), o = {
    overflowX: r.overflowX,
    overflowY: r.overflowY
  };
  return lQ(o, sQ) || process.env.NODE_ENV !== "production" && Ge(`
    We have detected that your <body> element might be a scroll container.
    We have found no reliable way of detecting whether the <body> element is a scroll container.
    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)

    Because we cannot determine if the <body> is a scroll container, and generally it is not one,
    we will be treating the <body> as *not* a scroll container

    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md
  `), !1;
}, fy = function e(t) {
  return t == null ? null : t === document.body ? cQ() ? t : null : t === document.documentElement ? null : dy(t) ? t : e(t.parentElement);
}, uQ = function(e) {
  if (e) {
    var t = fy(e.parentElement);
    t && process.env.NODE_ENV !== "production" && Ge(`
    Droppable: unsupported nested scroll container detected.
    A Droppable can only have one scroll parent (which can be itself)
    Nested scroll containers are currently not supported.

    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131
  `);
  }
}, r2 = function(e) {
  return {
    x: e.scrollLeft,
    y: e.scrollTop
  };
}, dQ = function e(t) {
  if (!t)
    return !1;
  var n = window.getComputedStyle(t);
  return n.position === "fixed" ? !0 : e(t.parentElement);
}, fQ = function(e) {
  var t = fy(e), n = dQ(e);
  return {
    closestScrollable: t,
    isFixedOnPage: n
  };
}, pQ = function(e) {
  var t = e.descriptor, n = e.isEnabled, r = e.isCombineEnabled, o = e.isFixedOnPage, a = e.direction, i = e.client, s = e.page, l = e.closest, c = function() {
    if (!l)
      return null;
    var h = l.scrollSize, g = l.client, m = JC({
      scrollHeight: h.scrollHeight,
      scrollWidth: h.scrollWidth,
      height: g.paddingBox.height,
      width: g.paddingBox.width
    });
    return {
      pageMarginBox: l.page.marginBox,
      frameClient: g,
      scrollSize: h,
      shouldClipSubject: l.shouldClipSubject,
      scroll: {
        initial: l.scroll,
        current: l.scroll,
        max: m,
        diff: {
          value: it,
          displacement: it
        }
      }
    };
  }(), d = a === "vertical" ? j0 : AC, f = Ko({
    page: s,
    withPlaceholder: null,
    axis: d,
    frame: c
  }), p = {
    descriptor: t,
    isCombineEnabled: r,
    isFixedOnPage: o,
    axis: d,
    isEnabled: n,
    client: i,
    page: s,
    frame: c,
    subject: f
  };
  return p;
}, hQ = function(t, n) {
  var r = CC(t);
  if (!n || t !== n)
    return r;
  var o = r.paddingBox.top - n.scrollTop, a = r.paddingBox.left - n.scrollLeft, i = o + n.scrollHeight, s = a + n.scrollWidth, l = {
    top: o,
    right: s,
    bottom: i,
    left: a
  }, c = G0(l, r.border), d = W0({
    borderBox: c,
    margin: r.margin,
    border: r.border,
    padding: r.padding
  });
  return d;
}, mQ = function(e) {
  var t = e.ref, n = e.descriptor, r = e.env, o = e.windowScroll, a = e.direction, i = e.isDropDisabled, s = e.isCombineEnabled, l = e.shouldClipSubject, c = r.closestScrollable, d = hQ(t, c), f = jl(d, o), p = function() {
    if (!c)
      return null;
    var g = CC(c), m = {
      scrollHeight: c.scrollHeight,
      scrollWidth: c.scrollWidth
    };
    return {
      client: g,
      page: jl(g, o),
      scroll: r2(c),
      scrollSize: m,
      shouldClipSubject: l
    };
  }(), h = pQ({
    descriptor: n,
    isEnabled: !i,
    isCombineEnabled: s,
    isFixedOnPage: r.isFixedOnPage,
    direction: a,
    client: d,
    page: f,
    closest: p
  });
  return h;
}, vQ = {
  passive: !1
}, gQ = {
  passive: !0
}, w7 = function(e) {
  return e.shouldPublishImmediately ? vQ : gQ;
};
function Jl(e) {
  var t = Ht(e);
  return t || (process.env.NODE_ENV !== "production" ? _(!1, "Could not find required context") : _(!1)), t;
}
var Xs = function(t) {
  return t && t.env.closestScrollable || null;
};
function wQ(e) {
  var t = le(null), n = Jl(_u), r = i5("droppable"), o = n.registry, a = n.marshal, i = l5(e), s = Se(function() {
    return {
      id: e.droppableId,
      type: e.type,
      mode: e.mode
    };
  }, [e.droppableId, e.mode, e.type]), l = le(s), c = Se(function() {
    return ot(function(x, E) {
      t.current || (process.env.NODE_ENV !== "production" ? _(!1, "Can only update scroll when dragging") : _(!1));
      var S = {
        x,
        y: E
      };
      a.updateDroppableScroll(s.id, S);
    });
  }, [s.id, a]), d = fe(function() {
    var x = t.current;
    return !x || !x.env.closestScrollable ? it : r2(x.env.closestScrollable);
  }, []), f = fe(function() {
    var x = d();
    c(x.x, x.y);
  }, [d, c]), p = Se(function() {
    return Ni(f);
  }, [f]), h = fe(function() {
    var x = t.current, E = Xs(x);
    x && E || (process.env.NODE_ENV !== "production" ? _(!1, "Could not find scroll options while scrolling") : _(!1));
    var S = x.scrollOptions;
    if (S.shouldPublishImmediately) {
      f();
      return;
    }
    p();
  }, [p, f]), g = fe(function(x, E) {
    t.current && (process.env.NODE_ENV !== "production" ? _(!1, "Cannot collect a droppable while a drag is occurring") : _(!1));
    var S = i.current, I = S.getDroppableRef();
    I || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot collect without a droppable ref") : _(!1));
    var D = fQ(I), N = {
      ref: I,
      descriptor: s,
      env: D,
      scrollOptions: E
    };
    t.current = N;
    var A = mQ({
      ref: I,
      descriptor: s,
      env: D,
      windowScroll: x,
      direction: S.direction,
      isDropDisabled: S.isDropDisabled,
      isCombineEnabled: S.isCombineEnabled,
      shouldClipSubject: !S.ignoreContainerClipping
    }), L = D.closestScrollable;
    return L && (L.setAttribute(f7.contextId, n.contextId), L.addEventListener("scroll", h, w7(N.scrollOptions)), process.env.NODE_ENV !== "production" && uQ(L)), A;
  }, [n.contextId, s, h, i]), m = fe(function() {
    var x = t.current, E = Xs(x);
    return x && E || (process.env.NODE_ENV !== "production" ? _(!1, "Can only recollect Droppable client for Droppables that have a scroll container") : _(!1)), r2(E);
  }, []), v = fe(function() {
    var x = t.current;
    x || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot stop drag when no active drag") : _(!1));
    var E = Xs(x);
    t.current = null, E && (p.cancel(), E.removeAttribute(f7.contextId), E.removeEventListener("scroll", h, w7(x.scrollOptions)));
  }, [h, p]), w = fe(function(x) {
    var E = t.current;
    E || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot scroll when there is no drag") : _(!1));
    var S = Xs(E);
    S || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot scroll a droppable with no closest scrollable") : _(!1)), S.scrollTop += x.y, S.scrollLeft += x.x;
  }, []), C = Se(function() {
    return {
      getDimensionAndWatchScroll: g,
      getScrollWhileDragging: m,
      dragStopped: v,
      scroll: w
    };
  }, [v, g, m, w]), y = Se(function() {
    return {
      uniqueId: r,
      descriptor: s,
      callbacks: C
    };
  }, [C, s, r]);
  Vt(function() {
    return l.current = y.descriptor, o.droppable.register(y), function() {
      t.current && (process.env.NODE_ENV !== "production" && Ge("Unsupported: changing the droppableId or type of a Droppable during a drag"), v()), o.droppable.unregister(y);
    };
  }, [C, s, v, y, a, o.droppable]), Vt(function() {
    t.current && a.updateDroppableIsEnabled(l.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, a]), Vt(function() {
    t.current && a.updateDroppableIsCombineEnabled(l.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, a]);
}
function y1() {
}
var b7 = {
  width: 0,
  height: 0,
  margin: _U
}, bQ = function(t) {
  var n = t.isAnimatingOpenOnMount, r = t.placeholder, o = t.animate;
  return n || o === "close" ? b7 : {
    height: r.client.borderBox.height,
    width: r.client.borderBox.width,
    margin: r.client.margin
  };
}, CQ = function(t) {
  var n = t.isAnimatingOpenOnMount, r = t.placeholder, o = t.animate, a = bQ({
    isAnimatingOpenOnMount: n,
    placeholder: r,
    animate: o
  });
  return {
    display: r.display,
    boxSizing: "border-box",
    width: a.width,
    height: a.height,
    marginTop: a.margin.top,
    marginRight: a.margin.right,
    marginBottom: a.margin.bottom,
    marginLeft: a.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: o !== "none" ? ii.placeholder : null
  };
};
function yQ(e) {
  var t = le(null), n = fe(function() {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), r = e.animate, o = e.onTransitionEnd, a = e.onClose, i = e.contextId, s = ue(e.animate === "open"), l = s[0], c = s[1];
  ye(function() {
    return l ? r !== "open" ? (n(), c(!1), y1) : t.current ? y1 : (t.current = setTimeout(function() {
      t.current = null, c(!1);
    }), n) : y1;
  }, [r, l, n]);
  var d = fe(function(p) {
    p.propertyName === "height" && (o(), r === "close" && a());
  }, [r, a, o]), f = CQ({
    isAnimatingOpenOnMount: l,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return X.createElement(e.placeholder.tagName, {
    style: f,
    "data-rbd-placeholder-context-id": i,
    onTransitionEnd: d,
    ref: e.innerRef
  });
}
var xQ = X.memo(yQ), d5 = X.createContext(null);
function py(e) {
  e && ms(e) || (process.env.NODE_ENV !== "production" ? _(!1, `
    provided.innerRef has not been provided with a HTMLElement.

    You can find a guide on using the innerRef callback functions at:
    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md
  `) : _(!1));
}
function x1(e) {
  return typeof e == "boolean";
}
function E1(e, t) {
  t.forEach(function(n) {
    return n(e);
  });
}
var EQ = [function(t) {
  var n = t.props;
  n.droppableId || (process.env.NODE_ENV !== "production" ? _(!1, "A Droppable requires a droppableId prop") : _(!1)), typeof n.droppableId != "string" && (process.env.NODE_ENV !== "production" ? _(!1, "A Droppable requires a [string] droppableId. Provided: [" + typeof n.droppableId + "]") : _(!1));
}, function(t) {
  var n = t.props;
  x1(n.isDropDisabled) || (process.env.NODE_ENV !== "production" ? _(!1, "isDropDisabled must be a boolean") : _(!1)), x1(n.isCombineEnabled) || (process.env.NODE_ENV !== "production" ? _(!1, "isCombineEnabled must be a boolean") : _(!1)), x1(n.ignoreContainerClipping) || (process.env.NODE_ENV !== "production" ? _(!1, "ignoreContainerClipping must be a boolean") : _(!1));
}, function(t) {
  var n = t.getDroppableRef;
  py(n());
}], IQ = [function(t) {
  var n = t.props, r = t.getPlaceholderRef;
  if (n.placeholder) {
    var o = r();
    o || process.env.NODE_ENV !== "production" && Ge(`
      Droppable setup issue [droppableId: "` + n.droppableId + `"]:
      DroppableProvided > placeholder could not be found.

      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.
      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md
    `);
  }
}], SQ = [function(t) {
  var n = t.props;
  n.renderClone || (process.env.NODE_ENV !== "production" ? _(!1, "Must provide a clone render function (renderClone) for virtual lists") : _(!1));
}, function(t) {
  var n = t.getPlaceholderRef;
  n() && (process.env.NODE_ENV !== "production" ? _(!1, "Expected virtual list to not have a placeholder") : _(!1));
}];
function DQ(e) {
  vs(function() {
    E1(e, EQ), e.props.mode === "standard" && E1(e, IQ), e.props.mode === "virtual" && E1(e, SQ);
  });
}
var MQ = function(e) {
  sC(t, e);
  function t() {
    for (var r, o = arguments.length, a = new Array(o), i = 0; i < o; i++)
      a[i] = arguments[i];
    return r = e.call.apply(e, [this].concat(a)) || this, r.state = {
      isVisible: !!r.props.on,
      data: r.props.on,
      animate: r.props.shouldAnimate && r.props.on ? "open" : "none"
    }, r.onClose = function() {
      r.state.animate === "close" && r.setState({
        isVisible: !1
      });
    }, r;
  }
  t.getDerivedStateFromProps = function(o, a) {
    return o.shouldAnimate ? o.on ? {
      isVisible: !0,
      data: o.on,
      animate: "open"
    } : a.isVisible ? {
      isVisible: !0,
      data: a.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!o.on,
      data: o.on,
      animate: "none"
    };
  };
  var n = t.prototype;
  return n.render = function() {
    if (!this.state.isVisible)
      return null;
    var o = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(o);
  }, t;
}(X.PureComponent), C7 = {
  dragging: 5e3,
  dropAnimating: 4500
}, NQ = function(t, n) {
  return n ? ii.drop(n.duration) : t ? ii.snap : ii.fluid;
}, PQ = function(t, n) {
  return t ? n ? Ti.opacity.drop : Ti.opacity.combining : null;
}, AQ = function(t) {
  return t.forceShouldAnimate != null ? t.forceShouldAnimate : t.mode === "SNAP";
};
function _Q(e) {
  var t = e.dimension, n = t.client, r = e.offset, o = e.combineWith, a = e.dropping, i = !!o, s = AQ(e), l = !!a, c = l ? e2.drop(r, i) : e2.moveTo(r), d = {
    position: "fixed",
    top: n.marginBox.top,
    left: n.marginBox.left,
    boxSizing: "border-box",
    width: n.borderBox.width,
    height: n.borderBox.height,
    transition: NQ(s, a),
    transform: c,
    opacity: PQ(i, l),
    zIndex: l ? C7.dropAnimating : C7.dragging,
    pointerEvents: "none"
  };
  return d;
}
function OQ(e) {
  return {
    transform: e2.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? null : "none"
  };
}
function TQ(e) {
  return e.type === "DRAGGING" ? _Q(e) : OQ(e);
}
function LQ(e, t, n) {
  n === void 0 && (n = it);
  var r = window.getComputedStyle(t), o = t.getBoundingClientRect(), a = bC(o, r), i = jl(a, n), s = {
    client: a,
    tagName: t.tagName.toLowerCase(),
    display: r.display
  }, l = {
    x: a.marginBox.width,
    y: a.marginBox.height
  }, c = {
    descriptor: e,
    placeholder: s,
    displaceBy: l,
    client: a,
    page: i
  };
  return c;
}
function RQ(e) {
  var t = i5("draggable"), n = e.descriptor, r = e.registry, o = e.getDraggableRef, a = e.canDragInteractiveElements, i = e.shouldRespectForcePress, s = e.isEnabled, l = Se(function() {
    return {
      canDragInteractiveElements: a,
      shouldRespectForcePress: i,
      isEnabled: s
    };
  }, [a, s, i]), c = fe(function(h) {
    var g = o();
    return g || (process.env.NODE_ENV !== "production" ? _(!1, "Cannot get dimension when no ref is set") : _(!1)), LQ(n, g, h);
  }, [n, o]), d = Se(function() {
    return {
      uniqueId: t,
      descriptor: n,
      options: l,
      getDimension: c
    };
  }, [n, c, l, t]), f = le(d), p = le(!0);
  Vt(function() {
    return r.draggable.register(f.current), function() {
      return r.draggable.unregister(f.current);
    };
  }, [r.draggable]), Vt(function() {
    if (p.current) {
      p.current = !1;
      return;
    }
    var h = f.current;
    f.current = d, r.draggable.update(d, h);
  }, [d, r.draggable]);
}
function VQ(e, t, n) {
  vs(function() {
    function r(a) {
      return "Draggable[id: " + a + "]: ";
    }
    var o = e.draggableId;
    o || (process.env.NODE_ENV !== "production" ? _(!1, "Draggable requires a draggableId") : _(!1)), typeof o != "string" && (process.env.NODE_ENV !== "production" ? _(!1, `Draggable requires a [string] draggableId.
      Provided: [type: ` + typeof o + "] (value: " + o + ")") : _(!1)), RU(e.index) || (process.env.NODE_ENV !== "production" ? _(!1, r(o) + " requires an integer index prop") : _(!1)), e.mapped.type !== "DRAGGING" && (py(n()), e.isEnabled && (oy(t, o) || (process.env.NODE_ENV !== "production" ? _(!1, r(o) + " Unable to find drag handle") : _(!1))));
  });
}
function kQ(e) {
  s5(function() {
    var t = le(e);
    vs(function() {
      e !== t.current && (process.env.NODE_ENV !== "production" ? _(!1, "Draggable isClone prop value changed during component life") : _(!1));
    }, [e]);
  });
}
function FQ(e) {
  e.preventDefault();
}
function HQ(e) {
  var t = le(null), n = fe(function(N) {
    t.current = N;
  }, []), r = fe(function() {
    return t.current;
  }, []), o = Jl(_u), a = o.contextId, i = o.dragHandleUsageInstructionsId, s = o.registry, l = Jl(d5), c = l.type, d = l.droppableId, f = Se(function() {
    return {
      id: e.draggableId,
      index: e.index,
      type: c,
      droppableId: d
    };
  }, [e.draggableId, e.index, c, d]), p = e.children, h = e.draggableId, g = e.isEnabled, m = e.shouldRespectForcePress, v = e.canDragInteractiveElements, w = e.isClone, C = e.mapped, y = e.dropAnimationFinished;
  if (VQ(e, a, r), kQ(w), !w) {
    var x = Se(function() {
      return {
        descriptor: f,
        registry: s,
        getDraggableRef: r,
        canDragInteractiveElements: v,
        shouldRespectForcePress: m,
        isEnabled: g
      };
    }, [f, s, r, v, m, g]);
    RQ(x);
  }
  var E = Se(function() {
    return g ? {
      tabIndex: 0,
      role: "button",
      "aria-describedby": i,
      "data-rbd-drag-handle-draggable-id": h,
      "data-rbd-drag-handle-context-id": a,
      draggable: !1,
      onDragStart: FQ
    } : null;
  }, [a, i, h, g]), S = fe(function(N) {
    C.type === "DRAGGING" && C.dropping && N.propertyName === "transform" && y();
  }, [y, C]), I = Se(function() {
    var N = TQ(C), A = C.type === "DRAGGING" && C.dropping ? S : null, L = {
      innerRef: n,
      draggableProps: {
        "data-rbd-draggable-context-id": a,
        "data-rbd-draggable-id": h,
        style: N,
        onTransitionEnd: A
      },
      dragHandleProps: E
    };
    return L;
  }, [a, E, h, C, S, n]), D = Se(function() {
    return {
      draggableId: f.id,
      type: f.type,
      source: {
        index: f.index,
        droppableId: f.droppableId
      }
    };
  }, [f.droppableId, f.id, f.index, f.type]);
  return p(I, C.snapshot, D);
}
var hy = function(e, t) {
  return e === t;
}, my = function(e) {
  var t = e.combine, n = e.destination;
  return n ? n.droppableId : t ? t.droppableId : null;
}, BQ = function(t) {
  return t.combine ? t.combine.draggableId : null;
}, GQ = function(t) {
  return t.at && t.at.type === "COMBINE" ? t.at.combine.draggableId : null;
};
function WQ() {
  var e = ot(function(o, a) {
    return {
      x: o,
      y: a
    };
  }), t = ot(function(o, a, i, s, l) {
    return {
      isDragging: !0,
      isClone: a,
      isDropAnimating: !!l,
      dropAnimation: l,
      mode: o,
      draggingOver: i,
      combineWith: s,
      combineTargetFor: null
    };
  }), n = ot(function(o, a, i, s, l, c, d) {
    return {
      mapped: {
        type: "DRAGGING",
        dropping: null,
        draggingOver: l,
        combineWith: c,
        mode: a,
        offset: o,
        dimension: i,
        forceShouldAnimate: d,
        snapshot: t(a, s, l, c, null)
      }
    };
  }), r = function(a, i) {
    if (a.isDragging) {
      if (a.critical.draggable.id !== i.draggableId)
        return null;
      var s = a.current.client.offset, l = a.dimensions.draggables[i.draggableId], c = Rt(a.impact), d = GQ(a.impact), f = a.forceShouldAnimate;
      return n(e(s.x, s.y), a.movementMode, l, i.isClone, c, d, f);
    }
    if (a.phase === "DROP_ANIMATING") {
      var p = a.completed;
      if (p.result.draggableId !== i.draggableId)
        return null;
      var h = i.isClone, g = a.dimensions.draggables[i.draggableId], m = p.result, v = m.mode, w = my(m), C = BQ(m), y = a.dropDuration, x = {
        duration: y,
        curve: Q0.drop,
        moveTo: a.newHomeClientOffset,
        opacity: C ? Ti.opacity.drop : null,
        scale: C ? Ti.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: a.newHomeClientOffset,
          dimension: g,
          dropping: x,
          draggingOver: w,
          combineWith: C,
          mode: v,
          forceShouldAnimate: null,
          snapshot: t(v, h, w, C, x)
        }
      };
    }
    return null;
  };
  return r;
}
function vy(e) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
var ZQ = {
  mapped: {
    type: "SECONDARY",
    offset: it,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: vy(null)
  }
};
function $Q() {
  var e = ot(function(i, s) {
    return {
      x: i,
      y: s
    };
  }), t = ot(vy), n = ot(function(i, s, l) {
    return s === void 0 && (s = null), {
      mapped: {
        type: "SECONDARY",
        offset: i,
        combineTargetFor: s,
        shouldAnimateDisplacement: l,
        snapshot: t(s)
      }
    };
  }), r = function(s) {
    return s ? n(it, s, !0) : null;
  }, o = function(s, l, c, d) {
    var f = c.displaced.visible[s], p = !!(d.inVirtualList && d.effected[s]), h = Nu(c), g = h && h.draggableId === s ? l : null;
    if (!f) {
      if (!p)
        return r(g);
      if (c.displaced.invisible[s])
        return null;
      var m = Ia(d.displacedBy.point), v = e(m.x, m.y);
      return n(v, g, !0);
    }
    if (p)
      return r(g);
    var w = c.displacedBy.point, C = e(w.x, w.y);
    return n(C, g, f.shouldAnimate);
  }, a = function(s, l) {
    if (s.isDragging)
      return s.critical.draggable.id === l.draggableId ? null : o(l.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      var c = s.completed;
      return c.result.draggableId === l.draggableId ? null : o(l.draggableId, c.result.draggableId, c.impact, c.afterCritical);
    }
    return null;
  };
  return a;
}
var YQ = function() {
  var t = WQ(), n = $Q(), r = function(a, i) {
    return t(a, i) || n(a, i) || ZQ;
  };
  return r;
}, jQ = {
  dropAnimationFinished: zC
}, zQ = gC(YQ, jQ, null, {
  context: a5,
  pure: !0,
  areStatePropsEqual: hy
})(HQ);
function gy(e) {
  var t = Jl(d5), n = t.isUsingCloneFor;
  return n === e.draggableId && !e.isClone ? null : X.createElement(zQ, e);
}
function XQ(e) {
  var t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, n = !!e.disableInteractiveElementBlocking, r = !!e.shouldRespectForcePress;
  return X.createElement(gy, ee({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: n,
    shouldRespectForcePress: r
  }));
}
function UQ(e) {
  var t = Ht(_u);
  t || (process.env.NODE_ENV !== "production" ? _(!1, "Could not find app context") : _(!1));
  var n = t.contextId, r = t.isMovementAllowed, o = le(null), a = le(null), i = e.children, s = e.droppableId, l = e.type, c = e.mode, d = e.direction, f = e.ignoreContainerClipping, p = e.isDropDisabled, h = e.isCombineEnabled, g = e.snapshot, m = e.useClone, v = e.updateViewportMaxScroll, w = e.getContainerForClone, C = fe(function() {
    return o.current;
  }, []), y = fe(function(F) {
    o.current = F;
  }, []), x = fe(function() {
    return a.current;
  }, []), E = fe(function(F) {
    a.current = F;
  }, []);
  DQ({
    props: e,
    getDroppableRef: C,
    getPlaceholderRef: x
  });
  var S = fe(function() {
    r() && v({
      maxScroll: qC()
    });
  }, [r, v]);
  wQ({
    droppableId: s,
    type: l,
    mode: c,
    direction: d,
    isDropDisabled: p,
    isCombineEnabled: h,
    ignoreContainerClipping: f,
    getDroppableRef: C
  });
  var I = X.createElement(MQ, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, function(F) {
    var k = F.onClose, G = F.data, J = F.animate;
    return X.createElement(xQ, {
      placeholder: G,
      onClose: k,
      innerRef: E,
      animate: J,
      contextId: n,
      onTransitionEnd: S
    });
  }), D = Se(function() {
    return {
      innerRef: y,
      placeholder: I,
      droppableProps: {
        "data-rbd-droppable-id": s,
        "data-rbd-droppable-context-id": n
      }
    };
  }, [n, s, I, y]), N = m ? m.dragging.draggableId : null, A = Se(function() {
    return {
      droppableId: s,
      type: l,
      isUsingCloneFor: N
    };
  }, [s, N, l]);
  function L() {
    if (!m)
      return null;
    var F = m.dragging, k = m.render, G = X.createElement(gy, {
      draggableId: F.draggableId,
      index: F.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, function(J, $) {
      return k(J, $, F);
    });
    return kt.createPortal(G, w());
  }
  return X.createElement(d5.Provider, {
    value: A
  }, i(D, g), L());
}
var I1 = function(t, n) {
  return t === n.droppable.type;
}, y7 = function(t, n) {
  return n.draggables[t.draggable.id];
}, JQ = function() {
  var t = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, n = ee({}, t, {
    shouldAnimatePlaceholder: !1
  }), r = ot(function(i) {
    return {
      draggableId: i.id,
      type: i.type,
      source: {
        index: i.index,
        droppableId: i.droppableId
      }
    };
  }), o = ot(function(i, s, l, c, d, f) {
    var p = d.descriptor.id, h = d.descriptor.droppableId === i;
    if (h) {
      var g = f ? {
        render: f,
        dragging: r(d.descriptor)
      } : null, m = {
        isDraggingOver: l,
        draggingOverWith: l ? p : null,
        draggingFromThisWith: p,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: d.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: m,
        useClone: g
      };
    }
    if (!s)
      return n;
    if (!c)
      return t;
    var v = {
      isDraggingOver: l,
      draggingOverWith: p,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: d.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: v,
      useClone: null
    };
  }), a = function(s, l) {
    var c = l.droppableId, d = l.type, f = !l.isDropDisabled, p = l.renderClone;
    if (s.isDragging) {
      var h = s.critical;
      if (!I1(d, h))
        return n;
      var g = y7(h, s.dimensions), m = Rt(s.impact) === c;
      return o(c, f, m, m, g, p);
    }
    if (s.phase === "DROP_ANIMATING") {
      var v = s.completed;
      if (!I1(d, v.critical))
        return n;
      var w = y7(v.critical, s.dimensions);
      return o(c, f, my(v.result) === c, Rt(v.impact) === c, w, p);
    }
    if (s.phase === "IDLE" && s.completed && !s.shouldFlush) {
      var C = s.completed;
      if (!I1(d, C.critical))
        return n;
      var y = Rt(C.impact) === c, x = !!(C.impact.at && C.impact.at.type === "COMBINE"), E = C.critical.droppable.id === c;
      return y ? x ? t : n : E ? t : n;
    }
    return n;
  };
  return a;
}, KQ = {
  updateViewportMaxScroll: $J
};
function qQ() {
  return document.body || (process.env.NODE_ENV !== "production" ? _(!1, "document.body is not ready") : _(!1)), document.body;
}
var QQ = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: qQ
}, wy = gC(JQ, KQ, null, {
  context: a5,
  pure: !0,
  areStatePropsEqual: hy
})(UQ);
wy.defaultProps = QQ;
const lne = ({
  children: e,
  onOrderChange: t,
  draggableItemsClassName: n
}) => {
  const [r, o] = X.useState([]);
  return ye(() => {
    const a = [];
    X.Children.forEach(e, (l, c) => {
      X.isValidElement(l) && l.type === eee && a.push(l);
    });
    const i = a.filter((l) => !r.map((c) => c.key).includes(l.key)), s = r.filter((l) => a.map((c) => c.key).includes(l.key));
    o([...s, ...i]);
  }, [e]), /* @__PURE__ */ u(
    oQ,
    {
      onDragEnd: (a) => {
        var l, c;
        const i = (l = a == null ? void 0 : a.destination) == null ? void 0 : l.index, s = (c = a == null ? void 0 : a.source) == null ? void 0 : c.index;
        s != null && i != null && o((d) => {
          const [f] = d.splice(s, 1);
          d.splice(i, 0, f);
          const p = d.map((h) => {
            var g;
            return ((g = h.key) == null ? void 0 : g.toString()) ?? "";
          });
          return t(p), d;
        });
      },
      children: /* @__PURE__ */ u("div", { children: /* @__PURE__ */ u(wy, { droppableId: "list", children: (a) => /* @__PURE__ */ T(
        "div",
        {
          className: "tw-w-full tw-flex tw-flex-col tw-gap-16px",
          ref: a.innerRef,
          ...a.droppableProps,
          children: [
            r.map((i, s) => {
              var l, c;
              return /* @__PURE__ */ u(XQ, { draggableId: ((l = i == null ? void 0 : i.key) == null ? void 0 : l.toString()) ?? "", index: s, children: (d) => /* @__PURE__ */ T(
                "div",
                {
                  ref: d.innerRef,
                  ...d.draggableProps,
                  className: P(
                    "tw-w-full tw-min-h-[40px] tw-items-center tw-flex tw-gap-8px !tw-left-auto",
                    n
                  ),
                  children: [
                    /* @__PURE__ */ u("div", { ...d.dragHandleProps, children: /* @__PURE__ */ u(l8, { color: "#9CA3AF", width: 24, height: 24, role: "button" }) }),
                    /* @__PURE__ */ u("div", { className: "tw-flex-1", children: i.props.children }),
                    /* @__PURE__ */ u(
                      rt,
                      {
                        className: "tw-cursor-pointer",
                        size: 24,
                        onClick: () => {
                          i.props.onClear && i.props.onClear();
                        }
                      }
                    )
                  ]
                }
              ) }, ((c = i == null ? void 0 : i.key) == null ? void 0 : c.toString()) ?? "");
            }),
            a.placeholder
          ]
        }
      ) }) })
    }
  );
}, eee = ({ children: e }) => /* @__PURE__ */ u(Ee, { children: e }), cne = (e) => {
  const [t, n] = X.useState(null), [r, o] = ue(null), a = (i) => i < 1024 ? i + " bytes" : i < 1048576 ? (i / 1024).toFixed(2) + " KB" : (i / 1048576).toFixed(2) + " MB";
  return ye(() => {
    if (t == null) {
      o(null);
      return;
    }
    if (t.type.startsWith("image/")) {
      const i = new FileReader();
      i.onloadend = () => {
        o(i.result);
      }, i.readAsDataURL(t);
    } else
      o(null);
    return () => {
      r && URL.revokeObjectURL(r);
    };
  }, [t]), /* @__PURE__ */ u(B2, { open: e.open, children: /* @__PURE__ */ T(
    Ic,
    {
      className: P("tw-w-[750px] tw-z-10001 tw-rounded-2xl tw-flex tw-flex-col tw-p-0", e.className),
      children: [
        /* @__PURE__ */ T("div", { className: "tw-p-16px tw-flex tw-items-center tw-justify-between", children: [
          /* @__PURE__ */ u(De, { variant: "h5", className: "tw-text-[#0F172A]", children: e.title }),
          /* @__PURE__ */ u(rt, { size: 24, className: "tw-cursor-pointer", onClick: e.onClose })
        ] }),
        /* @__PURE__ */ T("div", { className: "tw-p-16px tw-pt-0 tw-border-gray-500 tw-flex tw-flex-col tw-items-start tw-gap-16px", children: [
          /* @__PURE__ */ u(De, { variant: "normal", className: "tw-text-[#374151]", children: e.subtitle }),
          /* @__PURE__ */ u("div", { className: "tw-flex tw-items-center tw-justify-center tw-w-full", children: /* @__PURE__ */ T(
            "label",
            {
              htmlFor: "dropzone-file",
              className: "tw-h-[350px] tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full tw-border tw-border-[#6B7280] tw-border-dashed tw-rounded-md tw-cursor-pointer",
              children: [
                t != null ? /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-w-[200px]", children: [
                  t.type.startsWith("image/") ? /* @__PURE__ */ T("div", { className: "tw-w-[200px] tw-h-[200px] tw-rounded-lg tw-relative", children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        className: "tw-w-[20px] tw-h-[20px] tw-flex tw-items-center tw-justify-center tw-absolute -tw-top-[8px] -tw-right-[8px] tw-rounded-full tw-bg-[#000]",
                        onClick: (i) => {
                          i.stopPropagation(), n(null);
                        },
                        children: /* @__PURE__ */ u(rt, { color: "#fff", size: 16 })
                      }
                    ),
                    /* @__PURE__ */ u(
                      "img",
                      {
                        className: "tw-w-[200px] tw-h-[200px] tw-rounded-lg tw-object-cover",
                        src: r,
                        alt: "preview"
                      }
                    )
                  ] }) : /* @__PURE__ */ u("div", { className: "tw-w-[200px] tw-h-[200px] tw-bg-[#D9D9D9] tw-rounded-lg tw-relative", children: /* @__PURE__ */ u(
                    "div",
                    {
                      className: "tw-w-[20px] tw-h-[20px] tw-flex tw-items-center tw-justify-center tw-absolute -tw-top-[8px] -tw-right-[8px] tw-rounded-full tw-bg-[#000]",
                      onClick: (i) => {
                        i.stopPropagation(), n(null);
                      },
                      children: /* @__PURE__ */ u(rt, { color: "#fff", size: 16 })
                    }
                  ) }),
                  /* @__PURE__ */ u(De, { variant: "normal", className: "tw-font-semibold tw-mt-16px tw-line-clamp-2", children: t.name }),
                  /* @__PURE__ */ u(De, { variant: "normal", className: "tw-text-xs tw-text-[#6B7280] tw-mt-8px", children: a(t.size) })
                ] }) : /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-5 tw-pb-6 tw-gap-16px", children: [
                  /* @__PURE__ */ u(VD, { size: 32, color: "#6B7280" }),
                  /* @__PURE__ */ u(De, { variant: "normal", className: "tw-text-[#374151]", children: e.dragAndDropText || "Drag and drop your files here or browse images." })
                ] }),
                /* @__PURE__ */ u(
                  "input",
                  {
                    disabled: e.isUploadLoading || t != null,
                    multiple: !1,
                    id: "dropzone-file",
                    type: "file",
                    className: "tw-hidden",
                    onChange: (i) => {
                      var s, l;
                      (l = (s = i.target) == null ? void 0 : s.files) != null && l.length && i.target.files.length > 0 && (n(i.target.files[0]), e.onFileChange != null && e.onFileChange(i.target.files[0]));
                    }
                  }
                )
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ u("div", { className: "tw-px-16px tw-py-12px tw-flex tw-justify-end tw-items-center tw-border-t tw-border-[#D1D5DB]", children: /* @__PURE__ */ u(
          Yr,
          {
            variant: "primary",
            size: "md",
            isLoading: e.isUploadLoading,
            onClick: () => {
              e.onUpload != null && e.onUpload(t);
            },
            children: e.uploadText || "Upload"
          }
        ) })
      ]
    }
  ) });
}, tee = "_timePickerButton_g87jq_1", nee = "_timePickerPopup_g87jq_5", ree = "_scrollDiv_g87jq_9", Za = {
  timePickerButton: tee,
  timePickerPopup: nee,
  scrollDiv: ree
}, Eo = 40, une = (e) => {
  const [t, n] = ue(!1), [r, o] = ue(e.time.hour() % 12), [a, i] = ue(e.time.minute()), [s, l] = ue(""), [c, d] = ue(""), [f, p] = ue(e.time.hour() >= 12 ? "PM" : "AM"), h = le(null), g = le(null), m = le(null), v = le(null), w = Array.from({ length: 12 }, (S, I) => I + 1), C = Array.from({ length: 60 }, (S, I) => I);
  ye(() => {
    l(r.toString());
  }, [r]), ye(() => {
    d(y(a));
  }, [a]);
  const y = (S) => S.toString().padStart(2, "0");
  ye(() => {
    t && requestAnimationFrame(() => {
      const S = () => {
        g.current != null && g.current.classList.remove("tw-scroll-smooth"), m.current != null && m.current.classList.remove("tw-scroll-smooth"), v.current != null && v.current.classList.remove("tw-scroll-smooth");
      }, I = () => {
        g.current != null && g.current.classList.add("tw-scroll-smooth"), m.current != null && m.current.classList.add("tw-scroll-smooth"), v.current != null && v.current.classList.add("tw-scroll-smooth");
      }, D = w.indexOf(r), N = C.indexOf(a), A = f === "AM" ? 0 : 1;
      S(), g.current != null && (g.current.scrollTop = D * Eo), m.current != null && (m.current.scrollTop = N * Eo), v.current != null && (v.current.scrollTop = A * Eo), setTimeout(() => {
        I();
      }, 50);
    });
  }, [t]);
  const x = (S, I) => {
    const D = S.currentTarget;
    D.scrollTimeout || (D.scrollTimeout = setTimeout(() => {
      const N = D.scrollTop, A = Math.round(N / Eo);
      switch (I) {
        case "hour":
          o(w[A] || w[0]);
          break;
        case "minute":
          i(C[A] || C[0]);
          break;
        case "period":
          p(A === 0 ? "AM" : "PM");
          break;
      }
      D.scrollTimeout = null;
    }, 100));
  }, E = (S, I, D, N) => {
    N == null || N.stopPropagation();
    const A = S === "hour" ? g : S === "minute" ? m : v, L = S === "period" ? (I === "AM" ? 0 : 1) * Eo : (S === "hour" ? w.indexOf(I) : I) * Eo;
    switch (A.current != null && A.current.scrollTo({
      top: L,
      behavior: D
    }), S) {
      case "hour":
        o(I);
        break;
      case "minute":
        i(I);
        break;
      case "period":
        p(I);
        break;
    }
  };
  return /* @__PURE__ */ u("div", { className: P("tw-w-48", e.className), ref: h, children: /* @__PURE__ */ T(Ub, { open: t, onOpenChange: n, children: [
    /* @__PURE__ */ T(
      Jb,
      {
        className: P(
          "tw-flex tw-min-w-[250px] tw-h-[54px] tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-md tw-border tw-bg-background tw-px-12px tw-py-2 tw-text-normal tw-ring-offset-background data-[placeholder]:tw-text-muted-foreground focus:tw-outline-none disabled:tw-cursor-not-allowed disabled:tw-opacity-50 [&>span]:tw-line-clamp-1",
          e.hasError ? "tw-border-[#ef4444]" : "tw-border-input",
          e.isDisabled && "tw-bg-gray-50 tw-pointer-events-none tw-text-[#9CA3AF]",
          Za.timePickerButton,
          e.buttonClassName
        ),
        children: [
          /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-row tw-items-center tw-gap-2", children: [
            e.leftContent,
            /* @__PURE__ */ u("span", { children: e.time.format("LT") })
          ] }),
          /* @__PURE__ */ u(la, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" })
        ]
      }
    ),
    /* @__PURE__ */ u(
      A0,
      {
        className: P(
          "tw-w-[250px] tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-animate-in tw-p-0 tw-mt-2 tw-slide-in-from-top-2",
          Za.timePickerPopup,
          e.popupClassName
        ),
        children: /* @__PURE__ */ T("div", { className: "tw-py-2", children: [
          /* @__PURE__ */ T("div", { className: "tw-relative tw-flex", children: [
            /* @__PURE__ */ T("div", { className: "tw-w-[248px] tw-bg-gray-100 tw-h-[40px] tw-absolute tw-top-[60px] tw-text-xl tw-flex tw-items-center", children: [
              /* @__PURE__ */ u(
                "input",
                {
                  className: "tw-w-[82px] tw-bg-transparent tw-font-bold tw-text-center tw-border-none tw-outline-none focus:tw-ring-0",
                  type: "text",
                  value: s,
                  pattern: "[0-9]+([\\.][0-9]*)?",
                  inputMode: "numeric",
                  onWheel: (S) => {
                    S.preventDefault(), g.current != null && (g.current.scrollTop += S.deltaY);
                  },
                  onChange: (S) => {
                    !isNaN(+S.target.value) && +S.target.value >= 0 && +S.target.value <= 12 && (l(S.target.value), E("hour", +S.target.value, "instant"));
                  }
                }
              ),
              /* @__PURE__ */ u("span", { className: "tw-block tw-pb-4px tw-font-extrabold", children: ":" }),
              /* @__PURE__ */ u(
                "input",
                {
                  className: "tw-w-[76px] tw-bg-transparent tw-font-bold tw-text-center tw-border-none tw-outline-none focus:tw-ring-0",
                  pattern: "[0-9]+([\\.][0-9]*)?",
                  inputMode: "numeric",
                  type: "text",
                  onChange: (S) => {
                    !isNaN(+S.target.value) && +S.target.value >= 0 && +S.target.value <= 59 && (d(S.target.value), E("minute", +S.target.value, "instant"));
                  },
                  onWheel: (S) => {
                    S.preventDefault(), m.current != null && (m.current.scrollTop += S.deltaY);
                  },
                  value: c
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  className: "tw-w-[82px] tw-font-bold tw-text-center",
                  onWheel: (S) => {
                    S.preventDefault(), v.current != null && (v.current.scrollTop += S.deltaY);
                  },
                  children: f
                }
              )
            ] }),
            /* @__PURE__ */ T(
              "div",
              {
                ref: g,
                className: P(
                  "tw-flex-1 tw-h-40 tw-overflow-y-auto tw-w-16 tw-scroll-smooth tw-snap-y",
                  Za.scrollDiv
                ),
                onScroll: (S) => {
                  x(S, "hour");
                },
                children: [
                  /* @__PURE__ */ u("div", { className: "tw-h-16" }),
                  w.map((S) => /* @__PURE__ */ u(
                    "div",
                    {
                      onClick: (I) => {
                        E("hour", S, "smooth", I);
                      },
                      className: `tw-h-10 tw-flex tw-items-center tw-justify-center tw-snap-center tw-cursor-pointer
                      ${r === S ? "tw-text-primary-foreground tw-font-bold tw-text-xl" : "tw-text-gray-400"}`,
                      children: S
                    },
                    S
                  )),
                  /* @__PURE__ */ u("div", { className: "tw-h-16" })
                ]
              }
            ),
            /* @__PURE__ */ T(
              "div",
              {
                ref: m,
                className: P(
                  "tw-flex-1 tw-h-40 tw-overflow-y-auto tw-w-16 tw-scroll-smooth tw-snap-y",
                  Za.scrollDiv
                ),
                onScroll: (S) => {
                  x(S, "minute");
                },
                children: [
                  /* @__PURE__ */ u("div", { className: "tw-h-16" }),
                  C.map((S) => /* @__PURE__ */ u(
                    "div",
                    {
                      onClick: (I) => {
                        E("minute", S, "smooth", I);
                      },
                      className: `tw-h-10 tw-flex tw-items-center tw-justify-center tw-snap-center tw-cursor-pointer
                      ${a === S ? "tw-text-primary-foreground tw-font-bold tw-text-xl" : "tw-text-gray-400"}`,
                      children: y(S)
                    },
                    S
                  )),
                  /* @__PURE__ */ u("div", { className: "tw-h-16" })
                ]
              }
            ),
            /* @__PURE__ */ T(
              "div",
              {
                ref: v,
                className: P(
                  "tw-flex-1 tw-h-40 tw-overflow-y-auto tw-w-16 tw-scroll-smooth tw-snap-y",
                  Za.scrollDiv
                ),
                onScroll: (S) => {
                  x(S, "period");
                },
                children: [
                  /* @__PURE__ */ u("div", { className: "tw-h-16" }),
                  ["AM", "PM"].map((S) => /* @__PURE__ */ u(
                    "div",
                    {
                      onClick: (I) => {
                        E("period", S, "smooth", I);
                      },
                      className: `tw-h-10 tw-flex tw-items-center tw-justify-center tw-snap-center tw-cursor-pointer
                      ${f === S ? "tw-text-primary-foreground tw-font-bold tw-text-xl" : "tw-text-gray-400"}`,
                      children: S
                    },
                    S
                  )),
                  /* @__PURE__ */ u("div", { className: "tw-h-16" })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ T("div", { className: "tw-flex tw-justify-end tw-gap-8px tw-py-1 tw-px-2", children: [
            /* @__PURE__ */ u(
              Yr,
              {
                variant: "secondary",
                onClick: () => {
                  var S;
                  (S = e.onCancel) == null || S.call(e), n(!1), o(e.time.hour() % 12), i(e.time.minute()), p(e.time.hour() >= 12 ? "PM" : "AM");
                },
                children: e.cancelButtonText || "Cancel"
              }
            ),
            /* @__PURE__ */ u(
              Yr,
              {
                variant: "primary",
                onClick: () => {
                  var I;
                  const S = r === 12 ? f === "AM" ? 0 : 12 : r + (f === "PM" ? 12 : 0);
                  (I = e.onApply) == null || I.call(e, ae().hour(S).minute(a)), n(!1);
                },
                children: e.applyButtonText || "Apply"
              }
            )
          ] })
        ] })
      }
    )
  ] }) });
}, oee = (e) => {
  const [t, n] = ue(!1), [r, o] = ue(!0), a = le(null), i = (c) => {
    var d, f, p, h;
    if (!t) {
      n(!0), o(!1), (f = (d = a.current) == null ? void 0 : d.inputRef) == null || f.setAttribute("disabled", "true");
      return;
    }
    if (t && !r) {
      o(!0), (h = (p = a.current) == null ? void 0 : p.inputRef) == null || h.setAttribute("disabled", "false");
      return;
    }
    t && n(!1);
  }, s = (c) => {
    var p, h, g, m, v, w;
    const d = (p = a.current) == null ? void 0 : p.controlRef, f = (h = a.current) == null ? void 0 : h.menuListRef;
    d != null && !d.contains(c.target) && !(f != null && f.contains(c.target)) && (n(!1), o(!0), (m = (g = a.current) == null ? void 0 : g.inputRef) == null || m.setAttribute("disabled", "false"), (v = a.current) == null || v.focus(), (w = a.current) == null || w.blur());
  }, l = (c, d) => {
    var f, p, h;
    (f = e.onChange) == null || f.call(e, c, d), n(!1), o(!0), (h = (p = a.current) == null ? void 0 : p.inputRef) == null || h.setAttribute("disabled", "false");
  };
  return ye(() => {
    var d;
    if (!e.isMobile)
      return;
    const c = (d = a.current) == null ? void 0 : d.controlRef;
    return c != null && c.addEventListener("touchstart", i), document.addEventListener("touchend", s), () => {
      c != null && c.removeEventListener("touchstart", i), document.removeEventListener("touchend", s);
    };
  }, [i]), /* @__PURE__ */ T(Ee, { children: [
    /* @__PURE__ */ u(
      _2,
      {
        ...e,
        ref: a,
        styles: { ...L2(e.error), ...e.styles },
        ...e.isMobile && {
          menuIsOpen: t,
          isSearchable: r,
          closeMenuOnSelect: !0,
          onChange: l
        },
        components: {
          DropdownIndicator: lh,
          ClearIndicator: O2,
          MultiValueRemove: T2
        }
      }
    ),
    /* @__PURE__ */ u("div", { className: "block tw-mt-2", children: e.error && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: e.error }) })
  ] });
};
oee.defaultProps = {
  menuPortalTarget: document.body
};
var by = {};
Object.defineProperty(by, "__esModule", { value: !0 });
function aee() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e.length === 2)
    return E7(e[0], e[1]) || null;
  var n = e.slice(1).reduce(function(r, o) {
    return E7(r, o);
  }, e[0]);
  return n || null;
}
var iee = by.default = aee, x7 = /* @__PURE__ */ new WeakMap();
function E7(e, t) {
  if (e && t) {
    var n = x7.get(e) || /* @__PURE__ */ new WeakMap();
    x7.set(e, n);
    var r = n.get(t) || function(o) {
      I7(e, o), I7(t, o);
    };
    return n.set(t, r), r;
  }
  return e || t;
}
function I7(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
var S7 = Symbol("useLazyRef empty value"), see = (e) => {
  const t = le(S7);
  return t.current === S7 && (t.current = e()), t;
};
function lee() {
  var e = le(!1);
  return ye(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
var Us = function(t) {
  var n = X.useRef(t);
  return yl(function() {
    n.current = t;
  }), n;
};
function Gr(e) {
  return {
    isOk: () => !0,
    isOkAnd: (n) => n(e),
    isErr: () => !1,
    isErrAnd: () => !1,
    ok: () => f5(e),
    err: () => $r(),
    map: (n) => Gr(n(e)),
    mapOr: (n, r) => r(e),
    mapOrElse: (n, r) => r(e),
    mapErr: () => Gr(e),
    expect: () => e,
    expectErr: (n) => {
      throw new Error(n);
    },
    unwrap: () => e,
    unwrapErr: () => {
      throw new Error(`${e}`);
    },
    unwrapOr: () => e,
    unwrapOrElse: () => e,
    and: (n) => n,
    andThen: (n) => n(e),
    or: () => Gr(e),
    orElse: () => Gr(e)
  };
}
function Wr(e) {
  return {
    isOk: () => !1,
    isOkAnd: () => !1,
    isErr: () => !0,
    isErrAnd: (n) => n(e),
    ok: () => $r(),
    err: () => f5(e),
    map: () => Wr(e),
    mapOr: (n) => n,
    mapOrElse: (n) => n(e),
    mapErr: (n) => Wr(n(e)),
    expect: (n) => {
      throw new Error(n);
    },
    expectErr: () => e,
    unwrap: () => {
      throw new Error(`${e}`);
    },
    unwrapErr: () => e,
    unwrapOr: (n) => n,
    unwrapOrElse: (n) => n(e),
    and: () => Wr(e),
    andThen: () => Wr(e),
    or: (n) => n,
    orElse: (n) => n(e)
  };
}
function $r() {
  const e = {
    and: () => $r(),
    andThen: () => $r(),
    expect: (t) => {
      throw new Error(t);
    },
    filter: () => e,
    isSome: () => !1,
    isSomeAnd: () => !1,
    isNone: () => !0,
    map: () => $r(),
    mapOr: (t) => t,
    mapOrElse: (t) => t(),
    okOr: (t) => Wr(t),
    okOrElse: (t) => Wr(t()),
    or: (t) => t,
    orElse: (t) => t(),
    unwrap: () => {
      throw new Error("panic! call `unwrap` on a `None` value");
    },
    unwrapOr: (t) => t,
    unwrapOrElse: (t) => t(),
    xor: (t) => t.isSome() ? t : e
  };
  return e;
}
function f5(e) {
  const t = {
    and: (n) => n,
    andThen: (n) => n(e),
    expect: () => e,
    filter: (n) => n(e) ? t : $r(),
    isSome: () => !0,
    isSomeAnd: (n) => n(e),
    isNone: () => !1,
    map: (n) => f5(n(e)),
    mapOr: (n, r) => r(e),
    mapOrElse: (n, r) => r(e),
    okOr: () => Gr(e),
    okOrElse: () => Gr(e),
    or: () => t,
    orElse: () => t,
    unwrap: () => e,
    unwrapOr: () => e,
    unwrapOrElse: () => e,
    xor: (n) => n.isNone() ? t : $r()
  };
  return t;
}
function cee(e) {
  return e.then(
    (t) => Gr(t),
    (t) => Wr(t)
  );
}
var uee = setTimeout;
function dee(e, t) {
  var n = t.useCachedSetTimeout ? uee : setTimeout;
  return new Promise(function(r) {
    n(r, e);
  });
}
function fee(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.useCachedSetTimeout, r = dee(e, { useCachedSetTimeout: n });
  function o(a) {
    return r.then(function() {
      return a;
    });
  }
  return o.then = function() {
    return r.then.apply(r, arguments);
  }, o.catch = Promise.resolve().catch, o;
}
var pee = 300;
function hee(e) {
  function t(n) {
    const { selectProps: r, innerRef: o } = n, { handleScrolledToBottom: a, shouldLoadMore: i } = r, s = le(null), l = le(null), c = Ve(() => {
      const p = l.current;
      if (!p)
        return !1;
      const { scrollTop: h, scrollHeight: g, clientHeight: m } = p;
      return i(g, m, h);
    }, [i]), d = Ve(() => {
      c() && a && a();
    }, [c, a]), f = Xe(() => {
      const p = () => {
        d(), s.current = setTimeout(
          p,
          pee
        );
      };
      return p;
    }, [d]);
    return ye(() => (f(), () => {
      s.current && clearTimeout(s.current);
    }), []), /* @__PURE__ */ u(
      e,
      {
        ...n,
        innerRef: iee(o, l)
      }
    );
  }
  return t;
}
var mee = hee(
  // biome-ignore lint/suspicious/noExplicitAny: fix types
  X8.MenuList
), vee = (e) => Xe(
  () => ({
    MenuList: mee,
    ...e
  }),
  [e]
), gee = (e, t) => [...e, ...t], wee = 10, bee = (e, t, n) => e - t - wee < n, Cy = (e) => ({
  isFirstLoad: !0,
  options: [],
  hasMore: !0,
  isLoading: !1,
  lockedUntil: 0,
  additional: e.additional
}), Cee = ({
  options: e,
  defaultOptions: t,
  additional: n,
  defaultAdditional: r
}) => {
  const o = t === !0 ? null : Array.isArray(t) ? t : e;
  return o ? {
    "": {
      isFirstLoad: !1,
      isLoading: !1,
      options: o,
      hasMore: !0,
      lockedUntil: 0,
      additional: r || n
    }
  } : {};
}, D7 = '[react-select-async-paginate] response of "loadOptions" should be an object with "options" prop, which contains array of options.', yee = (e) => {
  if (!e)
    return !1;
  const { options: t, hasMore: n } = e;
  return !(!Array.isArray(t) || typeof n != "boolean" && typeof n < "u");
}, xee = (e) => {
  if (!yee(e))
    throw console.error(D7, "Received:", e), new Error(D7);
  return !0;
}, Eee = async (e, t, n, r, o, a, i, s) => {
  const l = t.current.inputValue, c = !n.current[l], d = c ? Cy(t.current) : n.current[l];
  if (d.isLoading || !d.hasMore || d.lockedUntil > Date.now())
    return;
  if (o(
    (m) => s && e === "input-change" ? {
      [l]: {
        ...d,
        isLoading: !0
      }
    } : {
      ...m,
      [l]: {
        ...d,
        isLoading: !0
      }
    }
  ), r > 0 && e === "input-change") {
    await fee(r);
    const m = t.current.inputValue;
    if (l !== m) {
      o((v) => {
        if (c) {
          const { [l]: w, ...C } = v;
          return C;
        }
        return {
          ...v,
          [l]: {
            ...d,
            isLoading: !1
          }
        };
      });
      return;
    }
  }
  const { loadOptions: f, reloadOnErrorTimeout: p = 0 } = t.current, h = await cee(
    Promise.resolve().then(
      () => f(
        l,
        d.options,
        d.additional
      )
    )
  );
  if (!i.current)
    return;
  if (h.isErr()) {
    o((m) => ({
      ...m,
      [l]: {
        ...d,
        isLoading: !1,
        lockedUntil: Date.now() + p
      }
    }));
    return;
  }
  const g = h.unwrap();
  if (xee(g)) {
    const { options: m, hasMore: v } = g, w = Object.hasOwn(g, "additional") ? g.additional : d.additional;
    o((C) => ({
      ...C,
      [l]: {
        ...d,
        options: a(d.options, m, w),
        hasMore: !!v,
        isLoading: !1,
        isFirstLoad: !1,
        additional: w
      }
    }));
  }
}, S1 = (e) => e + 1, Iee = (e, t = []) => {
  const {
    clearCacheOnSearchChange: n = !1,
    clearCacheOnMenuClose: r = !1,
    defaultOptions: o,
    loadOptionsOnMenuOpen: a = !0,
    debounceTimeout: i = 0,
    inputValue: s,
    menuIsOpen: l,
    filterOption: c = null,
    reduceOptions: d = gee,
    shouldLoadMore: f = bee,
    mapOptionsForMenu: p = void 0
  } = e, h = Us(l), g = lee(), m = Us(d), v = Us(a), w = le(!0), C = le(e);
  C.current = e;
  const [y, x] = ue(0), E = see(() => Cee(e)), S = Us(
    (A) => {
      Eee(
        A,
        C,
        E,
        i,
        (L) => {
          E.current = L(E.current), g.current && x(S1);
        },
        m.current,
        g,
        n
      );
    }
  ), I = Ve(() => {
    const A = C.current.inputValue;
    E.current[A] && S.current("menu-scroll");
  }, [S, E]);
  ye(() => {
    w.current ? w.current = !1 : (E.current = {}, x(S1)), o === !0 && S.current("autoload");
  }, t), ye(() => {
    h.current && !E.current[s] && S.current("input-change");
  }, [S, s, h, E]), ye(() => {
    if (l) {
      if (!E.current[""] && v.current) {
        S.current("menu-toggle");
        return;
      }
      return;
    }
    r && (E.current = {}, x(S1));
  }, [
    S,
    v,
    l,
    E,
    r
  ]);
  const D = E.current[s] || Cy(e), N = Xe(() => p ? p(D.options) : D.options, [D.options, p]);
  return {
    handleScrolledToBottom: I,
    shouldLoadMore: f,
    filterOption: c,
    isLoading: D.isLoading || D.lockedUntil > Date.now(),
    isFirstLoad: D.isFirstLoad,
    options: N
  };
}, See = (e, t = []) => {
  const {
    inputValue: n,
    menuIsOpen: r,
    defaultInputValue: o,
    defaultMenuIsOpen: a,
    onInputChange: i,
    onMenuClose: s,
    onMenuOpen: l
  } = e, [c, d] = ue(
    o || ""
  ), [f, p] = ue(!!a), h = typeof n == "string" ? n : c, g = typeof r == "boolean" ? r : f, m = Ve(
    (y, x) => {
      i && i(y, x), d(y);
    },
    [i]
  ), v = Ve(() => {
    s && s(), p(!1);
  }, [s]), w = Ve(() => {
    l && l(), p(!0);
  }, [l]);
  return {
    ...Iee(
      {
        ...e,
        inputValue: h,
        menuIsOpen: g
      },
      t
    ),
    inputValue: h,
    menuIsOpen: g,
    onInputChange: m,
    onMenuClose: v,
    onMenuOpen: w
  };
}, Dee = [], Mee = {};
function yy(e) {
  function t(n) {
    const {
      components: r = Mee,
      selectRef: o = void 0,
      isLoading: a,
      cacheUniqs: i = Dee,
      menuPlacement: s,
      menuShouldScrollIntoView: l,
      ...c
    } = n, d = See(c, i), f = vee(
      r
    ), p = typeof a == "boolean" ? a : d.isLoading;
    return /* @__PURE__ */ u(
      e,
      {
        ...n,
        ...d,
        menuPlacement: s,
        menuShouldScrollIntoView: s === "auto" && p ? !1 : l,
        isLoading: p,
        components: f,
        ref: o
      }
    );
  }
  return t;
}
const Nee = yy(sh), Pee = yy(_2);
function dne(e) {
  const { loadOptions: t, debounceTimeout: n = 300, isMobile: r, isCreatable: o, ...a } = e, [i, s] = ue(!1), [l, c] = ue(!1), d = le(null), f = () => {
    s((m) => {
      if (m)
        c(!0);
      else
        return !0;
      return m;
    });
  }, p = (m) => {
    var C, y, x, E;
    const v = (C = d.current) == null ? void 0 : C.controlRef, w = (y = d.current) == null ? void 0 : y.menuListRef;
    v != null && !v.contains(m.target) && !(w != null && w.contains(m.target)) && (s(!1), c(!1), (E = (x = d.current) == null ? void 0 : x.inputRef) == null || E.blur());
  };
  ye(() => {
    var m;
    if (l) {
      const v = (m = d.current) == null ? void 0 : m.inputRef;
      v != null && (v.removeAttribute("disabled"), v.focus({ preventScroll: !0 }));
    }
  }, [l]), ye(() => {
    var v;
    if (!r)
      return;
    const m = (v = d.current) == null ? void 0 : v.controlRef;
    return m != null && m.addEventListener("touchstart", f), document.addEventListener("touchstart", p), () => {
      m != null && m.removeEventListener("touchstart", f), document.removeEventListener("touchstart", p);
    };
  }, [r]);
  const h = (m, v) => {
    var w;
    (w = a.onChange) == null || w.call(a, m, v), s(!1), c(!1);
  };
  return /* @__PURE__ */ u(
    o ? Pee : Nee,
    {
      ...a,
      loadOptions: t,
      debounceTimeout: n,
      selectRef: d,
      menuIsOpen: r ? i : a.menuIsOpen,
      isSearchable: r ? l : a.isSearchable,
      onChange: h,
      styles: { ...L2(e.error), ...e.styles },
      components: {
        DropdownIndicator: lh,
        ClearIndicator: O2,
        MultiValueRemove: T2
      }
    }
  );
}
const Aee = ({ children: e, className: t }) => /* @__PURE__ */ u(
  "div",
  {
    className: P("tw-border-gray-100 tw-border tw-rounded-lg tw-p-3 tw-shadow-bordered-card tw-bg-white", t),
    children: e
  }
), _ee = Xt("tw-inline-block", {
  variants: {
    size: {
      xs: "tw-text-xs tw-leading-4",
      sm: "tw-text-sm tw-leading-5",
      base: "tw-text-base tw-leading-6",
      lg: "tw-text-lg tw-leading-7",
      xl: "tw-text-xl tw-leading-8",
      "2xl": "tw-text-2xl tw-leading-9",
      "3xl": "tw-text-3xl tw-leading-10",
      "4xl": "tw-text-4xl tw-leading-[2.5rem]",
      "5xl": "tw-text-5xl tw-leading-[3rem]",
      "6xl": "tw-text-6xl tw-leading-[3.5rem]",
      "7xl": "tw-text-7xl tw-leading-[4rem]"
    },
    variant: {
      body: "tw-text-gray-900",
      label: "tw-text-gray-600",
      disabled: "tw-text-gray-300",
      light: "tw-text-gray-0"
    },
    weight: {
      light: "tw-font-light",
      normal: "tw-font-normal",
      medium: "tw-font-medium",
      semibold: "tw-font-semibold",
      bold: "tw-font-bold"
    }
  },
  defaultVariants: {
    size: "base",
    variant: "body",
    weight: "normal"
  }
}), Oee = X.forwardRef(
  ({ className: e, size: t, variant: n, weight: r, as: o = "span", ...a }, i) => /* @__PURE__ */ u(o, { className: P(_ee({ size: t, variant: n, weight: r }), e), ref: i, ...a })
);
Oee.displayName = "TextV2";
const Tee = b.forwardRef(
  ({ className: e, asChild: t = !1, ...n }, r) => /* @__PURE__ */ u(
    t ? ta : "button",
    {
      className: P(
        "tw-bg-white tw-border tw-border-gray-100 tw-rounded-md tw-p-3 tw-flex tw-items-center tw-shadow-xs",
        e
      ),
      ref: r,
      ...n,
      children: n.children
    }
  )
);
Tee.displayName = "CardButton";
const Lee = (e, t) => t === "12h" ? e >= 1 && e <= 12 : e >= 0 && e <= 23, Ree = (e) => e >= 0 && e <= 59, M7 = (e) => {
  if (e == null || e === "")
    return null;
  if (ae.isMoment(e))
    return e.isValid() ? e : null;
  const t = ae(e);
  if (t.isValid())
    return t;
  const n = ae(e, ["HH:mm:ss", "HH:mm"]);
  return n.isValid() ? n : null;
};
function fne({
  onChange: e,
  defaultValue: t,
  format: n = "12h",
  disabled: r = !1,
  hasError: o = !1,
  className: a = ""
}) {
  const [i, s] = ue(() => M7(t) ?? ae("12:00", "HH:mm")), [l, c] = ue(""), [d, f] = ue(""), [p, h] = ue("PM"), [g, m] = ue(!0), v = [
    { value: "AM", label: "AM" },
    { value: "PM", label: "PM" }
  ];
  ye(() => {
    const I = M7(t);
    I !== null ? (s(I), w(I), m(!0)) : t !== void 0 && m(!1);
  }, [t]);
  const w = (I) => {
    if (!I.isValid()) {
      m(!1);
      return;
    }
    if (n === "12h") {
      const D = I.format("h"), N = I.format("mm"), A = I.format("A");
      c(D), f(N), h(A);
    } else
      c(I.format("HH")), f(I.format("mm"));
    m(!0);
  }, C = (I) => {
    const D = I.replace(/\D/g, "");
    if (D === "") {
      c(""), m(!1);
      return;
    }
    const N = parseInt(D, 10);
    if (!Lee(N, n)) {
      m(!1);
      return;
    }
    c(D);
    const A = i.clone();
    n === "12h" ? A.hour(p === "PM" ? N === 12 ? 12 : N + 12 : N === 12 ? 0 : N) : A.hour(N), s(A), E(A);
  }, y = (I) => {
    const D = I.replace(/\D/g, "");
    if (D === "") {
      f(""), m(!1);
      return;
    }
    const N = parseInt(D, 10);
    if (!Ree(N)) {
      m(!1);
      return;
    }
    f(D);
    const A = i.clone().minute(N);
    s(A), E(A);
  }, x = (I, D) => {
    if (I !== null) {
      const N = I.value;
      h(N);
      const A = i.clone(), L = A.hour();
      N === "PM" && L < 12 ? A.hour(L + 12) : N === "AM" && L >= 12 && A.hour(L - 12), s(A), E(A);
    }
  }, E = (I) => {
    if (!I.isValid()) {
      m(!1), typeof e == "function" && e(ae.invalid());
      return;
    }
    typeof e == "function" && e(I);
  }, S = () => {
    (!g || l === "" || d === "") && w(i);
  };
  return /* @__PURE__ */ T("div", { className: `tw-flex tw-items-center tw-gap-2 ${a}`, children: [
    /* @__PURE__ */ u("div", { className: "", children: /* @__PURE__ */ u(
      O4,
      {
        id: "hours",
        type: "text",
        className: "tw-w-12 tw-text-center",
        inputClassName: `${o ? "tw-border tw-border-red-500" : ""} tw-text-center`,
        value: l,
        onChange: (I) => {
          C(I.target.value);
        },
        onBlur: S,
        maxLength: 2,
        inputMode: "numeric",
        pattern: "[0-9]*",
        "aria-label": "Hours",
        disabled: r
      }
    ) }),
    /* @__PURE__ */ u("div", { className: "", children: /* @__PURE__ */ u(
      O4,
      {
        id: "minutes",
        type: "text",
        className: "tw-w-12 tw-text-center",
        inputClassName: `${o ? "tw-border tw-border-red-500" : ""} tw-text-center`,
        value: d,
        onChange: (I) => {
          y(I.target.value);
        },
        onBlur: S,
        maxLength: 2,
        inputMode: "numeric",
        pattern: "[0-9]*",
        "aria-label": "Minutes",
        disabled: r
      }
    ) }),
    n === "12h" && /* @__PURE__ */ u("div", { className: "", children: /* @__PURE__ */ u(
      ch,
      {
        value: v.find((I) => I.value === p),
        onChange: x,
        options: v,
        isSearchable: !1,
        className: "tw-w-24",
        isDisabled: r,
        styles: {
          control: (I, D) => ({
            ...I,
            height: "56px",
            width: "fit-content",
            padding: "0px 8px",
            borderRadius: "5px",
            boxShadow: "none",
            outline: D.isFocused ? "2px solid #8fe0c2" : "none",
            outlineOffset: 2,
            border: o ? "1px solid #EF4444" : "1px solid #D1D5DB",
            "&:hover": {
              border: o ? "1px solid #EF4444" : "1px solid #D1D5DB",
              boxShadow: "none"
            },
            backgroundColor: (D.isDisabled, "white"),
            cursor: D.isDisabled ? "not-allowed" : "pointer",
            pointerEvents: D.isDisabled ? "none" : "auto",
            opacity: D.isDisabled ? 0.7 : 1
          }),
          valueContainer: (I) => ({
            ...I,
            height: "36px",
            padding: "0px 8px"
          }),
          dropdownIndicator: (I) => ({
            ...I,
            padding: 0,
            margin: 0
          })
        }
      }
    ) })
  ] });
}
const Vee = Xt(
  "tw-text-normal tw-shadow tw-box-border tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-gap-8px tw-rounded-md !disabled:tw-pointer-events-none disabled:tw-cursor-not-allowed focus-visible:tw-outline-none",
  {
    variants: {
      variant: {
        primary: "tw-bg-brand2-main !tw-text-gray-0 hover:tw-bg-brand2-strong focus-visible:tw-shadow-primary-v2-focus disabled:tw-bg-brand2-bg !disabled:tw-text-gray-0 disabled:tw-shadow-disabled",
        destructive: "tw-bg-red-600 !tw-text-gray-0 hover:tw-bg-red-700 hover:tw-shadow-destructive-v2-hover focus-visible:tw-shadow-destructive-v2-focus disabled:tw-bg-red-200 disabled:tw-pointer-events-none disabled:tw-shadow-none",
        outline: "tw-border tw-border-gray-100 !tw-text-text-body tw-bg-gray-0 focus-visible:tw-shadow-outline-v2-focus disabled:tw-bg-gray-0 hover:tw-bg-gray-5 !disabled:tw-pointer-events-none disabled:tw-text-text-disabled",
        default: "tw-border tw-border-gray-100 tw-bg-gray-0 !tw-text-brand2-main hover:!tw-text-brand2-strong tw-shadow-xs hover:tw-bg-gray-5 focus-visible:tw-shadow-default-v2-focus disabled:tw-bg-gray-0 disabled:tw-text-text-disabled disabled:tw-pointer-events-none",
        ghost: "tw-bg-gray-0 !tw-text-text-body hover:tw-bg-gray-5 disabled:tw-bg-ghost disabled:tw-text-text-disabled disabled:tw-pointer-events-none tw-shadow-none",
        link: "!tw-text-brand2-main tw-underline tw-bg-transparent hover:tw-bg-transparent disabled:tw-bg-transparent disabled:tw-text-text-disabled disabled:tw-pointer-events-none tw-shadow-none"
      },
      size: {
        sm: "!tw-px-8px !tw-py-4px tw-text-sm",
        default: "!tw-px-10px !tw-py-8px tw-text-sm",
        icon: "!tw-p-6px"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), kee = b.forwardRef(
  ({ className: e, variant: t = "primary", size: n = "sm", isLoading: r, asChild: o = !1, ...a }, i) => /* @__PURE__ */ u(o ? ta : "button", { className: P(Vee({ variant: t, size: n }), e), ref: i, ...a, children: /* @__PURE__ */ T(Ee, { children: [
    r === !0 && /* @__PURE__ */ u(xD, { size: 20, color: L7.colors.white, className: "tw-animate-spin" }),
    a.children
  ] }) })
);
kee.displayName = "ButtonV2";
const Fee = b.forwardRef(({ ...e }, t) => /* @__PURE__ */ u("nav", { ref: t, "aria-label": "breadcrumb", ...e }));
Fee.displayName = "Breadcrumb";
const Hee = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "ol",
    {
      ref: n,
      className: P(
        "tw-flex tw-flex-wrap tw-items-center tw-gap-1.5 tw-break-words tw-text-base tw-leading-5 tw-text-grayscale-text-subtitle sm:tw-gap-1.5",
        e
      ),
      ...t
    }
  )
);
Hee.displayName = "BreadcrumbList";
const Bee = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u("li", { ref: n, className: P("tw-inline-flex tw-items-center tw-gap-1.5", e), ...t })
);
Bee.displayName = "BreadcrumbItem";
const Gee = b.forwardRef(({ asChild: e, className: t, ...n }, r) => /* @__PURE__ */ u(
  e ? ta : "a",
  {
    ref: r,
    className: P(
      "tw-transition-colors tw-text-base tw-leading-5  hover:!tw-text-brand2-strong tw-no-underline tw-decoration-none tw-cursor-pointer",
      t
    ),
    style: {
      color: "#19846C"
    },
    ...n
  }
));
Gee.displayName = "BreadcrumbLink";
const Wee = b.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ u(
    "span",
    {
      ref: n,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: P("tw-font-normal tw-text-grayscale-text-subtitle", e),
      ...t
    }
  )
);
Wee.displayName = "BreadcrumbPage";
const Zee = ({ children: e, className: t, ...n }) => /* @__PURE__ */ u("li", { role: "presentation", "aria-hidden": "true", className: P("[&>svg]:tw-w-5 [&>svg]:tw-h-5", t), ...n, children: e ?? /* @__PURE__ */ u(hc, { className: "tw-w-5 tw-h-5 tw-text-black tw-stroke-[1.5]" }) });
Zee.displayName = "BreadcrumbSeparator";
const $ee = ({ className: e, ...t }) => /* @__PURE__ */ T(
  "span",
  {
    role: "presentation",
    "aria-hidden": "true",
    className: P("tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ u(gD, { className: "tw-h-4 tw-w-4" }),
      /* @__PURE__ */ u("span", { className: "tw-sr-only", children: "More" })
    ]
  }
);
$ee.displayName = "BreadcrumbElipssis";
const Yee = ({
  tag: e,
  index: t,
  isDragging: n,
  isDragOver: r,
  dragOverPosition: o,
  onDragStart: a,
  onDragEnd: i,
  onDragOver: s,
  onDragLeave: l,
  onDrop: c,
  onDelete: d
}) => {
  const f = le(null), p = (w) => {
    var C, y, x;
    if (w.dataTransfer) {
      const E = (C = f.current) == null ? void 0 : C.cloneNode(!0);
      if (E) {
        E.style.position = "absolute", E.style.top = "-1000px";
        const S = ((y = f.current) == null ? void 0 : y.offsetWidth) ?? 0, I = ((x = f.current) == null ? void 0 : x.offsetHeight) ?? 0;
        E.style.width = `${S}px`, E.style.height = `${I}px`, document.body.appendChild(E), w.dataTransfer.setDragImage(E, 20, 20), requestAnimationFrame(() => {
          document.body.removeChild(E);
        });
      }
      w.dataTransfer.effectAllowed = "move", w.dataTransfer.setData("application/json", JSON.stringify({ index: t }));
    }
    a(w, t);
  }, h = (w) => {
    w.preventDefault(), w.stopPropagation(), s(w, t);
  }, g = (w) => {
    w.preventDefault(), w.stopPropagation(), l(w, t);
  }, m = (w) => {
    w.preventDefault(), w.stopPropagation(), c(w, t);
  }, v = (w) => {
    w.preventDefault(), w.stopPropagation(), d == null || d(e.id);
  };
  return /* @__PURE__ */ T(
    "div",
    {
      ref: f,
      draggable: !0,
      onDragStart: p,
      onDragEnd: i,
      onDragOver: h,
      onDragLeave: g,
      onDrop: m,
      className: P(
        "tw-relative tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-1 tw-bg-gray-5 tw-rounded-lg tw-border tw-border-gray-100",
        "tw-text-sm tw-font-medium tw-text-gray-700",
        "tw-select-none tw-cursor-grab active:tw-cursor-grabbing",
        "tw-transition-all tw-duration-200 tw-ease-in-out",
        "hover:tw-border-gray-200 hover:tw-bg-gray-50/50",
        n && "tw-opacity-50 tw-scale-95 tw-shadow-lg",
        r && o === "before" && "tw-mr-8",
        r && o === "after" && "tw-ml-8",
        r && "tw-border-gray-200 tw-bg-gray-50/80",
        "tw-border-gray-200"
      ),
      style: {
        touchAction: "none",
        transform: n ? "scale(0.95)" : "none",
        transition: "all 0.2s ease-in-out"
      },
      children: [
        /* @__PURE__ */ u(l8, { className: "tw-w-4 tw-h-4 tw-text-text-body tw-cursor-grab active:tw-cursor-grabbing" }),
        /* @__PURE__ */ u("span", { className: "tw-text-sm tw-font-normal tw-flex-1 tw-text-text-body tw-leading-5", children: e.label }),
        d && /* @__PURE__ */ u(
          "button",
          {
            onClick: v,
            className: "tw-p-0.5 tw-w-5 tw-h-5 tw-rounded-full tw-flex tw-items-center hover:tw-bg-gray-100 tw-transition-colors tw-duration-200",
            title: "Delete tag",
            children: /* @__PURE__ */ u(rt, { className: "tw-w-4 tw-h-4 tw-text-text-body " })
          }
        )
      ]
    }
  );
}, pne = ({
  tags: e,
  onOrderChange: t,
  onDelete: n,
  className: r
}) => {
  const [o, a] = ue(e), [i, s] = ue(null), [l, c] = ue(null), [d, f] = ue(null), p = le(null);
  ye(() => {
    a(e);
  }, [e]);
  const h = (C, y) => {
    s(y);
  }, g = () => {
    s(null), c(null), f(null);
  }, m = (C, y) => {
    var x;
    if (C.preventDefault(), C.stopPropagation(), !(i === null || i === y))
      try {
        if (JSON.parse(((x = C.dataTransfer) == null ? void 0 : x.getData("application/json")) || "{}").index === y)
          return;
        const I = C.currentTarget.getBoundingClientRect(), D = I.left + I.width / 2, N = C.clientX < D ? "before" : "after";
        (l !== y || d !== N) && (c(y), f(N));
      } catch (E) {
        console.error("Error parsing drag data:", E);
      }
  }, v = (C, y) => {
    C.preventDefault(), C.stopPropagation(), y === l && (c(null), f(null));
  }, w = (C, y) => {
    var x;
    C.preventDefault(), C.stopPropagation();
    try {
      const S = JSON.parse(((x = C.dataTransfer) == null ? void 0 : x.getData("application/json")) || "{}").index;
      if (S === void 0 || S === y)
        return;
      const I = Array.from(o), [D] = I.splice(S, 1), N = d === "after" ? y + 1 : y;
      I.splice(N, 0, D), a(I), t == null || t(I);
    } catch (E) {
      console.error("Error handling drop:", E);
    } finally {
      s(null), c(null), f(null);
    }
  };
  return /* @__PURE__ */ u(
    "div",
    {
      ref: p,
      className: P(
        "tw-relative tw-p-2 tw-bg-gray-50/50 tw-rounded-lg tw-border tw-border-gray-100",
        "tw-min-h-[80px] tw-w-full",
        "tw-transition-colors tw-duration-200",
        l !== null && "tw-bg-gray-50/50 tw-border-gray-200",
        r
      ),
      onDragOver: (C) => {
        C.preventDefault();
      },
      onDrop: (C) => {
        C.preventDefault();
      },
      children: /* @__PURE__ */ u("div", { className: "tw-flex tw-flex-wrap tw-gap-1.5", children: o.map((C, y) => /* @__PURE__ */ u(
        Yee,
        {
          tag: C,
          index: y,
          isDragging: y === i,
          isDragOver: y === l,
          dragOverPosition: y === l ? d : null,
          onDragStart: h,
          onDragEnd: g,
          onDragOver: m,
          onDragLeave: v,
          onDrop: w,
          onDelete: n
        },
        C.id
      )) })
    }
  );
}, hne = () => /* @__PURE__ */ u("div", { children: "Banner" }), jee = jb, zee = zb, xy = b.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ u(Xb, { children: /* @__PURE__ */ u(
  Su,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: P(
      "tw-z-50 tw-w-72 tw-rounded-md tw-border tw-bg-popover tw-p-4 tw-text-popover-foreground tw-shadow-md tw-outline-none data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
      e
    ),
    ...r
  }
) }));
xy.displayName = Su.displayName;
const Xee = "_content_2kj0r_1", Uee = {
  content: Xee
};
function mne({
  options: e,
  placeholder: t,
  noOptionText: n,
  isDisabled: r,
  onChange: o,
  value: a,
  error: i,
  smallerVariant: s,
  selectButtonClassName: l,
  helperText: c,
  allowClear: d,
  onClear: f,
  selectContentClassName: p,
  popoverContentClassName: h,
  searchPlaceholder: g
}) {
  var I, D, N;
  const [m, v] = b.useState(!1), [w, C] = b.useState(a), [y, x] = b.useState(""), E = (A, L) => A.label.toLowerCase().includes(L.toLowerCase()), S = (A) => {
    var L, F;
    C(A === w ? "" : A), o == null || o(((F = (L = e.find(({ value: k }) => k === A)) == null ? void 0 : L.value) == null ? void 0 : F.toString()) ?? null), v(!1), x("");
  };
  return /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-start tw-gap-8px", children: [
    /* @__PURE__ */ T(jee, { open: m, onOpenChange: v, children: [
      /* @__PURE__ */ u(zee, { asChild: !0, children: /* @__PURE__ */ T(
        Rb,
        {
          variant: "outline",
          role: "combobox",
          "aria-expanded": m,
          className: P(
            "tw-w-[300px] tw-h-[56px] tw-justify-between tw-px-3 !tw-text-normal tw-py-2 tw-text-grayscale-text-body hover:tw-bg-white",
            i && "tw-border-errorRed",
            s && "tw-w-[120px]",
            l
          ),
          disabled: r,
          children: [
            w ? /* @__PURE__ */ T("div", { className: "tw-flex tw-justify-start tw-items-center", children: [
              ((I = e.find((A) => A.value === w)) == null ? void 0 : I.icon) && /* @__PURE__ */ u("span", { className: "tw-mr-2 tw-h-5 tw-w-5 tw-flex tw-items-center tw-justify-center", children: (D = e.find((A) => A.value === w)) == null ? void 0 : D.icon }),
              (N = e.find((A) => A.value === w)) == null ? void 0 : N.label
            ] }) : t,
            w && d && !r ? /* @__PURE__ */ u(
              rt,
              {
                className: "tw-h-6 tw-w-6 tw-opacity-50 !tw-text-grayscale-text-label",
                onPointerDown: (A) => {
                  A.stopPropagation(), o == null || o(null), C(""), f == null || f();
                }
              }
            ) : s ? /* @__PURE__ */ u(qn, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" }) : /* @__PURE__ */ u(la, { className: "tw-h-6 tw-w-6 tw-opacity-50 tw-text-grayscale-text-label" })
          ]
        }
      ) }),
      /* @__PURE__ */ u(
        xy,
        {
          className: P(Uee.content, h, "tw-p-0 tw-w-full", s && "tw-w-[120px]"),
          children: /* @__PURE__ */ T(
            K2,
            {
              className: P("tw-max-w", s && "tw-w-[120px]", p),
              shouldFilter: !1,
              autoFocus: !1,
              children: [
                /* @__PURE__ */ u(
                  Rm,
                  {
                    placeholder: g ?? t,
                    className: "!tw-text-normal",
                    onValueChange: (A) => {
                      x(A);
                    }
                  }
                ),
                /* @__PURE__ */ T(q2, { className: "tw-max-h-64 tw-overflow-y-auto tw-overflow-x-hidden", children: [
                  /* @__PURE__ */ u(Q2, { children: /* @__PURE__ */ u("div", { className: "!tw-py-12px tw-text-center", role: "presentation", children: /* @__PURE__ */ u(De, { variant: "label", lineHeight: "20px", children: n ?? "No option" }) }) }),
                  /* @__PURE__ */ u(Vm, { className: "tw-text-grayscale-text-body tw-text-left", children: e.filter((A) => E(A, y)).map((A) => /* @__PURE__ */ T(
                    e3,
                    {
                      value: A.value.toString(),
                      className: P(
                        "data-[highlighted]:tw-bg-grayscale-surface-light tw-text-grayscale-text-body tw-overflow-x-hidden tw-text-ellipsis",
                        "tw-py-12px tw-pr-2",
                        !e.map((L) => L.value).includes(A.value) && "tw-hidden",
                        A.isHidden && "tw-hidden"
                      ),
                      onSelect: () => {
                        S(A.value);
                      },
                      disabled: A.isDisabled,
                      children: [
                        A.icon ? /* @__PURE__ */ u("span", { className: "tw-mr-2 tw-h-5 tw-w-5 tw-flex tw-items-center tw-justify-center", children: A.icon }) : /* @__PURE__ */ u(
                          sa,
                          {
                            className: P(
                              "tw-mr-2 tw-h-4 tw-w-4",
                              w === A.value ? "tw-opacity-100" : "tw-opacity-0"
                            )
                          }
                        ),
                        A.label
                      ]
                    },
                    A.value
                  )) })
                ] })
              ]
            }
          )
        }
      )
    ] }),
    i ? /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasError: !0, variant: "normal", children: i }) : c && /* @__PURE__ */ u(De, { lineHeight: "19.2px", hasHelperText: !0, variant: "normal", children: c })
  ] });
}
function vne({
  dateRange: e,
  setDateRange: t
}) {
  const [n, r] = X.useState(e), [o, a] = X.useState(!1);
  return ye(() => {
    t(n);
  }, [n]), /* @__PURE__ */ u(
    N0,
    {
      initialFocus: !0,
      mode: "range",
      selected: n,
      onSelect: (i) => {
        if (!o && i != null && n != null && n.from != null && n.to != null && i.to != null && i.from != null) {
          if (n.from.getTime() === i.from.getTime()) {
            r({ ...i, from: i.to, to: ae(i.to).add(1, "days").toDate() }), a(!0);
            return;
          }
          if (n.to.getTime() === i.to.getTime()) {
            r({ ...i, from: i.from, to: ae(i.from).add(1, "days").toDate() }), a(!0);
            return;
          }
        }
        r(i), a(!1);
      },
      numberOfMonths: 2
    }
  );
}
const Jee = {
  producing: {
    solid: {
      container: "tw-bg-brand2-originalBrandDarker",
      status: "tw-bg-brand2-originalBrandDarker",
      shiftBadge: "tw-bg-brand2-originalBrand tw-text-white",
      text: "tw-text-white"
    },
    light: {
      container: "tw-bg-brand2-originalBrandBackground",
      status: "tw-bg-brand2-originalBrandDarker",
      shiftBadge: "tw-bg-brand2-originalBrandDarker tw-text-white",
      text: "tw-text-white"
    }
  },
  stopped: {
    solid: {
      container: "tw-bg-status-stopped-1000",
      status: "tw-bg-status-stopped-1000",
      shiftBadge: "tw-bg-gray-900 tw-text-status-stopped-1000",
      text: "tw-text-gray-900"
    },
    light: {
      container: "tw-bg-status-stopped-20",
      status: "tw-bg-status-stopped-1000",
      shiftBadge: "tw-text-gray-900 tw-bg-status-stopped-1000",
      text: "tw-text-gray-900"
    }
  },
  alert: {
    solid: {
      container: "tw-bg-status-alert-1000",
      status: "tw-bg-status-alert-1000",
      shiftBadge: "tw-bg-gray-900 tw-text-white",
      text: "tw-text-white"
    },
    light: {
      container: "tw-bg-status-alert-20",
      status: "tw-bg-status-alert-1000",
      shiftBadge: "tw-text-white tw-bg-status-alert-1000",
      text: "tw-text-white"
    }
  },
  no_data: {
    solid: {
      container: "tw-bg-status-no_data-1000",
      status: "tw-bg-status-no_data-1000",
      shiftBadge: "tw-bg-gray-900 tw-text-status-no_data-20",
      text: "tw-text-gray-900"
    },
    light: {
      container: "tw-bg-status-no_data-20",
      status: "tw-bg-status-no_data-1000",
      shiftBadge: "tw-gray-900 tw-bg-status-no_data-1000",
      text: "tw-text-gray-900"
    }
  },
  out_of_shift: {
    solid: {
      container: "tw-bg-status-out_of_shift-1000",
      status: "tw-bg-status-out_of_shift-1000",
      shiftBadge: "tw-bg-gray-900 tw-text-white",
      text: "tw-text-white"
    },
    light: {
      container: "tw-bg-status-out_of_shift-20",
      status: "tw-bg-status-out_of_shift-1000",
      shiftBadge: "tw-bg-status-out_of_shift-1000 tw-text-white",
      text: "tw-text-white"
    }
  }
}, Kee = (e) => {
  switch (e) {
    case "producing":
      return fD;
    case "stopped":
      return uD;
    case "alert":
      return lD;
    case "no_data":
      return hD;
    case "out_of_shift":
      return OD;
    default:
      return s8;
  }
}, gne = ({
  machineName: e,
  status: t,
  timeText: n,
  statusText: r,
  variant: o = "light",
  size: a = "small",
  machineNameClassName: i,
  statusContainerClassName: s,
  iconClassName: l,
  shiftName: c,
  shiftNameClassName: d,
  toolTipText: f,
  tooltipContent: p,
  className: h,
  tooltipContentClassName: g,
  tooltipDelayDuration: m = 500,
  tooltipTextClassName: v,
  timeTextClassName: w,
  statusTextClassName: C
}) => {
  const y = Jee[t][o];
  return /* @__PURE__ */ T(
    "div",
    {
      className: P(
        y.container,
        "tw-pl-4 tw-flex tw-justify-between tw-items-stretch tw-rounded-bl-none tw-rounded-br-none tw-rounded-tl tw-rounded-tr tw-w-full tw-h-full",
        h
      ),
      children: [
        /* @__PURE__ */ T("div", { className: "tw-flex tw-gap-4 tw-items-center tw-w-full", children: [
          /* @__PURE__ */ u(
            "h3",
            {
              className: P(
                "tw-font-semibold tw-text-nowrap tw-text-ellipsis tw-overflow-hidden tw-my-auto tw-text-gray-900",
                i,
                a === "small" && "tw-text-base tw-leading-5 tw-py-2 tw-max-w-[40%]",
                a === "medium" && "tw-text-xl tw-leading-6 tw-py-2.5 tw-max-w-[45%]",
                a === "large" && "tw-text-4xl tw-leading-9 tw-py-4 tw-max-w-[50%]",
                a === "xlarge" && "tw-text-5xl tw-leading-10 tw-py-5 tw-max-w-[55%]"
              ),
              children: e
            }
          ),
          c != null && c !== "" && /* @__PURE__ */ u(
            "p",
            {
              className: P(
                "tw-mr-2 tw-font-medium tw-text-nowrap tw-text-ellipsis tw-overflow-hidden tw-rounded-full tw-border-0 tw-p-2 tw-py-0.5",
                y.shiftBadge,
                d,
                a === "small" && "tw-text-xs",
                a === "medium" && "tw-text-sm",
                a === "large" && "tw-text-base",
                a === "xlarge" && "tw-text-lg"
              ),
              children: c
            }
          )
        ] }),
        /* @__PURE__ */ u(XZ, { children: /* @__PURE__ */ T(UZ, { delayDuration: m, children: [
          /* @__PURE__ */ u(JZ, { asChild: !0, className: "tw-cursor-pointer", children: /* @__PURE__ */ T(
            "div",
            {
              className: P(
                "tw-flex tw-items-center tw-gap-2 tw-px-4 tw-rounded-none tw-rounded-tr tw-rounded-br-none tw-rounded-bl-2xl tw-text-nowrap tw-text-ellipsis tw-overflow-hidden tw-min-w-fit",
                s,
                y.status
              ),
              children: [
                /* @__PURE__ */ u(
                  "div",
                  {
                    className: P(
                      "tw-flex tw-items-center tw-justify-center",
                      a === "small" && "tw-h-4 tw-w-4 tw-min-w-4",
                      a === "medium" && "tw-h-5 tw-w-5 tw-min-w-5",
                      a === "large" && "tw-h-6 tw-w-6 tw-min-w-6",
                      a === "xlarge" && "tw-h-8 tw-w-8 tw-min-w-8"
                    ),
                    children: X.createElement(Kee(t), {
                      className: P("tw-w-full tw-h-full", y.text, l)
                    })
                  }
                ),
                /* @__PURE__ */ T(
                  "div",
                  {
                    className: P(
                      "tw-flex tw-items-center tw-gap-2 tw-font-semibold tw-min-w-fit",
                      a === "small" && "tw-text-sm",
                      a === "medium" && "tw-text-lg",
                      a === "large" && "tw-text-xl",
                      a === "xlarge" && "tw-text-2xl",
                      y.text,
                      w
                    ),
                    children: [
                      n != null && n !== "" && /* @__PURE__ */ T(Ee, { children: [
                        /* @__PURE__ */ u("span", { children: n }),
                        /* @__PURE__ */ u("span", { children: "|" })
                      ] }),
                      /* @__PURE__ */ u("span", { className: P(y.text, C), children: r })
                    ]
                  }
                )
              ]
            }
          ) }),
          /* @__PURE__ */ u(mb, { className: P(g), sideOffset: 10, children: f != null ? /* @__PURE__ */ u("p", { className: v, children: f }) : p })
        ] }) })
      ]
    }
  );
}, wne = ({ value: e, label: t, subLabel: n, className: r, separator: o }) => /* @__PURE__ */ T(
  "div",
  {
    className: P(
      "tw-py-2 tw-px-4 tw-flex tw-gap-2 tw-flex-col tw-min-w-fit tw-justify-center",
      {
        "tw-border-gray-100 tw-border-l": o
      },
      r
    ),
    children: [
      /* @__PURE__ */ T("div", { className: "tw-flex tw-items-baseline tw-gap-1", children: [
        /* @__PURE__ */ u("p", { className: "tw-text-xl tw-font-medium tw-text-title-main", children: e }),
        n != null && /* @__PURE__ */ u("span", { className: "tw-text-sm tw-text-title-main", children: n })
      ] }),
      /* @__PURE__ */ u("p", { className: "tw-text-gray-500 tw-text-xs tw-uppercase", children: t })
    ]
  }
), bne = ({ icon: e, label: t, className: n }) => /* @__PURE__ */ T(
  "div",
  {
    className: P(
      "tw-flex tw-items-center tw-gap-2.5 tw-rounded tw-bg-gray-50 tw-text-sm tw-text-title-main tw-max-w-fit tw-font-normal tw-px-2 tw-py-1",
      n
    ),
    children: [
      e,
      /* @__PURE__ */ u("span", { className: "tw-text-title-main tw-text-sm tw-font-normal", children: t })
    ]
  }
), Cne = ({ count: e, label: t, color: n, className: r }) => /* @__PURE__ */ u(Aee, { className: P("tw-min-w-fit tw-max-w-xs", r), children: /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-start tw-gap-2", children: [
  /* @__PURE__ */ T("div", { className: "tw-flex tw-items-center tw-gap-2", children: [
    /* @__PURE__ */ u("div", { className: P("tw-h-3 tw-w-3 tw-rounded-full tw-self-center", n) }),
    /* @__PURE__ */ u("h3", { className: "tw-text-xl tw-font-medium tw-text-title-main", children: e })
  ] }),
  /* @__PURE__ */ u("p", { className: "tw-text-gray-500 tw-text-xs tw-uppercase", children: t })
] }) }), qee = xc, Qee = KA, ete = Ec, Ey = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  oo,
  {
    ref: n,
    className: P(
      "tw-fixed tw-inset-0 tw-z-50 tw-bg-modal-bg data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0",
      e
    ),
    ...t
  }
));
Ey.displayName = oo.displayName;
const Iy = b.forwardRef(({ className: e, children: t, hideCloseButton: n, ...r }, o) => /* @__PURE__ */ T(ete, { children: [
  /* @__PURE__ */ u(Ey, {}),
  /* @__PURE__ */ T(
    ao,
    {
      ref: o,
      className: P(
        "tw-fixed tw-left-[50%] tw-top-[50%] tw-z-50 tw-grid tw-w-full tw-max-w-7xl tw-translate-x-[-50%] tw-translate-y-[-50%] tw-gap-6 tw-border tw-bg-background tw-p-6 tw-shadow-modal tw-duration-200 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95 data-[state=closed]:tw-slide-out-to-left-1/2 data-[state=closed]:tw-slide-out-to-top-[48%] data-[state=open]:tw-slide-in-from-left-1/2 data-[state=open]:tw-slide-in-from-top-[48%] tw-rounded-lg",
        e
      ),
      ...r,
      children: [
        t,
        !(n ?? !1) && /* @__PURE__ */ T(Lh, { className: "tw-absolute tw-right-4 tw-top-6 tw-rounded-sm tw-opacity-70 tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none data-[state=open]:tw-bg-accent data-[state=open]:tw-text-muted-foreground", children: [
          /* @__PURE__ */ u(rt, { className: "tw-h-6 tw-w-6 tw-text-title-main" }),
          /* @__PURE__ */ u("span", { className: "tw-sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Iy.displayName = ao.displayName;
const Sy = ({ className: e, ...t }) => /* @__PURE__ */ u("div", { className: P("tw-flex tw-flex-col tw-space-y-1.5 tw-text-center sm:tw-text-left", e), ...t });
Sy.displayName = "ModalHeader";
const Dy = ({ className: e, ...t }) => /* @__PURE__ */ u(
  "div",
  {
    className: P("tw-flex tw-flex-col-reverse sm:tw-flex-row sm:tw-justify-end sm:tw-space-x-2", e),
    ...t
  }
);
Dy.displayName = "ModalFooter";
const My = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  da,
  {
    ref: n,
    className: P("!tw-text-xl tw-font-semibold tw-text-title-main tw-leading-none tw-tracking-tight", e),
    ...t
  }
));
My.displayName = da.displayName;
const Ny = b.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(fa, { ref: n, className: P("tw-text-sm tw-text-muted-foreground", e), ...t }));
Ny.displayName = fa.displayName;
const tte = {
  sm: "sm:tw-max-w-[384px]",
  md: "sm:tw-max-w-[512px]",
  lg: "sm:tw-max-w-[640px]",
  xl: "sm:tw-max-w-[768px]",
  "2xl": "sm:tw-max-w-[896px]",
  "3xl": "sm:tw-max-w-[1024px]",
  full: "sm:tw-max-w-[calc(100vw-32px)]"
}, nte = ({ children: e, ...t }) => /* @__PURE__ */ u(qee, { ...t, children: e }), rte = Qee, ote = ({ children: e, className: t, size: n = "md", hideCloseButton: r }) => /* @__PURE__ */ u(
  Iy,
  {
    className: P("w-[95vw]", "max-h-[85vh]", "overflow-y-auto", tte[n], t),
    hideCloseButton: r,
    children: e
  }
), ate = ({ children: e, className: t }) => /* @__PURE__ */ u(Sy, { className: t, children: e }), ite = My, ste = Ny, lte = ({ children: e, className: t }) => /* @__PURE__ */ u(Dy, { className: t, children: e }), yne = {
  Root: nte,
  Trigger: rte,
  Content: ote,
  Header: ate,
  Title: ite,
  Description: ste,
  Footer: lte
}, xne = ({
  title: e,
  subTitle: t,
  className: n,
  icon: r,
  titleClassName: o,
  subTitleClassName: a,
  iconClassName: i
}) => /* @__PURE__ */ T(
  "div",
  {
    className: P(
      "tw-p-4 tw-flex tw-gap-4 tw-min-w-fit tw-w-96 tw-justify-start tw-items-center tw-rounded-md tw-shadow-md tw-bg-white tw-border-gray-100 tw-border",
      n
    ),
    children: [
      r != null && /* @__PURE__ */ u("div", { className: P("tw-w-10 tw-h-10", i), children: r }),
      /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col tw-items-baseline tw-gap-1", children: [
        /* @__PURE__ */ u("p", { className: P("tw-text-xl tw-font-semibold tw-text-title-main", o), children: e }),
        /* @__PURE__ */ u("p", { className: P("tw-text-gray-600 tw-text-xl tw-font-normal tw-leading-8", a), children: t })
      ] })
    ]
  }
), Ene = () => /* @__PURE__ */ u("div", { children: "Footer" });
function N7({ className: e, fill: t, width: n, height: r, name: o }) {
  return o === "small" ? /* @__PURE__ */ u("div", { className: "tw-pl-2", children: /* @__PURE__ */ T("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", fill: "none", viewBox: "0 0 40 40", children: [
    /* @__PURE__ */ u("g", { fill: "#5EAF91", clipPath: "url(#clip0_319_26095)", children: /* @__PURE__ */ u("path", { d: "M26.62 23.555c-.171-1.05-.055-1.889.433-2.826 2.09-4.009 3.44-8.195 2.674-12.81-.277-1.337-.708-2.317-1.323-2.69-.607-.388-1.677-.341-2.999.001-4.479 1.352-7.638 4.413-10.31 8.06-.625.852-1.327 1.327-2.343 1.637-3.064.937-4.431 3.502-5.491 6.23-.413 1.062.617.872 1.15.885a15.966 15.966 0 018.032 2.411 15.966 15.966 0 015.712 6.14c.248.473.532 1.48 1.303.64 1.978-2.156 3.676-4.516 3.162-7.678zm-5.673-6.341a2.57 2.57 0 112.715-4.364 2.57 2.57 0 01-2.715 4.364zM15.646 27.625a9.972 9.972 0 00-1.696-1.055.086.086 0 00-.11.032l-4.93 7.925a1.075 1.075 0 00.407 1.516c.505.27 1.136.075 1.438-.412l4.91-7.893a.086.086 0 00-.02-.113zM12.56 26.014a9.834 9.834 0 00-2.092-.415.086.086 0 00-.08.04l-2.193 3.524a1.075 1.075 0 00.407 1.516c.505.27 1.136.074 1.438-.412l2.567-4.126a.086.086 0 00-.046-.127zM18.056 30.32a9.835 9.835 0 00-1.298-1.694.086.086 0 00-.134.014l-2.587 4.157a1.075 1.075 0 00.407 1.517c.505.27 1.136.074 1.438-.413l2.173-3.492a.086.086 0 000-.09z" }) }),
    /* @__PURE__ */ u("defs", { children: /* @__PURE__ */ u("clipPath", { id: "clip0_319_26095", children: /* @__PURE__ */ u("path", { fill: "#fff", d: "M0 0H40V40H0z" }) }) })
  ] }) }) : /* @__PURE__ */ u("svg", { xmlns: "http://www.w3.org/2000/svg", width: "125", height: "18", fill: "none", viewBox: "0 0 125 18", children: /* @__PURE__ */ u(
    "path",
    {
      fill: "#374151",
      d: "M120.369 11.991c1.114-.479 1.972-1.167 2.576-2.07.604-.901.908-1.975.908-3.218 0-1.243-.3-2.322-.895-3.23-.597-.91-1.447-1.61-2.552-2.105-1.104-.495-2.407-.74-3.907-.74h-7.329v16.75h3.919V12.71h3.603l3.265 4.666h4.21l-3.798-5.385zm-1.404-3.135c-.613.51-1.507.766-2.685.766h-3.193V3.784h3.193c1.175 0 2.072.25 2.685.754.614.502.92 1.225.92 2.167 0 .924-.306 1.642-.92 2.15zM33.6 9.861c0 1.549-.323 2.684-.969 3.41-.645.725-1.581 1.087-2.805 1.087-2.516 0-3.774-1.498-3.774-4.5V.626h-3.92v9.38c0 2.456.674 4.347 2.02 5.672 1.346 1.325 3.23 1.986 5.648 1.986 2.419 0 4.302-.661 5.649-1.986 1.346-1.325 2.02-3.214 2.02-5.672V.625h-3.872V9.86h.003zM50.098.625h-3.92v16.75h12.41v-3.158h-8.49V.625zM75.28 8.376c-.823-.303-1.88-.606-3.168-.91-1.243-.271-2.165-.547-2.769-.825-.604-.279-.908-.707-.908-1.28 0-.572.26-1.037.786-1.389.523-.35 1.335-.526 2.43-.526 1.563 0 3.128.44 4.694 1.315l1.21-2.944c-.775-.479-1.678-.846-2.709-1.101a13.409 13.409 0 00-3.17-.379c-1.547 0-2.859.23-3.93.693-1.073.463-1.875 1.088-2.407 1.88a4.622 4.622 0 00-.798 2.643c0 1.117.295 2.009.883 2.68a5.138 5.138 0 002.116 1.46c.823.302 1.88.606 3.168.909.84.192 1.503.367 1.996.527.492.16.895.372 1.21.634.314.262.473.595.473.992 0 .543-.265.978-.797 1.304-.533.327-1.356.49-2.467.49-1 0-1.999-.159-3-.478-1-.32-1.862-.741-2.589-1.268l-1.33 2.919c.759.575 1.762 1.04 3.011 1.4a14.02 14.02 0 003.882.538c1.55 0 2.864-.232 3.943-.693 1.081-.463 1.89-1.088 2.43-1.879.54-.791.811-1.663.811-2.62 0-1.118-.295-2.003-.883-2.657a5.281 5.281 0 00-2.118-1.435zM91.139.625l-7.548 16.75h4.016L93.05 4.43l5.418 12.947h4.113L95.01.625h-3.871zM11.237 1.366C10.132.87 8.83.625 7.329.625H0v16.75h3.92V3.784h3.192c1.176 0 2.073.251 2.686.755s.92 1.225.92 2.167c0 .926-.307 1.64-.92 2.141-.613.502-1.508.753-2.686.753h-.627v3.158h.846c1.501 0 2.801-.244 3.908-.73 1.104-.485 1.955-1.188 2.552-2.104.597-.917.895-1.991.895-3.218 0-1.245-.3-2.322-.895-3.23-.6-.912-1.45-1.614-2.554-2.11z"
    }
  ) });
}
function cte(e) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: _t(e.className),
      onClick: () => {
        e.onClick();
      },
      children: e.isCollapse ? /* @__PURE__ */ u(qn, { size: 20, color: "#374151" }) : /* @__PURE__ */ u(mc, { size: 20, color: "#374151" })
    }
  );
}
function P7({
  option: e,
  optionIndex: t,
  isMenuCollapse: n,
  isExpandedOption: r,
  selectedOptionId: o,
  isNewText: a,
  onOptionSelect: i,
  setExpandIndex: s,
  onOptionExpanded: l,
  onClick: c
}) {
  const d = ({ to: f, externalLink: p, children: h, className: g, onClick: m, activeClassName: v }) => p ? /* @__PURE__ */ u(
    "a",
    {
      href: f,
      onClick: () => {
        m && m();
      },
      className: g,
      target: "_blank",
      rel: "noreferrer",
      children: h
    }
  ) : /* @__PURE__ */ u("div", { className: _t(g), onClick: m, children: h });
  return /* @__PURE__ */ T(Ee, { children: [
    /* @__PURE__ */ T(
      d,
      {
        to: e.to,
        externalLink: e.externalLink,
        className: _t(
          "tw-cursor-pointer tw-flex tw-items-center tw-relative tw-p-[8px] tw-gap-3 tw-self-stretch hover:tw-bg-[#F3F4F6] tw-rounded",
          o === e.id && "tw-bg-secondary tw-rounded"
        ),
        activeClassName: "tw-bg-secondary tw-rounded",
        onClick: () => {
          if (c != null && c(), e.options != null && e.options.length > 0) {
            s(r ? null : t), r || l(t);
            return;
          }
          i != null && (e.options == null || e.options.length === 0) && i(e.id, t, void 0), e.onSelected != null && e.onSelected();
        },
        children: [
          /* @__PURE__ */ u("div", { className: "", children: e.icon }),
          !n && /* @__PURE__ */ T(Ee, { children: [
            /* @__PURE__ */ u(
              "div",
              {
                className: "tw-font-sans tw-text-base tw-font-normal tw-text-body tw-tracking-wider tw-leading-normal",
                children: e.label
              }
            ),
            e.options != null && e.options.length > 0 && /* @__PURE__ */ u(cte, { onClick: () => {
            }, isCollapse: !r, className: "tw-ml-auto" })
          ] })
        ]
      }
    ),
    r && !n && /* @__PURE__ */ u("div", { className: "tw-h-52 tw-overflow-y-scroll", children: e.options.map((f, p) => /* @__PURE__ */ u(
      d,
      {
        to: f.to,
        externalLink: f.externalLink,
        className: _t(
          "tw-rounded tw-flex tw-relative tw-h-10 tw-items-center tw-pl-2",
          "tw-ml-5 tw-border-b-0 tw-h-8",
          o === f.id && "tw-bg-secondary",
          "hover:tw-bg-[#F3F4F6] "
        ),
        onClick: () => {
          c != null && c(), i != null && i(f.id, t, p), f.onSelected != null && f.onSelected();
        },
        activeClassName: "tw-bg-secondary",
        children: /* @__PURE__ */ u("div", { className: _t("tw-font-sans tw-text-sm tw-text-body tw-tracking-wider"), children: f.label })
      },
      `sub-option-${f.id}`
    )) }, `sub-option-list-${e.id}`)
  ] });
}
function ute(e, t) {
  ye(() => {
    function n(r) {
      e.current && !e.current.contains(r.target) && t();
    }
    return document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [e, t]);
}
function dte({ active: e, className: t, ...n }) {
  return /* @__PURE__ */ u("div", { className: _t(t), ...n, children: /* @__PURE__ */ u(PD, { color: "#000000", strokeWidth: 1.5, size: 24 }) });
}
function Ine(e) {
  var p;
  const [t, n] = ue(null), [r, o] = ue(!1), [a, i] = ue(!0), s = le(null), l = le(null);
  ye(() => {
    e.avoidCollapse && r && o(!1);
  }, [e.avoidCollapse]);
  const c = Ve(() => {
    !e.avoidCollapse && !a && o(!0);
  }, [e.avoidCollapse, a]);
  ute(s, c);
  const d = (h) => {
    setTimeout(() => {
      (l == null ? void 0 : l.current).scroll({
        top: h * 40,
        behavior: "smooth"
      });
    }, 5);
  }, f = !a && r;
  return /* @__PURE__ */ u(
    "div",
    {
      className: P(
        "tw-bg-background tw-z-10 tw-mr-0 tw-w-[4.5rem] tw-relative tw-h-full",
        a && "tw-w-60",
        e.classNames
      ),
      children: /* @__PURE__ */ u(
        "div",
        {
          className: P(
            "tw-h-screen tw-bg-background tw-shadow-sidebar tw-border-r tw-border-slate-900/10 tw-absolute tw-w-60  tw-top-0 tw-left-0 tw-z-50 tw-pt-6 tw-pb-3 tw-px-4",
            f && "tw-w-full",
            "tw-flex tw-flex-col tw-justify-between"
          ),
          ref: s,
          onMouseEnter: () => {
            f && o(!1);
          },
          onMouseLeave: () => {
            f || o(!0);
          },
          children: /* @__PURE__ */ T("div", { className: "tw-flex tw-flex-col  tw-justify-between tw-h-full", children: [
            /* @__PURE__ */ T("div", { id: "main-options-div", className: "tw-overflow-hidden tw-flex tw-flex-col tw-gap-8", ref: l, children: [
              f && /* @__PURE__ */ u("div", { className: "tw-flex tw-items-center tw-justify-center tw-h-10 tw-w-10", children: /* @__PURE__ */ u(
                N7,
                {
                  name: "small",
                  onClick: () => {
                    o(!1);
                  }
                }
              ) }),
              !f && /* @__PURE__ */ T("div", { className: "tw-flex tw-items-center tw-h-7 tw-justify-between", children: [
                /* @__PURE__ */ u(N7, { name: "pulsar-brand-name" }),
                /* @__PURE__ */ u(
                  dte,
                  {
                    active: a,
                    className: "tw-cursor-pointer",
                    onClick: () => {
                      i(!a), a && o(!0);
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ u("div", { children: e.options.map((h, g) => /* @__PURE__ */ u(
                P7,
                {
                  selectedOptionId: e.selectedOptionId,
                  option: h,
                  isMenuCollapse: f,
                  onOptionSelect: e.onOptionSelect,
                  optionIndex: g,
                  isExpandedOption: g === t,
                  setExpandIndex: n,
                  isNewText: e.isNewText,
                  onOptionExpanded: d,
                  onClick: h.onClick
                },
                `option-list-${h.id}`
              )) })
            ] }),
            /* @__PURE__ */ u("div", { children: (p = e.footerOptions) == null ? void 0 : p.map((h, g) => /* @__PURE__ */ u(
              P7,
              {
                option: h,
                selectedOptionId: e.selectedOptionId,
                isMenuCollapse: f,
                onOptionSelect: e.onFooterOptionSelect,
                optionIndex: g,
                isExpandedOption: !1,
                setExpandIndex: n,
                onOptionExpanded: d,
                isNewText: e.isNewText,
                onClick: h.onClick
              },
              `footer-option-${h.id}`
            )) })
          ] })
        }
      )
    }
  );
}
export {
  Pte as Accordion,
  Ate as AccordionItem,
  jte as Badge,
  rne as Banner,
  Fee as Breadcrumb,
  $ee as BreadcrumbEllipsis,
  Bee as BreadcrumbItem,
  Gee as BreadcrumbLink,
  Hee as BreadcrumbList,
  Wee as BreadcrumbPage,
  Zee as BreadcrumbSeparator,
  Yr as Button,
  kee as ButtonV2,
  N0 as Calendar,
  Lz as Card,
  Tee as CardButton,
  Fz as CardContent,
  kz as CardDescription,
  Hz as CardFooter,
  Rz as CardHeader,
  Vz as CardTitle,
  Nz as Carousel,
  Pz as CarouselContent,
  Tz as CarouselDots,
  Az as CarouselItem,
  Oz as CarouselNext,
  _z as CarouselPrevious,
  GA as Checkbox,
  O2 as ClearIndicator,
  mne as Combobox,
  oee as CreatableSelect,
  tne as DatePickerWithRange,
  vne as DateRangeCalendar,
  yte as Dialog,
  xte as DialogContent,
  Ete as DialogFooter,
  lne as DragAndDropContainer,
  eee as DragAndDropElement,
  lh as DropdownIndicator,
  Bte as DropdownMenu,
  gL as DropdownMenuCheckboxItem,
  mL as DropdownMenuContent,
  wX as DropdownMenuContentChildren,
  Wte as DropdownMenuGroup,
  vL as DropdownMenuItem,
  bL as DropdownMenuLabel,
  Zte as DropdownMenuPortal,
  Yte as DropdownMenuRadioGroup,
  wL as DropdownMenuRadioItem,
  CL as DropdownMenuSeparator,
  yL as DropdownMenuShortcut,
  $te as DropdownMenuSub,
  hL as DropdownMenuSubContent,
  pL as DropdownMenuSubTrigger,
  Gte as DropdownMenuTrigger,
  cne as FileUpload,
  zj as FilterButton,
  Ote as FullModal,
  Tte as FullModalContent,
  Lte as FullModalFooter,
  sne as Header,
  gX as HeaderElement,
  kx as IconButton,
  bne as IconTag,
  Rte as IllustrationCard,
  nne as ImageAssets,
  O4 as Input,
  une as IosLikeTimePicker,
  cZ as Label,
  gne as MachineStatusBar,
  wne as MetricCard,
  hne as MlBanner,
  yne as Modal,
  _te as MultiSelect,
  T2 as MultiValueRemove,
  Ene as OrFooter,
  dne as PaginatedSelect,
  Ub as Popover,
  A0 as PopoverContent,
  Jb as PopoverTrigger,
  iX as ProgressBar,
  Ine as PulsarMenuBar,
  aX as RadialProgress,
  CZ as RadioGroup,
  yZ as RadioGroupItem,
  pne as ReorderableTagList,
  Kte as ScrollableSection,
  vte as Select,
  ch as SelectV2,
  ch as SelectV2Default,
  ane as SelectWithPlotPreview,
  Cte as Sheet,
  n_ as SheetBase,
  Fh as SheetTitle,
  zte as Skeleton,
  R7 as Spinner,
  Cne as StatusCard,
  TA as Stepper,
  MZ as Switch,
  KO as Table,
  QO as TableBody,
  oT as TableCaption,
  rT as TableCell,
  eT as TableFooter,
  nT as TableHead,
  qO as TableHeader,
  tT as TableRow,
  Fte as Tabs,
  JO as TabsContent,
  XO as TabsList,
  UO as TabsTrigger,
  one as Tag,
  xne as TagCard,
  De as Text,
  Oee as TextV2,
  Vte as Textarea,
  Xte as TimePicker,
  fne as TimePickerV2,
  Ste as Toast,
  UZ as Tooltip,
  mb as TooltipContent,
  Qte as TooltipPortal,
  XZ as TooltipProvider,
  JZ as TooltipTrigger,
  xL as badgeVariants,
  L2 as baseSelectStyles,
  L7 as theme,
  Mte as toast,
  Dte as useToast
};
